// @ts-nocheck
// Migrated from cursorgame60.html — split into modules incrementally.

import { apiPath } from "../lib/apiPath";
import { gameRandom, seedGameRng, getGameRngSeed } from "./game-rng";
import {
    REFERENCE_HZ as SIM_REFERENCE_HZ,
    MAX_FRAME_DT_SEC,
    resetGameSimClock,
    getGameSimNowMs,
    getGameSimNowSec,
    advanceGameSimClock,
    clampFrameDtSec,
} from "./game-sim-clock";
import { ReplayRecorder } from "./replay/recorder";
import { quantizeDtMs } from "../../lib/replay/codec";
import {
    beginReplayPlayback,
    clearReplaySeekTarget,
    consumeReplayNeedsGameRestart,
    endReplayPlayback,
    freezeReplayPlayback,
    isReplayPlaybackActive,
    isReplaySeeking,
    replaySeekReached,
    resetReplayPlaybackToStart,
    resetReplaySpeedCredit,
    stepReplayPlaybackFrame,
    takeReplayFrameStepsThisTick,
} from "./replay/playback";
import {
    configureReplayUi,
    createViewReplayLink,
    hideReplayControls,
    showReplayControls,
    syncReplayControlsUi,
    wireReplayControls,
} from "./replay/ui";
import { metricForReplayMode } from "../../lib/replay/types";
import {
    changeAccountPassword,
    changeAccountUsername,
    fetchAccountSettings,
    fetchMyBests,
    fetchMyLeaderboardRank,
    fetchReplayMeta,
    fetchUserReplayMap,
    invalidateMyBestsCache,
    postDotsRunReward,
    postDotsTransfer,
    submitModeReplay,
} from "../lib/cloud";
import {
    flushPendingLeaderboardScores,
    initPendingLeaderboardSync,
    submitLeaderboardWithOffline,
} from "../lib/pending-leaderboard";
import {
    clearLocalAccountData,
    clearAccountSessionLocal,
    getAccountSyncUserId,
    flushAccountDataSync,
    isAccountSyncReady,
    pullAccountDataSync,
    schedulePushAccountData,
    setAccountSyncSignedIn,
    syncLocalRecordsFromServer,
    syncLocalStatsFromLeaderboard,
    touchAccountSettingsUpdatedAt,
} from "./account-sync";
import { syncHomeAmbientBallsEnabled } from "./home-ambient-balls";
import { resetNewsScreenList, syncNewsInHomeEnabled } from "./news-ui";
import {
    challengesPauseBlocked,
    constrainChallengeLobbyCursor,
    drawChallengeLobbySquare,
    handleChallengeReturn,
    isChallengeAttemptPlaying,
    isChallengeDeathSequence,
    isChallengeDeathShowingLobby,
    isChallengeDeathWorldActive,
    isChallengeLobby,
    isChallengeRewardFlow,
    isChallengeGoalCompleted,
    isChallengeTimedLevelAttempt,
    isChallengesActive,
    mountChallengesRuntime,
    noteChallengePlayFrame,
    checkChallengeGoalMet,
    checkChallengeTimeExpired,
    getChallengeCountdownRemainingSec,
    onChallengeDeathFail,
    onChallengeGoalReached,
    openChallengesFlow,
    resetChallengesState,
    getChallengeCountdownFlipCells,
    tickChallengeDeathSequence,
    tickChallengeLobby,
    tickChallengeReturnSure,
} from "./challenges/runtime";
import {
    campaignPauseBlocked,
    checkCampaignGoalMet,
    handleCampaignReturn,
    isCampaignActive,
    isCampaignAttemptPlaying,
    isCampaignClaiming,
    isCampaignGameOver,
    isCampaignGoalCompleted,
    isCampaignRaceTimedOut,
    getCampaignRaceRemainingSec,
    mountCampaignRuntime,
    noteCampaignGameOverShown,
    noteCampaignPlayFrame,
    onCampaignDeathWithGoal,
    onCampaignGoalReached,
    openCampaignFlow,
    closeCampaignFlow,
    retryCampaignFromGameOver,
} from "./campaign/runtime";
import {
    handleMarathonReturn,
    isMarathonActive,
    isMarathonAdvancing,
    isMarathonAttemptPlaying,
    isMarathonDeathSequence,
    isMarathonDeathWorldActive,
    isMarathonRaceTimedOut,
    marathonPauseBlocked,
    mountMarathonRuntime,
    checkMarathonGoalMet,
    onMarathonDeathFail,
    onMarathonGoalReached,
    openMarathonFlow,
    closeMarathonFlow,
    tickMarathonDeathSequence,
    tickMarathonPlayElapsed,
    tickMarathonReturnSure,
} from "./marathon/runtime";
import {
    beginTournamentMatch,
    cancelTournamentRun,
    getTournamentOpponentScore,
    isTournamentActive,
    isTournamentOpponentFinished,
    isTournamentPlaying,
    mountTournamentRuntime,
    onTournamentPlayerDeath,
} from "./tournaments/runtime";
import {
    mountTournamentsScreen,
    openTournamentsFlow,
    returnToTournamentScreen,
    handleTournamentsReturn,
} from "./tournaments/screen";
import {
    handleWorldMapReturn,
    isWorldMapActive,
    mountWorldMapRuntime,
    openWorldMapFlow,
    closeWorldMapFlow,
} from "./worldmap/runtime";
import { applyDomFlipClock, ensureDomFlipClock } from "./challenges/flip-countdown";
import {
  mountNotificationsUi,
  refreshNotificationsScreen,
  refreshNotificationsUnread,
  syncHomeNotificationsBell,
  syncNotificationsInHomeEnabled,
} from "./notifications-ui";
import { mountPushNotificationSettings, refreshPushSettingsUi, releasePushDeviceForSession, syncPushSubscriptionForSession } from "./push-notifications";
import {
  applyDotsFromAccountPayload,
  applyDotsFromApi,
  clearLastRunDotsReward,
  computeRunDotsReward,
  getDotsBalance,
  getDotsState,
  getLastRunDotsReward,
  setDotsBalance,
  setLastRunDotsReward,
  setModeDotsConfig,
  addOwnedCosmetic,
} from "./dots-currency";
import { setEquippedCosmeticLayers, setShopCosmeticCatalog, drawEquippedCosmeticOverlays, drawCosmeticOverlay, loadCosmeticImage, getCachedCosmeticImage, getEquippedTrailLayer, equippedHidesBaseCursor, COSMETIC_ART_SIZE, COSMETIC_REF_CURSOR_R } from "./cursor-cosmetics";
import { startIdleShowcaseCursor, stopIdleShowcaseCursor, isIdleShowcaseCursorActive } from "./idle-showcase-cursor";
import { resolveCosmeticVisual } from "./cosmetic-recolor";
import {
  paintMultiColorTrailStroke,
  paintParticleStamps,
  trySpawnTrailParticleStamp,
  updateTrailParticleStamps,
} from "./trail-cosmetics";
import { startCosmeticPreviewLoop, stopCosmeticPreviewLoop } from "./cosmetic-preview-loop";
import { ANIM_FRAME_MS } from "./shop-creator-fx";
import { closeShopScreen, openShopScreen } from "./shop-screen";
import { closeInventoryScreen, openInventoryScreen, refreshInventoryCursorColor } from "./inventory-screen";
import { playShopCoinSound } from "./ui-sounds";
import { claimDailyLoginDots, fetchShopCatalog } from "../lib/cloud";
import { renderProfileShowcase } from "./profile-showcase";
import { openProfilePhotoEditor } from "./profile-photo-editor";
import { createVisibilityInterval, isDocumentHidden } from "../lib/visibility-poll";
import {
  appendSnakeTrailPoint,
    drawSnakePlayBorder,
    drawSnakeTrail,
    resetSnakeTrail,
    resolveSnakeAppleTrailCollision,
    seedSnakeTrail,
    SNAKE_APPLE_SPEED,
    SNAKE_APPLE_START_COUNT,
    snakeBorderCollision,
    snakeSelfCollision,
    updateSnakeApple,
} from "./snake-mode";
import {
    resetComboState,
    getComboMultiplier,
    getComboLives,
    getComboDeadline,
    getComboLostFlashUntil,
    getComboBoostFlashUntil,
    getHeartDimProgress,
    tickComboHearts,
    updateComboNearDodges,
    comboTakeDamage,
    formatComboMultiplier,
    shiftComboTimers,
    isComboBallDodged,
    drawComboMultiplierPopups,
    COMBO_LIVES_MAX,
    COMBO_TIMEOUT_MS,
    COMBO_SPAWN_EVERY_MS,
    COMBO_BALLS_PER_SPAWN,
    COMBO_BALL_BASE_SPEED,
} from "./combo-mode";
import { isPwaStandalone } from "../pwa-detect";
import {
    applyGameplaySurfaceCssSize,
    gameplayCanvasInternalSize,
    refreshGameplayBackingStore,
    scalePointerDeltaForGameplay,
} from "./viewport-layout";
import {
    closeWallScreen,
    mountWallScreen,
    openWallScreen as refreshWallContent,
    setWallAuthenticated,
    setWallNavigateHandler,
} from "./wall-screen";
import { claimExclusiveUi, configureExclusiveUi } from "./exclusive-ui";
import {
    fetchAchievements,
    countCompletedAchievements,
} from "./achievements-api";
import {
    getSpeedrunLevelDef,
    distPointToSeg,
    sweptCircleHitsCircle,
    distSegToSeg2D,
    circleRectOverlap,
    getSpeedrunLevelCount,
    getSpeedrunPublishedLevelIndices,
    getNextSpeedrunPublishedLevel,
    hasSpeedrunPublishedLevel,
    getSpeedrunLevelCardMeta,
    getSpeedrunLevelDisplayTitle,
    bumpSpeedrunLevelViewCountLocal,
    setRuntimeSpeedrunLevelsFromPayload,
    wallSegToPx,
    wallDrawAlpha,
    setSpeedrunPlaytestOverride,
    clearSpeedrunPlaytestOverride,
    normalizeLevelData,
    movingLaserSegNorm,
    speedrunPointGoalPosNorm,
    speedrunPointTypeOf,
    speedrunTogglePointTypeOf,
    drawSpeedrunPointShape,
    drawSpeedrunCheckpointDeltoid,
    speedrunCheckpointRadiusPx,
    speedrunLevelCheckpoints,
    speedrunLevelTemporalSpawn,
    SPEEDRUN_LASER_HALF_BASE_PX,
    speedrunLaserHalfPxForWall,
    speedrunLaserHalfPxForMoving,
    wallSolidAnimatesAtRuntime,
    normPointInWindZone,
    speedrunWindDirUnit,
    speedrunWindStrengthValue,
    drawSpeedrunTextLabel,
    speedrunGroupRgb,
    speedrunPortalHalfThicknessPx,
    speedrunPortalPairmate,
    speedrunPortalClosestPx,
    speedrunPortalMapPointPx,
    speedrunPortalTryMotionCrossPx,
    speedrunPortalColor,
} from "./speedrun-levels";
import {
    drawSpeedrunPortals,
    emitSpeedrunPortalAbsorbBurst,
    resetSpeedrunPortalFx,
    updateSpeedrunPortalFx,
} from "./speedrun-portal-fx";
import {
    createPenaltyRuntimeState,
    setRuntimePenaltyLevelsFromPayload,
    getPenaltyPublishedLevelIndices,
    hasPenaltyPublishedLevel,
    getNextPenaltyPublishedLevel,
    getPenaltyLevelDef,
    tickPenaltyFrame,
    buildPenaltyGeomCtx,
    resetPenaltyBallFromLevel,
    penaltyRespawnNormAfterLaser,
    formatPenaltyHits,
    maybeWritePenaltyBest,
    readPenaltyBestHits,
    drawPenaltyBallLayer,
} from "./penalty-game";
import {
    getPenaltyLevelCount,
    getPenaltyLevelCardMeta,
    getPenaltyLevelDisplayTitle,
    bumpPenaltyLevelViewCountLocal,
    setPenaltyPlaytestOverride,
    clearPenaltyPlaytestOverride,
    normalizePenaltyLevelData,
} from "./penalty-levels";
import { resetPenaltyBallAtNorm, resolvePenaltyCursorAgainstBall, penaltyTryCursorHitBall } from "./penalty-mode";
import {
    mountGamepadInput,
    pollGamepadInput,
    isGamepadConnected,
    isGamepadDeferringToMouse,
    noteGamepadMouseActivity,
    getGamepadDisplayName,
    getSuperdotGamepadHints,
    formatGamepadButtonLabel,
} from "./gamepad-input";
import { pollGamepadMenuNav, endGamepadMenuNavSession, clearGamepadMenuFocus } from "./gamepad-menu-nav";
import {
    getGamepadSensitivity,
    setGamepadSensitivity,
    getGamepadDeadzonePercent,
    setGamepadDeadzonePercent,
    getGamepadClickSource,
    setGamepadClickSource,
    getGamepadPauseBtn,
    setGamepadPauseBtn,
    getGamepadReturnBtn,
    setGamepadReturnBtn,
    getGamepadMenuReturnBtn,
    setGamepadMenuReturnBtn,
    getGamepadMenuBtn,
    setGamepadMenuBtn,
    getGamepadRestartBtn,
    setGamepadRestartBtn,
    GP_SENSITIVITY_DEFAULT,
    GP_DEADZONE_DEFAULT,
    GP_BTN,
    type GamepadClickSource,
} from "./gamepad-settings";
import {
    normalizePracticeLevelData,
    setPracticePlaytestOverride,
    getRuntimePracticeLevel,
    setRuntimePracticeLevelsFromPayload,
    listRuntimePracticeLevels,
    pointInGuideZone,
    type PracticeLevelDef,
} from "./practice-levels";
import { fetchPracticeLevels, incrementLevelViewCount } from "../lib/cloud";
import { mountPracticeScreen, refreshPracticeScreen } from "./practice-screen";
import { tickPracticeGuide, drawPracticeGuideOverlay, initialPracticeGuideState } from "./practice-guide";
import { initAdminPanel } from "./admin-panel";
import { refreshWhatsNewModal } from "./whats-new-modal";
import { mountTasksScreen, syncTasksClaimBadge } from "./tasks/screen";
import { fetchTasks, reportTaskProgress } from "./tasks/api";
import { mountBattlePassScreen, syncBattlePassClaimBadge } from "./battle-pass/screen";
import { fetchBattlePass, reportBattlePassRun } from "./battle-pass/api";
import { notifyBattlePassXp } from "./battle-pass/fx";
import { initHomeSplash, refreshHomeSplash, syncHomeSplashEnabled, setSplashLinkNavigator } from "./home-splash";
import {
    afterPlayerSettingsApplied,
    initShowAdminThemeFromStorage,
    bootstrapThemeDevicePreviewFrame,
    loadPublishedGameTheme,
    refreshGameThemePresentation,
    setShowAdminThemeSetting,
    getShowAdminThemeSetting,
    setThemePreviewData,
    getThemeBallsPaint,
    modeAllowsThemeBallColorForBall,
    setThemePlayerColorRestorer,
    setThemeMusicPlaybackHook,
    getEffectiveThemeMusic,
} from "./game-theme";
import {
    playThemeMusicStep,
    themeMusicAppliesToGame,
    themeMusicAppliesToMenu,
    themeMusicStepMs,
    themeMusicTotalSteps,
} from "./theme-music";
import { mountThemePreviewChrome } from "./admin-theme-creator";
import {
    applyEquippedThemeCosmetics,
    getPlayerThemeBallsPaint,
    hasPlayerThemeBalls,
    getThemeCosmeticPreviewData,
    isThemeCosmeticPreviewPlay,
    registerThemeCosmeticBatch,
    setThemeCosmeticPreviewData,
    setThemeCosmeticPreviewPlay,
} from "./theme-cosmetic";
import { mountThemeCosmeticPreviewChrome } from "./theme-cosmetic-preview";
import { getSplashSettingsTarget, getSplashScreenTarget } from "./splash-links";
import { mountAdminSpeedrunEditor } from "./admin-speedrun-editor";
import { mountAdminPenaltyEditor } from "./admin-penalty-editor";
import { syncToggleSwitch } from "./toggle-switch";
import {
    resetHighwayState,
    updateHighway,
    drawHighwayRoad,
    drawHighwayObstacles,
    drawHighwayLayerRefMapped,
    highwayCollides,
    highwayCursorOffScreen,
    highwayCursorOffTrack,
    highwayCursorScreenPos,
    getHighwayCameraY,
    highwayWorldToScreen,
    applyHighwaySnapshot,
    setHighwayTuning,
    setHighwayRandom,
} from "./highway-mode";
import {
    resetDarknessState,
    setDarknessTuning,
    updateDarkness,
    drawDarknessPoints,
    fillDarknessBackground,
    fillDarknessVisionInterior,
    applyDarknessVisionClip,
    drawDarknessEdgeShade,
    getDarknessZoom,
    getDarknessDanger,
} from "./darkness-mode";
import {
    resetColorRushState,
    setColorRushTuning,
    tickColorRushColorCycle,
    buildColorRushColorDeck,
    getColorRushCursorColorIdx,
    getColorRushCursorHex,
    getColorRushBallHex,
    isColorRushCursorPulsing,
    getColorRushCursorPulseScale,
    COLOR_RUSH_BALL_SPEED,
    COLOR_RUSH_BALLS_TOTAL,
    scheduleColorRushRespawn,
    tickColorRushRespawn,
} from "./color-rush-mode";
import {
    resetCounterState,
    setCounterTuning,
    resetCounterWave,
    resetCounterTimer,
    getCounterNextExpected,
    advanceCounterExpected,
    scheduleCounterRespawn,
    tickCounterRespawn,
    tickCounterTimer,
    isCounterAwaitingRespawn,
    drawCounterTimeHud,
    drawCounterBallLabel,
    getCounterBallHex,
    getCounterBallDrawAlpha,
    getCounterBallNeonStrength,
    shiftCounterPauseTimers,
    COUNTER_BALLS_TOTAL,
    COUNTER_BALL_SPEED,
} from "./counter-mode";
import {
    resetAimState,
    setAimTuning,
    resetAimTimer,
    tickAimTimer,
    tickAimWave,
    drawAimTimeHud,
    shiftAimPauseTimers,
    assignRandomAimGolden,
    reassignAimGoldenFrom,
    scheduleAimWaveClearPause,
    isAimInputBlocked,
    isAimTimerFrozen,
    getAimWaveFadeAlpha,
    getAimBallDrawAlpha,
    getAimBallNeonStrength,
    AIM_BALLS_TOTAL,
    AIM_BALL_RADIUS_REF,
    AIM_BALL_SPEED,
    AIM_GOLDEN_BALL_HEX,
    AIM_GOLDEN_GLOW_HEX,
} from "./aim-mode";
import {
    resetHookState,
    nudgeHookAimByMouseDelta,
    pointHookAimAtCanvas,
    launchHook,
    tickHook,
    drawHookOverlay,
    drainHookCatchEvents,
    isHookInputBlocked,
    hookShouldSkipCursorBallCollision,
    shouldHookSpawn,
    markHookSpawned,
    shiftHookPauseTimers,
    getHookCaughtBall,
    setHookTuning,
    HOOK_NORMAL_START,
    HOOK_RED_START,
    HOOK_NORMAL_PER_SPAWN,
    HOOK_RED_PER_SPAWN,
    HOOK_BALL_SPEED,
    HOOK_BALL_RADIUS_REF,
    HOOK_RED_HEX,
    HOOK_RED_GLOW_HEX,
    pointHookAimFromStick,
} from "./hook-mode";
import {
    TILT_BALLS_PER_SPAWN,
    TILT_BALL_SPEED,
    TILT_SCORE_PER_SPAWN,
    deviceHasMotionSensors,
    isTiltDeviceEligible,
    requestTiltOrientationPermission,
    startTiltOrientationListening,
    stopTiltOrientationListening,
    resetTiltPhysics,
    tickTiltPhysics,
    syncTiltCursorPos,
    showTiltMobileOnlyToast,
} from "./tilt-mode";
import {
    ORBIT_INITIAL_BALLS,
    setOrbitTuning,
    resetOrbitState,
    tickOrbitMovement,
    takeOrbitSpawns,
    pickOrbitInboundSpawn,
    orbitBallHitsCore,
    drawOrbitCore,
    feedOrbitSlideDelta,
    orbitCursorPos,
    getOrbitAngle,
    orbitCoreTakeHit,
    orbitImpactPoint,
    tickOrbitLives,
    syncOrbitLivesFromScore,
    drawOrbitReversalMarks,
} from "./orbit-mode";
import { mountHookAimJoystick, setHookAimJoystickVisible } from "./hook-aim-joystick";
import { appendGameSelectHost, refreshGameSelect } from "./game-select";
import { noteFpsFrame, readFpsShowWhere, scheduleFpsOverlayPosition, setFpsOverlayOptions } from "./fps-overlay";
import {
    formatFpsLimitLabel,
    fpsLimitToSliderIndex,
    getGameplayFpsMinFrameMs,
    parseFpsLimitInput,
    readFpsLimit,
    readLowPowerCap60Enabled,
    setGameplayFpsLimit,
    setLowPowerCap60Enabled,
    sliderIndexToFpsLimit,
    type FpsLimit,
} from "./fps-limit";
import {
    setPlayHudLayoutOptions,
    setPlayHudSidebarCollapsed,
    syncPlayHudLayout,
} from "./play-hud-layout";
import {
    resetHeatState,
    tickHeat,
    getHeatLevel,
    getHeatDeathMessage,
    getHeatCursorColor,
    drawHeatBar,
    setHeatTuning,
    HEAT_BALLS_START,
    HEAT_SCORE_PER_SPAWN,
    HEAT_BALLS_PER_SPAWN,
    HEAT_BALL_SPEED,
} from "./heat-mode";
import {
    assignHunterPatrolAnchor,
    drawHunterBall,
    HUNTER_NORMAL_START,
    HUNTER_NORMAL_PER_SPAWN,
    HUNTER_RED_PER_SPAWN,
    HUNTER_NORMAL_SPEED,
    HUNTER_SCORE_PER_SPAWN,
    HUNTER_CHASE_SPEED,
    HUNTER_PATROL_RADIUS_REF_PX,
    HUNTER_TURN_RATE,
    hunterSpawnClearancePx,
    placeBallAwayFromCursor,
    updateHunterBalls,
    setHunterTuning,
} from "./hunter-mode";
import {
    POP_START_COUNT,
    POP_SIZE_LARGE,
    POP_SPLIT_COOLDOWN_MS,
    bouncePopBalls,
    bouncePopBallOffPoint,
    clampPopSize,
    enforcePopBallSpeed,
    growPopBall,
    isPopMini,
    makePopSplitChildren,
    popBallReadyToSplit,
    popRadiusPx,
    popSizesShouldSplit,
    popSpeedValue,
} from "./pop-mode";
import { recordModePlay, refreshModesScreen, getFavoriteModeTitle, setModeBestScoreProvider, cancelPendingModeView, isModesTouchUi, setModesRandomSfx } from "./modes-screen";
import { commitPlayStreakDay, refreshAllPlayStreakUi, ensureHomePlayStreakUi } from "./play-streaks";
import {
    mountModesSelectionPanel,
    wireModesContainerSelection,
    clearModeSelection,
    startModeById,
} from "./modes-selection-panel";
import { mountPlayTransition, runPlayTransition, withExitPlayTransition, isPlayTransitionEnabled, isPlayTransitionRunning } from "./play-transition";
import { hideHubScreens, mountGameHub, refreshHubCategoryVisibility, refreshHubLocalCardVisibility, setGameHubTab, fitGameHubCardTitles } from "./game-hub";
import { loadPublishedHubIcons, markDefaultHubIconSvgs, refreshAllHubIcons } from "./hub-icons";
import { mountHomeDashboard, applyHomeDashboardFromSettings, refreshHomeSettingsToggleUi } from "./home-dashboard";
import { refreshCustomScrollbars } from "./custom-scrollbar";
import {
    defaultSandboxConfig as defaultSandboxConfigV2,
    normalizeSandboxConfig as normalizeSandboxConfigV2,
    SANDBOX_BASE_MODE_TITLES,
    toMpSandboxWire,
    fromMpSandboxWire,
} from "./sandbox-schema";
import { rebuildSandboxConfigForm, readSandboxConfigFromForm, syncSandboxCustomizeButtons } from "./sandbox-config-ui";
import {
    mountSandboxBaseModePicker,
    mountSandboxCommunityScreen,
    refreshSandboxCommunityPresets,
    rerenderSandboxCommunityBestLines,
} from "./sandbox-hub";
import {
    beginSandboxRun,
    endSandboxRun,
    isSandboxRunActive,
    sbNum,
    sbCommonNum,
    sbCommonBool,
    sbBounceBoost,
    sbRuleEnabled,
    getSandboxActiveConfig,
} from "./sandbox-tuning";

import { formatModeBestLine, getModeBestKind } from "./mode-records";
import {
    clearNotificationToastsByKind,
    pushNotificationToast,
} from "./notification-stack";
import { drawMirrorCursorOnto, mirrorCursorPos } from "./mirror-mode";
import {
    drawDelayGhostCursorOnto,
    getDelayRealCursorPos,
    getDelayRealPrev,
    remapDelayHistory,
    resetDelayState,
    syncDelayRealPrev,
    tickDelayGhost,
} from "./delay-mode";
import {
    KEYBIND_ACTIONS,
    KEYBIND_DEFAULTS,
    KEYBIND_STORAGE_KEYS,
    formatKeybindDisplay,
    getKeybindKey,
    setKeybindKey,
    resetKeybindKey,
    keyboardEventToStoredKey,
    keyEventMatchesAction,
    findKeybindConflict,
    hasKeybindAssigned,
    replaceKeybindPlaceholders,
} from "./keybind-settings";
import {
    applySettingsHistorySnapshot,
    applySettingsShareSnapshot,
    clearAllSettingsStorageKeys,
    exportFullSettingsShareSnapshot,
    exportSettingsHistorySnapshot,
    parseSettingsShareJson,
    serializeSettingsShareJson,
    SETTINGS_HISTORY_KEYS,
    snapshotsEqual,
} from "./settings-history";
import {
    DPAD_INSET_R_KEY,
    DPAD_INSET_B_KEY,
    DPAD_INSET_L_KEY,
    DPAD_LAYOUT_KEY,
    DPAD_OFFSETS_KEY,
    DPAD_LAYOUT3_POS_KEY,
    DPAD_EIGHT_DIR_KEY,
    DPAD_SCALE_KEY,
    DPAD_OPACITY_KEY,
    DPAD_GRID_KEY,
    dpadHold,
    dpadPositionCustomizeMode,
    settingDpadEightDirections,
    applyDpadLayoutFromStorage,
    persistDpadPositionFromElement,
    setupDpadTouchControls,
    setDpadCustomizeMode,
    cycleDpadLayout,
    resetDpadToDefaults,
    setDpadEightDirections,
    reloadDpadSettingsFromStorage,
    refreshDpadSettingsUI,
    beginDpadCustomizeSession,
    commitDpadCustomizeSession,
    discardDpadCustomizeSession,
    persistDpadSettingsForShare,
    syncDpadCustomizeScaleSlider,
    setDpadScaleFromSliderValue,
    syncDpadCustomizeOpacitySlider,
    setDpadOpacityFromSliderValue,
    pushDpadCustomizeUndoBeforeChange,
    undoDpadCustomize,
    redoDpadCustomize,
    toggleDpadGridSnap,
    resetDpadHoldState,
} from "./dpad-mobile";
import {
    initMultiplayerGameRuntime,
    initMultiplayerUi,
    openMpEntry,
    isMultiplayerActive,
    isMpSpectator,
    isMpLocalAlive,
    isMpWasdMode,
    isMpHighwayMode,
    isMpSnakeMode,
    isMpHighwayPlaying,
    isMpSpeedrunMode,
    isMpBallDodgeMode,
    getMpGameMode,
    shouldSkipLocalCollision,
    tickMultiplayer,
    renderMultiplayerTrails,
    renderMultiplayerCursors,
    renderMultiplayerObstacles,
    renderMpHighwayLayer,
    renderMpSnakeTrails,
    renderMpSnakePlayBorder,
    mpHighwayLocalCursorScreen,
    onLocalMpDeathBegin,
  getMpScore,
  stopMultiplayerGame,
    ensureMultiplayerGameRunning,
    notifyMpHighwayCollision,
    hideAllMpScreens,
    handleMpReturn,
    endMultiplayerToLobby,
    markMpSpeedrunLocalFinished,
    isMpSpeedrunLocalFinished,
    getMpSpeedrunLocalFinishTime,
    getMpSpeedrunFinishers,
    syncLocalSpeedrunPoints,
    isMpSpeedrunSpectating,
    cycleMpSpectateTarget,
    getMpSpectateTargetName,
    getMpSpectatePointsSet,
    getMpSpectateCursorCanvas,
    isMpSpeedrunCoop,
    getMpSpeedrunSimTimeSec,
    registerMpSpeedrunCoopHooks,
    respawnMpSpeedrunFromLaser,
} from "./multiplayer";
import {
    initLocalUi,
    initLocalGameRuntime,
    hideLocalScreens,
    isLocalScreenVisible,
    openLocalSetup,
    isLocalActive,
    isLocalCoopMode,
    scheduleLocalMatchEnd,
    isLocalMatchUpdatesFrozen,
    isLocalSpeedrunRespawnPending,
    isLocalPreRoundFrozen,
    shouldHideGlobalTouchPad,
    getLocalConfig,
    startLocalSession,
    stopLocalSession,
    isLocalGameplayInputBlocked,
    tickLocalMultiplayer,
    handleLocalCollisions,
    onLocalSpeedrunCheckpoint,
    onLocalCountdownComplete,
    renderLocalOverlay,
    refreshLocalTouchZoneLayout,
    relayoutLocalTouchZones,
    handleLocalReturn,
    localSpawnClearanceCenters,
} from "./local";
import type { LocalConfig } from "./local";
import {
    initLootDropUi,
    initLootDropGameRuntime,
    openLootDropEntry,
    hideLdScreens,
    isLdScreenVisible,
    handleLdReturn,
    isLootDropActive,
    isLdHost,
    tickLootDrop,
    renderLootDropOverlay,
    handleLootDropCanvasClick,
    beginLootDropHostPaint,
    continueLootDropHostPaint,
    endLootDropHostPaint,
    isLootDropHostPaintActive,
    updateLootDropPointerFromClient,
    stopLootDropSession,
} from "./lootdrops";
import {
    mountSoccerUi,
    initSoccerRuntime,
    openSoccerCompete,
    hideSoccerScreens,
    isSoccerScreenVisible,
    handleSoccerReturn,
    isSoccerActive,
    tickSoccer,
    renderSoccer,
    prepareLocalSoccer,
    soccerBlocksReturn,
    beginSoccerCompeteQueue,
    trySoccerSkipReplay,
} from "./soccer";
import { buildLevelPickerGrid } from "./level-picker-cards";
import { mountAccountSwitcher, rememberAccountFromAuth, setSwitchAccountVisible, beginAddAccountFlow, getAddAccountReturnTarget, finishAddAccountFlow, cancelAddAccountFlow, clearAddAccountReturnTarget, getSavedAccounts, purgeSavedAccountEverywhere, switchToSavedAccount, type SavedAccount } from "./account-switcher";
import { incrementLevelViewCount } from "../lib/cloud";
import { mpClient } from "./multiplayer/client";
import { registerMpModeBridge } from "./multiplayer/mp-mode-bridge";
import { normalizeMpSandboxConfig } from "../../lib/multiplayer/sandbox-config";
import { mpCanvasToNorm, MP_REF_H, MP_REF_W, MP_HIGHWAY_LAYOUT_SCALE } from "../../lib/multiplayer/normal-sim";
import type { MpGameMode, MpSandboxConfigWire } from "../../lib/multiplayer/protocol";
function readStored(keys) {
    for (const key of keys) {
        const raw = localStorage.getItem(key);
        if (raw !== null) return Number(raw) || 0;
    }
    return 0;
}
function writeStored(keys, value) {
    for (const key of keys) localStorage.setItem(key, String(value));
}
function getBoolSetting(key, defaultValue) {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return raw === "1";
}
function setBoolSetting(key, value) {
    localStorage.setItem(key, value ? "1" : "0");
}
function getHexSetting(key, defaultValue) {
    const raw = localStorage.getItem(key);
    if (!raw) return defaultValue;
    const t = raw.trim();
    if (/^#([0-9a-fA-F]{6})$/i.test(t)) return t.toLowerCase();
    if (/^#([0-9a-fA-F]{3})$/i.test(t)) {
        const s = t.slice(1);
        return `#${s[0]}${s[0]}${s[1]}${s[1]}${s[2]}${s[2]}`.toLowerCase();
    }
    return defaultValue;
}
function getNumberSetting(key, defaultValue) {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === "") return defaultValue;
    const n = Number(raw);
    return Number.isFinite(n) ? n : defaultValue;
}
function hexToRgb(hex) {
    let s = (hex || "").trim().replace(/^#/, "");
    if (/^[0-9a-fA-F]{3}$/i.test(s)) {
        s = `${s[0]}${s[0]}${s[1]}${s[1]}${s[2]}${s[2]}`;
    }
    const m = /^([0-9a-fA-F]{6})$/i.exec(s);
    const n = m ? m[1] : "ffffff";
    return {
        r: parseInt(n.slice(0, 2), 16),
        g: parseInt(n.slice(2, 4), 16),
        b: parseInt(n.slice(4, 6), 16)
    };
}
function rgbToHex(r, g, b) {
    const toHex = (v) => Number(v).toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
/** WCAG relative luminance for sRGB 0–255 channels (mid-tone button fill). */
function relativeLuminance255(r, g, b) {
    const lin = (c) => {
        c /= 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const R = lin(r);
    const G = lin(g);
    const B = lin(b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
}
function formatVolume(v) {
    return Number(v) === 0 ? "OFF" : String(v);
}

const settingsSliderValDrafts = new WeakMap();

function setSettingsSliderValDisplay(inputEl, text) {
    if (!inputEl) return;
    if (document.activeElement === inputEl) return;
    settingsSliderValDrafts.delete(inputEl);
    inputEl.value = text;
}

function bindSettingsSliderValueInput(sliderEl, inputEl, onCommit) {
    if (!sliderEl || !inputEl) return;

    inputEl.setAttribute("inputmode", "numeric");
    inputEl.setAttribute("autocomplete", "off");

    inputEl.addEventListener("focus", () => {
        const raw = inputEl.value.trim();
        if (raw.toUpperCase() === "OFF") inputEl.value = "0";
        inputEl.select();
    });

    inputEl.addEventListener("input", () => {
        settingsSliderValDrafts.set(inputEl, inputEl.value);
    });

    inputEl.addEventListener("keydown", e => {
        if (e.key === "Enter") {
            e.preventDefault();
            inputEl.blur();
        }
    });

    inputEl.addEventListener("blur", () => {
        if (!settingsSliderValDrafts.has(inputEl)) return;
        const draft = settingsSliderValDrafts.get(inputEl);
        settingsSliderValDrafts.delete(inputEl);
        const trimmed = String(draft ?? "").trim();
        if (trimmed === "") {
            refreshSettingsUI();
            return;
        }
        const normalized = trimmed.toUpperCase() === "OFF" ? "0" : trimmed;
        const num = Number(normalized);
        if (!Number.isFinite(num)) {
            refreshSettingsUI();
            return;
        }
        onCommit(num);
    });
}

function bindColorChannelValueInput(channelSlider, channelValInput, rSlider, gSlider, bSlider, which) {
    bindSettingsSliderValueInput(channelSlider, channelValInput, n => {
        channelSlider.value = String(clamp(Math.round(n), 0, 255));
        saveColorSetting(which, rgbToHex(rSlider.value, gSlider.value, bSlider.value));
    });
}

function isTypingInEditable() {
    const el = document.activeElement;
    if (!el) return false;
    const tag = (el.tagName || "").toUpperCase();
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
}

const KEY_BEST_NORMAL = ["bestNormal", "bestScoreNormal"];
const KEY_BEST_WASD = ["bestWASD", "bestScoreWASD"];
const KEY_BEST_SUPER = ["bestSuper", "bestScoreSuperDot", "bestScoreSuper"];
const KEY_BEST_PROG = ["bestProg", "bestLevelProg"];
const KEY_BEST_ROULETTE = ["bestRoulette", "bestScoreRoulette"];
const KEY_BEST_SANDBOX = ["bestSandbox", "bestScoreSandbox"];
const KEY_BEST_HIGHWAY = ["bestHighway", "bestScoreHighway"];
const KEY_BEST_DARKNESS = ["bestDarkness", "bestScoreDarkness"];
const KEY_BEST_MIRROR = ["bestMirror", "bestScoreMirror"];
const KEY_BEST_SNAKE = ["bestSnake", "bestScoreSnake"];
const KEY_BEST_COMBO = ["bestCombo", "bestScoreCombo"];
const KEY_BEST_OVERLOAD = ["bestOverload", "bestScoreOverload"];
const KEY_BEST_COLOR_RUSH = ["bestColorRush", "bestScoreColorRush"];
const KEY_BEST_HEAT = ["bestHeat", "bestScoreHeat"];
const KEY_BEST_HUNTER = ["bestHunter", "bestScoreHunter"];
const KEY_BEST_POP = ["bestPop", "bestScorePop"];
const KEY_BEST_COUNTER = ["bestCounter", "bestScoreCounter"];
const KEY_BEST_AIM = ["bestAim", "bestScoreAim"];
const KEY_BEST_HOOK = ["bestHook", "bestScoreHook"];
const KEY_BEST_TILT = ["bestTilt", "bestScoreTilt"];
const KEY_BEST_ORBIT = ["bestOrbit", "bestScoreOrbit"];
const KEY_BEST_DELAY = ["bestDelay", "bestScoreDelay"];
const KEY_PLAYTIME = ["playTime", "totalPlayTime"];
const KEY_DEATHS = ["deathCount", "totalDeaths"];
/** Bumped when resetting SpeedRun bests (local + cloud leaderboard wipe). */
const KEY_SPEEDRUN_BEST = "bestSpeedrunTimesV4";
const KEY_STATS_SPEEDRUN_LEVEL = "statsSpeedrunLevelPick";
const KEY_RANKING_SPEEDRUN_LEVEL = "rankingSpeedrunLevelPick";
const KEY_STATS_PENALTY_LEVEL = "statsPenaltyLevelPick";
const KEY_RANKING_PENALTY_LEVEL = "rankingPenaltyLevelPick";
const KEY_SANDBOX_SPEEDRUN_LOCAL = "sandboxSpeedrunLocalBestsV1";
/** Per-preset Sandbox scores (not base-mode / global sandbox best): `cloud:<id>` | `local:<name>`. */
const KEY_SANDBOX_SCORE_LOCAL = "sandboxPresetScoreBestsV1";
const KEY_ACHIEVEMENT_TOAST_KNOWN_IDS = "achievementToastKnownIdsV1";

const RANKING_MODES = [
    ["normal", "Normal"],
    ["wasd", "WASD"],
    ["progression", "Progression"],
    ["superdot", "Superdot"],
    ["roulette", "Roulette"],
    ["speedrun", "SpeedRun"],
    ["penalty", "Golf"],
    ["highway", "Highway"],
    ["darkness", "Darkness"],
    ["mirror", "Mirror"],
    ["snake", "Snake"],
    ["combo", "Combo"],
    ["overload", "Overload"],
    ["colorrush", "Color Rush"],
    ["heat", "Heat"],
    ["hunter", "Hunter"],
    ["pop", "POP"],
    ["counter", "Counter"],
    ["aim", "AIM"],
    ["hook", "Hook"],
    ["tilt", "Tilt"],
    ["orbit", "Orbit"],
    ["delay", "Delay"]
];
const RANKING_GAME_MODE_IDS = new Set(RANKING_MODES.map(([val]) => val));

let bestNormal = readStored(KEY_BEST_NORMAL);
let bestWASD = readStored(KEY_BEST_WASD);
let bestSuper = readStored(KEY_BEST_SUPER);
let bestProg = readStored(KEY_BEST_PROG);
let bestRoulette = readStored(KEY_BEST_ROULETTE);
let bestSandbox = readStored(KEY_BEST_SANDBOX);
let bestHighway = readStored(KEY_BEST_HIGHWAY);
let bestDarkness = readStored(KEY_BEST_DARKNESS);
let bestMirror = readStored(KEY_BEST_MIRROR);
let bestSnake = readStored(KEY_BEST_SNAKE);
let bestCombo = readStored(KEY_BEST_COMBO);
let bestOverload = readStored(KEY_BEST_OVERLOAD);
let bestColorRush = readStored(KEY_BEST_COLOR_RUSH);
let bestHeat = readStored(KEY_BEST_HEAT);
let bestHunter = readStored(KEY_BEST_HUNTER);
let bestPop = readStored(KEY_BEST_POP);
let bestCounter = readStored(KEY_BEST_COUNTER);
let bestAim = readStored(KEY_BEST_AIM);
let bestHook = readStored(KEY_BEST_HOOK);
let bestTilt = readStored(KEY_BEST_TILT);
let bestOrbit = readStored(KEY_BEST_ORBIT);
let bestDelay = readStored(KEY_BEST_DELAY);
let playTime = readStored(KEY_PLAYTIME);
let deathCount = readStored(KEY_DEATHS);
let lastPlayerStatsSyncMs = 0;

function getModeBestValue(modeId) {
    switch (modeId) {
        case "normal": return bestNormal;
        case "wasd": return bestWASD;
        case "superdot": return bestSuper;
        case "progression": return bestProg;
        case "roulette": return bestRoulette;
        case "sandbox": return bestSandbox;
        case "highway": return bestHighway;
        case "darkness": return bestDarkness;
        case "mirror": return bestMirror;
        case "snake": return bestSnake;
        case "combo": return bestCombo;
        case "overload": return bestOverload;
        case "colorrush": return bestColorRush;
        case "heat": return bestHeat;
        case "hunter": return bestHunter;
        case "pop": return bestPop;
        case "counter": return bestCounter;
        case "aim": return bestAim;
        case "hook": return bestHook;
        case "tilt": return bestTilt;
        case "orbit": return bestOrbit;
        case "delay": return bestDelay;
        default: return 0;
    }
}

setModeBestScoreProvider(getModeBestValue);

/** Stats-aligned bests for in-game HUD (cloud value when signed in). */
let hudStatsBestCache = {};
let hudStatsBestCacheUserId = null;

async function refreshHudStatsBestCache() {
    if (!cloudUser) {
        hudStatsBestCache = {};
        hudStatsBestCacheUserId = null;
        return;
    }
    if (isAccountSyncReady()) {
        await syncLocalStatsFromLeaderboard().catch(() => {});
        reloadAccountGlobalsFromStorage();
    }
    hudStatsBestCache = await fetchStatsRankMap().catch(() => ({}));
    hudStatsBestCacheUserId = cloudUser.id;
}

function getDisplayedBestValue(modeId) {
    if (cloudUser && hudStatsBestCacheUserId === cloudUser.id) {
        const entry = hudStatsBestCache[modeId];
        const cloudVal = entry && typeof entry === "object" ? entry.value : null;
        if (cloudVal != null) return Math.floor(Number(cloudVal) || 0);
    }
    return getModeBestValue(modeId);
}

function formatHudBestLine(modeId) {
    const sandboxLine = sandboxRunBestLine();
    if (sandboxLine) return sandboxLine;
    return formatModeBestLine(modeId, getDisplayedBestValue(modeId));
}

function formatGameOverRunLine(modeId) {
    if (modeId === "progression") return `Level: ${progressionLevel}`;
    if (modeId === "speedrun") {
        const ms = Math.max(0, getGameSimNowMs() - speedrunStartPerf);
        return `Time: ${formatSpeedrunTime(ms)}`;
    }
    if (getModeBestKind(modeId) === "score") return `Score: ${gameplayScoreFloor()}`;
    return "";
}

function formatGameOverBestLine(modeId) {
    if (modeId === "speedrun") {
        const b = displayedSpeedrunBestMs(speedrunActiveLevel);
        const src = cloudUser ? "ranking" : "local";
        return b > 0
            ? `Best time (${src}, level ${speedrunActiveLevel}): ${formatSpeedrunTime(b)}`
            : `Best time (${src}, level ${speedrunActiveLevel}): —`;
    }
    if (sandboxRunActiveNow() && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        const b = displayedSandboxSpeedrunBestMs();
        return b > 0 ? `Best Time: ${formatSpeedrunTime(b)}` : "Best Time: —";
    }
    const sandboxLine = sandboxRunBestLine();
    if (sandboxLine) return sandboxLine;
    if (getModeBestKind(modeId) === "none") return "";
    return formatHudBestLine(modeId);
}

function hideShopScreenNav() {
    closeShopScreen();
    closeInventoryScreen();
}

function updateGameOverDotsPanel(modeId, isGuest) {
    if (!gameOverDotsPanel) return;
    gameOverDotsPanel.classList.remove("gameOverDotsPanel--animate");
    if (gameOverDotsScore) gameOverDotsScore.textContent = "";
    if (gameOverDotsBonus) {
        gameOverDotsBonus.textContent = "";
        gameOverDotsBonus.classList.add("hidden");
    }
    if (gameOverDotsTotal) gameOverDotsTotal.textContent = "";
    if (gameOverDotsGuest) gameOverDotsGuest.classList.add("hidden");

    if (isGuest) {
        showEl(gameOverDotsPanel);
        if (gameOverDotsGuest) gameOverDotsGuest.classList.remove("hidden");
        requestAnimationFrame(() => gameOverDotsPanel.classList.add("gameOverDotsPanel--animate"));
        return;
    }

    const reward = getLastRunDotsReward();
    if (!reward || reward.totalDots <= 0) {
        hideEl(gameOverDotsPanel);
        return;
    }
    showEl(gameOverDotsPanel);
    if (gameOverDotsScore) {
        gameOverDotsScore.textContent = `Dots from score: +${reward.dotsFromScore}`;
    }
    if (reward.bonusDots > 0 && gameOverDotsBonus) {
        gameOverDotsBonus.textContent = `Record bonus: +${reward.bonusDots}`;
        gameOverDotsBonus.classList.remove("hidden");
    }
    if (gameOverDotsTotal) {
        gameOverDotsTotal.textContent = `Total Dots earned: +${reward.totalDots}`;
    }
    requestAnimationFrame(() => gameOverDotsPanel.classList.add("gameOverDotsPanel--animate"));
}

function updateGameOverStatsPanel(modeId) {
    const deathText = gameOverMessage || (modeId === "speedrun" ? "Laser hit — attempt not saved." : "");
    if (gameOverDeathMsg) {
        if (deathText) {
            gameOverDeathMsg.textContent = deathText;
            gameOverDeathMsg.classList.remove("hidden");
        } else {
            gameOverDeathMsg.textContent = "";
            gameOverDeathMsg.classList.add("hidden");
        }
    }
    const runLine = formatGameOverRunLine(modeId);
    if (gameOverRunStat) {
        gameOverRunStat.textContent = runLine;
        gameOverRunStat.classList.toggle("hidden", !runLine);
    }
    const bestLine = formatGameOverBestLine(modeId);
    if (gameOverBestStat) {
        gameOverBestStat.textContent = bestLine;
        gameOverBestStat.classList.toggle("hidden", !bestLine);
    }
    updateGameOverDotsPanel(modeId, !cloudUser);
}

let settingBallsColor = getHexSetting("settingBallsColor", "#66ffff");
let settingCursorColor = getHexSetting("settingCursorColor", "#ffffff");
let settingButtonsColor = getHexSetting("settingButtonsColor", "#66ffff");
/** When true, UI text follows Buttons Color; when false, uses settingTextColor. */
let settingButtonsAutoText = getBoolSetting("settingButtonsAutoText", true);
let settingTextColor = getHexSetting("settingTextColor", "#66ffff");
let settingTrailColor = getHexSetting("settingTrailColor", "#66ffff");
function migrateLegacyBackgroundSettings() {
    const legacy = localStorage.getItem("settingBackgroundColor");
    if (legacy && localStorage.getItem("settingMenuBackgroundColor") === null) {
        localStorage.setItem("settingMenuBackgroundColor", legacy);
    }
    if (legacy && localStorage.getItem("settingGameBackgroundColor") === null) {
        localStorage.setItem("settingGameBackgroundColor", legacy);
    }
}
migrateLegacyBackgroundSettings();
let settingMenuBackgroundColor = getHexSetting("settingMenuBackgroundColor", "#000000");
let settingGameBackgroundColor = getHexSetting("settingGameBackgroundColor", "#000000");
const BACKGROUND_BRIGHT_MAX = 100;
function readBackgroundBright(storageKey, legacyDarkKey) {
    const raw = localStorage.getItem(storageKey);
    if (raw !== null && raw !== "") {
        let n = Number(raw);
        if (!Number.isFinite(n)) n = 0;
        const migratedKey = `${storageKey}V100`;
        if (n <= 10 && localStorage.getItem(migratedKey) !== "1") {
            n *= 10;
            localStorage.setItem(storageKey, String(n));
            localStorage.setItem(migratedKey, "1");
        }
        return clamp(Math.round(n), 0, BACKGROUND_BRIGHT_MAX);
    }
    const legacy = localStorage.getItem(legacyDarkKey);
    if (legacy === "0") return BACKGROUND_BRIGHT_MAX;
    if (legacy === "1") return 0;
    return 0;
}
let settingMenuBackgroundBright = readBackgroundBright("settingMenuBackgroundBright", "settingMenuBackgroundDarkMode");
let settingGameBackgroundBright = readBackgroundBright("settingGameBackgroundBright", "settingGameBackgroundDarkMode");
let settingWASDSensitivity = clamp(getNumberSetting("settingWASDSensitivity", 4), 1, 20);
let settingMusicVolume = clamp(getNumberSetting("settingMusicVolume", 6), 0, 10);
let settingGameMusicVolume = clamp(getNumberSetting("settingGameMusicVolume", 6), 0, 10);
let settingMenuSong = clamp(getNumberSetting("settingMenuSong", 1), 1, 10);
let settingGameSong = clamp(getNumberSetting("settingGameSong", 1), 1, 10);
const SFX_VOLUME_DEFAULT = 5;
let settingBounceVolume = clamp(getNumberSetting("settingBounceVolume", SFX_VOLUME_DEFAULT), 0, 10);
/** Soft-migrate new SFX sliders from Bounce once (they used to share that control). */
function readSfxVolumeSetting(key) {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "") {
        localStorage.setItem(key, String(settingBounceVolume));
        return settingBounceVolume;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? clamp(n, 0, 10) : SFX_VOLUME_DEFAULT;
}
let settingPickupVolume = readSfxVolumeSetting("settingPickupVolume");
let settingGameSfxVolume = readSfxVolumeSetting("settingGameSfxVolume");
let settingDarknessVolume = readSfxVolumeSetting("settingDarknessVolume");
const UI_VOLUME_DEFAULT = 8;
let settingUiVolume = clamp(getNumberSetting("settingUiVolume", UI_VOLUME_DEFAULT), 0, 10);
let settingEffectFlashes = getBoolSetting("settingEffectFlashes", true);
let settingEffectShake = getBoolSetting("settingEffectShake", true);
let settingEffectParticles = getBoolSetting("settingEffectParticles", true);
let settingFreezeOnLose = getBoolSetting("settingFreezeOnLose", true);
const FREEZE_ON_LOSE_SEC_MIN = 0.1;
const FREEZE_ON_LOSE_SEC_MAX = 60;
const FREEZE_ON_LOSE_SEC_DEFAULT = 2;

function readFreezeOnLoseSeconds(): number {
    const v = Number(localStorage.getItem("settingFreezeOnLoseSeconds") ?? String(FREEZE_ON_LOSE_SEC_DEFAULT));
    if (!Number.isFinite(v)) return FREEZE_ON_LOSE_SEC_DEFAULT;
    return Math.max(FREEZE_ON_LOSE_SEC_MIN, Math.min(FREEZE_ON_LOSE_SEC_MAX, Math.round(v * 10) / 10));
}

let settingFreezeOnLoseSeconds = readFreezeOnLoseSeconds();
let settingAutoRetry = getBoolSetting("settingAutoRetry", false);
let settingModesSelectPanel = getBoolSetting("settingModesSelectPanel", true);
let settingPlayTransition = getBoolSetting("settingPlayTransition", true);
let settingQuickRestart = getBoolSetting("settingQuickRestart", true);
let settingTrailEnabled = getBoolSetting("settingTrailEnabled", true);
let settingCosmeticsMatchCursor = getBoolSetting("settingCosmeticsMatchCursor", true);
let settingNeonBalls = getBoolSetting("settingNeonBalls", true);
let settingHomeAmbientBalls = getBoolSetting("settingHomeAmbientBalls", true);
let settingNewsInHome = getBoolSetting("settingNewsInHome", false);
let settingNotificationsInHome = getBoolSetting("settingNotificationsInHome", true);
let settingHomeSplash = getBoolSetting("settingHomeSplash", true);
let settingShowFps = getBoolSetting("settingShowFps", false);
let settingShowFpsWhere = readFpsShowWhere(localStorage.getItem("settingShowFpsWhere"));
let settingFpsLimit: FpsLimit = readFpsLimit(localStorage.getItem("settingFpsLimit"));
setGameplayFpsLimit(settingFpsLimit);
let settingLowPowerCap60 = readLowPowerCap60Enabled(localStorage.getItem("settingLowPowerCap60"));
setLowPowerCap60Enabled(settingLowPowerCap60);
let settingInvertReturnPause = getBoolSetting("settingInvertReturnPause", false);
let settingInvertSidebar = getBoolSetting("settingInvertSidebar", false);
const HOLD_RETURN_HOME_SEC_MIN = 0.3;
const HOLD_RETURN_HOME_SEC_MAX = 5;
const HOLD_RETURN_HOME_SEC_DEFAULT = 1;
function readHoldReturnHomeSeconds() {
    const v = Number(localStorage.getItem("settingHoldReturnHomeSeconds") ?? String(HOLD_RETURN_HOME_SEC_DEFAULT));
    if (!Number.isFinite(v)) return HOLD_RETURN_HOME_SEC_DEFAULT;
    return Math.max(HOLD_RETURN_HOME_SEC_MIN, Math.min(HOLD_RETURN_HOME_SEC_MAX, Math.round(v * 10) / 10));
}
let settingHoldReturnHome = getBoolSetting("settingHoldReturnHome", true);
let settingHoldReturnHomeSeconds = readHoldReturnHomeSeconds();
let settingSounds = getBoolSetting("settingSounds", true);
let settingTouchCursorJoystick = getBoolSetting("settingTouchCursorJoystick", false);
let settingTouchCursorJoystickVisible = getBoolSetting("settingTouchCursorJoystickVisible", true);
let settingTouchJoystickSensitivity = clamp(getNumberSetting("settingTouchJoystickSensitivity", 4), 1, 20);
let settingShowKeybindIndicator = getBoolSetting("settingShowKeybindIndicator", true);
let settingShowMobileSettingsInUi = getBoolSetting("settingShowMobileSettingsInUi", false);
/** Minimum collision radius (reference px); scaled in getCursorRadiusForMode. */
const CURSOR_HITBOX_MIN = 5;
/** Playing cursor cannot enter this inset from canvas edges; balls still use the full area (reference px). */
const CURSOR_EDGE_INSET_BASE_PX = 22;
/** Extra clearance beyond cursor hitbox + ball radius so new balls never spawn on top of the player (reference px). */
const SPAWN_CLEARANCE_FROM_CURSOR_REF_PX = 44;

function progressionTouchBandPx() {
    return Math.max(40 * gameLayoutScale(), cursorEdgeInsetPx());
}

function clampCursorXYToEdgeInset(x, y) {
    const m = cursorEdgeInsetPx();
    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) return { x, y };
    const minX = w >= 2 * m ? m : w * 0.5;
    const maxX = w >= 2 * m ? w - m : w * 0.5;
    const minY = h >= 2 * m ? m : h * 0.5;
    const maxY = h >= 2 * m ? h - m : h * 0.5;
    return { x: clamp(x, minX, maxX), y: clamp(y, minY, maxY) };
}

/** SpeedRun: full playfield — no invisible edge inset. */
function clampCursorXYToCanvas(x, y) {
    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) return { x, y };
    return { x: clamp(x, 0, w), y: clamp(y, 0, h) };
}
let settingRoulettePhotoAck = getBoolSetting("settingRoulettePhotoAck", false);

import { GAME_VERSION } from "../version";
const CREDIT_AUTHOR = "AdriLou111";

const L = {
    pauseTitle: "PAUSED",
    pauseHint: "Press P or click Resume to continue.",
    pauseHintNoKbd: "Click Resume to continue.",
    pauseHintTouch: "Tap Resume to continue.",
    pauseResume: "Resume",
    pauseReset: "Reset",
    creditsBy: `Game by ${CREDIT_AUTHOR}.`,
    creditsVersion: v => `v${v}`,
    photosensitivityBody:
        "Roulette mode can show bright full-screen flashes, rapid visual changes, and large motion. If you are sensitive to flashing lights or have photosensitive epilepsy, consider turning off Special Effects in Settings, or avoid this mode.",
    rouletteUnderstand: "I understand — Play",
    rouletteCancel: "Cancel"
};

let gamePaused = false;
let resumeCountdownTimer = null;
/** True while the 3-2-1 overlay is running after resume (blocks pause / input). */
let resumeCountdownActive = false;
/** `performance.now()` when gameplay was frozen; used to shift spawn/deadline timers on resume. */
let gameplayPauseStartedAt = 0;
let chatAutoRefreshTimer = null;
let friendsAutoRefreshTimer = null;
let friendsRefreshGen = 0;
let presenceHeartbeatTimer = null;
let lastPresenceActivitySent = "";
let lastPresenceSentAt = 0;
const PRESENCE_KEEPALIVE_MS = 45000;
const MESSAGE_PANEL_POLL_MS = 4000;
/** Incremental message thread DOM: avoid clearing on each poll. */
let lastMessageThreadPeer = "";
let lastMessageThreadIds = [];
let lastMessageThreadFingerprint = "";
const FRIEND_CHAT_ICON_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8A2.5 2.5 0 0 1 17.5 16H10l-4.2 3.4c-.7.55-1.8.06-1.8-.8V16H6.5A2.5 2.5 0 0 1 4 13.5v-8z"/></svg>';
const FRIEND_TRASH_ICON_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9.2 3h5.6l.8 1.5H20v1.8H4V4.5h4.4L9.2 3zM7 8.2h2V19H7V8.2zm4 0h2V19h-2V8.2zm4 0h2V19h-2V8.2z"/></svg>';
const MESSAGE_EDIT_CANCEL_ICON_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.4 5.3 12 10.9l5.6-5.6 1.1 1.1L13.1 12l5.6 5.6-1.1 1.1L12 13.1l-5.6 5.6-1.1-1.1L10.9 12 5.3 6.4l1.1-1.1z"/></svg>';
const MESSAGE_EDIT_SAVE_ICON_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9.2 16.6 5.4 12.8l1.4-1.4 2.4 2.4 7.4-7.4 1.4 1.4-8.8 8.8z"/></svg>';
const PRESENCE_MODE_LABELS = {
    normal: "Normal",
    wasd: "WASD",
    superdot: "Superdot",
    progression: "Progression",
    roulette: "Roulette",
    sandbox: "Sandbox",
    speedrun: "SpeedRun",
    highway: "Highway",
    darkness: "Darkness",
    mirror: "Mirror",
    snake: "Snake",
    combo: "Combo",
    overload: "Overload",
    colorrush: "Color Rush",
    heat: "Heat",
    hunter: "Hunter",
    pop: "POP",
    counter: "Counter",
    aim: "AIM",
    hook: "Hook",
    tilt: "Tilt",
    delay: "Delay",
    penalty: "Golf",
    multiplayer: "Multiplayer",
    local: "Local",
};
let equippedCosmeticCatalog = new Map();
/** Last shop catalog rows (for re-tint when cursor color changes). */
let shopCatalogForDisplay = [];
let lastCursorColorForMatchCosmetics = "";

async function resolveCosmeticDisplayLayer(item) {
    try {
        const layer = await resolveCosmeticVisual(item, {
            cursorHex: settingCursorColor,
            customTint: item.activeCustomColor || item.customColor || null,
        });
        return {
            imageData: layer.imageData,
            category: item.category || "cursor",
            animationFrames: layer.animationFrames,
            sourceImageData: item.imageData,
            outlineMaskData: item.outlineMaskData ?? null,
            matchCursorMaskData: item.matchCursorMaskData ?? null,
            matchCursorMaskFrames: item.matchCursorMaskFrames ?? null,
            sourceAnimationFrames: Array.isArray(item.animationFrames) ? item.animationFrames : null,
            trailMode: item.trailMode ?? null,
            trailColors: item.trailColors ?? null,
            newCursor: !!item.newCursor,
        };
    } catch {
        return {
            imageData: item.imageData,
            category: item.category || "cursor",
            animationFrames:
                Array.isArray(item.animationFrames) && item.animationFrames.length
                    ? item.animationFrames.filter((f) => typeof f === "string" && f.length > 0).slice(0, 10)
                    : null,
            sourceImageData: item.imageData,
            outlineMaskData: item.outlineMaskData ?? null,
            matchCursorMaskData: item.matchCursorMaskData ?? null,
            matchCursorMaskFrames: item.matchCursorMaskFrames ?? null,
            sourceAnimationFrames: Array.isArray(item.animationFrames) ? item.animationFrames : null,
            trailMode: item.trailMode ?? null,
            trailColors: item.trailColors ?? null,
            newCursor: !!item.newCursor,
        };
    }
}

async function refreshEquippedCosmeticDisplay() {
    if (!shopCatalogForDisplay.length) return;
    const entries = await Promise.all(
        shopCatalogForDisplay.map(async (i) => {
            const layer = await resolveCosmeticDisplayLayer(i);
            return [i.id, layer];
        }),
    );
    equippedCosmeticCatalog = new Map(entries);
    syncEquippedCosmeticFromState();
}

async function refreshShopCosmeticState() {
    try {
        const data = await fetchShopCatalog();
        setModeDotsConfig(data.modeDotsConfig);
        if (data.dots) applyDotsFromApi(data.dots);
        shopCatalogForDisplay = data.items;
        registerThemeCosmeticBatch(data.items);
        lastCursorColorForMatchCosmetics = settingCursorColor;
        // Shared catalog stays original art (multiplayer + shop resolve).
        setShopCosmeticCatalog(
            data.items.map((i) => ({
                id: i.id,
                imageData: i.imageData,
                category: i.category || "cursor",
                animationFrames: i.animationFrames ?? null,
                outlineMaskData: i.outlineMaskData ?? null,
                matchCursorMaskData: i.matchCursorMaskData ?? null,
                matchCursorMaskFrames: i.matchCursorMaskFrames ?? null,
                trailMode: i.trailMode ?? null,
                trailColors: i.trailColors ?? null,
                newCursor: !!i.newCursor,
            })),
        );
        const entries = await Promise.all(
            data.items.map(async (i) => {
                const layer = await resolveCosmeticDisplayLayer(i);
                return [i.id, layer];
            }),
        );
        equippedCosmeticCatalog = new Map(entries);
        syncEquippedCosmeticFromState();
    } catch {
        /* offline / no db / timeout — ignore so login/bootstrap never hangs */
    }
}

function syncEquippedCosmeticFromState() {
    const eqs = getDotsState().equippedCosmeticIds;
    setEquippedCosmeticLayers(
        eqs
            .map((id) => equippedCosmeticCatalog.get(id))
            .filter((x) => !!x)
            .map((x) => ({
                imageData: x.imageData,
                category: x.category || "cursor",
                animationFrames: x.animationFrames ?? null,
                sourceImageData: x.sourceImageData ?? x.imageData,
                outlineMaskData: x.outlineMaskData ?? null,
                matchCursorMaskData: x.matchCursorMaskData ?? null,
                matchCursorMaskFrames: x.matchCursorMaskFrames ?? null,
                sourceAnimationFrames: x.sourceAnimationFrames ?? x.animationFrames ?? null,
                trailMode: x.trailMode ?? null,
                trailColors: x.trailColors ?? null,
                newCursor: !!x.newCursor,
            })),
    );
}
let cloudUser = null;
let cloudIsAdmin = false;
let cloudAdminPermissions = [];
let cloudTimedOut = false;
let cloudTimedOutUntil = null;
let cloudTimedOutAt = null;
let timeoutTickTimer = null;
let accountBootstrapActive = true;
let appInitialBootstrapDone = false;
let authRefreshSerial = Promise.resolve();
/** Signed-in: map level → best ms from cloud ranking (`GET …&mine=1`). `null` = guest or not loaded yet. */
let speedrunCloudPersonalBests = null;
/** Signed-in: level index → best hits (`GET …mode=penalty&mine=1`). */
let penaltyCloudPersonalBests = null;
/** Loaded preset context for Sandbox SpeedRun times / cloud leaderboard (`presetId` = cloud row id). */
let sandboxActivePlayContext = { localName: null, cloudPresetId: null };
/** Signed-in: map presetId → best ms (`GET …mode=sandbox_speedrun&mine=1`). */
let sandboxSpeedrunCloudBests = null;
/** Signed-in: map presetId → best score (`GET …mode=sandbox&mine=1`). */
let sandboxScoreCloudBests = null;

const SANDBOX_DRAFT_KEY = "sandboxDraft";
const SANDBOX_PRESETS_KEY = "sandboxPresets";
const SANDBOX_SAVE_IS_PUBLIC_KEY = "sandboxSaveIsPublic";
/** Default "Public" toggle for next sandbox save (persisted). */
let sandboxSaveIsPublicPref = getBoolSetting(SANDBOX_SAVE_IS_PUBLIC_KEY, false);

function normalizeSandboxSpeedrunLayout(layout) {
    return normalizeLevelData(layout ?? {});
}

function defaultSandboxConfig() {
    return sandboxRuntimeFlat(defaultSandboxConfigV2("normal"));
}

/** Runtime flat view used by legacy spawn/update paths + nested mode params. */
function sandboxRuntimeFlat(cfg) {
    const n = normalizeSandboxConfigV2(cfg);
    return {
        ...n.common,
        baseMode: n.baseMode,
        mode: n.mode,
        schemaVersion: 2,
    };
}

function sandboxConfigAsV2(cfg) {
    if (!cfg || typeof cfg !== "object") return normalizeSandboxConfigV2({});
    // Nested v2
    if (cfg.common && typeof cfg.common === "object") return normalizeSandboxConfigV2(cfg);
    // Flat runtime (`sandboxRuntimeFlat`) — wrap so toggles are not dropped.
    return normalizeSandboxConfigV2({
        schemaVersion: 2,
        baseMode: cfg.baseMode || "normal",
        common: cfg,
        mode: cfg.mode || {},
    });
}

/** True when Sandbox WASD Movement is ON — keyboard/D-Pad only, never mouse. */
function sandboxWasdMovementActive() {
    if (isSandboxRunActive() && sbRuleEnabled("wasdEnabled")) return true;
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.wasdEnabled) return true;
    return false;
}

const SANDBOX_DEFAULTS = defaultSandboxConfig();

/** Roulette mouse mode: 1 = 1:1 pointer follow like Normal; sens_slow overrides `targetMouseLerp`. */
const ROULETTE_MOUSE_LERP_DEFAULT = 1;

/** Sandbox slide (no WASD): always 1:1 pointer follow (no smoothing). */
function sandboxPointerFollowLerp(_cfg) {
    return 1;
}

function roulettePointerFollowInstant() {
    return roulette.targetMouseLerp >= 1;
}

const sandboxNumericDrafts = {
    ballsSize: null,
    ballsSpeed: null,
    ballsPerSpawn: null,
    pointsPerSpawn: null,
    cursorSpeed: null,
    cursorSize: null,
    smoothCursor: null
};

function normalizeSandboxConfig(cfg = {}) {
    if (cfg && cfg.common) return sandboxRuntimeFlat(cfg);
    if (cfg && cfg.baseMode && cfg.mode && !cfg.ballsSize) return sandboxRuntimeFlat(cfg);
    return sandboxRuntimeFlat({
        schemaVersion: 2,
        baseMode: cfg.baseMode || "normal",
        common: cfg,
        mode: cfg.mode || {},
    });
}

function loadSandboxDraft() {
    try {
        const raw = localStorage.getItem(SANDBOX_DRAFT_KEY);
        if (!raw) return null;
        return normalizeSandboxConfig(JSON.parse(raw));
    } catch {
        return null;
    }
}

function saveSandboxDraft() {
    localStorage.setItem(SANDBOX_DRAFT_KEY, JSON.stringify(sandboxConfig));
}

function loadSandboxPresets() {
    try {
        const raw = localStorage.getItem(SANDBOX_PRESETS_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(arr)) return [];
        return arr
            .filter(item => item && typeof item.name === "string" && item.config)
            .map(item => {
                const cloudPresetId =
                    item.cloudPresetId != null && String(item.cloudPresetId).trim()
                        ? String(item.cloudPresetId).trim()
                        : undefined;
                const lastMs = Number(item.lastSpeedrunMs);
                return {
                    name: item.name,
                    config: normalizeSandboxConfig(item.config),
                    ...(cloudPresetId ? { cloudPresetId } : {}),
                    ...(Number.isFinite(lastMs) && lastMs > 0 ? { lastSpeedrunMs: Math.floor(lastMs) } : {}),
                };
            });
    } catch {
        return [];
    }
}

function saveSandboxPresets(arr) {
    localStorage.setItem(SANDBOX_PRESETS_KEY, JSON.stringify(arr));
    schedulePushAccountData();
}

function readSandboxSpeedrunLocalJson() {
    try {
        const raw = localStorage.getItem(KEY_SANDBOX_SPEEDRUN_LOCAL);
        if (!raw) return {};
        const o = JSON.parse(raw);
        return o && typeof o === "object" ? o : {};
    } catch {
        return {};
    }
}

function readSandboxSpeedrunLocalBestMs(key) {
    if (!key) return 0;
    const v = Number(readSandboxSpeedrunLocalJson()[key]);
    return Number.isFinite(v) && v > 0 ? v : 0;
}

function maybeWriteSandboxSpeedrunLocalBest(key, ms) {
    if (!key || !Number.isFinite(ms)) return;
    const flo = Math.floor(ms);
    const o = readSandboxSpeedrunLocalJson();
    const prev = Number(o[key]) || 0;
    if (!prev || flo < prev) {
        o[key] = flo;
        localStorage.setItem(KEY_SANDBOX_SPEEDRUN_LOCAL, JSON.stringify(o));
    }
}

function sandboxPresetStorageKey(cloudPresetId, localName) {
    if (cloudPresetId) return `cloud:${cloudPresetId}`;
    if (localName) return `local:${String(localName).toLowerCase()}`;
    return null;
}

function readSandboxScoreLocalJson() {
    try {
        const raw = localStorage.getItem(KEY_SANDBOX_SCORE_LOCAL);
        if (!raw) return {};
        const o = JSON.parse(raw);
        return o && typeof o === "object" ? o : {};
    } catch {
        return {};
    }
}

function readSandboxScoreLocalBest(key) {
    if (!key) return 0;
    const v = Number(readSandboxScoreLocalJson()[key]);
    return Number.isFinite(v) && v > 0 ? Math.floor(v) : 0;
}

function maybeWriteSandboxScoreLocalBest(key, score) {
    if (!key || !Number.isFinite(score)) return false;
    const flo = Math.floor(score);
    if (flo <= 0) return false;
    const o = readSandboxScoreLocalJson();
    const prev = Number(o[key]) || 0;
    if (flo > prev) {
        o[key] = flo;
        localStorage.setItem(KEY_SANDBOX_SCORE_LOCAL, JSON.stringify(o));
        return true;
    }
    return false;
}

/** Record for a named/cloud preset (score, or level when the preset runs Progression). */
function getSandboxPresetRecord(preset) {
    const cloudId = preset?.cloudPresetId || preset?.id || null;
    const key = sandboxPresetStorageKey(cloudId, preset?.name || preset?.localName || null);
    const fromMap = readSandboxScoreLocalBest(key);
    let cloud = 0;
    if (cloudId && cloudUser && sandboxScoreCloudBests) {
        cloud = Math.floor(Number(sandboxScoreCloudBests[cloudId]) || 0);
    }
    return Math.max(fromMap, cloud);
}

function formatSandboxPresetBestLine(preset) {
    const cfg = normalizeSandboxConfig(preset?.config || {});
    if (cfg.speedrunMode) {
        const ms = getSandboxSpeedrunBestMsForPreset(preset);
        return ms > 0 ? `Best Time: ${formatSpeedrunTime(ms)}` : "Best Time: —";
    }
    const n = getSandboxPresetRecord(preset);
    return cfg.progressionEnabled ? `Best Level: ${n}` : `Best Score: ${n}`;
}

/** Preset loaded for the active run, or `null` when playing an unsaved draft. */
function sandboxRunPresetRef() {
    const ctx = sandboxActivePlayContext;
    if (!ctx || (!ctx.localName && !ctx.cloudPresetId)) return null;
    return { id: ctx.cloudPresetId, cloudPresetId: ctx.cloudPresetId, name: ctx.localName };
}

/** Sandbox runs launch their base mode, so `gameMode` alone cannot identify them. */
function sandboxRunActiveNow() {
    return isSandboxRunActive() || gameMode === "sandbox";
}

function sandboxRunUsesLevelMetric() {
    return gameMode === "progression" || sandboxProgressionOverlayEnabled();
}

/** Best line for a sandbox run: the loaded preset’s record, else the Sandbox record. `null` outside sandbox runs. */
function sandboxRunBestLine() {
    if (!sandboxRunActiveNow()) return null;
    if (sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) return null;
    const ref = sandboxRunPresetRef();
    const value = ref ? getSandboxPresetRecord(ref) : bestSandbox;
    const n = Math.max(0, Math.floor(Number(value) || 0));
    return sandboxRunUsesLevelMetric() ? `Best Level: ${n}` : `Best Score: ${n}`;
}

let sandboxConfig = loadSandboxDraft() || defaultSandboxConfig();
let sandboxRuntimeConfig = null;
let sandboxPointerTarget = { x: innerWidth / 2, y: innerHeight / 2 };

const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
/** Mobile speakers/headphone routing is quieter; scale all Web Audio through one node. */
const MOBILE_AUDIO_MASTER_GAIN = 2.35;
const masterAudioGain = audioCtx.createGain();
masterAudioGain.connect(audioCtx.destination);
/** Low-pass on the full mix during Modes play transition (open = 22 kHz). */
const transitionLowpass = audioCtx.createBiquadFilter();
transitionLowpass.type = "lowpass";
transitionLowpass.frequency.value = 22000;
transitionLowpass.Q.value = 1.1;
const audioOutputBus = audioCtx.createGain();
audioOutputBus.connect(transitionLowpass);
transitionLowpass.connect(masterAudioGain);

function syncMasterAudioGain() {
    const g = isTouchGameUi() ? MOBILE_AUDIO_MASTER_GAIN : 1;
    if (isAudioContextRunning()) {
        masterAudioGain.gain.setValueAtTime(g, audioCtx.currentTime);
    } else {
        masterAudioGain.gain.value = g;
    }
}

syncMasterAudioGain();
window.addEventListener("resize", syncMasterAudioGain);

function isAudioContextRunning() {
    return audioCtx.state === "running";
}

/**
 * Resume AudioContext. Call only synchronously inside a trusted pointer/touch/click handler
 * (not keydown — Chrome often does not treat it as Web Audio user activation).
 */
/** Menu idle → suspend Web Audio (battery). Cleared on the next trusted gesture. */
const MENU_AUDIO_IDLE_MS = 45_000;
let menuAudioIdleSuspended = false;
let lastMenuUserActivityMs = performance.now();
let menuAudioIdleArmTimer = null;
let musicSyncIntervalId = null;

function noteMenuUserActivity() {
    lastMenuUserActivityMs = performance.now();
    if (menuAudioIdleSuspended) {
        menuAudioIdleSuspended = false;
        document.body.classList.remove("home-decor-idle");
    }
    armMenuAudioIdleTimer();
}

function armMenuAudioIdleTimer() {
    if (menuAudioIdleArmTimer != null) {
        clearTimeout(menuAudioIdleArmTimer);
        menuAudioIdleArmTimer = null;
    }
    if (playing || document.hidden) return;
    menuAudioIdleArmTimer = setTimeout(() => {
        menuAudioIdleArmTimer = null;
        maybeSuspendMenuAudioForIdle();
    }, MENU_AUDIO_IDLE_MS);
}

function maybeSuspendMenuAudioForIdle() {
    if (playing || document.hidden) return;
    if (!isMenuSceneVisible()) return;
    if (performance.now() - lastMenuUserActivityMs < MENU_AUDIO_IDLE_MS) {
        armMenuAudioIdleTimer();
        return;
    }
    menuAudioIdleSuspended = true;
    document.body.classList.add("home-decor-idle");
    stopMenuMusic();
    stopGameMusic();
    stopMusicSyncInterval();
    if (audioCtx.state === "running") {
        void audioCtx.suspend().catch(() => {});
    }
}

function stopMusicSyncInterval() {
    if (musicSyncIntervalId != null) {
        clearInterval(musicSyncIntervalId);
        musicSyncIntervalId = null;
    }
}

function ensureMusicSyncInterval() {
    if (musicSyncIntervalId != null) return;
    if (playing || menuAudioIdleSuspended || document.hidden) return;
    if (!isMenuSceneVisible()) return;
    musicSyncIntervalId = setInterval(() => {
        if (playing || menuAudioIdleSuspended || document.hidden || !isMenuSceneVisible()) {
            stopMusicSyncInterval();
            return;
        }
        syncMusicStateOnly();
    }, 1200);
}

function resumeAudioFromUserGesture() {
    noteMenuUserActivity();
    if (audioCtx.state === "running") return Promise.resolve();
    return audioCtx.resume().catch(() => {});
}

function uiVolumeGain(peak = 0.038) {
    if (settingUiVolume <= 0) return 0;
    return peak * (settingUiVolume / 10);
}

function sfxVolumeGain(level, peak) {
    if (level <= 0) return 0;
    return peak * (level / 10);
}

function playTone(freq, when, duration, gainValue, type = "square") {
    if (!gainValue || gainValue <= 0) return;
    if (!isAudioContextRunning()) return;

    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();

    osc.type = type;
    osc.frequency.setValueAtTime(freq, when);

    gain.gain.setValueAtTime(0.0001, when);
    gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, gainValue), when + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, when + duration);

    osc.connect(gain);
    gain.connect(audioOutputBus);

    osc.start(when);
    osc.stop(when + duration + 0.03);
}


let menuMusicTimer = null;
let menuMusicStep = 0;

let gameMusicTimer = null;
let gameMusicStep = 0;
/** 0–1: Flashbang in-game music curve (see startGameMusic). */
let gameMusicGainMultiplier = 1;
/** When set with `flashbangMusicTimelineStart > 0`, loop applies 1s silence + 2s fade-in. */
let flashbangMusicRampActive = false;
let flashbangMusicTimelineStart = 0;
const FLASHBANG_MUSIC_SILENT_MS = 1000;
const FLASHBANG_MUSIC_FADEIN_MS = 2000;
/** <1 while defeat SFX plays so game music stays very quiet (game loop only). */
let defeatGameMusicDuck = 1;
/** Darkness danger state: smooth duck on game music (1 = full volume). */
let darknessMusicDuck = 1;
/** Challenges red-lobby ambience: smoothly ducks game music toward a whisper. */
let challengeRedMusicDuck = 1;
let challengeRedMusicDuckTarget = 1;
const CHALLENGE_RED_MUSIC_LEVEL = 0.055;
const CHALLENGE_RED_MUSIC_FADE_PER_SEC = 0.85;
/** 0–1: distant duck during Modes play transition. */
let playTransitionMusicMuffle = 1;
const TRANSITION_LOWPASS_OPEN_HZ = 22000;
const TRANSITION_LOWPASS_MUFFLED_HZ = 340;
/** Continuous low drone while vision is critically small. */
let darknessTensionOsc = null;
let darknessTensionGain = null;
let darknessTensionActive = false;

/** Number of selectable chip loops (menu + game each pick 1…MUSIC_TRACK_COUNT). */
const MUSIC_TRACK_COUNT = 10;

/**
 * Looping 8-bit patterns (1 = legacy default). Each entry: menu voicing + brighter game voicing.
 */
const ARCADE_MUSIC_TRACKS = [
    {
        menuLead: [440, 523.25, 659.25, 523.25, 392, 523.25, 587.33, 493.88],
        menuBass: [110, 110, 130.81, 110, 98, 110, 130.81, 87.31],
        gameLead: [523.25, 659.25, 783.99, 659.25, 587.33, 698.46, 659.25, 523.25],
        gameBass: [130.81, 146.83, 174.61, 196, 174.61, 146.83, 130.81, 110],
    },
    {
        menuLead: [392, 440, 523.25, 440, 349.23, 392, 440, 392],
        menuBass: [98, 110, 130.81, 110, 87.31, 98, 110, 98],
        gameLead: [783.99, 880, 1046.5, 880, 698.46, 783.99, 880, 783.99],
        gameBass: [196, 220, 261.63, 220, 174.61, 196, 220, 196],
    },
    {
        menuLead: [523.25, 523.25, 659.25, 587.33, 523.25, 493.88, 523.25, 440],
        menuBass: [130.81, 130.81, 164.81, 146.83, 130.81, 123.47, 130.81, 110],
        gameLead: [1046.5, 1046.5, 1318.51, 1174.66, 1046.5, 987.77, 1046.5, 880],
        gameBass: [261.63, 261.63, 329.63, 293.66, 261.63, 246.94, 261.63, 220],
    },
    {
        menuLead: [329.63, 349.23, 392, 349.23, 311.13, 329.63, 293.66, 277.18],
        menuBass: [82.41, 87.31, 98, 87.31, 77.78, 82.41, 73.42, 69.3],
        gameLead: [659.25, 698.46, 783.99, 698.46, 622.25, 659.25, 587.33, 554.37],
        gameBass: [164.81, 174.61, 196, 174.61, 155.56, 164.81, 146.83, 138.59],
    },
    {
        menuLead: [392, 440, 493.88, 523.25, 587.33, 523.25, 493.88, 440],
        menuBass: [98, 110, 123.47, 130.81, 146.83, 130.81, 123.47, 110],
        gameLead: [783.99, 880, 987.77, 1046.5, 1174.66, 1046.5, 987.77, 880],
        gameBass: [196, 220, 246.94, 261.63, 293.66, 261.63, 246.94, 220],
    },
    {
        menuLead: [523.25, 493.88, 466.16, 493.88, 523.25, 587.33, 523.25, 440],
        menuBass: [130.81, 123.47, 116.54, 123.47, 130.81, 146.83, 130.81, 110],
        gameLead: [1046.5, 987.77, 932.33, 987.77, 1046.5, 1174.66, 1046.5, 880],
        gameBass: [261.63, 246.94, 233.08, 246.94, 261.63, 293.66, 261.63, 220],
    },
    {
        menuLead: [415.3, 523.25, 659.25, 523.25, 415.3, 349.23, 392, 440],
        menuBass: [103.83, 130.81, 164.81, 130.81, 103.83, 87.31, 98, 110],
        gameLead: [830.61, 1046.5, 1318.51, 1046.5, 830.61, 698.46, 783.99, 880],
        gameBass: [207.65, 261.63, 329.63, 261.63, 207.65, 174.61, 196, 220],
    },
    {
        menuLead: [587.33, 659.25, 783.99, 880, 783.99, 659.25, 587.33, 523.25],
        menuBass: [146.83, 164.81, 196, 220, 196, 164.81, 146.83, 130.81],
        gameLead: [1174.66, 1318.51, 1567.98, 1760, 1567.98, 1318.51, 1174.66, 1046.5],
        gameBass: [293.66, 329.63, 392, 440, 392, 329.63, 293.66, 261.63],
    },
    {
        menuLead: [349.23, 523.25, 392, 587.33, 440, 659.25, 493.88, 440],
        menuBass: [87.31, 130.81, 98, 146.83, 110, 164.81, 123.47, 110],
        gameLead: [698.46, 1046.5, 783.99, 1174.66, 880, 1318.51, 987.77, 880],
        gameBass: [174.61, 261.63, 196, 293.66, 220, 329.63, 246.94, 220],
    },
    {
        menuLead: [261.63, 329.63, 392, 523.25, 392, 349.23, 293.66, 246.94],
        menuBass: [65.41, 82.41, 98, 130.81, 98, 87.31, 73.42, 61.74],
        gameLead: [523.25, 659.25, 783.99, 1046.5, 783.99, 698.46, 587.33, 493.88],
        gameBass: [130.81, 164.81, 196, 261.63, 196, 174.61, 146.83, 123.47],
    },
];

function menuTrackArrays() {
    return ARCADE_MUSIC_TRACKS[clamp(settingMenuSong, 1, MUSIC_TRACK_COUNT) - 1];
}

function gameTrackArrays() {
    return ARCADE_MUSIC_TRACKS[clamp(settingGameSong, 1, MUSIC_TRACK_COUNT) - 1];
}

function isMpMenuFlowVisible() {
    const mpIds = ["mpEntryScreen", "mpCreateScreen", "mpJoinScreen", "mpLobbyScreen", "mpGameModeScreen"];
    return mpIds.some((id) => {
        const el = document.getElementById(id);
        return el && !el.classList.contains("hidden");
    });
}

function isMenuSceneVisible() {
    return !startScreen.classList.contains("hidden") ||
           !modeScreen.classList.contains("hidden") ||
           (gameHubScreen && !gameHubScreen.classList.contains("hidden")) ||
           (practiceScreen && !practiceScreen.classList.contains("hidden")) ||
           (challengesScreen && !challengesScreen.classList.contains("hidden")) ||
           (tournamentsScreen && !tournamentsScreen.classList.contains("hidden")) ||
           !statsScreen.classList.contains("hidden") ||
           !settingsScreen.classList.contains("hidden") ||
           !sandboxScreen.classList.contains("hidden") ||
           (sandboxBaseScreen && !sandboxBaseScreen.classList.contains("hidden")) ||
           (sandboxCommunityScreen && !sandboxCommunityScreen.classList.contains("hidden")) ||
           !creditsScreen.classList.contains("hidden") ||
           !rouletteWarnScreen.classList.contains("hidden") ||
           !authScreen.classList.contains("hidden") ||
           !leaderboardScreen.classList.contains("hidden") ||
           (achievementsScreen && !achievementsScreen.classList.contains("hidden")) ||
           (tasksScreen && !tasksScreen.classList.contains("hidden")) ||
           (battlePassScreen && !battlePassScreen.classList.contains("hidden")) ||
           (shopScreen && !shopScreen.classList.contains("hidden")) ||
           (inventoryScreen && !inventoryScreen.classList.contains("hidden")) ||
           !profileScreen.classList.contains("hidden") ||
           (newsScreen && !newsScreen.classList.contains("hidden")) ||
           (notificationsScreen && !notificationsScreen.classList.contains("hidden")) ||
           (wallScreen && !wallScreen.classList.contains("hidden")) ||
           isMpMenuFlowVisible() ||
           (() => {
               const adm = document.getElementById("adminPanelScreen");
               return adm && !adm.classList.contains("hidden");
           })() ||
           (speedrunLevelScreen && !speedrunLevelScreen.classList.contains("hidden")) ||
           (speedrunCompleteScreen && !speedrunCompleteScreen.classList.contains("hidden")) ||
           (penaltyLevelScreen && !penaltyLevelScreen.classList.contains("hidden")) ||
           (penaltyCompleteScreen && !penaltyCompleteScreen.classList.contains("hidden")) ||
           (() => {
               const sb = document.getElementById("sandboxSpeedrunPreviewScreen");
               return sb && !sb.classList.contains("hidden");
           })() ||
           (() => {
               const pb = document.getElementById("sandboxPenaltyPreviewScreen");
               return pb && !pb.classList.contains("hidden");
           })() ||
           (() => {
               const sw = document.getElementById("sandboxSpeedrunWinScreen");
               return sw && !sw.classList.contains("hidden");
           })();
}

function stopMenuMusic() {
    if (menuMusicTimer) {
        clearTimeout(menuMusicTimer);
        menuMusicTimer = null;
    }
}

function setPlayTransitionAudioDepth(depth) {
    const d = clamp(depth, 0, 1);
    const eased = d * d;
    playTransitionMusicMuffle = 1 - eased * 0.22;
    if (!isAudioContextRunning()) return;
    const t = audioCtx.currentTime;
    const freq =
        TRANSITION_LOWPASS_OPEN_HZ *
        Math.pow(TRANSITION_LOWPASS_MUFFLED_HZ / TRANSITION_LOWPASS_OPEN_HZ, eased);
    transitionLowpass.frequency.setTargetAtTime(Math.max(TRANSITION_LOWPASS_MUFFLED_HZ, freq), t, 0.09);
    transitionLowpass.Q.setTargetAtTime(1.1 + eased * 1.35, t, 0.09);
}

function playPlayTransitionSfx() {
    if (!settingSounds || settingUiVolume <= 0) return;
    runUiSound(() => {
        const vol = uiVolumeGain(0.028);
        const t0 = audioCtx.currentTime + 0.02;
        playTone(62, t0, 2.1, vol * 0.82, "sine");
        playTone(124, t0 + 0.12, 1.55, vol * 0.36, "triangle");
    });
}

function stopGameMusic() {
    if (gameMusicTimer) {
        clearTimeout(gameMusicTimer);
        gameMusicTimer = null;
    }
}

function startMenuMusic() {
    if (settingMusicVolume <= 0 || menuMusicTimer || playing || gamePaused || document.hidden) return;
    if (menuAudioIdleSuspended) return;
    if (!isAudioContextRunning()) return;
    menuMusicStep = 0;

    const loopStep = () => {
        if (!menuMusicTimer) return;

        if (!isAudioContextRunning()) {
            stopMenuMusic();
            return;
        }

        if (settingMusicVolume <= 0 || playing || gamePaused || document.hidden) {
            stopMenuMusic();
            return;
        }

        const now = audioCtx.currentTime + 0.03;
        const vol = 0.02 * (settingMusicVolume / 10) * playTransitionMusicMuffle;
        const themeMusic = getEffectiveThemeMusic();
        if (themeMusicAppliesToMenu(themeMusic)) {
            playThemeMusicStep(themeMusic, menuMusicStep, now, vol, playTone);
            menuMusicStep = (menuMusicStep + 1) % themeMusicTotalSteps(themeMusic);
            menuMusicTimer = setTimeout(loopStep, themeMusicStepMs(themeMusic.bpm));
            return;
        }

        const { menuLead, menuBass } = menuTrackArrays();
        const idx = menuMusicStep % menuLead.length;

        playTone(menuLead[idx], now, 0.16, vol, "square");
        if (menuMusicStep % 2 === 0) {
            const bassFreq = menuBass[Math.floor(menuMusicStep / 2) % menuBass.length];
            playTone(bassFreq, now, 0.24, vol * 0.75, "square");
        }

        menuMusicStep++;
        menuMusicTimer = setTimeout(loopStep, 240);
    };

    menuMusicTimer = setTimeout(loopStep, 0);
}

function startGameMusic() {
    if (settingGameMusicVolume <= 0 || gameMusicTimer || !playing || gamePaused || document.hidden) return;
    if (!isAudioContextRunning()) return;
    gameMusicStep = 0;

    const loopStep = () => {
        if (!gameMusicTimer) return;

        if (!isAudioContextRunning()) {
            stopGameMusic();
            return;
        }

        if (settingGameMusicVolume <= 0 || !playing || gamePaused || document.hidden) {
            stopGameMusic();
            return;
        }

        if (flashbangMusicRampActive && flashbangMusicTimelineStart > 0) {
            const elapsed = performance.now() - flashbangMusicTimelineStart;
            if (elapsed < FLASHBANG_MUSIC_SILENT_MS) {
                gameMusicGainMultiplier = 0;
            } else if (elapsed < FLASHBANG_MUSIC_SILENT_MS + FLASHBANG_MUSIC_FADEIN_MS) {
                gameMusicGainMultiplier =
                    (elapsed - FLASHBANG_MUSIC_SILENT_MS) / FLASHBANG_MUSIC_FADEIN_MS;
            } else {
                gameMusicGainMultiplier = 1;
                flashbangMusicRampActive = false;
                flashbangMusicTimelineStart = 0;
            }
        }

        const now = audioCtx.currentTime + 0.03;
        const vol =
            0.02 *
            (settingGameMusicVolume / 10) *
            gameMusicGainMultiplier *
            defeatGameMusicDuck *
            darknessMusicDuck *
            challengeRedMusicDuck *
            playTransitionMusicMuffle;
        const themeMusic = getEffectiveThemeMusic();
        if (themeMusicAppliesToGame(themeMusic)) {
            playThemeMusicStep(themeMusic, gameMusicStep, now, vol, playTone);
            gameMusicStep = (gameMusicStep + 1) % themeMusicTotalSteps(themeMusic);
            gameMusicTimer = setTimeout(loopStep, themeMusicStepMs(themeMusic.bpm));
            return;
        }

        const { gameLead, gameBass } = gameTrackArrays();
        const idx = gameMusicStep % gameLead.length;

        playTone(gameLead[idx], now, 0.16, vol, "triangle");
        if (gameMusicStep % 2 === 0) {
            const bassFreq = gameBass[Math.floor(gameMusicStep / 2) % gameBass.length];
            playTone(bassFreq, now, 0.24, vol * 0.75, "square");
        }

        gameMusicStep++;
        gameMusicTimer = setTimeout(loopStep, 240);
    };

    gameMusicTimer = setTimeout(loopStep, 0);
}

function updateMusicState() {
    if (document.hidden) {
        stopMenuMusic();
        stopGameMusic();
        stopMusicSyncInterval();
        return;
    }

    if (playing && gamePaused) {
        stopMenuMusic();
        stopGameMusic();
        stopMusicSyncInterval();
        return;
    }

    if (playing) {
        menuAudioIdleSuspended = false;
        document.body.classList.remove("home-decor-idle");
        stopMenuMusic();
        stopMusicSyncInterval();
        if (settingGameMusicVolume > 0) startGameMusic();
        else stopGameMusic();
        return;
    }

    if (menuAudioIdleSuspended) {
        stopMenuMusic();
        stopGameMusic();
        stopMusicSyncInterval();
        return;
    }

    if (isMenuSceneVisible()) {
        stopGameMusic();
        if (settingMusicVolume > 0) startMenuMusic();
        else stopMenuMusic();
        ensureMusicSyncInterval();
        return;
    }

    stopMenuMusic();
    stopGameMusic();
    stopMusicSyncInterval();
}

function updateMenuMusicState() {
    updateMusicState();
}

setTimeout(() => {
    if (!playing && isMenuSceneVisible()) updateMusicState();
}, 50);

function playBounceSound(speed = 1) {
    if (dpadPositionCustomizeMode) return;
    if (settingBounceVolume <= 0) return;
    const now = audioCtx.currentTime + 0.01;
    const base = clamp(220 + speed * 40 + Math.random() * 60, 120, 1000);
    const vol = sfxVolumeGain(settingBounceVolume, 0.02);
    playTone(base, now, 0.04, vol, "square");
    playTone(base * 1.5, now + 0.006, 0.025, vol * 0.6, "square");
}

/** Distinctive ORBIT intercept boom — not the wall bounce SFX. */
function playOrbitExplosionSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.004;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.038);

    const addNoiseBurst = (start, dur, peak) => {
        const n = Math.max(1, Math.floor(audioCtx.sampleRate * dur));
        const buf = audioCtx.createBuffer(1, n, audioCtx.sampleRate);
        const data = buf.getChannelData(0);
        for (let i = 0; i < n; i++) {
            const env = 1 - i / n;
            data[i] = (Math.random() * 2 - 1) * env * env;
        }
        const src = audioCtx.createBufferSource();
        const g = audioCtx.createGain();
        const f = audioCtx.createBiquadFilter();
        src.buffer = buf;
        f.type = "lowpass";
        f.frequency.setValueAtTime(2400, start);
        f.frequency.exponentialRampToValueAtTime(180, start + dur * 0.85);
        g.gain.setValueAtTime(0.0001, start);
        g.gain.exponentialRampToValueAtTime(Math.max(0.0001, peak), start + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
        src.connect(f);
        f.connect(g);
        g.connect(audioOutputBus);
        src.start(start);
        src.stop(start + dur + 0.02);
    };

    addNoiseBurst(t0, 0.22, vol * 0.95);
    playTone(98, t0, 0.16, vol * 0.7, "square");
    playTone(62, t0 + 0.02, 0.2, vol * 0.55, "triangle");
    playTone(310, t0 + 0.01, 0.07, vol * 0.35, "sawtooth");
    playTone(520, t0 + 0.045, 0.05, vol * 0.22, "square");
}

/** ORBIT core breach — heavy thud when a ball slips through. */
function playOrbitCoreHitSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.004;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.034);
    playTone(72, t0, 0.22, vol * 0.85, "triangle");
    playTone(48, t0 + 0.03, 0.28, vol * 0.65, "square");
    playTone(140, t0 + 0.01, 0.09, vol * 0.3, "sawtooth");
}

function playSpeedrunCoinPickupSound() {
    if (!settingSounds || settingPickupVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.006;
    const vol = sfxVolumeGain(settingPickupVolume, 0.026);
    playTone(1568, t0, 0.038, vol, "square");
    playTone(2093, t0 + 0.032, 0.048, vol * 0.82, "square");
    playTone(2637, t0 + 0.068, 0.042, vol * 0.55, "square");
}

/** Hook catch combo: higher pitch per catch in the same throw. */
function playHookComboCatchSound(combo) {
    if (!settingSounds || settingPickupVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const n = Math.max(1, Math.floor(combo));
    const t0 = audioCtx.currentTime + 0.004;
    const vol = sfxVolumeGain(settingPickupVolume, 0.028);
    const base = 520 * Math.pow(1.12, Math.min(16, n - 1));
    playTone(base, t0, 0.045, vol, "square");
    playTone(base * 1.5, t0 + 0.028, 0.055, vol * 0.72, "triangle");
}

/** Hook grabbed a red ball mid-throw — fail cue (combo text still shows). */
function playHookComboFailSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.004;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.034);
    playTone(280, t0, 0.08, vol, "sawtooth");
    playTone(180, t0 + 0.06, 0.12, vol * 0.9, "square");
    playTone(95, t0 + 0.14, 0.18, vol * 0.7, "triangle");
}

function playPendingHookCatchSfx() {
    const events = drainHookCatchEvents();
    for (const ev of events) {
        if (ev.isRed) playHookComboFailSound();
        else playHookComboCatchSound(ev.combo);
    }
}

/** LootDrop catcher-only chime when collecting a falling drop. */
function playLootDropPickupSound() {
    if (!settingSounds || settingPickupVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.004;
    const vol = sfxVolumeGain(settingPickupVolume, 0.03);
    playTone(988, t0, 0.04, vol, "square");
    playTone(1319, t0 + 0.04, 0.05, vol * 0.85, "square");
    playTone(1760, t0 + 0.09, 0.07, vol * 0.55, "triangle");
}

function playSpeedrunPortalWarpSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.003;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.032);

    const addSweep = (type, f0, f1, start, dur, peak) => {
        const osc = audioCtx.createOscillator();
        const g = audioCtx.createGain();
        osc.type = type;
        osc.frequency.setValueAtTime(Math.max(24, f0), start);
        osc.frequency.exponentialRampToValueAtTime(Math.max(24, f1), start + dur * 0.9);
        g.gain.setValueAtTime(0.0001, start);
        g.gain.exponentialRampToValueAtTime(Math.max(0.0001, peak), start + 0.007);
        g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
        osc.connect(g);
        g.connect(audioOutputBus);
        osc.start(start);
        osc.stop(start + dur + 0.04);
    };

    addSweep("sine", 1720, 88, t0, 0.15, vol * 0.88);
    addSweep("triangle", 2480, 290, t0 + 0.018, 0.12, vol * 0.52);
    addSweep("sine", 2050, 640, t0 + 0.095, 0.1, vol * 0.62);
    addSweep("sine", 102, 46, t0 + 0.035, 0.22, vol * 0.34);

    const shimmer = audioCtx.createOscillator();
    const shimmerGain = audioCtx.createGain();
    shimmer.type = "sine";
    shimmer.frequency.setValueAtTime(760, t0 + 0.075);
    shimmer.frequency.linearRampToValueAtTime(3680, t0 + 0.115);
    shimmer.frequency.exponentialRampToValueAtTime(180, t0 + 0.26);
    shimmerGain.gain.setValueAtTime(0.0001, t0 + 0.075);
    shimmerGain.gain.exponentialRampToValueAtTime(vol * 0.28, t0 + 0.1);
    shimmerGain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.27);
    shimmer.connect(shimmerGain);
    shimmerGain.connect(audioOutputBus);
    shimmer.start(t0 + 0.075);
    shimmer.stop(t0 + 0.3);
}

function playDefeatSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    const now = audioCtx.currentTime + 0.01;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.03);
    playTone(220, now, 0.18, vol, "square");
    playTone(165, now + 0.10, 0.22, vol * 0.85, "square");
    playTone(110, now + 0.22, 0.28, vol * 0.7, "triangle");
}

function playCursorCrackSound() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.008;
    const vol = sfxVolumeGain(settingGameSfxVolume, 0.038);
    playTone(920, t0, 0.028, vol * 0.75, "square");
    playTone(480, t0 + 0.01, 0.045, vol, "sawtooth");
    playTone(2100, t0 + 0.018, 0.022, vol * 0.45, "square");
    playTone(110, t0 + 0.025, 0.07, vol * 0.55, "triangle");
}

function playComboLifeLostSound() {
    if (!settingSounds || settingUiVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const t0 = audioCtx.currentTime + 0.006;
    const vol = 0.032 * (settingUiVolume / 10);
    playTone(420, t0, 0.06, vol, "square");
    playTone(280, t0 + 0.05, 0.09, vol * 0.85, "triangle");
    playTone(160, t0 + 0.1, 0.12, vol * 0.65, "sawtooth");
}

function stopDarknessTensionAudio() {
    if (darknessTensionGain && isAudioContextRunning()) {
        try {
            darknessTensionGain.gain.setTargetAtTime(0.0001, audioCtx.currentTime, 0.06);
        } catch {
            /* ignore */
        }
    }
    darknessTensionActive = false;
}

function ensureDarknessTensionNodes() {
    if (darknessTensionOsc && darknessTensionGain) return;
    if (!isAudioContextRunning()) return;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = "sawtooth";
    osc.frequency.value = 92;
    gain.gain.value = 0.0001;
    osc.connect(gain);
    gain.connect(audioOutputBus);
    osc.start();
    darknessTensionOsc = osc;
    darknessTensionGain = gain;
}

function updateDarknessTensionAudio(danger, dt) {
    if (gameMode !== "darkness" || !playing || gamePaused || deathPending) {
        stopDarknessTensionAudio();
        darknessMusicDuck = 1;
        return;
    }
    const d = clamp(danger, 0, 1);
    const targetDuck = 1 - d * 0.74;
    if (targetDuck < darknessMusicDuck) {
        darknessMusicDuck += (targetDuck - darknessMusicDuck) * lerpFrameRate(0.14, dt);
    } else {
        darknessMusicDuck += (targetDuck - darknessMusicDuck) * lerpFrameRate(0.38, dt);
    }

    if (!settingSounds || settingDarknessVolume <= 0 || d <= 0.008) {
        stopDarknessTensionAudio();
        if (d <= 0.008) darknessMusicDuck += (1 - darknessMusicDuck) * lerpFrameRate(0.32, dt);
        return;
    }

    ensureDarknessTensionNodes();
    if (!darknessTensionOsc || !darknessTensionGain || !isAudioContextRunning()) return;

    darknessTensionActive = true;
    const t = audioCtx.currentTime;
    const peak = sfxVolumeGain(settingDarknessVolume, 0.034) * d * d;
    darknessTensionGain.gain.setTargetAtTime(Math.max(0.0001, peak), t, d > 0.35 ? 0.18 : 0.08);
    const freq = 88 + d * 168;
    darknessTensionOsc.frequency.setTargetAtTime(freq, t, 0.2);
}

function clearFlashbangMusicSchedule() {
    flashbangMusicTimelineStart = 0;
    flashbangMusicRampActive = false;
}

/** Roulette FLASHBANG: ~2 s pitido (1 s estable + 1 s fade out). */
function playFlashbangLongBeep() {
    if (!settingSounds || settingGameSfxVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const peak = sfxVolumeGain(settingGameSfxVolume, 0.045);
    const t0 = audioCtx.currentTime + 0.008;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = "square";
    osc.frequency.setValueAtTime(2600, t0);
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.linearRampToValueAtTime(peak, t0 + 0.025);
    gain.gain.linearRampToValueAtTime(peak, t0 + 1);
    gain.gain.linearRampToValueAtTime(0.0001, t0 + 2);
    osc.connect(gain);
    gain.connect(audioOutputBus);
    osc.start(t0);
    osc.stop(t0 + 2.06);
}

const UI_TONE_GAIN = 0.038;

function beep(f = 600, d = 0.05) {
    if (!settingSounds || settingUiVolume <= 0) return;
    playTone(f, audioCtx.currentTime + 0.01, d, uiVolumeGain(UI_TONE_GAIN), "square");
}

/** Ascending chirp when opening pause (same contour inverted for close). */
function playPauseOpenChirp() {
    if (!settingSounds || settingUiVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const vol = uiVolumeGain(UI_TONE_GAIN);
    const t0 = audioCtx.currentTime + 0.012;
    const freqs = [523.25, 659.25, 783.99, 987.77];
    let t = t0;
    for (let i = 0; i < freqs.length; i++) {
        playTone(freqs[i], t, 0.07, vol, "sine");
        t += 0.065;
    }
}

/** Descending mirror when gameplay resumes after pause. */
function playPauseCloseChirp() {
    if (!settingSounds || settingUiVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const vol = uiVolumeGain(UI_TONE_GAIN);
    const t0 = audioCtx.currentTime + 0.012;
    const freqs = [987.77, 783.99, 659.25, 523.25];
    let t = t0;
    for (let i = 0; i < freqs.length; i++) {
        playTone(freqs[i], t, 0.07, vol, "sine");
        t += 0.065;
    }
}

const MENU_SIDEBAR_CHIRP = [440, 554.37, 659.25, 830.61];
const HOME_NAV_CHIRP = [392, 523.25, 659.25, 880];

function runUiSound(soundFn) {
    if (!settingSounds || settingUiVolume <= 0) return;
    const play = () => {
        if (!isAudioContextRunning()) return;
        soundFn();
    };
    if (isAudioContextRunning()) play();
    else void resumeAudioFromUserGesture().then(play);
}

/** Ascending chirp when opening the sidebar; descending mirror when closing. */
function playMenuSidebarChirp(opening) {
    runUiSound(() => {
        const vol = uiVolumeGain(UI_TONE_GAIN);
        const t0 = audioCtx.currentTime + 0.012;
        const freqs = opening ? MENU_SIDEBAR_CHIRP : [...MENU_SIDEBAR_CHIRP].reverse();
        let t = t0;
        for (let i = 0; i < freqs.length; i++) {
            playTone(freqs[i], t, 0.075, vol, "sine");
            t += 0.062;
        }
    });
}

/** Unique ascending chirp for Home navigation. */
function playHomeNavChirp() {
    runUiSound(() => {
        const vol = uiVolumeGain(UI_TONE_GAIN);
        const t0 = audioCtx.currentTime + 0.012;
        let t = t0;
        for (let i = 0; i < HOME_NAV_CHIRP.length; i++) {
            playTone(HOME_NAV_CHIRP[i], t, 0.08, vol, "sine");
            t += 0.064;
        }
    });
}

/** Negative return chirp (pause-like, triangle — distinct from generic UI beep). */
function playReturnNavChirp() {
    runUiSound(() => {
        const vol = uiVolumeGain(UI_TONE_GAIN);
        const t0 = audioCtx.currentTime + 0.012;
        const freqs = [739.99, 587.33, 440, 349.23];
        let t = t0;
        for (let i = 0; i < freqs.length; i++) {
            playTone(freqs[i], t, 0.08, vol, "triangle");
            t += 0.068;
        }
    });
}

function playModeCardBeep() {
    runUiSound(() => beep());
}

/** Challenges lobby / roulette / reveal cues (UI volume). */
function playChallengeSfx(kind) {
    runUiSound(() => {
        const vol = uiVolumeGain(0.042);
        const t0 = audioCtx.currentTime + 0.008;
        switch (kind) {
            case "enter_cube":
                playTone(220, t0, 0.28, vol * 0.9, "sine");
                playTone(330, t0 + 0.12, 0.35, vol * 0.55, "triangle");
                playTone(110, t0 + 0.05, 0.5, vol * 0.35, "sine");
                break;
            case "cube_break": {
                // Distinct shatter — not the wall-bounce SFX.
                const br = uiVolumeGain(0.07);
                playTone(180, t0, 0.06, br * 0.9, "square");
                playTone(95, t0 + 0.02, 0.18, br * 0.7, "sawtooth");
                playTone(420, t0 + 0.04, 0.05, br * 0.55, "triangle");
                playTone(640 + Math.random() * 80, t0 + 0.07, 0.04, br * 0.35, "square");
                playTone(310, t0 + 0.11, 0.12, br * 0.4, "triangle");
                playTone(70, t0 + 0.08, 0.28, br * 0.45, "sine");
                break;
            }
            case "fade_tick":
                playTone(180 + Math.random() * 40, t0, 0.08, vol * 0.28, "sine");
                break;
            case "countdown_tick": {
                // Loud second tick on the red countdown (high UI volume).
                const tick = uiVolumeGain(0.14);
                playTone(1480, t0, 0.028, tick, "square");
                playTone(980, t0 + 0.012, 0.04, tick * 0.55, "triangle");
                playTone(640, t0 + 0.02, 0.05, tick * 0.28, "sine");
                break;
            }
            case "roulette_appear":
                playTone(523.25, t0, 0.1, vol, "square");
                playTone(659.25, t0 + 0.08, 0.12, vol * 0.75, "square");
                playTone(880, t0 + 0.16, 0.16, vol * 0.55, "triangle");
                break;
            case "roulette_tick":
                playTone(740 + Math.random() * 80, t0, 0.035, vol * 0.32, "square");
                break;
            case "roulette_stop":
                playTone(392, t0, 0.12, vol * 0.85, "triangle");
                playTone(523.25, t0 + 0.1, 0.18, vol * 0.7, "sine");
                playTone(659.25, t0 + 0.22, 0.22, vol * 0.5, "sine");
                break;
            case "reveal_show":
                playTone(523.25, t0, 0.14, vol, "triangle");
                playTone(783.99, t0 + 0.1, 0.2, vol * 0.8, "sine");
                break;
            case "reveal_hide":
                playTone(659.25, t0, 0.08, vol * 0.45, "sine");
                playTone(392, t0 + 0.07, 0.12, vol * 0.35, "triangle");
                break;
            case "reward_appear":
                playTone(587.33, t0, 0.1, vol, "square");
                playTone(740.99, t0 + 0.09, 0.12, vol * 0.8, "square");
                playTone(987.77, t0 + 0.18, 0.18, vol * 0.6, "triangle");
                break;
            case "reward_claim":
                playTone(523.25, t0, 0.1, vol, "square");
                playTone(659.25, t0 + 0.09, 0.11, vol * 0.85, "square");
                playTone(783.99, t0 + 0.18, 0.12, vol * 0.7, "square");
                playTone(1046.5, t0 + 0.28, 0.22, vol * 0.55, "triangle");
                break;
            case "goal_complete": {
                const g = uiVolumeGain(0.055);
                playTone(392, t0, 0.1, g * 0.7, "triangle");
                playTone(523.25, t0 + 0.08, 0.12, g * 0.85, "square");
                playTone(659.25, t0 + 0.18, 0.14, g, "square");
                playTone(783.99, t0 + 0.3, 0.22, g * 0.75, "sine");
                playTone(1046.5, t0 + 0.42, 0.28, g * 0.55, "triangle");
                break;
            }
            case "fail":
                playTone(246.94, t0, 0.16, vol * 0.8, "square");
                playTone(196, t0 + 0.12, 0.2, vol * 0.65, "triangle");
                playTone(146.83, t0 + 0.26, 0.28, vol * 0.5, "sine");
                break;
            default:
                break;
        }
    });
}

function isMpGameplayInputBlocked() {
    return resumeCountdownActive || isMpSpeedrunLocalFinished() || isMpSpeedrunSpectating();
}

function playProgressionLevelUpSound(level) {
    runUiSound(() => {
        const vol = uiVolumeGain(0.04);
        const steps = clamp(Math.floor(level) - 1, 0, 32);
        const base = 392 * Math.pow(2, steps / 12);
        const t0 = audioCtx.currentTime + 0.01;
        playTone(base, t0, 0.11, vol, "square");
        playTone(base * 1.2599, t0 + 0.09, 0.09, vol * 0.72, "square");
        playTone(base * 1.5874, t0 + 0.17, 0.07, vol * 0.48, "square");
    });
}

/** Short tick when resume countdown digit updates (3 → 2 → 1). */
function playResumeCountdownTickBeep() {
    if (!settingSounds || settingUiVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    playTone(880, audioCtx.currentTime + 0.01, 0.055, uiVolumeGain(0.032), "square");
}

document.addEventListener("click", e => {
    if (e.target.tagName !== "BUTTON" || e.isTrusted === false) return;
    if (e.target instanceof Element && e.target.closest("#returnBtn, #sideHomeBtn, #sideNavToggle")) return;
    if (e.target instanceof Element && e.target.closest(".toggleSwitch")) return;
    const playBeep = () => {
        if (!settingSounds) return;
        beep();
    };
    if (isAudioContextRunning()) playBeep();
    else void resumeAudioFromUserGesture().then(playBeep);
});

/** Refresh music timers without touching AudioContext (no resume — avoids autoplay warnings). */
function syncMusicStateOnly() {
    updateMusicState();
}

function unlockAudioFromTrustedPointerOrTouch(ev) {
    if (!ev || ev.isTrusted === false) {
        noteMenuUserActivity();
        syncMusicStateOnly();
        return;
    }
    void resumeAudioFromUserGesture().then(() => {
        updateMusicState();
        ensureMusicSyncInterval();
    });
}

window.addEventListener("load", () => {
    syncMusicStateOnly();
    setTimeout(syncMusicStateOnly, 250);
    setTimeout(syncMusicStateOnly, 1000);
    armMenuAudioIdleTimer();
});
window.addEventListener("pageshow", syncMusicStateOnly);
document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
        noteMenuUserActivity();
        syncMusicStateOnly();
        ensureMusicSyncInterval();
    } else {
        stopMusicSyncInterval();
        if (menuAudioIdleArmTimer != null) {
            clearTimeout(menuAudioIdleArmTimer);
            menuAudioIdleArmTimer = null;
        }
    }
});
document.addEventListener("pointerdown", unlockAudioFromTrustedPointerOrTouch, { passive: true });
document.addEventListener("touchstart", unlockAudioFromTrustedPointerOrTouch, { passive: true });
/* armMenuAudioIdleTimer: only from load/visibility — not here (playing is declared later). */

document.addEventListener("contextmenu", e => {
    e.preventDefault();
    if (dpadPositionCustomizeMode) return;
    if (!playing || deathPending || gamePaused) return;
    // Right-click never ends the run. Only a mode's own action runs.
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        respawnSandboxSpeedrunFromLaser();
        return;
    }
    if (gameMode === "aim") handleAimGoldenRightClickReshuffle();
});

const canvas = document.getElementById("game");
const ctx = canvas.getContext("2d");
const canvasCursorTop = document.getElementById("gameCursorTop");
const ctxCursorTop = canvasCursorTop ? canvasCursorTop.getContext("2d") : null;
/** When set, gameplay canvas backing store stays at the recorded replay resolution. */
let replayCanvasLock = null;

/** Reference shorter edge (~720px): lasers, cursor, balls, insets scale with min(w,h)/this. */
const GAME_LAYOUT_REF_MIN = 720;
let lastGameLayoutScale = 1;
function gameLayoutScale() {
    const w = canvas.width;
    const h = canvas.height;
    const m = Math.min(w, h);
    if (m <= 0) return 1;
    return clamp(m / GAME_LAYOUT_REF_MIN, 0.42, 3.2);
}
function cursorEdgeInsetPx() {
    return Math.max(10, Math.round(CURSOR_EDGE_INSET_BASE_PX * gameLayoutScale()));
}

/** HIGHWAY: `mouse.x` / `mouse.y` are world coords; convert for draw / hit tests. */
function highwayCursorScreen() {
    return highwayCursorScreenPos(mouse.x, mouse.y, canvas.height);
}

function mirrorCursorScreen() {
    const sx = deathPending ? frozenMouse.x : mouse.x;
    const sy = deathPending ? frozenMouse.y : mouse.y;
    return mirrorCursorPos(sx, sy, canvas.width, canvas.height);
}

function clearGameCursorTopLayer() {
    if (!ctxCursorTop || !canvasCursorTop || canvasCursorTop.width <= 0 || canvasCursorTop.height <= 0) return;
    ctxCursorTop.clearRect(0, 0, canvasCursorTop.width, canvasCursorTop.height);
}

function resize() {
    refreshGameplayBackingStore();
    const pixel = replayCanvasLock || gameplayCanvasInternalSize();
    canvas.width = pixel.w;
    canvas.height = pixel.h;
    if (canvasCursorTop) {
        canvasCursorTop.width = pixel.w;
        canvasCursorTop.height = pixel.h;
    }
    applyGameplaySurfaceCssSize();
    lastGameLayoutScale = gameLayoutScale();
}
resize();
requestAnimationFrame(() => {
    resize();
});
function onViewportLayoutChange() {
    if (isReplayPlaybackActive() || replayCanvasLock) {
        resize();
        return;
    }
    const prevW = canvas.width;
    const prevH = canvas.height;
    const restorePlayCursor =
        typeof playing !== "undefined" && playing && !deathPending && prevW > 0 && prevH > 0;
    const mouseNorm = restorePlayCursor ? normCanvasPoint(mouse.x, mouse.y, prevW, prevH) : null;
    const rouletteNorm = restorePlayCursor
        ? normCanvasPoint(roulette.pointerTarget.x, roulette.pointerTarget.y, prevW, prevH)
        : null;
    const sandboxNorm = restorePlayCursor
        ? normCanvasPoint(sandboxPointerTarget.x, sandboxPointerTarget.y, prevW, prevH)
        : null;

    const prevLayoutScale = lastGameLayoutScale;
    resize();
    const s = lastGameLayoutScale;
    if (playing && obstacles.length > 0 && prevW > 0 && prevH > 0) {
        const rx = canvas.width / prevW;
        const ry = canvas.height / prevH;
        const dimChanged = Math.abs(rx - 1) > 0.001 || Math.abs(ry - 1) > 0.001;
        const layoutChanged = prevLayoutScale > 1e-8 && Math.abs(s / prevLayoutScale - 1) > 0.001;
        if (dimChanged || layoutChanged) {
            for (const o of obstacles) {
                if (dimChanged) {
                    o.x *= rx;
                    o.y *= ry;
                }
                if (layoutChanged) {
                    const ratio = s / prevLayoutScale;
                    o.r *= ratio;
                    o.vx *= ratio;
                    o.vy *= ratio;
                }
            }
        }
    }
    refreshMenuKbdLabels();
    applyDpadLayoutFromStorage();
    refreshDpadSettingsVisibility();
    if (sandboxSpeedrunPreviewScreen && !sandboxSpeedrunPreviewScreen.classList.contains("hidden")) {
        if (sandboxSpeedrunEditorApi) sandboxSpeedrunEditorApi.refitCanvas();
    }
    if (sandboxPenaltyPreviewScreen && !sandboxPenaltyPreviewScreen.classList.contains("hidden")) {
        if (sandboxPenaltyEditorApi) sandboxPenaltyEditorApi.refitCanvas();
    }
    if (typeof playing !== "undefined" && playing) updateMobilePlayChrome();
    if (isLocalActive() && localTouchZones) {
        relayoutLocalTouchZones(canvas.width, canvas.height);
    }
    if (typeof playing !== "undefined" && playing && !deathPending) {
        const sizeChanged = canvas.width !== prevW || canvas.height !== prevH;
        if (!sizeChanged) return;
        if (activeGameTouchPointers.size === 0 && !touchSteerSession) {
            resetRelativePointerAnchor();
        }
        if (typeof gameMode !== "undefined" && gameMode === "speedrun") {
            rebuildSpeedrunGeometry();
            mouse.x = clamp(speedrunLastNorm.nx, 0, 1) * canvas.width;
            mouse.y = clamp(speedrunLastNorm.ny, 0, 1) * canvas.height;
            const m = clampCursorXYToCanvas(mouse.x, mouse.y);
            mouse.x = m.x;
            mouse.y = m.y;
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
        } else if (typeof gameMode !== "undefined" && gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
            rebuildSandboxSpeedrunGeometry();
            mouse.x = clamp(speedrunLastNorm.nx, 0, 1) * canvas.width;
            mouse.y = clamp(speedrunLastNorm.ny, 0, 1) * canvas.height;
            const m = clampCursorXYToCanvas(mouse.x, mouse.y);
            mouse.x = m.x;
            mouse.y = m.y;
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
            sandboxSpeedrunPrev.x = mouse.x;
            sandboxSpeedrunPrev.y = mouse.y;
        } else if (typeof gameMode !== "undefined" && gameMode === "highway") {
            const rx = prevW > 0 ? canvas.width / prevW : 1;
            mouse.x = clamp(mouse.x * rx, 0, canvas.width);
        } else if (mouseNorm) {
            applyNormToEdgeInsetMouse(mouseNorm.nx, mouseNorm.ny);
        }
        if (isSpeedrunPhysicsMode()) {
            flushSpeedrunPointerIntent();
        }
        if (rouletteNorm) {
            const rt = clampCursorXYToEdgeInset(
                clamp(rouletteNorm.nx, 0, 1) * canvas.width,
                clamp(rouletteNorm.ny, 0, 1) * canvas.height,
            );
            roulette.pointerTarget.x = rt.x;
            roulette.pointerTarget.y = rt.y;
        } else {
            const r = clampCursorXYToEdgeInset(roulette.pointerTarget.x, roulette.pointerTarget.y);
            roulette.pointerTarget.x = r.x;
            roulette.pointerTarget.y = r.y;
        }
        const sandboxClamp =
            gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode
                ? clampCursorXYToCanvas
                : clampCursorXYToEdgeInset;
        if (sandboxNorm) {
            const sb = sandboxClamp(
                clamp(sandboxNorm.nx, 0, 1) * canvas.width,
                clamp(sandboxNorm.ny, 0, 1) * canvas.height,
            );
            sandboxPointerTarget.x = sb.x;
            sandboxPointerTarget.y = sb.y;
        } else {
            const sb = sandboxClamp(sandboxPointerTarget.x, sandboxPointerTarget.y);
            sandboxPointerTarget.x = sb.x;
            sandboxPointerTarget.y = sb.y;
        }
        syncCursorSweepPrevFromMouse();
        if (isSpeedrunPhysicsMode()) syncSpeedrunSweepPrevFromMouse();
        if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
            sandboxPointerTarget.x = mouse.x;
            sandboxPointerTarget.y = mouse.y;
        }
        if (gameMode === "tilt") {
            syncTiltCursorPos(mouse.x, mouse.y);
        }
        if (gameMode === "orbit") {
            const pos = orbitCursorPos(
                canvas.width,
                canvas.height,
                getCursorRadiusForMode(),
                gameLayoutScale(),
            );
            mouse.x = pos.x;
            mouse.y = pos.y;
        }
        if (gameMode === "delay" && prevW > 0 && prevH > 0) {
            remapDelayHistory(prevW, prevH, canvas.width, canvas.height);
            const real = getDelayRealCursorPos();
            syncDelayRealPrev(real.x, real.y);
        }
    }
}
addEventListener("resize", onViewportLayoutChange);
window.visualViewport?.addEventListener("resize", onViewportLayoutChange);
window.visualViewport?.addEventListener("scroll", onViewportLayoutChange);

document.addEventListener("pointerlockchange", () => {
    resetRelativePointerAnchor();
    if (document.pointerLockElement === canvas) {
        pointerLockMovementWarmup = true;
        return;
    }
    if (performance.now() < pointerLockPauseSuppressedUntil) return;
    if (isLootDropActive()) return;
    if (isPlayTransitionRunning()) return;
    // Challenges (and Campaign lobby) must keep running when the tab loses focus /
    // pointer lock — never auto-open the Pause screen on window switch.
    if (challengesPauseBlocked() || campaignPauseBlocked() || marathonPauseBlocked()) return;
    if (isReplayPlaybackActive()) return;
    if (playing && !gamePaused && !deathPending && !resumeCountdownActive && shouldUseGamePointerLock()) {
        setPaused(true);
    }
});

const startScreen = document.getElementById("startScreen");
const newsScreen = document.getElementById("newsScreen");
const notificationsScreen = document.getElementById("notificationsScreen");
const wallScreen = document.getElementById("wallScreen");
const statsScreen = document.getElementById("statsScreen");
const settingsScreen = document.getElementById("settingsScreen");
const achievementsScreen = document.getElementById("achievementsScreen");
const tasksScreen = document.getElementById("tasksScreen");
const tasksScreenMount = document.getElementById("tasksScreenMount");
const battlePassScreen = document.getElementById("battlePassScreen");
const battlePassScreenMount = document.getElementById("battlePassScreenMount");
const achievementsGrid = document.getElementById("achievementsGrid");
const achievementsCountLabel = document.getElementById("achievementsCountLabel");
const achievementsFilterSelect = document.getElementById("achievementsFilterSelect");
const achievementsLoadingHint = document.getElementById("achievementsLoadingHint");
const shopScreen = document.getElementById("shopScreen");
const shopDotsBalanceValue = document.getElementById("shopDotsBalanceValue");
const shopCosmeticsGrid = document.getElementById("shopCosmeticsGrid");
const shopStatusHint = document.getElementById("shopStatusHint");
const inventoryScreen = document.getElementById("inventoryScreen");
const inventoryDotsBalanceValue = document.getElementById("inventoryDotsBalanceValue");
const inventoryCosmeticsGrid = document.getElementById("inventoryCosmeticsGrid");
const inventoryOutfitsPanel = document.getElementById("inventoryOutfitsPanel");
const inventoryIndexPanel = document.getElementById("inventoryIndexPanel");
const inventoryTabCosmeticsBtn = document.getElementById("inventoryTabCosmeticsBtn");
const inventoryTabOutfitsBtn = document.getElementById("inventoryTabOutfitsBtn");
const inventoryTabIndexBtn = document.getElementById("inventoryTabIndexBtn");
const inventoryIndexFilter = document.getElementById("inventoryIndexFilter");
const inventoryStatusHint = document.getElementById("inventoryStatusHint");
const inventoryLivePreviewCanvas = document.getElementById("inventoryLivePreviewCanvas");
const inventoryBannerPreviewCanvas = document.getElementById("inventoryBannerPreviewCanvas");
const inventoryEquippedList = document.getElementById("inventoryEquippedList");
const modeScreen = document.getElementById("modeScreen");
const gameHubScreen = document.getElementById("gameHubScreen");
const practiceScreen = document.getElementById("practiceScreen");
const challengesScreen = document.getElementById("challengesScreen");
const tournamentsScreen = document.getElementById("tournamentsScreen");
const campaignScreen = document.getElementById("campaignScreen");
const marathonScreen = document.getElementById("marathonScreen");
const sandboxScreen = document.getElementById("sandboxScreen");
const sandboxBaseScreen = document.getElementById("sandboxBaseScreen");
const sandboxCommunityScreen = document.getElementById("sandboxCommunityScreen");
const gameOverScreen = document.getElementById("gameOverScreen");
const returnBtn = document.getElementById("returnBtn");
const pauseTopBtn = document.getElementById("pauseTopBtn");
const touchSteerLayer = document.getElementById("touchSteerLayer");
const orbitSteerLayer = document.getElementById("orbitSteerLayer");
const orbitHold = { left: false, right: false };
/** Active pointerId → { dir, startX, startY, sliding, gen, zone } for invisible side zones. */
const orbitZonePointers = new Map();
/** Monotonic gen per zone press — ignores stale lostpointercapture after rapid re-taps (iOS reuses ids). */
let orbitZonePointerGen = 0;
/** pointerId → gen we intentionally ended; delayed lostpointercapture must not kill a newer press. */
const orbitZonePendingLostGen = new Map();

function restartOrbitSteerHint() {
    if (!orbitSteerLayer) return;
    const touch = isTouchGameUi() || mobileTouchInputActive();
    const leftLabel = orbitSteerLayer.querySelector(".orbit-steer-hint-panel--left .orbit-steer-hint-label");
    const rightLabel = orbitSteerLayer.querySelector(".orbit-steer-hint-panel--right .orbit-steer-hint-label");
    if (leftLabel) leftLabel.textContent = touch ? "◀ HOLD" : "HOLD A";
    if (rightLabel) rightLabel.textContent = touch ? "HOLD ▶" : "HOLD D";
    orbitSteerLayer.classList.remove("orbit-steer-hint-play");
    void orbitSteerLayer.offsetWidth;
    orbitSteerLayer.classList.add("orbit-steer-hint-play");
}

function syncOrbitHoldFromZones() {
    let left = false;
    let right = false;
    for (const st of orbitZonePointers.values()) {
        if (st.sliding) continue;
        if (st.dir === "left") left = true;
        if (st.dir === "right") right = true;
    }
    orbitHold.left = left;
    orbitHold.right = right;
}

function clearAllOrbitZonePointers() {
    orbitZonePointers.clear();
    orbitZonePendingLostGen.clear();
    orbitHold.left = false;
    orbitHold.right = false;
}

/** End a zone press. `expectedGen` skips stale events after a newer press reused the same pointerId. */
function endOrbitZonePointer(pointerId, expectedGen = null) {
    const st = orbitZonePointers.get(pointerId);
    if (!st) {
        if (expectedGen != null) orbitZonePendingLostGen.delete(pointerId);
        return false;
    }
    if (expectedGen != null && st.gen !== expectedGen) return false;
    orbitZonePendingLostGen.set(pointerId, st.gen);
    orbitZonePointers.delete(pointerId);
    syncOrbitHoldFromZones();
    return true;
}

function beginOrbitZonePointer(zone, e) {
    const dir = zone.getAttribute("data-orbit-dir");
    if (dir !== "left" && dir !== "right") return;
    const gen = ++orbitZonePointerGen;
    orbitZonePointers.set(e.pointerId, {
        dir,
        startX: e.clientX,
        startY: e.clientY,
        lastX: e.clientX,
        sliding: false,
        gen,
        zone,
    });
    orbitZonePendingLostGen.delete(e.pointerId);
    try {
        zone.setPointerCapture(e.pointerId);
    } catch {
        /* ignore — global up/cancel still clears */
    }
    syncOrbitHoldFromZones();
}

function handleOrbitZoneLostCapture(e) {
    const pendingGen = orbitZonePendingLostGen.get(e.pointerId);
    orbitZonePendingLostGen.delete(e.pointerId);
    const st = orbitZonePointers.get(e.pointerId);
    if (!st) return;
    // Stale lostcapture from a prior press that reused this pointerId — keep the new press.
    if (pendingGen != null && st.gen !== pendingGen) return;
    orbitZonePointers.delete(e.pointerId);
    syncOrbitHoldFromZones();
}
const touchPlaySteerPad = document.getElementById("touchPlaySteerPad");
const localTouchZones = document.getElementById("localTouchZones");
const localResultScreen = document.getElementById("localResultScreen");
const localResultTitle = document.getElementById("localResultTitle");
const localResultMessage = document.getElementById("localResultMessage");
let localSnakeTrails = [];
let localPendingConfig = null;
let localSpeedrunFrozenTSec = -1;
/** Speedrun sim time held while death freeze is active (lasers / walls stop). */
let speedrunDeathFrozenTSec = -1;
/** Checkpoint laser hit — respawn after death freeze instead of game over. */
let speedrunCheckpointDeathPending = false;
let pendingLocalSpeedrunLaserHit = false;
const touchJoystickSettings = document.getElementById("touchJoystickSettings");
const touchJoystickVisibleRow = document.getElementById("touchJoystickVisibleRow");
const touchJoystickSensitivityRow = document.getElementById("touchJoystickSensitivityRow");
const touchJoystickSensitivity = document.getElementById("touchJoystickSensitivity");
const touchJoystickSensitivityVal = document.getElementById("touchJoystickSensitivityVal");
const touchJoystickSensitivityDefault = document.getElementById("touchJoystickSensitivityDefault");
const toggleTouchJoystickBtn = document.getElementById("toggleTouchJoystickBtn");
const toggleTouchJoystickVisibleBtn = document.getElementById("toggleTouchJoystickVisibleBtn");
const toggleShowMobileSettingsBtn = document.getElementById("toggleShowMobileSettingsBtn");
const settingsMobilePreviewNav = document.getElementById("settingsMobilePreviewNav");
const dpadPositionSettings = document.getElementById("dpadPositionSettings");
const dpadCustomizeBtn = document.getElementById("dpadCustomizeBtn");
const dpadCustomizeDoneBtn = document.getElementById("dpadCustomizeDoneBtn");
const dpadCustomizeLayoutBtn = document.getElementById("dpadCustomizeLayoutBtn");
const dpadCustomizeResetBtn = document.getElementById("dpadCustomizeResetBtn");
const dpadCustomizeReturnBtn = document.getElementById("dpadCustomizeReturnBtn");
const dpadCustomizeScaleSlider = document.getElementById("dpadCustomizeScaleSlider");
const dpadCustomizeOpacitySlider = document.getElementById("dpadCustomizeOpacitySlider");
const dpadCustomizeUndoBtn = document.getElementById("dpadCustomizeUndoBtn");
const dpadCustomizeRedoBtn = document.getElementById("dpadCustomizeRedoBtn");
const dpadCustomizeGridBtn = document.getElementById("dpadCustomizeGridBtn");
const dpadCustomizeExitConfirm = document.getElementById("dpadCustomizeExitConfirm");
const dpadCustomizeExitYesBtn = document.getElementById("dpadCustomizeExitYesBtn");
const dpadCustomizeExitNoBtn = document.getElementById("dpadCustomizeExitNoBtn");
const toggleDpadEightDirBtn = document.getElementById("toggleDpadEightDirBtn");
const superHud = document.getElementById("superHud");
const superHudSlowBtn = document.getElementById("superHudSlowBtn");
const superHudShieldBtn = document.getElementById("superHudShieldBtn");
const superHudBarrierBtn = document.getElementById("superHudBarrierBtn");
const superHudPushBtn = document.getElementById("superHudPushBtn");
const fxFlash = document.getElementById("fxFlash");
const topCenter = document.getElementById("topCenter");
const rouletteScoreLine = document.getElementById("rouletteScoreLine");
const rouletteEffectText = document.getElementById("rouletteEffectText");

function resetRouletteHudOverlay() {
    if (rouletteEffectText) {
        rouletteEffectText.style.opacity = "0";
        rouletteEffectText.textContent = "";
    }
    if (rouletteScoreLine) {
        rouletteScoreLine.style.opacity = "0";
        rouletteScoreLine.textContent = "";
        rouletteScoreLine.setAttribute("aria-hidden", "true");
    }
}

const statsGrid = document.getElementById("statsGrid");
const openModesBtn = document.getElementById("openModes");
const timeoutScreen = document.getElementById("timeoutScreen");
const timeoutRemainingLine = document.getElementById("timeoutRemainingLine");
const timeoutAppliedLine = document.getElementById("timeoutAppliedLine");
const timeoutLogoutBtn = document.getElementById("timeoutLogoutBtn");
const timeoutCreateAccountBtn = document.getElementById("timeoutCreateAccountBtn");
const settingsResetBtn = document.getElementById("settingsResetBtn");
const settingsUndoBtn = document.getElementById("settingsUndoBtn");
const settingsRedoBtn = document.getElementById("settingsRedoBtn");
const settingsResetConfirmScreen = document.getElementById("settingsResetConfirmScreen");
const settingsResetConfirmYesBtn = document.getElementById("settingsResetConfirmYesBtn");
const settingsResetConfirmNoBtn = document.getElementById("settingsResetConfirmNoBtn");
const settingsCopyBtn = document.getElementById("settingsCopyBtn");
const settingsPasteBtn = document.getElementById("settingsPasteBtn");
const startNormalBtn = document.getElementById("startNormalBtn");
const startProgressionBtn = document.getElementById("startProgressionBtn");
const startWASDBtn = document.getElementById("startWASDBtn");
const startSuperDotBtn = document.getElementById("startSuperDotBtn");
const startRouletteBtn = document.getElementById("startRouletteBtn");
const startSandboxBtn = document.getElementById("startSandboxBtn");
const startSpeedRunBtn = document.getElementById("startSpeedRunBtn");
const startPenaltyBtn = document.getElementById("startPenaltyBtn");
const startHighwayBtn = document.getElementById("startHighwayBtn");
const startDarknessBtn = document.getElementById("startDarknessBtn");
const startColorRushBtn = document.getElementById("startColorRushBtn");
const startHeatBtn = document.getElementById("startHeatBtn");
const startHunterBtn = document.getElementById("startHunterBtn");
const startPopBtn = document.getElementById("startPopBtn");
const startCounterBtn = document.getElementById("startCounterBtn");
const startAimBtn = document.getElementById("startAimBtn");
const startHookBtn = document.getElementById("startHookBtn");
const startMirrorBtn = document.getElementById("startMirrorBtn");
const startSnakeBtn = document.getElementById("startSnakeBtn");
const startComboBtn = document.getElementById("startComboBtn");
const comboHeartsRow = document.getElementById("comboHeartsRow");
const comboMultiplierHud = document.getElementById("comboMultiplierHud");
const comboToast = document.getElementById("comboToast");
const speedrunLevelScreen = document.getElementById("speedrunLevelScreen");
const speedrunLevelGrid = document.getElementById("speedrunLevelGrid");
const speedrunCompleteScreen = document.getElementById("speedrunCompleteScreen");
const speedrunCompleteTime = document.getElementById("speedrunCompleteTime");
const speedrunCompleteReturnBtn = document.getElementById("speedrunCompleteReturnBtn");
const speedrunCompletePlayAgainBtn = document.getElementById("speedrunCompletePlayAgainBtn");
const speedrunCompleteNextBtn = document.getElementById("speedrunCompleteNextBtn");
const speedrunCompleteHeading = document.getElementById("speedrunCompleteHeading");
const penaltyLevelScreen = document.getElementById("penaltyLevelScreen");
const penaltyLevelGrid = document.getElementById("penaltyLevelGrid");
const penaltyCompleteScreen = document.getElementById("penaltyCompleteScreen");
const penaltyCompleteHits = document.getElementById("penaltyCompleteHits");
const penaltyCompleteReturnBtn = document.getElementById("penaltyCompleteReturnBtn");
const penaltyCompletePlayAgainBtn = document.getElementById("penaltyCompletePlayAgainBtn");
const penaltyCompleteNextBtn = document.getElementById("penaltyCompleteNextBtn");
const penaltyCompleteHeading = document.getElementById("penaltyCompleteHeading");
const rankingPenaltyLevelWrap = document.getElementById("rankingPenaltyLevelWrap");
const rankingPenaltyLevelSelect = document.getElementById("rankingPenaltyLevelSelect");
const statsPenaltyLevelSelect = document.getElementById("statsPenaltyLevelSelect");
const statsPenaltyBestLine = document.getElementById("statsPenaltyBestLine");
const statsPenaltyTopLine = document.getElementById("statsPenaltyTopLine");
const rankingSpeedrunLevelWrap = document.getElementById("rankingSpeedrunLevelWrap");
const rankingSpeedrunLevelSelect = document.getElementById("rankingSpeedrunLevelSelect");
const statsSpeedrunLevelSelect = document.getElementById("statsSpeedrunLevelSelect");
const statsSpeedrunBestLine = document.getElementById("statsSpeedrunBestLine");
const statsSpeedrunTopLine = document.getElementById("statsSpeedrunTopLine");
/** Live-updated while STATS is open (play time ticks in game loop). */
let statsPlaytimeRecordEl = null;
const gameOverNewRecord = document.getElementById("gameOverNewRecord");
const gameOverDeathMsg = document.getElementById("gameOverDeathMsg");
const gameOverRunStat = document.getElementById("gameOverRunStat");
const gameOverBestStat = document.getElementById("gameOverBestStat");
const gameOverDotsPanel = document.getElementById("gameOverDotsPanel");
const gameOverDotsScore = document.getElementById("gameOverDotsScore");
const gameOverDotsBonus = document.getElementById("gameOverDotsBonus");
const gameOverDotsTotal = document.getElementById("gameOverDotsTotal");
const gameOverDotsGuest = document.getElementById("gameOverDotsGuest");
const playAgainBtn = document.getElementById("playAgainBtn");

const creditsScreen = document.getElementById("creditsScreen");
const creditsBody = document.getElementById("creditsBody");
const creditsVersionEl = document.getElementById("creditsVersion");
const rouletteWarnScreen = document.getElementById("rouletteWarnScreen");
const rouletteWarnText = document.getElementById("rouletteWarnText");
const rouletteWarnAcceptBtn = document.getElementById("rouletteWarnAcceptBtn");
const rouletteWarnCancelBtn = document.getElementById("rouletteWarnCancelBtn");
const pauseScreen = document.getElementById("pauseScreen");
const pauseTitle = document.getElementById("pauseTitle");
const pauseHint = document.getElementById("pauseHint");
const pauseResumeBtn = document.getElementById("pauseResumeBtn");
const pauseResetBtn = document.getElementById("pauseResetBtn");

const authScreen = document.getElementById("authScreen");
const authScreenTitle = document.getElementById("authScreenTitle");
const authSwitchBtn = document.getElementById("authSwitchBtn");
const authGuestBtn = document.getElementById("authGuestBtn");
const authAddAccountReturnBtn = document.getElementById("authAddAccountReturnBtn");
const loginFormBlock = document.getElementById("loginFormBlock");
const registerFormBlock = document.getElementById("registerFormBlock");
const loginEmail = document.getElementById("loginEmail");
const loginPassword = document.getElementById("loginPassword");
const loginError = document.getElementById("loginError");
const loginSubmitBtn = document.getElementById("loginSubmitBtn");
const forgotPasswordLink = document.getElementById("forgotPasswordLink");
const forgotPasswordFormBlock = document.getElementById("forgotPasswordFormBlock");
const forgotStep1 = document.getElementById("forgotStep1");
const forgotStep2 = document.getElementById("forgotStep2");
const forgotEmail = document.getElementById("forgotEmail");
const forgotTempPassword = document.getElementById("forgotTempPassword");
const forgotNewPassword = document.getElementById("forgotNewPassword");
const forgotVerifyError = document.getElementById("forgotVerifyError");
const forgotCompleteError = document.getElementById("forgotCompleteError");
const forgotCompleteOk = document.getElementById("forgotCompleteOk");
const forgotVerifyBtn = document.getElementById("forgotVerifyBtn");
const forgotDoneBtn = document.getElementById("forgotDoneBtn");
const forgotBackBtn = document.getElementById("forgotBackBtn");
let forgotRecoveryEmail = "";
let forgotRecoveryTempPassword = "";
const registerDisplayName = document.getElementById("registerDisplayName");
const registerEmail = document.getElementById("registerEmail");
const registerPassword = document.getElementById("registerPassword");
const registerError = document.getElementById("registerError");
const registerSubmitBtn = document.getElementById("registerSubmitBtn");
const authStatusLine = document.getElementById("authStatusLine");
const sideNav = document.getElementById("sideNav");
const sideNavToggle = document.getElementById("sideNavToggle");
const sideHomeBtn = document.getElementById("sideHomeBtn");
const sideSettingsBtn = document.getElementById("sideSettingsBtn");
const sideRankingsBtn = document.getElementById("sideRankingsBtn");
const sideStatsBtn = document.getElementById("sideStatsBtn");
const sideAchievementsBtn = document.getElementById("sideAchievementsBtn");
const sideTasksBtn = document.getElementById("sideTasksBtn");
const sideBattlePassBtn = document.getElementById("sideBattlePassBtn");
const sideBattlePassClaimBadge = document.getElementById("sideBattlePassClaimBadge");
const sideTasksClaimBadge = document.getElementById("sideTasksClaimBadge");
const sideShopBtn = document.getElementById("sideShopBtn");
const sideInventoryBtn = document.getElementById("sideInventoryBtn");
const sideSocialBtn = document.getElementById("sideSocialBtn");
const sideNotificationsBtn = document.getElementById("sideNotificationsBtn");
const sideNewsBtn = document.getElementById("sideNewsBtn");
const sideWallBtn = document.getElementById("sideWallBtn");
const sideCreditsBtn = document.getElementById("sideCreditsBtn");
const sideAdminPanelBtn = document.getElementById("sideAdminPanelBtn");
const sideSignInBtn = document.getElementById("sideSignInBtn");
const sideLogoutBtn = document.getElementById("sideLogoutBtn");
const sideSwitchAccountBtn = document.getElementById("sideSwitchAccountBtn");
const sideNavAccountRow = document.getElementById("sideNavAccountRow");
const homeSignInBtn = document.getElementById("homeSignInBtn");
const profileScreen = document.getElementById("profileScreen");
const profileScreenHint = document.getElementById("profileScreenHint");
const profileSignedBlock = document.getElementById("profileSignedBlock");
const profileAccountBlock = document.getElementById("profileAccountBlock");
const profileSocialTabs = document.getElementById("profileSocialTabs");
const socialTabFriendsBtn = document.getElementById("socialTabFriendsBtn");
const socialTabSearchBtn = document.getElementById("socialTabSearchBtn");
const profileFindPlayerBlock = document.getElementById("profileFindPlayerBlock");
const profileFriendsBlock = document.getElementById("profileFriendsBlock");
const profileMessagesBlock = document.getElementById("profileMessagesBlock");
const profileMeLine = document.getElementById("profileMeLine");
const profileMyId = document.getElementById("profileMyId");
const profileBioInput = document.getElementById("profileBioInput");
const profileBioSaveBtn = document.getElementById("profileBioSaveBtn");
const profileLookupId = document.getElementById("profileLookupId");
const profileLookupBtn = document.getElementById("profileLookupBtn");
const profilePublicCard = document.getElementById("profilePublicCard");
const friendEmailInput = document.getElementById("friendEmailInput");
const friendRequestBtn = document.getElementById("friendRequestBtn");
const friendActionStatus = document.getElementById("friendActionStatus");
const friendIncomingList = document.getElementById("friendIncomingList");
const friendListWrap = document.getElementById("friendListWrap");
const messagePeerSelect = document.getElementById("messagePeerSelect");
const messageThread = document.getElementById("messageThread");
const resumeCountdownOverlay = document.getElementById("resumeCountdownOverlay");
const messageComposeInput = document.getElementById("messageComposeInput");
const messageSendBtn = document.getElementById("messageSendBtn");
const messageBackBtn = document.getElementById("messageBackBtn");
const leaderboardScreen = document.getElementById("leaderboardScreen");
const rankingModeSelect = document.getElementById("rankingModeSelect");
const rankingOtherSelect = document.getElementById("rankingOtherSelect");
const rankingRefreshBtn = document.getElementById("rankingRefreshBtn");
const leaderboardStatus = document.getElementById("leaderboardStatus");
const leaderboardTableWrap = document.getElementById("leaderboardTableWrap");

const toggleEffectFlashesBtn = document.getElementById("toggleEffectFlashesBtn");
const toggleEffectShakeBtn = document.getElementById("toggleEffectShakeBtn");
const toggleEffectParticlesBtn = document.getElementById("toggleEffectParticlesBtn");
const freezeGameSettingsRow = document.getElementById("freezeGameSettingsRow");
const freezeGameSecondsInput = document.getElementById("freezeGameSecondsInput") as HTMLInputElement | null;
const toggleFreezeGameBtn = document.getElementById("toggleFreezeGameBtn");
const toggleAutoRetryBtn = document.getElementById("toggleAutoRetryBtn");
const toggleModesSelectPanelBtn = document.getElementById("toggleModesSelectPanelBtn");
const togglePlayTransitionBtn = document.getElementById("togglePlayTransitionBtn");
const quickRestartSettings = document.getElementById("quickRestartSettings");
const toggleQuickRestartBtn = document.getElementById("toggleQuickRestartBtn");
const toggleTrailBtn = document.getElementById("toggleTrailBtn");
const toggleCosmeticsMatchCursorBtn = document.getElementById("toggleCosmeticsMatchCursorBtn");
const trailColorSettings = document.getElementById("trailColorSettings");
const toggleNeonBallsBtn = document.getElementById("toggleNeonBallsBtn");
const toggleHomeAmbientBallsBtn = document.getElementById("toggleHomeAmbientBallsBtn");
const toggleNewsInHomeBtn = document.getElementById("toggleNewsInHomeBtn");
const toggleNotificationsInHomeBtn = document.getElementById("toggleNotificationsInHomeBtn");
const toggleHomeSplashBtn = document.getElementById("toggleHomeSplashBtn");
const toggleShowFpsBtn = document.getElementById("toggleShowFpsBtn");
const showFpsWhereRow = document.getElementById("showFpsWhereRow");
const showFpsWhereBtns = document.querySelectorAll("[data-fps-where]");
const fpsLimit = document.getElementById("fpsLimit");
const fpsLimitVal = document.getElementById("fpsLimitVal");
const toggleLowPowerCap60Btn = document.getElementById("toggleLowPowerCap60Btn");
const toggleInvertReturnPauseBtn = document.getElementById("toggleInvertReturnPauseBtn");
const toggleInvertSidebarBtn = document.getElementById("toggleInvertSidebarBtn");
const toggleHoldReturnHomeBtn = document.getElementById("toggleHoldReturnHomeBtn");
const holdReturnHomeSecondsInput = document.getElementById("holdReturnHomeSecondsInput") as HTMLInputElement | null;
const holdReturnHomeSecondsField = document.getElementById("holdReturnHomeSecondsField");
const toggleSoundsBtn = document.getElementById("toggleSoundsBtn");
const toggleKeybindIndicatorBtn = document.getElementById("toggleKeybindIndicatorBtn");

const ballsR = document.getElementById("ballsR");
const ballsG = document.getElementById("ballsG");
const ballsB = document.getElementById("ballsB");
const ballsRVal = document.getElementById("ballsRVal");
const ballsGVal = document.getElementById("ballsGVal");
const ballsBVal = document.getElementById("ballsBVal");
const ballsHex = document.getElementById("ballsHex");
const ballsPreview = document.getElementById("ballsPreview");

const trailR = document.getElementById("trailR");
const trailG = document.getElementById("trailG");
const trailB = document.getElementById("trailB");
const trailRVal = document.getElementById("trailRVal");
const trailGVal = document.getElementById("trailGVal");
const trailBVal = document.getElementById("trailBVal");
const trailHex = document.getElementById("trailHex");
const trailPreview = document.getElementById("trailPreview");

const cursorR = document.getElementById("cursorR");
const cursorG = document.getElementById("cursorG");
const cursorB = document.getElementById("cursorB");
const cursorRVal = document.getElementById("cursorRVal");
const cursorGVal = document.getElementById("cursorGVal");
const cursorBVal = document.getElementById("cursorBVal");
const cursorHex = document.getElementById("cursorHex");
const cursorPreview = document.getElementById("cursorPreview");

const inventoryCursorR = document.getElementById("inventoryCursorR");
const inventoryCursorG = document.getElementById("inventoryCursorG");
const inventoryCursorB = document.getElementById("inventoryCursorB");
const inventoryCursorRVal = document.getElementById("inventoryCursorRVal");
const inventoryCursorGVal = document.getElementById("inventoryCursorGVal");
const inventoryCursorBVal = document.getElementById("inventoryCursorBVal");
const inventoryCursorHex = document.getElementById("inventoryCursorHex");

const inventoryTrailR = document.getElementById("inventoryTrailR");
const inventoryTrailG = document.getElementById("inventoryTrailG");
const inventoryTrailB = document.getElementById("inventoryTrailB");
const inventoryTrailRVal = document.getElementById("inventoryTrailRVal");
const inventoryTrailGVal = document.getElementById("inventoryTrailGVal");
const inventoryTrailBVal = document.getElementById("inventoryTrailBVal");
const inventoryTrailHex = document.getElementById("inventoryTrailHex");
const inventoryTrailLinePreview = document.getElementById("inventoryTrailLinePreview");

const buttonsR = document.getElementById("buttonsR");
const buttonsG = document.getElementById("buttonsG");
const buttonsB = document.getElementById("buttonsB");
const buttonsRVal = document.getElementById("buttonsRVal");
const buttonsGVal = document.getElementById("buttonsGVal");
const buttonsBVal = document.getElementById("buttonsBVal");
const buttonsHex = document.getElementById("buttonsHex");
const buttonsPreview = document.getElementById("buttonsPreview");
const textR = document.getElementById("textR");
const textG = document.getElementById("textG");
const textB = document.getElementById("textB");
const textRVal = document.getElementById("textRVal");
const textGVal = document.getElementById("textGVal");
const textBVal = document.getElementById("textBVal");
const textHex = document.getElementById("textHex");
const textPreview = document.getElementById("textPreview");
const textAutoColorBtn = document.getElementById("textAutoColorBtn");
const showAdminThemeBtn = document.getElementById("showAdminThemeBtn");
const textColorSettings = document.getElementById("textColorSettings");

const wasdSensitivity = document.getElementById("wasdSensitivity");
const wasdSensitivityVal = document.getElementById("wasdSensitivityVal");
const wasdSensitivityDefault = document.getElementById("wasdSensitivityDefault");

const menuBackgroundR = document.getElementById("menuBackgroundR");
const menuBackgroundG = document.getElementById("menuBackgroundG");
const menuBackgroundB = document.getElementById("menuBackgroundB");
const menuBackgroundRVal = document.getElementById("menuBackgroundRVal");
const menuBackgroundGVal = document.getElementById("menuBackgroundGVal");
const menuBackgroundBVal = document.getElementById("menuBackgroundBVal");
const menuBackgroundHex = document.getElementById("menuBackgroundHex");
const menuBackgroundPreview = document.getElementById("menuBackgroundPreview");
const menuBackgroundBright = document.getElementById("menuBackgroundBright");
const menuBackgroundBrightVal = document.getElementById("menuBackgroundBrightVal");

const gameBackgroundR = document.getElementById("gameBackgroundR");
const gameBackgroundG = document.getElementById("gameBackgroundG");
const gameBackgroundB = document.getElementById("gameBackgroundB");
const gameBackgroundRVal = document.getElementById("gameBackgroundRVal");
const gameBackgroundGVal = document.getElementById("gameBackgroundGVal");
const gameBackgroundBVal = document.getElementById("gameBackgroundBVal");
const gameBackgroundHex = document.getElementById("gameBackgroundHex");
const gameBackgroundPreview = document.getElementById("gameBackgroundPreview");
const gameBackgroundBright = document.getElementById("gameBackgroundBright");
const gameBackgroundBrightVal = document.getElementById("gameBackgroundBrightVal");

const menuMusicVolume = document.getElementById("menuMusicVolume");
const menuMusicVolumeVal = document.getElementById("menuMusicVolumeVal");
const gameMusicVolume = document.getElementById("gameMusicVolume");
const gameMusicVolumeVal = document.getElementById("gameMusicVolumeVal");
const musicVolumeDefault = document.getElementById("musicVolumeDefault");
const menuSongPickBtn = document.getElementById("menuSongPickBtn");
const gameSongPickBtn = document.getElementById("gameSongPickBtn");

const bounceVolume = document.getElementById("bounceVolume");
const bounceVolumeVal = document.getElementById("bounceVolumeVal");
const bounceVolumeDefault = document.getElementById("bounceVolumeDefault");
const pickupVolume = document.getElementById("pickupVolume");
const pickupVolumeVal = document.getElementById("pickupVolumeVal");
const pickupVolumeDefault = document.getElementById("pickupVolumeDefault");
const gameSfxVolume = document.getElementById("gameSfxVolume");
const gameSfxVolumeVal = document.getElementById("gameSfxVolumeVal");
const gameSfxVolumeDefault = document.getElementById("gameSfxVolumeDefault");
const darknessVolume = document.getElementById("darknessVolume");
const darknessVolumeVal = document.getElementById("darknessVolumeVal");
const darknessVolumeDefault = document.getElementById("darknessVolumeDefault");
const uiVolumeSettings = document.getElementById("uiVolumeSettings");
const uiVolume = document.getElementById("uiVolume");
const uiVolumeVal = document.getElementById("uiVolumeVal");
const uiVolumeDefault = document.getElementById("uiVolumeDefault");


const slowText = document.getElementById("slowText");
const slowTime = document.getElementById("slowTime");
const shieldText = document.getElementById("shieldText");
const shieldTime = document.getElementById("shieldTime");
const barrierText = document.getElementById("barrierText");
const barrierTime = document.getElementById("barrierTime");
const pushText = document.getElementById("pushText");
const pushTime = document.getElementById("pushTime");

/* SANDBOX UI */
const sandboxBallsSize = document.getElementById("sandboxBallsSize");
const sandboxBallsSizeVal = document.getElementById("sandboxBallsSizeVal");
const sandboxBallsSizeInput = document.getElementById("sandboxBallsSizeInput");
const sandboxBallsSpeed = document.getElementById("sandboxBallsSpeed");
const sandboxBallsSpeedVal = document.getElementById("sandboxBallsSpeedVal");
const sandboxBallsPerSpawn = document.getElementById("sandboxBallsPerSpawn");
const sandboxBallsPerSpawnVal = document.getElementById("sandboxBallsPerSpawnVal");
const sandboxBallsPerSpawnInput = document.getElementById("sandboxBallsPerSpawnInput");
const sandboxPointsPerSpawn = document.getElementById("sandboxPointsPerSpawn");
const sandboxPointsPerSpawnVal = document.getElementById("sandboxPointsPerSpawnVal");
const sandboxCursorSpeed = document.getElementById("sandboxCursorSpeed");
const sandboxCursorSpeedVal = document.getElementById("sandboxCursorSpeedVal");
const sandboxCursorSpeedInput = document.getElementById("sandboxCursorSpeedInput");
const sandboxCursorSize = document.getElementById("sandboxCursorSize");
const sandboxCursorSizeVal = document.getElementById("sandboxCursorSizeVal");
const sandboxCursorSizeInput = document.getElementById("sandboxCursorSizeInput");
const sandboxSmoothCursor = document.getElementById("sandboxSmoothCursor");
const sandboxSmoothCursorVal = document.getElementById("sandboxSmoothCursorVal");
const sandboxSmoothCursorInput = document.getElementById("sandboxSmoothCursorInput");
const sandboxBallCollisionsBtn = document.getElementById("sandboxBallCollisionsBtn");
const sandboxMagnetBtn = document.getElementById("sandboxMagnetBtn");
const sandboxBounceBoost = document.getElementById("sandboxBounceBoost");
const sandboxBounceBoostVal = document.getElementById("sandboxBounceBoostVal");
const sandboxBounceBoostInput = document.getElementById("sandboxBounceBoostInput");
const sandboxWASDModeBtn = document.getElementById("sandboxWASDModeBtn");
const sandboxProgressionModeBtn = document.getElementById("sandboxProgressionModeBtn");
const sandboxLoadBtn = document.getElementById("sandboxLoadBtn");
const sandboxSaveBtn = document.getElementById("sandboxSaveBtn");
const sandboxPlayBtn = document.getElementById("sandboxPlayBtn");
const sandboxSaveCard = document.getElementById("sandboxSaveCard");
const sandboxLoadCard = document.getElementById("sandboxLoadCard");
const sandboxPresetName = document.getElementById("sandboxPresetName");
const confirmSandboxSaveBtn = document.getElementById("confirmSandboxSaveBtn");
const cancelSandboxSaveBtn = document.getElementById("cancelSandboxSaveBtn");
const sandboxLoadList = document.getElementById("sandboxLoadList");
const sandboxRemoteUserId = document.getElementById("sandboxRemoteUserId");
const sandboxRemoteFetchBtn = document.getElementById("sandboxRemoteFetchBtn");
const sandboxSavePublicCheck = document.getElementById("sandboxSavePublicCheck") as HTMLInputElement | null;
const closeSandboxLoadBtn = document.getElementById("closeSandboxLoadBtn");
const sandboxPresetInfoCard = document.getElementById("sandboxPresetInfoCard");
const sandboxPresetInfoBody = document.getElementById("sandboxPresetInfoBody");
const sandboxPresetInfoRank = document.getElementById("sandboxPresetInfoRank");
const closeSandboxPresetInfoBtn = document.getElementById("closeSandboxPresetInfoBtn");
const sandboxSpeedrunModeBtn = document.getElementById("sandboxSpeedrunModeBtn");
const sandboxSpeedrunCustomizeBtn = document.getElementById("sandboxSpeedrunCustomizeBtn");
const sandboxSpeedrunPreviewScreen = document.getElementById("sandboxSpeedrunPreviewScreen");
const sandboxSpeedrunPreviewDoneBtn = document.getElementById("sandboxSpeedrunPreviewDoneBtn");
const sandboxSpeedrunPreviewCancelBtn = document.getElementById("sandboxSpeedrunPreviewCancelBtn");
const sandboxPenaltyCustomizeBtn = document.getElementById("sandboxPenaltyCustomizeBtn");
const sandboxPenaltyPreviewScreen = document.getElementById("sandboxPenaltyPreviewScreen");
const sandboxPenaltyPreviewDoneBtn = document.getElementById("sandboxPenaltyPreviewDoneBtn");
const sandboxPenaltyPreviewCancelBtn = document.getElementById("sandboxPenaltyPreviewCancelBtn");
const sandboxSpeedrunWinScreen = document.getElementById("sandboxSpeedrunWinScreen");
const sandboxSpeedrunWinLine = document.getElementById("sandboxSpeedrunWinLine");
const sandboxSpeedrunWinContinueBtn = document.getElementById("sandboxSpeedrunWinContinueBtn");

fxFlash.style.opacity = "0";
superHud.style.display = "none";

let mouse = { x: innerWidth / 2, y: innerHeight / 2 };
/** Last pointer client coords; null means next event only seeds anchor (cursor stays put). */
let relativePointerLastClient = null;
/** After (re)starting play or resuming, ignore brief pointer-unlock so we don't auto-pause. */
let pointerLockPauseSuppressedUntil = 0;
/** Ignore the first relative movement after pointer lock — browsers often spike movementX/Y on acquire. */
let pointerLockMovementWarmup = false;
/** UI cursor mode: system mouse unlocked; in-game cursor frozen (toggle via keybind). */
let uiCursorMode = false;
/** Pointer id captured on canvas for touch slide steering (-1 = none). */
let canvasTouchSteerCaptureId = -1;
/** Mobile: only this pointer may move the gameplay cursor (blocks multi-touch teleport). */
let touchSteerPointerId = -1;
/** First touch contact after all fingers left the screen — only it may steer. */
let primaryTouchPointerId = -1;
const activeGameTouchPointers = new Set();
/** touch.identifier <-> pointerId when browsers disagree. */
const touchPointerAlias = new Map();
/** Mobile slide: total finger offset from touch-start (immune to per-frame anchor loss). */
let touchSteerSession = null;
/** Latest finger client position for the active steer session (polled in game loop). */
let touchSteerLiveClient = null;

/** Per-pointer slide sessions for solo modes — mirrors LOCAL wireZoneSteer (incremental deltas). */
const soloSlideSteerSessions = new Map();

const AIM_TOUCH_TAP_DRAG_THRESHOLD_PX = 14;

function mobileTouchInputActive() {
    // Phones / tablets / iPad only. Do NOT treat installed desktop PWAs as touch:
    // Windows often reports maxTouchPoints > 0 (touchpad/digitizer), and
    // display-mode:standalone|fullscreen would wrongly show Hook aim stick, D-Pad, etc.
    return isTouchTabletUi();
}

/** Phones/tablets/iPad — not touchscreen laptops (coarse + no hover). */
function isTouchTabletUi() {
    if (typeof matchMedia === "undefined") return false;
    if (document.documentElement.classList.contains("touch-ipad")) return true;
    if (matchMedia("(pointer: coarse)").matches && matchMedia("(hover: none)").matches) return true;
    if (matchMedia("(max-width: 820px)").matches && navigator.maxTouchPoints > 0 && matchMedia("(hover: none)").matches) {
        return true;
    }
    return false;
}

/** Finger pointer for slide-to-steer (touch/pen; mouse on touch tablets when iOS reports desktop UA). */
function isFingerSteerPointer(e) {
    if (e.pointerType === "touch" || e.pointerType === "pen") return true;
    if (!isTouchTabletUi() || typeof navigator === "undefined" || navigator.maxTouchPoints <= 0) return false;
    if (e.isPrimary === false) return false;
    return e.pointerType === "mouse";
}

function isSteerSurfaceTarget(target) {
    if (!(target instanceof Element)) return false;
    if (targetBlocksTouchAnalogJoystick(target)) return false;
    if (touchPlaySteerPad && (target === touchPlaySteerPad || touchPlaySteerPad.contains(target))) return true;
    if (canvas && (target === canvas || canvas.contains(target))) return true;
    if (canvasCursorTop && (target === canvasCursorTop || canvasCursorTop.contains(target))) return true;
    return false;
}

function aliasTouchPointerIds(a, b) {
    if (a == null || b == null || a < 0 || b < 0) return;
    touchPointerAlias.set(a, b);
    touchPointerAlias.set(b, a);
}

function sameTouchPointer(a, b) {
    if (a < 0 || b < 0) return false;
    if (a === b) return true;
    return touchPointerAlias.get(a) === b;
}

function clearTouchPointerAlias(pointerId) {
    const other = touchPointerAlias.get(pointerId);
    touchPointerAlias.delete(pointerId);
    if (other != null) touchPointerAlias.delete(other);
}

/** Per-finger tracking: tap vs drag and which finger steers the cursor. */
const touchFingers = new Map();
/** pointerId from pointerdown before matching touchstart (Safari/iPad). */
const orphanTouchPointerIds = [];

/**
 * Play conditions for slide-to-steer, INDEPENDENT of device detection.
 * A `touchstart`/`touchmove` event can only originate from a real finger, so
 * gating touch steering behind `mobileTouchInputActive()` (fragile UA / media
 * query / class detection) can wrongly disable it on some iPads/PWAs. This keeps
 * only the gameplay-state checks so the touch path always works when the user
 * is actually touching the screen.
 */
function touchSteerPlayConditionsMet() {
    return (
        playing &&
        !deathPending &&
        !gamePaused &&
        !resumeCountdownActive &&
        !shouldShowTouchDpadForCurrentMode()
    );
}

function touchGameplaySteerEnabled() {
    return touchSteerPlayConditionsMet() && !settingTouchCursorJoystick;
}

function soloSlideSteerOwnsPointer(pointerId) {
    return soloSlideSteerSessions.has(pointerId);
}

function soloSlideSteerMayClaimPointer(pointerId) {
    if (soloSlideSteerSessions.has(pointerId)) return true;
    if (soloSlideSteerSessions.size > 0) return false;
    return true;
}

function clearSoloSlideSteerSessions() {
    soloSlideSteerSessions.clear();
}

/** Apply incremental finger deltas in the game loop (same model as LOCAL steerSessions). */
function applySoloSlideSteerInLoop() {
    if (!isTouchTabletUi()) return;
    if (!touchSteerPlayConditionsMet() || isGameplayInputFrozen()) return;

    for (const sess of soloSlideSteerSessions.values()) {
        const rawDx = sess.liveClientX - sess.lastClientX;
        const rawDy = sess.liveClientY - sess.lastClientY;
        if (rawDx === 0 && rawDy === 0) continue;
        const { dx, dy } = clampGamePointerDelta(rawDx, rawDy);
        applyPointerDelta(dx, dy);
        sess.lastClientX = sess.liveClientX;
        sess.lastClientY = sess.liveClientY;
    }
}

function wireSoloSlideSteerSurface(zoneEl) {
    if (!(zoneEl instanceof HTMLElement)) return;
    if (zoneEl.dataset.soloSlideSteerBound === "1") return;
    zoneEl.dataset.soloSlideSteerBound = "1";

    zoneEl.addEventListener(
        "pointerdown",
        e => {
            if (!isTouchTabletUi() || !touchGameplaySteerEnabled()) return;
            if (!isFingerSteerPointer(e)) return;
            if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
            if (isGameplayInputFrozen()) return;
            if (targetBlocksTouchAnalogJoystick(e.target)) return;
            if (!soloSlideSteerMayClaimPointer(e.pointerId)) return;

            noteGameTouchDown(e.pointerId);
            soloSlideSteerSessions.set(e.pointerId, {
                pointerId: e.pointerId,
                lastClientX: e.clientX,
                lastClientY: e.clientY,
                liveClientX: e.clientX,
                liveClientY: e.clientY,
            });
            touchSteerPointerId = e.pointerId;

            try {
                zoneEl.setPointerCapture(e.pointerId);
            } catch {
                /* ignore */
            }
            if (e.cancelable) e.preventDefault();
            e.stopPropagation();
        },
        { passive: false, capture: true },
    );

    zoneEl.addEventListener(
        "pointermove",
        e => {
            if (!isTouchTabletUi() || !touchGameplaySteerEnabled()) return;
            const sess = soloSlideSteerSessions.get(e.pointerId);
            if (!sess) return;
            if (!playing || deathPending || isGameplayInputFrozen()) return;
            sess.liveClientX = e.clientX;
            sess.liveClientY = e.clientY;
            if (e.cancelable) e.preventDefault();
            e.stopPropagation();
        },
        { passive: false, capture: true },
    );

    const endSoloSlideSteer = e => {
        if (!soloSlideSteerSessions.has(e.pointerId)) return;
        soloSlideSteerSessions.delete(e.pointerId);
        noteGameTouchUp(e.pointerId);
        try {
            if (zoneEl.hasPointerCapture(e.pointerId)) zoneEl.releasePointerCapture(e.pointerId);
        } catch {
            /* ignore */
        }
    };
    zoneEl.addEventListener("pointerup", endSoloSlideSteer, { capture: true });
    zoneEl.addEventListener("pointercancel", endSoloSlideSteer, { capture: true });
}

/** iPad/Safari fires pointerdown before touchstart — arm steer on pointer so slide works immediately. */
function armPointerSteerDown(e) {
    if (!isFingerSteerPointer(e)) return;
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
    if (!touchGameplaySteerEnabled()) return;
    if (isTouchTabletUi()) return;
    if (targetBlocksTouchAnalogJoystick(e.target)) return;
    noteOrphanTouchPointerDown(e.pointerId);
    if (primaryTouchPointerId >= 0 && !sameTouchPointer(e.pointerId, primaryTouchPointerId)) return;
    if (primaryTouchPointerId < 0) {
        primaryTouchPointerId = e.pointerId;
        aliasTouchPointerIds(e.pointerId, e.pointerId);
    }
    claimTouchSteer(e.pointerId);
    if (!touchSteerSession) beginTouchSteerSession(e.clientX, e.clientY, primaryTouchPointerId);
    let finger = touchFingers.get(e.pointerId);
    if (!finger) {
        for (const [key, f] of touchFingers) {
            if (f.isSteer && key !== e.pointerId) {
                finger = f;
                touchFingers.delete(key);
                activeGameTouchPointers.delete(key);
                break;
            }
        }
    }
    touchFingers.set(e.pointerId, {
        startClientX: finger?.startClientX ?? e.clientX,
        startClientY: finger?.startClientY ?? e.clientY,
        moved: finger?.moved ?? false,
        isSteer: true,
    });
    activeGameTouchPointers.add(e.pointerId);
}

function migrateSteerFingerKeyToTouchId(touchId, clientX, clientY) {
    if (touchFingers.has(touchId)) return;
    for (const [key, finger] of touchFingers) {
        if (!finger.isSteer || key === touchId) continue;
        touchFingers.delete(key);
        activeGameTouchPointers.delete(key);
        touchFingers.set(touchId, {
            startClientX: finger.startClientX,
            startClientY: finger.startClientY,
            moved: finger.moved,
            isSteer: true,
        });
        activeGameTouchPointers.add(touchId);
        return;
    }
    touchFingers.set(touchId, {
        startClientX: clientX,
        startClientY: clientY,
        moved: false,
        isSteer: true,
    });
    activeGameTouchPointers.add(touchId);
}

function assignSteerTouchId(touchId) {
    if (touchId < 0) return;
    primaryTouchPointerId = touchId;
    touchSteerPointerId = -1;
    aliasTouchPointerIds(touchId, touchId);
}

function noteOrphanTouchPointerDown(pointerId) {
    if (pointerId < 0) return;
    aliasTouchPointerIds(pointerId, pointerId);
    orphanTouchPointerIds.push(pointerId);
}

function linkOrphanPointerToTouchId(touchId) {
    while (orphanTouchPointerIds.length > 0) {
        const pid = orphanTouchPointerIds.shift();
        if (pid != null && pid >= 0) {
            aliasTouchPointerIds(pid, touchId);
            break;
        }
    }
}

function updateTouchFingerMoved(finger, clientX, clientY, touchId) {
    if (finger.moved) return;
    if (
        Math.hypot(clientX - finger.startClientX, clientY - finger.startClientY) <
        AIM_TOUCH_TAP_DRAG_THRESHOLD_PX
    ) {
        return;
    }
    finger.moved = true;
    if (gameMode === "aim") {
        const s = getAimTouchStateForSteerId(touchId);
        if (s) s.dragged = true;
    } else if (gameMode === "hook") {
        const s = getHookTouchStateForSteerId(touchId);
        if (s) s.dragged = true;
    }
}

function registerModeTouchFingerOnStart(t, isSteerFinger) {
    const id = t.identifier;
    if (gameMode === "aim" && aimTouchPlayActive()) {
        aimTouchPointers.set(id, {
            startClientX: t.clientX,
            startClientY: t.clientY,
            dragged: false,
            tapOnly: !isSteerFinger,
        });
    } else if (gameMode === "hook" && hookTouchPlayActive()) {
        hookTouchPointers.set(id, {
            startClientX: t.clientX,
            startClientY: t.clientY,
            dragged: false,
            tapOnly: !isSteerFinger,
        });
    }
}

function fireGameplayTouchTap(touchId) {
    if (gameMode === "aim" && aimTouchPlayActive()) {
        handleAimFireAtCanvasXY(mouse.x, mouse.y);
    } else if (gameMode === "hook" && hookTouchPlayActive()) {
        handleHookLaunch();
    }
}

function ingestTouchStart(e) {
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (targetBlocksTouchAnalogJoystick(e.target)) return false;
    const changed = e.changedTouches;
    if (!changed || changed.length === 0) return false;

    for (let i = 0; i < changed.length; i++) {
        const t = changed[i];
        const id = t.identifier;
        const isSteerFinger = touchGameplaySteerEnabled() && e.touches.length === 1;

        if (isSteerFinger) {
            migrateSteerFingerKeyToTouchId(id, t.clientX, t.clientY);
            if (!isTouchTabletUi()) {
                assignSteerTouchId(id);
                claimTouchSteer(id);
                beginTouchSteerSession(t.clientX, t.clientY, id);
            }
        } else {
            touchFingers.set(id, {
                startClientX: t.clientX,
                startClientY: t.clientY,
                moved: false,
                isSteer: false,
            });
            activeGameTouchPointers.add(id);
        }

        linkOrphanPointerToTouchId(id);
        registerModeTouchFingerOnStart(t, isSteerFinger);
    }
    return true;
}

function touchFingerById(id) {
    let finger = touchFingers.get(id);
    if (finger) return finger;
    const alt = touchPointerAlias.get(id);
    if (alt != null) finger = touchFingers.get(alt);
    return finger;
}

function ingestTouchMove(e) {
    if (targetBlocksTouchAnalogJoystick(e.target)) return false;
    const changed = e.changedTouches;
    if (!changed || changed.length === 0) return false;

    let handledSteer = false;
    for (let i = 0; i < changed.length; i++) {
        const t = changed[i];
        const id = t.identifier;
        const finger = touchFingerById(id);
        if (!finger) continue;

        updateTouchFingerMoved(finger, t.clientX, t.clientY, id);

        if (!finger.isSteer || !touchGameplaySteerEnabled() || isGameplayInputFrozen()) continue;
        if (isTouchTabletUi()) continue;
        if (!sameTouchPointer(id, primaryTouchPointerId)) continue;

        if (!touchSteerSession) beginTouchSteerSession(t.clientX, t.clientY, primaryTouchPointerId);
        if (isSpeedrunPhysicsMode()) {
            queueTouchSteerLiveClient(t.clientX, t.clientY, primaryTouchPointerId);
            handledSteer = true;
        } else if (applyTouchSteerSessionAt(t.clientX, t.clientY, primaryTouchPointerId)) {
            handledSteer = true;
        }
    }
    return handledSteer;
}

function ingestTouchEnd(e) {
    const changed = e.changedTouches;
    if (!changed) return;

    for (let i = 0; i < changed.length; i++) {
        const t = changed[i];
        const id = t.identifier;
        const finger = touchFingers.get(id);

        if (finger && !finger.moved) fireGameplayTouchTap(id);

        if (finger?.isSteer || sameTouchPointer(id, primaryTouchPointerId)) {
            for (const pid of [...soloSlideSteerSessions.keys()]) {
                if (pid === id || sameTouchPointer(pid, id)) soloSlideSteerSessions.delete(pid);
            }
            endTouchSteerSession(id);
            releaseTouchSteer(id);
            if (finger?.isSteer || id === primaryTouchPointerId) primaryTouchPointerId = -1;
        }

        touchFingers.delete(id);
        activeGameTouchPointers.delete(id);
        aimTouchPointers.delete(id);
        hookTouchPointers.delete(id);
        clearTouchPointerAlias(id);

        if (canvasTouchSteerCaptureId === id || sameTouchPointer(canvasTouchSteerCaptureId, id)) {
            releaseCanvasTouchSteerCapture();
        }
    }

    if (activeGameTouchPointers.size === 0) resetGameTouchSteerState();
}

function beginTouchSteerSession(clientX, clientY, steerId) {
    const sid = primaryTouchPointerId >= 0 ? primaryTouchPointerId : steerId;
    const sr = isSpeedrunPhysicsMode();
    touchSteerSession = {
        steerId: sid,
        anchorClientX: clientX,
        anchorClientY: clientY,
        anchorMouseX: sr ? speedrunPrevMouse.x : mouse.x,
        anchorMouseY: sr ? speedrunPrevMouse.y : mouse.y,
        rouletteAnchorX: roulette.pointerTarget.x,
        rouletteAnchorY: roulette.pointerTarget.y,
        sandboxAnchorX: sandboxPointerTarget.x,
        sandboxAnchorY: sandboxPointerTarget.y,
    };
}

function endTouchSteerSession(steerId) {
    if (touchSteerSession && sameTouchPointer(touchSteerSession.steerId, steerId)) {
        touchSteerSession = null;
        touchSteerLiveClient = null;
    }
}

function queueTouchSteerLiveClient(clientX, clientY, steerId) {
    touchSteerLiveClient = { x: clientX, y: clientY, steerId };
}

function applyTouchSteerSessionAt(clientX, clientY, steerId) {
    if (!touchSteerSession || !sameTouchPointer(touchSteerSession.steerId, steerId)) return false;
    if (!playing || deathPending || isGameplayInputFrozen()) return false;
    queueTouchSteerLiveClient(clientX, clientY, steerId);
    const s = touchSteerSession;
    const { dx, dy } = clampGamePointerDelta(clientX - s.anchorClientX, clientY - s.anchorClientY);
    if (isSpeedrunPhysicsMode()) {
        const targetX = s.anchorMouseX + dx;
        const targetY = s.anchorMouseY + dy;
        speedrunPointerIntentDx = targetX - speedrunPrevMouse.x;
        speedrunPointerIntentDy = targetY - speedrunPrevMouse.y;
        return true;
    }
    mouse.x = s.anchorMouseX;
    mouse.y = s.anchorMouseY;
    roulette.pointerTarget.x = s.rouletteAnchorX;
    roulette.pointerTarget.y = s.rouletteAnchorY;
    sandboxPointerTarget.x = s.sandboxAnchorX;
    sandboxPointerTarget.y = s.sandboxAnchorY;
    applyPointerDelta(dx, dy);
    return true;
}

function pollTouchSteerInGameLoop() {
    applySoloSlideSteerInLoop();
    if (isTouchTabletUi()) return;
    if (!touchSteerSession || !touchSteerLiveClient) return;
    if (!touchSteerPlayConditionsMet() || isGameplayInputFrozen()) return;
    applyTouchSteerSessionAt(touchSteerLiveClient.x, touchSteerLiveClient.y, touchSteerLiveClient.steerId);
}

function noteGameTouchDown(pointerId) {
    if (pointerId < 0) return;
    if (primaryTouchPointerId >= 0 && !activeGameTouchPointers.has(primaryTouchPointerId)) {
        primaryTouchPointerId = -1;
        touchSteerPointerId = -1;
    }
    const wasEmpty = activeGameTouchPointers.size === 0;
    activeGameTouchPointers.add(pointerId);
    if (wasEmpty || primaryTouchPointerId < 0) {
        primaryTouchPointerId = pointerId;
        if (wasEmpty) touchSteerPointerId = -1;
    }
}

function noteGameTouchUp(pointerId) {
    if (pointerId < 0) return;
    activeGameTouchPointers.delete(pointerId);
    aimTouchPointers.delete(pointerId);
    hookTouchPointers.delete(pointerId);
    clearTouchPointerAlias(pointerId);
    endTouchSteerSession(pointerId);
    if (touchSteerPointerId === pointerId || sameTouchPointer(touchSteerPointerId, pointerId)) {
        touchSteerPointerId = -1;
        resetRelativePointerAnchor();
    }
    if (activeGameTouchPointers.size === 0) {
        primaryTouchPointerId = -1;
        touchSteerPointerId = -1;
        touchSteerSession = null;
        touchSteerLiveClient = null;
        touchPointerAlias.clear();
        clearSoloSlideSteerSessions();
        resetRelativePointerAnchor();
    }
}

function claimTouchSteer(pointerId) {
    if (primaryTouchPointerId >= 0 && !sameTouchPointer(pointerId, primaryTouchPointerId)) return false;
    touchSteerPointerId = pointerId;
    return true;
}

function releaseTouchSteer(pointerId) {
    if (touchSteerPointerId === pointerId || sameTouchPointer(touchSteerPointerId, pointerId)) {
        touchSteerPointerId = -1;
        resetRelativePointerAnchor();
    }
}

/** True when this pointer may steer the cursor (primary steer finger only). */
function touchPointerMayMoveCursor(pointerId) {
    if (pointerId < 0) return false;
    if (primaryTouchPointerId < 0) return touchGameplaySteerEnabled();
    return sameTouchPointer(pointerId, primaryTouchPointerId);
}

function ensureTouchSteerPrimary(pointerId, clientX, clientY) {
    if (pointerId < 0) return false;
    if (!touchPointerMayMoveCursor(pointerId)) return false;
    if (primaryTouchPointerId < 0) {
        primaryTouchPointerId = pointerId;
        aliasTouchPointerIds(pointerId, pointerId);
    }
    if (!touchSteerSession) beginTouchSteerSession(clientX, clientY, primaryTouchPointerId);
    return true;
}

function dispatchTouchSteerMove(e) {
    if (isTouchTabletUi() && touchGameplaySteerEnabled()) return;
    if (!ensureTouchSteerPrimary(e.pointerId, e.clientX, e.clientY)) return;
    if (e.cancelable) e.preventDefault();
    forEachCoalescedPointerMove(e, ev => {
        if (isSpeedrunPhysicsMode()) {
            queueTouchSteerLiveClient(ev.clientX, ev.clientY, primaryTouchPointerId);
        } else {
            applyTouchSteerSessionAt(ev.clientX, ev.clientY, primaryTouchPointerId);
        }
    });
}

function aimTouchPlayActive() {
    if (gameMode !== "aim") return false;
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isAimInputBlocked(getGameSimNowMs())) return false;
    return true;
}

function hookTouchPlayActive() {
    if (gameMode !== "hook") return false;
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isHookInputBlocked()) return false;
    return true;
}

function getAimTouchStateForSteerId(pid) {
    if (aimTouchPointers.has(pid)) return aimTouchPointers.get(pid);
    const alt = touchPointerAlias.get(pid);
    if (alt != null && aimTouchPointers.has(alt)) return aimTouchPointers.get(alt);
    return undefined;
}

function getHookTouchStateForSteerId(pid) {
    if (hookTouchPointers.has(pid)) return hookTouchPointers.get(pid);
    const alt = touchPointerAlias.get(pid);
    if (alt != null && hookTouchPointers.has(alt)) return hookTouchPointers.get(alt);
    return undefined;
}

function isSecondaryTouchPointer(pointerId) {
    if (primaryTouchPointerId < 0) return false;
    return !sameTouchPointer(pointerId, primaryTouchPointerId);
}

function beginCanvasTouchSteer(e) {
    if (!touchCanvasSlideSteerEnabled()) return false;
    if (mobileTouchInputActive()) return false;
    if (e.pointerType !== "touch" && e.pointerType !== "pen") return false;
    if (targetBlocksTouchAnalogJoystick(e.target)) return false;
    noteGameTouchDown(e.pointerId);
    if (isSecondaryTouchPointer(e.pointerId)) return false;
    if (canvasTouchSteerCaptureId >= 0) return false;
    if (!claimTouchSteer(e.pointerId)) return false;
    beginTouchSteerSession(e.clientX, e.clientY, e.pointerId);
    try {
        canvas.setPointerCapture(e.pointerId);
        canvasTouchSteerCaptureId = e.pointerId;
    } catch {
        /* ignore */
    }
    return true;
}
let keys = {};

function resetRelativePointerAnchor() {
    relativePointerLastClient = null;
}

function anchorPointerFromClient(clientX, clientY, pointerId = -1) {
    if (mobileTouchInputActive() && pointerId >= 0 && primaryTouchPointerId >= 0 && !sameTouchPointer(pointerId, primaryTouchPointerId)) return;
    relativePointerLastClient = { x: clientX, y: clientY };
}

function syncCursorSweepPrevFromMouse() {
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
}

function syncSpeedrunSweepPrevFromMouse() {
    speedrunPrevMouse.x = mouse.x;
    speedrunPrevMouse.y = mouse.y;
}

function syncSandboxPointerTargetFromMouse() {
    sandboxPointerTarget.x = mouse.x;
    sandboxPointerTarget.y = mouse.y;
}

function syncRoulettePointerTargetFromMouse() {
    roulette.pointerTarget.x = mouse.x;
    roulette.pointerTarget.y = mouse.y;
}

function isSpeedrunPhysicsMode() {
    return (
        gameMode === "speedrun" ||
        (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) ||
        (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode())
    );
}

function isOfficialSpeedrunPointerMode() {
    return gameMode === "speedrun" || (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode());
}

/** After an intentional reposition — avoids sweep collision across teleports. */
function syncCursorAfterExplicitReposition() {
    flushSpeedrunPointerIntent();
    syncCursorSweepPrevFromMouse();
    if (isSpeedrunPhysicsMode()) syncSpeedrunSweepPrevFromMouse();
    if (gameMode === "sandbox" || (gameMode === "multiplayer" && getMpGameMode() === "sandbox")) {
        syncSandboxPointerTargetFromMouse();
    }
    if (gameMode === "roulette") syncRoulettePointerTargetFromMouse();
    resetRelativePointerAnchor();
}

function flushSpeedrunPointerIntent() {
    speedrunPointerIntentDx = 0;
    speedrunPointerIntentDy = 0;
}

function accumulateSpeedrunPointerIntent(dx, dy) {
    speedrunPointerIntentDx += dx;
    speedrunPointerIntentDy += dy;
}

/** Reject one-frame pointer spikes from browser zoom, DPI, resize, or focus glitches. */
function clampGamePointerDelta(dx, dy) {
    const scaled = scalePointerDeltaForGameplay(dx, dy, canvas);
    dx = scaled.dx;
    dy = scaled.dy;
    if (dx === 0 && dy === 0) return { dx: 0, dy: 0 };
    const vw = canvas?.width > 0 ? canvas.width : innerWidth;
    const vh = canvas?.height > 0 ? canvas.height : innerHeight;
    const cap = Math.max(84, Math.min(vw, vh) * 0.42);
    const m = Math.hypot(dx, dy);
    if (m > cap) {
        const s = cap / m;
        return { dx: dx * s, dy: dy * s };
    }
    return { dx, dy };
}

function pointerLockAcquireSpikeCapPx() {
    const vw = canvas?.width > 0 ? canvas.width : innerWidth;
    const vh = canvas?.height > 0 ? canvas.height : innerHeight;
    return Math.max(96, Math.min(vw, vh) * 0.45);
}

function forEachCoalescedPointerMove(e, fn) {
    if (typeof e.getCoalescedEvents === "function") {
        const batch = e.getCoalescedEvents();
        if (batch.length > 0) {
            for (const ev of batch) fn(ev);
            return;
        }
    }
    fn(e);
}

function normCanvasPoint(x, y, w, h) {
    if (w <= 0 || h <= 0) return { nx: 0.5, ny: 0.5 };
    return { nx: clamp(x / w, 0, 1), ny: clamp(y / h, 0, 1) };
}

function applyNormToEdgeInsetMouse(nx, ny) {
    const m = clampCursorXYToEdgeInset(clamp(nx, 0, 1) * canvas.width, clamp(ny, 0, 1) * canvas.height);
    mouse.x = m.x;
    mouse.y = m.y;
}

function isTouchGameUi() {
    return isTouchTabletUi();
}

/** LOCAL is mobile/tablet only — same touch detection as the Modes screen. */
function isLocalModeDevice() {
    return isModesTouchUi();
}

let settingsCardWidthSyncScheduled = false;
let keybindListenAction = null;

const KEYBIND_ASSIGN_BTN_IDS = {
    return: "keybindReturnAssignBtn",
    pause: "keybindPauseAssignBtn",
    menu: "keybindMenuAssignBtn",
    playAgain: "keybindPlayAgainAssignBtn",
    nextLevel: "keybindNextLevelAssignBtn",
    quickRestart: "keybindQuickRestartAssignBtn",
    uiCursor: "keybindUiCursorAssignBtn",
};

const KEYBIND_DEFAULT_EL_IDS = {
    return: "keybindReturnDefault",
    pause: "keybindPauseDefault",
    menu: "keybindMenuDefault",
    playAgain: "keybindPlayAgainDefault",
    nextLevel: "keybindNextLevelDefault",
    quickRestart: "keybindQuickRestartDefault",
    uiCursor: "keybindUiCursorDefault",
};

const QUICK_RESTART_TAP_WINDOW_MS = 650;
const QUICK_RESTART_TAP_COUNT = 3;
let quickRestartTapCount = 0;
let quickRestartLastTapMs = 0;

function refreshKeybindSettingsUi() {
    const touchUi = isTouchGameUi();
    const accordion = document.getElementById("keybindsSettingsAccordion");
    if (accordion) accordion.classList.toggle("hidden", touchUi);
    const keybindsNavBtn = document.getElementById("settingsKeybindsNavBtn");
    if (keybindsNavBtn) keybindsNavBtn.classList.toggle("hidden", touchUi);

    for (const action of KEYBIND_ACTIONS) {
        const assignBtn = document.getElementById(KEYBIND_ASSIGN_BTN_IDS[action]);
        const defaultEl = document.getElementById(KEYBIND_DEFAULT_EL_IDS[action]);
        if (defaultEl) defaultEl.textContent = formatKeybindDisplay(KEYBIND_DEFAULTS[action]);
        if (!assignBtn) continue;
        const listening = keybindListenAction === action;
        assignBtn.textContent = listening ? "…" : formatKeybindDisplay(getKeybindKey(action));
        assignBtn.classList.toggle("keybindAssignBtn--listening", listening);
        assignBtn.setAttribute("aria-pressed", listening ? "true" : "false");
    }
}

function cancelKeybindListen() {
    keybindListenAction = null;
    refreshKeybindSettingsUi();
}

function startKeybindListen(action) {
    keybindListenAction = action;
    refreshKeybindSettingsUi();
}

function applyCapturedKeybind(action, key) {
    const conflict = findKeybindConflict(action, key);
    if (conflict) {
        const assignBtn = document.getElementById(KEYBIND_ASSIGN_BTN_IDS[action]);
        if (assignBtn) {
            assignBtn.textContent = "In use";
            window.setTimeout(() => refreshKeybindSettingsUi(), 720);
        }
        return;
    }
    pushSettingsUndoCurrent();
    setKeybindKey(action, key);
    keybindListenAction = null;
    refreshKeybindSettingsUi();
    refreshMenuKbdLabels();
    scheduleSettingsCardWidthSync();
}

function handleKeybindCaptureKeydown(e) {
    if (!keybindListenAction) return false;
    e.preventDefault();
    e.stopPropagation();
    if (e.key === "Escape") {
        cancelKeybindListen();
        return true;
    }
    const key = keyboardEventToStoredKey(e);
    if (!key) return true;
    applyCapturedKeybind(keybindListenAction, key);
    return true;
}

function initKeybindSettingsUi() {
    const root = document.getElementById("keybindsSettingsAccordion");
    if (!root || root.dataset.keybindUiInit === "1") return;
    root.dataset.keybindUiInit = "1";

    root.querySelectorAll(".keybindAssignBtn").forEach((btn) => {
        btn.addEventListener("click", () => {
            const action = btn.getAttribute("data-keybind-action");
            if (!action) return;
            if (keybindListenAction === action) cancelKeybindListen();
            else startKeybindListen(action);
        });
    });

    root.querySelectorAll(".keybindResetBtn").forEach((btn) => {
        btn.addEventListener("click", () => {
            const action = btn.getAttribute("data-keybind-action");
            if (!action) return;
            if (keybindListenAction === action) keybindListenAction = null;
            pushSettingsUndoCurrent();
            resetKeybindKey(action);
            refreshKeybindSettingsUi();
            refreshMenuKbdLabels();
            scheduleSettingsCardWidthSync();
        });
    });

    refreshKeybindSettingsUi();
}

function settingsCardIsMeasurable(card) {
    if (!(card instanceof HTMLElement)) return false;
    if (card.classList.contains("hidden")) return false;
    const rect = card.getBoundingClientRect();
    return rect.width > 8 && rect.height > 8;
}

function settingsCardContentOverflows(card) {
    if (!settingsCardIsMeasurable(card)) return false;
    const parts = card.querySelectorAll("p, h3, .btn, .rgbRow, .rgbHead");
    for (const node of parts) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.classList.contains("hidden")) continue;
        if (node.scrollWidth > node.clientWidth + 2) return true;
        if (node.scrollHeight > node.clientHeight + 2) return true;
    }
    return card.scrollWidth > card.clientWidth + 2 || card.scrollHeight > card.clientHeight + 2;
}

function refreshSettingsCardWidths() {
    if (!settingsScreen || settingsScreen.classList.contains("hidden")) return;
    const cards = settingsScreen.querySelectorAll(".settingsCard");
    if (!cards.length) return;

    cards.forEach((card) => {
        card.classList.remove("settingsCard--wide", "settingsCard--full");
    });

    for (const card of cards) {
        if (!settingsCardIsMeasurable(card)) continue;
        if (settingsCardContentOverflows(card)) card.classList.add("settingsCard--wide");
    }
    for (const card of cards) {
        if (!settingsCardIsMeasurable(card)) continue;
        if (card.classList.contains("settingsCard--wide") && settingsCardContentOverflows(card)) {
            card.classList.remove("settingsCard--wide");
            card.classList.add("settingsCard--full");
        }
    }
}

function scheduleSettingsCardWidthSync() {
    if (settingsCardWidthSyncScheduled) return;
    settingsCardWidthSyncScheduled = true;
    requestAnimationFrame(() => {
        settingsCardWidthSyncScheduled = false;
        refreshSettingsCardWidths();
        requestAnimationFrame(() => refreshSettingsCardWidths());
    });
}

function canUseMobileDpadCustomize() {
    return isTouchGameUi() || settingShowMobileSettingsInUi;
}

function shouldShowMobileSettingsSection() {
    return isTouchGameUi() || settingShowMobileSettingsInUi;
}

function refreshSettingsMobilePreviewNav() {
    if (settingsMobilePreviewNav) {
        settingsMobilePreviewNav.classList.toggle("hidden", isTouchGameUi());
    }
}

function refreshDpadSettingsVisibility() {
    const keybindRow = document.getElementById("keybindIndicatorSettings");
    if (keybindRow) keybindRow.classList.toggle("hidden", isTouchGameUi());
    if (quickRestartSettings) quickRestartSettings.classList.toggle("hidden", isTouchGameUi());
    if (dpadPositionSettings) {
        dpadPositionSettings.classList.toggle("hidden", !shouldShowMobileSettingsSection());
    }
    refreshSettingsMobilePreviewNav();
    refreshDpadSettingsUI();
    refreshKeybindSettingsUi();
    scheduleSettingsCardWidthSync();
}

function migrateLegacyEffectSettings() {
    const legacy = localStorage.getItem("settingEffects");
    if (legacy === null) return;
    for (const k of [
        "settingEffectFlashes",
        "settingEffectShake",
        "settingEffectParticles",
        "settingTrailEnabled",
    ]) {
        if (localStorage.getItem(k) === null) localStorage.setItem(k, legacy);
    }
}

function readDomColorHex(rEl, gEl, bEl, fallbackHex) {
    if (!rEl || !gEl || !bEl) return fallbackHex;
    return rgbToHex(rEl.value, gEl.value, bEl.value);
}

function readDomRangeInt(el, fallback, min, max) {
    if (!el) return fallback;
    const n = Number(el.value);
    if (!Number.isFinite(n)) return fallback;
    return clamp(Math.round(n), min, max);
}

/** Pull live Settings UI values into globals before Copy (sliders/colours may differ from storage). */
function syncSettingsDomToGlobalsBeforeShare() {
    settingBallsColor = readDomColorHex(ballsR, ballsG, ballsB, settingBallsColor);
    settingCursorColor = readDomColorHex(cursorR, cursorG, cursorB, settingCursorColor);
    settingButtonsColor = readDomColorHex(buttonsR, buttonsG, buttonsB, settingButtonsColor);
    settingTextColor = readDomColorHex(textR, textG, textB, settingTextColor);
    settingTrailColor = readDomColorHex(trailR, trailG, trailB, settingTrailColor);
    settingMenuBackgroundColor = readDomColorHex(
        menuBackgroundR,
        menuBackgroundG,
        menuBackgroundB,
        settingMenuBackgroundColor,
    );
    settingGameBackgroundColor = readDomColorHex(
        gameBackgroundR,
        gameBackgroundG,
        gameBackgroundB,
        settingGameBackgroundColor,
    );
    settingWASDSensitivity = readDomRangeInt(wasdSensitivity, settingWASDSensitivity, 1, 20);
    settingMenuBackgroundBright = readDomRangeInt(
        menuBackgroundBright,
        settingMenuBackgroundBright,
        0,
        BACKGROUND_BRIGHT_MAX,
    );
    settingGameBackgroundBright = readDomRangeInt(
        gameBackgroundBright,
        settingGameBackgroundBright,
        0,
        BACKGROUND_BRIGHT_MAX,
    );
    settingMusicVolume = readDomRangeInt(menuMusicVolume, settingMusicVolume, 0, 10);
    settingGameMusicVolume = readDomRangeInt(gameMusicVolume, settingGameMusicVolume, 0, 10);
    if (menuSongPickBtn) {
        const n = Number(menuSongPickBtn.textContent);
        if (Number.isFinite(n)) settingMenuSong = clamp(Math.round(n), 1, MUSIC_TRACK_COUNT);
    }
    if (gameSongPickBtn) {
        const n = Number(gameSongPickBtn.textContent);
        if (Number.isFinite(n)) settingGameSong = clamp(Math.round(n), 1, MUSIC_TRACK_COUNT);
    }
    settingBounceVolume = readDomRangeInt(bounceVolume, settingBounceVolume, 0, 10);
    settingPickupVolume = readDomRangeInt(pickupVolume, settingPickupVolume, 0, 10);
    settingGameSfxVolume = readDomRangeInt(gameSfxVolume, settingGameSfxVolume, 0, 10);
    settingDarknessVolume = readDomRangeInt(darknessVolume, settingDarknessVolume, 0, 10);
    settingUiVolume = readDomRangeInt(uiVolume, settingUiVolume, 0, 10);
    const touchJoySensEl = document.getElementById("touchJoystickSensitivity");
    settingTouchJoystickSensitivity = readDomRangeInt(
        touchJoySensEl,
        settingTouchJoystickSensitivity,
        1,
        20,
    );
    if (freezeGameSecondsInput) {
        const v = Number(freezeGameSecondsInput.value);
        if (Number.isFinite(v)) {
            settingFreezeOnLoseSeconds = Math.max(
                FREEZE_ON_LOSE_SEC_MIN,
                Math.min(FREEZE_ON_LOSE_SEC_MAX, Math.round(v * 10) / 10),
            );
        }
    }
    if (holdReturnHomeSecondsInput) {
        const v = Number(holdReturnHomeSecondsInput.value);
        if (Number.isFinite(v)) {
            settingHoldReturnHomeSeconds = Math.max(
                HOLD_RETURN_HOME_SEC_MIN,
                Math.min(HOLD_RETURN_HOME_SEC_MAX, Math.round(v * 10) / 10),
            );
        }
    }
    if (fpsLimit) {
        settingFpsLimit = sliderIndexToFpsLimit(Number(fpsLimit.value));
        setGameplayFpsLimit(settingFpsLimit);
    }
}

function persistAllSettingsForShare() {
    localStorage.setItem("settingBallsColor", settingBallsColor);
    localStorage.setItem("settingCursorColor", settingCursorColor);
    localStorage.setItem("settingButtonsColor", settingButtonsColor);
    setBoolSetting("settingButtonsAutoText", settingButtonsAutoText);
    localStorage.setItem("settingTextColor", settingTextColor);
    localStorage.setItem("settingTrailColor", settingTrailColor);
    localStorage.setItem("settingMenuBackgroundColor", settingMenuBackgroundColor);
    localStorage.setItem("settingGameBackgroundColor", settingGameBackgroundColor);
    localStorage.setItem("settingMenuBackgroundBright", String(settingMenuBackgroundBright));
    localStorage.setItem("settingGameBackgroundBright", String(settingGameBackgroundBright));
    localStorage.setItem("settingWASDSensitivity", String(settingWASDSensitivity));
    localStorage.setItem("settingMusicVolume", String(settingMusicVolume));
    localStorage.setItem("settingGameMusicVolume", String(settingGameMusicVolume));
    localStorage.setItem("settingMenuSong", String(settingMenuSong));
    localStorage.setItem("settingGameSong", String(settingGameSong));
    localStorage.setItem("settingBounceVolume", String(settingBounceVolume));
    localStorage.setItem("settingPickupVolume", String(settingPickupVolume));
    localStorage.setItem("settingGameSfxVolume", String(settingGameSfxVolume));
    localStorage.setItem("settingDarknessVolume", String(settingDarknessVolume));
    localStorage.setItem("settingUiVolume", String(settingUiVolume));
    setBoolSetting("settingEffectFlashes", settingEffectFlashes);
    setBoolSetting("settingEffectShake", settingEffectShake);
    setBoolSetting("settingEffectParticles", settingEffectParticles);
    setBoolSetting("settingFreezeOnLose", settingFreezeOnLose);
    localStorage.setItem("settingFreezeOnLoseSeconds", String(settingFreezeOnLoseSeconds));
    setBoolSetting("settingAutoRetry", settingAutoRetry);
    setBoolSetting("settingModesSelectPanel", settingModesSelectPanel);
    setBoolSetting("settingPlayTransition", settingPlayTransition);
    setBoolSetting("settingQuickRestart", settingQuickRestart);
    setBoolSetting("settingTrailEnabled", settingTrailEnabled);
    setBoolSetting("settingCosmeticsMatchCursor", settingCosmeticsMatchCursor);
    setBoolSetting("settingNeonBalls", settingNeonBalls);
    setBoolSetting("settingHomeAmbientBalls", settingHomeAmbientBalls);
    setBoolSetting("settingNewsInHome", settingNewsInHome);
    setBoolSetting("settingNotificationsInHome", settingNotificationsInHome);
    setBoolSetting("settingHomeSplash", settingHomeSplash);
    setBoolSetting("settingShowFps", settingShowFps);
    localStorage.setItem("settingShowFpsWhere", settingShowFpsWhere);
    localStorage.setItem("settingFpsLimit", String(settingFpsLimit));
    setBoolSetting("settingLowPowerCap60", settingLowPowerCap60);
    setBoolSetting("settingInvertReturnPause", settingInvertReturnPause);
    setBoolSetting("settingInvertSidebar", settingInvertSidebar);
    setBoolSetting("settingHoldReturnHome", settingHoldReturnHome);
    localStorage.setItem("settingHoldReturnHomeSeconds", String(settingHoldReturnHomeSeconds));
    setBoolSetting("settingSounds", settingSounds);
    setBoolSetting("settingTouchCursorJoystick", settingTouchCursorJoystick);
    setBoolSetting("settingTouchCursorJoystickVisible", settingTouchCursorJoystickVisible);
    localStorage.setItem("settingTouchJoystickSensitivity", String(settingTouchJoystickSensitivity));
    setBoolSetting("settingShowKeybindIndicator", settingShowKeybindIndicator);
    setBoolSetting("settingShowMobileSettingsInUi", settingShowMobileSettingsInUi);
    for (const action of KEYBIND_ACTIONS) {
        const key = getKeybindKey(action);
        const storageKey = KEYBIND_STORAGE_KEYS[action];
        if (key) localStorage.setItem(storageKey, key);
        else localStorage.removeItem(storageKey);
    }
    persistDpadSettingsForShare();
}

function settingsShareFallback(key) {
    switch (key) {
        case "settingBallsColor":
            return "#66ffff";
        case "settingCursorColor":
            return "#ffffff";
        case "settingButtonsColor":
            return "#66ffff";
        case "settingButtonsAutoText":
            return "1";
        case "settingTextColor":
            return "#66ffff";
        case "settingTrailColor":
            return "#66ffff";
        case "settingMenuBackgroundColor":
        case "settingGameBackgroundColor":
            return "#000000";
        case "settingMenuBackgroundBright":
        case "settingGameBackgroundBright":
            return "0";
        case "settingWASDSensitivity":
        case "settingTouchJoystickSensitivity":
            return "4";
        case "settingGamepadSensitivity":
            return String(GP_SENSITIVITY_DEFAULT);
        case "settingGamepadDeadzone":
            return String(GP_DEADZONE_DEFAULT);
        case "settingGamepadClickSource":
            return "both";
        case "settingGamepadPauseBtn":
            return String(GP_BTN.START);
        case "settingGamepadReturnBtn":
            return String(GP_BTN.SELECT);
        case "settingGamepadMenuReturnBtn":
            return String(GP_BTN.B);
        case "settingGamepadMenuBtn":
            return String(GP_BTN.LB);
        case "settingGamepadRestartBtn":
            return String(GP_BTN.RB);
        case "settingMusicVolume":
        case "settingGameMusicVolume":
            return "6";
        case "settingMenuSong":
        case "settingGameSong":
            return "1";
        case "settingBounceVolume":
        case "settingPickupVolume":
        case "settingGameSfxVolume":
        case "settingDarknessVolume":
            return String(SFX_VOLUME_DEFAULT);
        case "settingUiVolume":
            return String(UI_VOLUME_DEFAULT);
        case "settingEffectFlashes":
        case "settingEffectShake":
        case "settingEffectParticles":
        case "settingFreezeOnLose":
        case "settingQuickRestart":
        case "settingTrailEnabled":
        case "settingNeonBalls":
        case "settingHomeAmbientBalls":
        case "settingNotificationsInHome":
        case "settingHomeSplash":
        case "settingHomeShowStreak":
        case "settingSounds":
        case "settingTouchCursorJoystickVisible":
        case "settingShowKeybindIndicator":
        case "settingModesSelectPanel":
        case "settingPlayTransition":
            return "1";
        case "settingCosmeticsMatchCursor":
            return "1";
        case "settingShowMobileSettingsInUi":
            return "0";
        case "settingFreezeOnLoseSeconds":
            return String(FREEZE_ON_LOSE_SEC_DEFAULT);
        case "settingAutoRetry":
        case "settingTouchCursorJoystick":
        case "settingShowFps":
        case "settingNewsInHome":
        case "settingHomeShowFriends":
        case "settingHomeShowLastMode":
        case "settingHomeCursorBounce":
        case "settingHomeShowTrending":
        case "settingHomeShowDots":
        case "settingHomeShowChallenge":
        case "settingHomeShowLootDrops":
        case "settingHomeShowNewInShop":
        case "settingHomeShowSuggested":
        case "settingHomeShowContinue":
        case "settingInvertReturnPause":
        case "settingInvertSidebar":
            return "0";
        case "settingHomeFriendsFilter":
            return "online";
        case "settingHomeLayoutV1":
            return "";
        case "settingHoldReturnHome":
            return "1";
        case "settingHoldReturnHomeSeconds":
            return String(HOLD_RETURN_HOME_SEC_DEFAULT);
        case "settingShowFpsWhere":
            return "game";
        case "settingFpsLimit":
            return "0";
        case "settingLowPowerCap60":
            return "0";
        case "keybindReturn":
            return KEYBIND_DEFAULTS.return;
        case "keybindPause":
            return KEYBIND_DEFAULTS.pause;
        case "keybindMenu":
            return KEYBIND_DEFAULTS.menu;
        case "keybindPlayAgain":
            return KEYBIND_DEFAULTS.playAgain;
        case "keybindNextLevel":
            return KEYBIND_DEFAULTS.nextLevel;
        case "keybindQuickRestart":
            return KEYBIND_DEFAULTS.quickRestart;
        case DPAD_LAYOUT_KEY:
            return "1";
        case DPAD_SCALE_KEY:
            return "1";
        case DPAD_OPACITY_KEY:
            return "100";
        case DPAD_EIGHT_DIR_KEY:
            return "true";
        case DPAD_GRID_KEY:
            return "false";
        case DPAD_OFFSETS_KEY:
            return "{}";
        case DPAD_LAYOUT3_POS_KEY:
            return "{}";
        case DPAD_INSET_R_KEY:
        case DPAD_INSET_B_KEY:
        case DPAD_INSET_L_KEY:
            return "0";
        default:
            return "";
    }
}

function exportSettingsShareJson() {
    syncSettingsDomToGlobalsBeforeShare();
    persistAllSettingsForShare();
    return serializeSettingsShareJson(exportFullSettingsShareSnapshot(settingsShareFallback));
}

let settingsUndoStack = [];
let settingsRedoStack = [];
let settingsHistoryPaused = false;
let settingsUndoDebounceArmed = false;
let settingsUndoDebounceTimer = 0;

function settingsScreenVisible() {
    return !!(settingsScreen && !settingsScreen.classList.contains("hidden"));
}

function updateSettingsUndoRedoUi() {
    if (settingsUndoBtn) settingsUndoBtn.disabled = settingsUndoStack.length === 0;
    if (settingsRedoBtn) settingsRedoBtn.disabled = settingsRedoStack.length === 0;
}

function resetSettingsHistoryStacks() {
    settingsUndoStack = [];
    settingsRedoStack = [];
    updateSettingsUndoRedoUi();
}

function reloadSettingsFromStorageAndApply() {
    migrateLegacyEffectSettings();
    reloadSettingsGlobalsFromStorage();
    applyDpadLayoutFromStorage();
    applySettings();
    refreshDpadSettingsVisibility();
    refreshMenuKbdLabels();
}

function applySettingsHistorySnapshotPaused(raw) {
    settingsHistoryPaused = true;
    try {
        applySettingsHistorySnapshot(raw);
        reloadSettingsFromStorageAndApply();
    } finally {
        settingsHistoryPaused = false;
    }
}

function pushSettingsUndoCurrent() {
    if (settingsHistoryPaused || !settingsScreenVisible()) return;
    const snap = exportSettingsHistorySnapshot();
    const top = settingsUndoStack[settingsUndoStack.length - 1];
    if (top && snapshotsEqual(top, snap)) return;
    settingsUndoStack.push(snap);
    if (settingsUndoStack.length > 50) settingsUndoStack.shift();
    settingsRedoStack = [];
    updateSettingsUndoRedoUi();
}

function pushSettingsUndoDebounced() {
    if (settingsHistoryPaused || !settingsScreenVisible()) return;
    if (!settingsUndoDebounceArmed) {
        settingsUndoDebounceArmed = true;
        pushSettingsUndoCurrent();
    }
    if (settingsUndoDebounceTimer) window.clearTimeout(settingsUndoDebounceTimer);
    settingsUndoDebounceTimer = window.setTimeout(() => {
        settingsUndoDebounceArmed = false;
        settingsUndoDebounceTimer = 0;
    }, 450);
}

function settingsUndoAction() {
    if (settingsUndoStack.length === 0) return;
    const current = exportSettingsHistorySnapshot();
    settingsRedoStack.push(current);
    const prev = settingsUndoStack.pop();
    applySettingsHistorySnapshotPaused(prev);
    updateSettingsUndoRedoUi();
}

function settingsRedoAction() {
    if (settingsRedoStack.length === 0) return;
    const current = exportSettingsHistorySnapshot();
    settingsUndoStack.push(current);
    const next = settingsRedoStack.pop();
    applySettingsHistorySnapshotPaused(next);
    updateSettingsUndoRedoUi();
}

function resetAllSettingsToDefaults() {
    pushSettingsUndoCurrent();
    clearAllSettingsStorageKeys();
    reloadSettingsFromStorageAndApply();
    settingsRedoStack = [];
    updateSettingsUndoRedoUi();
}

function openSettingsResetConfirm() {
    if (!settingsResetConfirmScreen) return;
    showEl(settingsResetConfirmScreen);
    syncReturnBtnVisibility();
}

function closeSettingsResetConfirm() {
    if (!settingsResetConfirmScreen) return;
    hideEl(settingsResetConfirmScreen);
    syncReturnBtnVisibility();
}

function shouldShowTopReturnBtn() {
    if (soccerBlocksReturn()) return false;
    if (dpadPositionCustomizeMode) return false;
    if (isReplayPlaybackActive()) return true;
    if (settingsResetConfirmScreen && !settingsResetConfirmScreen.classList.contains("hidden")) return true;
    if (playing && gameMode) return true;
    if (gameOverScreen && !gameOverScreen.classList.contains("hidden")) return true;
    if (modeScreen && !modeScreen.classList.contains("hidden")) return true;
    if (gameHubScreen && !gameHubScreen.classList.contains("hidden")) return true;
    if (practiceScreen && !practiceScreen.classList.contains("hidden")) return true;
    if (challengesScreen && !challengesScreen.classList.contains("hidden")) return true;
    if (tournamentsScreen && !tournamentsScreen.classList.contains("hidden")) return true;
    if (marathonScreen && !marathonScreen.classList.contains("hidden")) return true;
    if (campaignScreen && !campaignScreen.classList.contains("hidden")) return true;
    const worldMapScreenEl = document.getElementById("worldMapScreen");
    if (worldMapScreenEl && !worldMapScreenEl.classList.contains("hidden")) return true;
    const soccerScreenEl = document.getElementById("soccerScreen");
    if (isSoccerScreenVisible()) return true;
    if (statsScreen && !statsScreen.classList.contains("hidden")) return true;
    if (settingsScreen && !settingsScreen.classList.contains("hidden")) return true;
    if (achievementsScreen && !achievementsScreen.classList.contains("hidden")) return true;
    if (tasksScreen && !tasksScreen.classList.contains("hidden")) return true;
    if (battlePassScreen && !battlePassScreen.classList.contains("hidden")) return true;
    if (shopScreen && !shopScreen.classList.contains("hidden")) return true;
    if (inventoryScreen && !inventoryScreen.classList.contains("hidden")) return true;
    if (profileScreen && !profileScreen.classList.contains("hidden")) return true;
    if (newsScreen && !newsScreen.classList.contains("hidden")) return true;
    if (notificationsScreen && !notificationsScreen.classList.contains("hidden")) return true;
    if (wallScreen && !wallScreen.classList.contains("hidden")) return true;
    if (leaderboardScreen && !leaderboardScreen.classList.contains("hidden")) return true;
    if (creditsScreen && !creditsScreen.classList.contains("hidden")) return true;
    if (speedrunLevelScreen && !speedrunLevelScreen.classList.contains("hidden")) return true;
    if (penaltyLevelScreen && !penaltyLevelScreen.classList.contains("hidden")) return true;
    if (sandboxScreen && !sandboxScreen.classList.contains("hidden")) return true;
    if (sandboxBaseScreen && !sandboxBaseScreen.classList.contains("hidden")) return true;
    if (sandboxCommunityScreen && !sandboxCommunityScreen.classList.contains("hidden")) return true;
    const sandboxPrev = document.getElementById("sandboxSpeedrunPreviewScreen");
    if (sandboxPrev && !sandboxPrev.classList.contains("hidden")) return true;
    const sandboxPenaltyPrev = document.getElementById("sandboxPenaltyPreviewScreen");
    if (sandboxPenaltyPrev && !sandboxPenaltyPrev.classList.contains("hidden")) return true;
    const mpResults = document.getElementById("mpSpeedrunResultsScreen");
    if (mpResults && !mpResults.classList.contains("hidden")) return true;
    const mpGameOver = document.getElementById("mpGameOverScreen");
    if (mpGameOver && !mpGameOver.classList.contains("hidden")) return true;
    const mpLobby = document.getElementById("mpLobbyScreen");
    if (mpLobby && !mpLobby.classList.contains("hidden")) return true;
    const mpEntry = document.getElementById("mpEntryScreen");
    if (mpEntry && !mpEntry.classList.contains("hidden")) return true;
    const mpJoin = document.getElementById("mpJoinScreen");
    if (mpJoin && !mpJoin.classList.contains("hidden")) return true;
    const mpCreate = document.getElementById("mpCreateScreen");
    if (mpCreate && !mpCreate.classList.contains("hidden")) return true;
    const mpGameMode = document.getElementById("mpGameModeScreen");
    if (mpGameMode && !mpGameMode.classList.contains("hidden")) return true;
    if (localResultScreen && !localResultScreen.classList.contains("hidden")) return true;
    if (isLocalScreenVisible()) return true;
    if (isLdScreenVisible()) return true;
    return false;
}

function syncReturnBtnVisibility() {
    if (!returnBtn) return;
    const show = shouldShowTopReturnBtn();
    returnBtn.classList.toggle("hidden", !show);
    if (show) {
        returnBtn.style.opacity = "";
        returnBtn.style.pointerEvents = "auto";
    }
    syncPlayHudLayout();
    scheduleFpsOverlayPosition();
}

/** Hold Return keybind / button → Home after configured duration. */
let returnHoldActive = false;
let returnHoldFiredHome = false;
let returnHoldFromPointer = false;
let returnHoldPointerId = null;
let returnHoldTimerId = null;

function clearReturnHoldTimer() {
    if (returnHoldTimerId != null) {
        clearTimeout(returnHoldTimerId);
        returnHoldTimerId = null;
    }
}

function cancelReturnHold() {
    clearReturnHoldTimer();
    returnHoldActive = false;
    returnHoldFiredHome = false;
    returnHoldFromPointer = false;
    returnHoldPointerId = null;
}

function fireReturnHoldHome() {
    returnHoldFiredHome = true;
    returnHoldActive = false;
    clearReturnHoldTimer();
    returnHoldFromPointer = false;
    returnHoldPointerId = null;
    goToMenu("home");
}

/** @returns {boolean} true if hold was started (caller should wait for release). */
function beginReturnHold(fromPointer, pointerId = null) {
    if (!settingHoldReturnHome) return false;
    if (returnHoldActive) return true;
    returnHoldActive = true;
    returnHoldFiredHome = false;
    returnHoldFromPointer = !!fromPointer;
    returnHoldPointerId = fromPointer ? pointerId : null;
    clearReturnHoldTimer();
    const ms = Math.max(HOLD_RETURN_HOME_SEC_MIN, settingHoldReturnHomeSeconds) * 1000;
    returnHoldTimerId = window.setTimeout(() => {
        returnHoldTimerId = null;
        if (!returnHoldActive || returnHoldFiredHome) return;
        fireReturnHoldHome();
    }, ms);
    return true;
}

/** End an active hold: short press → normal Return; completed hold → already went Home. */
function endReturnHold() {
    if (!returnHoldActive) return;
    const fired = returnHoldFiredHome;
    clearReturnHoldTimer();
    returnHoldActive = false;
    returnHoldFromPointer = false;
    returnHoldPointerId = null;
    if (!fired) handleGlobalReturnAction();
    returnHoldFiredHome = false;
}

function applyHoldReturnHomeSecondsFromInput() {
    if (!holdReturnHomeSecondsInput) return;
    const raw = Number(holdReturnHomeSecondsInput.value);
    const next = Number.isFinite(raw)
        ? Math.max(
              HOLD_RETURN_HOME_SEC_MIN,
              Math.min(HOLD_RETURN_HOME_SEC_MAX, Math.round(raw * 10) / 10),
          )
        : HOLD_RETURN_HOME_SEC_DEFAULT;
    settingHoldReturnHomeSeconds = next;
    holdReturnHomeSecondsInput.value = String(next);
    localStorage.setItem("settingHoldReturnHomeSeconds", String(next));
}

function handleGlobalReturnAction() {
    cancelReturnHold();
    if (isPlayTransitionRunning()) return;
    if (isReplayPlaybackActive()) {
        exitReplayViewer();
        return;
    }
    if (handleChallengeReturn()) return;
    if (handleCampaignReturn()) return;
    if (handleMarathonReturn()) return;
    if (handleTournamentsReturn()) return;
    if (handleWorldMapReturn()) return;
    if (handleLocalReturn()) return;
    if (handleMpReturn()) return;
    if (handleLdReturn()) return;
    if (handleSoccerReturn()) return;
    if (settingsResetConfirmScreen && !settingsResetConfirmScreen.classList.contains("hidden")) {
        closeSettingsResetConfirm();
        return;
    }
    playReturnNavChirp();
    if (settingsScreen && !settingsScreen.classList.contains("hidden")) {
        hideSettingsScreen({
            after: () => {
                showEl(startScreen);
                updateMusicState();
                playScreenEnterMotion();
            },
        });
        return;
    }
    if (statsScreen && !statsScreen.classList.contains("hidden")) {
        hideEl(statsScreen);
        showEl(startScreen);
        updateMusicState();
        playScreenEnterMotion();
        return;
    }
    if (achievementsScreen && !achievementsScreen.classList.contains("hidden")) {
        closeAchievementsScreen();
        return;
    }
    if (tasksScreen && !tasksScreen.classList.contains("hidden")) {
        closeTasksScreen();
        return;
    }
    if (battlePassScreen && !battlePassScreen.classList.contains("hidden")) {
        closeBattlePassScreen();
        return;
    }
    if (shopScreen && !shopScreen.classList.contains("hidden")) {
        closeShopScreenFromNav();
        return;
    }
    if (inventoryScreen && !inventoryScreen.classList.contains("hidden")) {
        closeInventoryScreenFromNav();
        return;
    }
    if (profileScreen && !profileScreen.classList.contains("hidden")) {
        closeProfileScreen();
        return;
    }
    if (newsScreen && !newsScreen.classList.contains("hidden")) {
        closeNewsScreen();
        return;
    }
    if (notificationsScreen && !notificationsScreen.classList.contains("hidden")) {
        closeNotificationsScreen();
        return;
    }
    if ((adminSpeedrunPlaytestActive || practicePlayActive) && playing && gameMode === "speedrun") {
        endAdminSpeedrunPlaytest();
        return;
    }
    if (adminPenaltyPlaytestActive && playing && gameMode === "penalty") {
        endAdminPenaltyPlaytest();
        return;
    }
    const sandboxSpeedrunPreviewScreen = document.getElementById("sandboxSpeedrunPreviewScreen");
    if (sandboxSpeedrunPreviewScreen && !sandboxSpeedrunPreviewScreen.classList.contains("hidden")) {
        closeSandboxSpeedrunPreview(false);
        return;
    }
    const sandboxPenaltyPreviewScreenEl = document.getElementById("sandboxPenaltyPreviewScreen");
    if (sandboxPenaltyPreviewScreenEl && !sandboxPenaltyPreviewScreenEl.classList.contains("hidden")) {
        closeSandboxPenaltyPreview(false);
        return;
    }
    const sandboxSpeedrunWinScreen = document.getElementById("sandboxSpeedrunWinScreen");
    if (sandboxSpeedrunWinScreen && !sandboxSpeedrunWinScreen.classList.contains("hidden")) {
        continueSandboxSpeedrunWin();
        return;
    }
    if (dpadPositionCustomizeMode && playing) {
        finishDpadPositionCustomize();
        return;
    }
    if (rouletteWarnScreen && !rouletteWarnScreen.classList.contains("hidden")) {
        cancelRouletteWarning();
        return;
    }
    if (creditsScreen && !creditsScreen.classList.contains("hidden")) {
        closeCredits();
        return;
    }
    if (speedrunLevelScreen && !speedrunLevelScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => closeSpeedrunLevelPickerToModes());
        return;
    }
    if (penaltyLevelScreen && !penaltyLevelScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => closePenaltyLevelPickerToModes());
        return;
    }
    if (speedrunCompleteScreen && !speedrunCompleteScreen.classList.contains("hidden")) {
        if (adminSpeedrunPlaytestActive || adminSpeedrunPlaytestSnapshot || practicePlayActive) {
            hideEl(speedrunCompleteScreen);
            endAdminSpeedrunPlaytest();
            return;
        }
        withExitPlayTransition(() => closeSpeedrunCompleteToPicker());
        return;
    }
    if (penaltyCompleteScreen && !penaltyCompleteScreen.classList.contains("hidden")) {
        if (adminPenaltyPlaytestActive || adminPenaltyPlaytestSnapshot) {
            hideEl(penaltyCompleteScreen);
            endAdminPenaltyPlaytest();
            return;
        }
        withExitPlayTransition(() => closePenaltyCompleteToPicker());
        return;
    }
    if (sandboxCommunityScreen && !sandboxCommunityScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(sandboxCommunityScreen);
            showEl(sandboxBaseScreen);
            showEl(returnBtn);
        });
        return;
    }
    if (sandboxBaseScreen && !sandboxBaseScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(sandboxBaseScreen);
            openGameHub();
        });
        return;
    }
    if (isLocalScreenVisible()) {
        withExitPlayTransition(() => {
            hideLocalScreens();
            openGameHub();
        });
        return;
    }
    if (localResultScreen && !localResultScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(localResultScreen);
            hideLocalScreens();
            openGameHub();
        });
        return;
    }
    if (leaderboardScreen && !leaderboardScreen.classList.contains("hidden")) {
        closeLeaderboardScreen();
        return;
    }
    if (authScreen && !authScreen.classList.contains("hidden")) {
        closeAuthScreen();
        return;
    }
    if (gameOverScreen && !gameOverScreen.classList.contains("hidden")) {
        if (dpadPositionCustomizeMode) {
            finishDpadPositionCustomize();
            return;
        }
        if (isSandboxRunActive() || gameMode === "sandbox") {
            withExitPlayTransition(() => returnToSandboxCustomization());
        } else {
            withExitPlayTransition(() => exitPlayToModes());
        }
        return;
    }
    if (sandboxScreen && !sandboxScreen.classList.contains("hidden") && !playing) {
        withExitPlayTransition(() => {
            hideEl(sandboxScreen);
            showEl(sandboxBaseScreen);
            showEl(returnBtn);
        });
        return;
    }
    if ((isSandboxRunActive() || gameMode === "sandbox") && playing) {
        withExitPlayTransition(() => returnToSandboxCustomization());
    } else if ((isSandboxRunActive() || gameMode === "sandbox") && !deathPending) {
        withExitPlayTransition(() => returnToSandboxCustomization());
    } else if (gameMode === "sandbox" && !deathPending) {
        withExitPlayTransition(() => returnToSandboxCustomization());
    } else if ((gameMode === "multiplayer" || isMultiplayerActive()) && playing && mpClient.room) {
        withExitPlayTransition(() => {
            if (mpClient.isHost()) mpClient.exitToLobby();
            endMultiplayerToLobby();
        });
    } else if (isLootDropActive() && playing) {
        withExitPlayTransition(() => {
            handleLdReturn();
        });
    } else if (isLdScreenVisible()) {
        withExitPlayTransition(() => {
            handleLdReturn();
        });
    } else if (isLocalActive() && playing) {
        withExitPlayTransition(() => stopLocalPlaying());
    } else if (gameMode === "multiplayer" || isMultiplayerActive()) {
        withExitPlayTransition(() => {
            stopMultiplayerGame();
            mpClient.leaveRoom();
            stopMultiplayerPlaying();
            hideAllMpScreens();
            openGameHub();
        });
    } else if (playing || deathPending) {
        withExitPlayTransition(() => exitPlayToModes());
    } else if (modeScreen && !modeScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(modeScreen);
            clearModeSelection();
            openGameHub();
        });
    } else if (practiceScreen && !practiceScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(practiceScreen);
            openGameHub();
        });
    } else if (challengesScreen && !challengesScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(challengesScreen);
            openGameHub();
        });
    } else if (tournamentsScreen && !tournamentsScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            hideEl(tournamentsScreen);
            if (tournamentsScreen) tournamentsScreen.setAttribute("aria-hidden", "true");
            openGameHub();
        });
    } else if (marathonScreen && !marathonScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => {
            closeMarathonFlow();
            hideEl(marathonScreen);
            if (marathonScreen) marathonScreen.setAttribute("aria-hidden", "true");
            openGameHub();
        });
    } else if (gameHubScreen && !gameHubScreen.classList.contains("hidden")) {
        withExitPlayTransition(() => goToMenu(null));
    } else {
        goToMenu(null);
    }
}

function applyLocalAccountSessionCleared() {
    reloadAccountGlobalsFromStorage();
    refreshStatsPlaytimeOnly();
    if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
    if (modeScreen && !modeScreen.classList.contains("hidden")) refreshModesScreen();
    void refreshSettingsAccountUi();
    if (gameMode && playing) updateTopHud();
}

/** Drop in-memory and local stats while swapping accounts (cookie may still be old until switch API). */
function clearSignedInAccountLocalState() {
    cloudUser = null;
    cloudTimedOut = false;
    cloudTimedOutUntil = null;
    cloudTimedOutAt = null;
    hudStatsBestCache = {};
    hudStatsBestCacheUserId = null;
    profileFriendsList = [];
    stopPresenceHeartbeat();
    speedrunCloudPersonalBests = null;
    sandboxSpeedrunCloudBests = null;
    sandboxScoreCloudBests = null;
    setWallAuthenticated(false);
    setAccountSyncSignedIn(false);
    clearAccountSessionLocal();
    applyLocalAccountSessionCleared();
    if (authStatusLine) {
        authStatusLine.classList.remove("authStatusLine--signedIn");
        authStatusLine.textContent = "Loading…";
    }
    hideEl(sideLogoutBtn);
    setSwitchAccountVisible(false);
    if (sideNavAccountRow) hideEl(sideNavAccountRow);
    if (sideSignInBtn) showEl(sideSignInBtn);
    if (homeSignInBtn) showEl(homeSignInBtn);
    cloudIsAdmin = false;
    cloudAdminPermissions = [];
    if (sideAdminPanelBtn) hideEl(sideAdminPanelBtn);
    void refreshSettingsAccountUi();
}

async function hydrateAccountDataForUser(userId) {
    invalidateMyBestsCache();
    await pullAccountDataSync(userId);
    applyLocalAccountSessionCleared();
    syncEquippedCosmeticFromState();
    refreshAllPlayStreakUi();
    // Daily login once per signed-in bootstrap (not on GET shop/account-data).
    void claimDailyLoginDots().then((dots) => {
        if (dots) applyDotsFromApi(dots);
    });
    // Never block account bootstrap / login on Shop catalog (large images or missing tables).
    void refreshShopCosmeticState();
    await Promise.all([
        refreshSpeedrunCloudPersonalBests(),
        refreshSandboxSpeedrunCloudBests(),
        refreshSandboxScoreCloudBests(),
    ]);
    await syncPlayerStatsToCloud(true);
    const flushed = await flushPendingLeaderboardScores();
    if (flushed > 0) {
        await Promise.all([
            refreshSpeedrunCloudPersonalBests(),
            refreshSandboxSpeedrunCloudBests(),
            refreshSandboxScoreCloudBests(),
        ]);
    }
    await refreshHudStatsBestCache();
    if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
    if (playing) updateTopHud();
}

async function performAccountSessionRefresh() {
    setAccountBootstrapActive(true);
    try {
        clearSignedInAccountLocalState();
        await refreshAuthStatus({ bootstrap: false, awaitAccountData: true });
    } finally {
        setAccountBootstrapActive(false);
    }
}

async function performAccountSwitch(account) {
    setAccountBootstrapActive(true);
    try {
        if (cloudUser && isAccountSyncReady()) {
            await syncPlayerStatsToCloud(true);
            await flushAccountDataSync();
        }
        await releasePushDeviceForSession();
        clearSignedInAccountLocalState();
        const result = await switchToSavedAccount(account);
        if (!result.ok) {
            alert(result.error || "Could not switch account.");
            await refreshAuthStatus({ bootstrap: false, awaitAccountData: true });
            return;
        }
        await refreshAuthStatus({ bootstrap: false, awaitAccountData: true });
        playScreenEnterMotion();
    } finally {
        setAccountBootstrapActive(false);
    }
}

let applyingRemoteAccountData = false;

function reloadAccountGlobalsFromStorage() {
    bestNormal = readStored(KEY_BEST_NORMAL);
    bestWASD = readStored(KEY_BEST_WASD);
    bestSuper = readStored(KEY_BEST_SUPER);
    bestProg = readStored(KEY_BEST_PROG);
    bestRoulette = readStored(KEY_BEST_ROULETTE);
    bestSandbox = readStored(KEY_BEST_SANDBOX);
    bestHighway = readStored(KEY_BEST_HIGHWAY);
    bestDarkness = readStored(KEY_BEST_DARKNESS);
    bestMirror = readStored(KEY_BEST_MIRROR);
    bestSnake = readStored(KEY_BEST_SNAKE);
    bestCombo = readStored(KEY_BEST_COMBO);
    bestOverload = readStored(KEY_BEST_OVERLOAD);
    bestColorRush = readStored(KEY_BEST_COLOR_RUSH);
    bestHeat = readStored(KEY_BEST_HEAT);
    bestHunter = readStored(KEY_BEST_HUNTER);
    bestPop = readStored(KEY_BEST_POP);
    bestCounter = readStored(KEY_BEST_COUNTER);
    bestAim = readStored(KEY_BEST_AIM);
    bestHook = readStored(KEY_BEST_HOOK);
    bestTilt = readStored(KEY_BEST_TILT);
    bestOrbit = readStored(KEY_BEST_ORBIT);
    bestDelay = readStored(KEY_BEST_DELAY);
    playTime = readStored(KEY_PLAYTIME);
    deathCount = readStored(KEY_DEATHS);
    sandboxSaveIsPublicPref = getBoolSetting(SANDBOX_SAVE_IS_PUBLIC_KEY, false);
    applyingRemoteAccountData = true;
    try {
        reloadSettingsGlobalsFromStorage();
        applySettings();
    } finally {
        applyingRemoteAccountData = false;
    }
    applyDpadLayoutFromStorage();
    refreshDpadSettingsVisibility();
    if (modeScreen && !modeScreen.classList.contains("hidden")) refreshModesScreen();
}

function reloadSettingsGlobalsFromStorage() {
    migrateLegacyEffectSettings();
    settingBallsColor = getHexSetting("settingBallsColor", "#66ffff");
    settingCursorColor = getHexSetting("settingCursorColor", "#ffffff");
    settingButtonsColor = getHexSetting("settingButtonsColor", "#66ffff");
    settingButtonsAutoText = getBoolSetting("settingButtonsAutoText", true);
    settingTextColor = getHexSetting("settingTextColor", "#66ffff");
    settingTrailColor = getHexSetting("settingTrailColor", "#66ffff");
    migrateLegacyBackgroundSettings();
    settingMenuBackgroundColor = getHexSetting("settingMenuBackgroundColor", "#000000");
    settingGameBackgroundColor = getHexSetting("settingGameBackgroundColor", "#000000");
    settingMenuBackgroundBright = readBackgroundBright("settingMenuBackgroundBright", "settingMenuBackgroundDarkMode");
    settingGameBackgroundBright = readBackgroundBright("settingGameBackgroundBright", "settingGameBackgroundDarkMode");
    settingWASDSensitivity = clamp(getNumberSetting("settingWASDSensitivity", 4), 1, 20);
    settingMusicVolume = clamp(getNumberSetting("settingMusicVolume", 6), 0, 10);
    settingGameMusicVolume = clamp(getNumberSetting("settingGameMusicVolume", 6), 0, 10);
    settingMenuSong = clamp(getNumberSetting("settingMenuSong", 1), 1, MUSIC_TRACK_COUNT);
    settingGameSong = clamp(getNumberSetting("settingGameSong", 1), 1, MUSIC_TRACK_COUNT);
    settingBounceVolume = clamp(getNumberSetting("settingBounceVolume", SFX_VOLUME_DEFAULT), 0, 10);
    settingPickupVolume = readSfxVolumeSetting("settingPickupVolume");
    settingGameSfxVolume = readSfxVolumeSetting("settingGameSfxVolume");
    settingDarknessVolume = readSfxVolumeSetting("settingDarknessVolume");
    settingUiVolume = clamp(getNumberSetting("settingUiVolume", UI_VOLUME_DEFAULT), 0, 10);
    settingEffectFlashes = getBoolSetting("settingEffectFlashes", true);
    settingEffectShake = getBoolSetting("settingEffectShake", true);
    settingEffectParticles = getBoolSetting("settingEffectParticles", true);
    settingFreezeOnLose = getBoolSetting("settingFreezeOnLose", true);
    settingFreezeOnLoseSeconds = readFreezeOnLoseSeconds();
    settingAutoRetry = getBoolSetting("settingAutoRetry", false);
    settingModesSelectPanel = getBoolSetting("settingModesSelectPanel", true);
    settingPlayTransition = getBoolSetting("settingPlayTransition", true);
    settingQuickRestart = getBoolSetting("settingQuickRestart", true);
    settingTrailEnabled = getBoolSetting("settingTrailEnabled", true);
    settingCosmeticsMatchCursor = getBoolSetting("settingCosmeticsMatchCursor", true);
    settingNeonBalls = getBoolSetting("settingNeonBalls", true);
    settingHomeAmbientBalls = getBoolSetting("settingHomeAmbientBalls", true);
    settingNewsInHome = getBoolSetting("settingNewsInHome", false);
    settingNotificationsInHome = getBoolSetting("settingNotificationsInHome", true);
    settingHomeSplash = getBoolSetting("settingHomeSplash", true);
    settingShowFps = getBoolSetting("settingShowFps", false);
    settingShowFpsWhere = readFpsShowWhere(localStorage.getItem("settingShowFpsWhere"));
    settingFpsLimit = readFpsLimit(localStorage.getItem("settingFpsLimit"));
    setGameplayFpsLimit(settingFpsLimit);
    settingLowPowerCap60 = readLowPowerCap60Enabled(localStorage.getItem("settingLowPowerCap60"));
    setLowPowerCap60Enabled(settingLowPowerCap60);
    settingInvertReturnPause = getBoolSetting("settingInvertReturnPause", false);
    settingInvertSidebar = getBoolSetting("settingInvertSidebar", false);
    settingHoldReturnHome = getBoolSetting("settingHoldReturnHome", true);
    settingHoldReturnHomeSeconds = readHoldReturnHomeSeconds();
    settingSounds = getBoolSetting("settingSounds", true);
    settingTouchCursorJoystick = getBoolSetting("settingTouchCursorJoystick", false);
    settingTouchCursorJoystickVisible = getBoolSetting("settingTouchCursorJoystickVisible", true);
    settingTouchJoystickSensitivity = clamp(getNumberSetting("settingTouchJoystickSensitivity", 4), 1, 20);
    settingShowKeybindIndicator = getBoolSetting("settingShowKeybindIndicator", true);
    settingShowMobileSettingsInUi = getBoolSetting("settingShowMobileSettingsInUi", false);
    reloadDpadSettingsFromStorage();
}

let settingsActionToastTimer = null;

function playSettingsActionToastSound() {
    if (!settingSounds || settingUiVolume <= 0) return;
    if (!isAudioContextRunning()) return;
    const vol = uiVolumeGain(0.034);
    const t0 = audioCtx.currentTime + 0.01;
    playTone(523.25, t0, 0.065, vol, "sine");
    playTone(659.25, t0 + 0.06, 0.075, vol, "sine");
    playTone(783.99, t0 + 0.125, 0.085, vol, "sine");
}

function showSettingsActionToast(message) {
    let toast = document.getElementById("settingsActionToast");
    if (!toast) {
        toast = document.createElement("div");
        toast.id = "settingsActionToast";
        toast.className = "settingsCopiedToast";
        toast.setAttribute("role", "status");
        toast.setAttribute("aria-live", "polite");
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    if (settingsActionToastTimer) {
        clearTimeout(settingsActionToastTimer);
        settingsActionToastTimer = null;
    }
    toast.classList.remove("settingsCopiedToast--visible");
    void toast.offsetWidth;
    toast.classList.add("settingsCopiedToast--visible");
    playSettingsActionToastSound();
    settingsActionToastTimer = window.setTimeout(() => {
        toast.classList.remove("settingsCopiedToast--visible");
        settingsActionToastTimer = null;
    }, 1500);
}

function showSettingsCopiedToast() {
    showSettingsActionToast("Copied");
}

async function copyTextToClipboard(text) {
    if (!text) return false;
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        /* fallback below */
    }
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "true");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        if (ok) return true;
    } catch {
        /* fallback below */
    }
    window.prompt("Copy this JSON:", text);
    return false;
}

async function onSettingsCopyClicked() {
    let json = "";
    try {
        json = exportSettingsShareJson();
    } catch {
        window.alert("Could not prepare settings to copy.");
        return;
    }
    if (!json.trim()) {
        window.alert("Could not prepare settings to copy.");
        return;
    }
    await copyTextToClipboard(json);
    showSettingsCopiedToast();
}

async function onSettingsPasteClicked() {
    let text = "";
    try {
        text = await navigator.clipboard.readText();
    } catch {
        text = window.prompt("Paste settings JSON here:") || "";
    }
    const trimmed = (text || "").trim();
    if (!trimmed) return;
    try {
        pushSettingsUndoCurrent();
        const snap = parseSettingsShareJson(trimmed);
        if (!snap) throw new Error("parse failed");
        applySettingsShareSnapshot(snap);
        migrateLegacyEffectSettings();
        reloadSettingsGlobalsFromStorage();
        applyDpadLayoutFromStorage();
        applySettings();
        refreshSettingsUI();
        refreshDpadSettingsVisibility();
        refreshMenuKbdLabels();
        showSettingsActionToast("Pasted");
    } catch {
        window.alert("Could not paste settings: invalid JSON or wrong format.");
    }
}

let shieldExpiresAt = 0;
let slowExpiresAt = 0;
let barrierExpiresAt = 0;
let pushExpiresAt = 0;

function tryActivateSuperdotShield() {
    if (gameMode !== "superdot" || !playing || gamePaused || deathPending || resumeCountdownActive) return;
    const now = getGameSimNowMs();
    const cd = sbNum("shieldCooldownMs", 15000);
    const dur = sbNum("abilityDurationMs", 5000);
    if (now - lastShieldUse < cd) return;
    shieldActive = true;
    lastShieldUse = now;
    shieldExpiresAt = now + dur;
}

function tryActivateSuperdotSlow() {
    if (gameMode !== "superdot" || !playing || gamePaused || deathPending || resumeCountdownActive) return;
    const now = getGameSimNowMs();
    const cd = sbNum("slowCooldownMs", 15000);
    const dur = sbNum("abilityDurationMs", 5000);
    if (now - lastSlowUse < cd) return;
    slowActive = true;
    lastSlowUse = now;
    slowExpiresAt = now + dur;
}

function tryActivateSuperdotBarrier() {
    if (gameMode !== "superdot" || !playing || gamePaused || deathPending || resumeCountdownActive) return;
    const now = getGameSimNowMs();
    const cd = sbNum("barrierCooldownMs", 30000);
    const dur = sbNum("abilityDurationMs", 5000);
    if (now - lastBarrierUse < cd) return;
    barrierActive = true;
    lastBarrierUse = now;
    barrierExpiresAt = now + dur;
}

function tryActivateSuperdotPush() {
    if (gameMode !== "superdot" || !playing || gamePaused || deathPending || resumeCountdownActive) return;
    const now = getGameSimNowMs();
    const cd = sbNum("pushCooldownMs", 30000);
    const dur = sbNum("abilityDurationMs", 5000);
    if (now - lastPushUse < cd) return;
    pushActive = true;
    lastPushUse = now;
    pushExpiresAt = now + dur;
}

function tickSuperdotAbilityExpiry(now = getGameSimNowMs()) {
    if (shieldActive && now >= shieldExpiresAt) shieldActive = false;
    if (slowActive && now >= slowExpiresAt) slowActive = false;
    if (barrierActive && now >= barrierExpiresAt) barrierActive = false;
    if (pushActive && now >= pushExpiresAt) pushActive = false;
}

function startDpadPositionCustomize() {
    if (!canUseMobileDpadCustomize()) return;
    hideSettingsScreen({
        after: () => {
            beginDpadCustomizeSession();
            setDpadCustomizeMode(true);
            initGame("wasd", { skipModeView: true });
            cancelPendingModeView();
            mouse.x = canvas.width / 2;
            mouse.y = canvas.height / 2;
            for (let i = 0; i < 10; i++) spawnObstacle(1.2);
            requestAnimationFrame(() => {
                applyDpadLayoutFromStorage();
                requestAnimationFrame(() => applyDpadLayoutFromStorage());
            });
            hideEl(returnBtn);
            if (topCenter) topCenter.textContent = "";
            updateMobilePlayChrome();
        }
    });
}

function closeDpadCustomizeExitConfirm() {
    if (dpadCustomizeExitConfirm) hideEl(dpadCustomizeExitConfirm);
}

function openDpadCustomizeExitConfirm() {
    if (!dpadCustomizeExitConfirm) return;
    showEl(dpadCustomizeExitConfirm);
}

function cancelDpadPositionCustomizeWithoutSave() {
    if (!dpadPositionCustomizeMode) return;
    discardDpadCustomizeSession();
    closeDpadCustomizeExitConfirm();
    setDpadCustomizeMode(false);
    hideEl(gameOverScreen);
    exitGamePointerLock();
    leavePauseMenuCursorMode();
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    playing = false;
    gameMode = null;
    obstacles = [];
    shieldActive = false;
    slowActive = false;
    barrierActive = false;
    pushActive = false;
    particles = [];
    trail = [];
    screenShake = 0;
    document.body.classList.remove("hideCursor");
    setSuperHudVisible(false);
    setTopHudMode(null);
    keys = {};
    hideEl(returnBtn);
    topCenter.textContent = "";
    resetRouletteHudOverlay();
    showSettingsScreen();
    if (sideSettingsBtn) setActiveSidebarBtn(sideSettingsBtn);
    refreshDpadSettingsVisibility();
    refreshDpadSettingsUI();
    applySettings();
    updateMobilePlayChrome();
    updateMusicState();
}

function finishDpadPositionCustomize() {
    if (!dpadPositionCustomizeMode) return;
    persistDpadPositionFromElement();
    commitDpadCustomizeSession();
    closeDpadCustomizeExitConfirm();
    setDpadCustomizeMode(false);
    hideEl(gameOverScreen);
    exitGamePointerLock();
    leavePauseMenuCursorMode();
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    playing = false;
    gameMode = null;
    obstacles = [];
    shieldActive = false;
    slowActive = false;
    barrierActive = false;
    pushActive = false;
    particles = [];
    trail = [];
    screenShake = 0;
    document.body.classList.remove("hideCursor");
    setSuperHudVisible(false);
    setTopHudMode(null);
    keys = {};
    hideEl(returnBtn);
    topCenter.textContent = "";
    resetRouletteHudOverlay();
    showSettingsScreen();
    if (sideSettingsBtn) setActiveSidebarBtn(sideSettingsBtn);
    refreshDpadSettingsVisibility();
    refreshDpadSettingsUI();
    applySettings();
    updateMobilePlayChrome();
    updateMusicState();
}

function refreshSuperHudKbdHints() {
    if (!shieldText || !slowText || !barrierText) return;
    const touch = isTouchGameUi();
    const gp = isGamepadConnected();
    if (gp) {
        const h = getSuperdotGamepadHints();
        slowText.textContent = `SLOW [${h.slow}]`;
        barrierText.textContent = `BARRIER [${h.barrier}]`;
        shieldText.textContent = `SHIELD [${h.shield}]`;
        if (pushText) pushText.textContent = `PUSH [${h.push}]`;
    } else {
        slowText.textContent = touch ? "SLOW" : "SLOW [Q]";
        shieldText.textContent = touch ? "SHIELD" : "SHIELD [E]";
        barrierText.textContent = touch ? "BARRIER" : "BARRIER [W]";
        if (pushText) pushText.textContent = touch ? "PUSH" : "PUSH [R]";
    }
    const touchSkills = touch && !gp;
    if (superHudSlowBtn) superHudSlowBtn.style.pointerEvents = touchSkills ? "auto" : "none";
    if (superHudShieldBtn) superHudShieldBtn.style.pointerEvents = touchSkills ? "auto" : "none";
    if (superHudBarrierBtn) superHudBarrierBtn.style.pointerEvents = touchSkills ? "auto" : "none";
    if (superHudPushBtn) superHudPushBtn.style.pointerEvents = touchSkills ? "auto" : "none";
}

function refreshMenuKbdLabels() {
    const touch = isTouchGameUi();
    const kbd = !touch && settingShowKeybindIndicator;
    document.querySelectorAll("[data-kbd-desktop]").forEach((el) => {
        const desk = el.getAttribute("data-kbd-desktop") || "";
        const mob =
            el.getAttribute("data-kbd-touch") ||
            desk.replace(/\s*\[[^\]]*\]/g, "").replace(/ · PAUSE \[P\]/, " · PAUSE");
        el.textContent = touch || !kbd ? mob : replaceKeybindPlaceholders(desk);
    });
    document.querySelectorAll(".pauseKbd").forEach((el) => {
        if (!kbd) {
            el.style.display = "none";
            el.textContent = "";
        } else {
            el.style.display = "";
            el.textContent = ` [${formatKeybindDisplay(getKeybindKey("pause"))}]`;
        }
    });
    refreshSuperHudKbdHints();
    if (gamePaused && pauseHint) {
        if (touch) pauseHint.textContent = L.pauseHintTouch;
        else if (kbd) pauseHint.textContent = `Press ${formatKeybindDisplay(getKeybindKey("pause"))} or click Resume to continue.`;
        else pauseHint.textContent = L.pauseHintNoKbd;
    }
    syncSidebarState();
}

function resetMobileJoystickVisual() {
    resetDpadHoldState();
}

/** D-Pad on touch only when WASD movement is active (WASD mode, roulette WASD effect, or sandbox WASD). */
function shouldShowTouchDpadForCurrentMode() {
    if (gameMode === "wasd") {
        if (isSandboxRunActive()) return sandboxWasdMovementActive();
        return true;
    }
    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpWasdMode()) return true;
    if (gameMode === "roulette" && roulette.controlMode === "wasd") return true;
    if (sandboxWasdMovementActive()) return true;
    return false;
}

/** Touch / pen: drag on canvas moves cursor when not in a WASD-controls context. */
function touchSlideSteerActive() {
    return touchSteerPlayConditionsMet();
}

function touchPlaySteerPadVisible() {
    if (isGamepadConnected()) return false;
    if (shouldHideGlobalTouchPad()) return false;
    if (isLootDropActive() && isLdHost()) return false;
    if (gameMode === "tilt") return false;
    return touchSteerPlayConditionsMet() && !settingTouchCursorJoystick && !isGameplayInputFrozen();
}

function updateTouchPlaySteerPad() {
    if (!touchPlaySteerPad) return;
    const on = touchPlaySteerPadVisible();
    touchPlaySteerPad.classList.toggle("hidden", !on);
    touchPlaySteerPad.setAttribute("aria-hidden", on ? "false" : "true");
}

/** Mobile: slide-to-steer on canvas (trackpad-style); disabled when floating joystick mode is ON. */
function touchCanvasSlideSteerEnabled() {
    if (shouldHideGlobalTouchPad()) return false;
    return touchSlideSteerActive() && !settingTouchCursorJoystick && gameMode !== "aim" && gameMode !== "hook" && gameMode !== "tilt";
}

let hookAimRmbHeld = false;

const touchCursorAnalog = {
    active: false,
    pointerId: -1,
    baseX: 0,
    baseY: 0,
    curX: 0,
    curY: 0,
    maxR: 96,
    /** @type {Element | null} */
    captureEl: null,
};

function hideTouchFloatJoystick() {
    const wrap = document.getElementById("touchFloatJoystick");
    if (wrap) wrap.classList.add("hidden");
}

function updateTouchFloatJoystickVisual() {
    const wrap = document.getElementById("touchFloatJoystick");
    const knob = wrap?.querySelector(".touch-float-joyst-knob");
    if (!wrap || !knob) return;
    let dx = touchCursorAnalog.curX - touchCursorAnalog.baseX;
    let dy = touchCursorAnalog.curY - touchCursorAnalog.baseY;
    const m = Math.hypot(dx, dy);
    const cap = touchCursorAnalog.maxR;
    if (m > cap && m > 1e-6) {
        const s = cap / m;
        dx *= s;
        dy *= s;
    }
    wrap.style.left = `${touchCursorAnalog.baseX}px`;
    wrap.style.top = `${touchCursorAnalog.baseY}px`;
    knob.style.transform = `translate(${dx}px, ${dy}px)`;
}

function endTouchCursorAnalogAny() {
    const id = touchCursorAnalog.pointerId;
    const cap = touchCursorAnalog.captureEl;
    touchCursorAnalog.active = false;
    touchCursorAnalog.pointerId = -1;
    touchCursorAnalog.captureEl = null;
    hideTouchFloatJoystick();
    if (id >= 0) {
        noteGameTouchUp(id);
        releaseTouchSteer(id);
    } else resetRelativePointerAnchor();
    if (id >= 0 && cap) {
        try {
            cap.releasePointerCapture(id);
        } catch {
            /* ignore */
        }
    }
}

function targetBlocksTouchAnalogJoystick(target) {
    if (!(target instanceof Element)) return true;
    const el = target;
    if (el.closest("#returnBtn")) return true;
    if (el.closest("#pauseTopBtn")) return true;
    if (el.closest("#superHud")) return true;
    if (el.closest("#topCenter")) return true;
    if (el.closest("#rouletteEffectText")) return true;
    if (el.closest("#rouletteScoreLine")) return true;
    if (pauseScreen && !pauseScreen.classList.contains("hidden") && el.closest("#pauseScreen")) return true;
    if (gameOverScreen && !gameOverScreen.classList.contains("hidden") && el.closest("#gameOverScreen")) return true;
    if (speedrunCompleteScreen && !speedrunCompleteScreen.classList.contains("hidden") && el.closest("#speedrunCompleteScreen"))
        return true;
    if (el.closest("#sideNav") || el.closest("#sideNavToggle")) return true;
    if (el.closest(".touch-steer-layer")) return true;
    if (el.closest(".orbit-steer-zone")) return true;
    if (el.closest("#hookAimJoystick")) return true;
    if (el.closest(".dpad-customize-toolbar")) return true;
    if (el.closest(".dpad-customize-return")) return true;
    if (el.closest("button, a[href], input, select, textarea, label")) return true;
    if (el.closest(".screen") && !document.body.classList.contains("game-active")) return true;
    return false;
}

function touchAnalogSteerWantsEvent(e) {
    if (isGamepadConnected()) return false;
    if (!isTouchGameUi() || !playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (!settingTouchCursorJoystick) return false;
    if (!touchSlideSteerActive()) return false;
    if (gameMode === "aim" || gameMode === "hook" || gameMode === "tilt") return false;
    if (e.pointerType !== "touch" && e.pointerType !== "pen") return false;
    if (!document.body.classList.contains("game-active")) return false;
    return true;
}

function applyTouchCursorAnalogInLoop(dt) {
    if (!touchCursorAnalog.active) return;
    if (!playing || deathPending || isGameplayInputFrozen()) return;
    const dx = touchCursorAnalog.curX - touchCursorAnalog.baseX;
    const dy = touchCursorAnalog.curY - touchCursorAnalog.baseY;
    const m = Math.hypot(dx, dy);
    const dead = 6;
    const capR = touchCursorAnalog.maxR;
    if (m < dead) return;
    const ux = dx / m;
    const uy = dy / m;
    const capped = Math.min(m, capR);
    const strength = (capped - dead) / Math.max(1e-6, capR - dead);
    const sp = 640 * (settingTouchJoystickSensitivity / 4) * strength;
    applyPointerDelta(ux * sp * dt, uy * sp * dt, false);
}

function releaseCanvasTouchSteerCapture() {
    if (canvasTouchSteerCaptureId < 0) return;
    const id = canvasTouchSteerCaptureId;
    canvasTouchSteerCaptureId = -1;
    releaseTouchSteer(id);
    try {
        canvas.releasePointerCapture(id);
    } catch {
        /* ignore */
    }
    resetRelativePointerAnchor();
}

/** Touch-only gameplay overlays (D-Pad, Hook aim stick) — not touchscreen laptops on PC. */
function touchGameplayOverlayEligible() {
    if (isGamepadConnected()) return false;
    return isTouchGameUi() || mobileTouchInputActive() || dpadPositionCustomizeMode;
}

function updateMobilePlayChrome() {
    if (!touchSlideSteerActive()) releaseCanvasTouchSteerCapture();
    const mobileChromeActive =
        playing && (mobileTouchInputActive() || dpadPositionCustomizeMode);
    if (!mobileChromeActive) {
        endTouchCursorAnalogAny();
        touchSteerSession = null;
        touchSteerLiveClient = null;
    }
    document.body.classList.toggle("game-playing-touch", mobileChromeActive);
    document.body.classList.toggle(
        "touch-play-noselect",
        !!(playing && (isTouchGameUi() || mobileTouchInputActive())),
    );
    updateTouchPlaySteerPad();
    const steerOn =
        playing &&
        !gamePaused &&
        !deathPending &&
        touchGameplayOverlayEligible() &&
        (shouldShowTouchDpadForCurrentMode() || dpadPositionCustomizeMode);
    if (touchSteerLayer) {
        if (steerOn) showEl(touchSteerLayer);
        else {
            hideEl(touchSteerLayer);
            resetMobileJoystickVisual();
        }
    }
    const orbitSteerOn =
        playing &&
        gameMode === "orbit" &&
        !gamePaused &&
        !deathPending &&
        !resumeCountdownActive &&
        !dpadPositionCustomizeMode;
    const orbitTouchZones = orbitSteerOn && touchGameplayOverlayEligible();
    if (orbitSteerLayer) {
        if (orbitSteerOn) {
            const wasHidden = orbitSteerLayer.classList.contains("hidden");
            showEl(orbitSteerLayer);
            orbitSteerLayer.classList.toggle("orbit-steer--touch-zones", !!orbitTouchZones);
            if (wasHidden) restartOrbitSteerHint();
        } else {
            hideEl(orbitSteerLayer);
            clearAllOrbitZonePointers();
            orbitSteerLayer.classList.remove("orbit-steer-hint-play");
            orbitSteerLayer.classList.remove("orbit-steer--touch-zones");
        }
    }
    if (pauseTopBtn) {
        const showPause =
            playing && !deathPending && !resumeCountdownActive && !isMultiplayerActive() && !isLocalActive() && !isLootDropActive() && !isSoccerActive() && !dpadPositionCustomizeMode && !isReplayPlaybackActive();
        if (showPause) showEl(pauseTopBtn);
        else hideEl(pauseTopBtn);
    }
    syncReturnBtnVisibility();
    const hookJoyOn =
        playing &&
        gameMode === "hook" &&
        !gamePaused &&
        !deathPending &&
        !resumeCountdownActive &&
        !isGamepadConnected() &&
        (isTouchGameUi() || mobileTouchInputActive());
    setHookAimJoystickVisible(!!hookJoyOn);
    if (localTouchZones) {
        const localOn =
            isLocalActive() && playing && !deathPending && !gamePaused && !isGamepadConnected();
        localTouchZones.classList.toggle("hidden", !localOn);
        localTouchZones.setAttribute("aria-hidden", localOn ? "false" : "true");
    }
}

function shouldUseGamePointerLock() {
    if (isLootDropActive() && isLdHost()) return false;
    return !isTouchGameUi() && !dpadPositionCustomizeMode && !uiCursorMode;
}

function clearUiCursorMode() {
    if (!uiCursorMode) return;
    uiCursorMode = false;
    document.body.classList.remove("ui-cursor-mode");
}

function setUiCursorMode(on) {
    if (isTouchGameUi()) return;
    if (on === uiCursorMode) return;
    uiCursorMode = on;
    if (uiCursorMode) {
        exitGamePointerLock();
        document.body.classList.add("ui-cursor-mode");
        document.body.classList.remove("hideCursor");
    } else {
        document.body.classList.remove("ui-cursor-mode");
        if (playing && !gamePaused && !deathPending && !dpadPositionCustomizeMode) {
            applyPlayingHideCursorClass();
            tryRequestGamePointerLock();
        }
    }
}

function toggleUiCursorMode() {
    if (!playing || isTouchGameUi()) return;
    setUiCursorMode(!uiCursorMode);
}

function exitGamePointerLock() {
    if (document.pointerLockElement === canvas) document.exitPointerLock();
}

function isGameplayInputFrozen() {
    return gamePaused || resumeCountdownActive || isPlayTransitionRunning();
}

function tryRequestGamePointerLock() {
    if (!canvas || !playing || deathPending) return;
    if (isReplayPlaybackActive()) return;
    if (isTouchGameUi() || dpadPositionCustomizeMode) return;
    // Play transition freezes movement but still needs lock from the PLAY click gesture.
    if (gamePaused || resumeCountdownActive) return;
    if (document.pointerLockElement === canvas) return;
    canvas.requestPointerLock().catch(() => {});
}

/** Pointer lock from the PLAY click before the run exists (user-gesture stack). */
function armPlayTransitionPointerLock() {
    if (!canvas || isTouchGameUi() || dpadPositionCustomizeMode) return;
    pointerLockPauseSuppressedUntil = performance.now() + 4000;
    if (document.pointerLockElement === canvas) return;
    canvas.requestPointerLock().catch(() => {});
}

function enterPauseMenuCursorMode() {
    document.body.classList.add("pause-menu-cursor");
}

function leavePauseMenuCursorMode() {
    document.body.classList.remove("pause-menu-cursor");
}

function applyPlayingHideCursorClass() {
    if (!playing) return;
    if (dpadPositionCustomizeMode) return;
    if (isReplayPlaybackActive()) return;
    document.body.classList.add("hideCursor");
}

function mpHighwayMouseScreen(cw = canvas.width, ch = canvas.height) {
    return mpHighwayLocalCursorScreen(cw, ch);
}

function applyMpHighwayPointerDelta(dx, dy) {
    const cw = canvas.width;
    const ch = canvas.height;
    if (cw <= 0 || ch <= 0) return;
    mouse.x += dx / (cw / MP_REF_W);
    mouse.y -= dy / (ch / MP_REF_H);
}

function mpSandboxRuntimeFromWire(wire) {
    return sandboxRuntimeFlat(fromMpSandboxWire(wire));
}

function mpKeyboardOnlyMovement() {
    if (gameMode !== "multiplayer" || !isMultiplayerActive() || isTouchGameUi()) return false;
    if (isMpWasdMode()) return true;
    if (getMpGameMode() === "sandbox" && sandboxRuntimeConfig?.wasdEnabled) return true;
    return false;
}

function mpWasdKeyboardOnly() {
    return mpKeyboardOnlyMovement();
}

function applyPointerDelta(dx, dy, _fromPointerLockMovement = false) {
    if (isReplayPlaybackActive()) return;
    if (!playing || deathPending) return;
    if (uiCursorMode) return;
    if (isGameplayInputFrozen()) return;
    if (isMultiplayerActive() && isMpGameplayInputBlocked()) return;
    if (isLootDropActive() && isLdHost()) return;
    if (dx === 0 && dy === 0) return;
    if (mpWasdKeyboardOnly()) return;
    if (gameMode === "tilt") return;
    if (gameMode === "orbit") {
        feedOrbitSlideDelta(dx, gameLayoutScale());
        return;
    }
    // Sandbox WASD Movement ON → keyboard/D-Pad only (no mouse), on any base mode.
    if (sandboxWasdMovementActive()) return;

    if (gameMode === "multiplayer" && isMpHighwayPlaying()) {
        applyMpHighwayPointerDelta(dx, dy);
        return;
    }

    if (gameMode === "roulette") {
        if (roulette.controlMode === "mouse") {
            const pt = clampCursorXYToEdgeInset(roulette.pointerTarget.x + dx, roulette.pointerTarget.y + dy);
            roulette.pointerTarget.x = pt.x;
            roulette.pointerTarget.y = pt.y;
            if (roulettePointerFollowInstant()) {
                mouse.x = pt.x;
                mouse.y = pt.y;
            }
        }
        return;
    }

    if (gameMode === "sandbox") {
        const cfg = sandboxRuntimeConfig || sandboxConfig;
        if (cfg && cfg.speedrunMode && !cfg.wasdEnabled) {
            accumulateSpeedrunPointerIntent(dx, dy);
            return;
        }
        const clampFn = cfg && cfg.speedrunMode ? clampCursorXYToCanvas : clampCursorXYToEdgeInset;
        const st = clampFn(sandboxPointerTarget.x + dx, sandboxPointerTarget.y + dy);
        sandboxPointerTarget.x = st.x;
        sandboxPointerTarget.y = st.y;
        if (cfg && !cfg.wasdEnabled && !cfg.speedrunMode) {
            mouse.x = st.x;
            mouse.y = st.y;
        }
        return;
    }

    if (gameMode === "multiplayer" && isMultiplayerActive() && getMpGameMode() === "sandbox" && sandboxRuntimeConfig) {
        const cfg = sandboxRuntimeConfig;
        if (cfg.wasdEnabled) return;
        const st = clampCursorXYToEdgeInset(sandboxPointerTarget.x + dx, sandboxPointerTarget.y + dy);
        sandboxPointerTarget.x = st.x;
        sandboxPointerTarget.y = st.y;
        mouse.x = st.x;
        mouse.y = st.y;
        return;
    }

    if (gameMode === "highway") {
        mouse.x += dx;
        mouse.y -= dy;
        return;
    }

    if (gameMode === "speedrun") {
        accumulateSpeedrunPointerIntent(dx, dy);
        return;
    }

    /** Soccer uses the full canvas — edge inset felt like an invisible wall mid-pitch. */
    if (gameMode === "soccer" || isSoccerActive()) {
        const c = clampCursorXYToCanvas(mouse.x + dx, mouse.y + dy);
        mouse.x = c.x;
        mouse.y = c.y;
        return;
    }

    if (gameMode === "penalty") {
        const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
        mouse.x = c.x;
        mouse.y = c.y;
        return;
    }

    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode()) {
        accumulateSpeedrunPointerIntent(dx, dy);
        return;
    }

    // Real WASD mode (non-sandbox) ignores mouse; Sandbox WASD-off uses mouse.
    if (gameMode === "wasd" && !(isSandboxRunActive() && !sandboxWasdMovementActive())) return;

    const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
    mouse.x = c.x;
    mouse.y = c.y;
}

function syncPointerFromMovement(movementX, movementY) {
    if (!playing || deathPending) return;
    if (uiCursorMode) return;
    if (isGameplayInputFrozen()) return;
    if (mpWasdKeyboardOnly()) return;
    if (document.pointerLockElement !== canvas) return;
    noteGamepadMouseActivity();
    if (gameMode === "hook" && hookAimRmbHeld) {
        nudgeHookAimByMouseDelta(movementX, movementY);
        return;
    }
    if (pointerLockMovementWarmup) {
        pointerLockMovementWarmup = false;
        const scaled = scalePointerDeltaForGameplay(movementX, movementY, canvas);
        if (Math.hypot(scaled.dx, scaled.dy) > pointerLockAcquireSpikeCapPx()) return;
    }
    const { dx, dy } = clampGamePointerDelta(movementX, movementY);
    applyPointerDelta(dx, dy, true);
}

function syncPointerFromClient(clientX, clientY, pointerId = -1) {
    if (!playing || deathPending) return;
    if (uiCursorMode) return;
    if (isGameplayInputFrozen()) return;
    if (mpWasdKeyboardOnly()) return;
    if (document.pointerLockElement === canvas) return;
    if (isTouchTabletUi() && pointerId >= 0 && soloSlideSteerOwnsPointer(pointerId)) {
        const sess = soloSlideSteerSessions.get(pointerId);
        if (sess) {
            sess.liveClientX = clientX;
            sess.liveClientY = clientY;
        }
        return;
    }
    // An active finger-slide session (Touch API) owns cursor steering; don't also
    // apply relative movement here or the cursor doubles up when a device emits
    // both touch and pointer events for the same finger.
    if (touchSteerSession) return;
    if (mobileTouchInputActive()) {
        if (pointerId < 0) return;
        if (isSecondaryTouchPointer(pointerId)) return;
        if (!ensureTouchSteerPrimary(pointerId, clientX, clientY)) return;
        if (touchSteerPointerId < 0) touchSteerPointerId = pointerId;
    }
    if (gameMode === "hook" && hookAimRmbHeld) {
        const p = clientToCanvasGameXY(clientX, clientY);
        pointHookAimAtCanvas(p.x, p.y, mouse.x, mouse.y);
        return;
    }

    if (relativePointerLastClient === null) {
        relativePointerLastClient = { x: clientX, y: clientY };
        return;
    }
    const rawDx = clientX - relativePointerLastClient.x;
    const rawDy = clientY - relativePointerLastClient.y;
    relativePointerLastClient = { x: clientX, y: clientY };
    if (rawDx === 0 && rawDy === 0) return;
    const { dx, dy } = clampGamePointerDelta(rawDx, rawDy);
    applyPointerDelta(dx, dy);
}

/** WASD-style digital move from gamepad D-Pad (same speed as mobile D-Pad). */
function applyGamepadWasdInput(ux, uy, dt) {
    if (!playing || deathPending || isGameplayInputFrozen()) return;
    if (gameMode === "tilt") return;
    const sp = 440 * dt;
    const dx = ux * sp;
    const dy = uy * sp;

    if (gameMode === "wasd") {
        if (!isSandboxRunActive() || sandboxWasdMovementActive()) {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        }
        return;
    }

    if (sandboxWasdMovementActive() && gameMode !== "sandbox") {
        if (gameMode === "highway") {
            mouse.x += dx;
            mouse.y -= dy;
        } else if (gameMode === "speedrun") {
            accumulateSpeedrunPointerIntent(dx, dy);
        } else {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        }
        return;
    }

    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpWasdMode()) {
        const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
        mouse.x = c.x;
        mouse.y = c.y;
        return;
    }

    if (gameMode === "roulette" && roulette.controlMode === "wasd") {
        const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
        mouse.x = c.x;
        mouse.y = c.y;
        roulette.pointerTarget.x = mouse.x;
        roulette.pointerTarget.y = mouse.y;
        return;
    }

    if (gameMode === "sandbox") {
        const cfg = sandboxRuntimeConfig || sandboxConfig;
        const clampFn = cfg && cfg.speedrunMode ? clampCursorXYToCanvas : clampCursorXYToEdgeInset;
        if (cfg && cfg.wasdEnabled) {
            const c = clampFn(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        }
    }
}

function handleGamepadCounterConfirm() {
    if (gameMode !== "counter" || !playing || deathPending || gamePaused || resumeCountdownActive) return;
    if (shouldSkipLocalCollision()) return;
    const expected = getCounterNextExpected();
    const nowHit = getGameSimNowMs();
    for (let i = obstacles.length - 1; i >= 0; i--) {
        const o = obstacles[i];
        if (!o.hit()) continue;
        if (o.counterNum === expected) {
            const hx = o.x;
            const hy = o.y;
            obstacles.splice(i, 1);
            score += 1;
            advanceCounterExpected();
            resetCounterTimer(nowHit);
            playSpeedrunCoinPickupSound();
            emitBurst(hx, hy, 6, [settingBallsColor, "#ffffff"], 1.05, 0, 0.9, 2.4, 8, 18);
            addShake(0.2);
            if (getCounterNextExpected() > COUNTER_BALLS_TOTAL) {
                scheduleCounterRespawn(nowHit);
            }
        } else {
            beginDeath("Wrong ball!");
        }
        return;
    }
}

function handleGamepadGolfStrike() {
    if (gameMode !== "penalty" || !playing || deathPending || gamePaused || resumeCountdownActive) return;
    const ball = penaltyRuntime.ball;
    const cr = getCursorRadiusForMode();
    const towardX = ball.x - mouse.x;
    const towardY = ball.y - mouse.y;
    const tm = Math.hypot(towardX, towardY) || 1;
    const ux = towardX / tm;
    const uy = towardY / tm;
    const prevX = mouse.x - ux * 14;
    const prevY = mouse.y - uy * 14;
    if (
        penaltyTryCursorHitBall(
            ball,
            mouse.x,
            mouse.y,
            prevX,
            prevY,
            cr,
            80,
            performance.now(),
            penaltyRuntime.lastHitMs,
        )
    ) {
        penaltyRuntime.hitCount += 1;
        beep(520, 0.04);
    }
}

function handleGamepadPrimaryConfirm() {
    if (!playing || deathPending || gamePaused || resumeCountdownActive || isGameplayInputFrozen()) return;
    if (gameMode === "aim") {
        handleAimFireAtCanvasXY(mouse.x, mouse.y);
        return;
    }
    if (gameMode === "hook") {
        handleHookLaunch();
        return;
    }
    if (gameMode === "counter") {
        handleGamepadCounterConfirm();
        return;
    }
    if (gameMode === "penalty") {
        handleGamepadGolfStrike();
    }
}

function canUseGamepadQuickRestart() {
    if (!settingQuickRestart || !isGamepadConnected()) return false;
    if (!playing || !gameMode || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isMultiplayerActive() || dpadPositionCustomizeMode || keybindListenAction) return false;
    return true;
}

function performGamepadQuickRestart() {
    if (!canUseGamepadQuickRestart()) return;
    resetQuickRestartTapState();
    gamePaused = false;
    hideEl(pauseScreen);
    clearResumeCountdown();
    leavePauseMenuCursorMode();
    gameOverMessage = "";
    if ((adminSpeedrunPlaytestActive || practicePlayActive) && gameMode === "speedrun") {
        respawnAdminSpeedrunPlaytest();
        updateMobilePlayChrome();
        return;
    }
    if (adminPenaltyPlaytestActive && gameMode === "penalty" && adminPenaltyPlaytestSnapshot) {
        restartAdminPenaltyPlaytestFromSnapshot();
        updateMobilePlayChrome();
        return;
    }
    restartCurrentGameMode();
    tryRequestGamePointerLock();
    updateMobilePlayChrome();
}

function refreshGamepadSettingsVisibility() {
    const on = isGamepadConnected();
    const acc = document.getElementById("settingsGamepadAccordion");
    const nav = document.getElementById("settingsGamepadNavBtn");
    if (acc) acc.classList.toggle("hidden", !on);
    if (nav) nav.classList.toggle("hidden", !on);
    const status = document.getElementById("gamepadStatusText");
    if (status) {
        status.textContent = on ? `Connected: ${getGamepadDisplayName()}` : "No controller connected";
    }
}

function fillGamepadButtonSelect(selectEl, selected) {
    if (!selectEl) return;
    const opts = [
        GP_BTN.A,
        GP_BTN.B,
        GP_BTN.X,
        GP_BTN.Y,
        GP_BTN.LB,
        GP_BTN.RB,
        GP_BTN.LT,
        GP_BTN.RT,
        GP_BTN.SELECT,
        GP_BTN.START,
    ];
    selectEl.innerHTML = "";
    for (const idx of opts) {
        const o = document.createElement("option");
        o.value = String(idx);
        o.textContent = formatGamepadButtonLabel(idx);
        if (idx === selected) o.selected = true;
        selectEl.appendChild(o);
    }
}

function syncGamepadClickSourceUi() {
    const src = getGamepadClickSource();
    document.querySelectorAll("#gamepadClickSourceRow [data-gp-click]").forEach((btn) => {
        const on = btn.getAttribute("data-gp-click") === src;
        btn.classList.toggle("settingsSegBtn--active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
}

function refreshGamepadSettingsUI() {
    refreshGamepadSettingsVisibility();
    const sens = document.getElementById("gamepadSensitivity");
    const sensVal = document.getElementById("gamepadSensitivityVal");
    const dead = document.getElementById("gamepadDeadzone");
    const deadVal = document.getElementById("gamepadDeadzoneVal");
    const s = getGamepadSensitivity();
    const d = getGamepadDeadzonePercent();
    if (sens) sens.value = String(s);
    if (sensVal) setSettingsSliderValDisplay(sensVal, String(s));
    if (dead) dead.value = String(d);
    if (deadVal) setSettingsSliderValDisplay(deadVal, `${d}%`);
    syncGamepadClickSourceUi();
    fillGamepadButtonSelect(document.getElementById("gamepadPauseBtnSelect"), getGamepadPauseBtn());
    fillGamepadButtonSelect(document.getElementById("gamepadMenuReturnBtnSelect"), getGamepadMenuReturnBtn());
    fillGamepadButtonSelect(document.getElementById("gamepadMenuBtnSelect"), getGamepadMenuBtn());
    fillGamepadButtonSelect(document.getElementById("gamepadReturnBtnSelect"), getGamepadReturnBtn());
    fillGamepadButtonSelect(document.getElementById("gamepadRestartBtnSelect"), getGamepadRestartBtn());
}

function isGamepadGameplayActive() {
    return (
        !!playing &&
        !gamePaused &&
        !deathPending &&
        !resumeCountdownActive &&
        !isPlayTransitionRunning() &&
        !uiCursorMode &&
        gameMode !== "tilt"
    );
}

function isGamepadMenuNavActive() {
    if (!isGamepadConnected()) return false;
    if (isGamepadGameplayActive()) return false;
    return true;
}

function setupGamepadControls() {
    mountGamepadInput({
        moveCursor: (dx, dy) => applyPointerDelta(dx, dy, false),
        moveWasd: (nx, ny, dt) => applyGamepadWasdInput(nx, ny, dt),
        aimHookStick: (nx, ny, dead) => pointHookAimFromStick(nx, ny, dead),
        pause: () => togglePause(),
        toggleMenu: () => {
            if (canShowSidebar()) toggleSidebarMenu();
        },
        returnDown: () => {
            if (!beginReturnHold(false)) handleGlobalReturnAction();
        },
        returnUp: () => endReturnHold(),
        quickRestartHoldComplete: () => performGamepadQuickRestart(),
        primaryConfirm: () => handleGamepadPrimaryConfirm(),
        superdotSlow: () => tryActivateSuperdotSlow(),
        superdotBarrier: () => tryActivateSuperdotBarrier(),
        superdotShield: () => tryActivateSuperdotShield(),
        superdotPush: () => tryActivateSuperdotPush(),
        isPlayingGameplay: () => isGamepadGameplayActive(),
        isMenuNavActive: () => isGamepadMenuNavActive(),
        getGameMode: () => gameMode,
        onConnectionChange: () => {
            refreshGamepadSettingsVisibility();
            refreshGamepadSettingsUI();
            refreshSuperHudKbdHints();
            updateMobilePlayChrome();
            if (!isGamepadConnected()) endGamepadMenuNavSession();
            else clearGamepadMenuFocus();
        },
        showToast: (msg) => showSettingsActionToast(msg),
        pollMenuNav: (frame) => {
            if (isGamepadMenuNavActive()) pollGamepadMenuNav(frame);
            else endGamepadMenuNavSession();
        },
    });

    const sens = document.getElementById("gamepadSensitivity");
    const sensVal = document.getElementById("gamepadSensitivityVal");
    const sensDef = document.getElementById("gamepadSensitivityDefault");
    const dead = document.getElementById("gamepadDeadzone");
    const deadVal = document.getElementById("gamepadDeadzoneVal");
    const deadDef = document.getElementById("gamepadDeadzoneDefault");

    const saveSens = (v) => {
        const n = setGamepadSensitivity(Number(v));
        if (sens) sens.value = String(n);
        if (sensVal) setSettingsSliderValDisplay(sensVal, String(n));
        pushSettingsUndoDebounced();
    };
    const saveDead = (v) => {
        const n = setGamepadDeadzonePercent(Number(v));
        if (dead) dead.value = String(n);
        if (deadVal) setSettingsSliderValDisplay(deadVal, `${n}%`);
        pushSettingsUndoDebounced();
    };

    if (sensDef) sensDef.onclick = () => saveSens(GP_SENSITIVITY_DEFAULT);
    if (deadDef) deadDef.onclick = () => saveDead(GP_DEADZONE_DEFAULT);
    if (sens) sens.addEventListener("input", () => saveSens(sens.value));
    if (dead) dead.addEventListener("input", () => saveDead(dead.value));
    if (sens && sensVal) bindSettingsSliderValueInput(sens, sensVal, saveSens);
    if (dead && deadVal) bindSettingsSliderValueInput(dead, deadVal, (v) => saveDead(v));

    document.querySelectorAll("#gamepadClickSourceRow [data-gp-click]").forEach((btn) => {
        btn.addEventListener("click", () => {
            const v = btn.getAttribute("data-gp-click");
            if (v === "rt" || v === "a" || v === "both") {
                setGamepadClickSource(/** @type {GamepadClickSource} */ (v));
                syncGamepadClickSourceUi();
                pushSettingsUndoCurrent();
            }
        });
    });

    const bindSelect = (id, getter, setter) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.addEventListener("change", () => {
            setter(Number(el.value));
            fillGamepadButtonSelect(el, getter());
            pushSettingsUndoCurrent();
        });
    };
    bindSelect("gamepadPauseBtnSelect", getGamepadPauseBtn, setGamepadPauseBtn);
    bindSelect("gamepadMenuReturnBtnSelect", getGamepadMenuReturnBtn, setGamepadMenuReturnBtn);
    bindSelect("gamepadMenuBtnSelect", getGamepadMenuBtn, setGamepadMenuBtn);
    bindSelect("gamepadReturnBtnSelect", getGamepadReturnBtn, setGamepadReturnBtn);
    bindSelect("gamepadRestartBtnSelect", getGamepadRestartBtn, setGamepadRestartBtn);

    refreshGamepadSettingsUI();
}

function pollGamepadInFrame(dt) {
    if (typeof navigator.getGamepads !== "function") return;
    pollGamepadInput(dt);
}

function applyMobileJoystickInput(dt) {
    if (!isTouchGameUi() || !playing || deathPending || isGameplayInputFrozen()) return;
    if (gameMode === "tilt") return;
    if (!shouldShowTouchDpadForCurrentMode()) return;
    let nx = 0;
    let ny = 0;
    if (dpadHold.left) nx -= 1;
    if (dpadHold.right) nx += 1;
    if (dpadHold.up) ny -= 1;
    if (dpadHold.down) ny += 1;
    if (nx === 0 && ny === 0) return;
    const len = Math.hypot(nx, ny);
    const ux = nx / len;
    const uy = ny / len;

    const sp = 440 * dt;
    const dx = ux * sp;
    const dy = uy * sp;

    if (gameMode === "wasd") {
        if (!isSandboxRunActive() || sandboxWasdMovementActive()) {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
            return;
        }
    }

    // Sandbox WASD Movement on any launched base mode → D-Pad steers like WASD.
    if (sandboxWasdMovementActive() && gameMode !== "sandbox") {
        if (gameMode === "highway") {
            mouse.x += dx;
            mouse.y -= dy;
        } else if (gameMode === "speedrun") {
            accumulateSpeedrunPointerIntent(dx, dy);
        } else {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        }
        return;
    }

    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpWasdMode()) {
        const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
        mouse.x = c.x;
        mouse.y = c.y;
        return;
    }

    if (gameMode === "multiplayer" && isMpHighwayPlaying()) {
        applyMpHighwayPointerDelta(dx, dy);
        return;
    }

    if (gameMode === "roulette") {
        if (roulette.controlMode === "wasd") {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
            roulette.pointerTarget.x = mouse.x;
            roulette.pointerTarget.y = mouse.y;
        } else if (roulette.controlMode === "mouse") {
            const pt = clampCursorXYToEdgeInset(roulette.pointerTarget.x + dx, roulette.pointerTarget.y + dy);
            roulette.pointerTarget.x = pt.x;
            roulette.pointerTarget.y = pt.y;
            if (roulettePointerFollowInstant()) {
                mouse.x = pt.x;
                mouse.y = pt.y;
            }
        }
        return;
    }

    if (gameMode === "sandbox") {
        const cfg = sandboxRuntimeConfig || sandboxConfig;
        const clampFn = cfg && cfg.speedrunMode ? clampCursorXYToCanvas : clampCursorXYToEdgeInset;
        if (cfg && cfg.wasdEnabled) {
            const c = clampFn(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        } else {
            const st = clampFn(sandboxPointerTarget.x + dx, sandboxPointerTarget.y + dy);
            sandboxPointerTarget.x = st.x;
            sandboxPointerTarget.y = st.y;
            mouse.x = st.x;
            mouse.y = st.y;
        }
        return;
    }

    if (gameMode === "normal" || gameMode === "mirror" || gameMode === "delay" || gameMode === "snake" || gameMode === "combo" || gameMode === "superdot" || gameMode === "progression" || gameMode === "speedrun" || gameMode === "highway" || gameMode === "darkness" || gameMode === "colorrush" || gameMode === "heat" || gameMode === "hunter" || gameMode === "pop" || gameMode === "counter" || gameMode === "aim" || gameMode === "hook") {
        if (gameMode === "highway") {
            mouse.x += dx;
            mouse.y -= dy;
        } else if (gameMode === "speedrun") {
            accumulateSpeedrunPointerIntent(dx, dy);
        } else {
            const c = clampCursorXYToEdgeInset(mouse.x + dx, mouse.y + dy);
            mouse.x = c.x;
            mouse.y = c.y;
        }
    }
}

/** Per-pointer tap vs drag tracking (supports steer + tap with two fingers). */
const aimTouchPointers = new Map();
/** Per-pointer move / tap tracking for Hook mobile (steer + second-finger fire). */
const hookTouchPointers = new Map();

function resetGameTouchSteerState() {
    activeGameTouchPointers.clear();
    touchFingers.clear();
    orphanTouchPointerIds.length = 0;
    touchPointerAlias.clear();
    primaryTouchPointerId = -1;
    touchSteerPointerId = -1;
    touchSteerSession = null;
    touchSteerLiveClient = null;
    clearSoloSlideSteerSessions();
    resetRelativePointerAnchor();
}

function resetHookTouchPointers() {
    hookTouchPointers.clear();
    resetGameTouchSteerState();
}

function hookTapWantsEvent(e) {
    if (gameMode !== "hook") return false;
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isHookInputBlocked()) return false;
    if (!mobileTouchInputActive()) return false;
    if (e.pointerType !== "touch" && e.pointerType !== "pen") return false;
    return true;
}

function resetAimTouchPointers() {
    aimTouchPointers.clear();
    resetGameTouchSteerState();
}

function aimTouchTapWantsEvent(e) {
    if (gameMode !== "aim") return false;
    if (!playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isAimInputBlocked(getGameSimNowMs())) return false;
    if (!mobileTouchInputActive()) return false;
    if (e.pointerType !== "touch" && e.pointerType !== "pen") return false;
    return true;
}

function bindTouchSteerSurface(el) {
    if (!(el instanceof EventTarget)) return;
    const node = el;
    if (node.dataset?.touchSteerSurfaceBound === "1") return;
    node.dataset.touchSteerSurfaceBound = "1";
    node.addEventListener(
        "touchstart",
        e => {
            if (ingestTouchStart(e) && e.cancelable) e.preventDefault();
        },
        { passive: false },
    );
    node.addEventListener(
        "touchmove",
        e => {
            if (ingestTouchMove(e) && e.cancelable) {
                e.preventDefault();
                return;
            }
            if (touchSteerPlayConditionsMet() && !isGameplayInputFrozen() && e.cancelable) {
                e.preventDefault();
            }
        },
        { passive: false },
    );
    node.addEventListener("touchend", ingestTouchEnd, { passive: true });
    node.addEventListener("touchcancel", ingestTouchEnd, { passive: true });
}

/** Capture-phase touch binding — iOS installed PWA often skips window-level touchmove. */
function bindTouchSteerSurfaceCapture(el) {
    if (!(el instanceof EventTarget)) return;
    const node = el;
    if (node.dataset?.touchSteerSurfaceCaptureBound === "1") return;
    node.dataset.touchSteerSurfaceCaptureBound = "1";
    const onTouchStart = e => {
        if (ingestTouchStart(e) && e.cancelable) e.preventDefault();
    };
    const onTouchMove = e => {
        if (ingestTouchMove(e) && e.cancelable) {
            e.preventDefault();
            return;
        }
        if (touchSteerPlayConditionsMet() && !isGameplayInputFrozen() && e.cancelable) {
            e.preventDefault();
        }
    };
    node.addEventListener("touchstart", onTouchStart, { passive: false, capture: true });
    node.addEventListener("touchmove", onTouchMove, { passive: false, capture: true });
    node.addEventListener("touchend", ingestTouchEnd, { passive: true, capture: true });
    node.addEventListener("touchcancel", ingestTouchEnd, { passive: true, capture: true });
}

/**
 * Touch tablets: legacy document-level pointer steer — superseded by wireSoloSlideSteerSurface
 * (LOCAL per-pointer session model). Kept as no-op so call sites stay stable.
 */
function setupTouchTabletPointerSteer() {
    /* solo slide steer uses wireSoloSlideSteerSurface on pad/canvas */
}

function setupTouchPlaySteerPad() {
    if (!touchPlaySteerPad) return;

    wireSoloSlideSteerSurface(touchPlaySteerPad);

    touchPlaySteerPad.addEventListener(
        "pointerdown",
        e => {
            if (!isFingerSteerPointer(e)) return;
            if (!settingTouchCursorJoystick) return;
            if (!touchPointerMayMoveCursor(e.pointerId)) return;
            try {
                touchPlaySteerPad.setPointerCapture(e.pointerId);
            } catch {
                /* ignore */
            }
            if (e.cancelable) e.preventDefault();
        },
        { passive: false, capture: true },
    );
}

function setupMobileControls() {
    setupDpadTouchControls(touchSteerLayer, {
        isPlaying: () =>
            dpadPositionCustomizeMode ||
            (playing && !gamePaused && !deathPending && !isGameplayInputFrozen()),
        isTouchUi: () => isTouchGameUi() || dpadPositionCustomizeMode,
    });

    orbitSteerLayer?.querySelectorAll(".orbit-steer-zone").forEach((zone) => {
        zone.addEventListener(
            "pointerdown",
            (e) => {
                if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
                if (gameMode !== "orbit") return;
                if (!orbitSteerLayer || orbitSteerLayer.classList.contains("hidden")) return;
                if (!orbitSteerLayer.classList.contains("orbit-steer--touch-zones")) return;
                if (e.pointerType === "mouse" && e.button !== 0) return;
                e.preventDefault();
                e.stopPropagation();
                beginOrbitZonePointer(zone, e);
            },
            { passive: false, capture: true },
        );
        zone.addEventListener(
            "pointermove",
            (e) => {
                const st = orbitZonePointers.get(e.pointerId);
                if (!st || st.zone !== zone || gameMode !== "orbit") return;
                // Higher threshold: iPad finger jitter was flipping holds into "slide" and dropping input.
                const moved = Math.hypot(e.clientX - st.startX, e.clientY - st.startY);
                if (!st.sliding && moved >= 28) {
                    st.sliding = true;
                    syncOrbitHoldFromZones();
                }
                if (st.sliding) {
                    const dx = e.clientX - st.lastX;
                    st.lastX = e.clientX;
                    if (dx !== 0) {
                        feedOrbitSlideDelta(dx, gameLayoutScale());
                    }
                }
            },
            { passive: true },
        );
        zone.addEventListener(
            "pointerup",
            (e) => {
                endOrbitZonePointer(e.pointerId);
            },
            true,
        );
        zone.addEventListener(
            "pointercancel",
            (e) => {
                endOrbitZonePointer(e.pointerId);
            },
            true,
        );
        zone.addEventListener("lostpointercapture", (e) => {
            handleOrbitZoneLostCapture(e);
        });
    });

    // Safety net: zone up/cancel can be missed on rapid taps; always clear by pointerId.
    window.addEventListener(
        "pointerup",
        (e) => {
            if (orbitZonePointers.has(e.pointerId)) endOrbitZonePointer(e.pointerId);
        },
        true,
    );
    window.addEventListener(
        "pointercancel",
        (e) => {
            if (orbitZonePointers.has(e.pointerId)) endOrbitZonePointer(e.pointerId);
        },
        true,
    );
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") clearAllOrbitZonePointers();
    });

    window.addEventListener("blur", () => {
        clearAllOrbitZonePointers();
        orbitSteerLayer?.classList.remove("orbit-steer-hint-play");
    });

    window.addEventListener(
        "pointerdown",
        e => {
            if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
            if (!isFingerSteerPointer(e)) return;
            armPointerSteerDown(e);
        },
        true,
    );

    setupTouchPlaySteerPad();
    if (canvas) wireSoloSlideSteerSurface(canvas);
    if (canvasCursorTop) wireSoloSlideSteerSurface(canvasCursorTop);

    addEventListener(
        "pointermove",
        e => {
            if (document.pointerLockElement === canvas) {
                if (!deathPending && playing && !gamePaused && !resumeCountdownActive) {
                    forEachCoalescedPointerMove(e, ev => {
                        syncPointerFromMovement(ev.movementX, ev.movementY);
                    });
                }
                return;
            }

            const touchPtr = isFingerSteerPointer(e);
            if (touchPtr && (touchGameplaySteerEnabled() || touchCursorAnalog.active)) {
                if (!playing || deathPending) return;
                if (isGameplayInputFrozen()) {
                    if (canvasTouchSteerCaptureId === e.pointerId) releaseCanvasTouchSteerCapture();
                    if (touchCursorAnalog.active && e.pointerId === touchCursorAnalog.pointerId) endTouchCursorAnalogAny();
                    return;
                }
                if (shouldShowTouchDpadForCurrentMode()) {
                    if (canvasTouchSteerCaptureId === e.pointerId) releaseCanvasTouchSteerCapture();
                    return;
                }
                if (settingTouchCursorJoystick) {
                    if (touchCursorAnalog.active && e.pointerId === touchCursorAnalog.pointerId) {
                        touchCursorAnalog.curX = e.clientX;
                        touchCursorAnalog.curY = e.clientY;
                        if (settingTouchCursorJoystickVisible) updateTouchFloatJoystickVisual();
                    }
                    return;
                }
            if ((gameMode === "aim" || gameMode === "hook") && !touchPointerMayMoveCursor(e.pointerId)) {
                return;
            }
            if (
                canvasTouchSteerCaptureId >= 0 &&
                !sameTouchPointer(canvasTouchSteerCaptureId, e.pointerId)
            ) {
                return;
            }
                if (touchCursorAnalog.active && touchCursorAnalog.pointerId !== e.pointerId) return;
                if (!touchPointerMayMoveCursor(e.pointerId)) return;
                if (!isFingerSteerPointer(e) && e.pointerType === "mouse" && e.buttons === 0) return;
                dispatchTouchSteerMove(e);
                return;
            }

            if (deathPending || !playing) return;
            syncPointerFromClient(e.clientX, e.clientY, e.pointerId);
        },
        { passive: false },
    );

    canvas.addEventListener(
        "pointerdown",
        e => {
            if (trySoccerSkipReplay()) {
                e.preventDefault();
                return;
            }
            beginCanvasTouchSteer(e);
        },
        { passive: false },
    );

    canvas.addEventListener(
        "pointermove",
        e => {
            if (!playing || deathPending) return;
            if (isGameplayInputFrozen()) return;
            if (shouldShowTouchDpadForCurrentMode()) return;
            if (settingTouchCursorJoystick) return;
            if (!isFingerSteerPointer(e)) return;
            if (!touchGameplaySteerEnabled()) return;
            if (gameMode === "aim" || gameMode === "hook") {
                if (!touchPointerMayMoveCursor(e.pointerId)) return;
            } else if (
                canvasTouchSteerCaptureId >= 0 &&
                !sameTouchPointer(canvasTouchSteerCaptureId, e.pointerId)
            ) {
                return;
            }
            dispatchTouchSteerMove(e);
        },
        { passive: true },
    );

    window.addEventListener(
        "pointerdown",
        e => {
            if (e.target === canvas) return;
            beginCanvasTouchSteer(e);
        },
        { passive: true, capture: true },
    );

    const endCanvasTouchSteer = e => {
        if (touchCursorAnalog.active && e.pointerId === touchCursorAnalog.pointerId) {
            endTouchCursorAnalogAny();
            return;
        }
        if (canvasTouchSteerCaptureId === e.pointerId) {
            noteGameTouchUp(e.pointerId);
            releaseCanvasTouchSteerCapture();
            return;
        }
        if (activeGameTouchPointers.has(e.pointerId)) noteGameTouchUp(e.pointerId);
    };
    canvas.addEventListener("pointerup", endCanvasTouchSteer);
    canvas.addEventListener("pointercancel", endCanvasTouchSteer);
    canvas.addEventListener("lostpointercapture", e => {
        if (touchCursorAnalog.active && e.pointerId === touchCursorAnalog.pointerId) {
            endTouchCursorAnalogAny();
            return;
        }
        if (canvasTouchSteerCaptureId === e.pointerId) {
            canvasTouchSteerCaptureId = -1;
            if (!activeGameTouchPointers.has(e.pointerId)) {
                releaseTouchSteer(e.pointerId);
            }
        }
    });

    const onTouchStart = e => {
        if (ingestTouchStart(e) && e.cancelable) e.preventDefault();
    };
    const onTouchMove = e => {
        if (ingestTouchMove(e) && e.cancelable) {
            e.preventDefault();
            return;
        }
        if (touchSteerPlayConditionsMet() && !isGameplayInputFrozen() && e.cancelable) {
            e.preventDefault();
        }
    };

    if (isPwaStandalone()) {
        // Standalone: window capture often misses touchmove — bind the pad only (single ingest path).
        bindTouchSteerSurfaceCapture(touchPlaySteerPad);
    } else {
        window.addEventListener("touchstart", onTouchStart, { passive: false, capture: true });
        window.addEventListener("touchmove", onTouchMove, { passive: false, capture: true });
        window.addEventListener("touchend", ingestTouchEnd, { passive: true, capture: true });
        window.addEventListener("touchcancel", ingestTouchEnd, { passive: true, capture: true });
    }

    setupTouchTabletPointerSteer();

    window.addEventListener(
        "pointerup",
        e => {
            if (!isFingerSteerPointer(e)) return;
            if (canvasTouchSteerCaptureId === e.pointerId) {
                noteGameTouchUp(e.pointerId);
                releaseCanvasTouchSteerCapture();
                return;
            }
            if (activeGameTouchPointers.has(e.pointerId)) noteGameTouchUp(e.pointerId);
        },
        true,
    );

    const onWindowTouchAnalogDown = e => {
        if (!touchAnalogSteerWantsEvent(e)) return;
        if (touchCursorAnalog.active) return;
        if (targetBlocksTouchAnalogJoystick(e.target)) return;
        noteGameTouchDown(e.pointerId);
        if (isSecondaryTouchPointer(e.pointerId)) return;
        if (!claimTouchSteer(e.pointerId)) return;
        touchCursorAnalog.active = true;
        touchCursorAnalog.pointerId = e.pointerId;
        touchCursorAnalog.baseX = e.clientX;
        touchCursorAnalog.baseY = e.clientY;
        touchCursorAnalog.curX = e.clientX;
        touchCursorAnalog.curY = e.clientY;
        resetRelativePointerAnchor();
        if (settingTouchCursorJoystickVisible) {
            const wrap = document.getElementById("touchFloatJoystick");
            if (wrap) {
                wrap.classList.remove("hidden");
                updateTouchFloatJoystickVisual();
            }
        } else {
            hideTouchFloatJoystick();
        }
        try {
            canvas.setPointerCapture(e.pointerId);
            touchCursorAnalog.captureEl = canvas;
        } catch {
            touchCursorAnalog.captureEl = null;
        }
    };
    const onWindowTouchAnalogEnd = e => {
        if (!touchCursorAnalog.active || e.pointerId !== touchCursorAnalog.pointerId) return;
        endTouchCursorAnalogAny();
    };
    window.addEventListener("pointerdown", onWindowTouchAnalogDown, true);
    window.addEventListener("pointerup", onWindowTouchAnalogEnd, true);
    window.addEventListener("pointercancel", onWindowTouchAnalogEnd, true);

    const bindSuperdotSkillTouch = (btn, activate) => {
        if (!btn) return;
        const fire = e => {
            if (!isTouchGameUi()) return;
            if (e.pointerType === "mouse" && e.button !== 0) return;
            e.preventDefault();
            e.stopPropagation();
            activate();
        };
        btn.addEventListener("pointerdown", fire, { passive: false });
        btn.addEventListener("click", e => {
            if (!isTouchGameUi()) return;
            e.preventDefault();
            e.stopPropagation();
        });
    };
    bindSuperdotSkillTouch(superHudSlowBtn, tryActivateSuperdotSlow);
    bindSuperdotSkillTouch(superHudShieldBtn, tryActivateSuperdotShield);
    bindSuperdotSkillTouch(superHudBarrierBtn, tryActivateSuperdotBarrier);
    bindSuperdotSkillTouch(superHudPushBtn, tryActivateSuperdotPush);

    const onHookAimRmbDown = e => {
        if (gameMode !== "hook" || isTouchGameUi()) return;
        if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
        if (e.button !== 2) return;
        hookAimRmbHeld = true;
        e.preventDefault();
    };
    const onHookAimRmbUp = e => {
        if (e.button !== 2) return;
        hookAimRmbHeld = false;
    };
    window.addEventListener("pointerdown", onHookAimRmbDown, true);
    window.addEventListener("pointerup", onHookAimRmbUp, true);
    window.addEventListener("pointercancel", onHookAimRmbUp, true);

    const tryHookLmbFire = e => {
        if (gameMode !== "hook" || isTouchGameUi()) return;
        if (e.button !== 0) return;
        if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
        if (isHookInputBlocked()) return;
        handleHookLaunch();
    };
    const onHookLmbDown = e => {
        tryHookLmbFire(e);
    };
    window.addEventListener("pointerdown", onHookLmbDown, true);
    window.addEventListener("mousedown", onHookLmbDown, true);

    canvas.addEventListener(
        "pointerdown",
        e => {
            if (gameMode !== "aim" || isTouchGameUi()) return;
            if (e.button !== 0) return;
            if (!playing || deathPending || gamePaused || resumeCountdownActive) return;
            if (isAimInputBlocked(getGameSimNowMs())) return;
            handleAimFireAtCanvasXY(mouse.x, mouse.y);
        },
        { passive: true },
    );

    const onGameTouchPointerEnd = e => {
        if (!isFingerSteerPointer(e)) return;
        if (activeGameTouchPointers.has(e.pointerId)) noteGameTouchUp(e.pointerId);
    };
    window.addEventListener("pointerup", onGameTouchPointerEnd, true);
    window.addEventListener("pointercancel", onGameTouchPointerEnd, true);
}

let gameMode = null;

let speedrunActiveLevel = 1;
let speedrunStartPerf = 0;
let speedrunStaticSegsPx = [];
let speedrunWallSegDefs = [];
let speedrunMovingDefs = [];
let speedrunGoalPx = { x: 0, y: 0, half: 0 };
let speedrunLastNorm = { nx: 0.5, ny: 0.5 };
let speedrunPrevMouse = { x: 0, y: 0 };
let collisionPrevMouse = { x: 0, y: 0 };
/** Pointer deltas queued for official / MP speedrun — applied only in handleSpeedrunCollisions. */
let speedrunPointerIntentDx = 0;
let speedrunPointerIntentDy = 0;
/** Last `performance.now()/1000` used for laser collision; `null` after pause / level reload. */
let speedrunLaserCollideTPrev = null;
/** Moving solid wall: locked material param `u` on segment until midpoint drive reverses. */
let speedrunStickyRail = null;
/** Per-wall-index midpoint velocity sample — detect oscillation reversal for sticky release. */
let speedrunSolidMidVelPrev = [];
let speedrunPointsNorm = [];
let speedrunPointsCollected = new Set();
/** Wind zones for active SpeedRun layout (normalized). */
let speedrunWindDefs = [];
let speedrunTextDefs = [];
/** Linked portal pairs (normalized segments). */
let speedrunPortalsNorm = [];
/** When set, draw cursor clipped on entry/exit portal halves. */
let speedrunPortalCursorSplit = null;
/** Bridge points inserted into trail at portal mouth (entry line → exit line). */
let speedrunPortalTrailBridge = null;
/** After warp, ignore re-entry through exit portal until cursor clears the exterior (+n) side. */
let speedrunPortalExitLatch = null;
/** For wind impulse integration between collision frames. */
let speedrunWindPrevT = null;
/** Indices in `speedrunWallSegDefs` disabled when that point group is fully collected. */
let speedrunDisabledWallSegIndices = new Set();
/** Indices in `speedrunMovingDefs` with `toggleGroup` disabled the same way as static segments. */
let speedrunDisabledMovingIndices = new Set();
let speedrunCheckpointsNorm = [];
/** Indices of deltoid checkpoints already touched this run. */
let speedrunCheckpointsCollected = new Set();
/** Last touched checkpoint index; respawn uses this position. */
let speedrunLastCheckpointIndex = null;
/** Progress frozen at last checkpoint touch (points + activated checkpoints). */
let speedrunCheckpointProgressSnapshot = null;

const penaltyRuntime = createPenaltyRuntimeState();

function clearAdminSpeedrunPlaytestState() {
    adminSpeedrunPlaytestActive = false;
    adminSpeedrunPlaytestSnapshot = null;
    adminPlaytestHideMoveVis = false;
    adminPlaytestHideRotVis = false;
    clearSpeedrunPlaytestOverride();
}

function clearPracticePlayState() {
    practicePlayActive = false;
    practicePlayFromAdmin = false;
    practiceActiveDef = null;
    practiceGuideState = initialPracticeGuideState();
    practicePlayLevelIndex = 1;
    practiceGuideFrozenAtSec = -1;
    setPracticePlaytestOverride(null);
}

function clearAdminPenaltyPlaytestState() {
    adminPenaltyPlaytestActive = false;
    adminPenaltyPlaytestSnapshot = null;
    penaltyRuntime.adminPlaytestActive = false;
    adminPlaytestHideMoveVis = false;
    adminPlaytestHideRotVis = false;
    clearPenaltyPlaytestOverride();
}

let adminSpeedrunPlaytestActive = false;
let adminPlaytestHideMoveVis = false;
let adminPlaytestHideRotVis = false;
/** Last level and animation pause for admin playtest “Try again”. */
let adminSpeedrunPlaytestSnapshot = null;
let adminPenaltyPlaytestActive = false;
/** Last level def and animation pause for Penalty admin playtest “Try again”. */
let adminPenaltyPlaytestSnapshot = null;
/** Practice hub / Practice Creator play — no score, no best, optional guide. */
let practicePlayActive = false;
let practicePlayFromAdmin = false;
let practiceActiveDef = null;
let practiceGuideState = initialPracticeGuideState();
let practicePlayLevelIndex = 1;
/** Wall-clock sim time frozen while a guide tip is showing. */
let practiceGuideFrozenAtSec = -1;

function isPracticeGuideFrozen() {
    return !!(practicePlayActive && practiceGuideState && practiceGuideState.frozen);
}
let sandboxSpeedrunPrev = { x: 0, y: 0 };
/** Mounted admin SpeedRun editor in sandbox “Customize” screen. */
let sandboxSpeedrunEditorApi = null;
/** Mounted admin Golf editor in sandbox “Customize” screen. */
let sandboxPenaltyEditorApi = null;
let playing = false;
let score = 0;
let lastNormalSpawn = 0;
let lastHunterRedSpawn = 0;
let lastSnakeSpawn = 0;
let comboNextSpawnAt = 0;
let lastWASDSpawn = 0;
let lastDarknessSpawn = 0;
let lastSandboxSpawn = 0;
let obstacles = [];
let particles = [];
let trail = [];
/** Fixed particle stamps for equipped particle trail cosmetics (do not slide with cursor). */
let trailParticleStamps = [];
let trailParticlePrev = null;
let screenShake = 0;
let flashTimer = null;
let lastFrameTime = performance.now();
let lastFpsLimitedFrameAt = 0;
/** Menu idle: ~10fps paint (100ms). Gameplay path untouched. */
const MENU_IDLE_LOOP_MIN_MS = 100;
/** Gameplay constants assume ~60 Hz; scale per-frame rates with dt via frameScale(dt). */
const REFERENCE_HZ = SIM_REFERENCE_HZ;
/** Max simulation step (seconds); prevents lag spikes from huge position/timer jumps. */
const MAX_DT_SEC = MAX_FRAME_DT_SEC;
let lastMenuIdlePaintAt = 0;
let wasMenuIdleLoopThrottled = false;

function isMenuIdleLoopThrottled() {
    return !playing && !deathPending && !gamePaused && !isIdleShowcaseCursorActive();
}

/** Seed ~1 frame of dt so menu→gameplay does not spike (100ms gap) nor freeze (dt=0). */
function resetFrameClockLeavingMenuIdle(now = performance.now()) {
    wasMenuIdleLoopThrottled = false;
    lastMenuIdlePaintAt = 0;
    lastFpsLimitedFrameAt = 0;
    lastFrameTime = now - 1000 / REFERENCE_HZ;
}
const SCORE_PER_SEC = REFERENCE_HZ;

function frameScale(dt) {
    return dt * REFERENCE_HZ;
}

function decayFrameRate(rate, dt) {
    return Math.pow(rate, frameScale(dt));
}

function lerpFrameRate(lerpAt60, dt) {
    return 1 - Math.pow(1 - lerpAt60, frameScale(dt));
}

function decayScreenShake(dt) {
    screenShake *= decayFrameRate(0.88, dt);
    if (screenShake < 0.05) screenShake = 0;
}

function gameplayScoreFloor(s = score) {
    return Math.floor(s);
}

let lastPlayTimeUpdate = performance.now();
let lastStatsUiUpdate = 0;
let lastAchievementPollMs = 0;

let progressionLevel = 1;
let progressionSide = "left";

let shieldActive = false;
let slowActive = false;
let lastShieldUse = 0;
let lastSlowUse = 0;
let barrierActive = false;
let lastBarrierUse = 0;
let pushActive = false;
let lastPushUse = 0;
/** Push field radius (layout units); only balls inside this ring are repelled. */
const SUPERDOT_PUSH_RADIUS = 220;
const SUPERDOT_BARRIER_RADIUS = 44;

let deathPending = false;
let deathStart = 0;
let deathRunPersisted = false;
let deathRunWasNewRecord = false;
const DEATH_LOSE_ANIM_MS = 2000;
/** Challenge loss cinematic: frozen hazards + fade alpha for balls. */
let challengeDeathWorldFrozen = false;
let challengeDeathBallAlpha = 1;
/** @type {{ x: number, y: number, vx: number, vy: number, life: number, maxLife: number, size: number, color: string, rot: number, spin: number }[]} */
let challengeDeathAshes = [];
let challengeDeathAshSpawnAcc = 0;
/** @type {{ x: number, y: number, r: number, topX: number, topY: number, botX: number, botY: number, topRot: number, botRot: number, started: number } | null} */
let deathCursorBreak = null;
let frozenMouse = { x: 0, y: 0 };
let gameOverMessage = "";
let authGateDismissed = false;
let activeProfilePanel = "friends";
/** When true, public profile Back returns to Friends tab instead of search results. */
let publicProfileReturnToFriends = false;
let sidebarSyncScheduled = false;
let sidebarCollapsed = true;

const PROGRESSION_MAX_BALLS = 256;

const roulette = {
    effect: "",
    lastEffect: "",
    startedAt: 0,
    endsAt: 0,
    nextDisplay: 10,
    pulseUntil: 0,
    transitionPending: false,
    transitionDoneAt: 0,
    cursorScale: 1,
    targetCursorScale: 1,
    ballScale: 1,
    targetBallScale: 1,
    ballAlpha: 1,
    pointerTarget: { x: innerWidth / 2, y: innerHeight / 2 },
    mouseLerp: ROULETTE_MOUSE_LERP_DEFAULT,
    targetMouseLerp: ROULETTE_MOUSE_LERP_DEFAULT,
    flashVisibleUntil: 0,
    flashFadeEnd: 0,
    whiteOverrideUntil: 0,
    controlMode: "mouse",
    labelText: "",
    labelStart: 0,
    /** Next scheduled periodic ball wave (`performance.now()` ms). */
    nextPeriodicSpawnAt: 0
};

function setAccountBootstrapActive(on) {
    accountBootstrapActive = !!on;
    const overlay = document.getElementById("accountBootstrapOverlay");
    if (overlay) overlay.classList.toggle("hidden", !on);
    document.body.classList.toggle("account-bootstrap-active", !!on);
    if (!on) syncSidebarState();
}

function formatTimeoutRemainingMs(ms) {
    if (ms <= 0) return "0m";
    const totalMin = Math.ceil(ms / 60000);
    const days = Math.floor(totalMin / (60 * 24));
    const hours = Math.floor((totalMin % (60 * 24)) / 60);
    const mins = totalMin % 60;
    if (days > 0) return `${days}d ${hours}h ${mins}m`;
    if (hours > 0) return `${hours}h ${mins}m`;
    return `${mins}m`;
}

function updateTimeoutScreenText() {
    if (!timeoutRemainingLine || !timeoutAppliedLine) return;
    if (!cloudTimedOutUntil) {
        timeoutRemainingLine.textContent = "";
        timeoutAppliedLine.textContent = "";
        return;
    }
    const left = Date.parse(cloudTimedOutUntil) - Date.now();
    timeoutRemainingLine.textContent =
        left > 0
            ? `Time remaining: ${formatTimeoutRemainingMs(left)}`
            : "Timeout ended — log in again to restore access.";
    timeoutAppliedLine.textContent = cloudTimedOutAt
        ? `Timeout applied: ${new Date(cloudTimedOutAt).toLocaleString()}`
        : "";
}

function stopTimeoutTick() {
    if (timeoutTickTimer) {
        clearInterval(timeoutTickTimer);
        timeoutTickTimer = null;
    }
}

function startTimeoutTick() {
    stopTimeoutTick();
    timeoutTickTimer = window.setInterval(() => {
        updateTimeoutScreenText();
        if (cloudTimedOutUntil && Date.parse(cloudTimedOutUntil) <= Date.now()) {
            stopTimeoutTick();
            void refreshAuthStatus();
        }
    }, 1000);
}

function hideTimeoutScreen() {
    stopTimeoutTick();
    if (timeoutScreen) hideEl(timeoutScreen);
}

function showTimeoutScreen() {
    claimExclusiveUi(null);
    hideEl(startScreen);
    hideHubScreens();
    hideEl(authScreen);
    hideEl(returnBtn);
    if (timeoutScreen) showEl(timeoutScreen);
    updateTimeoutScreenText();
    startTimeoutTick();
    scheduleSidebarSync();
    updateMusicState();
}

function canShowSidebar() {
    if (cloudTimedOut) return false;
    if (timeoutScreen && !timeoutScreen.classList.contains("hidden")) return false;
    if (accountBootstrapActive) return false;
    const isGameOverVisible = !gameOverScreen.classList.contains("hidden");
    const isAuthVisible = !authScreen.classList.contains("hidden");
    const adminPanel = document.getElementById("adminPanelScreen");
    const inAdminPanel = adminPanel && !adminPanel.classList.contains("hidden");
    const inSpeedrunPicker = speedrunLevelScreen && !speedrunLevelScreen.classList.contains("hidden");
    const inSpeedrunComplete = speedrunCompleteScreen && !speedrunCompleteScreen.classList.contains("hidden");
    const inPenaltyPicker = penaltyLevelScreen && !penaltyLevelScreen.classList.contains("hidden");
    const inPenaltyComplete = penaltyCompleteScreen && !penaltyCompleteScreen.classList.contains("hidden");
    const inRouletteWarn = rouletteWarnScreen && !rouletteWarnScreen.classList.contains("hidden");
    const sandboxWinEl = document.getElementById("sandboxSpeedrunWinScreen");
    const inSandboxSpeedrunWin = sandboxWinEl && !sandboxWinEl.classList.contains("hidden");
    const sandboxPrevEl = document.getElementById("sandboxSpeedrunPreviewScreen");
    const inSandboxPreview = sandboxPrevEl && !sandboxPrevEl.classList.contains("hidden");
    const sandboxPenaltyPrevEl = document.getElementById("sandboxPenaltyPreviewScreen");
    const inSandboxPenaltyPreview = sandboxPenaltyPrevEl && !sandboxPenaltyPrevEl.classList.contains("hidden");
    return !playing &&
        !isGameOverVisible &&
        !isAuthVisible &&
        (
            !startScreen.classList.contains("hidden") ||
            !modeScreen.classList.contains("hidden") ||
            (gameHubScreen && !gameHubScreen.classList.contains("hidden")) ||
            (practiceScreen && !practiceScreen.classList.contains("hidden")) ||
            (challengesScreen && !challengesScreen.classList.contains("hidden")) ||
            (tournamentsScreen && !tournamentsScreen.classList.contains("hidden")) ||
            (marathonScreen && !marathonScreen.classList.contains("hidden")) ||
            (campaignScreen && !campaignScreen.classList.contains("hidden")) ||
            (document.getElementById("worldMapScreen") &&
                !document.getElementById("worldMapScreen")!.classList.contains("hidden")) ||
            !statsScreen.classList.contains("hidden") ||
            !settingsScreen.classList.contains("hidden") ||
            !sandboxScreen.classList.contains("hidden") ||
            (sandboxBaseScreen && !sandboxBaseScreen.classList.contains("hidden")) ||
            (sandboxCommunityScreen && !sandboxCommunityScreen.classList.contains("hidden")) ||
            !creditsScreen.classList.contains("hidden") ||
            !leaderboardScreen.classList.contains("hidden") ||
            (achievementsScreen && !achievementsScreen.classList.contains("hidden")) ||
            (tasksScreen && !tasksScreen.classList.contains("hidden")) ||
            (battlePassScreen && !battlePassScreen.classList.contains("hidden")) ||
            (shopScreen && !shopScreen.classList.contains("hidden")) ||
            (inventoryScreen && !inventoryScreen.classList.contains("hidden")) ||
            !profileScreen.classList.contains("hidden") ||
            (newsScreen && !newsScreen.classList.contains("hidden")) ||
            (notificationsScreen && !notificationsScreen.classList.contains("hidden")) ||
           (wallScreen && !wallScreen.classList.contains("hidden")) ||
            inAdminPanel ||
            inSpeedrunPicker ||
            inSpeedrunComplete ||
            inPenaltyPicker ||
            inPenaltyComplete ||
            inRouletteWarn ||
            inSandboxSpeedrunWin ||
            inSandboxPreview ||
            inSandboxPenaltyPreview
        );
}

function toggleSidebarMenu() {
    const opening = sidebarCollapsed;
    sidebarCollapsed = !sidebarCollapsed;
    setPlayHudSidebarCollapsed(sidebarCollapsed);
    syncSidebarState();
    playMenuSidebarChirp(opening);
}

function syncSidebarState() {
    const showSidebar = canShowSidebar();
    document.body.classList.toggle("show-sidebar", showSidebar);
    document.body.classList.toggle("sidebar-collapsed", sidebarCollapsed);
    if (sideNav) sideNav.classList.toggle("hidden", !showSidebar);
    if (sideNavToggle) {
        sideNavToggle.classList.toggle("hidden", !showSidebar);
        const touchUi = isTouchGameUi();
        const kbd = !touchUi && settingShowKeybindIndicator;
        const menuKey = formatKeybindDisplay(getKeybindKey("menu"));
        sideNavToggle.textContent = sidebarCollapsed
            ? (touchUi ? "MENU" : kbd ? `MENU [${menuKey}]` : "MENU")
            : (touchUi ? "CLOSE" : kbd ? `CLOSE [${menuKey}]` : "CLOSE");
        sideNavToggle.setAttribute(
            "aria-label",
            touchUi ? "Toggle menu" : kbd ? `Toggle sidebar (${menuKey})` : "Toggle menu",
        );
    }
    if (showSidebar) syncActiveSidebarFromVisibleScreen();
    syncPlayHudLayout();
    scheduleFpsOverlayPosition();
}

function scheduleSidebarSync() {
    if (sidebarSyncScheduled) return;
    sidebarSyncScheduled = true;
    requestAnimationFrame(() => {
        sidebarSyncScheduled = false;
        syncSidebarState();
        syncReturnBtnVisibility();
    });
}

let screenEnterMotionTimer = 0;

function screenMotionReducedMotion() {
    return typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Subtle UI settle when opening a menu screen (no flash). Off when Flashes is OFF. */
function playScreenEnterMotion(opts) {
    if (!settingEffectFlashes || screenMotionReducedMotion() || (opts && opts.instant)) return;
    document.body.classList.remove("screenEnterMotion");
    if (screenEnterMotionTimer) window.clearTimeout(screenEnterMotionTimer);
    void document.body.offsetWidth;
    document.body.classList.add("screenEnterMotion");
    screenEnterMotionTimer = window.setTimeout(() => {
        document.body.classList.remove("screenEnterMotion");
        screenEnterMotionTimer = 0;
    }, 520);
}

function showSettingsScreen() {
    if (!settingsScreen) return;
    claimExclusiveUi("settingsScreen");
    resetSettingsHistoryStacks();
    showEl(settingsScreen);
    playScreenEnterMotion();
    refreshKeybindSettingsUi();
    void refreshSettingsAccountUi();
    initSettingsSectionNav();
    scheduleSettingsCardWidthSync();
    requestAnimationFrame(() => {
        scheduleSettingsCardWidthSync();
        updateSettingsNavFromScroll();
    });
}

async function refreshSettingsAccountUi() {
    const guest = document.getElementById("settingsAccountGuest");
    const signed = document.getElementById("settingsAccountSignedIn");
    const pwdCard = document.getElementById("settingsChangePasswordCard");
    const userCard = document.getElementById("settingsChangeUsernameCard");
    const userHint = document.getElementById("settingsUsernameHint");
    const userToggle = document.getElementById("settingsChangeUsernameToggleBtn");
    void refreshPushSettingsUi();
    if (!guest || !signed) return;

    if (!cloudUser) {
        showEl(guest);
        hideEl(signed);
        return;
    }

    hideEl(guest);
    showEl(signed);

    let info = null;
    try {
        info = await fetchAccountSettings();
    } catch {
        info = null;
    }

    if (pwdCard) {
        if (info && !info.hasPasswordAccount) hideEl(pwdCard);
        else showEl(pwdCard);
    }

    if (userCard && userHint && userToggle) {
        if (info && !info.canChangeUsername) {
            userToggle.disabled = true;
            const when = info.usernameChangeAvailableAt
                ? new Date(info.usernameChangeAvailableAt).toLocaleDateString()
                : "";
            userHint.textContent = when
                ? `You can change your username again on ${when}.`
                : "You can change your username again in 30 days.";
        } else {
            userToggle.disabled = false;
            userHint.textContent = "You can change your username once every 30 days.";
        }
    }
}

/**
 * Hide settings. `instant` kept for call-site clarity (hide is always immediate). `after` runs after hide.
 */
function hideSettingsScreen(opts) {
    const after = opts && opts.after;
    if (!settingsScreen) {
        after?.();
        return;
    }
    if (settingsScreen.classList.contains("hidden")) {
        scheduleSidebarSync();
        after?.();
        return;
    }
    cancelKeybindListen();
    closeSettingsResetConfirm();
    hideEl(settingsScreen);
    after?.();
}

let cachedAchievementRows = null;

function renderAchievementsGrid(rows) {
    if (!achievementsGrid) return;
    const filt = achievementsFilterSelect ? achievementsFilterSelect.value : "all";
    const filtered =
        filt === "completed"
            ? rows.filter(r => r.done)
            : filt === "uncompleted"
              ? rows.filter(r => !r.done)
              : rows;
    achievementsGrid.replaceChildren();
    for (const row of filtered) {
        const card = document.createElement("div");
        card.className = "achievementCard" + (row.done ? " achievementCard--done" : "");
        card.setAttribute("role", "listitem");
        const title = document.createElement("div");
        title.className = "achievementCardTitle";
        title.textContent = row.title;
        card.appendChild(title);
        const descText = String(row.description || "").trim();
        if (descText) {
            const desc = document.createElement("div");
            desc.className = "achievementCardDesc";
            desc.textContent = descText;
            card.appendChild(desc);
        }
        if (row.showHowToComplete && row.criteriaSummary) {
            const goal = document.createElement("div");
            goal.className = "achievementCardGoal";
            goal.textContent = row.criteriaSummary;
            card.appendChild(goal);
        }
        achievementsGrid.appendChild(card);
    }
    if (achievementsCountLabel) {
        const total = rows.length;
        achievementsCountLabel.textContent = `${countCompletedAchievements(rows)}/${total}`;
    }
}

async function openShopScreenFromNav() {
    playShopCoinSound();
    if (!shopScreen || !shopDotsBalanceValue || !shopCosmeticsGrid || !shopStatusHint) return;
    claimExclusiveUi("shopScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(returnBtn);
    await openShopScreen({
        screen: shopScreen,
        balanceEl: shopDotsBalanceValue,
        gridEl: shopCosmeticsGrid,
        statusEl: shopStatusHint,
        isSignedIn: () => !!cloudUser,
        getCursorColor: () => settingCursorColor,
        onDotsChanged: () => {
            syncEquippedCosmeticFromState();
            schedulePushAccountData(true);
        },
    });
    scheduleSidebarSync();
    updateMusicState();
    playScreenEnterMotion();
    syncActiveSidebarFromVisibleScreen();
}

function closeShopScreenFromNav() {
    closeShopScreen();
    showEl(startScreen);
    showEl(returnBtn);
    scheduleSidebarSync();
    updateMusicState();
    playScreenEnterMotion();
}

async function openInventoryScreenFromNav() {
    if (
        !inventoryScreen ||
        !inventoryDotsBalanceValue ||
        !inventoryCosmeticsGrid ||
        !inventoryOutfitsPanel ||
        !inventoryIndexPanel ||
        !inventoryTabCosmeticsBtn ||
        !inventoryTabOutfitsBtn ||
        !inventoryTabIndexBtn ||
        !inventoryIndexFilter ||
        !inventoryStatusHint
    )
        return;
    claimExclusiveUi("inventoryScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(returnBtn);
    await openInventoryScreen({
        screen: inventoryScreen,
        balanceEl: inventoryDotsBalanceValue,
        gridEl: inventoryCosmeticsGrid,
        outfitsPanelEl: inventoryOutfitsPanel,
        indexPanelEl: inventoryIndexPanel,
        tabCosmeticsBtn: inventoryTabCosmeticsBtn as HTMLButtonElement,
        tabOutfitsBtn: inventoryTabOutfitsBtn as HTMLButtonElement,
        tabIndexBtn: inventoryTabIndexBtn as HTMLButtonElement,
        indexFilterEl: inventoryIndexFilter as HTMLSelectElement,
        statusEl: inventoryStatusHint,
        livePreviewCanvas:
            inventoryLivePreviewCanvas instanceof HTMLCanvasElement
                ? inventoryLivePreviewCanvas
                : null,
        bannerPreviewCanvas:
            inventoryBannerPreviewCanvas instanceof HTMLCanvasElement
                ? inventoryBannerPreviewCanvas
                : null,
        equippedListEl: inventoryEquippedList,
        isSignedIn: () => !!cloudUser,
        getCursorColor: () => settingCursorColor,
        getTrailColor: () => settingTrailColor,
        applyOutfitColors: ({ cursorColor, trailColor }) => {
            if (cursorColor) saveColorSetting("cursor", cursorColor);
            if (trailColor) saveColorSetting("trail", trailColor);
        },
        onEquippedChanged: () => {
            applyEquippedThemeCosmetics();
            afterPlayerSettingsApplied();
            if (hasPlayerThemeBalls()) {
                applyEquippedThemeCosmetics({ onlyChannels: { balls: true } });
            }
            void refreshShopCosmeticState().then(() => {
                syncEquippedCosmeticFromState();
                schedulePushAccountData(true);
            });
        },
    });
    scheduleSidebarSync();
    updateMusicState();
    playScreenEnterMotion();
    syncActiveSidebarFromVisibleScreen();
}

function closeInventoryScreenFromNav() {
    closeInventoryScreen();
    showEl(startScreen);
    showEl(returnBtn);
    scheduleSidebarSync();
    updateMusicState();
    playScreenEnterMotion();
}

async function openAchievementsScreen() {
    claimExclusiveUi("achievementsScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(achievementsScreen);
    updateMusicState();
    playScreenEnterMotion();
    if (achievementsLoadingHint) achievementsLoadingHint.classList.remove("hidden");
    try {
        cachedAchievementRows = await fetchAchievements();
        applyAchievementToastDiff(cachedAchievementRows);
        renderAchievementsGrid(cachedAchievementRows);
    } finally {
        if (achievementsLoadingHint) achievementsLoadingHint.classList.add("hidden");
    }
}

let tasksScreenApi = null;
function ensureTasksScreenMounted() {
    if (tasksScreenApi || !tasksScreenMount) return;
    tasksScreenApi = mountTasksScreen(tasksScreenMount, {
        isSignedIn: () => !!cloudUser,
        onClaimableChange: (count) => {
            syncTasksClaimBadge(sideTasksBtn, count);
            if (sideTasksClaimBadge) {
                sideTasksClaimBadge.classList.toggle("hidden", count <= 0);
                sideTasksClaimBadge.setAttribute("aria-hidden", count <= 0 ? "true" : "false");
            }
        },
        onNeedSignIn: () => {
            /* guest: message already shown in Tasks screen */
        },
    });
}

async function openTasksScreen() {
    claimExclusiveUi("tasksScreen");
    hideEl(startScreen);
    hideHubScreens();
    ensureTasksScreenMounted();
    showEl(tasksScreen);
    updateMusicState();
    playScreenEnterMotion();
    await tasksScreenApi?.refresh();
}

function closeTasksScreen() {
    hideEl(tasksScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

let battlePassScreenApi = null;
function ensureBattlePassScreenMounted() {
    if (battlePassScreenApi || !battlePassScreenMount) return;
    battlePassScreenApi = mountBattlePassScreen(battlePassScreenMount, {
        onClaimableChange: (count) => {
            syncBattlePassClaimBadge(sideBattlePassBtn, count);
            if (sideBattlePassClaimBadge) {
                sideBattlePassClaimBadge.classList.toggle("hidden", count <= 0);
                sideBattlePassClaimBadge.setAttribute("aria-hidden", count <= 0 ? "true" : "false");
            }
        },
    });
}

async function openBattlePassScreen() {
    claimExclusiveUi("battlePassScreen");
    hideEl(startScreen);
    hideHubScreens();
    ensureBattlePassScreenMounted();
    showEl(battlePassScreen);
    updateMusicState();
    playScreenEnterMotion();
    await battlePassScreenApi?.refresh();
}

function closeBattlePassScreen() {
    hideEl(battlePassScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

async function refreshBattlePassClaimIndicator() {
    if (!cloudUser) {
        syncBattlePassClaimBadge(sideBattlePassBtn, 0);
        if (sideBattlePassClaimBadge) {
            sideBattlePassClaimBadge.classList.add("hidden");
            sideBattlePassClaimBadge.setAttribute("aria-hidden", "true");
        }
        return;
    }
    try {
        const data = await fetchBattlePass();
        syncBattlePassClaimBadge(sideBattlePassBtn, data.claimableCount || 0);
        if (sideBattlePassClaimBadge) {
            const show = (data.claimableCount || 0) > 0;
            sideBattlePassClaimBadge.classList.toggle("hidden", !show);
            sideBattlePassClaimBadge.setAttribute("aria-hidden", show ? "false" : "true");
        }
    } catch {
        /* optional */
    }
}

async function refreshTasksClaimIndicator() {
    if (!cloudUser) {
        syncTasksClaimBadge(sideTasksBtn, 0);
        if (sideTasksClaimBadge) {
            sideTasksClaimBadge.classList.add("hidden");
            sideTasksClaimBadge.setAttribute("aria-hidden", "true");
        }
        return;
    }
    try {
        const data = await fetchTasks();
        syncTasksClaimBadge(sideTasksBtn, data.claimableCount || 0);
        if (sideTasksClaimBadge) {
            const show = (data.claimableCount || 0) > 0;
            sideTasksClaimBadge.classList.toggle("hidden", !show);
            sideTasksClaimBadge.setAttribute("aria-hidden", show ? "false" : "true");
        }
    } catch {
        /* optional */
    }
}

let taskRunStartedPerf = 0;
function markTaskRunStarted() {
    taskRunStartedPerf = performance.now();
}

async function reportTasksAfterRun(opts) {
    if (!cloudUser || !opts?.modeId) return;
    const timeSec =
        opts.timeSec != null
            ? Number(opts.timeSec) || 0
            : taskRunStartedPerf > 0
              ? Math.max(0, (performance.now() - taskRunStartedPerf) / 1000)
              : 0;
    try {
        const res = await reportTaskProgress({
            modeId: opts.modeId,
            score: Math.max(0, Math.floor(Number(opts.score) || 0)),
            timeSec,
            levelIndex: opts.levelIndex ?? null,
        });
        if (res.claimableCount != null) {
            syncTasksClaimBadge(sideTasksBtn, res.claimableCount);
            if (sideTasksClaimBadge) {
                const show = res.claimableCount > 0;
                sideTasksClaimBadge.classList.toggle("hidden", !show);
                sideTasksClaimBadge.setAttribute("aria-hidden", show ? "false" : "true");
            }
        }
    } catch {
        /* optional */
    }
    void reportBattlePassAfterRun(opts);
}

async function reportBattlePassAfterRun(opts) {
    if (!cloudUser || !opts?.modeId) return;
    try {
        const res = await reportBattlePassRun({
            modeId: opts.modeId,
            outcome: opts.outcome === "win" ? "win" : "play",
            score: Math.max(0, Math.floor(Number(opts.score) || 0)),
            isNewRecord: !!opts.isNewRecord,
        });
        if (res.battlePass) notifyBattlePassXp(res.battlePass);
        if (res.claimableCount != null) {
            syncBattlePassClaimBadge(sideBattlePassBtn, res.claimableCount);
            if (sideBattlePassClaimBadge) {
                const show = res.claimableCount > 0;
                sideBattlePassClaimBadge.classList.toggle("hidden", !show);
                sideBattlePassClaimBadge.setAttribute("aria-hidden", show ? "false" : "true");
            }
        }
        if (battlePassScreen && !battlePassScreen.classList.contains("hidden")) {
            await battlePassScreenApi?.refresh();
        }
    } catch {
        /* optional */
    }
}

function closeAchievementsScreen() {
    hideEl(achievementsScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function showEl(el) {
    if (el) el.classList.remove("hidden");
    if (el === startScreen) refreshHomeSplash();
    scheduleSidebarSync();
    syncIdleShowcaseCursorVisibility();
    refreshGameThemePresentation();
}
function hideEl(el) {
    if (el) el.classList.add("hidden");
    scheduleSidebarSync();
    syncIdleShowcaseCursorVisibility();
    refreshGameThemePresentation();
}

/** One exclusive menu/panel at a time — see `exclusive-ui.ts`. */
configureExclusiveUi({
    hideElement: (el) => hideEl(el),
    closeHandlers: {
        settingsScreen: () => hideSettingsScreen({ instant: true }),
        shopScreen: () => closeShopScreen(),
        inventoryScreen: () => closeInventoryScreen(),
        wallScreen: () => {
            closeWallScreen();
            hideEl(wallScreen);
        },
    },
});

function syncIdleShowcaseCursorVisibility() {
    const pauseOn = pauseScreen && !pauseScreen.classList.contains("hidden");
    const goOn = gameOverScreen && !gameOverScreen.classList.contains("hidden");
    if (pauseOn || goOn) {
        if (!isIdleShowcaseCursorActive()) {
            startIdleShowcaseCursor(() => settingCursorColor);
        }
    } else {
        stopIdleShowcaseCursor();
    }
}

function setProfilePanel(panel) {
    let next = panel;
    if (next === "account" || next === "social" || next === "profile") next = "friends";
    activeProfilePanel = next;
    if (chatAutoRefreshTimer) { chatAutoRefreshTimer.stop(); chatAutoRefreshTimer = null; }
    if (friendsAutoRefreshTimer) { friendsAutoRefreshTimer.stop(); friendsAutoRefreshTimer = null; }
    const showMessages = next === "messages";
    const showFriends = next === "friends";
    const showSearch = next === "find-player";
    const showSocialChrome = !showMessages;
    if (profileAccountBlock) profileAccountBlock.classList.toggle("hidden", !showSocialChrome);
    if (profileSocialTabs) profileSocialTabs.classList.toggle("hidden", !showSocialChrome);
    if (profileFriendsBlock) profileFriendsBlock.classList.toggle("hidden", !showFriends);
    if (profileFindPlayerBlock) profileFindPlayerBlock.classList.toggle("hidden", !showSearch);
    if (profileMessagesBlock) profileMessagesBlock.classList.toggle("hidden", !showMessages);
    if (socialTabFriendsBtn) {
        socialTabFriendsBtn.classList.toggle("active", showFriends);
        socialTabFriendsBtn.setAttribute("aria-selected", showFriends ? "true" : "false");
    }
    if (socialTabSearchBtn) {
        socialTabSearchBtn.classList.toggle("active", showSearch);
        socialTabSearchBtn.setAttribute("aria-selected", showSearch ? "true" : "false");
    }
    if (profileScreen) {
        profileScreen.classList.toggle("screen--messagesFull", showMessages);
        profileScreen.classList.toggle("screen--social", showSocialChrome);
        profileScreen.classList.remove("screen--findPlayer");
    }
    const profileTitle = profileScreen ? profileScreen.querySelector("h1") : null;
    if (profileTitle) profileTitle.textContent = showMessages ? "MESSAGES" : "SOCIAL";
    if (showMessages) {
        chatAutoRefreshTimer = createVisibilityInterval(() => {
            if (activeProfilePanel === "messages") void loadMessageThread();
        }, MESSAGE_PANEL_POLL_MS, { runOnStart: true });
    }
    if (showFriends) {
        publicProfileReturnToFriends = false;
        void refreshFriendsUi();
        friendsAutoRefreshTimer = createVisibilityInterval(() => {
            if (activeProfilePanel === "friends") void refreshFriendsUi();
        }, 5000);
    }
    scheduleSidebarSync();
    void pushPresenceHeartbeat(true);
}

function updateSideNavActiveDot(btn: HTMLElement | null | undefined): void {
    const dot = document.getElementById("sideNavActiveDot");
    const sideNavEl = document.getElementById("sideNav");
    if (!dot || !sideNavEl) return;
    if (!btn) {
        dot.classList.remove("sideNavActiveDot--visible");
        return;
    }
    const navRect = sideNavEl.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    dot.style.top = `${btnRect.top - navRect.top + btnRect.height / 2}px`;
    dot.classList.add("sideNavActiveDot--visible");
}

function setActiveSidebarBtn(btn) {
    document.querySelectorAll(".sideNavBtn").forEach(b => b.classList.remove("active"));
    if (btn) btn.classList.add("active");
    updateSideNavActiveDot(btn ?? null);
}

function hideAdminPanelScreen() {
    const adm = document.getElementById("adminPanelScreen");
    if (adm) hideEl(adm);
    scheduleSidebarSync();
}

function getSidebarNavButtons() {
    if (!sideNav) return [];
    const excludeIds = new Set(["sideSignInBtn", "sideLogoutBtn", "sideSwitchAccountBtn", "sideAdminPanelBtn"]);
    const out = [];
    sideNav.querySelectorAll(".sideNavBtn").forEach((btn) => {
        if (!(btn instanceof HTMLButtonElement)) return;
        if (btn.classList.contains("hidden")) return;
        if (excludeIds.has(btn.id)) return;
        if (btn.closest("#sideNavAdminScroll")) return;
        out.push(btn);
    });
    return out;
}

function inferActiveSidebarBtn() {
    const adminPanel = document.getElementById("adminPanelScreen");
    if (adminPanel && !adminPanel.classList.contains("hidden")) return sideAdminPanelBtn;
    if (authScreen && !authScreen.classList.contains("hidden")) return sideSignInBtn;
    if (settingsScreen && !settingsScreen.classList.contains("hidden")) return sideSettingsBtn;
    if (leaderboardScreen && !leaderboardScreen.classList.contains("hidden")) return sideRankingsBtn;
    if (statsScreen && !statsScreen.classList.contains("hidden")) return sideStatsBtn;
    if (achievementsScreen && !achievementsScreen.classList.contains("hidden")) return sideAchievementsBtn;
    if (tasksScreen && !tasksScreen.classList.contains("hidden")) return sideTasksBtn;
    if (battlePassScreen && !battlePassScreen.classList.contains("hidden")) return sideBattlePassBtn;
    if (shopScreen && !shopScreen.classList.contains("hidden")) return sideShopBtn;
    if (inventoryScreen && !inventoryScreen.classList.contains("hidden")) return sideInventoryBtn;
    if (profileScreen && !profileScreen.classList.contains("hidden")) {
        return sideSocialBtn;
    }
    if (newsScreen && !newsScreen.classList.contains("hidden")) return sideNewsBtn;
    if (notificationsScreen && !notificationsScreen.classList.contains("hidden")) return sideNotificationsBtn;
    if (wallScreen && !wallScreen.classList.contains("hidden")) return sideWallBtn;
    if (creditsScreen && !creditsScreen.classList.contains("hidden")) return sideCreditsBtn;
    return sideHomeBtn;
}

function syncAdminSidebarNavMode(inAdmin) {
    const wasAdmin = document.body.classList.contains("admin-sidebar-nav");
    document.body.classList.toggle("admin-sidebar-nav", !!inAdmin);
    const adminScroll = document.getElementById("sideNavAdminScroll");
    const mainScroll = document.getElementById("sideNavMainScroll");
    if (adminScroll) {
        adminScroll.setAttribute("aria-hidden", inAdmin ? "false" : "true");
    }
    if (!inAdmin && wasAdmin && mainScroll) {
        mainScroll.classList.remove("sideNavScroll--enter");
        void mainScroll.offsetWidth;
        mainScroll.classList.add("sideNavScroll--enter");
        window.setTimeout(() => mainScroll.classList.remove("sideNavScroll--enter"), 260);
    }
}

function syncActiveSidebarFromVisibleScreen() {
    const adminPanel = document.getElementById("adminPanelScreen");
    const inAdmin = !!(adminPanel && !adminPanel.classList.contains("hidden"));
    syncAdminSidebarNavMode(inAdmin);
    if (inAdmin) {
        document.querySelectorAll(".sideNavBtn.active").forEach((b) => b.classList.remove("active"));
        const green = document.querySelector("#sideNavAdminScroll .sideNavBtn.green");
        if (green instanceof HTMLElement) {
            green.classList.add("active");
            updateSideNavActiveDot(green);
        } else {
            updateSideNavActiveDot(null);
        }
        return;
    }
    const btn = inferActiveSidebarBtn();
    if (btn) setActiveSidebarBtn(btn);
}

function canUseSidebarArrowNav() {
    if (isTouchGameUi()) return false;
    if (playing || deathPending) return false;
    if (!canShowSidebar()) return false;
    if (keybindListenAction) return false;
    const adminPanel = document.getElementById("adminPanelScreen");
    if (adminPanel && !adminPanel.classList.contains("hidden")) return false;
    return getSidebarNavButtons().length > 0;
}

function navigateSidebarPanel(delta) {
    const buttons = getSidebarNavButtons();
    if (!buttons.length) return;

    syncActiveSidebarFromVisibleScreen();

    let idx = buttons.findIndex((b) => b.classList.contains("active"));
    if (idx < 0) idx = 0;
    idx = (idx + delta + buttons.length) % buttons.length;

    const target = buttons[idx];
    if (!target) return;
    target.click();

    if (!sidebarCollapsed && sideNav && !sideNav.classList.contains("hidden")) {
        target.scrollIntoView({ block: "nearest", behavior: "auto" });
    }
}

function handleSidebarArrowNavKeydown(e) {
    if (!canUseSidebarArrowNav()) return false;
    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return false;
    if (isTypingInEditable()) return false;
    e.preventDefault();
    navigateSidebarPanel(e.key === "ArrowDown" ? 1 : -1);
    return true;
}

function setSuperHudVisible(visible) {
    if (!superHud) return;
    superHud.classList.toggle("hidden", !visible);
    superHud.style.display = visible ? "flex" : "none";
    if (visible) {
        refreshSuperHudKbdHints();
    }
}

function setTopHudMode(mode) {
    topCenter.classList.toggle("rouletteHud", mode === "roulette");
    if (mode !== "roulette") topCenter.classList.remove("roulettePulse");
    if (mode !== "roulette") {
        rouletteEffectText.style.opacity = "0";
        rouletteEffectText.textContent = "";
        if (rouletteScoreLine) {
            rouletteScoreLine.style.opacity = "0";
            rouletteScoreLine.textContent = "";
            rouletteScoreLine.setAttribute("aria-hidden", "true");
        }
    }
}

function syncShowFpsWhereUi() {
    if (showFpsWhereRow) showFpsWhereRow.classList.toggle("hidden", !settingShowFps);
    showFpsWhereBtns.forEach(btn => {
        const w = btn.getAttribute("data-fps-where");
        const on = w === settingShowFpsWhere;
        btn.classList.toggle("settingsSegBtn--active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
}

function refreshSettingsUI() {
    refreshSettingsUI._balls = (hex) => {
        const rgb = hexToRgb(hex);
        ballsR.value = rgb.r;
        ballsG.value = rgb.g;
        ballsB.value = rgb.b;
        setSettingsSliderValDisplay(ballsRVal, String(rgb.r));
        setSettingsSliderValDisplay(ballsGVal, String(rgb.g));
        setSettingsSliderValDisplay(ballsBVal, String(rgb.b));
        ballsHex.textContent = hex.toUpperCase();
        ballsPreview.style.background = hex;
    };

    refreshSettingsUI._cursor = (hex) => {
        const rgb = hexToRgb(hex);
        cursorR.value = rgb.r;
        cursorG.value = rgb.g;
        cursorB.value = rgb.b;
        setSettingsSliderValDisplay(cursorRVal, String(rgb.r));
        setSettingsSliderValDisplay(cursorGVal, String(rgb.g));
        setSettingsSliderValDisplay(cursorBVal, String(rgb.b));
        cursorHex.textContent = hex.toUpperCase();
        cursorPreview.style.background = hex;
        if (inventoryCursorR) inventoryCursorR.value = rgb.r;
        if (inventoryCursorG) inventoryCursorG.value = rgb.g;
        if (inventoryCursorB) inventoryCursorB.value = rgb.b;
        setSettingsSliderValDisplay(inventoryCursorRVal, String(rgb.r));
        setSettingsSliderValDisplay(inventoryCursorGVal, String(rgb.g));
        setSettingsSliderValDisplay(inventoryCursorBVal, String(rgb.b));
        if (inventoryCursorHex) inventoryCursorHex.textContent = hex.toUpperCase();
    };

    refreshSettingsUI._buttons = (hex) => {
        const rgb = hexToRgb(hex);
        buttonsR.value = rgb.r;
        buttonsG.value = rgb.g;
        buttonsB.value = rgb.b;
        setSettingsSliderValDisplay(buttonsRVal, String(rgb.r));
        setSettingsSliderValDisplay(buttonsGVal, String(rgb.g));
        setSettingsSliderValDisplay(buttonsBVal, String(rgb.b));
        buttonsHex.textContent = hex.toUpperCase();
        buttonsPreview.style.background = hex;
    };

    refreshSettingsUI._text = (hex) => {
        const rgb = hexToRgb(hex);
        textR.value = rgb.r;
        textG.value = rgb.g;
        textB.value = rgb.b;
        setSettingsSliderValDisplay(textRVal, String(rgb.r));
        setSettingsSliderValDisplay(textGVal, String(rgb.g));
        setSettingsSliderValDisplay(textBVal, String(rgb.b));
        textHex.textContent = hex.toUpperCase();
        textPreview.style.background = hex;
    };

    refreshSettingsUI._trail = (hex) => {
        const rgb = hexToRgb(hex);
        trailR.value = rgb.r;
        trailG.value = rgb.g;
        trailB.value = rgb.b;
        setSettingsSliderValDisplay(trailRVal, String(rgb.r));
        setSettingsSliderValDisplay(trailGVal, String(rgb.g));
        setSettingsSliderValDisplay(trailBVal, String(rgb.b));
        trailHex.textContent = hex.toUpperCase();
        trailPreview.style.background = hex;
        if (inventoryTrailR) inventoryTrailR.value = rgb.r;
        if (inventoryTrailG) inventoryTrailG.value = rgb.g;
        if (inventoryTrailB) inventoryTrailB.value = rgb.b;
        setSettingsSliderValDisplay(inventoryTrailRVal, String(rgb.r));
        setSettingsSliderValDisplay(inventoryTrailGVal, String(rgb.g));
        setSettingsSliderValDisplay(inventoryTrailBVal, String(rgb.b));
        if (inventoryTrailHex) inventoryTrailHex.textContent = hex.toUpperCase();
        if (inventoryTrailLinePreview) inventoryTrailLinePreview.style.borderTopColor = hex;
    };

    refreshSettingsUI._menuBackground = (hex) => {
        const rgb = hexToRgb(hex);
        menuBackgroundR.value = rgb.r;
        menuBackgroundG.value = rgb.g;
        menuBackgroundB.value = rgb.b;
        setSettingsSliderValDisplay(menuBackgroundRVal, String(rgb.r));
        setSettingsSliderValDisplay(menuBackgroundGVal, String(rgb.g));
        setSettingsSliderValDisplay(menuBackgroundBVal, String(rgb.b));
        menuBackgroundHex.textContent = hex.toUpperCase();
        menuBackgroundPreview.style.background = hex;
    };

    refreshSettingsUI._gameBackground = (hex) => {
        const rgb = hexToRgb(hex);
        gameBackgroundR.value = rgb.r;
        gameBackgroundG.value = rgb.g;
        gameBackgroundB.value = rgb.b;
        setSettingsSliderValDisplay(gameBackgroundRVal, String(rgb.r));
        setSettingsSliderValDisplay(gameBackgroundGVal, String(rgb.g));
        setSettingsSliderValDisplay(gameBackgroundBVal, String(rgb.b));
        gameBackgroundHex.textContent = hex.toUpperCase();
        gameBackgroundPreview.style.background = hex;
    };

    refreshSettingsUI._balls(settingBallsColor);
    refreshSettingsUI._cursor(settingCursorColor);
    refreshSettingsUI._buttons(settingButtonsColor);
    refreshSettingsUI._text(settingTextColor);
    refreshSettingsUI._trail(settingTrailColor);
    refreshSettingsUI._menuBackground(settingMenuBackgroundColor);
    refreshSettingsUI._gameBackground(settingGameBackgroundColor);

    wasdSensitivity.value = String(settingWASDSensitivity);
    setSettingsSliderValDisplay(wasdSensitivityVal, String(settingWASDSensitivity));

    menuMusicVolume.value = String(settingMusicVolume);
    setSettingsSliderValDisplay(menuMusicVolumeVal, formatVolume(settingMusicVolume));

    gameMusicVolume.value = String(settingGameMusicVolume);
    setSettingsSliderValDisplay(gameMusicVolumeVal, formatVolume(settingGameMusicVolume));

    if (menuSongPickBtn) {
        const lockMenu = themeMusicAppliesToMenu(getEffectiveThemeMusic());
        menuSongPickBtn.textContent = lockMenu ? "Theme" : String(settingMenuSong);
        menuSongPickBtn.disabled = lockMenu;
        menuSongPickBtn.title = lockMenu
            ? "Theme music is active — turn off Show Admin Theme to pick a song"
            : "Cycle menu song";
    }
    if (gameSongPickBtn) {
        const lockGame = themeMusicAppliesToGame(getEffectiveThemeMusic());
        gameSongPickBtn.textContent = lockGame ? "Theme" : String(settingGameSong);
        gameSongPickBtn.disabled = lockGame;
        gameSongPickBtn.title = lockGame
            ? "Theme music is active — turn off Show Admin Theme to pick a song"
            : "Cycle game song";
    }

    bounceVolume.value = String(settingBounceVolume);
    setSettingsSliderValDisplay(bounceVolumeVal, formatVolume(settingBounceVolume));

    if (pickupVolume) pickupVolume.value = String(settingPickupVolume);
    if (pickupVolumeVal) setSettingsSliderValDisplay(pickupVolumeVal, formatVolume(settingPickupVolume));
    if (gameSfxVolume) gameSfxVolume.value = String(settingGameSfxVolume);
    if (gameSfxVolumeVal) setSettingsSliderValDisplay(gameSfxVolumeVal, formatVolume(settingGameSfxVolume));
    if (darknessVolume) darknessVolume.value = String(settingDarknessVolume);
    if (darknessVolumeVal) setSettingsSliderValDisplay(darknessVolumeVal, formatVolume(settingDarknessVolume));

    if (uiVolume) uiVolume.value = String(settingUiVolume);
    if (uiVolumeVal) setSettingsSliderValDisplay(uiVolumeVal, formatVolume(settingUiVolume));
    if (uiVolumeSettings) uiVolumeSettings.classList.toggle("hidden", !settingSounds);

    const setBtn = (btn, on) => syncToggleSwitch(btn, on);

    setBtn(toggleEffectFlashesBtn, settingEffectFlashes);
    setBtn(toggleEffectShakeBtn, settingEffectShake);
    setBtn(toggleEffectParticlesBtn, settingEffectParticles);
    setBtn(toggleFreezeGameBtn, settingFreezeOnLose);
    if (freezeGameSettingsRow) freezeGameSettingsRow.classList.toggle("hidden", settingEffectParticles);
    if (freezeGameSecondsInput) freezeGameSecondsInput.value = String(settingFreezeOnLoseSeconds);
    setBtn(toggleAutoRetryBtn, settingAutoRetry);
    setBtn(toggleModesSelectPanelBtn, settingModesSelectPanel);
    setBtn(togglePlayTransitionBtn, settingPlayTransition);
    setBtn(toggleQuickRestartBtn, settingQuickRestart);
    setBtn(toggleTrailBtn, settingTrailEnabled);
    setBtn(toggleCosmeticsMatchCursorBtn, settingCosmeticsMatchCursor);
    setBtn(toggleNeonBallsBtn, settingNeonBalls);
    setBtn(toggleHomeAmbientBallsBtn, settingHomeAmbientBalls);
    setBtn(toggleNewsInHomeBtn, settingNewsInHome);
    setBtn(toggleNotificationsInHomeBtn, settingNotificationsInHome);
    setBtn(toggleHomeSplashBtn, settingHomeSplash);
    refreshHomeSettingsToggleUi();
    setBtn(toggleShowFpsBtn, settingShowFps);
    syncShowFpsWhereUi();
    if (fpsLimit) fpsLimit.value = String(fpsLimitToSliderIndex(settingFpsLimit));
    if (fpsLimitVal) setSettingsSliderValDisplay(fpsLimitVal, formatFpsLimitLabel(settingFpsLimit));
    setBtn(toggleLowPowerCap60Btn, settingLowPowerCap60);
    setBtn(toggleInvertReturnPauseBtn, settingInvertReturnPause);
    setBtn(toggleInvertSidebarBtn, settingInvertSidebar);
    setBtn(toggleHoldReturnHomeBtn, settingHoldReturnHome);
    if (holdReturnHomeSecondsInput) holdReturnHomeSecondsInput.value = String(settingHoldReturnHomeSeconds);
    if (holdReturnHomeSecondsField) {
        holdReturnHomeSecondsField.classList.toggle("hidden", !settingHoldReturnHome);
    }
    setBtn(toggleSoundsBtn, settingSounds);
    setBtn(toggleKeybindIndicatorBtn, settingShowKeybindIndicator);
    setBtn(toggleShowMobileSettingsBtn, settingShowMobileSettingsInUi);
    setBtn(toggleTouchJoystickBtn, settingTouchCursorJoystick);
    setBtn(toggleTouchJoystickVisibleBtn, settingTouchCursorJoystickVisible);
    setBtn(textAutoColorBtn, settingButtonsAutoText);
    setBtn(showAdminThemeBtn, getShowAdminThemeSetting());
    if (menuBackgroundBright) menuBackgroundBright.value = String(settingMenuBackgroundBright);
    if (menuBackgroundBrightVal) setSettingsSliderValDisplay(menuBackgroundBrightVal, String(settingMenuBackgroundBright));
    if (gameBackgroundBright) gameBackgroundBright.value = String(settingGameBackgroundBright);
    if (gameBackgroundBrightVal) setSettingsSliderValDisplay(gameBackgroundBrightVal, String(settingGameBackgroundBright));
    if (trailColorSettings) trailColorSettings.classList.toggle("hidden", !settingTrailEnabled);
    if (textColorSettings) textColorSettings.classList.toggle("hidden", settingButtonsAutoText);
    if (touchJoystickVisibleRow) touchJoystickVisibleRow.classList.toggle("hidden", !settingTouchCursorJoystick);
    if (touchJoystickSensitivityRow) touchJoystickSensitivityRow.classList.toggle("hidden", !settingTouchCursorJoystick);
    if (touchJoystickSensitivity) touchJoystickSensitivity.value = String(settingTouchJoystickSensitivity);
    if (touchJoystickSensitivityVal) setSettingsSliderValDisplay(touchJoystickSensitivityVal, String(settingTouchJoystickSensitivity));
    refreshDpadSettingsUI();
    refreshKeybindSettingsUi();
    refreshGamepadSettingsUI();
}

function darkenBackgroundHex(hex) {
    const rgb = hexToRgb(hex);
    const mix = (c, t) => Math.round(c * (1 - t) + 0 * t);
    const t = 0.72;
    return rgbToHex(mix(rgb.r, t), mix(rgb.g, t), mix(rgb.b, t));
}

function effectiveBackgroundFromBright(rawHex, bright) {
    const t = clamp(bright, 0, BACKGROUND_BRIGHT_MAX) / BACKGROUND_BRIGHT_MAX;
    const dark = darkenBackgroundHex(rawHex);
    if (t <= 0) return dark;
    if (t >= 1) return rawHex;
    const a = hexToRgb(dark);
    const b = hexToRgb(rawHex);
    const lerp = (x, y) => Math.round(x + (y - x) * t);
    return rgbToHex(lerp(a.r, b.r), lerp(a.g, b.g), lerp(a.b, b.b));
}

function isBackgroundBrightMax(bright) {
    return bright >= BACKGROUND_BRIGHT_MAX;
}

function effectiveGameBackgroundColor() {
    return effectiveBackgroundFromBright(settingGameBackgroundColor, settingGameBackgroundBright);
}

function applyBackgroundTheme() {
    const menuEffective = effectiveBackgroundFromBright(settingMenuBackgroundColor, settingMenuBackgroundBright);
    const gameEffective = effectiveBackgroundFromBright(settingGameBackgroundColor, settingGameBackgroundBright);
    const root = document.documentElement;
    root.style.setProperty("--menu-bg-raw", settingMenuBackgroundColor);
    root.style.setProperty("--game-bg-raw", settingGameBackgroundColor);
    root.style.setProperty("--menu-bg-color", menuEffective);
    root.style.setProperty("--game-bg-color", gameEffective);
    root.style.setProperty(
        "--bg-color",
        document.body.classList.contains("game-active") ? gameEffective : menuEffective
    );
    document.body.classList.toggle("menu-bg-plain", isBackgroundBrightMax(settingMenuBackgroundBright));
    document.body.classList.toggle("game-bg-plain", isBackgroundBrightMax(settingGameBackgroundBright));
}

function applyButtonGradientCssVars(buttonsHex, autoText = true) {
    const rgb = hexToRgb(buttonsHex);
    const mix = (a, b, t) => Math.round(a + (b - a) * t);
    const light = {
        r: mix(rgb.r, 255, 0.4),
        g: mix(rgb.g, 255, 0.4),
        b: mix(rgb.b, 255, 0.4)
    };
    const edge = {
        r: mix(rgb.r, 0, 0.52),
        g: mix(rgb.g, 0, 0.52),
        b: mix(rgb.b, 0, 0.52)
    };
    const edgeHi = {
        r: mix(rgb.r, 0, 0.62),
        g: mix(rgb.g, 0, 0.62),
        b: mix(rgb.b, 0, 0.62)
    };
    const root = document.documentElement;
    root.style.setProperty("--btn-sky-light", rgbToHex(light.r, light.g, light.b));
    root.style.setProperty("--btn-sky-mid", rgbToHex(rgb.r, rgb.g, rgb.b));
    root.style.setProperty("--btn-sky-edge", rgbToHex(edge.r, edge.g, edge.b));
    root.style.setProperty("--btn-sky-edge-hover", rgbToHex(edgeHi.r, edgeHi.g, edgeHi.b));

    const lum = relativeLuminance255(rgb.r, rgb.g, rgb.b);
    const isLight = lum > 0.55;
    root.style.setProperty("--btn-fg", autoText ? (isLight ? "#000000" : "#ffffff") : "#000000");

    let aLight;
    let aMid;
    if (isLight) {
        const d = 0.5;
        aLight = { r: mix(light.r, 0, d), g: mix(light.g, 0, d), b: mix(light.b, 0, d) };
        aMid = { r: mix(rgb.r, 0, d), g: mix(rgb.g, 0, d), b: mix(rgb.b, 0, d) };
    } else {
        const u = 0.24;
        aLight = { r: mix(light.r, 255, u), g: mix(light.g, 255, u), b: mix(light.b, 255, u) };
        aMid = { r: mix(rgb.r, 255, u), g: mix(rgb.g, 255, u), b: mix(rgb.b, 255, u) };
    }
    const aEdge = {
        r: mix(aMid.r, 0, 0.52),
        g: mix(aMid.g, 0, 0.52),
        b: mix(aMid.b, 0, 0.52)
    };
    root.style.setProperty("--btn-active-sky-light", rgbToHex(aLight.r, aLight.g, aLight.b));
    root.style.setProperty("--btn-active-sky-mid", rgbToHex(aMid.r, aMid.g, aMid.b));
    root.style.setProperty("--btn-active-sky-edge", rgbToHex(aEdge.r, aEdge.g, aEdge.b));
    root.style.setProperty("--btn-active-flat", rgbToHex(aMid.r, aMid.g, aMid.b));
}

function applySettings() {
    if (playing && gameMode) {
        document.body.classList.add("hideCursor");
    }

    document.documentElement.style.setProperty("--btn-main-bg", settingButtonsColor);
    document.documentElement.style.setProperty("--btn-main-glow", settingButtonsColor);
    document.documentElement.style.setProperty("--btn-green-bg", settingButtonsColor);
    document.documentElement.style.setProperty("--btn-green-glow", settingButtonsColor);
    document.documentElement.style.setProperty("--btn-color", settingButtonsColor);
    applyButtonGradientCssVars(settingButtonsColor, true);
    const effectiveTextColor = settingButtonsAutoText ? settingButtonsColor : settingTextColor;
    document.documentElement.style.setProperty("--ball-color", settingBallsColor);
    document.documentElement.style.setProperty("--cursor-color", settingCursorColor);
    document.documentElement.style.setProperty("--text-color", effectiveTextColor);
    document.documentElement.style.setProperty("--home-title-glow", effectiveTextColor);
    document.documentElement.style.setProperty("--home-start-glow", settingButtonsColor);
    document.documentElement.style.setProperty("--trail-color", settingTrailColor);
    applyBackgroundTheme();
    applyEquippedThemeCosmetics();

    if (settingCursorColor !== lastCursorColorForMatchCosmetics) {
        lastCursorColorForMatchCosmetics = settingCursorColor;
        if (
            shopCatalogForDisplay.some(
                (i) => i.matchCursorColor || i.matchCursorMaskData || i.matchCursorMaskFrames?.length,
            )
        ) {
            void refreshEquippedCosmeticDisplay();
        }
        refreshInventoryCursorColor();
    }

    if (!settingEffectParticles && !deathPending) deathCursorBreak = null;
    if (!settingTrailEnabled) {
        trail = [];
        clearTrailParticles();
    }
    if (!settingEffectShake) screenShake = 0;
    if (!settingEffectFlashes && fxFlash) fxFlash.style.opacity = "0";
    syncHomeAmbientBallsEnabled(settingHomeAmbientBalls);
    syncNewsInHomeEnabled(settingNewsInHome);
    syncNotificationsInHomeEnabled(settingNotificationsInHome);
    syncHomeSplashEnabled(settingHomeSplash);
    applyHomeDashboardFromSettings();
    setFpsOverlayOptions({ enabled: settingShowFps, where: settingShowFpsWhere });
    setPlayHudLayoutOptions({
        invertReturnPause: settingInvertReturnPause,
        invertSidebar: settingInvertSidebar,
    });
    setPlayHudSidebarCollapsed(sidebarCollapsed);
    syncPlayHudLayout();
    scheduleFpsOverlayPosition();

    refreshSettingsUI();
    refreshMenuKbdLabels();
    updateMusicState();
    if (cloudUser && !applyingRemoteAccountData) {
        touchAccountSettingsUpdatedAt();
        schedulePushAccountData();
    }
    afterPlayerSettingsApplied();
    // Player Theme balls channel must win over Admin Game Theme (CSS + canvas).
    if (hasPlayerThemeBalls()) {
        applyEquippedThemeCosmetics({ onlyChannels: { balls: true } });
    }
}

/** Obstacle / FX ball fill: player Theme → Admin Theme → Settings (mode-gated). */
function gameplayBallsColor(opts) {
    const paint = gameplayBallsPaint(opts);
    return paint.color || settingBallsColor;
}

function gameplayBallsPaint(opts) {
    if (!modeAllowsThemeBallColorForBall(gameMode, opts)) {
        return { color: null, gradientTo: null };
    }
    const player = getPlayerThemeBallsPaint();
    if (player.color) return player;
    return getThemeBallsPaint(gameMode);
}

function saveColorSetting(which, hex) {
    pushSettingsUndoDebounced();
    if (which === "balls") {
        settingBallsColor = hex;
        localStorage.setItem("settingBallsColor", hex);
    } else if (which === "cursor") {
        settingCursorColor = hex;
        localStorage.setItem("settingCursorColor", hex);
    } else if (which === "buttons") {
        settingButtonsColor = hex;
        localStorage.setItem("settingButtonsColor", hex);
    } else if (which === "text") {
        settingTextColor = hex;
        localStorage.setItem("settingTextColor", hex);
    } else if (which === "trail") {
        settingTrailColor = hex;
        localStorage.setItem("settingTrailColor", hex);
    } else if (which === "menuBackground") {
        settingMenuBackgroundColor = hex;
        localStorage.setItem("settingMenuBackgroundColor", hex);
    } else if (which === "gameBackground") {
        settingGameBackgroundColor = hex;
        localStorage.setItem("settingGameBackgroundColor", hex);
    }
    applySettings();
}

function saveWASDSensitivity(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 4, 1, 20);
    settingWASDSensitivity = v;
    localStorage.setItem("settingWASDSensitivity", String(v));
    refreshSettingsUI();
}

function applyFpsLimitSetting(next: FpsLimit) {
    settingFpsLimit = next;
    setGameplayFpsLimit(settingFpsLimit);
    localStorage.setItem("settingFpsLimit", String(settingFpsLimit));
    refreshSettingsUI();
}

function applyLowPowerCap60Setting(on: boolean) {
    settingLowPowerCap60 = on;
    setLowPowerCap60Enabled(on);
    setBoolSetting("settingLowPowerCap60", on);
    lastFpsLimitedFrameAt = 0;
    refreshSettingsUI();
}

function saveFpsLimitFromSlider() {
    if (!fpsLimit) return;
    pushSettingsUndoDebounced();
    applyFpsLimitSetting(sliderIndexToFpsLimit(Number(fpsLimit.value)));
}

function saveFpsLimitFromTyped(value) {
    pushSettingsUndoDebounced();
    const next = parseFpsLimitInput(value);
    if (next == null) {
        refreshSettingsUI();
        return;
    }
    applyFpsLimitSetting(next);
}

function saveGameBackgroundBright(value) {
    pushSettingsUndoCurrent();
    const v = clamp(Math.round(Number(value)), 0, BACKGROUND_BRIGHT_MAX);
    settingGameBackgroundBright = v;
    localStorage.setItem("settingGameBackgroundBright", String(v));
    refreshSettingsUI();
    applySettings();
}

function saveMenuBackgroundBright(value) {
    pushSettingsUndoCurrent();
    const v = clamp(Math.round(Number(value)), 0, BACKGROUND_BRIGHT_MAX);
    settingMenuBackgroundBright = v;
    localStorage.setItem("settingMenuBackgroundBright", String(v));
    refreshSettingsUI();
    applySettings();
}

function saveMusicVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingMusicVolume = v;
    localStorage.setItem("settingMusicVolume", String(v));
    refreshSettingsUI();
    updateMusicState();
}

function saveGameMusicVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingGameMusicVolume = v;
    localStorage.setItem("settingGameMusicVolume", String(v));
    refreshSettingsUI();
    updateMusicState();
}

function cycleMenuSong() {
    if (themeMusicAppliesToMenu(getEffectiveThemeMusic())) return;
    pushSettingsUndoCurrent();
    settingMenuSong = settingMenuSong >= MUSIC_TRACK_COUNT ? 1 : settingMenuSong + 1;
    localStorage.setItem("settingMenuSong", String(settingMenuSong));
    refreshSettingsUI();
    stopMenuMusic();
    updateMusicState();
}

function cycleGameSong() {
    if (themeMusicAppliesToGame(getEffectiveThemeMusic())) return;
    pushSettingsUndoCurrent();
    settingGameSong = settingGameSong >= MUSIC_TRACK_COUNT ? 1 : settingGameSong + 1;
    localStorage.setItem("settingGameSong", String(settingGameSong));
    refreshSettingsUI();
    stopGameMusic();
    updateMusicState();
}

function saveBounceVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingBounceVolume = v;
    localStorage.setItem("settingBounceVolume", String(v));
    refreshSettingsUI();
}

function savePickupVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingPickupVolume = v;
    localStorage.setItem("settingPickupVolume", String(v));
    refreshSettingsUI();
}

function saveGameSfxVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingGameSfxVolume = v;
    localStorage.setItem("settingGameSfxVolume", String(v));
    refreshSettingsUI();
}

function saveDarknessVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingDarknessVolume = v;
    localStorage.setItem("settingDarknessVolume", String(v));
    refreshSettingsUI();
}

function saveUiVolume(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 0, 0, 10);
    settingUiVolume = v;
    localStorage.setItem("settingUiVolume", String(v));
    refreshSettingsUI();
}

function saveTouchJoystickSensitivity(value) {
    pushSettingsUndoDebounced();
    const v = clamp(Number(value) || 4, 1, 20);
    settingTouchJoystickSensitivity = v;
    localStorage.setItem("settingTouchJoystickSensitivity", String(v));
    refreshSettingsUI();
}

function triggerFlash(color = "#fff", alpha = 0.45, duration = 90) {
    if (!settingEffectFlashes || !fxFlash) return;
    fxFlash.style.background = color;
    fxFlash.style.opacity = String(alpha);
    clearTimeout(flashTimer);
    flashTimer = setTimeout(() => {
        fxFlash.style.opacity = "0";
    }, duration);
}

function addShake(amount) {
    if (!settingEffectShake) return;
    const cap = 18 * gameLayoutScale();
    screenShake = Math.min(cap, screenShake + amount);
}

class Particle {
    constructor(x, y, vx, vy, life, color, size, gravity = 0) {
        this.x = x;
        this.y = y;
        this.vx = vx;
        this.vy = vy;
        this.life = life;
        this.maxLife = life;
        this.color = color;
        this.size = size;
        this.gravity = gravity;
    }
    update(dt) {
        const fs = frameScale(dt);
        this.x += this.vx * fs;
        this.y += this.vy * fs;
        const drag = decayFrameRate(0.985, dt);
        this.vx *= drag;
        this.vy = this.vy * drag + this.gravity * fs;
        this.life -= fs;
    }
    draw() {
        const t = Math.max(0, this.life / this.maxLife);
        ctx.save();
        ctx.globalAlpha = t * t;
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
    }
    dead() {
        return this.life <= 0;
    }
}

function emitBurst(x, y, count = 16, palette = ["#fff"], power = 2.5, gravity = 0, sizeMin = 1.5, sizeMax = 3.5, lifeMin = 18, lifeMax = 38) {
    const ls = gameLayoutScale();
    power *= ls;
    gravity *= ls;
    sizeMin *= ls;
    sizeMax *= ls;
    for (let i = 0; i < count; i++) {
        const ang = Math.random() * Math.PI * 2;
        const sp = power * (0.45 + Math.random());
        const vx = Math.cos(ang) * sp;
        const vy = Math.sin(ang) * sp;
        const life = Math.floor(lifeMin + Math.random() * (lifeMax - lifeMin));
        const color = palette[Math.floor(Math.random() * palette.length)];
        const size = sizeMin + Math.random() * (sizeMax - sizeMin);
        particles.push(new Particle(x, y, vx, vy, life, color, size, gravity));
    }
}

function updateParticles(dt) {
    for (let i = particles.length - 1; i >= 0; i--) {
        particles[i].update(dt);
        if (particles[i].dead()) particles.splice(i, 1);
    }
}

function drawParticles() {
    ctx.save();
    ctx.globalCompositeOperation = "lighter";
    for (const p of particles) p.draw();
    ctx.restore();
}

function updateTrail(dt) {
    if (!settingTrailEnabled) {
        trail = [];
        trailParticleStamps = [];
        trailParticlePrev = null;
        return;
    }
    const fs = frameScale(dt);
    for (const t of trail) t.life -= fs;
    trail = trail.filter(t => t.life > 0);
}

function clearTrailParticles() {
    trailParticleStamps = [];
    trailParticlePrev = null;
}

function drawTrail() {
    if (!settingTrailEnabled) return;
    const equippedTrail = getEquippedTrailLayer();
    ctx.save();
    ctx.globalCompositeOperation = "lighter";
    if (equippedTrail?.trailMode === "multiColor" && equippedTrail.trailColors?.length) {
        if (trail.length < 2) {
            ctx.restore();
            return;
        }
        paintMultiColorTrailStroke(ctx, trail, equippedTrail.trailColors, {
            maxLife: 12,
            lineWidth: 4 * gameLayoutScale(),
            alphaScale: 0.45,
        });
    } else if (equippedTrail?.trailMode === "particle") {
        if (!trailParticleStamps.length) {
            ctx.restore();
            return;
        }
        const cr = getCursorRadiusForMode();
        const particleSize = Math.max(
            28 * gameLayoutScale(),
            cr * (COSMETIC_ART_SIZE / COSMETIC_REF_CURSOR_R) * 0.58,
        );
        void paintParticleStamps(
            ctx,
            trailParticleStamps,
            {
                trailMode: "particle",
                imageData: equippedTrail.imageData,
                animationFrames: equippedTrail.animationFrames ?? null,
            },
            {
                particleSize,
                alphaScale: 0.95,
            },
        );
    } else {
        if (trail.length < 2) {
            ctx.restore();
            return;
        }
        for (let i = 0; i < trail.length - 1; i++) {
            const a = trail[i];
            const b = trail[i + 1];
            if (a.breakAfter || b.breakBefore) continue;
            const seg = Math.hypot(b.x - a.x, b.y - a.y);
            if (seg < 0.75) continue;
            const alpha = Math.max(0, a.life / 12);
            const ls = gameLayoutScale();
            ctx.strokeStyle = gameMode === "colorrush" ? getColorRushCursorHex() : settingTrailColor;
            ctx.globalAlpha = alpha * 0.45;
            ctx.lineWidth = Math.max(1 * ls, alpha * 4 * ls);
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
        }
    }
    ctx.restore();
}

function startFX(color) {
    triggerFlash(color, 0.38, 120);
    addShake(4);
    emitBurst(mouse.x, mouse.y, 22, [color, "#fff", settingBallsColor], 3.0, 0, 1.4, 3.6, 16, 30);
}

function clearDeathState() {
    deathPending = false;
    speedrunCheckpointDeathPending = false;
    speedrunDeathFrozenTSec = -1;
    deathStart = 0;
    deathRunPersisted = false;
    deathRunWasNewRecord = false;
    deathCursorBreak = null;
    gameOverMessage = "";
    defeatGameMusicDuck = 1;
}

function isDeathWorldFrozen() {
    return deathPending && !settingEffectParticles;
}

function startDeathCursorBreak(x, y) {
    deathCursorBreak = {
        x,
        y,
        r: getCursorRadiusForMode(),
        topX: x,
        topY: y,
        botX: x,
        botY: y,
        topRot: 0,
        botRot: 0,
        started: performance.now(),
    };
}

function updateDeathCursorBreak(now) {
    if (!deathCursorBreak) return;
    const elapsed = now - deathCursorBreak.started;
    const fallT = Math.max(0, (elapsed - 40) / 1000);
    const ls = gameLayoutScale();
    const drop = fallT * fallT * 320 * ls + fallT * 95 * ls;
    const drift = fallT * 22 * ls;
    deathCursorBreak.topX = deathCursorBreak.x - drift;
    deathCursorBreak.topY = deathCursorBreak.y - drop * 0.42;
    deathCursorBreak.botX = deathCursorBreak.x + drift;
    deathCursorBreak.botY = deathCursorBreak.y + drop;
    deathCursorBreak.topRot = fallT * 0.55;
    deathCursorBreak.botRot = -fallT * 0.48;
}

function drawCursorHalfOnto(c, cx, cy, r, color, isTop, rot) {
    c.save();
    c.translate(cx, cy);
    c.rotate(rot);
    c.beginPath();
    if (isTop) c.rect(-r * 1.25, -r * 1.25, r * 2.5, r * 1.02);
    else c.rect(-r * 1.25, -0.02 * r, r * 2.5, r * 1.27);
    c.clip();
    c.fillStyle = color;
    c.beginPath();
    c.arc(0, 0, r, 0, Math.PI * 2);
    c.fill();
    c.restore();
}

function drawDeathCursorCrackOnto(c, breakState, now) {
    const elapsed = now - breakState.started;
    if (elapsed > 280) return;
    const alpha = 1 - elapsed / 280;
    const { x, y, r } = breakState;
    c.save();
    c.strokeStyle = `rgba(255,255,255,${0.92 * alpha})`;
    c.lineWidth = Math.max(1.2, r * 0.14);
    c.beginPath();
    const steps = 7;
    for (let i = 0; i <= steps; i++) {
        const t = i / steps;
        const px = x - r + t * r * 2;
        const jag = i === 0 || i === steps ? 0 : (Math.sin(i * 2.7 + breakState.x * 0.01) * r * 0.08);
        if (i === 0) c.moveTo(px, y + jag);
        else c.lineTo(px, y + jag);
    }
    c.stroke();
    c.restore();
}

function drawBrokenCursorOnto(c, breakState, now) {
    const elapsed = now - breakState.started;
    const t = Math.min(1, elapsed / DEATH_LOSE_ANIM_MS);
    const color = deathCursorColor();
    c.save();
    if (t > 0.82) c.globalAlpha = Math.max(0, 1 - (t - 0.82) / 0.18);
    drawDeathCursorCrackOnto(c, breakState, now);
    drawCursorHalfOnto(c, breakState.topX, breakState.topY, breakState.r, color, true, breakState.topRot);
    drawCursorHalfOnto(c, breakState.botX, breakState.botY, breakState.r, color, false, breakState.botRot);
    c.restore();
}

function readSpeedrunBestJson() {
    try {
        const raw = localStorage.getItem(KEY_SPEEDRUN_BEST);
        if (!raw) return {};
        const o = JSON.parse(raw);
        return o && typeof o === "object" ? o : {};
    } catch {
        return {};
    }
}

function readSpeedrunBestMs(level) {
    const o = readSpeedrunBestJson();
    const v = Number(o[String(level)]);
    return Number.isFinite(v) && v > 0 ? v : 0;
}

function maybeWriteSpeedrunBest(level, ms) {
    const prev = readSpeedrunBestMs(level);
    if (!prev || ms < prev) {
        const o = readSpeedrunBestJson();
        o[String(level)] = Math.floor(ms);
        localStorage.setItem(KEY_SPEEDRUN_BEST, JSON.stringify(o));
    }
    schedulePushAccountData();
}

async function refreshSpeedrunCloudPersonalBests() {
    if (!cloudUser) {
        speedrunCloudPersonalBests = null;
        return;
    }
    try {
        const r = await fetch(
            apiPath(`/api/leaderboard?mode=speedrun&mine=1&limit=1`),
            { credentials: "include" }
        );
        const d = await r.json();
        speedrunCloudPersonalBests =
            d.speedrunPersonalBests && typeof d.speedrunPersonalBests === "object"
                ? d.speedrunPersonalBests
                : {};
    } catch {
        speedrunCloudPersonalBests = {};
    }
    if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
    updateTopHud();
}

async function refreshSandboxSpeedrunCloudBests() {
    if (!cloudUser) {
        sandboxSpeedrunCloudBests = null;
        sandboxScoreCloudBests = null;
    sandboxScoreCloudBests = null;
        return;
    }
    try {
        const r = await fetch(apiPath(`/api/leaderboard?mode=sandbox_speedrun&mine=1&limit=1`), {
            credentials: "include",
        });
        const d = await r.json();
        sandboxSpeedrunCloudBests =
            d.sandboxSpeedrunPersonalBests && typeof d.sandboxSpeedrunPersonalBests === "object"
                ? d.sandboxSpeedrunPersonalBests
                : {};
    } catch {
        sandboxSpeedrunCloudBests = {};
    }
    updateTopHud();
    rerenderSandboxCommunityBestLines();
}

async function refreshSandboxScoreCloudBests() {
    if (!cloudUser) {
        sandboxScoreCloudBests = null;
        return;
    }
    try {
        const r = await fetch(apiPath(`/api/leaderboard?mode=sandbox&mine=1&limit=1`), {
            credentials: "include",
        });
        const d = await r.json();
        sandboxScoreCloudBests =
            d.sandboxPersonalBests && typeof d.sandboxPersonalBests === "object"
                ? d.sandboxPersonalBests
                : {};
    } catch {
        sandboxScoreCloudBests = {};
    }
    updateTopHud();
    rerenderSandboxCommunityBestLines();
}

/** In-game / STATS “best” for SpeedRun: best of cloud ranking and localStorage when signed in. */
function displayedSpeedrunBestMs(level) {
    const local = readSpeedrunBestMs(level);
    if (cloudUser && speedrunCloudPersonalBests != null) {
        const cloud = Number(speedrunCloudPersonalBests[String(level)]) || 0;
        if (local > 0 && cloud > 0) return Math.min(local, cloud);
        return cloud || local;
    }
    return local;
}

/** In-game HUD best for Sandbox SpeedRun when a preset context is set. */
function displayedSandboxSpeedrunBestMs() {
    const ctx = sandboxActivePlayContext;
    if (!ctx || (!ctx.localName && !ctx.cloudPresetId)) return 0;
    if (!sandboxRuntimeConfig || !sandboxRuntimeConfig.speedrunMode) return 0;
    const key = ctx.cloudPresetId ? `cloud:${ctx.cloudPresetId}` : `local:${String(ctx.localName).toLowerCase()}`;
    const fromMap = readSandboxSpeedrunLocalBestMs(key);
    let cloud = 0;
    if (ctx.cloudPresetId && cloudUser && sandboxSpeedrunCloudBests) {
        cloud = Number(sandboxSpeedrunCloudBests[ctx.cloudPresetId]) || 0;
    }
    return mergeSandboxLocalAndCloudBestMs(fromMap, cloud);
}

function formatSpeedrunTime(ms) {
    const m = Math.floor(ms / 60000);
    const s = (ms % 60000) / 1000;
    if (m <= 0) return s.toFixed(2) + " s";
    return `${m}m ${s < 10 ? "0" : ""}${s.toFixed(2)}s`;
}

function mergeSandboxLocalAndCloudBestMs(localMs, cloudMs) {
    const L = Number(localMs) || 0;
    const C = Number(cloudMs) || 0;
    if (L > 0 && C > 0) return Math.min(L, C);
    return Math.max(L, C);
}

/** `preset`: local row `{ name, config, cloudPresetId? }` or cloud `{ id, config }` (use p.id as cloudPresetId). */
function getSandboxSpeedrunBestMsForPreset(preset) {
    const cfg = normalizeSandboxConfig(preset.config);
    if (!cfg.speedrunMode) return 0;
    const cloudId = preset.cloudPresetId || preset.id || null;
    const key = cloudId ? `cloud:${cloudId}` : `local:${String(preset.name || "").toLowerCase()}`;
    const fromMap = readSandboxSpeedrunLocalBestMs(key);
    let cloud = 0;
    if (cloudId && cloudUser && sandboxSpeedrunCloudBests) {
        cloud = Number(sandboxSpeedrunCloudBests[cloudId]) || 0;
    }
    let ms = mergeSandboxLocalAndCloudBestMs(fromMap, cloud);
    const cached = Number(preset.lastSpeedrunMs) || 0;
    if (cached > 0) ms = ms > 0 ? Math.min(ms, cached) : cached;
    return ms;
}

function applySpeedrunDefToRuntime(d) {
    if (canvas.width < 1 || canvas.height < 1) resize();
    const w = Math.max(1, canvas.width);
    const h = Math.max(1, canvas.height);
    const m = Math.min(w, h);
    speedrunWallSegDefs = Array.isArray(d.staticSegs) ? d.staticSegs.slice() : [];
    speedrunMovingDefs = Array.isArray(d.moving) ? d.moving.slice() : [];
    speedrunGoalPx = { x: d.goal.nx * w, y: d.goal.ny * h, half: d.goal.nHalf * m };
    speedrunPointsNorm = d.points || [];
    speedrunCheckpointsNorm = speedrunLevelCheckpoints(d);
    speedrunWindDefs = d.winds || [];
    speedrunTextDefs = d.texts || [];
    speedrunPortalsNorm = d.portals || [];
    resetSpeedrunPortalFx();
    speedrunPortalCursorSplit = null;
    speedrunPortalTrailBridge = null;
    speedrunPortalExitLatch = null;
    speedrunWindPrevT = null;
    speedrunPointsCollected = new Set();
    speedrunCheckpointsCollected = new Set();
    speedrunLastCheckpointIndex = null;
    speedrunCheckpointProgressSnapshot = null;
    speedrunDisabledWallSegIndices.clear();
    speedrunDisabledMovingIndices.clear();
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    speedrunStickyRail = null;
    speedrunSolidMidVelPrev = [];
}

function tryActivateSpeedrunCheckpoints(px, py, tSec) {
    const cks = speedrunCheckpointsNorm;
    if (!cks.length) return false;
    let touched = false;
    for (let i = 0; i < cks.length; i++) {
        if (speedrunCheckpointsCollected.has(i)) continue;
        const ck = cks[i];
        const pos = speedrunPointGoalPosNorm(ck.nx, ck.ny, ck.pathMove, ck.move, tSec);
        const pnx = pos.nx * canvas.width;
        const pny = pos.ny * canvas.height;
        if (Math.hypot(px - pnx, py - pny) < speedrunCheckpointHitRadiusPx(ck.sizeMul)) {
            speedrunCheckpointsCollected.add(i);
            speedrunLastCheckpointIndex = i;
            touched = true;
        }
    }
    return touched;
}

function speedrunPortalIsLatched(portal) {
    if (!speedrunPortalExitLatch) return false;
    return speedrunPortalExitLatch.group === portal.group && speedrunPortalExitLatch.side === portal.side;
}

function speedrunPortalUpdateExitLatch(px, py, cr) {
    if (!speedrunPortalExitLatch) return;
    let portal = null;
    for (const p of speedrunPortalsNorm) {
        if (p.group === speedrunPortalExitLatch.group && p.side === speedrunPortalExitLatch.side) {
            portal = p;
            break;
        }
    }
    if (!portal) {
        speedrunPortalExitLatch = null;
        return;
    }
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const ht = speedrunPortalHalfThicknessPx(ls);
    const gateBand = ht + cr * 2.1;
    const c = speedrunPortalClosestPx(portal, px, py, w, h, 0.18);
    const clearMargin = ht + cr * 0.35;
    if (!c.onSegment || Math.abs(c.perp) >= gateBand || Math.abs(c.perp) > clearMargin) {
        speedrunPortalExitLatch = null;
    }
}

function speedrunPortalFindByGroupSide(group, side) {
    for (const p of speedrunPortalsNorm) {
        if (p.group === group && p.side === side) return p;
    }
    return null;
}

function speedrunPortalExteriorNormal(dest, px, py, entryPerp0, w, h, ht) {
    const outC = speedrunPortalClosestPx(dest, px, py, w, h, 0.18);
    let nx = outC.frame.nx;
    let ny = outC.frame.ny;
    if (outC.perp < -ht * 0.02) {
        nx = -outC.frame.nx;
        ny = -outC.frame.ny;
    } else if (Math.abs(outC.perp) <= ht * 0.02) {
        nx = entryPerp0 > 0 ? -outC.frame.nx : outC.frame.nx;
        ny = entryPerp0 > 0 ? -outC.frame.ny : outC.frame.ny;
    }
    return { nx, ny, qx: outC.qx, qy: outC.qy, frame: outC.frame };
}

/** Unconditional exit placement: portal warp ignores surrounding solid walls. */
function speedrunPortalForcedExitPx(dest, mappedX, mappedY, entryPerp0, cr) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const ht = speedrunPortalHalfThicknessPx(ls);
    const { nx, ny, qx, qy } = speedrunPortalExteriorNormal(dest, mappedX, mappedY, entryPerp0, w, h, ht);
    const pushOut = Math.max(ht * 1.25, cr * 1.4);
    return clampCursorXYToCanvas(qx + nx * pushOut, qy + ny * pushOut);
}

function speedrunPortalPushOutNormal(dest, outX, outY, entryPerp0, w, h, ht, cr) {
    const { nx, ny, qx, qy } = speedrunPortalExteriorNormal(dest, outX, outY, entryPerp0, w, h, ht);
    const pushOut = Math.max(ht * 0.55, cr * 0.65);
    return { x: qx + nx * pushOut, y: qy + ny * pushOut };
}

function applySpeedrunPortalMotionStep(p0x, p0y, px, py, cr) {
    const portals = speedrunPortalsNorm;
    if (!portals.length) return { x: px, y: py, trailBridge: null, split: null };

    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const ht = speedrunPortalHalfThicknessPx(ls);
    const gateBand = ht + cr * 2.1;

    let bestCross = null;

    for (const portal of portals) {
        if (speedrunPortalIsLatched(portal)) continue;
        const dest = speedrunPortalPairmate(portals, portal.group, portal.side);
        if (!dest) continue;

        const cross = speedrunPortalTryMotionCrossPx(p0x, p0y, px, py, portal, dest, w, h, gateBand);
        if (cross) {
            if (!bestCross || cross.tPortal < bestCross.cross.tPortal) {
                bestCross = { portal, dest, cross };
            }
        }
    }

    if (bestCross) {
        const { portal, dest, cross } = bestCross;
        const entryC0 = speedrunPortalClosestPx(portal, p0x, p0y, w, h, 0.18);
        const forced = speedrunPortalForcedExitPx(dest, cross.outX, cross.outY, entryC0.perp, cr);
        const outX = forced.x;
        const outY = forced.y;
        speedrunPortalExitLatch = { group: dest.group, side: dest.side, entryPerp: entryC0.perp };

        const c1 = speedrunPortalClosestPx(portal, cross.entryX, cross.entryY, w, h, 0.18);
        const splitRad = Math.max(cr * 0.95, ht * 0.6);
        let split = null;
        if (Math.abs(c1.perp) < splitRad) {
            const exitC = speedrunPortalClosestPx(dest, cross.exitX, cross.exitY, w, h);
            split = {
                entryX: cross.entryX,
                entryY: cross.entryY,
                exitX: outX,
                exitY: outY,
                qx: cross.entryX,
                qy: cross.entryY,
                nx: c1.frame.nx,
                ny: c1.frame.ny,
                exitQx: exitC.qx,
                exitQy: exitC.qy,
                exitNx: exitC.frame.nx,
                exitNy: exitC.frame.ny,
            };
        }
        return {
            x: outX,
            y: outY,
            trailBridge: {
                entryX: cross.entryX,
                entryY: cross.entryY,
                exitX: cross.exitX,
                exitY: cross.exitY,
            },
            split,
        };
    }

    let outX = px;
    let outY = py;
    let split = null;
    const splitRad = Math.max(cr * 0.95, ht * 0.6);

    for (const portal of portals) {
        const dest = speedrunPortalPairmate(portals, portal.group, portal.side);
        if (!dest) continue;
        const c0 = speedrunPortalClosestPx(portal, p0x, p0y, w, h, 0.18);
        const c1 = speedrunPortalClosestPx(portal, px, py, w, h, 0.18);
        if (!c1.onSegment || Math.abs(c1.perp) >= gateBand) continue;

        const planeEps = ht * 0.04;
        // Block walking through the portal plane without a warp (both sides).
        if (c0.perp > planeEps && c1.perp < -planeEps) {
            const eps = Math.max(ht * 0.15, cr * 0.1);
            outX = c1.qx + c1.frame.nx * eps;
            outY = c1.qy + c1.frame.ny * eps;
        } else if (c0.perp < -planeEps && c1.perp > planeEps) {
            const eps = Math.max(ht * 0.15, cr * 0.1);
            outX = c1.qx - c1.frame.nx * eps;
            outY = c1.qy - c1.frame.ny * eps;
        }

        if (Math.abs(c1.perp) > planeEps && Math.abs(c1.perp) < splitRad && !split) {
            const mapped = speedrunPortalMapPointPx(portal, dest, outX, outY, w, h);
            const exitC = speedrunPortalClosestPx(dest, mapped.x, mapped.y, w, h);
            split = {
                entryX: outX,
                entryY: outY,
                exitX: mapped.x,
                exitY: mapped.y,
                qx: c1.qx,
                qy: c1.qy,
                nx: c1.frame.nx,
                ny: c1.frame.ny,
                exitQx: exitC.qx,
                exitQy: exitC.qy,
                exitNx: exitC.frame.nx,
                exitNy: exitC.frame.ny,
            };
        }
    }

    return { x: outX, y: outY, trailBridge: null, split };
}

function applySpeedrunPortalMotion(p0x, p0y, px, py, cr) {
    speedrunPortalUpdateExitLatch(p0x, p0y, cr);
    const dist = Math.hypot(px - p0x, py - p0y);
    const stepLen = Math.max(3, cr * 0.28);
    const steps = Math.max(1, Math.ceil(dist / stepLen));
    let x = p0x;
    let y = p0y;
    let trailBridge = null;
    let split = null;
    for (let i = 1; i <= steps; i++) {
        const t = i / steps;
        const tx = p0x + (px - p0x) * t;
        const ty = p0y + (py - p0y) * t;
        const step = applySpeedrunPortalMotionStep(x, y, tx, ty, cr);
        if (step.trailBridge && !trailBridge) trailBridge = step.trailBridge;
        if (step.split) split = step.split;
        x = step.x;
        y = step.y;
        if (trailBridge) break;
    }
    speedrunPortalCursorSplit = split;
    return { x, y, trailBridge };
}

function speedrunPlaytestStartNorm() {
    const d = getSpeedrunLevelDef(speedrunActiveLevel);
    const ts = speedrunLevelTemporalSpawn(d);
    if (adminSpeedrunPlaytestActive && ts) return ts;
    return d.spawn;
}

function penaltyPlaytestStartNorm() {
    const d = getPenaltyLevelDef(penaltyRuntime.activeLevel);
    const ts = speedrunLevelTemporalSpawn(d);
    if (adminPenaltyPlaytestActive && ts) return ts;
    return d.spawn;
}

function speedrunSandboxSpeedrunStartNorm() {
    const d = getSpeedrunLevelDef(1);
    const ts = speedrunLevelTemporalSpawn(d);
    if (ts) return ts;
    return d.spawn;
}

function speedrunRespawnNormAfterLaserHit() {
    const cks = speedrunCheckpointsNorm;
    if (
        speedrunLastCheckpointIndex != null &&
        speedrunCheckpointsCollected.has(speedrunLastCheckpointIndex) &&
        cks[speedrunLastCheckpointIndex]
    ) {
        return cks[speedrunLastCheckpointIndex];
    }
    return getSpeedrunLevelDef(speedrunActiveLevel).spawn;
}

function speedrunCheckpointHitRadiusPx(sizeMul) {
    return speedrunCheckpointRadiusPx(sizeMul, gameLayoutScale());
}

function speedrunRespawnNormAtLevelStart() {
    if (adminSpeedrunPlaytestActive) return speedrunPlaytestStartNorm();
    if (gameMode === "sandbox" && sandboxRuntimeConfig?.speedrunMode) return speedrunSandboxSpeedrunStartNorm();
    return getSpeedrunLevelDef(speedrunActiveLevel).spawn;
}

function captureSpeedrunCheckpointProgressSnapshot() {
    speedrunCheckpointProgressSnapshot = {
        pointsCollected: new Set(speedrunPointsCollected),
        checkpointsCollected: new Set(speedrunCheckpointsCollected),
        lastCheckpointIndex: speedrunLastCheckpointIndex,
    };
}

function restoreSpeedrunCheckpointProgressSnapshot() {
    const snap = speedrunCheckpointProgressSnapshot;
    if (!snap) return;
    speedrunPointsCollected = new Set(snap.pointsCollected);
    speedrunCheckpointsCollected = new Set(snap.checkpointsCollected);
    speedrunLastCheckpointIndex = snap.lastCheckpointIndex;
    speedrunDisabledWallSegIndices.clear();
    speedrunDisabledMovingIndices.clear();
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    resetSpeedrunPortalFx();
    speedrunPortalCursorSplit = null;
    speedrunPortalTrailBridge = null;
    speedrunPortalExitLatch = null;
}

function resetSpeedrunProgressAndTimer() {
    speedrunPointsCollected = new Set();
    speedrunCheckpointsCollected = new Set();
    speedrunLastCheckpointIndex = null;
    speedrunCheckpointProgressSnapshot = null;
    speedrunDisabledWallSegIndices.clear();
    speedrunDisabledMovingIndices.clear();
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    resetSpeedrunPortalFx();
    speedrunPortalCursorSplit = null;
    speedrunPortalTrailBridge = null;
    speedrunPortalExitLatch = null;
    speedrunStartPerf = getGameSimNowMs();
}

function restartSpeedrunLevelProgressFromScratch() {
    resetSpeedrunProgressAndTimer();
    repositionCursorToSpeedrunNorm(speedrunRespawnNormAtLevelStart());
    speedrunStickyRail = null;
    speedrunLaserCollideTPrev = null;
    speedrunSolidMidVelPrev = [];
    if (settingEffectFlashes) triggerFlash("#ff3333", 0.1, 36);
    beep(220, 0.06);
}

function handleSpeedrunCheckpointLaserDeath() {
    deathPending = false;
    defeatGameMusicDuck = 1;
    if (speedrunLastCheckpointIndex != null && speedrunCheckpointProgressSnapshot) {
        restoreSpeedrunCheckpointProgressSnapshot();
        respawnSpeedrunFromLaserHit();
    } else {
        restartSpeedrunLevelProgressFromScratch();
    }
    trail = [];
    particles = [];
    screenShake = 0;
}

function beginSpeedrunCheckpointLaserDeath() {
    if (deathPending) return;
    pointerLockPauseSuppressedUntil = performance.now() + 900;
    endTouchCursorAnalogAny();
    deathPending = true;
    speedrunCheckpointDeathPending = true;
    deathStart = performance.now();
    gamePaused = false;
    hideEl(pauseScreen);
    leavePauseMenuCursorMode();
    exitGamePointerLock();
    frozenMouse = { x: mouse.x, y: mouse.y };
    if (!settingEffectParticles) {
        speedrunDeathFrozenTSec = getGameSimNowSec();
    } else {
        speedrunDeathFrozenTSec = -1;
    }
    trail = [];
    particles = [];
    defeatGameMusicDuck = 0.07;
    playCursorCrackSound();
    playDefeatSound();
    triggerFlash(deathCursorColor(), 0.28, 65);
    addShake(5);
    if (settingEffectParticles) startDeathCursorBreak(frozenMouse.x, frozenMouse.y);
    else deathCursorBreak = null;
    updateMobilePlayChrome();
    if (deathLoseDelayMs() === 0) {
        finishSpeedrunCheckpointDeath();
    }
}

function finishSpeedrunCheckpointDeath() {
    if (!speedrunCheckpointDeathPending) return;
    speedrunCheckpointDeathPending = false;
    speedrunDeathFrozenTSec = -1;
    deathCursorBreak = null;
    handleSpeedrunCheckpointLaserDeath();
    if (gameMode === "sandbox" && sandboxRuntimeConfig?.speedrunMode) {
        sandboxSpeedrunPrev.x = mouse.x;
        sandboxSpeedrunPrev.y = mouse.y;
        sandboxPointerTarget.x = mouse.x;
        sandboxPointerTarget.y = mouse.y;
        flushSpeedrunPointerIntent();
    }
    clearDeathState();
    tryRequestGamePointerLock();
    updateMobilePlayChrome();
}

function speedrunRespawnNormAtSpawn() {
    return getSpeedrunLevelDef(speedrunActiveLevel).spawn;
}

function repositionCursorToSpeedrunNorm(norm) {
    mouse.x = clamp(norm.nx, 0, 1) * canvas.width;
    mouse.y = clamp(norm.ny, 0, 1) * canvas.height;
    speedrunLastNorm.nx = clamp(norm.nx, 0, 1);
    speedrunLastNorm.ny = clamp(norm.ny, 0, 1);
    const inset = clampCursorXYToCanvas(mouse.x, mouse.y);
    mouse.x = inset.x;
    mouse.y = inset.y;
    resetRelativePointerAnchor();
    speedrunPrevMouse.x = mouse.x;
    speedrunPrevMouse.y = mouse.y;
    syncCursorAfterExplicitReposition();
}

function speedrunOfficialRespawnOnLaserHit() {
    return !isMultiplayerActive() && speedrunCheckpointsNorm.length > 0;
}

function respawnSpeedrunFromLaserHit() {
    const origin = speedrunRespawnNormAfterLaserHit();
    repositionCursorToSpeedrunNorm(origin);
    speedrunStickyRail = null;
    speedrunLaserCollideTPrev = null;
    if (settingEffectFlashes) triggerFlash("#ff3333", 0.1, 36);
    beep(220, 0.06);
}

function rebuildSpeedrunGeometry() {
    const mpSpeedrun = gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode();
    if (gameMode !== "speedrun" && gameMode !== "penalty" && !mpSpeedrun) return;
    const d =
        gameMode === "penalty"
            ? getPenaltyLevelDef(penaltyRuntime.activeLevel)
            : getSpeedrunLevelDef(speedrunActiveLevel);
    applySpeedrunDefToRuntime(d);
}

function rebuildPenaltyGeometry() {
    if (gameMode !== "penalty") return;
    speedrunActiveLevel = penaltyRuntime.activeLevel;
    const d = getPenaltyLevelDef(penaltyRuntime.activeLevel);
    applySpeedrunDefToRuntime(d);
}

function refreshSpeedrunGroupWallState() {
    speedrunDisabledWallSegIndices.clear();
    speedrunDisabledMovingIndices.clear();
    const pts = speedrunPointsNorm;
    const pointTypes = ["circle", "triangle", "square"];
    for (let g = 1; g <= 15; g++) {
        for (let ti = 0; ti < pointTypes.length; ti++) {
            const ptType = pointTypes[ti]!;
            const idxs = [];
            for (let i = 0; i < pts.length; i++) {
                if (pts[i].group !== g) continue;
                if (speedrunPointTypeOf(pts[i]) !== ptType) continue;
                idxs.push(i);
            }
            if (idxs.length === 0) continue;
            const all = idxs.every((i) => speedrunPointsCollected.has(i));
            if (!all) continue;
            for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
                const seg = speedrunWallSegDefs[wi];
                if (seg.toggleGroup !== g) continue;
                if (speedrunTogglePointTypeOf(seg) !== ptType) continue;
                speedrunDisabledWallSegIndices.add(wi);
            }
            for (let mi = 0; mi < speedrunMovingDefs.length; mi++) {
                const mv = speedrunMovingDefs[mi];
                if (mv.toggleGroup !== g) continue;
                if (speedrunTogglePointTypeOf(mv) !== ptType) continue;
                speedrunDisabledMovingIndices.add(mi);
            }
        }
    }
}

/** Combined wind direction (unit) and summed strength for push in overlapping zones. */
function getSpeedrunWindEffectAtNorm(nx, ny) {
    let wx = 0;
    let wy = 0;
    let strSum = 0;
    for (const z of speedrunWindDefs) {
        if (!normPointInWindZone(nx, ny, z)) continue;
        const u = speedrunWindDirUnit(z.dir);
        const s = speedrunWindStrengthValue(z);
        wx += u.x * s;
        wy += u.y * s;
        strSum += s;
    }
    const len = Math.hypot(wx, wy);
    if (len < 1e-8) return null;
    return { hx: wx / len, hy: wy / len, strength: strSum };
}

function drawSpeedrunWindWavesLayer(ctx, tSec) {
    const wv = canvas.width;
    const hv = canvas.height;
    const ls = gameLayoutScale();
    for (let wi = 0; wi < speedrunWindDefs.length; wi++) {
        const wz = speedrunWindDefs[wi];
        const x0 = wz.nx * wv;
        const y0 = wz.ny * hv;
        const ww = wz.nw * wv;
        const hh = wz.nh * hv;
        const u = speedrunWindDirUnit(wz.dir);
        const strM = speedrunWindStrengthValue(wz);
        ctx.save();
        ctx.beginPath();
        ctx.rect(x0, y0, ww, hh);
        ctx.clip();
        const cell = ls * Math.max(11, Math.min(24, 15 + strM * 0.35));
        const flow = 32 + strM * 14 + wi * 2.2;
        const phaseOff = wi * 1.7;
        for (let gx = x0 - cell; gx < x0 + ww + cell; gx += cell) {
            for (let gy = y0 - cell; gy < y0 + hh + cell; gy += cell) {
                const along = gx * u.x + gy * u.y;
                const ph = along * 0.045 - tSec * flow + phaseOff;
                const wob = Math.sin(ph);
                const len = ls * (4.5 + strM * 2.2) * (0.55 + 0.45 * Math.abs(wob));
                const a = 0.06 + 0.12 * (0.5 + 0.5 * wob);
                ctx.strokeStyle = `rgba(175,235,255,${a})`;
                ctx.lineWidth = ls * (1 + 0.35 * Math.min(strM, 3));
                ctx.beginPath();
                ctx.moveTo(gx - u.x * len * 0.5, gy - u.y * len * 0.5);
                ctx.lineTo(gx + u.x * len * 0.5, gy + u.y * len * 0.5);
                ctx.stroke();
            }
        }
        ctx.restore();
    }
}

function getSpeedrunSimTimeSec() {
    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode()) {
        return getMpSpeedrunSimTimeSec();
    }
    if (isLocalActive() && resumeCountdownActive && localSpeedrunFrozenTSec >= 0) {
        return localSpeedrunFrozenTSec;
    }
    if (isLocalActive() && isLocalSpeedrunRespawnPending() && localSpeedrunFrozenTSec >= 0) {
        return localSpeedrunFrozenTSec;
    }
    if (deathPending && speedrunDeathFrozenTSec >= 0) {
        return speedrunDeathFrozenTSec;
    }
    if (isPracticeGuideFrozen() && practiceGuideFrozenAtSec >= 0) {
        return practiceGuideFrozenAtSec;
    }
    return getGameSimNowSec();
}

function refreshSpeedrunFrameGeometry() {
    const speedrunGeomActive =
        gameMode === "speedrun" ||
        gameMode === "penalty" ||
        (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode()) ||
        (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode);
    if (!speedrunGeomActive) {
        return;
    }
    const tSec = getSpeedrunSimTimeSec();
    const w = canvas.width;
    const h = canvas.height;
    const m = Math.min(w, h);
    const ls = gameLayoutScale();
    const d =
        gameMode === "penalty"
            ? getPenaltyLevelDef(penaltyRuntime.activeLevel)
            : getSpeedrunLevelDef(speedrunActiveLevel);
    const gN = speedrunPointGoalPosNorm(d.goal.nx, d.goal.ny, d.goal.pathMove, d.goal.move, tSec);
    speedrunGoalPx = { x: gN.nx * w, y: gN.ny * h, half: d.goal.nHalf * m };
    speedrunStaticSegsPx = [];
    for (let i = 0; i < speedrunWallSegDefs.length; i++) {
        if (speedrunDisabledWallSegIndices.has(i)) continue;
        const sdef = speedrunWallSegDefs[i];
        const seg = wallSegToPx(sdef, tSec, w, h);
        speedrunStaticSegsPx.push({
            x1: seg.x1,
            y1: seg.y1,
            x2: seg.x2,
            y2: seg.y2,
            half: speedrunLaserHalfPxForWall(sdef, ls),
        });
    }
}

function speedrunYellowPointsUncollectedCount() {
    const pts = speedrunPointsNorm;
    let n = 0;
    for (let i = 0; i < pts.length; i++) {
        if (pts[i].group) continue;
        if (!speedrunPointsCollected.has(i)) n++;
    }
    return n;
}

function speedrunPointHitRadiusPx() {
    const ls = gameLayoutScale();
    return Math.max(14 * ls, getCursorRadiusForMode() * 1.25 + 10 * ls);
}

function speedrunPointHitRadiusPxFor(pts, i) {
    const ls = gameLayoutScale();
    const base = speedrunPointHitRadiusPx();
    const pt = pts[i];
    const mul = pt?.radiusMul;
    if (mul != null && Number.isFinite(mul)) return Math.max(8 * ls, Math.min(72 * ls, base * mul));
    return base;
}

function rebuildSandboxSpeedrunGeometry() {
    if (gameMode !== "sandbox" || !sandboxRuntimeConfig || !sandboxRuntimeConfig.speedrunMode) return;
    const d = normalizeLevelData(sandboxRuntimeConfig.speedrunLayout);
    setSpeedrunPlaytestOverride(1, d);
    speedrunActiveLevel = 1;
    applySpeedrunDefToRuntime(d);
}

function getSpeedrunMovingSegsPx(tSec) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const out = [];
    for (let i = 0; i < speedrunMovingDefs.length; i++) {
        if (speedrunDisabledMovingIndices.has(i)) continue;
        const d = speedrunMovingDefs[i];
        const s = movingLaserSegNorm(d, tSec);
        out.push({
            x1: s.ax * w,
            y1: s.ay * h,
            x2: s.bx * w,
            y2: s.by * h,
            half: speedrunLaserHalfPxForMoving(d, ls),
        });
    }
    return out;
}

function drawSpeedrunLayer() {
    const speedrunDrawActive =
        gameMode === "speedrun" ||
        gameMode === "penalty" ||
        (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode()) ||
        (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode);
    if (speedrunDrawActive) {
        const tSec = getSpeedrunSimTimeSec();
        const ls = gameLayoutScale();
        ctx.save();
        ctx.lineCap = "round";
        drawSpeedrunWindWavesLayer(ctx, tSec);
        const drawSegLaser = s => {
            ctx.beginPath();
            ctx.moveTo(s.x1, s.y1);
            ctx.lineTo(s.x2, s.y2);
            ctx.stroke();
        };
        for (let i = 0; i < speedrunWallSegDefs.length; i++) {
            if (speedrunDisabledWallSegIndices.has(i)) continue;
            const sdef = speedrunWallSegDefs[i];
            const s = wallSegToPx(sdef, tSec, canvas.width, canvas.height);
            ctx.lineWidth = speedrunLaserHalfPxForWall(sdef, ls) * 2;
            const a = wallDrawAlpha(sdef, adminPlaytestHideMoveVis, adminPlaytestHideRotVis);
            const tg = sdef.toggleGroup;
            if (sdef.solidWall) {
                ctx.shadowBlur = 0;
                let stroke = `rgba(118,122,138,${a})`;
                if (tg != null && typeof tg === "number") {
                    const { r, g, b } = speedrunGroupRgb(tg);
                    stroke = `rgba(${Math.round(r * 0.45 + 90)},${Math.round(g * 0.45 + 90)},${Math.round(
                        b * 0.45 + 95,
                    )},${a})`;
                }
                ctx.strokeStyle = stroke;
                drawSegLaser(s);
                continue;
            }
            let stroke = `rgba(255,34,34,${a})`;
            let glow = `rgba(255,0,0,${a})`;
            if (tg != null && typeof tg === "number") {
                const { r, g, b } = speedrunGroupRgb(tg);
                stroke = `rgba(${r},${g},${b},${a})`;
                glow = `rgba(${r},${g},${b},${Math.min(1, a + 0.15)})`;
            }
            ctx.strokeStyle = stroke;
            ctx.shadowColor = glow;
            ctx.shadowBlur = 10 * ls;
            drawSegLaser(s);
        }
        ctx.shadowBlur = 0;
        ctx.globalAlpha = 1;
        for (let mi = 0; mi < speedrunMovingDefs.length; mi++) {
            if (speedrunDisabledMovingIndices.has(mi)) continue;
            const mvDef = speedrunMovingDefs[mi];
            const s = movingLaserSegNorm(mvDef, tSec);
            const sx1 = s.ax * canvas.width;
            const sy1 = s.ay * canvas.height;
            const sx2 = s.bx * canvas.width;
            const sy2 = s.by * canvas.height;
            const tgM = mvDef.toggleGroup;
            let strokeM = "#ff9944";
            let glowM = "rgba(255,120,40,0.55)";
            if (tgM != null && typeof tgM === "number") {
                const { r, g, b } = speedrunGroupRgb(tgM);
                strokeM = `rgb(${r},${g},${b})`;
                glowM = `rgba(${r},${g},${b},0.85)`;
            }
            ctx.strokeStyle = strokeM;
            ctx.shadowColor = glowM;
            ctx.shadowBlur = 10 * ls;
            ctx.lineWidth = speedrunLaserHalfPxForMoving(mvDef, ls) * 2;
            ctx.beginPath();
            ctx.moveTo(sx1, sy1);
            ctx.lineTo(sx2, sy2);
            ctx.stroke();
        }
        ctx.shadowBlur = 0;

        for (let i = 0; i < speedrunPointsNorm.length; i++) {
            if (speedrunPointsCollected.has(i)) continue;
            const pt = speedrunPointsNorm[i];
            const pos = speedrunPointGoalPosNorm(pt.nx, pt.ny, pt.pathMove, pt.move, tSec);
            const pnx = pos.nx * canvas.width;
            const pny = pos.ny * canvas.height;
            const bob = Math.sin(tSec * 3 + i) * 4 * ls;
            const rDot = Math.max(4 * ls, Math.min(22 * ls, 9 * ls * (pt.radiusMul ?? 1)));
            let fill = "#fff25a";
            let sh = "#ffe500";
            if (pt.group != null && typeof pt.group === "number") {
                const { r, g, b } = speedrunGroupRgb(pt.group);
                fill = `rgb(${r},${g},${b})`;
                sh = pt.group === 7 ? "rgba(200,210,255,0.95)" : `rgba(${r},${g},${b},0.95)`;
            }
            ctx.fillStyle = fill;
            ctx.shadowColor = sh;
            ctx.shadowBlur = 18 * ls;
            drawSpeedrunPointShape(ctx, pnx, pny + bob, rDot, speedrunPointTypeOf(pt), pt.rotationDeg ?? 0);
            ctx.shadowBlur = 0;
        }

        for (let i = 0; i < speedrunCheckpointsNorm.length; i++) {
            const ckDef = speedrunCheckpointsNorm[i];
            const ckPos = speedrunPointGoalPosNorm(ckDef.nx, ckDef.ny, ckDef.pathMove, ckDef.move, tSec);
            const ckx = ckPos.nx * canvas.width;
            const cky = ckPos.ny * canvas.height;
            const ckBob = Math.sin(tSec * 3 + i * 0.7) * 4 * ls;
            const ckR = speedrunCheckpointRadiusPx(ckDef.sizeMul, ls);
            const activated = speedrunCheckpointsCollected.has(i);
            ctx.shadowColor = activated ? "rgba(80,255,160,0.95)" : "rgba(45,110,75,0.55)";
            ctx.shadowBlur = activated ? 22 * ls : 10 * ls;
            drawSpeedrunCheckpointDeltoid(ctx, ckx, cky + ckBob, ckR, activated, ckDef.rotationDeg ?? 0);
            ctx.shadowBlur = 0;
        }

        drawSpeedrunPortals(ctx, speedrunPortalsNorm, canvas.width, canvas.height, tSec, { lineScale: ls });

        const g = speedrunGoalPx;
        const rgb = hexToRgb(settingBallsColor);
        ctx.fillStyle = settingBallsColor;
        ctx.shadowColor = `rgba(${rgb.r},${rgb.g},${rgb.b},0.95)`;
        ctx.shadowBlur = 28 * ls;
        const side = g.half * 2;
        const goalRot = (getSpeedrunLevelDef(speedrunActiveLevel).goal.rotationDeg ?? 0) * (Math.PI / 180);
        ctx.save();
        ctx.translate(g.x, g.y);
        if (goalRot) ctx.rotate(goalRot);
        ctx.fillRect(-g.half, -g.half, side, side);
        ctx.restore();
        ctx.shadowBlur = 0;
        for (const t of speedrunTextDefs) {
            drawSpeedrunTextLabel(ctx, t, canvas.width, canvas.height);
        }
        ctx.restore();
        return;
    }
}

/**
 * Whether the cursor segment (p0→p1) hits a laser between `t0` and `t1` (seconds).
 * Samples along the cursor path with the same progress through the frame’s time window,
 * so rotating or oscillating lasers cannot “teleport” through the stroke between frames.
 */
function speedrunCursorPathHitsLasers(px0, py0, px1, py1, cr, t0, t1) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    let maxHalf = SPEEDRUN_LASER_HALF_BASE_PX * 5 * ls;
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (sdef.solidWall) continue;
        maxHalf = Math.max(maxHalf, speedrunLaserHalfPxForWall(sdef, ls));
    }
    for (let mi = 0; mi < speedrunMovingDefs.length; mi++) {
        if (speedrunDisabledMovingIndices.has(mi)) continue;
        maxHalf = Math.max(maxHalf, speedrunLaserHalfPxForMoving(speedrunMovingDefs[mi], ls));
    }
    const dist = Math.hypot(px1 - px0, py1 - py0);
    const stepPx = Math.max(2.5, (cr + maxHalf) * 0.42);
    const spatialSteps = Math.max(1, Math.ceil(dist / stepPx));
    const dt = Math.max(0, t1 - t0);
    const extraTimeSteps = dt < 1e-9 ? 0 : Math.min(48, 2 + Math.floor(dt * 100));
    const steps = Math.max(spatialSteps, extraTimeSteps, 8);
    for (let i = 0; i <= steps; i++) {
        const u = i / steps;
        const px = px0 + (px1 - px0) * u;
        const py = py0 + (py1 - py0) * u;
        const t = t0 + (t1 - t0) * u;
        for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
            if (speedrunDisabledWallSegIndices.has(wi)) continue;
            const sdef = speedrunWallSegDefs[wi];
            if (sdef.solidWall) continue;
            const seg = wallSegToPx(sdef, t, w, h);
            const half = speedrunLaserHalfPxForWall(sdef, ls);
            if (distPointToSeg(px, py, seg.x1, seg.y1, seg.x2, seg.y2) < cr + half) return true;
        }
        for (let mi = 0; mi < speedrunMovingDefs.length; mi++) {
            if (speedrunDisabledMovingIndices.has(mi)) continue;
            const d = speedrunMovingDefs[mi];
            const s = movingLaserSegNorm(d, t);
            const half = speedrunLaserHalfPxForMoving(d, ls);
            const x1 = s.ax * w;
            const y1 = s.ay * h;
            const x2 = s.bx * w;
            const y2 = s.by * h;
            if (distPointToSeg(px, py, x1, y1, x2, y2) < cr + half) return true;
        }
    }
    return false;
}

function speedrunClosestPointOnSegPx(px, py, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len2 = dx * dx + dy * dy;
    if (len2 < 1e-12) return { qx: x1, qy: y1, dist: Math.hypot(px - x1, py - y1) };
    let t = ((px - x1) * dx + (py - y1) * dy) / len2;
    t = Math.max(0, Math.min(1, t));
    const qx = x1 + t * dx;
    const qy = y1 + t * dy;
    return { qx, qy, dist: Math.hypot(px - qx, py - qy) };
}

/**
 * Shared px slack: segment–wall clearance test and push-out must agree; otherwise the cursor can sit
 * in a band where motion is always “blocked” but no push runs → freeze on the wall.
 */
function speedrunSolidGeomEps() {
    return 0.08 * gameLayoutScale();
}

/** Max cursor motion (px) per solid-wall CCD sub-step — must stay below combined capsule diameter. */
function speedrunSolidMotionMaxStepPx(cr) {
    const ls = gameLayoutScale();
    let maxHalf = SPEEDRUN_LASER_HALF_BASE_PX * ls * 0.5;
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (!sdef.solidWall) continue;
        maxHalf = Math.max(maxHalf, speedrunLaserHalfPxForWall(sdef, ls));
    }
    return Math.max(0.75, (cr + maxHalf) * 0.28);
}

/**
 * Push a point out of solid (`solidWall`) capsules. `prevPx/prevPy` bias the escape normal when the
 * cursor lies on the segment axis (degenerate closest point).
 * Optional `intentDx/intentDy` are ignored for degenerate escape — aligning degenerate normals with
 * intent can push the cursor *through* a moving capsule when intent crosses the wall (tunneling).
 */
function speedrunResolveAgainstSolidWallsCore(px, py, cr, tSec, prevPx, prevPy, intentDx, intentDy) {
    void intentDx;
    void intentDy;
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    let cx = px;
    let cy = py;
    for (let iter = 0; iter < 14; iter++) {
        let moved = false;
        for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
            if (speedrunDisabledWallSegIndices.has(wi)) continue;
            const sdef = speedrunWallSegDefs[wi];
            if (!sdef.solidWall) continue;
            const seg = wallSegToPx(sdef, tSec, w, h);
            const half = speedrunLaserHalfPxForWall(sdef, ls);
            const capR = cr + half;
            const cp = speedrunClosestPointOnSegPx(cx, cy, seg.x1, seg.y1, seg.x2, seg.y2);
            if (cp.dist >= capR - speedrunSolidGeomEps()) continue;
            if (cp.dist > 1e-4) {
                const nx = (cx - cp.qx) / cp.dist;
                const ny = (cy - cp.qy) / cp.dist;
                cx += nx * (capR - cp.dist);
                cy += ny * (capR - cp.dist);
            } else {
                const sdx = seg.x2 - seg.x1;
                const sdy = seg.y2 - seg.y1;
                const sl = Math.hypot(sdx, sdy) || 1;
                let nx = -sdy / sl;
                let ny = sdx / sl;
                const dot = nx * (cx - prevPx) + ny * (cy - prevPy);
                if (dot < 0) {
                    nx = -nx;
                    ny = -ny;
                }
                cx += nx * capR;
                cy += ny * capR;
            }
            moved = true;
        }
        if (!moved) break;
    }
    const m = clampCursorXYToCanvas(cx, cy);
    return { x: m.x, y: m.y };
}

/** If the point still overlaps the swept moving-solid volume or end pose, push out once (anti-tunnel). */
function speedrunSealSolidIfOverlappingPoint(px, py, cr, tWall0, tWall1) {
    if (speedrunMotionSegmentClearOfSolids(px, py, px, py, cr, tWall0, tWall1)) return { x: px, y: py };
    return speedrunResolveAgainstSolidWallsCore(px, py, cr, tWall1, speedrunPrevMouse.x, speedrunPrevMouse.y, undefined, undefined);
}

function speedrunResolveAgainstSolidWalls(px, py, cr, tSec, intentDx, intentDy) {
    return speedrunResolveAgainstSolidWallsCore(
        px,
        py,
        cr,
        tSec,
        speedrunPrevMouse.x,
        speedrunPrevMouse.y,
        intentDx,
        intentDy,
    );
}

/**
 * True iff cursor motion (ax,ay)→(bx,by) stays clear of solid wall capsules while wall time runs from
 * `tWallStart` to `tWallEnd` (same clock fraction for wall pose and cursor position). This matches CCD
 * when both move in one frame; sub-segments must pass a shortened `tWallEnd` (see clip binary search).
 */
function speedrunMotionSegmentClearOfSolids(ax, ay, bx, by, cr, tWallStart, tWallEnd) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const dMove = Math.hypot(bx - ax, by - ay);
    const dtWall = tWallEnd - tWallStart;
    const span = Math.abs(dtWall);
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (!sdef.solidWall) continue;
        const half = speedrunLaserHalfPxForWall(sdef, ls);
        const minClear = cr + half - speedrunSolidGeomEps();
        const anim = wallSolidAnimatesAtRuntime(sdef);
        if (!anim) {
            const seg = wallSegToPx(sdef, tWallEnd, w, h);
            const d =
                dMove < 1e-4
                    ? distPointToSeg(ax, ay, seg.x1, seg.y1, seg.x2, seg.y2)
                    : distSegToSeg2D(ax, ay, bx, by, seg.x1, seg.y1, seg.x2, seg.y2);
            if (d < minClear) return false;
            continue;
        }
        if (span < 1e-8) {
            const seg = wallSegToPx(sdef, tWallStart, w, h);
            const d =
                dMove < 1e-4
                    ? distPointToSeg(ax, ay, seg.x1, seg.y1, seg.x2, seg.y2)
                    : distSegToSeg2D(ax, ay, bx, by, seg.x1, seg.y1, seg.x2, seg.y2);
            if (d < minClear) return false;
            continue;
        }
        const segA = wallSegToPx(sdef, tWallStart, w, h);
        const segB = wallSegToPx(sdef, tWallEnd, w, h);
        const dispW = Math.max(
            Math.hypot(segA.x1 - segB.x1, segA.y1 - segB.y1),
            Math.hypot(segA.x2 - segB.x2, segA.y2 - segB.y2),
        );
        const stepPx = Math.max(0.35, minClear * 0.32);
        const nMove = Math.ceil(dMove / stepPx);
        const nWall = Math.ceil(dispW / stepPx);
        const nTime = Math.min(512, Math.max(2, nMove, nWall));
        for (let si = 0; si < nTime; si++) {
            const u0 = si / nTime;
            const u1 = (si + 1) / nTime;
            const c0x = ax + (bx - ax) * u0;
            const c0y = ay + (by - ay) * u0;
            const c1x = ax + (bx - ax) * u1;
            const c1y = ay + (by - ay) * u1;
            const t0 = tWallStart + dtWall * u0;
            const t1 = tWallStart + dtWall * u1;
            const seg0 = wallSegToPx(sdef, t0, w, h);
            const seg1 = wallSegToPx(sdef, t1, w, h);
            const d0 = distSegToSeg2D(c0x, c0y, c1x, c1y, seg0.x1, seg0.y1, seg0.x2, seg0.y2);
            if (d0 < minClear) return false;
            const d1 = distSegToSeg2D(c0x, c0y, c1x, c1y, seg1.x1, seg1.y1, seg1.x2, seg1.y2);
            if (d1 < minClear) return false;
        }
    }
    return true;
}

/**
 * Geometric motion clamp against solid walls: segment p0→p1 cannot cross the wall capsule
 * (distance segment–segment vs centerline + thickness). Then push with Core for sliding.
 */
function speedrunClipSolidOneShot(p0x, p0y, t1x, t1y, cr, tWall0, tWall1) {
    const idX = t1x - p0x;
    const idY = t1y - p0y;
    if (!speedrunMotionSegmentClearOfSolids(p0x, p0y, p0x, p0y, cr, tWall0, tWall1)) {
        return speedrunResolveAgainstSolidWallsCore(p0x, p0y, cr, tWall1, speedrunPrevMouse.x, speedrunPrevMouse.y, idX, idY);
    }
    if (speedrunMotionSegmentClearOfSolids(p0x, p0y, t1x, t1y, cr, tWall0, tWall1)) {
        return speedrunResolveAgainstSolidWallsCore(t1x, t1y, cr, tWall1, p0x, p0y, idX, idY);
    }
    let lo = 0;
    let hi = 1;
    for (let k = 0; k < 44; k++) {
        const mid = (lo + hi) * 0.5;
        const mx = p0x + (t1x - p0x) * mid;
        const my = p0y + (t1y - p0y) * mid;
        const tPart = tWall0 + (tWall1 - tWall0) * mid;
        if (speedrunMotionSegmentClearOfSolids(p0x, p0y, mx, my, cr, tWall0, tPart)) lo = mid;
        else hi = mid;
    }
    const qx = p0x + (t1x - p0x) * lo;
    const qy = p0y + (t1y - p0y) * lo;
    const tHit = tWall0 + (tWall1 - tWall0) * lo;
    return speedrunResolveAgainstSolidWallsCore(qx, qy, cr, tHit, p0x, p0y, idX, idY);
}

/** If normal motion is almost fully clipped, try moving only along the nearest wall tangent. */
function speedrunSolidSlideTarget(p0x, p0y, p1x, p1y, cr, tSec) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const dx = p1x - p0x;
    const dy = p1y - p0y;
    const dIn = Math.hypot(dx, dy);
    if (dIn < 1e-6) return null;
    let pick = null;
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (!sdef.solidWall) continue;
        const seg = wallSegToPx(sdef, tSec, w, h);
        const half = speedrunLaserHalfPxForWall(sdef, ls);
        const capR = cr + half;
        const cp = speedrunClosestPointOnSegPx(p0x, p0y, seg.x1, seg.y1, seg.x2, seg.y2);
        const d0 = cp.dist;
        if (d0 > capR + 20 * ls) continue;
        const sdx = seg.x2 - seg.x1;
        const sdy = seg.y2 - seg.y1;
        const sl = Math.hypot(sdx, sdy);
        if (sl < 1e-8) continue;
        const ux = sdx / sl;
        const uy = sdy / sl;
        const slide = dx * ux + dy * uy;
        if (!pick || d0 < pick.dContact - 1e-4) {
            pick = { dContact: d0, ux, uy, slide };
        }
    }
    if (!pick || Math.abs(pick.slide) < 1e-5) return null;
    return { x: p0x + pick.ux * pick.slide, y: p0y + pick.uy * pick.slide };
}

function speedrunClipSolidMotionAgainstWalls(p0x, p0y, p1x, p1y, cr, tWall0, tWall1) {
    const dIn = Math.hypot(p1x - p0x, p1y - p0y);
    const maxStep = speedrunSolidMotionMaxStepPx(cr);
    const steps = Math.max(1, Math.ceil(dIn / maxStep));
    let cx = p0x;
    let cy = p0y;
    for (let i = 1; i <= steps; i++) {
        const u = i / steps;
        const tx = p0x + (p1x - p0x) * u;
        const ty = p0y + (p1y - p0y) * u;
        const tw0 = tWall0 + (tWall1 - tWall0) * ((i - 1) / steps);
        const tw = tWall0 + (tWall1 - tWall0) * u;
        let out = speedrunClipSolidOneShot(cx, cy, tx, ty, cr, tw0, tw);
        const dStep = Math.hypot(out.x - cx, out.y - cy);
        const dWant = Math.hypot(tx - cx, ty - cy);
        if (dWant > 2.6 && dStep < dWant * 0.22) {
            const st = speedrunSolidSlideTarget(cx, cy, tx, ty, cr, tw);
            if (st) {
                const dSlide = Math.hypot(st.x - cx, st.y - cy);
                const lamS = dWant < 1e-8 ? 1 : Math.min(1, dSlide / dWant);
                const tSlideEnd = tw0 + (tw - tw0) * lamS;
                const out2 = speedrunClipSolidOneShot(cx, cy, st.x, st.y, cr, tw0, tSlideEnd);
                if (Math.hypot(out2.x - cx, out2.y - cy) > dStep + 0.35) out = out2;
            }
        }
        cx = out.x;
        cy = out.y;
    }
    return { x: cx, y: cy };
}

function speedrunHasAnimatingSolidWall() {
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (sdef.solidWall && wallSolidAnimatesAtRuntime(sdef)) return true;
    }
    return false;
}

/** Push point out of solid capsules sampled along the frame wall-clock window (rotating/moving walls). */
function speedrunResolveAgainstSolidWallsSweepAnimated(px, py, cr, tWall0, tWall1, prevPx, prevPy, intentDx, intentDy) {
    const dt = tWall1 - tWall0;
    if (Math.abs(dt) < 1e-8)
        return speedrunResolveAgainstSolidWallsCore(px, py, cr, tWall1, prevPx, prevPy, intentDx, intentDy);
    const n = Math.min(32, Math.max(10, Math.ceil(10 + Math.abs(dt) * 55)));
    let cx = px;
    let cy = py;
    for (let si = 0; si <= n; si++) {
        const tt = tWall0 + (dt * si) / n;
        const r = speedrunResolveAgainstSolidWallsCore(cx, cy, cr, tt, prevPx, prevPy, intentDx, intentDy);
        cx = r.x;
        cy = r.y;
    }
    return { x: cx, y: cy };
}

function speedrunStickyWallMidVelocity(wi, tSec) {
    const eps = 1 / 120;
    const w = canvas.width;
    const h = canvas.height;
    const sdef = speedrunWallSegDefs[wi];
    const s0 = wallSegToPx(sdef, Math.max(0, tSec - eps), w, h);
    const s1 = wallSegToPx(sdef, tSec, w, h);
    const mx0 = (s0.x1 + s0.x2) * 0.5;
    const my0 = (s0.y1 + s0.y2) * 0.5;
    const mx1 = (s1.x1 + s1.x2) * 0.5;
    const my1 = (s1.y1 + s1.y2) * 0.5;
    const invEps = 1 / eps;
    return { vx: (mx1 - mx0) * invEps, vy: (my1 - my0) * invEps };
}

/** Updates midpoint-velocity samples and clears sticky rail when drive reverses (dot product negative). */
function speedrunStickyUpdateMidVelAndMaybeReleaseRail(tSec) {
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (!sdef.solidWall || !wallSolidAnimatesAtRuntime(sdef)) continue;
        const prev = speedrunSolidMidVelPrev[wi];
        const v = speedrunStickyWallMidVelocity(wi, tSec);
        if (
            speedrunStickyRail != null &&
            speedrunStickyRail.wi === wi &&
            prev &&
            typeof prev.vx === "number"
        ) {
            const dot = prev.vx * v.vx + prev.vy * v.vy;
            const m0 = Math.hypot(prev.vx, prev.vy);
            const m1 = Math.hypot(v.vx, v.vy);
            if (m0 > 1e-4 && m1 > 1e-4 && dot < -0.12 * m0 * m1) speedrunStickyRail = null;
        }
        speedrunSolidMidVelPrev[wi] = v;
    }
}

function speedrunStickyRailResolve(wi, u, cr, tSec, prevCx, prevCy) {
    const sdef = speedrunWallSegDefs[wi];
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    const seg = wallSegToPx(sdef, tSec, w, h);
    const half = speedrunLaserHalfPxForWall(sdef, ls);
    const capR = cr + half;
    const dx = seg.x2 - seg.x1;
    const dy = seg.y2 - seg.y1;
    const len = Math.hypot(dx, dy) || 1;
    const qx = seg.x1 + u * dx;
    const qy = seg.y1 + u * dy;
    let nx = -dy / len;
    let ny = dx / len;
    const vx = prevCx - qx;
    const vy = prevCy - qy;
    if (nx * vx + ny * vy < 0) {
        nx = -nx;
        ny = -ny;
    }
    return clampCursorXYToCanvas(qx + nx * capR, qy + ny * capR);
}

/** Goal cube acts as a solid until required (ungrouped) points are collected. */
function speedrunPushCircleOutOfLockedGoal(cx, cy, cr, gx, gy, half) {
    const left = gx - half;
    const top = gy - half;
    const right = gx + half;
    const bottom = gy + half;
    const qx = Math.max(left, Math.min(cx, right));
    const qy = Math.max(top, Math.min(cy, bottom));
    const dx = cx - qx;
    const dy = cy - qy;
    const dist = Math.hypot(dx, dy);
    const eps = Math.max(1e-4, speedrunSolidGeomEps() * 0.5);
    if (dist >= cr - eps) return { x: cx, y: cy };
    if (dist < 1e-8) {
        const dl = cx - left;
        const dr = right - cx;
        const dt = cy - top;
        const db = bottom - cy;
        const minD = Math.min(dl, dr, dt, db);
        if (minD === dl) return { x: left - cr, y: cy };
        if (minD === dr) return { x: right + cr, y: cy };
        if (minD === dt) return { x: cx, y: top - cr };
        return { x: cx, y: bottom + cr };
    }
    const nx = dx / dist;
    const ny = dy / dist;
    return { x: qx + nx * cr, y: qy + ny * cr };
}

/**
 * Prevents tunneling through the locked goal at high speed: tests the segment prev→next,
 * finds the first param where the cursor circle overlaps the goal, and stops + pushes out.
 */
function speedrunSweepSegmentPastLockedGoal(ax, ay, bx, by, cr, gx, gy, half) {
    const gl = gx - half;
    const gt = gy - half;
    const side = half * 2;
    const ov = (x, y) => circleRectOverlap(x, y, cr, gl, gt, side, side);

    if (ov(ax, ay)) {
        const po = speedrunPushCircleOutOfLockedGoal(ax, ay, cr, gx, gy, half);
        const c = clampCursorXYToCanvas(po.x, po.y);
        ax = c.x;
        ay = c.y;
    }

    const dx = bx - ax;
    const dy = by - ay;
    const segLen = Math.hypot(dx, dy);
    if (segLen < 1e-6) {
        if (ov(bx, by)) {
            const po = speedrunPushCircleOutOfLockedGoal(bx, by, cr, gx, gy, half);
            return clampCursorXYToCanvas(po.x, po.y);
        }
        return { x: bx, y: by };
    }

    const ls = gameLayoutScale();
    const stepPx = Math.max(2.5 * ls, cr * 0.14);
    const STEPS = Math.min(320, Math.max(56, Math.ceil(segLen / stepPx)));
    let firstOver = -1;
    for (let i = 1; i <= STEPS; i++) {
        const t = i / STEPS;
        if (ov(ax + dx * t, ay + dy * t)) {
            firstOver = i;
            break;
        }
    }
    if (firstOver < 0) return { x: bx, y: by };

    let lo = (firstOver - 1) / STEPS;
    let hi = firstOver / STEPS;
    for (let j = 0; j < 20; j++) {
        const mid = (lo + hi) * 0.5;
        if (ov(ax + dx * mid, ay + dy * mid)) hi = mid;
        else lo = mid;
    }
    const tSafe = Math.max(0, lo - 1e-5);
    const sx = ax + dx * tSafe;
    const sy = ay + dy * tSafe;
    const pushed = speedrunPushCircleOutOfLockedGoal(sx, sy, cr, gx, gy, half);
    return clampCursorXYToCanvas(pushed.x, pushed.y);
}

function speedrunTryAttachStickyRail(cx, cy, cr, tSec) {
    if (speedrunStickyRail != null) return;
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    for (let wi = 0; wi < speedrunWallSegDefs.length; wi++) {
        if (speedrunDisabledWallSegIndices.has(wi)) continue;
        const sdef = speedrunWallSegDefs[wi];
        if (!sdef.solidWall || !wallSolidAnimatesAtRuntime(sdef)) continue;
        const seg = wallSegToPx(sdef, tSec, w, h);
        const half = speedrunLaserHalfPxForWall(sdef, ls);
        const capR = cr + half;
        const cp = speedrunClosestPointOnSegPx(cx, cy, seg.x1, seg.y1, seg.x2, seg.y2);
        if (cp.dist >= capR - speedrunSolidGeomEps()) continue;
        const dx = seg.x2 - seg.x1;
        const dy = seg.y2 - seg.y1;
        const len2 = dx * dx + dy * dy;
        let u = 0.5;
        if (len2 > 1e-12) {
            u = ((cx - seg.x1) * dx + (cy - seg.y1) * dy) / len2;
            u = Math.max(0, Math.min(1, u));
        }
        speedrunStickyRail = { wi, u };
        return;
    }
}

function handleSpeedrunCollisions() {
    const tSec = getSpeedrunSimTimeSec();
    const sbSandboxSr = gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode;
    try {
    const cr = getCursorRadiusForMode();
    let rawMx = mouse.x;
    let rawMy = mouse.y;
    const p0x = speedrunPrevMouse.x;
    const p0y = speedrunPrevMouse.y;
    let intentDx;
    let intentDy;
    const sbSandboxSrMouse = sbSandboxSr && !sandboxRuntimeConfig.wasdEnabled;
    if (isOfficialSpeedrunPointerMode() || sbSandboxSrMouse) {
        intentDx = speedrunPointerIntentDx;
        intentDy = speedrunPointerIntentDy;
        speedrunPointerIntentDx = 0;
        speedrunPointerIntentDy = 0;
    } else {
        intentDx = rawMx - p0x;
        intentDy = rawMy - p0y;
    }
    const midNx = ((p0x + rawMx) / 2 / canvas.width);
    const midNy = ((p0y + rawMy) / 2 / canvas.height);
    const windFx = getSpeedrunWindEffectAtNorm(midNx, midNy);
    if (windFx) {
        const kOp = intentDx * windFx.hx + intentDy * windFx.hy;
        if (kOp < 0) {
            const keepOppose = 0.52;
            const k2 = kOp * keepOppose;
            intentDx += (k2 - kOp) * windFx.hx;
            intentDy += (k2 - kOp) * windFx.hy;
        }
        const pWind = speedrunWindPrevT == null ? 1 / 60 : Math.min(0.05, Math.max(1 / 240, tSec - speedrunWindPrevT));
        speedrunWindPrevT = tSec;
        const pushBase = 68 * gameLayoutScale();
        const push = pushBase * windFx.strength * pWind;
        intentDx += windFx.hx * push;
        intentDy += windFx.hy * push;
    } else {
        speedrunWindPrevT = null;
    }
    rawMx = p0x + intentDx;
    rawMy = p0y + intentDy;
    mouse.x = rawMx;
    mouse.y = rawMy;
    /** Raw desired delta this frame — sweeps / resolve use for moving solid walls. */
    let tLaser0 = speedrunLaserCollideTPrev == null ? tSec : speedrunLaserCollideTPrev;
    const dtRaw = Math.max(0, tSec - tLaser0);
    const dtCap = 0.22;
    if (dtRaw > dtCap) tLaser0 = tSec - dtCap;
    refreshSpeedrunFrameGeometry();

    if (speedrunStickyRail != null) {
        const wi = speedrunStickyRail.wi;
        const bad =
            wi < 0 ||
            wi >= speedrunWallSegDefs.length ||
            speedrunDisabledWallSegIndices.has(wi);
        const sdef = !bad ? speedrunWallSegDefs[wi] : null;
        if (bad || !sdef.solidWall || !wallSolidAnimatesAtRuntime(sdef)) {
            speedrunStickyRail = null;
        }
    }
    speedrunStickyUpdateMidVelAndMaybeReleaseRail(tSec);

    let portalRes = applySpeedrunPortalMotion(p0x, p0y, rawMx, rawMy, cr);
    let portalWarped = !!portalRes.trailBridge;
    if (!portalWarped) {
        const solidFirst = speedrunClipSolidMotionAgainstWalls(p0x, p0y, rawMx, rawMy, cr, tLaser0, tSec);
        const solidFirstSealed = speedrunSealSolidIfOverlappingPoint(solidFirst.x, solidFirst.y, cr, tLaser0, tSec);
        portalRes = applySpeedrunPortalMotion(p0x, p0y, solidFirstSealed.x, solidFirstSealed.y, cr);
        portalWarped = !!portalRes.trailBridge;
    }

    let px;
    let py;
    let onStickyRail = false;
    if (portalWarped) {
        const latch = speedrunPortalExitLatch;
        const destPortal = latch && speedrunPortalFindByGroupSide(latch.group, latch.side);
        if (destPortal) {
            const forced = speedrunPortalForcedExitPx(
                destPortal,
                portalRes.x,
                portalRes.y,
                latch.entryPerp ?? 0,
                cr,
            );
            px = forced.x;
            py = forced.y;
        } else {
            px = portalRes.x;
            py = portalRes.y;
        }
    } else if (speedrunStickyRail != null) {
        onStickyRail = true;
        const { wi, u } = speedrunStickyRail;
        const r = speedrunStickyRailResolve(wi, u, cr, tSec, p0x, p0y);
        px = r.x;
        py = r.y;
    } else {
        px = portalRes.x;
        py = portalRes.y;
        const reclipped = speedrunClipSolidMotionAgainstWalls(p0x, p0y, px, py, cr, tLaser0, tSec);
        const sealedClip = speedrunSealSolidIfOverlappingPoint(reclipped.x, reclipped.y, cr, tLaser0, tSec);
        px = sealedClip.x;
        py = sealedClip.y;
        if (portalRes.x !== px || portalRes.y !== py) {
            portalRes = { x: px, y: py, trailBridge: portalRes.trailBridge, split: portalRes.split };
        }
    }
    mouse.x = px;
    mouse.y = py;
    speedrunPortalUpdateExitLatch(px, py, cr);
    if (portalRes.trailBridge) {
        speedrunPortalTrailBridge = portalRes.trailBridge;
        playSpeedrunPortalWarpSound();
        const br = portalRes.trailBridge;
        const ls = gameLayoutScale();
        let burstColor = "#7ef0ff";
        const w = canvas.width;
        const h = canvas.height;
        for (const portal of speedrunPortalsNorm) {
            const near = speedrunPortalClosestPx(portal, br.entryX, br.entryY, w, h);
            if (Math.abs(near.perp) < speedrunPortalHalfThicknessPx(ls) * 3.2) {
                burstColor = speedrunPortalColor(portal.group, portal.side);
                break;
            }
        }
        emitSpeedrunPortalAbsorbBurst(br.entryX, br.entryY, burstColor, ls);
        speedrunPrevMouse.x = px;
        speedrunPrevMouse.y = py;
    }
    const pts = speedrunPointsNorm;
    let pickedSpeedrunPoint = false;
    for (let i = 0; i < pts.length; i++) {
        if (speedrunPointsCollected.has(i)) continue;
        const pos = speedrunPointGoalPosNorm(pts[i].nx, pts[i].ny, pts[i].pathMove, pts[i].move, tSec);
        const pnx = pos.nx * canvas.width;
        const pny = pos.ny * canvas.height;
        const pr = speedrunPointHitRadiusPxFor(pts, i);
        if (Math.hypot(px - pnx, py - pny) < pr) {
            speedrunPointsCollected.add(i);
            pickedSpeedrunPoint = true;
        }
    }
    if (pickedSpeedrunPoint) {
        playSpeedrunCoinPickupSound();
        if (isMultiplayerActive() && isMpSpeedrunMode()) {
            syncLocalSpeedrunPoints(speedrunPointsCollected);
        }
    }
    const checkpointTouched = tryActivateSpeedrunCheckpoints(px, py, tSec);
    if (checkpointTouched) {
        playSpeedrunCoinPickupSound();
    }
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    if (checkpointTouched) {
        captureSpeedrunCheckpointProgressSnapshot();
    }
    if (!portalWarped) {
        if (speedrunStickyRail != null && speedrunDisabledWallSegIndices.has(speedrunStickyRail.wi)) {
            speedrunStickyRail = null;
        }
        if (!onStickyRail) {
            speedrunTryAttachStickyRail(px, py, cr, tSec);
            if (speedrunStickyRail != null) {
                const ar = speedrunStickyRail;
                const rr = speedrunStickyRailResolve(ar.wi, ar.u, cr, tSec, p0x, p0y);
                px = rr.x;
                py = rr.y;
                mouse.x = px;
                mouse.y = py;
                onStickyRail = true;
            }
        }
        if (!onStickyRail) {
            const pathClip = speedrunClipSolidMotionAgainstWalls(p0x, p0y, px, py, cr, tLaser0, tSec);
            const pathSeal = speedrunSealSolidIfOverlappingPoint(pathClip.x, pathClip.y, cr, tLaser0, tSec);
            px = pathSeal.x;
            py = pathSeal.y;
            mouse.x = px;
            mouse.y = py;
        }
        const solid2 = onStickyRail
            ? { x: px, y: py }
            : speedrunHasAnimatingSolidWall()
              ? speedrunResolveAgainstSolidWallsSweepAnimated(
                    px,
                    py,
                    cr,
                    tLaser0,
                    tSec,
                    speedrunPrevMouse.x,
                    speedrunPrevMouse.y,
                    intentDx,
                    intentDy,
                )
              : speedrunResolveAgainstSolidWalls(px, py, cr, tSec, intentDx, intentDy);
        const sealedFinal = speedrunSealSolidIfOverlappingPoint(solid2.x, solid2.y, cr, tLaser0, tSec);
        const solid2Clamp = clampCursorXYToCanvas(sealedFinal.x, sealedFinal.y);
        px = solid2Clamp.x;
        py = solid2Clamp.y;
        mouse.x = px;
        mouse.y = py;
    } else {
        const portalClamp = clampCursorXYToCanvas(px, py);
        px = portalClamp.x;
        py = portalClamp.y;
        mouse.x = px;
        mouse.y = py;
    }
    const g = speedrunGoalPx;
    const gh = g.half;
    const side = gh * 2;
    const gl = g.x - gh;
    const gt = g.y - gh;
    if (speedrunYellowPointsUncollectedCount() > 0) {
        const sw = speedrunSweepSegmentPastLockedGoal(p0x, p0y, px, py, cr, g.x, g.y, gh);
        px = sw.x;
        py = sw.y;
        mouse.x = px;
        mouse.y = py;
        if (circleRectOverlap(px, py, cr, gl, gt, side, side)) {
            const p2 = speedrunPushCircleOutOfLockedGoal(px, py, cr, g.x, g.y, gh);
            const c2 = clampCursorXYToCanvas(p2.x, p2.y);
            px = c2.x;
            py = c2.y;
            mouse.x = px;
            mouse.y = py;
        }
    }
    if (circleRectOverlap(px, py, cr, gl, gt, side, side)) {
        if (speedrunYellowPointsUncollectedCount() > 0) {
            speedrunPrevMouse.x = px;
            speedrunPrevMouse.y = py;
            speedrunLaserCollideTPrev = tSec;
            if (sbSandboxSr) {
                sandboxSpeedrunPrev.x = px;
                sandboxSpeedrunPrev.y = py;
            }
            return;
        }
        if (sbSandboxSr) {
            const elapsed = getGameSimNowMs() - speedrunStartPerf;
            beginSandboxSpeedrunWin(elapsed);
        } else {
            const elapsed = getGameSimNowMs() - speedrunStartPerf;
            beginSpeedrunWin(elapsed);
        }
        speedrunLaserCollideTPrev = tSec;
        return;
    }
    let laserHit = false;
    if (portalWarped && portalRes.trailBridge) {
        const br = portalRes.trailBridge;
        if (speedrunCursorPathHitsLasers(p0x, p0y, br.entryX, br.entryY, cr, tLaser0, tSec)) {
            laserHit = true;
        } else {
            laserHit = speedrunCursorPathHitsLasers(px, py, px, py, cr, tSec, tSec);
        }
    } else {
        laserHit = speedrunCursorPathHitsLasers(p0x, p0y, px, py, cr, tLaser0, tSec);
    }
    if (laserHit) {
        if (practicePlayActive && practiceGuideState.frozen) {
            // Ignore laser hits while a guide tip freezes the run.
            speedrunPrevMouse.x = px;
            speedrunPrevMouse.y = py;
            speedrunLaserCollideTPrev = tSec;
            return;
        }
        if (isLocalActive()) {
            pendingLocalSpeedrunLaserHit = true;
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
            speedrunLaserCollideTPrev = tSec;
            return;
        }
        if (sbSandboxSr) {
            if (speedrunCheckpointsNorm.length > 0) {
                beginSpeedrunCheckpointLaserDeath();
            } else {
                respawnSandboxSpeedrunFromLaser();
            }
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
        } else if (speedrunOfficialRespawnOnLaserHit()) {
            beginSpeedrunCheckpointLaserDeath();
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
        } else if (adminSpeedrunPlaytestActive || practicePlayActive) {
            respawnAdminSpeedrunPlaytest();
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
        } else if (isMultiplayerActive() && isMpSpeedrunMode()) {
            if (isMpSpeedrunCoop()) {
                mpClient.sendSpeedrunCoopHit();
                respawnMpSpeedrunFromLaser();
            } else {
                mpSpeedrunRespawnFromLaser();
            }
        } else {
            beginDeath("Laser hit — time not saved.");
        }
        speedrunLaserCollideTPrev = tSec;
        return;
    }
    speedrunPrevMouse.x = px;
    speedrunPrevMouse.y = py;
    speedrunLaserCollideTPrev = tSec;
    if (sbSandboxSr) {
        sandboxSpeedrunPrev.x = px;
        sandboxSpeedrunPrev.y = py;
    }

    if (practicePlayActive && practiceActiveDef) {
        const nx = px / Math.max(1, canvas.width);
        const ny = py / Math.max(1, canvas.height);
        practiceGuideState = tickPracticeGuide(
            practiceActiveDef.guideSteps,
            practiceGuideState,
            nx,
            ny,
        );
        if (practiceGuideState.frozen) {
            if (practiceGuideFrozenAtSec < 0) practiceGuideFrozenAtSec = getGameSimNowSec();
        } else {
            practiceGuideFrozenAtSec = -1;
        }
        if (!practiceGuideState.frozen) {
            const cr = getCursorRadiusForMode();
            for (const o of obstacles) {
                if (o.hitAtSweep(p0x, p0y, px, py) || Math.hypot(px - o.x, py - o.y) < cr + o.r) {
                    // Practice: soft reset to spawn — no death score, keep practicing.
                    repositionCursorToSpeedrunNorm(speedrunPlaytestStartNorm());
                    syncCursorAfterExplicitReposition();
                    speedrunPrevMouse.x = mouse.x;
                    speedrunPrevMouse.y = mouse.y;
                    break;
                }
            }
        }
    }
    } finally {
        /* Sandbox mouse mode: syncGameLogic lerps mouse → sandboxPointerTarget before this runs.
         * Without syncing back, the target stays past walls and next frame snaps mouse (teleport / huge speed). */
        if (sbSandboxSr) {
            sandboxPointerTarget.x = mouse.x;
            sandboxPointerTarget.y = mouse.y;
        }
    }
}

function syncSpeedrunCompleteScreenForPlaytest(isAdminPlaytest, elapsedMs) {
    if (isAdminPlaytest) {
        if (speedrunCompleteHeading) speedrunCompleteHeading.textContent = "Level completed";
        if (speedrunCompleteTime) speedrunCompleteTime.textContent = `Time: ${formatSpeedrunTime(elapsedMs)}`;
        if (speedrunCompleteNextBtn) hideEl(speedrunCompleteNextBtn);
        if (speedrunCompleteReturnBtn) speedrunCompleteReturnBtn.textContent = "Return";
        if (speedrunCompletePlayAgainBtn) speedrunCompletePlayAgainBtn.textContent = "Try again";
    } else {
        if (speedrunCompleteHeading) speedrunCompleteHeading.textContent = "Level Completed";
        if (speedrunCompleteTime) speedrunCompleteTime.textContent = `Your time: ${formatSpeedrunTime(elapsedMs)}`;
        if (speedrunCompleteNextBtn) showEl(speedrunCompleteNextBtn);
        if (speedrunCompleteReturnBtn) speedrunCompleteReturnBtn.textContent = "Return";
        if (speedrunCompletePlayAgainBtn) speedrunCompletePlayAgainBtn.textContent = "Play Again";
    }
}

function mpSpeedrunRespawnFromLaser() {
    const d = getSpeedrunLevelDef(speedrunActiveLevel);
    mouse.x = d.spawn.nx * canvas.width;
    mouse.y = d.spawn.ny * canvas.height;
    speedrunPointsCollected = new Set();
    speedrunStickyRail = null;
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    syncCursorAfterExplicitReposition();
    playSpeedrunCoinPickupSound();
}

/** LOCAL Speedrun laser: restore checkpoint or clear points, then return shared spawn px. */
function applyLocalSpeedrunLaserRespawn() {
    if (speedrunLastCheckpointIndex != null && speedrunCheckpointProgressSnapshot) {
        restoreSpeedrunCheckpointProgressSnapshot();
        repositionCursorToSpeedrunNorm(speedrunRespawnNormAfterLaserHit());
    } else {
        speedrunPointsCollected = new Set();
        speedrunCheckpointsCollected = new Set();
        speedrunLastCheckpointIndex = null;
        speedrunCheckpointProgressSnapshot = null;
        speedrunDisabledWallSegIndices.clear();
        speedrunDisabledMovingIndices.clear();
        refreshSpeedrunGroupWallState();
        refreshSpeedrunFrameGeometry();
        resetSpeedrunPortalFx();
        speedrunPortalCursorSplit = null;
        speedrunPortalTrailBridge = null;
        speedrunPortalExitLatch = null;
        repositionCursorToSpeedrunNorm(speedrunRespawnNormAtSpawn());
    }
    speedrunStickyRail = null;
    speedrunLaserCollideTPrev = null;
    trail = [];
    particles = [];
    screenShake = 0;
    localSpeedrunFrozenTSec = -1;
    if (settingEffectFlashes) triggerFlash("#ff3333", 0.1, 36);
    beep(220, 0.06);
    return { x: mouse.x, y: mouse.y };
}

function playLocalSpeedrunLaserDeathFx() {
    localSpeedrunFrozenTSec = getGameSimNowSec();
    trail = [];
    particles = [];
    playCursorCrackSound();
    playDefeatSound();
    triggerFlash(deathCursorColor(), 0.28, 65);
    addShake(5);
}

function applyMpTeamSpeedrunPoints(indices) {
    const prev = new Set(speedrunPointsCollected);
    const next = new Set(indices);
    let added = false;
    for (const i of next) {
        if (!prev.has(i)) {
            added = true;
            break;
        }
    }
    speedrunPointsCollected = next;
    if (added) playSpeedrunCoinPickupSound();
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
}

function beginMpSpeedrunWin(elapsedMs) {
    if (isMpSpeedrunLocalFinished()) return;
    const ms = Math.floor(elapsedMs);
    markMpSpeedrunLocalFinished(ms);
    trail = [];
    exitGamePointerLock();
    relativePointerLastClient = null;
    if (!isTouchGameUi()) document.body.classList.remove("hideCursor");
    if (topCenter) topCenter.textContent = `Time: ${formatSpeedrunTime(ms)} — waiting for others…`;
    playSpeedrunCoinPickupSound();
    updateMpSpeedrunSpectateChrome();
}

function beginSpeedrunWin(elapsedMs) {
    if (isLocalActive() && isLocalCoopMode()) {
        scheduleLocalMatchEnd({
            kind: "coop_win",
            title: "VICTORY",
            message: formatSpeedrunTime(elapsedMs),
        });
        return;
    }
    if (isMultiplayerActive() && isMpSpeedrunMode()) {
        beginMpSpeedrunWin(elapsedMs);
        return;
    }
    if (isChallengeAttemptPlaying()) {
        if (checkChallengeTimeExpired()) return;
        onChallengeGoalReached();
        softRestartChallengeSpeedrun(elapsedMs);
        return;
    }
    if (isCampaignAttemptPlaying()) {
        if (isCampaignRaceTimedOut()) return;
        onCampaignGoalReached();
        softRestartChallengeSpeedrun(elapsedMs);
        return;
    }
    if (isMarathonAttemptPlaying()) {
        if (isMarathonRaceTimedOut()) return;
        void onMarathonGoalReached();
        return;
    }
    if (!playing || deathPending) return;
    deathPending = false;
    gamePaused = false;
    clearResumeCountdown();
    exitGamePointerLock();
    playing = false;
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(returnBtn);
    hideEl(pauseScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    const adminWin = adminSpeedrunPlaytestActive || practicePlayActive || isThemeCosmeticPreviewPlay();
    syncSpeedrunCompleteScreenForPlaytest(adminWin, elapsedMs);
    if (!adminWin) maybeWriteSpeedrunBest(speedrunActiveLevel, elapsedMs);
    if (practicePlayActive) {
        const titleEl = document.getElementById("speedrunCompleteTitle");
        const msgEl = document.getElementById("speedrunCompleteMsg");
        if (titleEl) titleEl.textContent = "PRACTICE COMPLETE";
        if (msgEl) msgEl.textContent = "No score recorded — this was practice.";
    } else if (isThemeCosmeticPreviewPlay()) {
        const titleEl = document.getElementById("speedrunCompleteTitle");
        const msgEl = document.getElementById("speedrunCompleteMsg");
        if (titleEl) titleEl.textContent = "THEME PREVIEW";
        if (msgEl) msgEl.textContent = "No score recorded — Theme Preview.";
    }
    showEl(speedrunCompleteScreen);
    hideEl(gameOverScreen);
    void submitSpeedrunCloud(elapsedMs);
    updateMobilePlayChrome();
    void pollAchievementUnlocksNow();
}

async function submitSpeedrunCloud(elapsedMs) {
    if (!cloudUser || adminSpeedrunPlaytestActive || practicePlayActive || isThemeCosmeticPreviewPlay()) return;
    const ms = Math.floor(elapsedMs);
    const prevBest = Number((speedrunCloudPersonalBests || {})[String(speedrunActiveLevel)]) || 0;
    const localPrev = (() => {
        try {
            const map = bestSpeedrunTimesV4 || {};
            return Number(map[String(speedrunActiveLevel)]) || 0;
        } catch {
            return 0;
        }
    })();
    const prev = prevBest || localPrev;
    const isNew = !prev || ms < prev;
    let replayPayload = null;
    if (isNew && !isReplayPlaybackActive() && activeReplayRecorder) {
        const rec = activeReplayRecorder;
        activeReplayRecorder = null;
        replayPayload = rec.finalize(ms);
    } else if (!isNew) {
        activeReplayRecorder = null;
    }
    try {
        const r = await submitLeaderboardWithOffline({
            mode: "speedrun",
            level: speedrunActiveLevel,
            value: ms,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
            ...(replayPayload ? { replay: replayPayload } : {}),
        });
        if (r === "ok" || r === "queued") {
            const k = String(speedrunActiveLevel);
            if (speedrunCloudPersonalBests == null) speedrunCloudPersonalBests = {};
            const p2 = Number(speedrunCloudPersonalBests[k]) || 0;
            if (!p2 || ms < p2) speedrunCloudPersonalBests[k] = ms;
            if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
            updateTopHud();
        }
    } catch {
        /* optional */
    }
    if (replayPayload && !isReplayPlaybackActive()) {
        void submitModeReplay({
            mode: "speedrun",
            value: ms,
            replay: replayPayload,
            level: speedrunActiveLevel,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
        }).catch((e) => console.warn("[replay] speedrun submit:", e));
    }
    void reportTasksAfterRun({
        modeId: "speedrun",
        score: 1,
        timeSec: ms / 1000,
        levelIndex: speedrunActiveLevel,
    });
}

function persistSandboxPresetSpeedrunIfMatch(localName, cloudPresetId, ms) {
    const m = Math.floor(ms);
    const presets = loadSandboxPresets();
    let changed = false;
    for (const p of presets) {
        const matchCloud = cloudPresetId && p.cloudPresetId === cloudPresetId;
        const matchLocal =
            !cloudPresetId && localName && p.name.toLowerCase() === String(localName).toLowerCase();
        if (matchCloud || matchLocal) {
            const prev = p.lastSpeedrunMs || 0;
            if (!prev || m < prev) {
                p.lastSpeedrunMs = m;
                changed = true;
            }
        }
    }
    if (changed) saveSandboxPresets(presets);
}

async function submitSandboxSpeedrunCloud(elapsedMs) {
    const presetId = sandboxActivePlayContext?.cloudPresetId;
    if (!cloudUser || !presetId) return;
    const ms = Math.floor(Number(elapsedMs) || 0);
    if (ms <= 0) return;
    try {
        const r = await submitLeaderboardWithOffline({
            mode: "sandbox_speedrun",
            presetId,
            value: ms,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
        });
        if (r === "ok" || r === "queued") {
            if (sandboxSpeedrunCloudBests == null) sandboxSpeedrunCloudBests = {};
            const prev = Number(sandboxSpeedrunCloudBests[presetId]) || 0;
            if (!prev || ms < prev) sandboxSpeedrunCloudBests[presetId] = ms;
            updateTopHud();
            rerenderSandboxCommunityBestLines();
        }
    } catch {
        /* optional */
    }
}

async function submitSandboxPresetScoreCloud(score) {
    const presetId = sandboxActivePlayContext?.cloudPresetId;
    if (!cloudUser || !presetId) return;
    const value = Math.floor(Number(score) || 0);
    if (value <= 0) return;
    try {
        const r = await submitLeaderboardWithOffline({
            mode: "sandbox",
            presetId,
            value,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
        });
        if (r === "ok" || r === "queued") {
            if (sandboxScoreCloudBests == null) sandboxScoreCloudBests = {};
            const prev = Math.floor(Number(sandboxScoreCloudBests[presetId]) || 0);
            if (value > prev) sandboxScoreCloudBests[presetId] = value;
            updateTopHud();
            rerenderSandboxCommunityBestLines();
        }
    } catch {
        /* optional */
    }
}

function openSpeedrunLevelPicker() {
    clearAdminSpeedrunPlaytestState();
    hideAdminPanelScreen();
    resize();
    void refreshSpeedrunLevelsFromApi().then(() => buildSpeedrunLevelGridOnce());
    hideEl(modeScreen);
    hideEl(startScreen);
    hideEl(speedrunCompleteScreen);
    showEl(speedrunLevelScreen);
    showEl(returnBtn);
    updateMusicState();
}

function closeSpeedrunLevelPickerToModes() {
    hideEl(speedrunLevelScreen);
    gameMode = null;
    showEl(modeScreen);
    showEl(returnBtn);
    updateMusicState();
}

function closeSpeedrunCompleteToPicker() {
    hideEl(speedrunCompleteScreen);
    gameMode = null;
    showEl(speedrunLevelScreen);
    showEl(returnBtn);
    updateMusicState();
}

/** After finishing a SpeedRun level in Challenges: keep playing the same map (records still count). */
function softRestartChallengeSpeedrun(elapsedMs) {
    maybeWriteSpeedrunBest(speedrunActiveLevel, elapsedMs);
    void submitSpeedrunCloud(elapsedMs);
    playSpeedrunCoinPickupSound();
    clearDeathState();
    deathPending = false;
    gamePaused = false;
    hideEl(pauseScreen);
    hideEl(speedrunCompleteScreen);
    hideEl(gameOverScreen);
    rebuildSpeedrunGeometry();
    repositionCursorToSpeedrunNorm(getSpeedrunLevelDef(speedrunActiveLevel).spawn);
    speedrunStartPerf = getGameSimNowMs();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
    void pollAchievementUnlocksNow();
}

function startSpeedrunGame(level, options = {}) {
    clearAdminSpeedrunPlaytestState();
    hideAdminPanelScreen();
    resize();
    const published = getSpeedrunPublishedLevelIndices();
    if (published.length < 1) {
        if (topCenter) topCenter.textContent = "No SpeedRun levels available.";
        return;
    }
    const lv = Math.floor(Number(level) || published[0]);
    if (!hasSpeedrunPublishedLevel(lv)) {
        if (topCenter) topCenter.textContent = `Level ${lv} is not available.`;
        return;
    }
    speedrunActiveLevel = lv;
    clearDeathState();
    hideEl(gameOverScreen);
    hideEl(speedrunCompleteScreen);
    hideEl(speedrunLevelScreen);
    if (!options.replayPlayback) recordSpeedrunLevelView(lv);
    initGame("speedrun", options);
    resize();
    rebuildSpeedrunGeometry();
    repositionCursorToSpeedrunNorm(getSpeedrunLevelDef(speedrunActiveLevel).spawn);
    speedrunStartPerf = getGameSimNowMs();
    tryRequestGamePointerLock();
}

function speedrunLevelCardRows(): import("./level-picker-cards").LevelCardData[] {
    return getSpeedrunPublishedLevelIndices().map((lvl) => {
        const meta = getSpeedrunLevelCardMeta(lvl);
        return {
            levelIndex: lvl,
            title: getSpeedrunLevelDisplayTitle(lvl),
            description: meta?.description ?? null,
            authorName: meta?.authorName ?? null,
            viewCount: meta?.viewCount ?? 0,
        };
    });
}

function penaltyLevelCardRows(): import("./level-picker-cards").LevelCardData[] {
    return getPenaltyPublishedLevelIndices().map((lvl) => {
        const meta = getPenaltyLevelCardMeta(lvl);
        return {
            levelIndex: lvl,
            title: getPenaltyLevelDisplayTitle(lvl),
            description: meta?.description ?? null,
            authorName: meta?.authorName ?? null,
            viewCount: meta?.viewCount ?? 0,
        };
    });
}

function recordSpeedrunLevelView(level: number) {
    void incrementLevelViewCount("speedrun", level).then((count) => {
        if (count == null) return;
        bumpSpeedrunLevelViewCountLocal(level, count);
        if (speedrunLevelGrid && !speedrunLevelScreen?.classList.contains("hidden")) {
            delete speedrunLevelGrid.dataset.built;
            buildSpeedrunLevelGridOnce();
        }
    });
}

function recordPenaltyLevelView(level: number) {
    void incrementLevelViewCount("penalty", level).then((count) => {
        if (count == null) return;
        bumpPenaltyLevelViewCountLocal(level, count);
        if (penaltyLevelGrid && !penaltyLevelScreen?.classList.contains("hidden")) {
            delete penaltyLevelGrid.dataset.built;
            buildPenaltyLevelGridOnce();
        }
    });
}

function buildSpeedrunLevelGridOnce(selectedLevel = null) {
    if (!speedrunLevelGrid) return;
    const indices = getSpeedrunPublishedLevelIndices();
    const keys = indices.join(",");
    const tag = `${indices.length}:${keys}:${selectedLevel ?? ""}`;
    if (speedrunLevelGrid.dataset.built === tag) return;
    speedrunLevelGrid.dataset.built = tag;
    buildLevelPickerGrid(speedrunLevelGrid, {
        kind: "speedrun",
        levels: speedrunLevelCardRows(),
        selectedLevel,
        emptyMessage: "No official SpeedRun levels yet. (Admin)",
        onSelect: (lvl) => {
            playModeCardBeep();
            startSpeedrunGame(lvl);
        },
    });
}

async function refreshPenaltyCloudPersonalBests() {
    if (!cloudUser) {
        penaltyCloudPersonalBests = null;
        return;
    }
    try {
        const r = await fetch(apiPath(`/api/leaderboard?mode=penalty&mine=1&limit=1`), { credentials: "include" });
        const d = await r.json();
        penaltyCloudPersonalBests =
            d.penaltyPersonalBests && typeof d.penaltyPersonalBests === "object" ? d.penaltyPersonalBests : {};
    } catch {
        penaltyCloudPersonalBests = {};
    }
    if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
    updateTopHud();
}

function displayedPenaltyBestHits(level) {
    const local = readPenaltyBestHits(level);
    if (cloudUser && penaltyCloudPersonalBests != null) {
        const cloud = Number(penaltyCloudPersonalBests[String(level)]) || 0;
        if (local > 0 && cloud > 0) return Math.min(local, cloud);
        return cloud || local;
    }
    return local;
}

function handlePenaltyBallLaserDeath(tSec) {
    const w = canvas.width;
    const h = canvas.height;
    const ls = gameLayoutScale();
    if (speedrunLastCheckpointIndex != null && speedrunCheckpointProgressSnapshot) {
        restoreSpeedrunCheckpointProgressSnapshot();
        const norm = penaltyRespawnNormAfterLaser(penaltyRuntime, {
            lastCheckpointIndex: speedrunLastCheckpointIndex,
            checkpointsNorm: speedrunCheckpointsNorm,
            tSec,
        });
        resetPenaltyBallAtNorm(penaltyRuntime.ball, norm.nx, norm.ny, w, h, ls);
    } else {
        penaltyRuntime.hitCount = 0;
        speedrunPointsCollected = new Set();
        speedrunCheckpointsCollected = new Set();
        speedrunLastCheckpointIndex = null;
        speedrunCheckpointProgressSnapshot = null;
        refreshSpeedrunGroupWallState();
        refreshSpeedrunFrameGeometry();
        resetPenaltyBallFromLevel(penaltyRuntime, w, h, ls);
    }
    penaltyRuntime.ball.vx = 0;
    penaltyRuntime.ball.vy = 0;
    penaltyRuntime.ballPrev.x = penaltyRuntime.ball.x;
    penaltyRuntime.ballPrev.y = penaltyRuntime.ball.y;
    if (settingEffectFlashes) triggerFlash("#ff3333", 0.1, 36);
    beep(220, 0.06);
}

function handlePenaltyCollisions() {
    const tSec = getSpeedrunSimTimeSec();
    refreshSpeedrunFrameGeometry();
    let tLaser0 = speedrunLaserCollideTPrev == null ? tSec : speedrunLaserCollideTPrev;
    const dtRaw = Math.max(0, tSec - tLaser0);
    const dtCap = 0.22;
    if (dtRaw > dtCap) tLaser0 = tSec - dtCap;
    const dt = Math.max(1 / 240, Math.min(0.05, tSec - tLaser0));
    const ls = gameLayoutScale();
    const w = canvas.width;
    const h = canvas.height;
    const cr = getCursorRadiusForMode();
    refreshSpeedrunGroupWallState();
    const rawMx = mouse.x;
    const rawMy = mouse.y;
    const def = getPenaltyLevelDef(penaltyRuntime.activeLevel);
    const geomCtx = buildPenaltyGeomCtx(penaltyRuntime, {
        w,
        h,
        ls,
        tSec,
        wallSegDefs: speedrunWallSegDefs,
        disabledWallIndices: speedrunDisabledWallSegIndices,
        movingDefs: speedrunMovingDefs,
        disabledMovingIndices: speedrunDisabledMovingIndices,
        pointsNorm: speedrunPointsNorm,
        pointsCollected: speedrunPointsCollected,
        windDefs: speedrunWindDefs,
        goal: def.goal,
        goalPx: speedrunGoalPx,
    });
    const result = tickPenaltyFrame({
        st: penaltyRuntime,
        ctx: geomCtx,
        cursorX: rawMx,
        cursorY: rawMy,
        cursorPrevX: collisionPrevMouse.x,
        cursorPrevY: collisionPrevMouse.y,
        cursorR: cr,
        dt,
        nowMs: performance.now(),
    });
    const cursorResolved = resolvePenaltyCursorAgainstBall(
        rawMx,
        rawMy,
        collisionPrevMouse.x,
        collisionPrevMouse.y,
        penaltyRuntime.ball,
        cr,
    );
    mouse.x = cursorResolved.x;
    mouse.y = cursorResolved.y;
    const cursorAfterBall = resolvePenaltyCursorAgainstBall(
        mouse.x,
        mouse.y,
        mouse.x,
        mouse.y,
        penaltyRuntime.ball,
        cr,
    );
    mouse.x = cursorAfterBall.x;
    mouse.y = cursorAfterBall.y;
    const checkpointTouched = tryActivateSpeedrunCheckpoints(
        penaltyRuntime.ball.x,
        penaltyRuntime.ball.y,
        tSec,
    );
    if (checkpointTouched) {
        playSpeedrunCoinPickupSound();
        captureSpeedrunCheckpointProgressSnapshot();
    }
    if (result.hitRegistered) beep(520, 0.04);
    if (result.pointCollected) {
        playSpeedrunCoinPickupSound();
        refreshSpeedrunGroupWallState();
        refreshSpeedrunFrameGeometry();
    }
    if (result.laserHit) {
        handlePenaltyBallLaserDeath(tSec);
    }
    if (result.goalReached) {
        beginPenaltyWin(penaltyRuntime.hitCount);
    }
    speedrunLaserCollideTPrev = tSec;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
}

function syncPenaltyCompleteScreen(isAdminPlaytest, hits) {
    if (isAdminPlaytest) {
        if (penaltyCompleteHeading) penaltyCompleteHeading.textContent = "Level completed";
        if (penaltyCompleteHits) penaltyCompleteHits.textContent = formatPenaltyHits(hits);
        if (penaltyCompleteNextBtn) hideEl(penaltyCompleteNextBtn);
        if (penaltyCompleteReturnBtn) penaltyCompleteReturnBtn.textContent = "Return";
        if (penaltyCompletePlayAgainBtn) penaltyCompletePlayAgainBtn.textContent = "Try again";
    } else {
        if (penaltyCompleteHeading) penaltyCompleteHeading.textContent = "Level Completed";
        if (penaltyCompleteHits) penaltyCompleteHits.textContent = `Your hits: ${formatPenaltyHits(hits)}`;
        if (penaltyCompleteNextBtn) showEl(penaltyCompleteNextBtn);
        if (penaltyCompleteReturnBtn) penaltyCompleteReturnBtn.textContent = "Return";
        if (penaltyCompletePlayAgainBtn) penaltyCompletePlayAgainBtn.textContent = "Play Again";
    }
}

function beginPenaltyWin(hits) {
    if (isChallengeAttemptPlaying()) {
        if (checkChallengeTimeExpired()) return;
        onChallengeGoalReached();
        softRestartChallengePenalty(hits);
        return;
    }
    if (isCampaignAttemptPlaying()) {
        if (isCampaignRaceTimedOut()) return;
        onCampaignGoalReached();
        softRestartChallengePenalty(hits);
        return;
    }
    if (isMarathonAttemptPlaying()) {
        if (isMarathonRaceTimedOut()) return;
        void onMarathonGoalReached();
        return;
    }
    if (!playing || deathPending) return;
    deathPending = false;
    gamePaused = false;
    clearResumeCountdown();
    exitGamePointerLock();
    playing = false;
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(returnBtn);
    hideEl(pauseScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    const adminWin = penaltyRuntime.adminPlaytestActive || isThemeCosmeticPreviewPlay();
    syncPenaltyCompleteScreen(adminWin, hits);
    if (!adminWin) maybeWritePenaltyBest(penaltyRuntime.activeLevel, hits);
    showEl(penaltyCompleteScreen);
    hideEl(gameOverScreen);
    void submitPenaltyCloud(hits);
    updateMobilePlayChrome();
    void pollAchievementUnlocksNow();
}

async function submitPenaltyCloud(hits) {
    if (!cloudUser || penaltyRuntime.adminPlaytestActive || isThemeCosmeticPreviewPlay()) return;
    const h = Math.floor(hits);
    const k = String(penaltyRuntime.activeLevel);
    const prevCloud = Number((penaltyCloudPersonalBests || {})[k]) || 0;
    const isNew = !prevCloud || h < prevCloud;
    let replayPayload = null;
    if (isNew && !isReplayPlaybackActive() && activeReplayRecorder) {
        const rec = activeReplayRecorder;
        activeReplayRecorder = null;
        replayPayload = rec.finalize(h);
    } else if (!isNew) {
        activeReplayRecorder = null;
    }
    try {
        const r = await submitLeaderboardWithOffline({
            mode: "penalty",
            level: penaltyRuntime.activeLevel,
            value: h,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
            ...(replayPayload ? { replay: replayPayload } : {}),
        });
        if (r === "ok" || r === "queued") {
            if (penaltyCloudPersonalBests == null) penaltyCloudPersonalBests = {};
            const prev = Number(penaltyCloudPersonalBests[k]) || 0;
            if (!prev || h < prev) penaltyCloudPersonalBests[k] = h;
            if (statsScreen && !statsScreen.classList.contains("hidden")) void updateStats();
            updateTopHud();
        }
    } catch {
        /* optional */
    }
    if (replayPayload && !isReplayPlaybackActive()) {
        void submitModeReplay({
            mode: "penalty",
            value: h,
            replay: replayPayload,
            level: penaltyRuntime.activeLevel,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
        }).catch((e) => console.warn("[replay] penalty submit:", e));
    }
    const timeSec =
        taskRunStartedPerf > 0 ? Math.max(0, (performance.now() - taskRunStartedPerf) / 1000) : 0;
    void reportTasksAfterRun({
        modeId: "penalty",
        score: 1,
        timeSec,
        levelIndex: penaltyRuntime.activeLevel,
    });
}

function openPenaltyLevelPicker() {
    hideAdminPanelScreen();
    resize();
    void refreshPenaltyLevelsFromApi().then(() => buildPenaltyLevelGridOnce());
    hideEl(modeScreen);
    hideEl(startScreen);
    hideEl(penaltyCompleteScreen);
    showEl(penaltyLevelScreen);
    showEl(returnBtn);
    updateMusicState();
}

function closePenaltyLevelPickerToModes() {
    hideEl(penaltyLevelScreen);
    gameMode = null;
    showEl(modeScreen);
    showEl(returnBtn);
    updateMusicState();
}

function closePenaltyCompleteToPicker() {
    hideEl(penaltyCompleteScreen);
    gameMode = null;
    showEl(penaltyLevelScreen);
    showEl(returnBtn);
    updateMusicState();
}

/** After finishing a Golf hole in Challenges: reset the ball and keep playing. */
function softRestartChallengePenalty(hits) {
    if (!isThemeCosmeticPreviewPlay()) {
        maybeWritePenaltyBest(penaltyRuntime.activeLevel, hits);
        void submitPenaltyCloud(hits);
    }
    playSpeedrunCoinPickupSound();
    clearDeathState();
    deathPending = false;
    gamePaused = false;
    hideEl(pauseScreen);
    hideEl(penaltyCompleteScreen);
    hideEl(gameOverScreen);
    penaltyRuntime.hitCount = 0;
    rebuildPenaltyGeometry();
    repositionCursorToSpeedrunNorm(getPenaltyLevelDef(penaltyRuntime.activeLevel).spawn);
    resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
    void pollAchievementUnlocksNow();
}

function startPenaltyGame(level, options = {}) {
    hideAdminPanelScreen();
    resize();
    const published = getPenaltyPublishedLevelIndices();
    if (published.length < 1) {
        if (topCenter) topCenter.textContent = "No Golf levels available.";
        return;
    }
    const lv = Math.floor(Number(level) || published[0]);
    if (!hasPenaltyPublishedLevel(lv)) {
        if (topCenter) topCenter.textContent = `Level ${lv} is not available.`;
        return;
    }
    penaltyRuntime.activeLevel = lv;
    penaltyRuntime.hitCount = 0;
    penaltyRuntime.adminPlaytestActive = false;
    speedrunActiveLevel = lv;
    clearDeathState();
    hideEl(gameOverScreen);
    hideEl(penaltyCompleteScreen);
    hideEl(penaltyLevelScreen);
    if (!options.replayPlayback) recordPenaltyLevelView(lv);
    initGame("penalty", options);
    resize();
    rebuildPenaltyGeometry();
    repositionCursorToSpeedrunNorm(getPenaltyLevelDef(lv).spawn);
    resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
}

function buildPenaltyLevelGridOnce(selectedLevel = null) {
    if (!penaltyLevelGrid) return;
    const indices = getPenaltyPublishedLevelIndices();
    const keys = indices.join(",");
    const tag = `${indices.length}:${keys}:${selectedLevel ?? ""}`;
    if (penaltyLevelGrid.dataset.built === tag) return;
    penaltyLevelGrid.dataset.built = tag;
    buildLevelPickerGrid(penaltyLevelGrid, {
        kind: "penalty",
        levels: penaltyLevelCardRows(),
        selectedLevel,
        emptyMessage: "No official Golf levels yet. (Admin)",
        onSelect: (lvl) => {
            playModeCardBeep();
            startPenaltyGame(lvl);
        },
    });
}

async function refreshPenaltyLevelsFromApi() {
    try {
        const r = await fetch(apiPath("/api/penalty-levels"), { credentials: "include" });
        const data = await r.json();
        setRuntimePenaltyLevelsFromPayload(data.levels || []);
    } catch {
        setRuntimePenaltyLevelsFromPayload([]);
    }
    initPenaltyAuxUi();
    if (penaltyLevelGrid) delete penaltyLevelGrid.dataset.built;
    buildPenaltyLevelGridOnce();
}

function initPenaltyAuxUi() {
    const fill = (sel, storageKey, onChange) => {
        if (!sel) return;
        const n = Math.max(1, getPenaltyLevelCount());
        const needRebuild = sel.options.length !== n || sel.dataset.penaltyOptCount !== String(n);
        if (needRebuild) {
            sel.dataset.penaltyOptCount = String(n);
            sel.replaceChildren();
            for (let i = 1; i <= n; i++) {
                const o = document.createElement("option");
                o.value = String(i);
                o.textContent = "Level " + i;
                sel.appendChild(o);
            }
        }
        if (!sel.dataset.penaltyChangeHook) {
            sel.dataset.penaltyChangeHook = "1";
            sel.addEventListener("change", () => {
                localStorage.setItem(storageKey, sel.value);
                onChange();
            });
        }
        const sv = localStorage.getItem(storageKey);
        const lv = clamp(Math.round(Number(sv) || 1), 1, n);
        sel.value = String(lv);
    };
    fill(statsPenaltyLevelSelect, KEY_STATS_PENALTY_LEVEL, refreshStatsPenaltyLine);
    fill(rankingPenaltyLevelSelect, KEY_RANKING_PENALTY_LEVEL, loadLeaderboardTable);
    syncRankingSpeedrunLevelUi();
}

function goToMenu(navSound = "return") {
    if (isChallengesActive()) {
        resetChallengesState();
        document.body.classList.remove("challenge-lobby");
        if (returnBtn) returnBtn.textContent = "Return";
        const fade = document.getElementById("challengeFadeOverlay");
        if (fade) {
            fade.style.opacity = "0";
            fade.classList.remove("challengeFadeOverlay--on");
        }
    }
    if (isCampaignActive()) {
        closeCampaignFlow();
        if (returnBtn) returnBtn.textContent = "Return";
    }
    if (isMarathonActive()) {
        closeMarathonFlow();
        document.body.classList.remove("challenge-lobby", "challenge-goal-complete", "challenge-active");
        if (returnBtn) returnBtn.textContent = "Return";
        clearMarathonFadeOverlay();
        hideMarathonProgressHud();
        hideMarathonLostScreen();
    }
    if (isWorldMapActive()) {
        closeWorldMapFlow();
        if (returnBtn) returnBtn.textContent = "Return";
    }
    endSandboxRun();
    clearPenaltyPlaytestOverride();
    cancelPendingModeView();
    if (navSound === "return") playReturnNavChirp();
    else if (navSound === "home") playHomeNavChirp();
    stopTiltOrientationListening();
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        clearSpeedrunPlaytestOverride();
    }
    if (adminSpeedrunPlaytestActive || adminSpeedrunPlaytestSnapshot) {
        clearAdminSpeedrunPlaytestState();
    }
    if (adminPenaltyPlaytestActive || adminPenaltyPlaytestSnapshot) {
        clearAdminPenaltyPlaytestState();
    }
    if (dpadPositionCustomizeMode) {
        discardDpadCustomizeSession();
        closeDpadCustomizeExitConfirm();
        setDpadCustomizeMode(false);
    }
    exitGamePointerLock();
    leavePauseMenuCursorMode();
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(creditsScreen);
    hideEl(rouletteWarnScreen);
    hideEl(authScreen);
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    const admSc = document.getElementById("adminPanelScreen");
    if (admSc) hideEl(admSc);
    if (speedrunLevelScreen) hideEl(speedrunLevelScreen);
    if (speedrunCompleteScreen) hideEl(speedrunCompleteScreen);
    if (penaltyLevelScreen) hideEl(penaltyLevelScreen);
    if (penaltyCompleteScreen) hideEl(penaltyCompleteScreen);
    if (sandboxSpeedrunWinScreen) hideEl(sandboxSpeedrunWinScreen);
    playing = false;
    gameMode = null;
    obstacles = [];
    shieldActive = false;
    slowActive = false;
    particles = [];
    trail = [];
    screenShake = 0;
    document.body.classList.remove("hideCursor");
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideEl(gameOverScreen);
    hideEl(modeScreen);
    hideHubScreens();
    hideEl(statsScreen);
    hideSettingsScreen({ instant: true });
    hideEl(sandboxScreen);
    hideEl(achievementsScreen);
    hideEl(tasksScreen);
    hideEl(battlePassScreen);
    showEl(startScreen);
    hideEl(returnBtn);
    topCenter.textContent = "";
    resetRouletteHudOverlay();
    keys = {};
    updateMusicState();
    refreshAuthStatus();
    updateMobilePlayChrome();
    playScreenEnterMotion();
    syncHomeNotificationsBell();
    void pollAchievementUnlocksNow();
}

/** Leave an active/ended Modes run and land on the Modes list (not Home). */
function exitPlayToModes() {
    if (isChallengesActive()) {
        resetChallengesState();
        document.body.classList.remove("challenge-lobby");
        if (returnBtn) returnBtn.textContent = "Return";
        const fade = document.getElementById("challengeFadeOverlay");
        if (fade) {
            fade.style.opacity = "0";
            fade.classList.remove("challengeFadeOverlay--on");
        }
    }
    endSandboxRun();
    clearPenaltyPlaytestOverride();
    cancelPendingModeView();
    stopTiltOrientationListening();
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        clearSpeedrunPlaytestOverride();
    }
    if (adminSpeedrunPlaytestActive || adminSpeedrunPlaytestSnapshot) {
        clearAdminSpeedrunPlaytestState();
    }
    if (adminPenaltyPlaytestActive || adminPenaltyPlaytestSnapshot) {
        clearAdminPenaltyPlaytestState();
    }
    if (dpadPositionCustomizeMode) {
        discardDpadCustomizeSession();
        closeDpadCustomizeExitConfirm();
        setDpadCustomizeMode(false);
    }
    exitGamePointerLock();
    leavePauseMenuCursorMode();
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(creditsScreen);
    hideEl(rouletteWarnScreen);
    hideEl(authScreen);
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    const admSc = document.getElementById("adminPanelScreen");
    if (admSc) hideEl(admSc);
    if (speedrunLevelScreen) hideEl(speedrunLevelScreen);
    if (speedrunCompleteScreen) hideEl(speedrunCompleteScreen);
    if (penaltyLevelScreen) hideEl(penaltyLevelScreen);
    if (penaltyCompleteScreen) hideEl(penaltyCompleteScreen);
    if (sandboxSpeedrunWinScreen) hideEl(sandboxSpeedrunWinScreen);
    playing = false;
    gameMode = null;
    obstacles = [];
    activeReplayRecorder = null;
    if (isReplayPlaybackActive()) {
        endReplayPlayback();
        hideReplayControls();
        replayViewerPayload = null;
        replayViewerReturnCtx = null;
    }
    shieldActive = false;
    slowActive = false;
    particles = [];
    trail = [];
    screenShake = 0;
    document.body.classList.remove("hideCursor");
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideEl(gameOverScreen);
    hideEl(statsScreen);
    hideSettingsScreen({ instant: true });
    hideEl(sandboxScreen);
    hideEl(startScreen);
    topCenter.textContent = "";
    resetRouletteHudOverlay();
    keys = {};
    openModes();
    updateMusicState();
    refreshAuthStatus();
    updateMobilePlayChrome();
    void pollAchievementUnlocksNow();
}

function returnToSandboxCustomization() {
    if (!isSandboxRunActive() && gameMode !== "sandbox") {
        goToMenu(null);
        return;
    }

    if (sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        setSpeedrunPlaytestOverride(1, null);
    }
    clearPenaltyPlaytestOverride();
    endSandboxRun();

    exitGamePointerLock();
    leavePauseMenuCursorMode();
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(creditsScreen);
    hideEl(rouletteWarnScreen);
    hideEl(authScreen);
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    if (speedrunLevelScreen) hideEl(speedrunLevelScreen);
    if (speedrunCompleteScreen) hideEl(speedrunCompleteScreen);
    if (penaltyLevelScreen) hideEl(penaltyLevelScreen);
    if (penaltyCompleteScreen) hideEl(penaltyCompleteScreen);
    playing = false;
    gameMode = null;
    obstacles = [];
    particles = [];
    trail = [];
    screenShake = 0;
    shieldActive = false;
    slowActive = false;
    barrierActive = false;
    pushActive = false;
    document.body.classList.remove("hideCursor");
    hideEl(gameOverScreen);
    hideEl(modeScreen);
    hideEl(statsScreen);
    hideSettingsScreen({ instant: true });
    hideEl(startScreen);
    hideEl(returnBtn);
    hideEl(sandboxSaveCard);
    hideEl(sandboxLoadCard);
    if (sandboxSpeedrunPreviewScreen) hideEl(sandboxSpeedrunPreviewScreen);
    if (sandboxSpeedrunWinScreen) hideEl(sandboxSpeedrunWinScreen);
    showEl(sandboxScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    resetRouletteHudOverlay();
    keys = {};
    updateMusicState();
    updateMobilePlayChrome();
}

/** Active input recorder for the current solo run (null when not recording). */
let activeReplayRecorder = null;
/** Where to return after closing the replay viewer. */
let replayViewerReturnCtx = null;
let replayViewerPayload = null;
/** Nested loop() calls for seek / >1x speed (avoid waiting one rAF per recorded frame). */
let replayReentryDepth = 0;
/** Frames left to process in the current outer rAF (speed / seek). */
let replayStepsLeftThisTick = 0;
/** Replay hit a death: freeze last frame, no Game Over screen. */
let replayDeathFrozen = false;

function replayRecordingAllowed(mode) {
    if (!mode) return false;
    if (isReplayPlaybackActive()) return false;
    if (isMultiplayerActive() || isLocalActive() || isLootDropActive() || isSoccerActive()) return false;
    if (isChallengesActive() || isCampaignActive()) return false;
    if (isThemeCosmeticPreviewPlay()) return false;
    if (dpadPositionCustomizeMode) return false;
    if (adminSpeedrunPlaytestActive || adminPenaltyPlaytestActive || practicePlayActive) return false;
    if (mode === "multiplayer" || mode === "challenges") return false;
    return true;
}

function beginReplayRecordingForRun(mode, options = {}) {
    activeReplayRecorder = null;
    if (!replayRecordingAllowed(mode)) return;
    const seed = getGameRngSeed();
    let level = options.level;
    if (level == null && (mode === "speedrun" || mode === "penalty")) {
        if (mode === "penalty") {
            level =
                typeof penaltyRuntime?.activeLevel === "number" ? penaltyRuntime.activeLevel : undefined;
        } else {
            level = typeof speedrunActiveLevel === "number" ? speedrunActiveLevel : undefined;
        }
    }
    let presetId = options.presetId || options.cloudPresetId;
    if (!presetId && (mode === "sandbox" || mode === "sandbox_speedrun")) {
        try {
            const ref = typeof sandboxRunPresetRef === "function" ? sandboxRunPresetRef() : null;
            if (ref?.cloudPresetId) presetId = ref.cloudPresetId;
        } catch {
            /* optional */
        }
    }
    const metric = metricForReplayMode(mode, { level, presetId }) || "score";
    const rec = new ReplayRecorder({
        mode,
        metric,
        seed,
        canvasW: canvas.width || innerWidth || 800,
        canvasH: canvas.height || innerHeight || 600,
        gameVersion: GAME_VERSION,
        device: isTouchGameUi() ? "mobile" : "pc",
        level,
        presetId,
    });
    rec.start();
    activeReplayRecorder = rec;
}

/** @returns true if this call will POST the leaderboard score (caller should skip submitCloudScore). */
function finalizeAndMaybeSubmitReplay(opts) {
    const rec = activeReplayRecorder;
    activeReplayRecorder = null;
    if (!rec || !opts || !opts.isNewRecord) return false;
    if (!cloudUser) return false;
    const value = Math.floor(Number(opts.value) || 0);
    const payload = rec.finalize(value);
    if (!payload) return false;
    // One shot: score + replay on leaderboard (meta fallback), then /api/replay for ModeReplay.
    void (async () => {
        try {
            if (payload.mode !== "speedrun" && payload.mode !== "penalty") {
                await submitLeaderboardWithOffline({
                    mode: payload.mode,
                    value: payload.value,
                    clientVersion: GAME_VERSION,
                    device: payload.device,
                    replay: payload,
                    ...(payload.level != null ? { level: payload.level } : {}),
                    ...(payload.presetId ? { presetId: payload.presetId } : {}),
                });
            }
            const result = await submitModeReplay({
                mode: payload.mode,
                value: payload.value,
                replay: payload,
                level: payload.level,
                presetId: payload.presetId,
                clientVersion: GAME_VERSION,
                device: payload.device,
            });
            if (!result.ok) {
                console.warn("[replay] submit failed:", result.error);
            }
        } catch (e) {
            console.warn("[replay] submit error:", e);
        }
    })();
    return payload.mode !== "speedrun" && payload.mode !== "penalty";
}

function exitReplayViewer() {
    if (!isReplayPlaybackActive() && !replayViewerPayload) {
        hideReplayControls();
        return;
    }
    endReplayPlayback();
    hideReplayControls();
    replayViewerPayload = null;
    replayDeathFrozen = false;
    const ctx = replayViewerReturnCtx;
    replayViewerReturnCtx = null;
    clearDeathState();
    clearResumeCountdown();
    gamePaused = false;
    hideEl(pauseScreen);
    playing = false;
    gameMode = null;
    obstacles = [];
    particles = [];
    trail = [];
    replayCanvasLock = null;
    resize();
    document.body.classList.remove("game-active", "hideCursor", "replay-playback");
    applyBackgroundTheme();
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideEl(gameOverScreen);
    keys = {};
    if (ctx === "leaderboard") {
        openLeaderboardScreen();
    } else if (ctx === "stats") {
        claimExclusiveUi("statsScreen");
        hideEl(startScreen);
        hideHubScreens();
        showEl(statsScreen);
        void updateStats();
        updateMusicState();
    } else if (ctx && typeof ctx === "object" && ctx.type === "profile") {
        void openPublicPlayerProfile(ctx.userId);
    } else {
        showEl(startScreen);
        updateMusicState();
    }
    syncReturnBtnVisibility();
    updateMobilePlayChrome();
}

/**
 * Deterministic replay bootstrap: lock the recorded canvas size, then run the
 * same start*() path as a live game (same RNG call order / spawns / mode state).
 */
function launchReplayFromPayload(payload) {
    if (!payload || !payload.mode) return;
    const w = Math.max(1, Math.floor(Number(payload.canvasW) || 0));
    const h = Math.max(1, Math.floor(Number(payload.canvasH) || 0));
    replayCanvasLock = w >= 2 && h >= 2 ? { w, h } : null;
    resize();
    resetReplaySpeedCredit();
    replayDeathFrozen = false;
    deathPending = false;
    clearDeathState();
    hideEl(gameOverScreen);
    const options = {
        gameSeed: payload.seed,
        skipModeView: true,
        replayPlayback: true,
        level: payload.level,
        presetId: payload.presetId,
    };
    const mode = payload.mode;
    switch (mode) {
        case "normal": startNormal(options); break;
        case "progression": startProgression(options); break;
        case "wasd": startWASD(options); break;
        case "superdot": startSuperDot(options); break;
        case "roulette": beginRouletteGame(options); break;
        case "highway": startHighway(options); break;
        case "darkness": startDarkness(options); break;
        case "mirror": startMirror(options); break;
        case "delay": startDelay(options); break;
        case "snake": startSnake(options); break;
        case "combo": startCombo(options); break;
        case "colorrush": startColorRush(options); break;
        case "heat": startHeat(options); break;
        case "hunter": startHunter(options); break;
        case "pop": startPop(options); break;
        case "counter": startCounter(options); break;
        case "aim": startAim(options); break;
        case "hook": startHook(options); break;
        case "tilt": void startTilt(options); break;
        case "orbit": startOrbit(options); break;
        case "speedrun":
            if (payload.level != null) startSpeedrunGame(payload.level, options);
            else initGame(mode, options);
            break;
        case "penalty":
            if (payload.level != null) startPenaltyGame(payload.level, options);
            else initGame(mode, options);
            break;
        default:
            initGame(mode, options);
            break;
    }
    exitGamePointerLock();
    document.body.classList.remove("hideCursor");
}

function applyReplaySeekRestart() {
    if (!replayViewerPayload || !isReplayPlaybackActive()) return;
    clearDeathState();
    deathPending = false;
    launchReplayFromPayload(replayViewerPayload);
}

async function openReplayViewer(userId, mode, opts = {}) {
    if (!userId || !mode) return;
    try {
        const meta = await fetchReplayMeta({
            userId,
            mode,
            metric: opts.metric,
            level: opts.level,
            presetId: opts.presetId,
            play: true,
        });
        if (!meta.available || !meta.payload) return;
        const payload = meta.payload;
        if (!beginReplayPlayback(payload)) return;

        replayViewerReturnCtx = opts.returnCtx || null;
        replayViewerPayload = payload;
        claimExclusiveUi(null);
        hideEl(startScreen);
        hideHubScreens();
        hideEl(leaderboardScreen);
        hideEl(statsScreen);
        hideEl(profileScreen);
        hideEl(gameOverScreen);
        showReplayControls();
        launchReplayFromPayload(payload);
        updateMusicState();
        syncReturnBtnVisibility();
        updateMobilePlayChrome();
    } catch {
        endReplayPlayback();
        hideReplayControls();
        replayCanvasLock = null;
        resize();
    }
}

function initGame(mode, options = {}) {
    clearUiCursorMode();
    clearDeathState();
    clearResumeCountdown();
    resetQuickRestartTapState();
    stopTiltOrientationListening();
    gamePaused = false;
    gameplayPauseStartedAt = 0;
    hideEl(pauseScreen);
    gameMode = mode;
    flushSpeedrunPointerIntent();
    if (!options.skipModeView) recordModePlay(mode);
    if (!options.skipModeView && mode) {
        void commitPlayStreakDay(mode, { server: !!cloudUser });
    }
    playing = true;
    markTaskRunStarted();
    seedGameRng(options.gameSeed);
    resetGameSimClock(0);
    if (options.replayPlayback) {
        activeReplayRecorder = null;
    } else {
        beginReplayRecordingForRun(mode, {
            level: options.level,
            presetId: options.presetId || options.cloudPresetId,
        });
    }
    shieldExpiresAt = 0;
    slowExpiresAt = 0;
    barrierExpiresAt = 0;
    pushExpiresAt = 0;
    resetFrameClockLeavingMenuIdle();
    resetGameTouchSteerState();
    document.body.classList.add("game-active");
    applyBackgroundTheme();
    sidebarCollapsed = true;
    setPlayHudSidebarCollapsed(true);
    if (sideNav) sideNav.style.transition = "none";
    syncSidebarState();
    requestAnimationFrame(() => { if (sideNav) sideNav.style.transition = ""; });
    score = 0;
    hudScorePulsePrev = -1;
    hudScorePulseMode = "";
    obstacles = [];
    particles = [];
    trail = [];
    resetSnakeTrail();
    resetComboState();
    hideComboHud();
    screenShake = 0;
    lastNormalSpawn = 0;
    lastHunterRedSpawn = 0;
    lastSnakeSpawn = 0;
    comboNextSpawnAt = 0;
    lastWASDSpawn = 0;
    lastSandboxSpawn = 0;
    lastDarknessSpawn = 0;
    shieldActive = false;
    slowActive = false;
    barrierActive = false;
    pushActive = false;
    lastShieldUse = 0;
    lastSlowUse = 0;
    lastBarrierUse = 0;
    lastPushUse = 0;
    progressionLevel = 1;
    progressionSide = "left";

    roulette.effect = "";
    roulette.lastEffect = "";
    roulette.startedAt = 0;
    roulette.endsAt = 0;
    roulette.nextDisplay = 10;
    roulette.pulseUntil = 0;
    roulette.transitionPending = false;
    roulette.transitionDoneAt = 0;
    roulette.cursorScale = 1;
    roulette.targetCursorScale = 1;
    roulette.ballScale = 1;
    roulette.targetBallScale = 1;
    roulette.ballAlpha = 1;
    roulette.pointerTarget = { x: innerWidth / 2, y: innerHeight / 2 };
    roulette.mouseLerp = ROULETTE_MOUSE_LERP_DEFAULT;
    roulette.targetMouseLerp = ROULETTE_MOUSE_LERP_DEFAULT;
    roulette.flashVisibleUntil = 0;
    roulette.flashFadeEnd = 0;
    roulette.whiteOverrideUntil = 0;
    roulette.controlMode = "mouse";
    roulette.labelText = "";
    roulette.labelStart = 0;
    roulette.nextPeriodicSpawnAt = 0;

    gameMusicGainMultiplier = 1;
    flashbangMusicRampActive = false;
    clearFlashbangMusicSchedule();
    defeatGameMusicDuck = 1;
    darknessMusicDuck = 1;
    stopDarknessTensionAudio();

    document.body.classList.toggle(
        "hideCursor",
        !dpadPositionCustomizeMode && !options.replayPlayback,
    );
    if (options.replayPlayback) {
        document.body.classList.remove("hideCursor");
        exitGamePointerLock();
    }
    hideEl(startScreen);
    hideHubScreens();
    hideEl(modeScreen);
    hideEl(statsScreen);
    hideSettingsScreen({ instant: true });
    hideEl(sandboxScreen);
    hideEl(gameOverScreen);
    hideEl(gameOverNewRecord);
    hideEl(creditsScreen);
    hideEl(rouletteWarnScreen);
    hideEl(authScreen);
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    const apPanel = document.getElementById("adminPanelScreen");
    if (apPanel) hideEl(apPanel);
    if (speedrunLevelScreen) hideEl(speedrunLevelScreen);
    if (speedrunCompleteScreen) hideEl(speedrunCompleteScreen);
    if (penaltyLevelScreen) hideEl(penaltyLevelScreen);
    if (penaltyCompleteScreen) hideEl(penaltyCompleteScreen);
    if (sandboxSpeedrunWinScreen) hideEl(sandboxSpeedrunWinScreen);
    showEl(returnBtn);
    updateMobilePlayChrome();
    setSuperHudVisible(mode === "superdot");
    setTopHudMode(mode === "roulette" ? "roulette" : null);
    keys = {};
    resetRelativePointerAnchor();
    if (mode === "normal") startFX("#0ff");
    if (mode === "progression") startFX("#0f0");
    if (mode === "wasd") startFX("#ffffff");
    if (mode === "superdot") startFX("#ff66ff");
    if (mode === "roulette") startFX("#ffffff");
    if (mode === "sandbox") startFX("#0ff");
    if (mode === "speedrun") startFX(settingBallsColor);
    if (mode === "penalty") startFX(settingBallsColor);
    if (mode === "lootdrop") startFX("#ffd040");
    if (mode === "highway") {
        startFX("#66ffff");
        setHighwayRandom(gameRandom);
        resetHighwayState(canvas.width, canvas.height);
    }
    if (mode === "darkness") {
        startFX("#8899cc");
        resetDarknessState(
            canvas.width,
            canvas.height,
            gameLayoutScale(),
            canvas.width / 2,
            canvas.height / 2,
            cursorEdgeInsetPx(),
        );
    }
    if (mode === "colorrush") {
        resetColorRushState();
        startFX(getColorRushCursorHex());
    }
    if (mode === "heat") {
        resetHeatState();
        startFX("#ffaa66");
    }
    if (mode === "hunter") startFX("#ff3333");
    if (mode === "pop") startFX("#66ddff");
    if (mode === "counter") {
        resetCounterState(getGameSimNowMs());
        startFX("#aaff66");
    }
    if (mode === "aim") {
        resetAimState(getGameSimNowMs());
        startFX("#ffd84d");
    }
    if (mode === "hook") {
        resetHookState(getGameSimNowMs());
        resetHookTouchPointers();
        hookAimRmbHeld = false;
        startFX("#66eeff");
    }
    if (mode === "tilt") {
        startFX("#88ffcc");
        startTiltOrientationListening();
    }
    if (mode === "orbit") {
        resetOrbitState();
        startFX("#a8d8ff");
    }
    if (mode === "mirror") startFX("#ff66cc");
    if (mode === "delay") {
        resetDelayState(mouse.x, mouse.y);
        startFX("#7ec8e3");
    }
    if (mode === "snake") startFX("#66ff99");
    if (mode === "combo") {
        startFX("#ff6644");
        showComboHud();
    } else {
        hideComboHud();
    }
    if (mode === "multiplayer") startFX("#0ff");
    if (mode === "soccer") {
        startFX("#3d8cff");
        obstacles = [];
        setTopHudMode(null);
        if (topCenter) topCenter.textContent = "";
        hideEl(returnBtn);
        hideEl(pauseTopBtn);
    }
    pointerLockPauseSuppressedUntil = performance.now() + 900;
    messageNotifyInboxNeedsBootstrap = true;
    tryRequestGamePointerLock();
    void refreshHudStatsBestCache().then(() => {
        if (playing) updateTopHud();
    });
}

function restartAdminPenaltyPlaytestFromSnapshot() {
    const snap = adminPenaltyPlaytestSnapshot;
    if (!snap || !snap.def) return;
    hideAdminPanelScreen();
    resize();
    adminPenaltyPlaytestActive = true;
    penaltyRuntime.adminPlaytestActive = true;
    const pause = !!snap.pauseAnimations;
    adminPlaytestHideMoveVis = pause;
    adminPlaytestHideRotVis = pause;
    setPenaltyPlaytestOverride(1, normalizePenaltyLevelData(JSON.parse(JSON.stringify(snap.def))));
    penaltyRuntime.activeLevel = 1;
    penaltyRuntime.hitCount = 0;
    speedrunActiveLevel = 1;
    hideEl(penaltyCompleteScreen);
    initGame("penalty");
    resize();
    rebuildPenaltyGeometry();
    repositionCursorToSpeedrunNorm(penaltyPlaytestStartNorm());
    resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
}

function restartAdminSpeedrunPlaytestFromSnapshot() {
    const snap = adminSpeedrunPlaytestSnapshot;
    if (!snap || !snap.def) return;
    hideAdminPanelScreen();
    resize();
    adminSpeedrunPlaytestActive = true;
    const pause = !!snap.pauseAnimations;
    adminPlaytestHideMoveVis = pause;
    adminPlaytestHideRotVis = pause;
    setSpeedrunPlaytestOverride(1, normalizeLevelData(JSON.parse(JSON.stringify(snap.def))));
    speedrunActiveLevel = 1;
    initGame("speedrun");
    resize();
    rebuildSpeedrunGeometry();
    repositionCursorToSpeedrunNorm(speedrunPlaytestStartNorm());
    syncCursorAfterExplicitReposition();
    speedrunStartPerf = getGameSimNowMs();
    tryRequestGamePointerLock();
}

function respawnAdminSpeedrunPlaytest() {
    if (!adminSpeedrunPlaytestActive || gameMode !== "speedrun" || !playing) return;
    if (speedrunCheckpointsNorm.length > 0) {
        handleSpeedrunCheckpointLaserDeath();
    } else {
        deathPending = false;
        defeatGameMusicDuck = 1;
        respawnSpeedrunFromLaserHit();
        speedrunPointsCollected = new Set();
        speedrunDisabledWallSegIndices.clear();
        refreshSpeedrunGroupWallState();
        refreshSpeedrunFrameGeometry();
        speedrunStartPerf = getGameSimNowMs();
        trail = [];
        particles = [];
        screenShake = 0;
    }
    tryRequestGamePointerLock();
}

document.addEventListener("arcade-sandbox-speedrun-editor-play", ev => {
    const d = ev.detail;
    if (!d || !d.def) return;
    sandboxConfig = normalizeSandboxConfig({
        ...sandboxConfig,
        speedrunLayout: normalizeLevelData(d.def),
        speedrunMode: true,
        baseMode: "speedrun",
    });
    saveSandboxDraft();
    refreshSandboxUI();
    destroySandboxSpeedrunEditorIfAny();
    hideEl(sandboxSpeedrunPreviewScreen);
    showEl(sandboxScreen);
    hideEl(returnBtn);
    startSandboxGame();
});

document.addEventListener("arcade-sandbox-penalty-editor-play", ev => {
    const d = ev.detail;
    if (!d || !d.def) return;
    sandboxConfig = normalizeSandboxConfig({
        ...sandboxConfig,
        penaltyLayout: normalizePenaltyLevelData(d.def),
        baseMode: "penalty",
    });
    saveSandboxDraft();
    refreshSandboxUI();
    destroySandboxPenaltyEditorIfAny();
    hideEl(sandboxPenaltyPreviewScreen);
    showEl(sandboxScreen);
    hideEl(returnBtn);
    startSandboxGame();
});

document.addEventListener("arcade-admin-speedrun-play", ev => {
    const d = ev.detail;
    if (!d || !d.def) return;
    hideAdminPanelScreen();
    resize();
    clearAdminSpeedrunPlaytestState();
    clearPracticePlayState();
    const pause = !!d.pauseAnimations || !!d.hideMove || !!d.hideRot;
    adminSpeedrunPlaytestSnapshot = {
        def: JSON.parse(JSON.stringify(d.def)),
        pauseAnimations: pause,
    };
    adminSpeedrunPlaytestActive = true;
    adminPlaytestHideMoveVis = pause;
    adminPlaytestHideRotVis = pause;
    setSpeedrunPlaytestOverride(1, normalizeLevelData(d.def));
    speedrunActiveLevel = 1;
    initGame("speedrun");
    resize();
    rebuildSpeedrunGeometry();
    repositionCursorToSpeedrunNorm(speedrunPlaytestStartNorm());
    syncCursorAfterExplicitReposition();
    speedrunStartPerf = getGameSimNowMs();
    tryRequestGamePointerLock();
});

function spawnPracticeBallsFromDef(def) {
    if (!def || !Array.isArray(def.balls) || !def.balls.length) return;
    const ls = gameLayoutScale();
    for (const b of def.balls) {
        const rad = Math.max(6, (b.radius || 14) * ls);
        const speed = Math.max(0.4, (b.speed || 1) * 2.2 * ls);
        const o = new Obstacle(speed, rad);
        o.x = (b.nx ?? 0.5) * canvas.width;
        o.y = (b.ny ?? 0.5) * canvas.height;
        const ang = ((b.angleDeg || 0) * Math.PI) / 180;
        o.vx = Math.cos(ang) * speed;
        o.vy = Math.sin(ang) * speed;
        if (def.mechanics?.colorRush) o.colorRushIdx = Math.floor(gameRandom() * 4);
        if (def.mechanics?.aim) o.isAimGolden = gameRandom() < 0.15;
        obstacles.push(o);
    }
}

function beginPracticeRun(defRaw, opts = {}) {
    const def = normalizePracticeLevelData(defRaw);
    const fromAdmin = !!opts.fromAdmin;
    const levelIndex = Math.max(1, Math.floor(Number(opts.levelIndex) || 1));
    if (fromAdmin) hideAdminPanelScreen();
    else {
        hideHubScreens();
        hideEl(practiceScreen);
        hideEl(modeScreen);
        hideEl(returnBtn);
    }
    resize();
    clearAdminSpeedrunPlaytestState();
    clearPracticePlayState();
    practicePlayActive = true;
    practicePlayFromAdmin = fromAdmin;
    practiceActiveDef = def;
    practiceGuideState = initialPracticeGuideState();
    practicePlayLevelIndex = levelIndex;
    setPracticePlaytestOverride(def);
    setSpeedrunPlaytestOverride(1, normalizeLevelData(def));
    speedrunActiveLevel = 1;
    initGame("speedrun");
    resize();
    rebuildSpeedrunGeometry();
    obstacles.length = 0;
    spawnPracticeBallsFromDef(def);
    repositionCursorToSpeedrunNorm(speedrunPlaytestStartNorm());
    syncCursorAfterExplicitReposition();
    speedrunStartPerf = getGameSimNowMs();
    tryRequestGamePointerLock();
}

document.addEventListener("arcade-admin-practice-play", ev => {
    const d = ev.detail;
    if (!d || !d.def) return;
    beginPracticeRun(d.def, { fromAdmin: true, levelIndex: 1 });
});

function startPracticeGame(levelIndex) {
    const idx = Math.max(1, Math.floor(Number(levelIndex) || 1));
    const def = getRuntimePracticeLevel(idx);
    if (!def) {
        alert("This practice is not available.");
        return;
    }
    void incrementLevelViewCount("practice", idx);
    beginPracticeRun(def, { fromAdmin: false, levelIndex: idx });
}

function openPractice() {
    if (cloudTimedOut) return;
    hideAllMpScreens();
    hideLocalScreens();
    hideEl(localResultScreen);
    claimExclusiveUi("practiceScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(practiceScreen);
    showEl(returnBtn);
    mountPracticeScreen({ onPlay: startPracticeGame });
    void refreshPracticeLevelsFromApi().then(() => refreshPracticeScreen());
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    syncActiveSidebarFromVisibleScreen();
    playScreenEnterMotion();
}

document.addEventListener("arcade-admin-penalty-play", ev => {
    const d = ev.detail;
    if (!d || !d.def) return;
    hideAdminPanelScreen();
    resize();
    clearAdminPenaltyPlaytestState();
    const pause = !!d.pauseAnimations || !!d.hideMove || !!d.hideRot;
    adminPenaltyPlaytestSnapshot = {
        def: JSON.parse(JSON.stringify(d.def)),
        pauseAnimations: pause,
    };
    adminPenaltyPlaytestActive = true;
    penaltyRuntime.adminPlaytestActive = true;
    adminPlaytestHideMoveVis = pause;
    adminPlaytestHideRotVis = pause;
    setPenaltyPlaytestOverride(1, normalizePenaltyLevelData(d.def));
    penaltyRuntime.activeLevel = 1;
    penaltyRuntime.hitCount = 0;
    speedrunActiveLevel = 1;
    initGame("penalty");
    resize();
    rebuildPenaltyGeometry();
    repositionCursorToSpeedrunNorm(penaltyPlaytestStartNorm());
    resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
});

function startNormal(options = {}) {
    initGame("normal", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", sbCommonNum("initialBalls", 1))));
    const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
    for (let i = 0; i < n; i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

async function startTilt(options = {}) {
    const begin = () => {
        initGame("tilt", options);
        mouse.x = canvas.width / 2;
        mouse.y = canvas.height / 2;
        resetTiltPhysics(mouse.x, mouse.y);
        const n = Math.max(0, Math.floor(sbNum("initialBalls", 1)));
        const spd = sbNum("ballsSpeed", TILT_BALL_SPEED);
        for (let i = 0; i < Math.max(n, isSandboxRunActive() ? n : 1); i++) spawnObstacle(spd);
        syncBallCollisionPrevMouse();
    };
    // Replay must use the same spawn path without device permission prompts.
    if (options.replayPlayback) {
        begin();
        return;
    }
    // Must run permission from this user-gesture call stack (not after play-transition delay).
    if (!isTiltDeviceEligible(() => isTouchTabletUi() || isLocalModeDevice()) || !deviceHasMotionSensors()) {
        showTiltMobileOnlyToast();
        return;
    }
    const permitted = await requestTiltOrientationPermission();
    if (!permitted) {
        showTiltMobileOnlyToast();
        return;
    }
    if (options.withTransition && isPlayTransitionEnabled()) {
        runPlayTransition(begin, { origin: options.origin ?? null });
    } else {
        begin();
    }
}

function spawnOrbitBall(speedUnits) {
    const ls = gameLayoutScale();
    const radius = getObstacleRadius();
    const o = new Obstacle(0, radius);
    const spawn = pickOrbitInboundSpawn(canvas.width, canvas.height, radius, speedUnits * ls);
    o.x = spawn.x;
    o.y = spawn.y;
    o.vx = spawn.vx;
    o.vy = spawn.vy;
    obstacles.push(o);
    return o;
}

function startOrbit(options = {}) {
    if (isSandboxRunActive()) {
        setOrbitTuning({
            coreRadiusFrac: sbNum("coreRadiusFrac", 0.118),
            cursorGapRef: sbNum("cursorGapRef", 18),
            angularAccel: sbNum("angularAccel", 36),
            maxAngularSpeed: sbNum("maxAngularSpeed", 9.5),
            angularDrag: sbNum("angularDrag", 22),
            ballSpeedBase: sbNum("ballSpeedBase", 0.52),
            ballSpeedPerTier: sbNum("ballSpeedPerTier", 0.2),
            spawnRateBase: sbNum("spawnRateBase", 0.48),
            spawnRatePerTier: sbNum("spawnRatePerTier", 0.38),
            livesStart: sbNum("livesStart", 3),
            livesCap: sbNum("livesCap", 5),
            lifeBonusEvery: sbNum("lifeBonusEvery", 1000),
        });
    } else {
        setOrbitTuning();
    }
    initGame("orbit", options);
    const cr = getCursorRadiusForMode();
    const pos = orbitCursorPos(canvas.width, canvas.height, cr, gameLayoutScale());
    mouse.x = pos.x;
    mouse.y = pos.y;
    const n = Math.max(
        0,
        Math.floor(isSandboxRunActive() ? sbNum("initialBalls", ORBIT_INITIAL_BALLS) : ORBIT_INITIAL_BALLS),
    );
    const spd = isSandboxRunActive() ? sbNum("ballSpeedBase", 0.52) : 0.52;
    for (let i = 0; i < n; i++) spawnOrbitBall(spd);
    syncBallCollisionPrevMouse();
    updateMobilePlayChrome();
    restartOrbitSteerHint();
}

function startProgression(options = {}) {
    initGame("progression", options);
    resetProgressionCursor();
    spawnProgressionBalls();
    syncBallCollisionPrevMouse();
}

function startWASD(options = {}) {
    initGame("wasd", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", sbCommonNum("initialBalls", 5))));
    const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 1.2));
    for (let i = 0; i < (isSandboxRunActive() ? n : Math.max(1, n)); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function startSuperDot(options = {}) {
    initGame("superdot", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", sbCommonNum("initialBalls", 1))));
    const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
    for (let i = 0; i < (isSandboxRunActive() ? n : Math.max(1, n)); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function startHighway(options = {}) {
    if (isSandboxRunActive()) {
        setHighwayTuning({
            baseCameraPxS: sbNum("baseCameraPxS", 78),
            maxSpeedScore: sbNum("maxSpeedScore", 5000),
            scorePerSpeedTier: sbNum("scorePerSpeedTier", 1000),
            speedStepMul: sbNum("speedStepMul", 1.25),
            roadWidthFrac: sbNum("roadWidthFrac", 0.72),
        });
    } else {
        setHighwayTuning();
    }
    initGame("highway", options);
    mouse.x = canvas.width / 2;
    mouse.y = getHighwayCameraY() + canvas.height * 0.28;
    resetRelativePointerAnchor();
}

function startDarkness(options = {}) {
    if (isSandboxRunActive()) {
        setDarknessTuning({
            pointCount: sbNum("pointCount", 3),
            visionStartFrac: sbNum("visionStartFrac", 0.27),
            visionMaxFrac: sbNum("visionMaxFrac", 0.4),
            visionShrinkBasePxS: sbNum("visionShrinkBasePxS", 10.2),
            visionShrinkMaxPxS: sbNum("visionShrinkMaxPxS", 22.5),
            visionShrinkScoreCap: sbNum("visionShrinkScoreCap", 4000),
        });
    } else {
        setDarknessTuning();
    }
    initGame("darkness", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    resetDarknessState(
        canvas.width,
        canvas.height,
        gameLayoutScale(),
        mouse.x,
        mouse.y,
        cursorEdgeInsetPx(),
    );
    const n = Math.max(0, Math.floor(sbNum("initialBalls", 5)));
    const spd = sbNum("ballsSpeed", 0.85);
    for (let i = 0; i < (isSandboxRunActive() ? n : 5); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function randomColorRushBallPos(radius, clearanceCenters = null, clearanceMult = 1) {
    const w = canvas.width > 0 ? canvas.width : 800;
    const h = canvas.height > 0 ? canvas.height : 600;
    const centers =
        clearanceCenters && clearanceCenters.length > 0
            ? clearanceCenters
            : [{ x: mouse.x, y: mouse.y }];
    const minDist = getMinSpawnDistanceFromCursor(radius) * clearanceMult;
    return pickSpawnOutsideClearance({
        minX: radius,
        maxX: w - radius,
        minY: radius,
        maxY: h - radius,
        centers,
        minDist,
    });
}

function randomCounterBallPos(radius) {
    const w = canvas.width > 0 ? canvas.width : 800;
    const h = canvas.height > 0 ? canvas.height : 600;
    const minDist = getMinSpawnDistanceFromCursor(radius);
    return pickSpawnOutsideClearance({
        minX: radius,
        maxX: w - radius,
        minY: radius,
        maxY: h - radius,
        centers: [{ x: mouse.x, y: mouse.y }],
        minDist,
    });
}

function spawnColorRushBalls(opts = {}) {
    const total = opts.total ?? (isSandboxRunActive() ? sbNum("ballsTotal", COLOR_RUSH_BALLS_TOTAL) : COLOR_RUSH_BALLS_TOTAL);
    const clearanceCenters = opts.clearanceCenters ?? null;
    const clearanceMult = opts.clearanceMult ?? 1;
    const deck = buildColorRushColorDeck(total);
    const ls = gameLayoutScale();
    const radius = getObstacleRadius();
    const speed = (isSandboxRunActive() ? sbNum("ballSpeed", COLOR_RUSH_BALL_SPEED) : COLOR_RUSH_BALL_SPEED) * ls;
    for (const colorIdx of deck) {
        const pos = randomColorRushBallPos(radius, clearanceCenters, clearanceMult);
        const o = new Obstacle(speed, radius);
        o.x = pos.x;
        o.y = pos.y;
        o.colorRushIdx = colorIdx;
        obstacles.push(o);
    }
}

function spawnLocalColorRushBalls(config) {
    const total = Math.max(25, Math.min(500, Math.floor(Number(config?.colorRushBallCount) || 125)));
    spawnColorRushBalls({
        total,
        clearanceCenters: localSpawnClearanceCenters(),
        clearanceMult: 2.75,
    });
}

function startColorRush(options = {}) {
    if (isSandboxRunActive()) {
        setColorRushTuning({
            cycleMs: sbNum("cycleMs", 5000),
            respawnDelayMs: sbNum("respawnDelayMs", 2000),
        });
    } else {
        setColorRushTuning();
    }
    initGame("colorrush", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    spawnColorRushBalls();
    syncBallCollisionPrevMouse();
}

function startHeat(options = {}) {
    if (isSandboxRunActive()) {
        setHeatTuning({
            heatRiseRate: sbNum("heatRiseRate", 0.00275),
            heatCoolRate: sbNum("heatCoolRate", 0.0042),
        });
    } else {
        setHeatTuning();
    }
    initGame("heat", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", HEAT_BALLS_START)));
    const spd = sbNum("ballsSpeed", HEAT_BALL_SPEED);
    for (let i = 0; i < (isSandboxRunActive() ? n : HEAT_BALLS_START); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function startHunter(options = {}) {
    if (isSandboxRunActive()) {
        setHunterTuning({
            chaseSpeed: sbNum("chaseSpeed", HUNTER_CHASE_SPEED),
            patrolRadius: sbNum("patrolRadius", HUNTER_PATROL_RADIUS_REF_PX),
            turnRate: sbNum("turnRate", HUNTER_TURN_RATE),
        });
    } else {
        setHunterTuning();
    }
    initGame("hunter", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("normalStart", HUNTER_NORMAL_START)));
    const spd = sbNum("normalSpeed", HUNTER_NORMAL_SPEED);
    for (let i = 0; i < (isSandboxRunActive() ? n : HUNTER_NORMAL_START); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function spawnPopBall(size, x, y, vx, vy, opts) {
    const ls = gameLayoutScale();
    const r = popRadiusPx(size, ls);
    const o = new Obstacle(0, r);
    o.popSize = size;
    o.r = r;
    if (Number.isFinite(x) && Number.isFinite(y)) {
        o.x = x;
        o.y = y;
    }
    o.popSplitReadyAt = Number(opts?.splitReadyAt) || 0;
    if (vx != null && vy != null) {
        o.vx = vx;
        o.vy = vy;
    } else {
        const spd = popSpeedValue(size, ls);
        const a = gameRandom() * Math.PI * 2;
        o.vx = Math.cos(a) * spd;
        o.vy = Math.sin(a) * spd;
    }
    enforcePopBallSpeed(o, ls);
    return o;
}

function startPop(options = {}) {
    initGame("pop", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const ls = gameLayoutScale();
    const readyAt = getGameSimNowMs() + POP_SPLIT_COOLDOWN_MS;
    const n = Math.max(0, Math.floor(isSandboxRunActive() ? sbNum("initialBalls", POP_START_COUNT) : POP_START_COUNT));
    for (let i = 0; i < n; i++) {
        const o = spawnPopBall(POP_SIZE_LARGE, undefined, undefined, undefined, undefined, { splitReadyAt: readyAt });
        const clearance = getMinSpawnDistanceFromCursor(o.r);
        if (!placeBallAwayFromCursor(o, mouse.x, mouse.y, clearance, canvas.width, canvas.height)) {
            o.x = mouse.x < canvas.width / 2 ? canvas.width - o.r - 4 : o.r + 4;
            o.y = mouse.y < canvas.height / 2 ? canvas.height - o.r - 4 : o.r + 4;
        }
        enforcePopBallSpeed(o, ls);
        obstacles.push(o);
    }
    syncBallCollisionPrevMouse();
}

function spawnCounterBalls() {
    const ls = gameLayoutScale();
    const radius = getObstacleRadius();
    const speed = (isSandboxRunActive() ? sbNum("ballSpeed", COUNTER_BALL_SPEED) : COUNTER_BALL_SPEED) * ls;
    const total = isSandboxRunActive() ? Math.max(1, Math.floor(sbNum("ballsTotal", COUNTER_BALLS_TOTAL))) : COUNTER_BALLS_TOTAL;
    for (let num = 1; num <= total; num++) {
        const pos = randomCounterBallPos(radius);
        const o = new Obstacle(speed, radius);
        o.x = pos.x;
        o.y = pos.y;
        o.counterNum = num;
        obstacles.push(o);
    }
}

function startCounter(options = {}) {
    if (isSandboxRunActive()) {
        setCounterTuning({
            roundMs: sbNum("roundMs", 5000),
            respawnDelayMs: sbNum("respawnDelayMs", 2000),
        });
    } else {
        setCounterTuning();
    }
    initGame("counter", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    spawnCounterBalls();
    syncBallCollisionPrevMouse();
}

function spawnAimBalls() {
    const ls = gameLayoutScale();
    const radius = getObstacleRadius();
    const speed = (isSandboxRunActive() ? sbNum("ballSpeed", AIM_BALL_SPEED) : AIM_BALL_SPEED) * ls;
    const total = isSandboxRunActive() ? Math.max(1, Math.floor(sbNum("ballsTotal", AIM_BALLS_TOTAL))) : AIM_BALLS_TOTAL;
    for (let i = 0; i < total; i++) {
        const pos = randomCounterBallPos(radius);
        const o = new Obstacle(speed, radius);
        o.x = pos.x;
        o.y = pos.y;
        obstacles.push(o);
    }
    assignRandomAimGolden(obstacles);
}

function startAim(options = {}) {
    if (isSandboxRunActive()) {
        setAimTuning({
            roundMs: sbNum("roundMs", 2000),
            wavePauseMs: sbNum("wavePauseMs", 3000),
        });
    } else {
        setAimTuning();
    }
    initGame("aim", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    spawnAimBalls();
    syncBallCollisionPrevMouse();
}

function spawnHookBall(isRed, pos = null) {
    const ls = gameLayoutScale();
    const radius = getObstacleRadius();
    const speed = (isSandboxRunActive() ? sbNum("ballSpeed", HOOK_BALL_SPEED) : HOOK_BALL_SPEED) * ls;
    const o = new Obstacle(speed, radius);
    if (pos) {
        o.x = pos.x;
        o.y = pos.y;
    }
    o.isHookRed = isRed;
    obstacles.push(o);
}

function spawnHookBalls(normalCount, redCount) {
    const radius = getObstacleRadius();
    for (let i = 0; i < normalCount; i++) {
        const p = randomCounterBallPos(radius);
        spawnHookBall(false, p);
    }
    for (let i = 0; i < redCount; i++) {
        const p = randomCounterBallPos(radius);
        spawnHookBall(true, p);
    }
}

function startHook(options = {}) {
    if (isSandboxRunActive()) {
        setHookTuning({
            spawnEveryMs: sbNum("spawnEveryMs", 15000),
            flySpeed: sbNum("flySpeed", 1280),
            retractMs: sbNum("retractMs", 520),
        });
    } else {
        setHookTuning();
    }
    initGame("hook", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    resetHookState(getGameSimNowMs());
    const normals = isSandboxRunActive() ? Math.max(0, Math.floor(sbNum("normalStart", HOOK_NORMAL_START))) : HOOK_NORMAL_START;
    const reds = isSandboxRunActive() ? Math.max(0, Math.floor(sbNum("redStart", HOOK_RED_START))) : HOOK_RED_START;
    spawnHookBalls(normals, reds);
    syncBallCollisionPrevMouse();
}

let lastHookLaunchAt = 0;

function handleHookLaunch() {
    if (gameMode !== "hook" || !playing || deathPending || gamePaused || resumeCountdownActive) return;
    if (isHookInputBlocked()) return;
    const now = getGameSimNowMs();
    if (now - lastHookLaunchAt < 60) return;
    lastHookLaunchAt = now;
    launchHook(mouse.x, mouse.y);
}

function completeHookCatchBatch(balls) {
    let scored = 0;
    for (const ball of balls) {
        if (ball.isHookRed) continue;
        const idx = obstacles.indexOf(ball);
        if (idx < 0) continue;
        obstacles.splice(idx, 1);
        scored++;
        emitBurst(ball.x, ball.y, 8, [settingBallsColor, "#ffffff"], 1.05, 0, 0.9, 2.4, 10, 22);
    }
    if (scored <= 0) return;
    score += scored;
    playSpeedrunCoinPickupSound();
    addShake(0.22 + Math.min(0.18, scored * 0.04));
}

function clientToCanvasGameXY(clientX, clientY) {
    const rect = canvas.getBoundingClientRect();
    const cw = canvas.width || 1;
    const ch = canvas.height || 1;
    return {
        x: ((clientX - rect.left) / rect.width) * cw,
        y: ((clientY - rect.top) / rect.height) * ch,
    };
}

function findAimBallAt(cx, cy) {
    let goldenHit = null;
    let otherHit = null;
    for (let i = obstacles.length - 1; i >= 0; i--) {
        const o = obstacles[i];
        const dx = cx - o.x;
        const dy = cy - o.y;
        if (Math.hypot(dx, dy) < o.collisionRadius()) {
            if (o.isAimGolden) goldenHit = o;
            else if (!otherHit) otherHit = o;
        }
    }
    return goldenHit || otherHit;
}

function getAimGoldenUnderCursor() {
    for (let i = obstacles.length - 1; i >= 0; i--) {
        const o = obstacles[i];
        if (!o.isAimGolden) continue;
        if (Math.hypot(mouse.x - o.x, mouse.y - o.y) < o.collisionRadius()) return o;
    }
    return null;
}

function handleAimGoldenRightClickReshuffle() {
    if (gameMode !== "aim" || !playing || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isAimInputBlocked(getGameSimNowMs())) return false;
    const golden = getAimGoldenUnderCursor();
    if (!golden) return false;
    reassignAimGoldenFrom(obstacles, golden);
    return true;
}

function handleAimFireAtCanvasXY(cx, cy) {
    if (gameMode !== "aim" || !playing || deathPending || gamePaused || resumeCountdownActive) return;
    if (isAimInputBlocked(getGameSimNowMs())) return;
    const nowHit = getGameSimNowMs();
    const hitBall = findAimBallAt(cx, cy);
    if (hitBall && hitBall.isAimGolden) {
        const hx = hitBall.x;
        const hy = hitBall.y;
        const idx = obstacles.indexOf(hitBall);
        if (idx >= 0) obstacles.splice(idx, 1);
        score += 1;
        playSpeedrunCoinPickupSound();
        emitBurst(hx, hy, 8, [AIM_GOLDEN_BALL_HEX, "#ffffff"], 1.1, 0, 0.9, 2.6, 10, 22);
        addShake(0.25);
        if (obstacles.length === 0) {
            scheduleAimWaveClearPause(nowHit);
        } else {
            resetAimTimer(nowHit);
            assignRandomAimGolden(obstacles);
        }
        return;
    }
    beginDeath(hitBall ? "Wrong ball!" : "Missed!");
}

function startMirror(options = {}) {
    initGame("mirror", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", 1)));
    const spd = sbNum("ballsSpeed", 0.8);
    for (let i = 0; i < (isSandboxRunActive() ? n : 1); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function startDelay(options = {}) {
    initGame("delay", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    resetDelayState(mouse.x, mouse.y);
    const n = Math.max(0, Math.floor(sbNum("initialBalls", 1)));
    const spd = sbNum("ballsSpeed", 0.8);
    for (let i = 0; i < (isSandboxRunActive() ? n : 1); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function spawnSnakeApple(speed = SNAKE_APPLE_SPEED) {
    spawnObstacle(isSandboxRunActive() ? sbNum("appleSpeed", speed) : speed);
}

function startSnake(options = {}) {
    initGame("snake", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    seedSnakeTrail(mouse.x, mouse.y);
    syncBallCollisionPrevMouse();
    const count = isSandboxRunActive()
        ? Math.max(0, Math.floor(sbNum("appleStartCount", SNAKE_APPLE_START_COUNT)))
        : SNAKE_APPLE_START_COUNT;
    for (let i = 0; i < count; i++) spawnSnakeApple();
}

function startCombo(options = {}) {
    initGame("combo", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    if (isSandboxRunActive()) {
        resetComboState({
            livesMax: sbNum("livesMax", COMBO_LIVES_MAX),
            timeoutMs: sbNum("timeoutMs", COMBO_TIMEOUT_MS),
        });
    } else {
        resetComboState();
    }
    const spawnEvery = isSandboxRunActive() ? sbNum("spawnEveryMs", COMBO_SPAWN_EVERY_MS) : COMBO_SPAWN_EVERY_MS;
    comboNextSpawnAt = getGameSimNowMs() + spawnEvery;
    const n = Math.max(0, Math.floor(sbNum("initialBalls", 12)));
    const spd = sbNum("ballsSpeed", COMBO_BALL_BASE_SPEED);
    for (let i = 0; i < (isSandboxRunActive() ? n : 12); i++) spawnObstacle(spd);
    syncBallCollisionPrevMouse();
}

function beginRouletteGame(options = {}) {
    initGame("roulette", options);
    mouse.x = canvas.width / 2;
    mouse.y = canvas.height / 2;
    roulette.pointerTarget = { x: mouse.x, y: mouse.y };
    const batch = isSandboxRunActive() ? Math.max(0, Math.floor(sbNum("initialBalls", ROULETTE_SPAWN_BATCH))) : ROULETTE_SPAWN_BATCH;
    const spd = isSandboxRunActive() ? sbNum("ballsSpeed", ROULETTE_BALL_BASE_SPEED) : ROULETTE_BALL_BASE_SPEED;
    for (let i = 0; i < batch; i++) spawnObstacle(spd);
    const every = isSandboxRunActive() ? sbNum("spawnEveryMs", ROULETTE_SPAWN_EVERY_MS) : ROULETTE_SPAWN_EVERY_MS;
    roulette.nextPeriodicSpawnAt = getGameSimNowMs() + every;
    chooseRouletteEffect(true);
    syncBallCollisionPrevMouse();
}

function cancelRouletteWarning() {
    hideEl(rouletteWarnScreen);
    showEl(modeScreen);
    showEl(returnBtn);
    updateMusicState();
}

function confirmRouletteWarning() {
    settingRoulettePhotoAck = true;
    setBoolSetting("settingRoulettePhotoAck", true);
    hideEl(rouletteWarnScreen);
    beginRouletteGame();
}

function startRoulette() {
    if (settingEffectFlashes && !settingRoulettePhotoAck) {
        hideEl(modeScreen);
        hideEl(authScreen);
        hideEl(leaderboardScreen);
        hideEl(achievementsScreen);
    hideShopScreenNav();
        hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
        showEl(rouletteWarnScreen);
        showEl(returnBtn);
        rouletteWarnText.textContent = L.photosensitivityBody;
        rouletteWarnAcceptBtn.textContent = L.rouletteUnderstand;
        rouletteWarnCancelBtn.textContent = L.rouletteCancel;
        updateMusicState();
        return;
    }
    beginRouletteGame();
}

function launchSandboxBaseMode(baseMode) {
    switch (baseMode) {
        case "normal": startNormal(); break;
        case "progression": startProgression(); break;
        case "wasd": startWASD(); break;
        case "superdot": startSuperDot(); break;
        case "roulette": beginRouletteGame(); break;
        case "speedrun":
            // Always uses custom SpeedRun layout path (SpeedRun Layer toggle removed).
            initGame("sandbox");
            rebuildSandboxSpeedrunGeometry();
            repositionCursorToSpeedrunNorm(speedrunSandboxSpeedrunStartNorm());
            sandboxPointerTarget = { x: mouse.x, y: mouse.y };
            sandboxSpeedrunPrev.x = mouse.x;
            sandboxSpeedrunPrev.y = mouse.y;
            speedrunStartPerf = getGameSimNowMs();
            break;
        case "highway": startHighway(); break;
        case "darkness": startDarkness(); break;
        case "mirror": startMirror(); break;
        case "delay": startDelay(); break;
        case "snake": startSnake(); break;
        case "combo": startCombo(); break;
        case "colorrush": startColorRush(); break;
        case "heat": startHeat(); break;
        case "hunter": startHunter(); break;
        case "pop": startPop(); break;
        case "counter": startCounter(); break;
        case "aim": startAim(); break;
        case "hook": startHook(); break;
        case "tilt": void startTilt(); break;
        case "orbit": startOrbit(); break;
        case "penalty":
            startSandboxPenaltyGame();
            break;
        default:
            startNormal();
    }
}

function startSandboxPenaltyGame() {
    const raw =
        (isSandboxRunActive() && getSandboxActiveConfig()?.common?.penaltyLayout) ||
        sandboxRuntimeConfig?.penaltyLayout ||
        sandboxConfig?.penaltyLayout ||
        {};
    const def = normalizePenaltyLevelData(raw);
    clearAdminPenaltyPlaytestState();
    setPenaltyPlaytestOverride(1, def);
    penaltyRuntime.activeLevel = 1;
    penaltyRuntime.hitCount = 0;
    penaltyRuntime.adminPlaytestActive = false;
    speedrunActiveLevel = 1;
    clearDeathState();
    hideEl(gameOverScreen);
    hideEl(penaltyCompleteScreen);
    hideEl(penaltyLevelScreen);
    hideEl(sandboxScreen);
    initGame("penalty");
    resize();
    rebuildPenaltyGeometry();
    repositionCursorToSpeedrunNorm(penaltyPlaytestStartNorm());
    resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
    refreshSpeedrunGroupWallState();
    refreshSpeedrunFrameGeometry();
    speedrunLaserCollideTPrev = null;
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    tryRequestGamePointerLock();
}

function startSandboxGame() {
    closeSandboxCards();
    syncSandboxConfigFromUI();
    sandboxRuntimeConfig = normalizeSandboxConfig({ ...sandboxConfig });
    const v2 = sandboxConfigAsV2(sandboxRuntimeConfig);
    // SpeedRun base always plays as speedrun layout mode.
    if (v2.baseMode === "speedrun") {
        sandboxRuntimeConfig.speedrunMode = true;
        v2.common.speedrunMode = true;
    }
    if (sandboxMpReturnToLocal) {
        const cb = sandboxMpReturnToLocal;
        sandboxMpReturnToLocal = null;
        hideEl(sandboxScreen);
        beginSandboxRun(v2);
        cb();
        return;
    }
    beginSandboxRun(v2);
    if (v2.baseMode === "speedrun" || sandboxRuntimeConfig.speedrunMode) {
        initGame("sandbox");
        rebuildSandboxSpeedrunGeometry();
        repositionCursorToSpeedrunNorm(speedrunSandboxSpeedrunStartNorm());
        sandboxPointerTarget = { x: mouse.x, y: mouse.y };
        sandboxSpeedrunPrev.x = mouse.x;
        sandboxSpeedrunPrev.y = mouse.y;
        speedrunStartPerf = getGameSimNowMs();
        return;
    }
    launchSandboxBaseMode(v2.baseMode || "normal");
}

const MESSAGE_INBOX_POLL_MS = 5000;
let lastMessageInboxPollAt = 0;
let messageNotifyInboxCursorMs = 0;
/** After initGame, first poll only syncs cursor so old inbox does not spam toasts. */
let messageNotifyInboxNeedsBootstrap = false;
const messageNotifyShownIds = new Set();

function hideMessageNotifyToast() {
    clearNotificationToastsByKind("message", true);
}

function showMessageNotifyToastForSender(fromLabel) {
    if (!playing) return;
    pushNotificationToast("message", fromLabel);
}

function syncMessageNotifyToastVisibility() {
    if (!playing) {
        hideMessageNotifyToast();
    }
}

async function pollMessageInboxWhilePlaying(now) {
    if (!cloudUser || !playing) return;
    if (isDocumentHidden()) return;
    if (now - lastMessageInboxPollAt < MESSAGE_INBOX_POLL_MS) return;
    lastMessageInboxPollAt = now;
    try {
        const r = await fetch(apiPath("/api/messages?inbox=1&limit=40"), { credentials: "include" });
        if (!r.ok) return;
        const d = await r.json();
        const raw = Array.isArray(d.notifications) ? d.notifications : [];
        const prevCursor = messageNotifyInboxCursorMs;
        let maxAt = prevCursor;
        for (const n of raw) {
            const t = n.at ? Date.parse(String(n.at)) || 0 : 0;
            if (t > maxAt) maxAt = t;
        }
        if (messageNotifyInboxNeedsBootstrap) {
            messageNotifyInboxNeedsBootstrap = false;
            messageNotifyInboxCursorMs = Math.max(prevCursor, maxAt);
            return;
        }
        const sorted = raw
            .map((n) => ({
                id: String(n.id || ""),
                fromLabel: String(n.fromLabel || "Someone"),
                at: n.at ? Date.parse(String(n.at)) || 0 : 0
            }))
            .filter((n) => n.id.length && n.at > prevCursor)
            .sort((a, b) => a.at - b.at);
        messageNotifyInboxCursorMs = Math.max(prevCursor, maxAt);
        for (const n of sorted) {
            if (messageNotifyShownIds.has(n.id)) continue;
            messageNotifyShownIds.add(n.id);
            showMessageNotifyToastForSender(n.fromLabel);
        }
    } catch {
        /* optional */
    }
}

const ACHIEVEMENT_POLL_INTERVAL_MS = 90000;
let achievementUnlockPollInFlight = false;

function queueAchievementToast(title) {
    pushNotificationToast("achievement", title);
}

function applyAchievementToastDiff(rows) {
    let raw;
    try {
        raw = localStorage.getItem(KEY_ACHIEVEMENT_TOAST_KNOWN_IDS);
    } catch {
        raw = null;
    }
    if (raw == null) {
        const doneIds = rows.filter((r) => r.done).map((r) => r.id);
        try {
            localStorage.setItem(KEY_ACHIEVEMENT_TOAST_KNOWN_IDS, JSON.stringify(doneIds));
        } catch {
            /* ignore */
        }
        return;
    }
    /** @type {string[]} */
    let knownList = [];
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) knownList = parsed.map((x) => String(x));
    } catch {
        knownList = [];
    }
    const known = new Set(knownList);
    const newTitles = [];
    for (const r of rows) {
        if (r.done && !known.has(r.id)) {
            known.add(r.id);
            newTitles.push(r.title);
        }
    }
    if (newTitles.length) {
        try {
            localStorage.setItem(KEY_ACHIEVEMENT_TOAST_KNOWN_IDS, JSON.stringify([...known]));
        } catch {
            /* ignore */
        }
        schedulePushAccountData();
        for (const t of newTitles) queueAchievementToast(t);
    }
}

async function pollAchievementUnlocksNow() {
    if (achievementUnlockPollInFlight || !cloudUser) return;
    achievementUnlockPollInFlight = true;
    try {
        const rows = await fetchAchievements();
        applyAchievementToastDiff(rows);
        if (cachedAchievementRows && achievementsScreen && !achievementsScreen.classList.contains("hidden")) {
            cachedAchievementRows = rows;
            renderAchievementsGrid(rows);
        }
    } catch {
        /* ignore */
    } finally {
        achievementUnlockPollInFlight = false;
    }
}

function clearResumeCountdown() {
    resumeCountdownActive = false;
    if (resumeCountdownTimer) {
        clearTimeout(resumeCountdownTimer);
        resumeCountdownTimer = null;
    }
    if (resumeCountdownOverlay) resumeCountdownOverlay.classList.add("hidden");
}

function shiftFutureTimestamp(ts, delta) {
    return ts > 0 ? ts + delta : ts;
}

function applyGameplayPauseTimeShift() {
    // Spawn/deadline/speedrun timers use getGameSimNowMs(), which does not advance while
    // paused — wall-clock compensation would double-shift and break determinism.
    gameplayPauseStartedAt = 0;
}

function setResumeCountdownDisplay(numStr) {
    if (!resumeCountdownOverlay) return;
    resumeCountdownOverlay.replaceChildren();
    const span = document.createElement("span");
    span.className = "resume-countdown-num";
    span.textContent = numStr;
    resumeCountdownOverlay.appendChild(span);
    requestAnimationFrame(() => {
        span.classList.add("resume-countdown-tick");
    });
    span.addEventListener(
        "animationend",
        () => {
            span.classList.remove("resume-countdown-tick");
        },
        { once: true },
    );
}

function startResumeCountdown() {
    if (resumeCountdownTimer) {
        clearTimeout(resumeCountdownTimer);
        resumeCountdownTimer = null;
    }
    hideEl(pauseScreen);
    if (!resumeCountdownOverlay) {
        leavePauseMenuCursorMode();
        applyGameplayPauseTimeShift();
        gamePaused = false;
        playPauseCloseChirp();
        applyPlayingHideCursorClass();
        pointerLockPauseSuppressedUntil = performance.now() + 750;
        tryRequestGamePointerLock();
        updateMusicState();
        updateMobilePlayChrome();
        return;
    }
    if (isLocalActive() && isSpeedrunPhysicsMode()) {
        localSpeedrunFrozenTSec = getGameSimNowSec();
    }
    resumeCountdownActive = true;
    updateMobilePlayChrome();
    let count = 3;
    setResumeCountdownDisplay(String(count));
    playResumeCountdownTickBeep();
    resumeCountdownOverlay.classList.remove("hidden");

    const tick = () => {
        if (!playing || deathPending) {
            clearResumeCountdown();
            leavePauseMenuCursorMode();
            gameplayPauseStartedAt = 0;
            gamePaused = false;
            updateMusicState();
            updateMobilePlayChrome();
            return;
        }
        count--;
        if (count <= 0) {
            resumeCountdownOverlay.classList.add("hidden");
            resumeCountdownTimer = null;
            resumeCountdownActive = false;
            applyGameplayPauseTimeShift();
            gamePaused = false;
            playPauseCloseChirp();
            leavePauseMenuCursorMode();
            applyPlayingHideCursorClass();
            pointerLockPauseSuppressedUntil = performance.now() + 750;
            tryRequestGamePointerLock();
            updateMusicState();
            updateMobilePlayChrome();
            if (isSpeedrunPhysicsMode()) {
                flushSpeedrunPointerIntent();
                speedrunLaserCollideTPrev = null;
                syncSpeedrunSweepPrevFromMouse();
                if (isMultiplayerActive() && isMpSpeedrunMode()) {
                    speedrunStartPerf = getGameSimNowMs();
                    speedrunPointsCollected = new Set();
                    refreshSpeedrunGroupWallState();
                    refreshSpeedrunFrameGeometry();
                }
            }
            syncCursorSweepPrevFromMouse();
            if (isLocalActive()) {
                onLocalCountdownComplete();
                localSpeedrunFrozenTSec = -1;
            }
        } else {
            setResumeCountdownDisplay(String(count));
            playResumeCountdownTickBeep();
            resumeCountdownTimer = setTimeout(tick, 1000);
        }
    };
    resumeCountdownTimer = setTimeout(tick, 1000);
}

function setPaused(on) {
    if (isReplayPlaybackActive()) return;
    if (on === gamePaused) return;
    if (!playing || deathPending) return;
    if (isMultiplayerActive()) return;
    if (isLootDropActive()) return;
    if (isSoccerActive()) return;
    if (on && (challengesPauseBlocked() || campaignPauseBlocked() || marathonPauseBlocked())) return;
    resetQuickRestartTapState();
    if (!!on) {
        clearResumeCountdown();
        gameplayPauseStartedAt = performance.now();
        gamePaused = true;
        endTouchCursorAnalogAny();
        if (
            gameMode === "speedrun" ||
            (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode)
        ) {
            speedrunLaserCollideTPrev = null;
            flushSpeedrunPointerIntent();
        }
        exitGamePointerLock();
        resetRelativePointerAnchor();
        enterPauseMenuCursorMode();
        pauseTitle.textContent = L.pauseTitle;
        pauseResumeBtn.textContent = L.pauseResume;
        if (pauseResetBtn) pauseResetBtn.textContent = L.pauseReset;
        showEl(pauseScreen);
        refreshMenuKbdLabels();
        playPauseOpenChirp();
        updateMusicState();
        updateMobilePlayChrome();
    } else {
        startResumeCountdown();
    }
}

function togglePause() {
    if (isReplayPlaybackActive()) return;
    if (challengesPauseBlocked() || campaignPauseBlocked() || marathonPauseBlocked()) return;
    if (isMultiplayerActive()) return;
    if (isLootDropActive()) return;
    if (isSoccerActive()) return;
    if (resumeCountdownActive) return;
    setPaused(!gamePaused);
}

function resetFromPauseMenu() {
    if (!playing || deathPending || !gamePaused) return;
    if (isMultiplayerActive()) return;
    resetQuickRestartTapState();
    clearResumeCountdown();
    gamePaused = false;
    gameplayPauseStartedAt = 0;
    hideEl(pauseScreen);
    clearDeathState();
    gameOverMessage = "";
    leavePauseMenuCursorMode();
    playReturnNavChirp();
    if ((adminSpeedrunPlaytestActive || practicePlayActive) && gameMode === "speedrun" && (adminSpeedrunPlaytestSnapshot || practiceActiveDef)) {
        if (practicePlayActive && practiceActiveDef) {
            beginPracticeRun(practiceActiveDef, {
                fromAdmin: practicePlayFromAdmin,
                levelIndex: practicePlayLevelIndex,
            });
        } else {
            restartAdminSpeedrunPlaytestFromSnapshot();
        }
    } else if (adminPenaltyPlaytestActive && gameMode === "penalty" && adminPenaltyPlaytestSnapshot) {
        restartAdminPenaltyPlaytestFromSnapshot();
    } else {
        restartCurrentGameMode();
    }
    updateMobilePlayChrome();
    tryRequestGamePointerLock();
}

function openCredits() {
    creditsBody.textContent = L.creditsBy;
    creditsVersionEl.textContent = L.creditsVersion(GAME_VERSION);
    claimExclusiveUi("creditsScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(creditsScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    playScreenEnterMotion();
}

function closeCredits() {
    hideEl(creditsScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function openNewsScreen() {
    claimExclusiveUi("newsScreen");
    hideEl(startScreen);
    hideHubScreens();
    resetNewsScreenList();
    showEl(newsScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    playScreenEnterMotion();
}

function closeNewsScreen() {
    hideEl(newsScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function openNotificationsScreen() {
    claimExclusiveUi("notificationsScreen");
    hideEl(startScreen);
    hideHubScreens();
    if (notificationsScreen) showEl(notificationsScreen);
    void refreshNotificationsScreen();
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    playScreenEnterMotion();
}

function closeNotificationsScreen() {
    if (notificationsScreen) hideEl(notificationsScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function openWallScreenView() {
    claimExclusiveUi("wallScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(wallScreen);
    refreshWallContent();
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    playScreenEnterMotion();
}

function closeWallScreenView() {
    closeWallScreen();
    hideEl(wallScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function navigateFromWallSection(section) {
    const s = String(section || "").toLowerCase();
    if (s === "home" || s === "start") {
        setActiveSidebarBtn(sideHomeBtn);
        goToMenu("home");
        return;
    }
    if (s === "rankings" || s === "ranking") {
        sideRankingsBtn?.click();
        return;
    }
    if (s === "stats") {
        sideStatsBtn?.click();
        return;
    }
    if (s === "settings") {
        sideSettingsBtn?.click();
        return;
    }
    if (s === "news") {
        sideNewsBtn?.click();
        return;
    }
    if (s === "wall") {
        sideWallBtn?.click();
        return;
    }
    if (s === "achievements") {
        sideAchievementsBtn?.click();
        return;
    }
    if (s === "profile" || s === "social") {
        sideSocialBtn?.click();
        return;
    }
    if (s === "credits") {
        sideCreditsBtn?.click();
        return;
    }
    goToMenu("home");
}

function setAuthTab(tab) {
    const inAddFlow = !!getAddAccountReturnTarget();
    const isReg = tab === "register";
    const isForgot = tab === "forgot";
    const isAddAccount = tab === "addAccount" || (inAddFlow && !isReg && !isForgot);
    const isRegInAddFlow = inAddFlow && isReg;
    registerFormBlock.classList.toggle("hidden", !isReg);
    loginFormBlock.classList.toggle("hidden", isReg || isForgot);
    if (forgotPasswordFormBlock) forgotPasswordFormBlock.classList.toggle("hidden", !isForgot);
    authSwitchBtn.classList.toggle("hidden", isForgot);
    authGuestBtn.classList.toggle("hidden", isForgot || inAddFlow);
    if (authAddAccountReturnBtn) authAddAccountReturnBtn.classList.toggle("hidden", !inAddFlow || isForgot);
    if (inAddFlow) {
        authSwitchBtn.textContent = isRegInAddFlow
            ? "Sign in to existing account"
            : "Create new account";
    } else {
        authSwitchBtn.textContent = isReg ? "Already have an account? Sign in" : "Need an account? Register";
    }
    if (authScreenTitle) {
        authScreenTitle.textContent = inAddFlow ? "ADD ACCOUNT" : "ACCOUNT";
    }
    const loginHeading = loginFormBlock?.querySelector("h3");
    if (loginHeading) loginHeading.textContent = inAddFlow && !isReg ? "Add account" : "Sign in";
    if (loginSubmitBtn) loginSubmitBtn.textContent = inAddFlow && !isReg ? "Add Account" : "Sign in";
    if (forgotPasswordLink) forgotPasswordLink.classList.toggle("hidden", inAddFlow);
    if (isForgot) {
        if (forgotStep1) forgotStep1.classList.remove("hidden");
        if (forgotStep2) forgotStep2.classList.add("hidden");
        if (forgotVerifyError) forgotVerifyError.classList.add("hidden");
        if (forgotCompleteError) forgotCompleteError.classList.add("hidden");
        if (forgotCompleteOk) forgotCompleteOk.classList.add("hidden");
        if (forgotEmail) forgotEmail.value = "";
        if (forgotTempPassword) forgotTempPassword.value = "";
        if (forgotNewPassword) forgotNewPassword.value = "";
        forgotRecoveryEmail = "";
        forgotRecoveryTempPassword = "";
    }
}

let adminPanelUi = null;
let adminPanelSetupDone = false;
let themePreviewChromeApi = null;
let themeCosmeticPreviewChromeApi = null;

async function refreshSpeedrunLevelsFromApi() {
    try {
        const r = await fetch(apiPath("/api/speedrun-levels"), { credentials: "include" });
        const data = await r.json();
        setRuntimeSpeedrunLevelsFromPayload(data.levels || []);
    } catch {
        setRuntimeSpeedrunLevelsFromPayload([]);
    }
    initSpeedrunAuxUi();
    if (speedrunLevelGrid) delete speedrunLevelGrid.dataset.built;
    buildSpeedrunLevelGridOnce();
    if (adminPanelUi && typeof adminPanelUi.refillSpeedrunLevelFilter === "function") {
        adminPanelUi.refillSpeedrunLevelFilter(getSpeedrunLevelCount());
    }
}

async function refreshPracticeLevelsFromApi() {
    try {
        const levels = await fetchPracticeLevels();
        setRuntimePracticeLevelsFromPayload(levels);
    } catch {
        setRuntimePracticeLevelsFromPayload([]);
    }
    refreshPracticeScreen();
}

function setupAdminPanelOnce() {
    if (adminPanelSetupDone || !cloudIsAdmin) return;
    const screen = document.getElementById("adminPanelScreen");
    const btnReturn = document.getElementById("adminPanelReturnBtn");
    const btnRec = document.getElementById("adminBtnRecords");
    const btnPwd = document.getElementById("adminBtnPasswordRecovery");
    const btnLev = document.getElementById("adminBtnLevels");
    const btnEd = document.getElementById("adminBtnEditor");
    const btnPenaltyLev = document.getElementById("adminBtnPenaltyLevels");
    const btnPenaltyEd = document.getElementById("adminBtnPenaltyEditor");
    const btnPracticeLev = document.getElementById("adminBtnPracticeLevels");
    const btnPracticeEd = document.getElementById("adminBtnPracticeEditor");
    const btnWall = document.getElementById("adminBtnWall");
        const btnAch = document.getElementById("adminBtnAchievements");
    const btnTasks = document.getElementById("adminBtnTasks");
    const btnBattlePass = document.getElementById("adminBtnBattlePass");
    const btnChallenges = document.getElementById("adminBtnChallenges");
    const btnTournaments = document.getElementById("adminBtnTournaments");
    const btnMarathon = document.getElementById("adminBtnMarathon");
    const btnCampaign = document.getElementById("adminBtnCampaign");
    const btnAnnouncements = document.getElementById("adminBtnAnnouncements");
    const btnWhatsNew = document.getElementById("adminBtnWhatsNew");
    const btnCrateCreator = document.getElementById("adminBtnCrateCreator");
    const btnShopCrates = document.getElementById("adminBtnShopCrates");
    const btnAdm = document.getElementById("adminBtnAdministrators");
    const panR = document.getElementById("adminPanelRecords");
    const panPwd = document.getElementById("adminPanelPasswordRecovery");
    const panL = document.getElementById("adminPanelLevels");
    const panE = document.getElementById("adminPanelEditor");
    const panPenaltyL = document.getElementById("adminPanelPenaltyLevels");
    const panPenaltyE = document.getElementById("adminPanelPenaltyEditor");
    const panPracticeL = document.getElementById("adminPanelPracticeLevels");
    const panPracticeE = document.getElementById("adminPanelPracticeEditor");
    const panWall = document.getElementById("adminPanelWall");
        const panAch = document.getElementById("adminPanelAchievements");
    const panTasks = document.getElementById("adminPanelTasks");
    const panBattlePass = document.getElementById("adminPanelBattlePass");
    const panChallenges = document.getElementById("adminPanelChallenges");
    const panTournaments = document.getElementById("adminPanelTournaments");
    const panMarathon = document.getElementById("adminPanelMarathon");
    const panCampaign = document.getElementById("adminPanelCampaign");
    const panAnnouncements = document.getElementById("adminPanelAnnouncements");
    const panWhatsNew = document.getElementById("adminPanelWhatsNew");
    const panCrateCreator = document.getElementById("adminPanelCrateCreator");
    const panShopCrates = document.getElementById("adminPanelShopCrates");
    const panAdm = document.getElementById("adminPanelAdministrators");
    const levMount = document.getElementById("adminSpeedrunLevelsMount");
    const penaltyLevMount = document.getElementById("adminPenaltyLevelsMount");
    const penaltyEdMount = document.getElementById("adminPenaltyEditorMount");
    const practiceLevMount = document.getElementById("adminPracticeLevelsMount");
    const practiceEdMount = document.getElementById("adminPracticeEditorMount");
    const srch = document.getElementById("adminRecordsSearch");
    const mode = document.getElementById("adminRecordsMode");
    const srl = document.getElementById("adminRecordsSpeedrunLevel");
    const srr = document.getElementById("adminRecordsSpeedrunRow");
    const refr = document.getElementById("adminRecordsRefresh");
    const manageStats = document.getElementById("adminRecordsManageStatsBtn");
    const tw = document.getElementById("adminRecordsTableWrap");
    const st = document.getElementById("adminRecordsStatus");
    const psScreen = document.getElementById("adminPlayerStatsScreen");
    const psBack = document.getElementById("adminPlayerStatsBackBtn");
    const psTitle = document.getElementById("adminPlayerStatsTitle");
    const psStatus = document.getElementById("adminPlayerStatsStatus");
    const psCore = document.getElementById("adminPlayerStatsCore");
    const psAch = document.getElementById("adminPlayerStatsAchievements");
    const psRec = document.getElementById("adminPlayerStatsRecords");
    const psSync = document.getElementById("adminPlayerStatsSynced");
    const psChModal = document.getElementById("adminPlayerStatsChangeModal");
    const psChLabel = document.getElementById("adminPlayerStatsChangeLabel");
    const psChCurrent = document.getElementById("adminPlayerStatsChangeCurrent");
    const psChInput = document.getElementById("adminPlayerStatsChangeInput");
    const psChHint = document.getElementById("adminPlayerStatsChangeHint");
    const psChError = document.getElementById("adminPlayerStatsChangeError");
    const psChCancel = document.getElementById("adminPlayerStatsChangeCancelBtn");
    const psChApply = document.getElementById("adminPlayerStatsChangeApplyBtn");
    const pwdSrch = document.getElementById("adminPasswordRecoverySearch");
    const pwdSrchBtn = document.getElementById("adminPasswordRecoverySearchBtn");
    const pwdTw = document.getElementById("adminPasswordRecoveryTableWrap");
    const pwdSt = document.getElementById("adminPasswordRecoveryStatus");
    const pwdRes = document.getElementById("adminPasswordRecoveryResult");
    const pwdUser = document.getElementById("adminTempPasswordUser");
    const pwdEmail = document.getElementById("adminTempPasswordEmail");
    const pwdVal = document.getElementById("adminTempPasswordValue");
    const pwdCopy = document.getElementById("adminTempPasswordCopyBtn");
    const edMount = document.getElementById("adminSpeedrunEditorMount");
    const wallMount = document.getElementById("adminWallEditorMount");
    const achMount = document.getElementById("adminAchievementsMount");
    const tasksMount = document.getElementById("adminTasksMount");
    const battlePassMount = document.getElementById("adminBattlePassMount");
    const challengesMount = document.getElementById("adminChallengesMount");
    const tournamentsMount = document.getElementById("adminTournamentsMount");
    const marathonMount = document.getElementById("adminMarathonMount");
    const campaignMount = document.getElementById("adminCampaignMount");
    const announcementsMount = document.getElementById("adminAnnouncementsMount");
    const whatsNewMount = document.getElementById("adminWhatsNewMount");
    const crateCreatorMount = document.getElementById("adminCrateCreatorMount");
    const shopCratesMount = document.getElementById("adminShopCratesMount");
    const admSrch = document.getElementById("adminAdministratorsSearch");
    const admSrchBtn = document.getElementById("adminAdministratorsSearchBtn");
    const admListBtn = document.getElementById("adminAdministratorsListBtn");
    const admTw = document.getElementById("adminAdministratorsTableWrap");
    const admSt = document.getElementById("adminAdministratorsStatus");
    const toSrch = document.getElementById("adminTimeoutSearch");
    const toMin = document.getElementById("adminTimeoutMinutes");
    const toBtn = document.getElementById("adminTimeoutSearchBtn");
    const toActiveBtn = document.getElementById("adminTimeoutActiveRefreshBtn");
    const toActiveTw = document.getElementById("adminTimeoutActiveTableWrap");
    const toActiveSt = document.getElementById("adminTimeoutActiveStatus");
    const toTw = document.getElementById("adminTimeoutTableWrap");
    const toSt = document.getElementById("adminTimeoutStatus");
    const toReduceModal = document.getElementById("adminTimeoutReduceModal");
    const toReduceUser = document.getElementById("adminTimeoutReduceUser");
    const toReduceCurrent = document.getElementById("adminTimeoutReduceCurrent");
    const toReduceMode = document.getElementById("adminTimeoutReduceMode");
    const toReduceDuration = document.getElementById("adminTimeoutReduceDuration");
    const toReduceError = document.getElementById("adminTimeoutReduceError");
    const toReduceCancel = document.getElementById("adminTimeoutReduceCancelBtn");
    const toReduceApply = document.getElementById("adminTimeoutReduceApplyBtn");
    const delRecModal = document.getElementById("adminDeleteRecordsModal");
    const delRecUser = document.getElementById("adminDeleteRecordsUser");
    const delRecMode = document.getElementById("adminDeleteRecordsMode");
    const delRecLevelList = document.getElementById("adminDeleteRecordsLevelList");
    const delRecError = document.getElementById("adminDeleteRecordsError");
    const delRecCancel = document.getElementById("adminDeleteRecordsCancelBtn");
    const delRecAllLevels = document.getElementById("adminDeleteRecordsAllLevelsBtn");
    if (
        !screen ||
        !btnReturn ||
        !btnRec ||
        !btnPwd ||
        !btnLev ||
        !btnEd ||
        !btnPenaltyLev ||
        !btnPenaltyEd ||
        !btnPracticeLev ||
        !btnPracticeEd ||
        !btnWall ||
        !btnAch ||
        !btnTasks ||
        !btnBattlePass ||
        !btnChallenges ||
        !btnTournaments ||
        !btnMarathon ||
        !btnCampaign ||
        !btnAnnouncements ||
        !btnWhatsNew ||
        !btnCrateCreator ||
        !btnShopCrates ||
        !btnAdm ||
        !panR ||
        !panPwd ||
        !panL ||
        !panE ||
        !panPenaltyL ||
        !panPenaltyE ||
        !panPracticeL ||
        !panPracticeE ||
        !panWall ||
        !panAch ||
        !panTasks ||
        !panBattlePass ||
        !panChallenges ||
        !panTournaments ||
        !panMarathon ||
        !panCampaign ||
        !panAnnouncements ||
        !panWhatsNew ||
        !panCrateCreator ||
        !panShopCrates ||
        !panAdm ||
        !levMount ||
        !penaltyLevMount ||
        !penaltyEdMount ||
        !practiceLevMount ||
        !practiceEdMount ||
        !srch ||
        !mode ||
        !srl ||
        !srr ||
        !refr ||
        !manageStats ||
        !tw ||
        !st ||
        !psScreen ||
        !psBack ||
        !psTitle ||
        !psStatus ||
        !psCore ||
        !psAch ||
        !psRec ||
        !psSync ||
        !psChModal ||
        !psChLabel ||
        !psChCurrent ||
        !psChInput ||
        !psChHint ||
        !psChError ||
        !psChCancel ||
        !psChApply ||
        !pwdSrch ||
        !pwdSrchBtn ||
        !pwdTw ||
        !pwdSt ||
        !pwdRes ||
        !pwdUser ||
        !pwdEmail ||
        !pwdVal ||
        !pwdCopy ||
        !edMount ||
        !wallMount ||
        !achMount ||
        !tasksMount ||
        !battlePassMount ||
        !challengesMount ||
        !tournamentsMount ||
        !marathonMount ||
        !campaignMount ||
        !announcementsMount ||
        !whatsNewMount ||
        !crateCreatorMount ||
        !shopCratesMount ||
        !admSrch ||
        !admSrchBtn ||
        !admListBtn ||
        !admTw ||
        !admSt ||
        !toSrch ||
        !toMin ||
        !toBtn ||
        !toActiveBtn ||
        !toActiveTw ||
        !toActiveSt ||
        !toTw ||
        !toSt ||
        !toReduceModal ||
        !toReduceUser ||
        !toReduceCurrent ||
        !toReduceMode ||
        !toReduceDuration ||
        !toReduceError ||
        !toReduceCancel ||
        !toReduceApply ||
        !delRecModal ||
        !delRecUser ||
        !delRecMode ||
        !delRecLevelList ||
        !delRecError ||
        !delRecCancel ||
        !delRecAllLevels
    )
        return;
    RANKING_MODES.forEach(([val, label]) => {
        const o = document.createElement("option");
        o.value = val;
        o.textContent = label;
        mode.appendChild(o);
    });
    adminPanelUi = initAdminPanel({
        onVisibilityChange: scheduleSidebarSync,
        onPlayerRecordsChanged: async (userId) => {
            if (!cloudUser || cloudUser.id !== userId) return;
            await syncLocalStatsFromLeaderboard();
            applyLocalAccountSessionCleared();
        },
        screen,
        btnReturn,
        btnRecords: btnRec,
        btnPasswordRecovery: btnPwd,
        btnLevels: btnLev,
        btnEditor: btnEd,
        btnPenaltyLevels: btnPenaltyLev as HTMLButtonElement,
        btnPenaltyEditor: btnPenaltyEd as HTMLButtonElement,
        btnPracticeLevels: btnPracticeLev as HTMLButtonElement,
        btnPracticeEditor: btnPracticeEd as HTMLButtonElement,
        btnWall,
        btnAchievements: btnAch,
        btnTasks: btnTasks as HTMLButtonElement,
        btnBattlePass: btnBattlePass as HTMLButtonElement,
        btnChallenges: btnChallenges as HTMLButtonElement,
        btnTournaments: btnTournaments as HTMLButtonElement,
        btnMarathon: btnMarathon as HTMLButtonElement,
        btnCampaign: btnCampaign as HTMLButtonElement,
        btnAnnouncements: btnAnnouncements as HTMLButtonElement,
        btnWhatsNew: btnWhatsNew as HTMLButtonElement,
        btnShopCreator: document.getElementById("adminBtnShopCreator") as HTMLButtonElement,
        btnCrateCreator: btnCrateCreator as HTMLButtonElement,
        btnShopItems: document.getElementById("adminBtnShopItems") as HTMLButtonElement,
        btnShopCrates: btnShopCrates as HTMLButtonElement,
        btnShopDots: document.getElementById("adminBtnShopDots") as HTMLButtonElement,
        btnSplash: document.getElementById("adminBtnSplash") as HTMLButtonElement,
        btnThemeCreator: document.getElementById("adminBtnThemeCreator") as HTMLButtonElement,
        btnIconCreator: document.getElementById("adminBtnIconCreator") as HTMLButtonElement,
        btnAdministrators: btnAdm,
        adminPermissions: cloudAdminPermissions,
        currentUserId: cloudUser?.id ?? null,
        onEnterThemePreview: (api) => {
            const adm = document.getElementById("adminPanelScreen");
            if (adm) hideEl(adm);
            document.body.classList.remove("admin-sidebar-nav");
            showEl(startScreen);
            setActiveSidebarBtn(null);
            setThemePreviewData(api.getData());
            refreshGameThemePresentation();
            themePreviewChromeApi?.destroy();
            themePreviewChromeApi = mountThemePreviewChrome({
                getData: api.getData,
                setData: (d) => {
                    api.setData(d);
                    setThemePreviewData(d);
                    refreshGameThemePresentation();
                },
                onBack: () => {
                    themePreviewChromeApi?.destroy();
                    themePreviewChromeApi = null;
                    api.onExit();
                    if (adminPanelUi) adminPanelUi.open();
                    const themeBtn = document.getElementById("adminBtnThemeCreator");
                    if (themeBtn instanceof HTMLButtonElement) themeBtn.click();
                },
            });
        },
        onEnterThemeCosmeticPreview: (api) => {
            themeCosmeticPreviewChromeApi?.destroy();
            themePreviewChromeApi?.destroy();
            themePreviewChromeApi = null;
            const adm = document.getElementById("adminPanelScreen");
            if (adm) hideEl(adm);
            document.body.classList.remove("admin-sidebar-nav");
            showEl(startScreen);
            setActiveSidebarBtn(null);
            setThemeCosmeticPreviewData(api.getData());
            setThemeCosmeticPreviewPlay(true);
            applySettings();
            // Particle emitters sync via refresh — applySettings alone does not mount them.
            refreshGameThemePresentation();
            themeCosmeticPreviewChromeApi = mountThemeCosmeticPreviewChrome({
                getData: api.getData,
                setData: (d) => {
                    api.setData(d);
                    setThemeCosmeticPreviewData(d);
                    refreshGameThemePresentation();
                },
                onBack: () => {
                    const latest = getThemeCosmeticPreviewData() ?? api.getData();
                    api.setData(latest);
                    goToMenu(null);
                    themeCosmeticPreviewChromeApi?.destroy();
                    themeCosmeticPreviewChromeApi = null;
                    setThemeCosmeticPreviewPlay(false);
                    setThemeCosmeticPreviewData(null);
                    applySettings();
                    refreshGameThemePresentation();
                    api.onExit();
                    if (adminPanelUi) adminPanelUi.open();
                    const returnId = api.returnButtonId || "adminBtnShopCreator";
                    const returnBtn = document.getElementById(returnId);
                    if (returnBtn instanceof HTMLButtonElement) returnBtn.click();
                },
            });
        },
        onAdminClosed: () => {
            if (document.body.classList.contains("theme-preview-mode")) return;
            setThemePreviewData(null);
            void loadPublishedGameTheme();
            if (isThemeCosmeticPreviewPlay()) {
                setThemeCosmeticPreviewPlay(false);
                setThemeCosmeticPreviewData(null);
                themeCosmeticPreviewChromeApi?.destroy();
                themeCosmeticPreviewChromeApi = null;
                applySettings();
            }
        },
        panelRecords: panR,
        panelPasswordRecovery: panPwd,
        panelLevels: panL,
        panelEditor: panE,
        panelPenaltyLevels: panPenaltyL,
        panelPenaltyEditor: panPenaltyE,
        panelPracticeLevels: panPracticeL,
        panelPracticeEditor: panPracticeE,
        panelWall: panWall,
        panelAchievements: panAch,
        panelTasks: panTasks as HTMLElement,
        panelBattlePass: panBattlePass as HTMLElement,
        panelChallenges: panChallenges as HTMLElement,
        panelTournaments: panTournaments as HTMLElement,
        panelMarathon: panMarathon as HTMLElement,
        panelCampaign: panCampaign as HTMLElement,
        panelAnnouncements: panAnnouncements as HTMLElement,
        panelWhatsNew: panWhatsNew as HTMLElement,
        panelShopCreator: document.getElementById("adminPanelShopCreator") as HTMLElement,
        panelCrateCreator: panCrateCreator as HTMLElement,
        panelShopItems: document.getElementById("adminPanelShopItems") as HTMLElement,
        panelShopCrates: panShopCrates as HTMLElement,
        panelShopDots: document.getElementById("adminPanelShopDots") as HTMLElement,
        panelSplash: document.getElementById("adminPanelSplash") as HTMLElement,
        panelThemeCreator: document.getElementById("adminPanelThemeCreator") as HTMLElement,
        panelIconCreator: document.getElementById("adminPanelIconCreator") as HTMLElement,
        panelAdministrators: panAdm,
        levelsMount: levMount,
        penaltyLevelsMount: penaltyLevMount,
        penaltyEditorMount: penaltyEdMount,
        practiceLevelsMount: practiceLevMount,
        practiceEditorMount: practiceEdMount,
        recordsSearch: srch,
        recordsMode: mode,
        recordsSpeedrunLevel: srl,
        recordsSpeedrunRow: srr,
        recordsRefresh: refr as HTMLButtonElement,
        recordsManageStatsBtn: manageStats as HTMLButtonElement,
        recordsTableWrap: tw,
        recordsStatus: st,
        playerStatsScreen: psScreen,
        playerStatsBackBtn: psBack as HTMLButtonElement,
        playerStatsTitle: psTitle,
        playerStatsStatus: psStatus,
        playerStatsCore: psCore,
        playerStatsAchievements: psAch,
        playerStatsRecords: psRec,
        playerStatsSynced: psSync,
        playerStatsChangeModal: psChModal,
        playerStatsChangeLabel: psChLabel,
        playerStatsChangeCurrent: psChCurrent,
        playerStatsChangeInput: psChInput as HTMLInputElement,
        playerStatsChangeHint: psChHint,
        playerStatsChangeError: psChError,
        playerStatsChangeCancelBtn: psChCancel as HTMLButtonElement,
        playerStatsChangeApplyBtn: psChApply as HTMLButtonElement,
        timeoutSearch: toSrch,
        timeoutMinutes: toMin,
        timeoutSearchBtn: toBtn,
        timeoutActiveRefreshBtn: toActiveBtn,
        timeoutActiveTableWrap: toActiveTw,
        timeoutActiveStatus: toActiveSt,
        timeoutTableWrap: toTw,
        timeoutStatus: toSt,
        timeoutReduceModal: toReduceModal,
        timeoutReduceUser: toReduceUser,
        timeoutReduceCurrent: toReduceCurrent,
        timeoutReduceMode: toReduceMode as HTMLSelectElement,
        timeoutReduceDuration: toReduceDuration as HTMLInputElement,
        timeoutReduceError: toReduceError,
        timeoutReduceCancelBtn: toReduceCancel as HTMLButtonElement,
        timeoutReduceApplyBtn: toReduceApply as HTMLButtonElement,
        deleteRecordsModal: delRecModal,
        deleteRecordsUser: delRecUser,
        deleteRecordsMode: delRecMode,
        deleteRecordsLevelList: delRecLevelList,
        deleteRecordsError: delRecError,
        deleteRecordsCancelBtn: delRecCancel as HTMLButtonElement,
        deleteRecordsAllLevelsBtn: delRecAllLevels as HTMLButtonElement,
        passwordRecoverySearch: pwdSrch,
        passwordRecoverySearchBtn: pwdSrchBtn,
        passwordRecoveryTableWrap: pwdTw,
        passwordRecoveryStatus: pwdSt,
        passwordRecoveryResult: pwdRes,
        tempPasswordUser: pwdUser,
        tempPasswordEmail: pwdEmail,
        tempPasswordValue: pwdVal,
        tempPasswordCopyBtn: pwdCopy,
        editorMount: edMount,
        wallMount,
        achievementsMount: achMount,
        tasksMount: tasksMount as HTMLElement,
        battlePassMount: battlePassMount as HTMLElement,
        challengesMount: challengesMount as HTMLElement,
        tournamentsMount: tournamentsMount as HTMLElement,
        marathonMount: marathonMount as HTMLElement,
        campaignMount: campaignMount as HTMLElement,
        announcementsMount: announcementsMount as HTMLElement,
        whatsNewMount: whatsNewMount as HTMLElement,
        shopCreatorMount: document.getElementById("adminShopCreatorMount") as HTMLElement,
        crateCreatorMount: crateCreatorMount as HTMLElement,
        shopItemsMount: document.getElementById("adminShopItemsMount") as HTMLElement,
        shopCratesMount: shopCratesMount as HTMLElement,
        shopDotsSearch: document.getElementById("adminShopDotsSearch") as HTMLInputElement,
        shopDotsSearchBtn: document.getElementById("adminShopDotsSearchBtn") as HTMLButtonElement,
        shopDotsStatus: document.getElementById("adminShopDotsStatus") as HTMLElement,
        shopDotsCandidates: document.getElementById("adminShopDotsCandidates") as HTMLElement,
        shopDotsDetail: document.getElementById("adminShopDotsDetail") as HTMLElement,
        shopDotsDetailTitle: document.getElementById("adminShopDotsDetailTitle") as HTMLElement,
        shopDotsBalance: document.getElementById("adminShopDotsBalance") as HTMLElement,
        shopDotsInventory: document.getElementById("adminShopDotsInventory") as HTMLElement,
        splashMount: document.getElementById("adminSplashMount") as HTMLElement,
        themeCreatorMount: document.getElementById("adminThemeCreatorMount") as HTMLElement,
        iconCreatorMount: document.getElementById("adminIconCreatorMount") as HTMLElement,
        administratorsSearch: admSrch,
        administratorsSearchBtn: admSrchBtn,
        administratorsListBtn: admListBtn,
        administratorsTableWrap: admTw,
        administratorsStatus: admSt,
        onSpeedrunLevelsChanged: () => {
            void refreshSpeedrunLevelsFromApi();
        },
        onPenaltyLevelsChanged: () => {
            void refreshPenaltyLevelsFromApi();
        },
        onPracticeLevelsChanged: () => {
            void refreshPracticeLevelsFromApi();
        },
    });
    adminPanelUi.refillSpeedrunLevelFilter(getSpeedrunLevelCount());
    if (sideAdminPanelBtn) {
        sideAdminPanelBtn.onclick = () => {
            setActiveSidebarBtn(sideAdminPanelBtn);
            adminPanelUi.open();
        };
    }
    adminPanelSetupDone = true;
}

function endAdminSpeedrunPlaytest() {
    clearAdminSpeedrunPlaytestState();
    const wasPractice = practicePlayActive;
    const practiceFromAdmin = practicePlayFromAdmin;
    clearPracticePlayState();
    exitGamePointerLock();
    playing = false;
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    document.body.classList.remove("hideCursor");
    gameMode = null;
    hideEl(returnBtn);
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    hideEl(speedrunCompleteScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    if (topCenter) topCenter.textContent = "";
    resize();
    if (wasPractice && !practiceFromAdmin) {
        openPractice();
        updateMusicState();
        updateMobilePlayChrome();
        return;
    }
    const adm = document.getElementById("adminPanelScreen");
    if (adm) showEl(adm);
    if (
        wasPractice &&
        practiceFromAdmin &&
        adminPanelUi &&
        typeof adminPanelUi.restorePracticeEditorAfterPlaytest === "function"
    ) {
        adminPanelUi.restorePracticeEditorAfterPlaytest();
    } else if (adminPanelUi && typeof adminPanelUi.restoreEditorAfterPlaytest === "function") {
        adminPanelUi.restoreEditorAfterPlaytest();
    }
    updateMusicState();
    updateMobilePlayChrome();
}

function endAdminPenaltyPlaytest() {
    clearAdminPenaltyPlaytestState();
    exitGamePointerLock();
    playing = false;
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    document.body.classList.remove("hideCursor");
    gameMode = null;
    hideEl(returnBtn);
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    hideEl(penaltyCompleteScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    if (topCenter) topCenter.textContent = "";
    resize();
    const adm = document.getElementById("adminPanelScreen");
    if (adm) showEl(adm);
    if (adminPanelUi && typeof adminPanelUi.restorePenaltyEditorAfterPlaytest === "function") {
        adminPanelUi.restorePenaltyEditorAfterPlaytest();
    }
    updateMusicState();
    updateMobilePlayChrome();
}

const SESSION_FETCH_TIMEOUT_MS = 12000;

async function fetchSessionResponse() {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), SESSION_FETCH_TIMEOUT_MS);
    try {
        return await fetch(apiPath("/api/session"), {
            credentials: "include",
            signal: controller.signal,
        });
    } finally {
        window.clearTimeout(timer);
    }
}

async function refreshAuthStatus(options: { bootstrap?: boolean; awaitAccountData?: boolean } = {}) {
    const useBootstrap = options.bootstrap === true || !appInitialBootstrapDone;
    const awaitAccountData = options.awaitAccountData === true;
    authRefreshSerial = authRefreshSerial.then(async () => {
    if (useBootstrap) setAccountBootstrapActive(true);
    try {
    if (!authStatusLine) return;
    authStatusLine.classList.remove("authStatusLine--signedIn");
    const showGuestAuthChrome = () => {
        hideEl(sideLogoutBtn);
        if (sideSwitchAccountBtn) hideEl(sideSwitchAccountBtn);
        if (sideNavAccountRow) hideEl(sideNavAccountRow);
        setSwitchAccountVisible(false);
        if (sideSignInBtn) showEl(sideSignInBtn);
        if (homeSignInBtn) showEl(homeSignInBtn);
        cloudIsAdmin = false;
        cloudAdminPermissions = [];
        if (sideAdminPanelBtn) hideEl(sideAdminPanelBtn);
    };
    const showSignedAuthChrome = () => {
        if (sideNavAccountRow) showEl(sideNavAccountRow);
        showEl(sideLogoutBtn);
        setSwitchAccountVisible(true);
        if (sideSignInBtn) hideEl(sideSignInBtn);
        if (homeSignInBtn) hideEl(homeSignInBtn);
    };
    let r;
    try {
        r = await fetchSessionResponse();
    } catch (err) {
        cloudUser = null;
        speedrunCloudPersonalBests = null;
        sandboxSpeedrunCloudBests = null;
        sandboxScoreCloudBests = null;
    sandboxScoreCloudBests = null;
        authStatusLine.textContent =
            err && typeof err === "object" && (err).name === "AbortError"
                ? "Session check timed out — menu loaded without cloud sync. Check your network or API proxy."
                : "Could not reach /api. Run the game with `npm run dev` (do not open the HTML file alone). Check blockers, the URL, and if you use VITE_API_PROXY that the backend (e.g. vercel dev) is running.";
        showGuestAuthChrome();
        authGateDismissed = false;
        return;
    }
    let data;
    try {
        data = await r.json();
    } catch {
        cloudUser = null;
        speedrunCloudPersonalBests = null;
        sandboxSpeedrunCloudBests = null;
        sandboxScoreCloudBests = null;
    sandboxScoreCloudBests = null;
        authStatusLine.textContent =
            "/api did not return JSON (often index.html: SPA rewrite caught /api, or static host without serverless). Open " +
            apiPath("/api/health") +
            " in this deployment. On Vercel, confirm Deployment summary lists Serverless Functions.";
        showGuestAuthChrome();
        authGateDismissed = false;
        return;
    }
    if (data.authenticated && data.user) {
        cloudUser = data.user;
        cloudTimedOut = !!data.timedOut;
        cloudTimedOutUntil = data.timedOutUntil || null;
        cloudTimedOutAt = data.timedOutAt || null;
        const name = data.user.displayName || data.user.email || "Player";
        authStatusLine.textContent = name;
        authStatusLine.classList.add("authStatusLine--signedIn");
        authGateDismissed = true;
        cloudAdminPermissions = Array.isArray(data.adminPermissions) ? data.adminPermissions : [];
        cloudIsAdmin = !!data.isAdmin;
        setWallAuthenticated(!!data.authenticated);
        syncHomeNotificationsBell();
        void refreshNotificationsUnread();
        void refreshTasksClaimIndicator();
        void refreshBattlePassClaimIndicator();

        if (cloudTimedOut) {
            hideEl(sideLogoutBtn);
            if (sideSignInBtn) hideEl(sideSignInBtn);
            if (homeSignInBtn) hideEl(homeSignInBtn);
            if (sideAdminPanelBtn) hideEl(sideAdminPanelBtn);
            setAccountSyncSignedIn(false);
            stopPresenceHeartbeat();
            showTimeoutScreen();
            void syncPushSubscriptionForSession(null);
            return;
        }

        hideTimeoutScreen();
        showSignedAuthChrome();
        if (data.sessionToken) rememberAccountFromAuth(data.user, data.sessionToken);
        if (sideAdminPanelBtn) {
            if (cloudIsAdmin) {
                showEl(sideAdminPanelBtn);
                setupAdminPanelOnce();
            } else hideEl(sideAdminPanelBtn);
        }
        setAccountSyncSignedIn(true, data.user.id);
        startPresenceHeartbeat();
        void syncPushSubscriptionForSession(data.user.id);
        // Do not clear local here — pullAccountDataSync snapshots play streaks first, then clears if needed.
        if (awaitAccountData) {
            await hydrateAccountDataForUser(data.user.id);
            applyLocalAccountSessionCleared();
        } else {
            void hydrateAccountDataForUser(data.user.id).then(() => applyLocalAccountSessionCleared());
        }
    } else {
        const wasSignedIn = !!cloudUser;
        const orphanedSync = !!getAccountSyncUserId();
        cloudUser = null;
        cloudTimedOut = false;
        cloudTimedOutUntil = null;
        cloudTimedOutAt = null;
        stopPresenceHeartbeat();
        invalidateMyBestsCache();
        hudStatsBestCache = {};
        hudStatsBestCacheUserId = null;
        hideTimeoutScreen();
        setWallAuthenticated(false);
        setAccountSyncSignedIn(false);
        void syncPushSubscriptionForSession(null);
        if (wasSignedIn || orphanedSync) {
            clearAccountSessionLocal();
            applyLocalAccountSessionCleared();
        }
        speedrunCloudPersonalBests = null;
        sandboxSpeedrunCloudBests = null;
        sandboxScoreCloudBests = null;
    sandboxScoreCloudBests = null;
        if (data.apiProxyFallback) {
            authStatusLine.textContent =
                "Local: VITE_API_PROXY is not responding; using mock API. Start the backend or remove VITE_API_PROXY from .env for mock-only.";
        } else if (data.localViteStub) {
            authStatusLine.textContent =
                "Local: Vite serves /api in mock mode (no PostgreSQL). For a real account use the Vercel deployment or VITE_API_PROXY + vercel dev.";
        } else if (data.database === false) {
            authStatusLine.textContent =
                "Cloud: no database URL on the server (set DATABASE_URL or Neon POSTGRES_PRISMA_URL / POSTGRES_URL). Redeploy after env changes.";
        } else {
            authStatusLine.textContent =
                "Not signed in — scores are only sent to the leaderboard when you are logged in.";
        }
        showGuestAuthChrome();
    }
    void refreshSpeedrunLevelsFromApi();
    void refreshSettingsAccountUi();
    } finally {
        if (useBootstrap) {
            appInitialBootstrapDone = true;
            setAccountBootstrapActive(false);
            ensureHomePlayStreakUi();
            refreshAllPlayStreakUi();
            refreshWhatsNewModal();
        }
    }
    }).catch(() => {
        if (!appInitialBootstrapDone) {
            appInitialBootstrapDone = true;
            setAccountBootstrapActive(false);
            refreshWhatsNewModal();
        }
        void refreshSpeedrunLevelsFromApi();
    });
    return authRefreshSerial;
}

let addAccountResumeModeScreen = false;
let addAccountResumeGameHub = false;

async function resolveCurrentSavedAccount(): Promise<SavedAccount | null> {
    if (!cloudUser) return null;
    const existing = getSavedAccounts().find((a) => a.id === cloudUser.id);
    if (existing) return existing;
    try {
        const r = await fetchSessionResponse();
        const data = await r.json();
        if (data.authenticated && data.user && data.sessionToken) {
            return rememberAccountFromAuth(data.user, data.sessionToken, { addIfMissing: true });
        }
    } catch {
        /* ignore */
    }
    return null;
}

async function beginAddAccountFlowAndOpen() {
    const current = await resolveCurrentSavedAccount();
    if (!current || !beginAddAccountFlow(current)) {
        openAuthScreen("login");
        return;
    }
    openAddAccountScreen();
}

function openAddAccountScreen() {
    addAccountResumeModeScreen = !!(modeScreen && !modeScreen.classList.contains("hidden"));
    addAccountResumeGameHub = !!(gameHubScreen && !gameHubScreen.classList.contains("hidden"));
    hideTimeoutScreen();
    claimExclusiveUi("authScreen");
    hideEl(startScreen);
    hideHubScreens();
    hideEl(returnBtn);
    showEl(authScreen);
    setAuthTab("addAccount");
    loginError.classList.add("hidden");
    registerError.classList.add("hidden");
    updateMusicState();
}

async function closeAddAccountScreen() {
    clearAddAccountReturnTarget();
    hideEl(authScreen);
    if (addAccountResumeModeScreen) {
        showEl(modeScreen);
        showEl(returnBtn);
    } else if (addAccountResumeGameHub) {
        showEl(gameHubScreen);
        showEl(returnBtn);
    } else {
        showEl(startScreen);
    }
    addAccountResumeModeScreen = false;
    addAccountResumeGameHub = false;
    updateMusicState();
    await performAccountSessionRefresh();
    void refreshSettingsAccountUi();
    playScreenEnterMotion();
}

function openAuthScreen(tab) {
    clearAddAccountReturnTarget();
    hideTimeoutScreen();
    claimExclusiveUi("authScreen");
    hideEl(startScreen);
    hideHubScreens();
    hideEl(returnBtn);
    showEl(authScreen);
    setAuthTab(tab === "register" ? "register" : "login");
    loginError.classList.add("hidden");
    registerError.classList.add("hidden");
    updateMusicState();
}

function closeAuthScreen() {
    authGateDismissed = true;
    hideEl(authScreen);
    showEl(startScreen);
    updateMusicState();
    refreshAuthStatus({ bootstrap: true });
    playScreenEnterMotion();
}

function openLeaderboardForGameMode(modeId) {
    if (!RANKING_GAME_MODE_IDS.has(modeId)) return;
    setActiveSidebarBtn(sideRankingsBtn);
    if (rankingOtherSelect) rankingOtherSelect.value = "";
    if (rankingModeSelect) rankingModeSelect.value = modeId;
    syncRankingSpeedrunLevelUi();
    openLeaderboardScreen();
}

function openLeaderboardScreen() {
    claimExclusiveUi("leaderboardScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(leaderboardScreen);
    leaderboardStatus.textContent = "";
    loadLeaderboardTable();
    updateMusicState();
    playScreenEnterMotion();
}

function closeLeaderboardScreen() {
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

function syncRankingSpeedrunLevelUi() {
    if (rankingSpeedrunLevelWrap && rankingModeSelect) {
        const other = rankingOtherSelect ? rankingOtherSelect.value : "";
        const on = rankingModeSelect.value === "speedrun" && !other;
        rankingSpeedrunLevelWrap.classList.toggle("hidden", !on);
    }
    if (rankingPenaltyLevelWrap && rankingModeSelect) {
        const other = rankingOtherSelect ? rankingOtherSelect.value : "";
        const on = rankingModeSelect.value === "penalty" && !other;
        rankingPenaltyLevelWrap.classList.toggle("hidden", !on);
    }
}

function applyLeaderboardRankRowClass(tr, rank) {
    const r = Math.floor(Number(rank) || 0);
    if (r === 1) tr.classList.add("lbRow--rank1");
    else if (r === 2) tr.classList.add("lbRow--rank2");
    else if (r === 3) tr.classList.add("lbRow--rank3");
}

async function loadOtherRankingTable(stat) {
    leaderboardTableWrap.innerHTML = "";
    const valueLabel = stat === "deaths" ? "Deaths" : stat === "dots" ? "Dots" : "PlayTime";
    leaderboardStatus.textContent = "Loading…";
    syncRankingSpeedrunLevelUi();
    try {
        const url =
            stat === "dots"
                ? "/api/player-stats?stat=dots"
                : `/api/player-stats?stat=${encodeURIComponent(stat)}&limit=25`;
        const r = await fetch(apiPath(url), { credentials: "include" });
        const data = await r.json();
        if (data.message) leaderboardStatus.textContent = data.message;
        else if (data.items && data.items.length) {
            leaderboardStatus.textContent =
                stat === "dots"
                    ? `${data.items.length} player(s) ranked by Dots balance.`
                    : `Top ${data.items.length} players by ${valueLabel.toLowerCase()}.`;
        } else {
            leaderboardStatus.textContent =
                stat === "dots"
                    ? "No players yet."
                    : `No ${valueLabel.toLowerCase()} entries yet. Sign in and play to appear.`;
        }
        const rows = data.items || [];
        if (!rows.length) return;
        const tbl = document.createElement("table");
        tbl.className = "lbTable";
        const thead = document.createElement("thead");
        const hr = document.createElement("tr");
        ["#", "Name", valueLabel].forEach((h) => {
            const th = document.createElement("th");
            th.textContent = h;
            hr.appendChild(th);
        });
        thead.appendChild(hr);
        tbl.appendChild(thead);
        const tb = document.createElement("tbody");
        rows.forEach((it, i) => {
            const tr = document.createElement("tr");
            const rank = it.rank ?? i + 1;
            applyLeaderboardRankRowClass(tr, rank);
            const valCell =
                stat === "playtime"
                    ? formatTime(Number(it.value) || 0)
                    : stat === "dots"
                      ? (Number(it.value) || 0).toLocaleString()
                      : String(Number(it.value) || 0);
            [String(rank), String(it.displayName || "?"), valCell].forEach((txt) => {
                const td = document.createElement("td");
                td.textContent = txt;
                tr.appendChild(td);
            });
            tb.appendChild(tr);
        });
        tbl.appendChild(tb);
        leaderboardTableWrap.appendChild(tbl);
    } catch {
        leaderboardStatus.textContent = "Could not load rankings.";
    }
}

async function syncPlayerStatsToCloud(force = false) {
    if (!cloudUser || !isAccountSyncReady()) return;
    schedulePushAccountData(force);
    const now = performance.now();
    if (!force && now - lastPlayerStatsSyncMs < 30000) return;
    lastPlayerStatsSyncMs = now;
    try {
        await fetch(apiPath("/api/player-stats"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                totalDeaths: Math.floor(Number(deathCount) || 0),
                totalPlayTimeSec: Math.floor(Number(playTime) || 0),
            }),
        });
    } catch {
        /* optional cloud */
    }
}

function tryPlayAgainOrStartKeybind() {
    if (!hasKeybindAssigned("playAgain")) return false;
    if (gameOverScreen && !gameOverScreen.classList.contains("hidden")) {
        playAgainBtn?.click();
        return true;
    }
    if (startScreen && !startScreen.classList.contains("hidden")) {
        openModesBtn?.click();
        return true;
    }
    if (speedrunCompleteScreen && !speedrunCompleteScreen.classList.contains("hidden")) {
        speedrunCompletePlayAgainBtn?.click();
        return true;
    }
    if (penaltyCompleteScreen && !penaltyCompleteScreen.classList.contains("hidden")) {
        penaltyCompletePlayAgainBtn?.click();
        return true;
    }
    if (sandboxScreen && !sandboxScreen.classList.contains("hidden")) {
        sandboxPlayBtn?.click();
        return true;
    }
    return false;
}

function tryNextLevelKeybind() {
    if (!hasKeybindAssigned("nextLevel")) return false;
    if (
        speedrunCompleteScreen &&
        !speedrunCompleteScreen.classList.contains("hidden") &&
        speedrunCompleteNextBtn &&
        !speedrunCompleteNextBtn.classList.contains("hidden")
    ) {
        speedrunCompleteNextBtn.click();
        return true;
    }
    if (
        penaltyCompleteScreen &&
        !penaltyCompleteScreen.classList.contains("hidden") &&
        penaltyCompleteNextBtn &&
        !penaltyCompleteNextBtn.classList.contains("hidden")
    ) {
        penaltyCompleteNextBtn.click();
        return true;
    }
    return false;
}

async function loadLeaderboardTable() {
    leaderboardTableWrap.innerHTML = "";
    const other = rankingOtherSelect ? rankingOtherSelect.value : "";
    if (other === "deaths" || other === "playtime" || other === "dots") {
        await loadOtherRankingTable(other);
        return;
    }
    const mode = rankingModeSelect.value;
    const valueLabel =
        mode === "progression"
            ? "Best level"
            : mode === "speedrun"
              ? "Best time"
              : mode === "penalty"
                ? "Fewest hits"
                : "Best score";
    leaderboardStatus.textContent = "Loading…";
    syncRankingSpeedrunLevelUi();
    try {
        let url = `/api/leaderboard?mode=${encodeURIComponent(mode)}&limit=25`;
        if (mode === "speedrun" && rankingSpeedrunLevelSelect) {
            url += `&level=${encodeURIComponent(rankingSpeedrunLevelSelect.value)}`;
        }
        if (mode === "penalty" && rankingPenaltyLevelSelect) {
            url += `&level=${encodeURIComponent(rankingPenaltyLevelSelect.value)}`;
        }
        const r = await fetch(apiPath(url), {
            credentials: "include",
        });
        if (!r.ok) {
            leaderboardStatus.textContent = "Could not load rankings.";
            return;
        }
        const data = await r.json();
        if (data.message) leaderboardStatus.textContent = data.message;
        else if (data.items && data.items.length)
            leaderboardStatus.textContent =
                "Top " + data.items.length + " players (each player’s best in this mode).";
        else leaderboardStatus.textContent = "No entries yet for this mode.";
        const rows = data.items || [];
        if (!rows.length) return;
        const tbl = document.createElement("table");
        tbl.className = "lbTable";
        const thead = document.createElement("thead");
        const hr = document.createElement("tr");
        ["#", "Name", valueLabel, "Device", "When", ""].forEach((h) => {
            const th = document.createElement("th");
            th.textContent = h;
            hr.appendChild(th);
        });
        thead.appendChild(hr);
        tbl.appendChild(thead);
        const tb = document.createElement("tbody");
        rows.forEach((it, i) => {
            const tr = document.createElement("tr");
            const rank = i + 1;
            applyLeaderboardRankRowClass(tr, rank);
            const deviceLabel = it.device === "mobile" ? "Mobile" : it.device === "pc" ? "PC" : "—";
            const valCell =
                mode === "speedrun"
                    ? formatSpeedrunTime(Number(it.value) || 0)
                    : mode === "penalty"
                      ? formatPenaltyHits(Number(it.value) || 0)
                      : String(it.value);
            [String(rank), String(it.displayName || "?"), valCell, deviceLabel, new Date(it.at).toLocaleString()].forEach((txt) => {
                const td = document.createElement("td");
                td.textContent = txt;
                tr.appendChild(td);
            });
            const replayTd = document.createElement("td");
            replayTd.className = "lbReplayCell";
            if (it.hasReplay && it.userId) {
                let lvl;
                if (mode === "speedrun" && rankingSpeedrunLevelSelect) {
                    lvl = Math.floor(Number(rankingSpeedrunLevelSelect.value) || 0) || undefined;
                } else if (mode === "penalty" && rankingPenaltyLevelSelect) {
                    lvl = Math.floor(Number(rankingPenaltyLevelSelect.value) || 0) || undefined;
                }
                replayTd.appendChild(
                    createViewReplayLink(() => {
                        void openReplayViewer(it.userId, mode, {
                            level: lvl,
                            returnCtx: "leaderboard",
                        });
                    }),
                );
            }
            tr.appendChild(replayTd);
            tb.appendChild(tr);
        });
        tbl.appendChild(tb);
        leaderboardTableWrap.appendChild(tbl);
        if (mode === "speedrun" && cloudUser) void refreshSpeedrunCloudPersonalBests();
        if (mode === "penalty" && cloudUser) void refreshPenaltyCloudPersonalBests();
    } catch {
        leaderboardStatus.textContent = "Could not load rankings.";
    }
}

async function submitCloudScore() {
    if (dpadPositionCustomizeMode) return;
    if (isThemeCosmeticPreviewPlay()) return;
    const mode = gameMode;
    if (!mode) return;
    if (mode === "speedrun") return;
    if (mode === "penalty") return;
    if (!cloudUser) return;
    const value = mode === "progression" ? progressionLevel : gameplayScoreFloor();
    try {
        await submitLeaderboardWithOffline({
            mode,
            value,
            clientVersion: GAME_VERSION,
            device: isTouchGameUi() ? "mobile" : "pc",
        });
    } catch {
        /* optional cloud */
    }
    void reportTasksAfterRun({
        modeId: mode,
        score: value,
        levelIndex: null,
    });
}

let profileFriendsList = [];

function openProfileScreen() {
    claimExclusiveUi("profileScreen");
    hideEl(startScreen);
    hideHubScreens();
    if (!cloudUser) setProfilePanel("friends");
    else setProfilePanel(activeProfilePanel === "messages" ? "friends" : activeProfilePanel);
    showEl(profileScreen);
    updateMusicState();
    void loadProfileShell();
    playScreenEnterMotion();
}

function closeProfileScreen() {
    if (chatAutoRefreshTimer) { chatAutoRefreshTimer.stop(); chatAutoRefreshTimer = null; }
    if (friendsAutoRefreshTimer) { friendsAutoRefreshTimer.stop(); friendsAutoRefreshTimer = null; }
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    showEl(startScreen);
    updateMusicState();
    playScreenEnterMotion();
}

async function loadProfileShell() {
    if (friendActionStatus) friendActionStatus.textContent = "";
    if (!cloudUser) {
        setProfilePanel("friends");
        if (profileScreenHint) profileScreenHint.classList.remove("hidden");
        if (profileSignedBlock) profileSignedBlock.classList.add("hidden");
        return;
    }
    if (profileScreenHint) profileScreenHint.classList.add("hidden");
    if (profileSignedBlock) profileSignedBlock.classList.remove("hidden");
    if (profileMyId) profileMyId.textContent = cloudUser.id;
    if (profileMeLine) {
        const bits = [cloudUser.displayName, cloudUser.email].filter(Boolean);
        profileMeLine.textContent = bits.join(" · ");
    }
    if (profileBioInput) profileBioInput.value = cloudUser.profileBio || "";
    ensureOwnProfileActions();
    // Friends panel refresh is owned by setProfilePanel; still sync peer list data when elsewhere.
    if (activeProfilePanel !== "friends") await refreshFriendsUi();
    else refreshMessagePeerOptions();
}

function ensureOwnProfileActions() {
    if (!profileAccountBlock || !cloudUser) return;
    let row = profileAccountBlock.querySelector(".profileOwnProfileActions");
    if (!(row instanceof HTMLElement)) {
        row = document.createElement("div");
        row.className = "formRow profileOwnProfileActions";
        row.style.marginTop = "10px";
        row.style.gap = "8px";
        row.style.flexWrap = "wrap";
        const viewBtn = document.createElement("button");
        viewBtn.type = "button";
        viewBtn.className = "btn green";
        viewBtn.textContent = "View my profile";
        viewBtn.id = "profileViewOwnBtn";
        const photoBtn = document.createElement("button");
        photoBtn.type = "button";
        photoBtn.className = "btn";
        photoBtn.textContent = "Edit profile photo";
        photoBtn.id = "profileEditPhotoBtn";
        row.appendChild(viewBtn);
        row.appendChild(photoBtn);
        profileAccountBlock.appendChild(row);
    }
    const viewBtn = row.querySelector("#profileViewOwnBtn");
    const photoBtn = row.querySelector("#profileEditPhotoBtn");
    if (viewBtn instanceof HTMLButtonElement) {
        viewBtn.onclick = () => {
            publicProfileReturnToFriends = false;
            setProfilePanel("find-player");
            void openPublicPlayerProfile(cloudUser.id);
        };
    }
    if (photoBtn instanceof HTMLButtonElement) {
        photoBtn.onclick = async () => {
            try {
                const r = await fetch(apiPath(`/api/profile?userId=${encodeURIComponent(cloudUser.id)}`), {
                    credentials: "include",
                    headers: { Accept: "application/json" },
                });
                if (!r.ok) return;
                const data = await r.json();
                openProfilePhotoEditor({
                    cosmetics: Array.isArray(data.cosmetics) ? data.cosmetics : [],
                    cursorColor: data.cursorColor || settingCursorColor || "#ffffff",
                    initial: data.profilePhoto || null,
                    resolveCosmeticDisplay: resolvePublicCosmeticDisplay,
                    onSaved: () => {},
                });
            } catch {
                /* ignore */
            }
        };
    }
}

async function refreshFriendsUi() {
    if (!friendIncomingList || !friendListWrap) return;
    const gen = ++friendsRefreshGen;
    try {
        const r = await fetch(apiPath("/api/friends"), { credentials: "include" });
        if (gen !== friendsRefreshGen) return;
        if (!r.ok) return;
        const d = await r.json();
        if (gen !== friendsRefreshGen) return;
        profileFriendsList = Array.isArray(d.friends) ? d.friends : [];
        renderFriendsIncoming(Array.isArray(d.incoming) ? d.incoming : []);
        renderFriendsList(profileFriendsList);
        refreshMessagePeerOptions();
    } catch {
        /* ignore */
    }
}

function renderFriendsIncoming(incoming) {
    if (!friendIncomingList) return;
    const seen = new Set();
    incoming.forEach((req) => {
        const id = String(req.requestId || "");
        if (!id) return;
        seen.add(id);
        let wrap = friendIncomingList.querySelector(`[data-request-id="${cssEscapeAttr(id)}"]`);
        if (!(wrap instanceof HTMLElement)) {
            wrap = document.createElement("div");
            wrap.className = "profileFriendRow profileFriendRow--request";
            wrap.dataset.requestId = id;
            const label = document.createElement("p");
            label.className = "accessHint profileFriendRequestLabel";
            wrap.appendChild(label);
            const row = document.createElement("div");
            row.className = "sandboxRowBtns";
            const ok = document.createElement("button");
            ok.type = "button";
            ok.className = "btn green";
            ok.textContent = "Accept";
            ok.onclick = async () => {
                await fetch(apiPath("/api/friends"), {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ action: "accept", requestId: id }),
                });
                void refreshFriendsUi();
            };
            const no = document.createElement("button");
            no.type = "button";
            no.className = "btn";
            no.textContent = "Decline";
            no.onclick = async () => {
                await fetch(apiPath("/api/friends"), {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ action: "decline", requestId: id }),
                });
                void refreshFriendsUi();
            };
            row.appendChild(ok);
            row.appendChild(no);
            wrap.appendChild(row);
            friendIncomingList.appendChild(wrap);
        }
        const labelEl = wrap.querySelector(".profileFriendRequestLabel");
        if (labelEl) {
            labelEl.textContent = `Friend request from: ${req.displayName || req.fromUserId}`;
        }
    });
    friendIncomingList.querySelectorAll("[data-request-id]").forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        if (!seen.has(el.dataset.requestId || "")) el.remove();
    });
}

function formatFriendLastSeen(lastSeenAt) {
    if (!lastSeenAt) return "";
    const t = Date.parse(String(lastSeenAt));
    if (!Number.isFinite(t)) return "";
    const sec = Math.max(0, Math.floor((Date.now() - t) / 1000));
    if (sec < 60) return "just now";
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const day = Math.floor(hr / 24);
    if (day < 30) return `${day}d ago`;
    const mo = Math.floor(day / 30);
    if (mo < 12) return `${mo}mo ago`;
    const yr = Math.floor(day / 365);
    return `${yr}y ago`;
}

function renderFriendsList(friends) {
    if (!friendListWrap) return;
    const seen = new Set();
    friends.forEach((f) => {
        const id = String(f.id || "");
        if (!id) return;
        seen.add(id);
        let div = friendListWrap.querySelector(`[data-friend-id="${cssEscapeAttr(id)}"]`);
        if (!(div instanceof HTMLElement)) {
            div = document.createElement("div");
            div.className = "profileFriendRow";
            div.dataset.friendId = id;

            const info = document.createElement("div");
            info.className = "profileFriendInfo";
            const dot = document.createElement("span");
            dot.className = "profileFriendStatusDot";
            const meta = document.createElement("div");
            meta.className = "profileFriendMeta";
            const name = document.createElement("span");
            name.className = "profileFriendName";
            const bpLevel = document.createElement("span");
            bpLevel.className = "profileFriendBpLevel";
            const statusLine = document.createElement("span");
            statusLine.className = "profileFriendActivity";
            const statusLabel = document.createElement("span");
            statusLabel.className = "profileFriendStatusLabel";
            const lastSeen = document.createElement("span");
            lastSeen.className = "profileFriendLastSeen";
            statusLine.appendChild(statusLabel);
            statusLine.appendChild(lastSeen);
            meta.appendChild(name);
            meta.appendChild(bpLevel);
            meta.appendChild(statusLine);
            info.appendChild(dot);
            info.appendChild(meta);

            const actions = document.createElement("div");
            actions.className = "profileFriendActions";
            actions.addEventListener("click", (e) => e.stopPropagation());
            const open = document.createElement("button");
            open.type = "button";
            open.className = "profileFriendIconBtn profileFriendChatBtn";
            open.title = "Chat";
            open.innerHTML = FRIEND_CHAT_ICON_SVG;
            open.onclick = (e) => {
                e.stopPropagation();
                const peerId = div.dataset.friendId || id;
                if (messagePeerSelect) messagePeerSelect.value = peerId;
                setActiveSidebarBtn(sideSocialBtn);
                setProfilePanel("messages");
                if (profileMessagesBlock) {
                    profileMessagesBlock.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
                requestAnimationFrame(() => {
                    void loadMessageThread();
                });
            };
            const remove = document.createElement("button");
            remove.type = "button";
            remove.className = "profileFriendIconBtn profileFriendIconBtn--danger profileFriendRemoveBtn";
            remove.title = "Remove friend";
            remove.innerHTML = FRIEND_TRASH_ICON_SVG;
            remove.onclick = (e) => {
                e.stopPropagation();
                const peerId = div.dataset.friendId || id;
                const label =
                    (div.querySelector(".profileFriendName") || {}).textContent || peerId;
                void removeFriend({ id: peerId, displayName: label });
            };
            actions.appendChild(open);
            actions.appendChild(remove);

            div.appendChild(info);
            div.appendChild(actions);
            div.addEventListener("click", () => {
                const peerId = div.dataset.friendId || id;
                void openFriendPublicProfile(peerId);
            });
            friendListWrap.appendChild(div);
        }

        const label = f.displayName || f.id;
        const online = !!f.online;
        const statusText = online ? (f.activity || "Online") : "Offline";
        const lastSeenText = online ? "" : formatFriendLastSeen(f.lastSeenAt);
        const lastSeenDisplay = lastSeenText ? ` · ${lastSeenText}` : "";
        const dot = div.querySelector(".profileFriendStatusDot");
        if (dot) {
            dot.classList.toggle("profileFriendStatusDot--online", online);
            dot.title = online
                ? "Online"
                : lastSeenText
                  ? `Offline · last seen ${lastSeenText}`
                  : "Offline";
        }
        const nameEl = div.querySelector(".profileFriendName");
        if (nameEl && nameEl.textContent !== label) nameEl.textContent = label;
        const bpEl = div.querySelector(".profileFriendBpLevel");
        if (bpEl) {
            const bp = f.battlePass;
            const bpText = bp ? `S${bp.seasonNumber} · Lv ${bp.level}` : "";
            if (bpEl.textContent !== bpText) bpEl.textContent = bpText;
            bpEl.classList.toggle("hidden", !bpText);
        }
        const activityEl = div.querySelector(".profileFriendActivity");
        if (activityEl) {
            activityEl.classList.toggle("profileFriendActivity--offline", !online);
            let statusLabel = activityEl.querySelector(".profileFriendStatusLabel");
            let lastSeenEl = activityEl.querySelector(".profileFriendLastSeen");
            if (!(statusLabel instanceof HTMLElement) || !(lastSeenEl instanceof HTMLElement)) {
                activityEl.textContent = "";
                statusLabel = document.createElement("span");
                statusLabel.className = "profileFriendStatusLabel";
                lastSeenEl = document.createElement("span");
                lastSeenEl.className = "profileFriendLastSeen";
                activityEl.appendChild(statusLabel);
                activityEl.appendChild(lastSeenEl);
            }
            if (statusLabel.textContent !== statusText) statusLabel.textContent = statusText;
            if (lastSeenEl.textContent !== lastSeenDisplay) lastSeenEl.textContent = lastSeenDisplay;
        }
        const chatBtn = div.querySelector(".profileFriendChatBtn");
        if (chatBtn) chatBtn.setAttribute("aria-label", `Chat with ${label}`);
        const removeBtn = div.querySelector(".profileFriendRemoveBtn");
        if (removeBtn) removeBtn.setAttribute("aria-label", `Remove ${label}`);
    });

    friendListWrap.querySelectorAll("[data-friend-id]").forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        if (!seen.has(el.dataset.friendId || "")) el.remove();
    });

    let empty = friendListWrap.querySelector(".profileFriendsEmpty");
    if (!friends.length) {
        if (!(empty instanceof HTMLElement)) {
            empty = document.createElement("p");
            empty.className = "accessHint profileFriendsEmpty";
            empty.textContent = "No friends yet.";
            friendListWrap.appendChild(empty);
        }
    } else if (empty) {
        empty.remove();
    }
}

function cssEscapeAttr(value) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") return CSS.escape(value);
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}

async function removeFriend(friend) {
    if (!friend || !friend.id) return;
    const label = friend.displayName || friend.id;
    if (!window.confirm(`Remove ${label} from your friends? They will not see you in their list until you add each other again.`)) {
        return;
    }
    try {
        const r = await fetch(apiPath("/api/friends"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "remove", friendUserId: friend.id }),
        });
        if (!r.ok) {
            if (friendActionStatus) friendActionStatus.textContent = "Could not remove friend.";
            return;
        }
        if (messagePeerSelect && messagePeerSelect.value === friend.id) {
            messagePeerSelect.value = "";
            if (messageThread) messageThread.innerHTML = "";
            lastMessageThreadPeer = "";
            lastMessageThreadIds = [];
            lastMessageThreadFingerprint = "";
        }
        if (friendActionStatus) friendActionStatus.textContent = `${label} removed.`;
        await refreshFriendsUi();
    } catch {
        if (friendActionStatus) friendActionStatus.textContent = "Network error.";
    }
}

function refreshMessagePeerOptions() {
    if (!messagePeerSelect) return;
    const cur = messagePeerSelect.value;
    messagePeerSelect.innerHTML = "";
    const z = document.createElement("option");
    z.value = "";
    z.textContent = "— Pick a friend —";
    messagePeerSelect.appendChild(z);
    profileFriendsList.forEach((f) => {
        const o = document.createElement("option");
        o.value = f.id;
        o.textContent = f.displayName || f.id;
        messagePeerSelect.appendChild(o);
    });
    if (cur && profileFriendsList.some((x) => x.id === cur)) messagePeerSelect.value = cur;
}

function messageIdsArePrefix(prefix, full) {
    if (full.length < prefix.length) return false;
    for (let i = 0; i < prefix.length; i++) {
        if (prefix[i] !== full[i]) return false;
    }
    return true;
}

function messageThreadFingerprint(msgs) {
    return msgs.map((m) => `${m.id}\0${m.body}\0${m.editedAt || ""}\0${m.mine ? 1 : 0}`).join("\n");
}

function appendMessageBubble(m) {
    const b = document.createElement("div");
    b.className = "messageBubble" + (m.mine ? " mine" : "");
    b.dataset.messageId = String(m.id);
    const text = document.createElement("div");
    text.className = "messageBubbleText";
    text.textContent = m.body;
    b.appendChild(text);
    const meta = document.createElement("div");
    meta.className = "messageBubbleMeta";
    if (m.editedAt) {
        const edited = document.createElement("span");
        edited.className = "messageEditedTag";
        edited.textContent = "edited";
        meta.appendChild(edited);
    }
    if (m.mine) {
        const acts = document.createElement("div");
        acts.className = "messageBubbleActs";
        const editBtn = document.createElement("button");
        editBtn.type = "button";
        editBtn.className = "messageBubbleAct";
        editBtn.textContent = "Edit";
        editBtn.onclick = () => beginEditMessageBubble(b, m);
        const delBtn = document.createElement("button");
        delBtn.type = "button";
        delBtn.className = "messageBubbleAct messageBubbleAct--danger";
        delBtn.textContent = "Delete";
        delBtn.onclick = () => void deleteOwnMessage(m.id);
        acts.appendChild(editBtn);
        acts.appendChild(delBtn);
        meta.appendChild(acts);
    }
    if (meta.childNodes.length) b.appendChild(meta);
    messageThread.appendChild(b);
}

function beginEditMessageBubble(bubble, m) {
    if (!bubble || !m) return;
    bubble.innerHTML = "";
    const row = document.createElement("div");
    row.className = "messageBubbleEditRow";
    const input = document.createElement("textarea");
    input.className = "messageBubbleEditInput";
    input.rows = 2;
    input.maxLength = 2000;
    input.value = m.body || "";
    const btns = document.createElement("div");
    btns.className = "messageBubbleEditBtns";
    const cancel = document.createElement("button");
    cancel.type = "button";
    cancel.className = "messageBubbleEditIconBtn messageBubbleEditIconBtn--cancel";
    cancel.title = "Cancel";
    cancel.setAttribute("aria-label", "Cancel edit");
    cancel.innerHTML = MESSAGE_EDIT_CANCEL_ICON_SVG;
    cancel.onclick = () => {
        lastMessageThreadFingerprint = "";
        void loadMessageThread();
    };
    const save = document.createElement("button");
    save.type = "button";
    save.className = "messageBubbleEditIconBtn messageBubbleEditIconBtn--save";
    save.title = "Save";
    save.setAttribute("aria-label", "Save edit");
    save.innerHTML = MESSAGE_EDIT_SAVE_ICON_SVG;
    save.onclick = async () => {
        const next = input.value.trim();
        if (!next) return;
        try {
            const r = await fetch(apiPath("/api/messages"), {
                method: "PATCH",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ messageId: m.id, body: next }),
            });
            if (!r.ok) {
                if (friendActionStatus) friendActionStatus.textContent = "Could not edit message.";
                return;
            }
            lastMessageThreadFingerprint = "";
            void loadMessageThread();
        } catch {
            if (friendActionStatus) friendActionStatus.textContent = "Network error.";
        }
    };
    btns.appendChild(cancel);
    btns.appendChild(save);
    row.appendChild(input);
    row.appendChild(btns);
    bubble.appendChild(row);
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
}

async function deleteOwnMessage(messageId) {
    if (!messageId) return;
    if (!window.confirm("Delete this message?")) return;
    try {
        const r = await fetch(apiPath(`/api/messages?id=${encodeURIComponent(messageId)}`), {
            method: "DELETE",
            credentials: "include",
        });
        if (!r.ok) {
            if (friendActionStatus) friendActionStatus.textContent = "Could not delete message.";
            return;
        }
        lastMessageThreadFingerprint = "";
        void loadMessageThread();
    } catch {
        if (friendActionStatus) friendActionStatus.textContent = "Network error.";
    }
}

async function loadMessageThread() {
    if (!messageThread || !messagePeerSelect) return;
    const withId = messagePeerSelect.value.trim();
    if (!withId) {
        messageThread.innerHTML = "";
        lastMessageThreadPeer = "";
        lastMessageThreadIds = [];
        lastMessageThreadFingerprint = "";
        return;
    }
    try {
        const r = await fetch(apiPath(`/api/messages?with=${encodeURIComponent(withId)}&limit=80`), {
            credentials: "include",
        });
        if (!r.ok) {
            messageThread.innerHTML = "";
            lastMessageThreadPeer = "";
            lastMessageThreadIds = [];
            lastMessageThreadFingerprint = "";
            const p = document.createElement("p");
            p.className = "accessHint";
            p.textContent = "Could not load messages.";
            messageThread.appendChild(p);
            return;
        }
        const data = await r.json();
        const msgs = data.messages || [];
        const ids = msgs.map((m) => String(m.id));
        const fp = messageThreadFingerprint(msgs);

        if (withId === lastMessageThreadPeer && fp === lastMessageThreadFingerprint) return;

        if (
            withId === lastMessageThreadPeer &&
            messageIdsArePrefix(lastMessageThreadIds, ids) &&
            ids.length > lastMessageThreadIds.length
        ) {
            const onlyAppend =
                lastMessageThreadFingerprint ===
                messageThreadFingerprint(msgs.slice(0, lastMessageThreadIds.length));
            if (onlyAppend) {
                for (let i = lastMessageThreadIds.length; i < msgs.length; i++) {
                    appendMessageBubble(msgs[i]);
                }
                lastMessageThreadIds = ids;
                lastMessageThreadFingerprint = fp;
                messageThread.scrollTop = messageThread.scrollHeight;
                return;
            }
        }

        messageThread.innerHTML = "";
        lastMessageThreadPeer = withId;
        lastMessageThreadIds = ids;
        lastMessageThreadFingerprint = fp;
        msgs.forEach((m) => appendMessageBubble(m));
        messageThread.scrollTop = messageThread.scrollHeight;
    } catch {
        messageThread.innerHTML = "";
        lastMessageThreadPeer = "";
        lastMessageThreadIds = [];
        lastMessageThreadFingerprint = "";
        const p = document.createElement("p");
        p.className = "accessHint";
        p.textContent = "Network error.";
        messageThread.appendChild(p);
    }
}

function getPresenceActivityLabel() {
    if (isLootDropActive()) return "Playing a Lootdrop";
    if (playing && !deathPending) {
        let modeId = gameMode;
        if (isMultiplayerActive()) {
            modeId = getMpGameMode() || gameMode;
        } else if (isLocalActive()) {
            modeId = getLocalConfig()?.mode || gameMode || "local";
        }
        if (modeId === "multiplayer" || modeId === "local") {
            // Fall through to nested mode if available; otherwise keep shell label.
            modeId = null;
        }
        if (modeId) {
            const label = PRESENCE_MODE_LABELS[modeId] || String(modeId);
            if (isMultiplayerActive()) return `Playing Multiplayer · ${label}`;
            if (isLocalActive()) return `Playing Local · ${label}`;
            return `Playing ${label}`;
        }
        if (isMultiplayerActive()) return "Playing Multiplayer";
        if (isLocalActive()) return "Playing Local";
        if (gameMode) {
            const label = PRESENCE_MODE_LABELS[gameMode] || String(gameMode);
            return `Playing ${label}`;
        }
    }
    if (shopScreen && !shopScreen.classList.contains("hidden")) return "In Shop";
    if (inventoryScreen && !inventoryScreen.classList.contains("hidden")) return "In Inventory";
    if (settingsScreen && !settingsScreen.classList.contains("hidden")) return "In Settings";
    if (profileScreen && !profileScreen.classList.contains("hidden")) {
        if (activeProfilePanel === "messages") return "In Messages";
        if (activeProfilePanel === "find-player") return "In Social · Search";
        if (activeProfilePanel === "friends") return "In Social · Friends";
        return "In Social";
    }
    if (wallScreen && !wallScreen.classList.contains("hidden")) return "In Wall";
    if (newsScreen && !newsScreen.classList.contains("hidden")) return "In News";
    if (notificationsScreen && !notificationsScreen.classList.contains("hidden")) return "In Notifications";
    if (leaderboardScreen && !leaderboardScreen.classList.contains("hidden")) return "In Rankings";
    if (achievementsScreen && !achievementsScreen.classList.contains("hidden")) return "In Achievements";
    if (tasksScreen && !tasksScreen.classList.contains("hidden")) return "In Tasks";
    if (battlePassScreen && !battlePassScreen.classList.contains("hidden")) return "In Battle Pass";
    if (sandboxScreen && !sandboxScreen.classList.contains("hidden")) return "In Sandbox";
    if (modeScreen && !modeScreen.classList.contains("hidden")) return "In Modes";
    if (creditsScreen && !creditsScreen.classList.contains("hidden")) return "In Credits";
    if (authScreen && !authScreen.classList.contains("hidden")) return "In Account";
    if (statsScreen && !statsScreen.classList.contains("hidden")) return "In Stats";
    return "Online";
}

async function pushPresenceHeartbeat(force = false) {
    if (!cloudUser || cloudTimedOut) return;
    const activity = getPresenceActivityLabel();
    const now = Date.now();
    if (
        !force &&
        activity === lastPresenceActivitySent &&
        now - lastPresenceSentAt < PRESENCE_KEEPALIVE_MS
    ) {
        return;
    }
    try {
        const r = await fetch(apiPath("/api/presence"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ activity }),
        });
        if (r.ok) {
            lastPresenceActivitySent = activity;
            lastPresenceSentAt = now;
        }
    } catch {
        /* optional */
    }
}

function startPresenceHeartbeat() {
    stopPresenceHeartbeat();
    if (!cloudUser || cloudTimedOut) return;
    void pushPresenceHeartbeat(true);
    presenceHeartbeatTimer = createVisibilityInterval(() => {
        void pushPresenceHeartbeat(false);
    }, PRESENCE_KEEPALIVE_MS);
}

function stopPresenceHeartbeat() {
    if (presenceHeartbeatTimer) {
        presenceHeartbeatTimer.stop();
        presenceHeartbeatTimer = null;
    }
    lastPresenceActivitySent = "";
    lastPresenceSentAt = 0;
}

async function saveProfileBio() {
    if (!cloudUser || !profileBioInput) return;
    try {
        const r = await fetch(apiPath("/api/profile"), {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ profileBio: profileBioInput.value }),
        });
        const d = await r.json().catch(() => ({}));
        if (friendActionStatus) {
            friendActionStatus.textContent = r.ok && d.user ? "Bio saved." : "Could not save bio.";
        }
        if (r.ok && d.user) cloudUser = { ...cloudUser, profileBio: d.user.profileBio };
    } catch {
        if (friendActionStatus) friendActionStatus.textContent = "Network error.";
    }
}

function appendDotsTransferUi(parent, toUserId, displayName) {
    if (!parent || !toUserId || !cloudUser || cloudUser.id === toUserId) return;
    const wrap = document.createElement("div");
    wrap.className = "profileDotsTransfer modeBox";
    const heading = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = "Transfer Dots";
    heading.appendChild(strong);
    wrap.appendChild(heading);
    const hint = document.createElement("p");
    hint.className = "accessHint";
    hint.textContent = `Send Dots to ${displayName || toUserId}. Your balance: ${getDotsBalance().toLocaleString()}.`;
    wrap.appendChild(hint);
    const row = document.createElement("div");
    row.className = "formRow profileDotsTransferRow";
    const amountInput = document.createElement("input");
    amountInput.type = "number";
    amountInput.min = "1";
    amountInput.step = "1";
    amountInput.className = "formInput";
    amountInput.placeholder = "Amount";
    amountInput.setAttribute("aria-label", "Dots amount to send");
    const sendBtn = document.createElement("button");
    sendBtn.type = "button";
    sendBtn.className = "btn green";
    sendBtn.textContent = "Send";
    row.appendChild(amountInput);
    row.appendChild(sendBtn);
    wrap.appendChild(row);
    const status = document.createElement("p");
    status.className = "accessHint";
    wrap.appendChild(status);

    sendBtn.onclick = async () => {
        const amount = Math.floor(Number(amountInput.value) || 0);
        if (amount < 1) {
            status.textContent = "Enter a positive amount.";
            return;
        }
        if (amount > getDotsBalance()) {
            status.textContent = "Not enough Dots.";
            return;
        }
        sendBtn.disabled = true;
        status.textContent = "Sending…";
        try {
            const res = await postDotsTransfer({ toUserId, amount });
            if (res.dots) applyDotsFromApi(res.dots);
            hint.textContent = `Send Dots to ${displayName || toUserId}. Your balance: ${getDotsBalance().toLocaleString()}.`;
            amountInput.value = "";
            status.textContent = `Sent ${amount.toLocaleString()} Dots to ${res.toDisplayName || displayName || toUserId}.`;
        } catch (e) {
            const code = e instanceof Error ? e.message : "transfer_failed";
            if (e && typeof e === "object" && e.dots) applyDotsFromApi(e.dots);
            hint.textContent = `Send Dots to ${displayName || toUserId}. Your balance: ${getDotsBalance().toLocaleString()}.`;
            if (code === "insufficient_dots") status.textContent = "Not enough Dots.";
            else if (code === "user_not_found") status.textContent = "User not found.";
            else if (code === "cannot_transfer_to_self") status.textContent = "You cannot send Dots to yourself.";
            else if (code === "invalid_amount") status.textContent = "Invalid amount.";
            else status.textContent = "Transfer failed.";
        } finally {
            sendBtn.disabled = false;
        }
    };

    parent.appendChild(wrap);
}

async function resolvePublicCosmeticDisplay(item, profileCursorColor) {
    try {
        const layer = await resolveCosmeticVisual(item, {
            cursorHex: profileCursorColor || "#ffffff",
            customTint: item.activeCustomColor || null,
        });
        return { imageData: layer.imageData, animationFrames: layer.animationFrames };
    } catch {
        const frames =
            Array.isArray(item.animationFrames) && item.animationFrames.length
                ? item.animationFrames.filter((f) => typeof f === "string" && f.length > 0).slice(0, 10)
                : null;
        return { imageData: item.imageData, animationFrames: frames };
    }
}

/** Draw order matches equip order: later equipped cosmetics stack on top. */
function orderedPublicEquippedCosmetics(cosmetics, equippedIds) {
    const list = Array.isArray(cosmetics) ? cosmetics : [];
    const byId = new Map(list.map((c) => [c.id, c]));
    const ids = Array.isArray(equippedIds) ? equippedIds : [];
    const ordered = [];
    const seen = new Set();
    for (const id of ids) {
        const item = byId.get(id);
        if (!item || seen.has(id)) continue;
        seen.add(id);
        ordered.push(item);
    }
    // Fallback if API omitted equippedCosmeticIds
    if (!ordered.length) {
        for (const item of list) {
            if (item?.equipped && item.id && !seen.has(item.id)) {
                seen.add(item.id);
                ordered.push(item);
            }
        }
    }
    return ordered;
}

async function paintPublicPlayerCursor(canvas, cursorColor, cosmetics, equippedIds) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    stopCosmeticPreviewLoop(canvas);

    const equipped = orderedPublicEquippedCosmetics(cosmetics, equippedIds);
    const layers = [];
    for (const item of equipped) {
        const layer = await resolvePublicCosmeticDisplay(item, cursorColor);
        if (!canvas.isConnected) return;
        await loadCosmeticImage(layer.imageData);
        if (layer.animationFrames?.length) {
            await Promise.all(layer.animationFrames.map((f) => loadCosmeticImage(f)));
        }
        if (!canvas.isConnected) return;
        layers.push(layer);
    }

    const drawFrame = () => {
        if (!canvas.isConnected) return;
        const w = canvas.width;
        const h = canvas.height;
        ctx.clearRect(0, 0, w, h);
        const cx = w * 0.5;
        const cy = h * 0.5;
        const fill = Math.min(w, h) * 0.78;
        const r = fill / (COSMETIC_ART_SIZE / COSMETIC_REF_CURSOR_R);
        ctx.save();
        ctx.fillStyle = cursorColor || "#ffffff";
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        for (const layer of layers) {
            drawCosmeticOverlay(ctx, cx, cy, r, getCachedCosmeticImage(layer.imageData));
            if (layer.animationFrames?.length) {
                const fi = Math.floor(performance.now() / ANIM_FRAME_MS) % layer.animationFrames.length;
                drawCosmeticOverlay(
                    ctx,
                    cx,
                    cy,
                    r,
                    getCachedCosmeticImage(layer.animationFrames[fi]),
                );
            }
        }
    };

    drawFrame();
    if (layers.some((l) => l.animationFrames?.length)) {
        startCosmeticPreviewLoop(canvas, drawFrame, () => canvas.isConnected);
    }
}

function renderFindPlayerResults(users) {
    if (!profilePublicCard) return;
    profilePublicCard.replaceChildren();
    if (!users.length) {
        const p = document.createElement("p");
        p.className = "accessHint";
        p.textContent = "No players found.";
        profilePublicCard.appendChild(p);
        profilePublicCard.classList.remove("hidden");
        return;
    }
    const intro = document.createElement("p");
    intro.className = "accessHint";
    intro.textContent =
        users.length === 1 ? "1 player — tap to open profile." : `${users.length} players — tap one to open their profile.`;
    profilePublicCard.appendChild(intro);
    const list = document.createElement("div");
    list.className = "profilePlayerSearchList";
    for (const u of users) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "btn profilePlayerSearchBtn";
        btn.textContent = u.displayName || u.id;
        btn.title = u.id;
        btn.onclick = () => void openPublicPlayerProfile(u.id);
        list.appendChild(btn);
    }
    profilePublicCard.appendChild(list);
    profilePublicCard.classList.remove("hidden");
}

async function renderPublicPlayerProfile(data, presets, resolvedUserId) {
    if (!profilePublicCard) return;
    const selfId = cloudUser?.id || null;
    const replayMap = await fetchUserReplayMap(resolvedUserId).catch(() => ({}));
    await renderProfileShowcase(profilePublicCard, data, presets, resolvedUserId, {
        resolveCosmeticDisplay: resolvePublicCosmeticDisplay,
        viewerUserId: selfId,
        isSignedIn: () => !!cloudUser,
        formatTime,
        replayAvailableByMode: replayMap,
        onViewReplay: (modeId) => {
            void openReplayViewer(resolvedUserId, modeId, {
                returnCtx: { type: "profile", userId: resolvedUserId },
            });
        },
        onBack: () => {
            if (publicProfileReturnToFriends) {
                publicProfileReturnToFriends = false;
                setProfilePanel("friends");
                return;
            }
            const q = profileLookupId?.value.trim() || "";
            if (q) void lookupPublicProfile();
            else {
                profilePublicCard.replaceChildren();
                profilePublicCard.classList.add("hidden");
            }
        },
        onRefresh: () => void openPublicPlayerProfile(resolvedUserId),
        onOpenChat: (peerId) => {
            if (messagePeerSelect) messagePeerSelect.value = peerId;
            setActiveSidebarBtn(sideSocialBtn);
            setProfilePanel("messages");
            if (profileMessagesBlock) {
                profileMessagesBlock.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            requestAnimationFrame(() => {
                void loadMessageThread();
            });
        },
        onFriendRequest: async (userId) => {
            const r = await fetch(apiPath("/api/friends"), {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ action: "request", userId }),
            });
            const d = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(d.error || "request_failed");
            await refreshFriendsUi();
            void openPublicPlayerProfile(resolvedUserId);
        },
        onUnfriend: async (userId, displayName) => {
            await removeFriend({ id: userId, displayName });
            void openPublicPlayerProfile(resolvedUserId);
        },
        onUseSandboxPreset: (p) => {
            sandboxConfig = normalizeSandboxConfig(p.config);
            saveSandboxDraft();
            refreshSandboxUI();
            closeProfileScreen();
            openSandboxScreen();
        },
        onEditPhoto: () => {
            openProfilePhotoEditor({
                cosmetics: Array.isArray(data.cosmetics) ? data.cosmetics : [],
                cursorColor: data.cursorColor || "#ffffff",
                initial: data.profilePhoto || null,
                resolveCosmeticDisplay: resolvePublicCosmeticDisplay,
                onSaved: () => void openPublicPlayerProfile(resolvedUserId),
            });
        },
    });
}

async function openFriendPublicProfile(userId) {
    if (!userId) return;
    publicProfileReturnToFriends = true;
    setActiveSidebarBtn(sideSocialBtn);
    setProfilePanel("find-player");
    await openPublicPlayerProfile(userId);
    if (profilePublicCard) {
        profilePublicCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
}

async function openPublicPlayerProfile(userId) {
    if (!profilePublicCard || !userId) return;
    profilePublicCard.classList.remove("hidden");
    profilePublicCard.replaceChildren();
    const loading = document.createElement("p");
    loading.className = "accessHint";
    loading.textContent = "Loading profile…";
    profilePublicCard.appendChild(loading);
    try {
        const [pr, presetsRes] = await Promise.all([
            fetch(apiPath(`/api/profile?userId=${encodeURIComponent(userId)}`), {
                credentials: "include",
                headers: { Accept: "application/json" },
            }),
            fetch(apiPath(`/api/sandbox-presets?userId=${encodeURIComponent(userId)}`), {
                credentials: "include",
                headers: { Accept: "application/json" },
            }),
        ]);
        if (!pr.ok) {
            profilePublicCard.replaceChildren();
            const p = document.createElement("p");
            p.className = "accessHint";
            p.textContent = "User not found.";
            profilePublicCard.appendChild(p);
            return;
        }
        const data = await pr.json();
        let presets = [];
        if (presetsRes.ok) {
            const pd = await presetsRes.json();
            presets = pd.presets || [];
        }
        const uid = data.user?.id || userId;
        await renderPublicPlayerProfile(data, presets, uid);
    } catch {
        profilePublicCard.replaceChildren();
        const p = document.createElement("p");
        p.className = "accessHint";
        p.textContent = "Error loading profile.";
        profilePublicCard.appendChild(p);
    }
}

async function lookupPublicProfile() {
    if (!profileLookupId || !profilePublicCard) return;
    const q = profileLookupId.value.trim();
    profilePublicCard.classList.add("hidden");
    profilePublicCard.replaceChildren();
    if (!q.length) return;
    if (q.length < 2) {
        profilePublicCard.classList.remove("hidden");
        const p = document.createElement("p");
        p.className = "accessHint";
        p.textContent = "Type at least 2 characters.";
        profilePublicCard.appendChild(p);
        return;
    }
    profilePublicCard.classList.remove("hidden");
    const loading = document.createElement("p");
    loading.className = "accessHint";
    loading.textContent = "Searching…";
    profilePublicCard.appendChild(loading);
    try {
        const r = await fetch(apiPath(`/api/profile?search=${encodeURIComponent(q)}`), {
            credentials: "include",
            headers: { Accept: "application/json" },
        });
        if (!r.ok) {
            profilePublicCard.replaceChildren();
            const p = document.createElement("p");
            p.className = "accessHint";
            p.textContent = "Search failed.";
            profilePublicCard.appendChild(p);
            return;
        }
        const data = await r.json();
        renderFindPlayerResults(data.users || []);
    } catch {
        profilePublicCard.replaceChildren();
        const p = document.createElement("p");
        p.className = "accessHint";
        p.textContent = "Error searching players.";
        profilePublicCard.appendChild(p);
    }
}

function detachStatsSelect(select) {
    if (!select) return;
    const host = (select.closest(".gameSelect") as HTMLElement | null) ?? select;
    if (host.parentNode) host.parentNode.removeChild(host);
}

function detachStatsSpeedrunControls() {
    detachStatsSelect(statsSpeedrunLevelSelect);
    if (statsSpeedrunBestLine && statsSpeedrunBestLine.parentNode) {
        statsSpeedrunBestLine.parentNode.removeChild(statsSpeedrunBestLine);
    }
    if (statsSpeedrunTopLine && statsSpeedrunTopLine.parentNode) {
        statsSpeedrunTopLine.parentNode.removeChild(statsSpeedrunTopLine);
    }
}

function detachStatsPenaltyControls() {
    detachStatsSelect(statsPenaltyLevelSelect);
    if (statsPenaltyBestLine && statsPenaltyBestLine.parentNode) {
        statsPenaltyBestLine.parentNode.removeChild(statsPenaltyBestLine);
    }
    if (statsPenaltyTopLine && statsPenaltyTopLine.parentNode) {
        statsPenaltyTopLine.parentNode.removeChild(statsPenaltyTopLine);
    }
}

function appendStatsSpeedrunCard(parent) {
    if (!statsSpeedrunLevelSelect || !statsSpeedrunBestLine || !statsSpeedrunTopLine || !parent) return;
    const card = document.createElement("div");
    card.className = "statsCard statsCard--speedrun";
    const modeEl = document.createElement("div");
    modeEl.className = "statsCardMode";
    modeEl.textContent = "SPEEDRUN";
    card.appendChild(modeEl);
    statsSpeedrunBestLine.className = "statsCardRecord";
    statsSpeedrunBestLine.removeAttribute("aria-hidden");
    card.appendChild(statsSpeedrunBestLine);
    const ddWrap = document.createElement("div");
    ddWrap.className = "statsSpeedrunDropdownWrap";
    statsSpeedrunLevelSelect.className = "formInput statsSpeedrunLevelSelect hidden";
    appendGameSelectHost(ddWrap, statsSpeedrunLevelSelect);
    card.appendChild(ddWrap);
    statsSpeedrunTopLine.className = "statsCardTop statsSpeedrunTopLine";
    statsSpeedrunTopLine.classList.remove("hidden");
    card.appendChild(statsSpeedrunTopLine);
    parent.appendChild(card);
}

function appendStatsPenaltyCard(parent) {
    if (!statsPenaltyLevelSelect || !statsPenaltyBestLine || !statsPenaltyTopLine || !parent) return;
    const card = document.createElement("div");
    card.className = "statsCard statsCard--speedrun";
    const modeEl = document.createElement("div");
    modeEl.className = "statsCardMode";
    modeEl.textContent = "PENALTY";
    card.appendChild(modeEl);
    statsPenaltyBestLine.className = "statsCardRecord";
    statsPenaltyBestLine.removeAttribute("aria-hidden");
    card.appendChild(statsPenaltyBestLine);
    const ddWrap = document.createElement("div");
    ddWrap.className = "statsSpeedrunDropdownWrap";
    statsPenaltyLevelSelect.className = "formInput statsPenaltyLevelSelect hidden";
    appendGameSelectHost(ddWrap, statsPenaltyLevelSelect);
    card.appendChild(ddWrap);
    statsPenaltyTopLine.className = "statsCardTop statsSpeedrunTopLine";
    statsPenaltyTopLine.classList.remove("hidden");
    card.appendChild(statsPenaltyTopLine);
    parent.appendChild(card);
}

const STATS_SR_TIME_FONT_MIN = 9;
const STATS_SR_TOP_FONT_MIN = 7;

function scheduleFitStatsSpeedrunCardText() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => fitStatsSpeedrunCardText());
    });
}

function shrinkStatsLineToFit(el, maxPx, minPx) {
    if (!el || maxPx <= minPx) return;
    let px = maxPx;
    el.style.fontSize = `${px}px`;
    void el.offsetHeight;
    while (px > minPx && el.scrollWidth > el.clientWidth + 0.5) {
        px -= 0.5;
        el.style.fontSize = `${px}px`;
    }
}

function fitStatsSpeedrunCardText() {
    if (!statsSpeedrunBestLine || !statsSpeedrunTopLine) return;
    if (!statsSpeedrunBestLine.isConnected || !statsSpeedrunTopLine.isConnected) return;

    statsSpeedrunBestLine.style.fontSize = "";
    statsSpeedrunTopLine.style.fontSize = "";

    const maxTime =
        parseFloat(getComputedStyle(statsSpeedrunBestLine).fontSize) || 22;
    const maxTop =
        parseFloat(getComputedStyle(statsSpeedrunTopLine).fontSize) || 11;

    shrinkStatsLineToFit(statsSpeedrunBestLine, maxTime, STATS_SR_TIME_FONT_MIN);
    shrinkStatsLineToFit(statsSpeedrunTopLine, maxTop, STATS_SR_TOP_FONT_MIN);
}

let statsSpeedrunFitResizeHooked = false;
function ensureStatsSpeedrunFitOnResize() {
    if (statsSpeedrunFitResizeHooked) return;
    statsSpeedrunFitResizeHooked = true;
    addEventListener(
        "resize",
        () => {
            if (statsScreen && !statsScreen.classList.contains("hidden")) {
                scheduleFitStatsSpeedrunCardText();
            }
        },
        { passive: true }
    );
}

function refreshStatsSpeedrunLine() {
    if (!statsSpeedrunLevelSelect || !statsSpeedrunBestLine) return;
    const lvl = clamp(Math.round(Number(statsSpeedrunLevelSelect.value) || 1), 1, Math.max(1, getSpeedrunLevelCount()));
    const ms = displayedSpeedrunBestMs(lvl);
    statsSpeedrunBestLine.textContent = ms > 0 ? formatSpeedrunTime(ms) : "—";
    void refreshStatsSpeedrunTopLine().finally(() => {
        scheduleFitStatsSpeedrunCardText();
    });
}

async function refreshStatsSpeedrunTopLine() {
    if (!statsSpeedrunTopLine) return;
    if (!cloudUser) {
        statsSpeedrunTopLine.textContent = "TOP: —";
        return;
    }
    const lvl = clamp(
        Math.round(Number(statsSpeedrunLevelSelect?.value) || 1),
        1,
        Math.max(1, getSpeedrunLevelCount())
    );
    try {
        const { myRank } = await fetchMyLeaderboardRank("speedrun", { level: lvl });
        statsSpeedrunTopLine.textContent = myRank != null ? `TOP: ${myRank}` : "TOP: —";
    } catch {
        statsSpeedrunTopLine.textContent = "TOP: —";
    }
}

function refreshStatsPenaltyLine() {
    if (!statsPenaltyLevelSelect || !statsPenaltyBestLine) return;
    const lvl = clamp(
        Math.round(Number(statsPenaltyLevelSelect.value) || 1),
        1,
        Math.max(1, getPenaltyLevelCount()),
    );
    const hits = displayedPenaltyBestHits(lvl);
    statsPenaltyBestLine.textContent = hits > 0 ? formatPenaltyHits(hits) : "—";
    void refreshStatsPenaltyTopLine();
}

async function refreshStatsPenaltyTopLine() {
    if (!statsPenaltyTopLine) return;
    if (!cloudUser) {
        statsPenaltyTopLine.textContent = "TOP: —";
        return;
    }
    const lvl = clamp(
        Math.round(Number(statsPenaltyLevelSelect?.value) || 1),
        1,
        Math.max(1, getPenaltyLevelCount()),
    );
    try {
        const { myRank } = await fetchMyLeaderboardRank("penalty", { level: lvl });
        statsPenaltyTopLine.textContent = myRank != null ? `TOP: ${myRank}` : "TOP: —";
    } catch {
        statsPenaltyTopLine.textContent = "TOP: —";
    }
}

const STATS_GRID_CARDS = [
    { key: "progression", title: "Progression", getValue: () => bestProg },
    { key: "normal", title: "Normal", getValue: () => bestNormal },
    { key: "wasd", title: "WASD", getValue: () => bestWASD },
    { key: "superdot", title: "Superdot", getValue: () => bestSuper },
    { key: "roulette", title: "Roulette", getValue: () => bestRoulette },
    { key: "sandbox", title: "Sandbox", getValue: () => bestSandbox },
    { key: "highway", title: "Highway", getValue: () => bestHighway },
    { key: "darkness", title: "Darkness", getValue: () => bestDarkness },
    { key: "mirror", title: "Mirror", getValue: () => bestMirror },
    { key: "delay", title: "Delay", getValue: () => bestDelay },
    { key: "snake", title: "Snake", getValue: () => bestSnake },
    { key: "combo", title: "Combo", getValue: () => bestCombo },
    { key: "overload", title: "Overload", getValue: () => bestOverload },
    { key: "colorrush", title: "Color Rush", getValue: () => bestColorRush },
    { key: "heat", title: "Heat", getValue: () => bestHeat },
    { key: "hunter", title: "Hunter", getValue: () => bestHunter },
    { key: "pop", title: "POP", getValue: () => bestPop },
    { key: "counter", title: "Counter", getValue: () => bestCounter },
    { key: "aim", title: "AIM", getValue: () => bestAim },
    { key: "hook", title: "Hook", getValue: () => bestHook },
    { key: "tilt", title: "Tilt", getValue: () => bestTilt },
    { key: "orbit", title: "Orbit", getValue: () => bestOrbit }
];

/** One GET /api/my-bests (cached briefly) instead of 22× GET /api/leaderboard?myRank=1. */
async function fetchStatsRankMap() {
    const bests = await fetchMyBests();
    const out = {};
    for (const { key } of STATS_GRID_CARDS) {
        const b = bests[key];
        out[key] = { rank: b ? b.rank : null, value: b ? b.value : null };
    }
    return out;
}

function formatStatsRecordValue(modeKey, value) {
    const n = Math.floor(Number(value) || 0);
    if (n <= 0) return "0";
    return String(n);
}

function refreshStatsPlaytimeOnly() {
    if (statsPlaytimeRecordEl) statsPlaytimeRecordEl.textContent = formatTime(playTime);
}

async function updateStats() {
    if (!statsGrid) return;
    detachStatsSpeedrunControls();
    detachStatsPenaltyControls();
    if (cloudUser && isAccountSyncReady()) {
        await syncLocalStatsFromLeaderboard().catch(() => {});
        reloadAccountGlobalsFromStorage();
    }
    const rankMap = cloudUser ? await fetchStatsRankMap().catch(() => ({})) : {};
    if (cloudUser) {
        hudStatsBestCache = rankMap;
        hudStatsBestCacheUserId = cloudUser.id;
    } else {
        hudStatsBestCache = {};
        hudStatsBestCacheUserId = null;
    }

    statsGrid.replaceChildren();
    statsPlaytimeRecordEl = null;

    const ownReplayMap =
        cloudUser ? await fetchUserReplayMap(cloudUser.id).catch(() => ({})) : {};

    for (const def of STATS_GRID_CARDS) {
        const entry = rankMap[def.key];
        const cloudVal = entry && typeof entry === "object" ? entry.value : null;
        const val =
            cloudUser && cloudVal != null
                ? Math.floor(Number(cloudVal) || 0)
                : def.getValue();
        const card = document.createElement("div");
        card.className = "statsCard";

        const modeEl = document.createElement("div");
        modeEl.className = "statsCardMode";
        modeEl.textContent = def.title;
        card.appendChild(modeEl);

        const recEl = document.createElement("div");
        recEl.className = "statsCardRecord";
        recEl.textContent = formatStatsRecordValue(def.key, val);
        card.appendChild(recEl);

        const topEl = document.createElement("div");
        topEl.className = "statsCardTop";
        const r = entry && typeof entry === "object" ? entry.rank : entry;
        topEl.textContent = cloudUser && r != null ? `TOP: ${r}` : "TOP: —";
        card.appendChild(topEl);

        const replayMeta = ownReplayMap[def.key];
        if (cloudUser && replayMeta && (replayMeta.available === true || replayMeta.available === undefined && replayMeta.gameVersion)) {
            card.appendChild(
                createViewReplayLink(() => {
                    void openReplayViewer(cloudUser.id, def.key, { returnCtx: "stats" });
                }),
            );
        }

        statsGrid.appendChild(card);
        if (def.key === "sandbox") {
            appendStatsSpeedrunCard(statsGrid);
            appendStatsPenaltyCard(statsGrid);
        }
    }

    const playCard = document.createElement("div");
    playCard.className = "statsCard statsCard--wide";
    const pm = document.createElement("div");
    pm.className = "statsCardMode";
    pm.textContent = "Play time";
    playCard.appendChild(pm);
    const pr = document.createElement("div");
    pr.className = "statsCardRecord";
    pr.textContent = formatTime(playTime);
    statsPlaytimeRecordEl = pr;
    playCard.appendChild(pr);
    statsGrid.appendChild(playCard);

    const deathsCard = document.createElement("div");
    deathsCard.className = "statsCard statsCard--wide";
    const dm = document.createElement("div");
    dm.className = "statsCardMode";
    dm.textContent = "Deaths";
    deathsCard.appendChild(dm);
    const dr = document.createElement("div");
    dr.className = "statsCardRecord";
    dr.textContent = String(Math.floor(Number(deathCount) || 0));
    deathsCard.appendChild(dr);
    statsGrid.appendChild(deathsCard);

    const favCard = document.createElement("div");
    favCard.className = "statsCard statsCard--wide";
    const fm = document.createElement("div");
    fm.className = "statsCardMode";
    fm.textContent = "Favorite Mode";
    favCard.appendChild(fm);
    const fr = document.createElement("div");
    fr.className = "statsCardRecord";
    fr.textContent = getFavoriteModeTitle();
    favCard.appendChild(fr);
    statsGrid.appendChild(favCard);

    refreshStatsSpeedrunLine();
    refreshStatsPenaltyLine();
}

function pad2(n) {
    return String(n).padStart(2, "0");
}

function formatTime(seconds) {
    let sec = Math.floor(Number(seconds) || 0);
    const d = Math.floor(sec / 86400);
    sec %= 86400;
    const h = Math.floor(sec / 3600);
    sec %= 3600;
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${pad2(d)}D / ${pad2(h)}H / ${pad2(m)}M / ${pad2(s)}S`;
}

function openGameHub() {
    if (cloudTimedOut) return;
    hideAllMpScreens();
    hideLocalScreens();
    hideSoccerScreens();
    hideEl(localResultScreen);
    claimExclusiveUi("gameHubScreen");
    hideEl(startScreen);
    hideHubScreens();
    clearModeSelection();
    showEl(gameHubScreen);
    showEl(returnBtn);
    setGameHubTab("play");
    refreshHubLocalCardVisibility();
    void refreshHubCategoryVisibility();
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    syncActiveSidebarFromVisibleScreen();
    requestAnimationFrame(() => {
        fitGameHubCardTitles();
        refreshCustomScrollbars();
    });
}

function openModes() {
    if (cloudTimedOut) return;
    hideAllMpScreens();
    hideLocalScreens();
    hideEl(localResultScreen);
    claimExclusiveUi("modeScreen");
    hideEl(startScreen);
    hideHubScreens();
    clearModeSelection();
    refreshModesScreen();
    showEl(modeScreen);
    showEl(returnBtn);
    setSuperHudVisible(false);
    setTopHudMode(null);
    updateMusicState();
    syncActiveSidebarFromVisibleScreen();
    void (async () => {
        if (cloudUser && isAccountSyncReady()) {
            await syncLocalStatsFromLeaderboard().catch(() => {});
            reloadAccountGlobalsFromStorage();
        }
        refreshModesScreen();
    })();
}

let splashNavHighlightTimer = null;
function flashSplashNavHighlight(node) {
    if (!node) return;
    document.querySelectorAll(".splashNavHighlight").forEach((el) => {
        el.classList.remove("splashNavHighlight");
    });
    // Restart CSS fade if the same node is targeted again.
    void node.offsetWidth;
    node.classList.add("splashNavHighlight");
    if (splashNavHighlightTimer) clearTimeout(splashNavHighlightTimer);
    splashNavHighlightTimer = setTimeout(() => {
        node.classList.remove("splashNavHighlight");
        splashNavHighlightTimer = null;
    }, 1000);
}

function openSettingsFromSplashLink() {
    if (sideSettingsBtn) setActiveSidebarBtn(sideSettingsBtn);
    refreshDpadSettingsVisibility();
    hideEl(startScreen);
    hideHubScreens();
    showSettingsScreen();
    setSuperHudVisible(false);
    setTopHudMode(null);
    applySettings();
}

function highlightSplashSelector(selector) {
    if (!selector) return;
    const node = document.querySelector(selector);
    if (node instanceof HTMLElement) flashSplashNavHighlight(node);
}

function navigateFromSplashLink(target) {
    const t = String(target || "").trim().toLowerCase();
    if (!t) return;
    if (t.startsWith("mode.")) {
        const modeId = t.slice(5);
        openModes();
        const searchInput = document.getElementById("modesSearchInput");
        if (searchInput instanceof HTMLInputElement && searchInput.value) {
            searchInput.value = "";
            searchInput.dispatchEvent(new Event("input", { bubbles: true }));
        }
        refreshModesScreen();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const sel =
                    typeof CSS !== "undefined" && typeof CSS.escape === "function"
                        ? `#modesContainer .modeBox[data-mode-id="${CSS.escape(modeId)}"]`
                        : `#modesContainer .modeBox[data-mode-id="${modeId.replace(/"/g, "")}"]`;
                const box = document.querySelector(sel);
                if (!(box instanceof HTMLElement)) return;
                box.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                flashSplashNavHighlight(box);
            });
        });
        return;
    }
    if (t.startsWith("settings.")) {
        const meta = getSplashSettingsTarget(t);
        openSettingsFromSplashLink();
        const accordionId = meta?.accordionId || "settingsAccessibilityAccordion";
        const accordion = document.getElementById(accordionId);
        void ensureSettingsAccordionOpen(accordion).then(() => {
            requestAnimationFrame(() => {
                const esc =
                    typeof CSS !== "undefined" && typeof CSS.escape === "function" ? CSS.escape(t) : t.replace(/"/g, "");
                const card = document.querySelector(`#settingsScreen [data-splash-target="${esc}"]`);
                const container = document.getElementById("settingsContainer");
                if (!(card instanceof HTMLElement) || !container) return;
                const cRect = container.getBoundingClientRect();
                const tRect = card.getBoundingClientRect();
                const top = tRect.top - cRect.top + container.scrollTop - 12;
                const reduceMotion =
                    typeof window.matchMedia === "function" &&
                    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                container.scrollTo({
                    top: Math.max(0, top),
                    behavior: reduceMotion ? "auto" : "smooth",
                });
                setActiveSettingsNavButton(accordionId);
                flashSplashNavHighlight(card);
            });
        });
        return;
    }

    const screenMeta = getSplashScreenTarget(t);
    if (!screenMeta) return;

    const afterOpen = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                highlightSplashSelector(screenMeta.highlightSelector);
            });
        });
    };

    // Hub.* opens Play hub and highlights the category card / tab.
    if (t.startsWith("hub.")) {
        openGameHub();
        const hubTabByTarget = {
            "hub.challenges": "quests",
            "hub.campaign": "quests",
            "hub.worldmap": "quests",
            "hub.tournaments": "compete",
            "hub.marathon": "compete",
            "hub.tab.quests": "quests",
            "hub.tab.compete": "compete",
            "hub.tab.play": "play",
        };
        setGameHubTab(hubTabByTarget[t] || "play");
        afterOpen();
        return;
    }

    switch (t) {
        case "screen.home":
            sideHomeBtn?.click();
            afterOpen();
            break;
        case "screen.play":
            openGameHub();
            afterOpen();
            break;
        case "screen.settings":
            openSettingsFromSplashLink();
            afterOpen();
            break;
        case "screen.rankings":
            sideRankingsBtn?.click();
            afterOpen();
            break;
        case "screen.stats":
            sideStatsBtn?.click();
            afterOpen();
            break;
        case "screen.achievements":
            sideAchievementsBtn?.click();
            afterOpen();
            break;
        case "screen.shop":
            sideShopBtn?.click();
            afterOpen();
            break;
        case "screen.inventory":
            sideInventoryBtn?.click();
            afterOpen();
            break;
        case "screen.social":
            sideSocialBtn?.click();
            afterOpen();
            break;
        case "screen.news":
            sideNewsBtn?.click();
            afterOpen();
            break;
        case "screen.notifications":
            sideNotificationsBtn?.click();
            afterOpen();
            break;
        case "screen.wall":
            sideWallBtn?.click();
            afterOpen();
            break;
        case "screen.credits":
            sideCreditsBtn?.click();
            afterOpen();
            break;
        case "screen.modes":
            openModes();
            afterOpen();
            break;
        case "screen.practice":
            openPractice();
            afterOpen();
            break;
        case "screen.sandbox":
            openSandboxHub();
            afterOpen();
            break;
        case "screen.multiplayer":
            void openMpEntry().then(() => afterOpen());
            break;
        case "screen.local":
            openLocalSetup();
            afterOpen();
            break;
        case "screen.lootdrops":
            void openLootDropEntry().then(() => afterOpen());
            break;
        case "screen.challenges":
            void Promise.resolve(openChallengesFlow()).then(() => afterOpen());
            break;
        case "screen.campaign":
            void Promise.resolve(openCampaignFlow()).then(() => afterOpen());
            break;
        default:
            break;
    }
}

setSplashLinkNavigator(navigateFromSplashLink);

refreshAuthStatus();

openModesBtn.onclick = (e) => {
    if (document.body.classList.contains("theme-decor-edit")) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    const hasPoint = e instanceof MouseEvent && (e.clientX !== 0 || e.clientY !== 0);
    const origin = hasPoint
        ? { x: e.clientX, y: e.clientY }
        : (() => {
              const rect = openModesBtn.getBoundingClientRect();
              return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
          })();
    if (isPlayTransitionEnabled()) {
        runPlayTransition(() => openGameHub(), { origin, armPointerLock: false });
    } else {
        openGameHub();
    }
};

sideStatsBtn.onclick = () => {
    setActiveSidebarBtn(sideStatsBtn);
    claimExclusiveUi("statsScreen");
    hideEl(startScreen);
    hideHubScreens();
    showEl(statsScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    void updateStats();
    updateMusicState();
    playScreenEnterMotion();
};

if (sideAchievementsBtn) {
    sideAchievementsBtn.onclick = () => {
        setActiveSidebarBtn(sideAchievementsBtn);
        void openAchievementsScreen();
    };
}
if (sideTasksBtn) {
    sideTasksBtn.onclick = () => {
        setActiveSidebarBtn(sideTasksBtn);
        void openTasksScreen();
    };
}
if (sideBattlePassBtn) {
    sideBattlePassBtn.onclick = () => {
        setActiveSidebarBtn(sideBattlePassBtn);
        void openBattlePassScreen();
    };
}
if (sideShopBtn) {
    sideShopBtn.onclick = () => {
        setActiveSidebarBtn(sideShopBtn);
        void openShopScreenFromNav();
    };
}
if (sideInventoryBtn) {
    sideInventoryBtn.onclick = () => {
        setActiveSidebarBtn(sideInventoryBtn);
        void openInventoryScreenFromNav();
    };
}
if (achievementsFilterSelect) {
    achievementsFilterSelect.addEventListener("change", () => {
        if (cachedAchievementRows) renderAchievementsGrid(cachedAchievementRows);
    });
}

sideSettingsBtn.onclick = () => {
    setActiveSidebarBtn(sideSettingsBtn);
    refreshDpadSettingsVisibility();
    hideEl(startScreen);
    hideHubScreens();
    showSettingsScreen();
    setSuperHudVisible(false);
    setTopHudMode(null);
    applySettings();
};

if (settingsCopyBtn) settingsCopyBtn.addEventListener("click", () => void onSettingsCopyClicked());
if (settingsPasteBtn) settingsPasteBtn.addEventListener("click", () => void onSettingsPasteClicked());
if (settingsResetBtn) settingsResetBtn.addEventListener("click", () => openSettingsResetConfirm());
if (settingsUndoBtn) settingsUndoBtn.addEventListener("click", () => settingsUndoAction());
if (settingsRedoBtn) settingsRedoBtn.addEventListener("click", () => settingsRedoAction());
if (settingsResetConfirmYesBtn) {
    settingsResetConfirmYesBtn.addEventListener("click", () => {
        resetAllSettingsToDefaults();
        closeSettingsResetConfirm();
    });
}
if (settingsResetConfirmNoBtn) {
    settingsResetConfirmNoBtn.addEventListener("click", () => closeSettingsResetConfirm());
}

returnBtn.onclick = (e) => {
    if (settingHoldReturnHome) {
        // Pointer hold path handles press/release; ignore synthetic click after hold.
        e.preventDefault();
        return;
    }
    handleGlobalReturnAction();
};
if (returnBtn) {
    returnBtn.addEventListener("pointerdown", (e) => {
        if (!settingHoldReturnHome) return;
        if (e.button != null && e.button !== 0) return;
        e.preventDefault();
        try {
            returnBtn.setPointerCapture(e.pointerId);
        } catch {
            /* ignore */
        }
        beginReturnHold(true, e.pointerId);
    });
    const endPointerHold = (e) => {
        if (!returnHoldActive || !returnHoldFromPointer) return;
        if (returnHoldPointerId != null && e.pointerId !== returnHoldPointerId) return;
        endReturnHold();
    };
    returnBtn.addEventListener("pointerup", endPointerHold);
    returnBtn.addEventListener("pointercancel", (e) => {
        if (!returnHoldActive || !returnHoldFromPointer) return;
        if (returnHoldPointerId != null && e.pointerId !== returnHoldPointerId) return;
        cancelReturnHold();
    });
    returnBtn.addEventListener("lostpointercapture", (e) => {
        if (!returnHoldActive || !returnHoldFromPointer) return;
        if (returnHoldPointerId != null && e.pointerId !== returnHoldPointerId) return;
        if (returnHoldFiredHome) {
            cancelReturnHold();
            return;
        }
        endReturnHold();
    });
}

function wireModesScreenPlayActions() {
    const modePlayActions = {
        normal: () => startNormal(),
        progression: () => startProgression(),
        wasd: () => startWASD(),
        superdot: () => startSuperDot(),
        roulette: () => startRoulette(),
        sandbox: () => openSandboxHub(),
        speedrun: () => openSpeedrunLevelPicker(),
        penalty: () => openPenaltyLevelPicker(),
        highway: () => startHighway(),
        darkness: () => startDarkness(),
        mirror: () => startMirror(),
        delay: () => startDelay(),
        snake: () => startSnake(),
        combo: () => startCombo(),
        colorrush: () => startColorRush(),
        heat: () => startHeat(),
        hunter: () => startHunter(),
        pop: () => startPop(),
        counter: () => startCounter(),
        aim: () => startAim(),
        hook: () => startHook(),
        tilt: () => { void startTilt({ withTransition: true }); },
        orbit: () => startOrbit(),
    };
    mountModesSelectionPanel({ playActions: modePlayActions });
    wireModesContainerSelection();
    document.querySelectorAll("#modesContainer .modeBox[data-mode-id]").forEach((box) => {
        box.setAttribute("role", "button");
        if (!box.hasAttribute("tabindex")) box.tabIndex = 0;
    });
}
wireModesScreenPlayActions();
setModesRandomSfx(playChallengeSfx);
mountPlayTransition({
    setTransitionAudioDepth: setPlayTransitionAudioDepth,
    playTransitionSfx: playPlayTransitionSfx,
    armPointerLockFromGesture: armPlayTransitionPointerLock,
    onTransitionComplete() {
        applyPlayingHideCursorClass();
        pointerLockPauseSuppressedUntil = performance.now() + 750;
        tryRequestGamePointerLock();
    },
});

document.getElementById("mpSpectatePrevBtn")?.addEventListener("click", () => {
    cycleMpSpectateTarget(-1);
    updateMpSpeedrunSpectateChrome();
});
document.getElementById("mpSpectateNextBtn")?.addEventListener("click", () => {
    cycleMpSpectateTarget(1);
    updateMpSpeedrunSpectateChrome();
});

startNormalBtn?.addEventListener("click", startNormal);
startProgressionBtn?.addEventListener("click", startProgression);
startWASDBtn?.addEventListener("click", startWASD);
startSuperDotBtn?.addEventListener("click", startSuperDot);
startRouletteBtn?.addEventListener("click", startRoulette);
if (startHighwayBtn) startHighwayBtn.onclick = startHighway;
if (startDarknessBtn) startDarknessBtn.onclick = startDarkness;
if (startColorRushBtn) startColorRushBtn.onclick = startColorRush;
if (startHeatBtn) startHeatBtn.onclick = startHeat;
if (startHunterBtn) startHunterBtn.onclick = startHunter;
if (startPopBtn) startPopBtn.onclick = startPop;
if (startCounterBtn) startCounterBtn.onclick = startCounter;
if (startAimBtn) startAimBtn.onclick = startAim;
if (startHookBtn) startHookBtn.onclick = startHook;
if (startMirrorBtn) startMirrorBtn.onclick = startMirror;
if (startSnakeBtn) startSnakeBtn.onclick = startSnake;
if (startComboBtn) startComboBtn.onclick = startCombo;
async function performLogout() {
    clearUiCursorMode();
    if (cloudUser && isAccountSyncReady()) {
        await syncPlayerStatsToCloud(true);
        await flushAccountDataSync();
    }
    await releasePushDeviceForSession();
    try {
        await fetch(apiPath("/api/logout"), { method: "POST", credentials: "include" });
    } catch {
        /* ignore */
    }
    cloudUser = null;
    cloudTimedOut = false;
    cloudTimedOutUntil = null;
    cloudTimedOutAt = null;
    stopPresenceHeartbeat();
    hideTimeoutScreen();
    authGateDismissed = false;
    setAccountSyncSignedIn(false);
    clearAccountSessionLocal();
    applyLocalAccountSessionCleared();
    setProfilePanel("friends");
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    showEl(startScreen);
    await refreshAuthStatus();
    void refreshSettingsAccountUi();
    playScreenEnterMotion();
}

async function performLogoutAllDevices() {
    if (!cloudUser) return;
    const userId = cloudUser.id;
    if (isAccountSyncReady()) {
        await syncPlayerStatsToCloud(true);
        await flushAccountDataSync();
    }
    try {
        await fetch(apiPath("/api/logout-all-devices"), { method: "POST", credentials: "include" });
    } catch {
        /* ignore */
    }
    purgeSavedAccountEverywhere(userId);
    await performLogout();
}

sideLogoutBtn.onclick = () => {
    void performLogout();
};

if (sideSwitchAccountBtn instanceof HTMLButtonElement) {
    mountAccountSwitcher({
        switchBtn: sideSwitchAccountBtn,
        getCurrentUserId: () => cloudUser?.id ?? null,
        onAddAccount: () => {
            void beginAddAccountFlowAndOpen();
        },
        onSwitchAccount: async (account) => {
            await performAccountSwitch(account);
        },
    });
}

if (timeoutLogoutBtn) {
    timeoutLogoutBtn.onclick = () => {
        void performLogout();
    };
}
if (timeoutCreateAccountBtn) {
    timeoutCreateAccountBtn.onclick = () => {
        void (async () => {
            await performLogout();
            openAuthScreen("register");
        })();
    };
}

const settingsAccountSignInBtn = document.getElementById("settingsAccountSignInBtn");
const settingsLogoutBtn = document.getElementById("settingsLogoutBtn");
const settingsLogoutAllBtn = document.getElementById("settingsLogoutAllBtn");
const settingsChangePasswordToggleBtn = document.getElementById("settingsChangePasswordToggleBtn");
const settingsChangePasswordForm = document.getElementById("settingsChangePasswordForm");
const settingsCurrentPassword = document.getElementById("settingsCurrentPassword");
const settingsNewPassword = document.getElementById("settingsNewPassword");
const settingsConfirmPassword = document.getElementById("settingsConfirmPassword");
const settingsPasswordSaveBtn = document.getElementById("settingsPasswordSaveBtn");
const settingsPasswordCancelBtn = document.getElementById("settingsPasswordCancelBtn");
const settingsPasswordError = document.getElementById("settingsPasswordError");
const settingsPasswordOk = document.getElementById("settingsPasswordOk");
const settingsChangeUsernameToggleBtn = document.getElementById("settingsChangeUsernameToggleBtn");
const settingsChangeUsernameForm = document.getElementById("settingsChangeUsernameForm");
const settingsNewUsername = document.getElementById("settingsNewUsername");
const settingsUsernameSaveBtn = document.getElementById("settingsUsernameSaveBtn");
const settingsUsernameCancelBtn = document.getElementById("settingsUsernameCancelBtn");
const settingsUsernameError = document.getElementById("settingsUsernameError");
const settingsUsernameOk = document.getElementById("settingsUsernameOk");

function hideSettingsFormFeedback(errEl, okEl) {
    if (errEl) {
        errEl.textContent = "";
        errEl.classList.add("hidden");
    }
    if (okEl) {
        okEl.textContent = "";
        okEl.classList.add("hidden");
    }
}

function closeSettingsPasswordForm() {
    if (settingsChangePasswordForm) hideEl(settingsChangePasswordForm);
    if (settingsCurrentPassword) settingsCurrentPassword.value = "";
    if (settingsNewPassword) settingsNewPassword.value = "";
    if (settingsConfirmPassword) settingsConfirmPassword.value = "";
    hideSettingsFormFeedback(settingsPasswordError, settingsPasswordOk);
}

function closeSettingsUsernameForm() {
    if (settingsChangeUsernameForm) hideEl(settingsChangeUsernameForm);
    if (settingsNewUsername) settingsNewUsername.value = "";
    hideSettingsFormFeedback(settingsUsernameError, settingsUsernameOk);
}

if (settingsAccountSignInBtn) {
    settingsAccountSignInBtn.onclick = () => openAuthScreen("login");
}
if (settingsLogoutBtn) {
    settingsLogoutBtn.onclick = () => {
        void performLogout();
    };
}
if (settingsLogoutAllBtn) {
    settingsLogoutAllBtn.onclick = () => {
        void performLogoutAllDevices();
    };
}
if (settingsChangePasswordToggleBtn && settingsChangePasswordForm) {
    settingsChangePasswordToggleBtn.onclick = () => {
        hideSettingsFormFeedback(settingsPasswordError, settingsPasswordOk);
        showEl(settingsChangePasswordForm);
        settingsCurrentPassword?.focus();
    };
}
if (settingsPasswordCancelBtn) {
    settingsPasswordCancelBtn.onclick = closeSettingsPasswordForm;
}
if (settingsPasswordSaveBtn) {
    settingsPasswordSaveBtn.onclick = async () => {
        hideSettingsFormFeedback(settingsPasswordError, settingsPasswordOk);
        const current = settingsCurrentPassword?.value || "";
        const next = settingsNewPassword?.value || "";
        const confirm = settingsConfirmPassword?.value || "";
        if (!current || next.length < 8) {
            if (settingsPasswordError) {
                settingsPasswordError.textContent =
                    "Enter your current password and a new password (8+ characters).";
                settingsPasswordError.classList.remove("hidden");
            }
            return;
        }
        if (next !== confirm) {
            if (settingsPasswordError) {
                settingsPasswordError.textContent = "New passwords do not match.";
                settingsPasswordError.classList.remove("hidden");
            }
            return;
        }
        try {
            const data = await changeAccountPassword(current, next);
            if (settingsChangePasswordForm) hideEl(settingsChangePasswordForm);
            if (settingsCurrentPassword) settingsCurrentPassword.value = "";
            if (settingsNewPassword) settingsNewPassword.value = "";
            if (settingsConfirmPassword) settingsConfirmPassword.value = "";
            if (settingsPasswordError) settingsPasswordError.classList.add("hidden");
            if (settingsPasswordOk) {
                settingsPasswordOk.textContent = data.message || "Password updated.";
                settingsPasswordOk.classList.remove("hidden");
            }
        } catch (e) {
            if (settingsPasswordError) {
                settingsPasswordError.textContent =
                    e instanceof Error ? e.message : "Could not change password.";
                settingsPasswordError.classList.remove("hidden");
            }
        }
    };
}
if (settingsChangeUsernameToggleBtn && settingsChangeUsernameForm) {
    settingsChangeUsernameToggleBtn.onclick = () => {
        if (settingsChangeUsernameToggleBtn.disabled) return;
        hideSettingsFormFeedback(settingsUsernameError, settingsUsernameOk);
        showEl(settingsChangeUsernameForm);
        if (settingsNewUsername && cloudUser?.displayName) {
            settingsNewUsername.value = cloudUser.displayName;
            settingsNewUsername.select();
        }
        settingsNewUsername?.focus();
    };
}
if (settingsUsernameCancelBtn) {
    settingsUsernameCancelBtn.onclick = closeSettingsUsernameForm;
}
if (settingsUsernameSaveBtn) {
    settingsUsernameSaveBtn.onclick = async () => {
        hideSettingsFormFeedback(settingsUsernameError, settingsUsernameOk);
        const raw = (settingsNewUsername?.value || "").trim().toLowerCase();
        if (!/^[a-z0-9_]{2,40}$/.test(raw)) {
            if (settingsUsernameError) {
                settingsUsernameError.textContent =
                    "Username: lowercase letters, numbers, underscore only (2–40 chars).";
                settingsUsernameError.classList.remove("hidden");
            }
            return;
        }
        try {
            const data = await changeAccountUsername(raw);
            if (cloudUser) cloudUser.displayName = data.displayName;
            if (authStatusLine) {
                authStatusLine.textContent = data.displayName || cloudUser?.email || "Player";
                authStatusLine.classList.add("authStatusLine--signedIn");
            }
            if (settingsUsernameOk) {
                settingsUsernameOk.textContent = "Username updated.";
                settingsUsernameOk.classList.remove("hidden");
            }
            closeSettingsUsernameForm();
            void refreshSettingsAccountUi();
        } catch (e) {
            if (settingsUsernameError) {
                settingsUsernameError.textContent =
                    e instanceof Error ? e.message : "Could not change username.";
                settingsUsernameError.classList.remove("hidden");
            }
        }
    };
}
sideRankingsBtn.onclick = () => { setActiveSidebarBtn(sideRankingsBtn); openLeaderboardScreen(); };
sideSocialBtn.onclick = () => {
    setActiveSidebarBtn(sideSocialBtn);
    setProfilePanel("friends");
    openProfileScreen();
};
if (socialTabFriendsBtn) {
    socialTabFriendsBtn.onclick = () => {
        publicProfileReturnToFriends = false;
        setProfilePanel("friends");
    };
}
if (socialTabSearchBtn) {
    socialTabSearchBtn.onclick = () => {
        publicProfileReturnToFriends = false;
        setProfilePanel("find-player");
    };
}
if (messageBackBtn) {
    messageBackBtn.onclick = () => {
        setProfilePanel("friends");
    };
}
if (sideNotificationsBtn) {
    sideNotificationsBtn.onclick = () => {
        setActiveSidebarBtn(sideNotificationsBtn);
        openNotificationsScreen();
    };
}
sideNewsBtn.onclick = () => {
    setActiveSidebarBtn(sideNewsBtn);
    openNewsScreen();
};
if (sideWallBtn) {
    sideWallBtn.onclick = () => {
        setActiveSidebarBtn(sideWallBtn);
        openWallScreenView();
    };
}
setWallNavigateHandler(navigateFromWallSection);
mountWallScreen();
mountNotificationsUi({ isSignedIn: () => !!cloudUser });
mountPushNotificationSettings({
    isSignedIn: () => !!cloudUser,
    getUserId: () => cloudUser?.id ?? null,
    openShop: () => {
        void openShopScreenFromNav();
    },
    openFriends: () => {
        openProfileScreen();
        setProfilePanel("friends");
    },
    openMessages: () => {
        openProfileScreen();
        setProfilePanel("messages");
    },
    openNotifications: () => {
        openNotificationsScreen();
    },
    openSettingsNotifications: () => {
        if (sideSettingsBtn) setActiveSidebarBtn(sideSettingsBtn);
        hideEl(startScreen);
        hideHubScreens();
        showSettingsScreen();
        setSuperHudVisible(false);
        setTopHudMode(null);
        applySettings();
        window.setTimeout(() => scrollToSettingsSection("settingsNotificationsAccordion"), 120);
    },
    goHome: () => {
        goToMenu("home");
    },
});
sideHomeBtn.onclick = () => { setActiveSidebarBtn(sideHomeBtn); goToMenu("home"); };
sideCreditsBtn.onclick = () => { setActiveSidebarBtn(sideCreditsBtn); openCredits(); };
{
    const sideNavEl = document.getElementById("sideNav");
    if (sideNavEl) {
        const syncDotFromScroll = () => {
            const active = sideNavEl.querySelector(".sideNavBtn.active");
            if (active instanceof HTMLElement) updateSideNavActiveDot(active);
        };
        sideNavEl.querySelectorAll(".sideNavScroll").forEach((scrollEl) => {
            scrollEl.addEventListener("scroll", syncDotFromScroll);
        });
        const clearShimmer = (el: HTMLElement) => {
            el.classList.remove("sideNavBtn-shimmer");
        };
        sideNavEl.addEventListener("click", e => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            const btn = t.closest(".sideNavBtn");
            if (!btn || btn.id === "sideAdminPanelBtn") return;
            if (btn.closest("#sideNavAdminScroll")) return;
            hideAdminPanelScreen();
        }, true);
        sideNavEl.addEventListener("pointerdown", e => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            const btn = t.closest(".sideNavBtn");
            if (!btn || !sideNavEl.contains(btn)) return;
            clearShimmer(btn);
            void btn.getBoundingClientRect();
            btn.classList.add("sideNavBtn-shimmer");
            window.setTimeout(() => clearShimmer(btn), 620);
        });
        sideNavEl.addEventListener(
            "animationend",
            e => {
                const el = e.target;
                if (el instanceof HTMLElement && el.classList.contains("sideNavBtn-shimmer")) clearShimmer(el);
            },
            true
        );
    }
}
if (profileBioSaveBtn) profileBioSaveBtn.onclick = () => void saveProfileBio();
if (profileLookupBtn) profileLookupBtn.onclick = () => void lookupPublicProfile();
if (friendRequestBtn) {
    friendRequestBtn.onclick = async () => {
        if (!friendEmailInput || !friendActionStatus) return;
        friendActionStatus.textContent = "";
        const raw = friendEmailInput.value.trim();
        if (!raw) return;
        const lower = raw.toLowerCase();
        const payload =
            raw.includes("@")
                ? { action: "request", email: lower }
                : { action: "request", username: lower };
        try {
            const r = await fetch(apiPath("/api/friends"), {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const d = await r.json().catch(() => ({}));
            friendActionStatus.textContent = r.ok
                ? "Request sent."
                : d.error === "user_not_found"
                  ? "User not found."
                  : d.error === "invalid_username"
                    ? "Invalid username (2–40 chars: a–z, 0–9, _)."
                    : d.error === "already_friends"
                      ? "You are already friends."
                      : d.error === "request_exists"
                        ? "A request is already pending."
                        : d.error === "cannot_friend_self"
                          ? "You cannot add yourself."
                          : d.error || `Could not send (${r.status}).`;
            if (r.ok) friendEmailInput.value = "";
            void refreshFriendsUi();
        } catch {
            friendActionStatus.textContent = "Network error.";
        }
    };
}
if (messagePeerSelect) {
    messagePeerSelect.addEventListener("change", () => void loadMessageThread());
}
async function sendComposedMessage() {
    if (!messagePeerSelect || !messageComposeInput || !friendActionStatus) return;
    const to = messagePeerSelect.value.trim();
    const body = messageComposeInput.value.trim();
    if (!to || !body) return;
    try {
        const r = await fetch(apiPath("/api/messages"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ toUserId: to, body }),
        });
        if (r.ok) {
            messageComposeInput.value = "";
            void loadMessageThread();
        } else friendActionStatus.textContent = "Message not sent.";
    } catch {
        friendActionStatus.textContent = "Network error.";
    }
}
if (messageSendBtn) {
    messageSendBtn.onclick = () => void sendComposedMessage();
}
if (messageComposeInput) {
    messageComposeInput.addEventListener("keydown", e => {
        if (e.key !== "Enter") return;
        e.preventDefault();
        void sendComposedMessage();
    });
}
rankingRefreshBtn.onclick = () => {
    loadLeaderboardTable();
};
rankingModeSelect.addEventListener("change", () => {
    if (rankingOtherSelect) rankingOtherSelect.value = "";
    syncRankingSpeedrunLevelUi();
    loadLeaderboardTable();
});
if (rankingOtherSelect) {
    rankingOtherSelect.addEventListener("change", () => {
        syncRankingSpeedrunLevelUi();
        loadLeaderboardTable();
    });
}

document.addEventListener("cursorgame:open-rankings-mode", (e) => {
    const modeId = e instanceof CustomEvent ? String(e.detail?.modeId || "") : "";
    if (modeId) openLeaderboardForGameMode(modeId);
});
if (authGuestBtn) authGuestBtn.onclick = closeAuthScreen;
if (homeSignInBtn) homeSignInBtn.onclick = () => openAuthScreen("login");
if (sideSignInBtn) sideSignInBtn.onclick = () => openAuthScreen("login");
authSwitchBtn.onclick = () => {
    const showingRegister = !registerFormBlock.classList.contains("hidden");
    if (getAddAccountReturnTarget()) {
        setAuthTab(showingRegister ? "addAccount" : "register");
        return;
    }
    setAuthTab(showingRegister ? "login" : "register");
};
if (forgotPasswordLink) {
    forgotPasswordLink.onclick = () => {
        loginError.classList.add("hidden");
        setAuthTab("forgot");
    };
}
if (forgotBackBtn) {
    forgotBackBtn.onclick = () => {
        setAuthTab("login");
    };
}
if (forgotVerifyBtn) {
    forgotVerifyBtn.onclick = async () => {
        if (forgotVerifyError) forgotVerifyError.classList.add("hidden");
        const email = (forgotEmail && forgotEmail.value.trim()) || "";
        const tempPassword = (forgotTempPassword && forgotTempPassword.value) || "";
        if (!email || !tempPassword) {
            if (forgotVerifyError) {
                forgotVerifyError.textContent = "Enter your email and temporary password.";
                forgotVerifyError.classList.remove("hidden");
            }
            return;
        }
        try {
            const r = await fetch(apiPath("/api/password-recovery"), {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ action: "verify", email, tempPassword }),
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                if (forgotVerifyError) {
                    forgotVerifyError.textContent = data.message || data.error || "Invalid temporary password.";
                    forgotVerifyError.classList.remove("hidden");
                }
                return;
            }
            forgotRecoveryEmail = email;
            forgotRecoveryTempPassword = tempPassword;
            if (forgotStep1) forgotStep1.classList.add("hidden");
            if (forgotStep2) forgotStep2.classList.remove("hidden");
            if (forgotNewPassword) forgotNewPassword.focus();
        } catch {
            if (forgotVerifyError) {
                forgotVerifyError.textContent = "Network error";
                forgotVerifyError.classList.remove("hidden");
            }
        }
    };
}
if (forgotDoneBtn) {
    forgotDoneBtn.onclick = async () => {
        if (forgotCompleteError) forgotCompleteError.classList.add("hidden");
        if (forgotCompleteOk) forgotCompleteOk.classList.add("hidden");
        const newPassword = (forgotNewPassword && forgotNewPassword.value) || "";
        if (!forgotRecoveryEmail || !forgotRecoveryTempPassword) {
            if (forgotCompleteError) {
                forgotCompleteError.textContent = "Session expired. Start Forgot Password again.";
                forgotCompleteError.classList.remove("hidden");
            }
            return;
        }
        if (newPassword.length < 8) {
            if (forgotCompleteError) {
                forgotCompleteError.textContent = "New password must be at least 8 characters.";
                forgotCompleteError.classList.remove("hidden");
            }
            return;
        }
        try {
            const r = await fetch(apiPath("/api/password-recovery"), {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "complete",
                    email: forgotRecoveryEmail,
                    tempPassword: forgotRecoveryTempPassword,
                    newPassword,
                }),
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                if (forgotCompleteError) {
                    forgotCompleteError.textContent = data.message || data.error || "Could not update password.";
                    forgotCompleteError.classList.remove("hidden");
                }
                return;
            }
            if (forgotCompleteOk) {
                forgotCompleteOk.textContent = data.message || "Password updated. You can sign in now.";
                forgotCompleteOk.classList.remove("hidden");
            }
            if (loginEmail) loginEmail.value = forgotRecoveryEmail;
            if (loginPassword) loginPassword.value = "";
            forgotRecoveryEmail = "";
            forgotRecoveryTempPassword = "";
            window.setTimeout(() => setAuthTab("login"), 1200);
        } catch {
            if (forgotCompleteError) {
                forgotCompleteError.textContent = "Network error";
                forgotCompleteError.classList.remove("hidden");
            }
        }
    };
}
if (sideNavToggle) {
    sideNavToggle.onclick = () => {
        toggleSidebarMenu();
    };
}
if (pauseTopBtn) {
    pauseTopBtn.onclick = () => {
        if (playing && !deathPending) togglePause();
    };
}

loginSubmitBtn.onclick = async () => {
    loginError.classList.add("hidden");
    const addAccountMode = !!getAddAccountReturnTarget();
    try {
        if (addAccountMode) {
            if (cloudUser && isAccountSyncReady()) {
                await syncPlayerStatsToCloud(true);
                await flushAccountDataSync();
            }
        } else if (cloudUser && isAccountSyncReady()) {
            await syncPlayerStatsToCloud(true);
            await flushAccountDataSync();
        }
        if (cloudUser) await releasePushDeviceForSession();
        const r = await fetch(apiPath("/api/login"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: loginEmail.value.trim(),
                password: loginPassword.value
            })
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
            loginError.textContent = data.message || data.error || "Login failed";
            loginError.classList.remove("hidden");
            // Re-bind previous session if login failed and cookie may still be old user
            if (cloudUser?.id) void syncPushSubscriptionForSession(cloudUser.id);
            return;
        }
        loginPassword.value = "";
        if (addAccountMode) {
            const added = rememberAccountFromAuth(data.user, data.sessionToken, { addIfMissing: true });
            if (added) {
                await releasePushDeviceForSession();
                const switched = await finishAddAccountFlow(added);
                if (!switched.ok) {
                    loginError.textContent = switched.error || "Could not return to your previous account.";
                    loginError.classList.remove("hidden");
                    return;
                }
                loginEmail.value = "";
                await closeAddAccountScreen();
                return;
            }
        } else {
            rememberAccountFromAuth(data.user, data.sessionToken);
        }
        closeAuthScreen();
    } catch {
        loginError.textContent = "Network error";
        loginError.classList.remove("hidden");
    }
};

if (authAddAccountReturnBtn) {
    authAddAccountReturnBtn.onclick = () => {
        void (async () => {
            const switched = await cancelAddAccountFlow();
            if (!switched.ok) {
                loginError.textContent = switched.error || "Could not return to your account.";
                loginError.classList.remove("hidden");
                return;
            }
            loginEmail.value = "";
            loginPassword.value = "";
            await closeAddAccountScreen();
        })();
    };
}

registerSubmitBtn.onclick = async () => {
    registerError.classList.add("hidden");
    const addAccountMode = !!getAddAccountReturnTarget();
    try {
        if (addAccountMode) {
            if (cloudUser && isAccountSyncReady()) {
                await syncPlayerStatsToCloud(true);
                await flushAccountDataSync();
            }
        } else if (cloudUser && isAccountSyncReady()) {
            await syncPlayerStatsToCloud(true);
            await flushAccountDataSync();
        }
        if (cloudUser) await releasePushDeviceForSession();
        const r = await fetch(apiPath("/api/register"), {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: registerEmail.value.trim(),
                password: registerPassword.value,
                displayName: registerDisplayName.value.trim()
            })
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
            registerError.textContent = data.message || data.error || "Registration failed";
            registerError.classList.remove("hidden");
            if (cloudUser?.id) void syncPushSubscriptionForSession(cloudUser.id);
            return;
        }
        registerPassword.value = "";
        if (addAccountMode) {
            const added = rememberAccountFromAuth(data.user, data.sessionToken, { addIfMissing: true });
            if (added) {
                await releasePushDeviceForSession();
                const switched = await finishAddAccountFlow(added);
                if (!switched.ok) {
                    registerError.textContent = switched.error || "Could not return to your previous account.";
                    registerError.classList.remove("hidden");
                    return;
                }
                registerEmail.value = "";
                registerDisplayName.value = "";
                await closeAddAccountScreen();
                return;
            }
        } else {
            rememberAccountFromAuth(data.user, data.sessionToken);
        }
        closeAuthScreen();
    } catch {
        registerError.textContent = "Network error";
        registerError.classList.remove("hidden");
    }
};

rouletteWarnAcceptBtn.onclick = confirmRouletteWarning;
rouletteWarnCancelBtn.onclick = cancelRouletteWarning;
pauseResumeBtn.onclick = () => {
    if (gamePaused) togglePause();
};
if (pauseResetBtn) {
    pauseResetBtn.onclick = () => resetFromPauseMenu();
}

function openSandboxHub() {
    sandboxActivePlayContext = { localName: null, cloudPresetId: null };
    hideHubScreens();
    hideEl(modeScreen);
    hideEl(sandboxScreen);
    hideEl(sandboxCommunityScreen);
    hideEl(creditsScreen);
    hideEl(rouletteWarnScreen);
    hideEl(authScreen);
    hideEl(leaderboardScreen);
    hideEl(achievementsScreen);
    hideShopScreenNav();
    hideEl(profileScreen);
    if (newsScreen) hideEl(newsScreen);
    if (notificationsScreen) hideEl(notificationsScreen);
    if (wallScreen) hideEl(wallScreen);
    showEl(sandboxBaseScreen);
    showEl(returnBtn);
    setTopHudMode(null);
    syncSidebarState();
    syncReturnBtnVisibility();
    updateMusicState();
    playScreenEnterMotion();
}

function openSandboxCommunityFromHub() {
    hideEl(sandboxBaseScreen);
    hideEl(sandboxScreen);
    showEl(sandboxCommunityScreen);
    showEl(returnBtn);
    syncSidebarState();
    syncReturnBtnVisibility();
    void refreshSandboxSpeedrunCloudBests();
    void refreshSandboxScoreCloudBests();
    void refreshSandboxCommunityPresets();
    playScreenEnterMotion();
}

function openSandboxConfigForBaseMode(baseMode) {
    sandboxConfig = sandboxRuntimeFlat(defaultSandboxConfigV2(baseMode));
    // Keep draft layout if same base, else fresh
    try {
        const draft = loadSandboxDraft();
        if (draft && draft.baseMode === baseMode) {
            sandboxConfig = normalizeSandboxConfig(draft);
        }
    } catch { /* ignore */ }
    saveSandboxDraft();
    openSandboxScreen();
}

function openSandboxScreen() {
    claimExclusiveUi("sandboxScreen");
    hideEl(sandboxBaseScreen);
    hideEl(sandboxCommunityScreen);
    hideSandboxCommunityLeaderboard();
    showEl(sandboxScreen);
    showEl(returnBtn);
    hideEl(sandboxSaveCard);
    hideEl(sandboxLoadCard);
    refreshSandboxUI();
    setTopHudMode(null);
    updateMusicState();
}

startSandboxBtn?.addEventListener("click", openSandboxScreen);

if (startSpeedRunBtn) {
    startSpeedRunBtn.onclick = () => {
        openSpeedrunLevelPicker();
    };
}
if (startPenaltyBtn) {
    startPenaltyBtn.onclick = () => {
        openPenaltyLevelPicker();
    };
}
if (speedrunCompleteReturnBtn) {
    speedrunCompleteReturnBtn.onclick = () => {
        if (adminSpeedrunPlaytestActive || adminSpeedrunPlaytestSnapshot || practicePlayActive) {
            hideEl(speedrunCompleteScreen);
            endAdminSpeedrunPlaytest();
            return;
        }
        closeSpeedrunCompleteToPicker();
    };
}
if (speedrunCompletePlayAgainBtn) {
    speedrunCompletePlayAgainBtn.onclick = () => {
        hideEl(speedrunCompleteScreen);
        if (practicePlayActive && practiceActiveDef) {
            beginPracticeRun(practiceActiveDef, {
                fromAdmin: practicePlayFromAdmin,
                levelIndex: practicePlayLevelIndex,
            });
            return;
        }
        if (adminSpeedrunPlaytestActive && adminSpeedrunPlaytestSnapshot) {
            restartAdminSpeedrunPlaytestFromSnapshot();
            return;
        }
        startSpeedrunGame(speedrunActiveLevel);
    };
}
if (speedrunCompleteNextBtn) {
    speedrunCompleteNextBtn.onclick = () => {
        hideEl(speedrunCompleteScreen);
        const nextLv = getNextSpeedrunPublishedLevel(speedrunActiveLevel);
        if (nextLv != null) startSpeedrunGame(nextLv);
        else {
            gameMode = null;
            showEl(speedrunLevelScreen);
            showEl(returnBtn);
            updateMusicState();
        }
    };
}

if (penaltyCompleteReturnBtn) {
    penaltyCompleteReturnBtn.onclick = () => {
        if (adminPenaltyPlaytestActive || adminPenaltyPlaytestSnapshot) {
            hideEl(penaltyCompleteScreen);
            endAdminPenaltyPlaytest();
            return;
        }
        closePenaltyCompleteToPicker();
    };
}
if (penaltyCompletePlayAgainBtn) {
    penaltyCompletePlayAgainBtn.onclick = () => {
        hideEl(penaltyCompleteScreen);
        if (adminPenaltyPlaytestActive && adminPenaltyPlaytestSnapshot) {
            restartAdminPenaltyPlaytestFromSnapshot();
            return;
        }
        startPenaltyGame(penaltyRuntime.activeLevel);
    };
}
if (penaltyCompleteNextBtn) {
    penaltyCompleteNextBtn.onclick = () => {
        hideEl(penaltyCompleteScreen);
        const nextLv = getNextPenaltyPublishedLevel(penaltyRuntime.activeLevel);
        if (nextLv != null) startPenaltyGame(nextLv);
        else {
            gameMode = null;
            showEl(penaltyLevelScreen);
            showEl(returnBtn);
            updateMusicState();
        }
    };
}

function beginSandboxSpeedrunWin(elapsedMs) {
    if (gameMode !== "sandbox" || !sandboxRuntimeConfig || !sandboxRuntimeConfig.speedrunMode) return;
    playing = false;
    gamePaused = false;
    clearResumeCountdown();
    exitGamePointerLock();
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    applyBackgroundTheme();
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    const ms = Math.floor(Number(elapsedMs) || 0);
    const ctx = sandboxActivePlayContext;
    const key = ctx.cloudPresetId
        ? `cloud:${ctx.cloudPresetId}`
        : ctx.localName
          ? `local:${String(ctx.localName).toLowerCase()}`
          : null;
    if (!isThemeCosmeticPreviewPlay()) {
        if (key && ms > 0) maybeWriteSandboxSpeedrunLocalBest(key, ms);
        if (ctx && ms > 0) persistSandboxPresetSpeedrunIfMatch(ctx.localName, ctx.cloudPresetId, ms);
    }
    if (sandboxSpeedrunWinLine) {
        sandboxSpeedrunWinLine.textContent =
            ms > 0
                ? isThemeCosmeticPreviewPlay()
                    ? `Time: ${formatSpeedrunTime(ms)} · Theme Preview (not saved)`
                    : `Time: ${formatSpeedrunTime(ms)} · Press Continue to play again from spawn`
                : `Press Continue to play again from spawn`;
    }
    if (!isThemeCosmeticPreviewPlay()) void submitSandboxSpeedrunCloud(ms);
    if (sandboxSpeedrunWinScreen) showEl(sandboxSpeedrunWinScreen);
    showEl(returnBtn);
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    startFX("#0f0");
    updateMobilePlayChrome();
    void pollAchievementUnlocksNow();
}

function continueSandboxSpeedrunWin() {
    if (sandboxSpeedrunWinScreen) hideEl(sandboxSpeedrunWinScreen);
    if (gameMode !== "sandbox" || !sandboxRuntimeConfig || !sandboxRuntimeConfig.speedrunMode) return;
    rebuildSandboxSpeedrunGeometry();
    speedrunCheckpointsCollected = new Set();
    speedrunLastCheckpointIndex = null;
    speedrunCheckpointProgressSnapshot = null;
    repositionCursorToSpeedrunNorm(speedrunRespawnNormAtSpawn());
    sandboxSpeedrunPrev.x = mouse.x;
    sandboxSpeedrunPrev.y = mouse.y;
    sandboxPointerTarget.x = mouse.x;
    sandboxPointerTarget.y = mouse.y;
    playing = true;
    resetFrameClockLeavingMenuIdle();
    speedrunStartPerf = getGameSimNowMs();
    document.body.classList.add("hideCursor");
    document.body.classList.add("game-active");
    applyBackgroundTheme();
    hideEl(pauseScreen);
    tryRequestGamePointerLock();
    updateMobilePlayChrome();
}

function respawnSandboxSpeedrunFromLaser() {
    if (!sandboxRuntimeConfig || !sandboxRuntimeConfig.speedrunMode) return;
    if (speedrunCheckpointsNorm.length > 0) {
        handleSpeedrunCheckpointLaserDeath();
    } else {
        respawnSpeedrunFromLaserHit();
    }
    sandboxSpeedrunPrev.x = mouse.x;
    sandboxSpeedrunPrev.y = mouse.y;
    sandboxPointerTarget.x = mouse.x;
    sandboxPointerTarget.y = mouse.y;
    flushSpeedrunPointerIntent();
}

if (sandboxSpeedrunWinContinueBtn) {
    sandboxSpeedrunWinContinueBtn.onclick = () => continueSandboxSpeedrunWin();
}

if (toggleEffectFlashesBtn) {
    toggleEffectFlashesBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingEffectFlashes = !settingEffectFlashes;
        setBoolSetting("settingEffectFlashes", settingEffectFlashes);
        applySettings();
    };
}
if (toggleEffectShakeBtn) {
    toggleEffectShakeBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingEffectShake = !settingEffectShake;
        setBoolSetting("settingEffectShake", settingEffectShake);
        applySettings();
    };
}
if (toggleEffectParticlesBtn) {
    toggleEffectParticlesBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingEffectParticles = !settingEffectParticles;
        setBoolSetting("settingEffectParticles", settingEffectParticles);
        applySettings();
    };
}
if (toggleFreezeGameBtn) {
    toggleFreezeGameBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingFreezeOnLose = !settingFreezeOnLose;
        setBoolSetting("settingFreezeOnLose", settingFreezeOnLose);
        applySettings();
    };
}
if (freezeGameSecondsInput) {
    freezeGameSecondsInput.addEventListener("change", () => {
        pushSettingsUndoCurrent();
        applyFreezeGameSecondsFromInput();
    });
    freezeGameSecondsInput.addEventListener("blur", () => {
        applyFreezeGameSecondsFromInput();
    });
}
if (toggleAutoRetryBtn) {
    toggleAutoRetryBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingAutoRetry = !settingAutoRetry;
        setBoolSetting("settingAutoRetry", settingAutoRetry);
        refreshSettingsUI();
    };
}
if (toggleModesSelectPanelBtn) {
    toggleModesSelectPanelBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingModesSelectPanel = !settingModesSelectPanel;
        setBoolSetting("settingModesSelectPanel", settingModesSelectPanel);
        if (!settingModesSelectPanel) clearModeSelection();
        refreshSettingsUI();
    };
}
if (togglePlayTransitionBtn) {
    togglePlayTransitionBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingPlayTransition = !settingPlayTransition;
        setBoolSetting("settingPlayTransition", settingPlayTransition);
        refreshSettingsUI();
    };
}
if (toggleQuickRestartBtn) {
    toggleQuickRestartBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingQuickRestart = !settingQuickRestart;
        setBoolSetting("settingQuickRestart", settingQuickRestart);
        refreshSettingsUI();
    };
}
if (toggleTrailBtn) {
    toggleTrailBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingTrailEnabled = !settingTrailEnabled;
        setBoolSetting("settingTrailEnabled", settingTrailEnabled);
        applySettings();
    };
}

if (toggleCosmeticsMatchCursorBtn) {
    toggleCosmeticsMatchCursorBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingCosmeticsMatchCursor = !settingCosmeticsMatchCursor;
        setBoolSetting("settingCosmeticsMatchCursor", settingCosmeticsMatchCursor);
        refreshSettingsUI();
    };
}

if (toggleNeonBallsBtn) {
    toggleNeonBallsBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingNeonBalls = !settingNeonBalls;
        setBoolSetting("settingNeonBalls", settingNeonBalls);
        refreshSettingsUI();
    };
}

if (toggleHomeAmbientBallsBtn) {
    toggleHomeAmbientBallsBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingHomeAmbientBalls = !settingHomeAmbientBalls;
        setBoolSetting("settingHomeAmbientBalls", settingHomeAmbientBalls);
        applySettings();
    };
}

if (toggleNewsInHomeBtn) {
    toggleNewsInHomeBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingNewsInHome = !settingNewsInHome;
        setBoolSetting("settingNewsInHome", settingNewsInHome);
        applySettings();
    };
}

if (toggleNotificationsInHomeBtn) {
    toggleNotificationsInHomeBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingNotificationsInHome = !settingNotificationsInHome;
        setBoolSetting("settingNotificationsInHome", settingNotificationsInHome);
        applySettings();
    };
}

if (toggleHomeSplashBtn) {
    toggleHomeSplashBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingHomeSplash = !settingHomeSplash;
        setBoolSetting("settingHomeSplash", settingHomeSplash);
        applySettings();
    };
}

if (toggleShowFpsBtn) {
    toggleShowFpsBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingShowFps = !settingShowFps;
        setBoolSetting("settingShowFps", settingShowFps);
        applySettings();
    };
}

showFpsWhereBtns.forEach(btn => {
    btn.addEventListener("click", () => {
        const next = btn.getAttribute("data-fps-where");
        if (!next || next === settingShowFpsWhere) return;
        if (next !== "home" && next !== "game" && next !== "always") return;
        pushSettingsUndoCurrent();
        settingShowFpsWhere = next;
        localStorage.setItem("settingShowFpsWhere", settingShowFpsWhere);
        applySettings();
    });
});

if (toggleLowPowerCap60Btn) {
    toggleLowPowerCap60Btn.onclick = () => {
        pushSettingsUndoCurrent();
        applyLowPowerCap60Setting(!settingLowPowerCap60);
    };
}

if (toggleInvertReturnPauseBtn) {
    toggleInvertReturnPauseBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingInvertReturnPause = !settingInvertReturnPause;
        setBoolSetting("settingInvertReturnPause", settingInvertReturnPause);
        applySettings();
    };
}

if (toggleHoldReturnHomeBtn) {
    toggleHoldReturnHomeBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingHoldReturnHome = !settingHoldReturnHome;
        setBoolSetting("settingHoldReturnHome", settingHoldReturnHome);
        cancelReturnHold();
        applySettings();
    };
}

if (holdReturnHomeSecondsInput) {
    holdReturnHomeSecondsInput.addEventListener("change", () => {
        pushSettingsUndoCurrent();
        applyHoldReturnHomeSecondsFromInput();
        if (cloudUser && !applyingRemoteAccountData) {
            touchAccountSettingsUpdatedAt();
            schedulePushAccountData();
        }
    });
    holdReturnHomeSecondsInput.addEventListener("blur", () => {
        applyHoldReturnHomeSecondsFromInput();
    });
}

if (toggleInvertSidebarBtn) {
    toggleInvertSidebarBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingInvertSidebar = !settingInvertSidebar;
        setBoolSetting("settingInvertSidebar", settingInvertSidebar);
        applySettings();
    };
}

if (toggleShowMobileSettingsBtn) {
    toggleShowMobileSettingsBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingShowMobileSettingsInUi = !settingShowMobileSettingsInUi;
        setBoolSetting("settingShowMobileSettingsInUi", settingShowMobileSettingsInUi);
        syncToggleSwitch(toggleShowMobileSettingsBtn, settingShowMobileSettingsInUi);
        refreshDpadSettingsVisibility();
    };
}

toggleSoundsBtn.onclick = () => {
    pushSettingsUndoCurrent();
    settingSounds = !settingSounds;
    setBoolSetting("settingSounds", settingSounds);
    applySettings();
};

if (textAutoColorBtn) {
    textAutoColorBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingButtonsAutoText = !settingButtonsAutoText;
        setBoolSetting("settingButtonsAutoText", settingButtonsAutoText);
        applySettings();
    };
}

if (showAdminThemeBtn) {
    showAdminThemeBtn.onclick = () => {
        pushSettingsUndoCurrent();
        setShowAdminThemeSetting(!getShowAdminThemeSetting());
        applySettings();
    };
}

if (toggleTouchJoystickBtn) {
    toggleTouchJoystickBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingTouchCursorJoystick = !settingTouchCursorJoystick;
        setBoolSetting("settingTouchCursorJoystick", settingTouchCursorJoystick);
        if (!settingTouchCursorJoystick) endTouchCursorAnalogAny();
        applySettings();
    };
}
if (toggleTouchJoystickVisibleBtn) {
    toggleTouchJoystickVisibleBtn.onclick = () => {
        if (!settingTouchCursorJoystick) return;
        pushSettingsUndoCurrent();
        settingTouchCursorJoystickVisible = !settingTouchCursorJoystickVisible;
        setBoolSetting("settingTouchCursorJoystickVisible", settingTouchCursorJoystickVisible);
        applySettings();
    };
}
if (touchJoystickSensitivityDefault) {
    touchJoystickSensitivityDefault.onclick = () => saveTouchJoystickSensitivity(4);
}
if (touchJoystickSensitivity) {
    touchJoystickSensitivity.addEventListener("input", () => saveTouchJoystickSensitivity(touchJoystickSensitivity.value));
}

if (toggleKeybindIndicatorBtn) {
    toggleKeybindIndicatorBtn.onclick = () => {
        pushSettingsUndoCurrent();
        settingShowKeybindIndicator = !settingShowKeybindIndicator;
        setBoolSetting("settingShowKeybindIndicator", settingShowKeybindIndicator);
        applySettings();
    };
}

document.getElementById("ballsDefault").onclick = () => saveColorSetting("balls", "#66ffff");
document.getElementById("trailDefault").onclick = () => saveColorSetting("trail", "#66ffff");
document.getElementById("cursorDefault").onclick = () => saveColorSetting("cursor", "#ffffff");
document.getElementById("buttonsDefault").onclick = () => saveColorSetting("buttons", "#66ffff");
document.getElementById("textDefault").onclick = () => saveColorSetting("text", "#66ffff");
document.getElementById("menuBackgroundDefault").onclick = () => saveColorSetting("menuBackground", "#000000");
document.getElementById("gameBackgroundDefault").onclick = () => saveColorSetting("gameBackground", "#000000");
wasdSensitivityDefault.onclick = () => saveWASDSensitivity(4);
musicVolumeDefault.onclick = () => {
    saveMusicVolume(6);
    saveGameMusicVolume(6);
    settingMenuSong = 1;
    settingGameSong = 1;
    localStorage.setItem("settingMenuSong", "1");
    localStorage.setItem("settingGameSong", "1");
    refreshSettingsUI();
    stopMenuMusic();
    stopGameMusic();
    updateMusicState();
};
bounceVolumeDefault.onclick = () => saveBounceVolume(SFX_VOLUME_DEFAULT);
if (pickupVolumeDefault) pickupVolumeDefault.onclick = () => savePickupVolume(SFX_VOLUME_DEFAULT);
if (gameSfxVolumeDefault) gameSfxVolumeDefault.onclick = () => saveGameSfxVolume(SFX_VOLUME_DEFAULT);
if (darknessVolumeDefault) darknessVolumeDefault.onclick = () => saveDarknessVolume(SFX_VOLUME_DEFAULT);
if (uiVolumeDefault) uiVolumeDefault.onclick = () => saveUiVolume(UI_VOLUME_DEFAULT);

ballsR.addEventListener("input", () => saveColorSetting("balls", rgbToHex(ballsR.value, ballsG.value, ballsB.value)));
ballsG.addEventListener("input", () => saveColorSetting("balls", rgbToHex(ballsR.value, ballsG.value, ballsB.value)));
ballsB.addEventListener("input", () => saveColorSetting("balls", rgbToHex(ballsR.value, ballsG.value, ballsB.value)));

trailR.addEventListener("input", () => saveColorSetting("trail", rgbToHex(trailR.value, trailG.value, trailB.value)));
trailG.addEventListener("input", () => saveColorSetting("trail", rgbToHex(trailR.value, trailG.value, trailB.value)));
trailB.addEventListener("input", () => saveColorSetting("trail", rgbToHex(trailR.value, trailG.value, trailB.value)));

cursorR.addEventListener("input", () => saveColorSetting("cursor", rgbToHex(cursorR.value, cursorG.value, cursorB.value)));
cursorG.addEventListener("input", () => saveColorSetting("cursor", rgbToHex(cursorR.value, cursorG.value, cursorB.value)));
cursorB.addEventListener("input", () => saveColorSetting("cursor", rgbToHex(cursorR.value, cursorG.value, cursorB.value)));

if (inventoryCursorR && inventoryCursorG && inventoryCursorB) {
    inventoryCursorR.addEventListener("input", () =>
        saveColorSetting("cursor", rgbToHex(inventoryCursorR.value, inventoryCursorG.value, inventoryCursorB.value)),
    );
    inventoryCursorG.addEventListener("input", () =>
        saveColorSetting("cursor", rgbToHex(inventoryCursorR.value, inventoryCursorG.value, inventoryCursorB.value)),
    );
    inventoryCursorB.addEventListener("input", () =>
        saveColorSetting("cursor", rgbToHex(inventoryCursorR.value, inventoryCursorG.value, inventoryCursorB.value)),
    );
}

if (inventoryTrailR && inventoryTrailG && inventoryTrailB) {
    inventoryTrailR.addEventListener("input", () =>
        saveColorSetting("trail", rgbToHex(inventoryTrailR.value, inventoryTrailG.value, inventoryTrailB.value)),
    );
    inventoryTrailG.addEventListener("input", () =>
        saveColorSetting("trail", rgbToHex(inventoryTrailR.value, inventoryTrailG.value, inventoryTrailB.value)),
    );
    inventoryTrailB.addEventListener("input", () =>
        saveColorSetting("trail", rgbToHex(inventoryTrailR.value, inventoryTrailG.value, inventoryTrailB.value)),
    );
}

buttonsR.addEventListener("input", () => saveColorSetting("buttons", rgbToHex(buttonsR.value, buttonsG.value, buttonsB.value)));
buttonsG.addEventListener("input", () => saveColorSetting("buttons", rgbToHex(buttonsR.value, buttonsG.value, buttonsB.value)));
buttonsB.addEventListener("input", () => saveColorSetting("buttons", rgbToHex(buttonsR.value, buttonsG.value, buttonsB.value)));

textR.addEventListener("input", () => saveColorSetting("text", rgbToHex(textR.value, textG.value, textB.value)));
textG.addEventListener("input", () => saveColorSetting("text", rgbToHex(textR.value, textG.value, textB.value)));
textB.addEventListener("input", () => saveColorSetting("text", rgbToHex(textR.value, textG.value, textB.value)));

menuBackgroundR.addEventListener("input", () => saveColorSetting("menuBackground", rgbToHex(menuBackgroundR.value, menuBackgroundG.value, menuBackgroundB.value)));
menuBackgroundG.addEventListener("input", () => saveColorSetting("menuBackground", rgbToHex(menuBackgroundR.value, menuBackgroundG.value, menuBackgroundB.value)));
menuBackgroundB.addEventListener("input", () => saveColorSetting("menuBackground", rgbToHex(menuBackgroundR.value, menuBackgroundG.value, menuBackgroundB.value)));

gameBackgroundR.addEventListener("input", () => saveColorSetting("gameBackground", rgbToHex(gameBackgroundR.value, gameBackgroundG.value, gameBackgroundB.value)));
gameBackgroundG.addEventListener("input", () => saveColorSetting("gameBackground", rgbToHex(gameBackgroundR.value, gameBackgroundG.value, gameBackgroundB.value)));
gameBackgroundB.addEventListener("input", () => saveColorSetting("gameBackground", rgbToHex(gameBackgroundR.value, gameBackgroundG.value, gameBackgroundB.value)));

if (menuBackgroundBright) {
    menuBackgroundBright.addEventListener("input", () => saveMenuBackgroundBright(menuBackgroundBright.value));
}
if (gameBackgroundBright) {
    gameBackgroundBright.addEventListener("input", () => saveGameBackgroundBright(gameBackgroundBright.value));
}

wasdSensitivity.addEventListener("input", () => saveWASDSensitivity(wasdSensitivity.value));
menuMusicVolume.addEventListener("input", () => saveMusicVolume(menuMusicVolume.value));
gameMusicVolume.addEventListener("input", () => saveGameMusicVolume(gameMusicVolume.value));
bounceVolume.addEventListener("input", () => saveBounceVolume(bounceVolume.value));
if (pickupVolume) pickupVolume.addEventListener("input", () => savePickupVolume(pickupVolume.value));
if (gameSfxVolume) gameSfxVolume.addEventListener("input", () => saveGameSfxVolume(gameSfxVolume.value));
if (darknessVolume) darknessVolume.addEventListener("input", () => saveDarknessVolume(darknessVolume.value));
if (uiVolume) uiVolume.addEventListener("input", () => saveUiVolume(uiVolume.value));
if (fpsLimit) fpsLimit.addEventListener("input", () => saveFpsLimitFromSlider());

bindSettingsSliderValueInput(wasdSensitivity, wasdSensitivityVal, saveWASDSensitivity);
if (touchJoystickSensitivity) {
    bindSettingsSliderValueInput(touchJoystickSensitivity, touchJoystickSensitivityVal, saveTouchJoystickSensitivity);
}
if (menuBackgroundBright) {
    bindSettingsSliderValueInput(menuBackgroundBright, menuBackgroundBrightVal, saveMenuBackgroundBright);
}
if (gameBackgroundBright) {
    bindSettingsSliderValueInput(gameBackgroundBright, gameBackgroundBrightVal, saveGameBackgroundBright);
}
bindSettingsSliderValueInput(menuMusicVolume, menuMusicVolumeVal, saveMusicVolume);
bindSettingsSliderValueInput(gameMusicVolume, gameMusicVolumeVal, saveGameMusicVolume);
bindSettingsSliderValueInput(bounceVolume, bounceVolumeVal, saveBounceVolume);
if (pickupVolume) bindSettingsSliderValueInput(pickupVolume, pickupVolumeVal, savePickupVolume);
if (gameSfxVolume) bindSettingsSliderValueInput(gameSfxVolume, gameSfxVolumeVal, saveGameSfxVolume);
if (darknessVolume) bindSettingsSliderValueInput(darknessVolume, darknessVolumeVal, saveDarknessVolume);
if (uiVolume) bindSettingsSliderValueInput(uiVolume, uiVolumeVal, saveUiVolume);
if (fpsLimit && fpsLimitVal) {
    fpsLimitVal.setAttribute("autocomplete", "off");
    fpsLimitVal.addEventListener("focus", () => {
        fpsLimitVal.select();
    });
    fpsLimitVal.addEventListener("input", () => {
        settingsSliderValDrafts.set(fpsLimitVal, fpsLimitVal.value);
    });
    fpsLimitVal.addEventListener("keydown", e => {
        if (e.key === "Enter") {
            e.preventDefault();
            fpsLimitVal.blur();
        }
    });
    fpsLimitVal.addEventListener("blur", () => {
        if (!settingsSliderValDrafts.has(fpsLimitVal)) return;
        const draft = settingsSliderValDrafts.get(fpsLimitVal);
        settingsSliderValDrafts.delete(fpsLimitVal);
        const trimmed = String(draft ?? "").trim();
        if (trimmed === "") {
            refreshSettingsUI();
            return;
        }
        saveFpsLimitFromTyped(trimmed);
    });
}

bindColorChannelValueInput(ballsR, ballsRVal, ballsR, ballsG, ballsB, "balls");
bindColorChannelValueInput(ballsG, ballsGVal, ballsR, ballsG, ballsB, "balls");
bindColorChannelValueInput(ballsB, ballsBVal, ballsR, ballsG, ballsB, "balls");
bindColorChannelValueInput(cursorR, cursorRVal, cursorR, cursorG, cursorB, "cursor");
bindColorChannelValueInput(cursorG, cursorGVal, cursorR, cursorG, cursorB, "cursor");
bindColorChannelValueInput(cursorB, cursorBVal, cursorR, cursorG, cursorB, "cursor");
bindColorChannelValueInput(inventoryCursorR, inventoryCursorRVal, inventoryCursorR, inventoryCursorG, inventoryCursorB, "cursor");
bindColorChannelValueInput(inventoryCursorG, inventoryCursorGVal, inventoryCursorR, inventoryCursorG, inventoryCursorB, "cursor");
bindColorChannelValueInput(inventoryCursorB, inventoryCursorBVal, inventoryCursorR, inventoryCursorG, inventoryCursorB, "cursor");
bindColorChannelValueInput(inventoryTrailR, inventoryTrailRVal, inventoryTrailR, inventoryTrailG, inventoryTrailB, "trail");
bindColorChannelValueInput(inventoryTrailG, inventoryTrailGVal, inventoryTrailR, inventoryTrailG, inventoryTrailB, "trail");
bindColorChannelValueInput(inventoryTrailB, inventoryTrailBVal, inventoryTrailR, inventoryTrailG, inventoryTrailB, "trail");
bindColorChannelValueInput(buttonsR, buttonsRVal, buttonsR, buttonsG, buttonsB, "buttons");
bindColorChannelValueInput(buttonsG, buttonsGVal, buttonsR, buttonsG, buttonsB, "buttons");
bindColorChannelValueInput(buttonsB, buttonsBVal, buttonsR, buttonsG, buttonsB, "buttons");
bindColorChannelValueInput(textR, textRVal, textR, textG, textB, "text");
bindColorChannelValueInput(textG, textGVal, textR, textG, textB, "text");
bindColorChannelValueInput(textB, textBVal, textR, textG, textB, "text");
bindColorChannelValueInput(trailR, trailRVal, trailR, trailG, trailB, "trail");
bindColorChannelValueInput(trailG, trailGVal, trailR, trailG, trailB, "trail");
bindColorChannelValueInput(trailB, trailBVal, trailR, trailG, trailB, "trail");
bindColorChannelValueInput(menuBackgroundR, menuBackgroundRVal, menuBackgroundR, menuBackgroundG, menuBackgroundB, "menuBackground");
bindColorChannelValueInput(menuBackgroundG, menuBackgroundGVal, menuBackgroundR, menuBackgroundG, menuBackgroundB, "menuBackground");
bindColorChannelValueInput(menuBackgroundB, menuBackgroundBVal, menuBackgroundR, menuBackgroundG, menuBackgroundB, "menuBackground");
bindColorChannelValueInput(gameBackgroundR, gameBackgroundRVal, gameBackgroundR, gameBackgroundG, gameBackgroundB, "gameBackground");
bindColorChannelValueInput(gameBackgroundG, gameBackgroundGVal, gameBackgroundR, gameBackgroundG, gameBackgroundB, "gameBackground");
bindColorChannelValueInput(gameBackgroundB, gameBackgroundBVal, gameBackgroundR, gameBackgroundG, gameBackgroundB, "gameBackground");

if (menuSongPickBtn) {
    menuSongPickBtn.addEventListener("click", () => {
        void resumeAudioFromUserGesture().then(() => cycleMenuSong());
    });
}
if (gameSongPickBtn) {
    gameSongPickBtn.addEventListener("click", () => {
        void resumeAudioFromUserGesture().then(() => cycleGameSong());
    });
}

function updateSandboxToggleButtons() {
    syncSandboxCustomizeButtons(sandboxConfigAsV2(sandboxConfig));
}

function formatSandboxBoost(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return "OFF";
    return `x${n.toFixed(1)}`;
}

function getSandboxDefaultValue(field) {
    return SANDBOX_DEFAULTS[field];
}

function setSandboxMpHostOnly(isHost: boolean) {
    const container = document.getElementById("sandboxContainer");
    const skipIds = new Set(["mpSandboxContinueBtn", "mpSandboxConfigBackBtn"]);
    if (container) {
        container.querySelectorAll("input, button").forEach((el) => {
            const id = (el as HTMLElement).id;
            if (skipIds.has(id)) return;
            if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
                el.disabled = !isHost;
            }
        });
        container.classList.toggle("sandboxMpReadOnly", !isHost);
    }
    for (const id of ["sandboxLoadBtn", "sandboxSaveBtn", "sandboxResetBtn", "sandboxSpeedrunCustomizeBtn", "sandboxPenaltyCustomizeBtn"]) {
        const btn = document.getElementById(id);
        if (btn instanceof HTMLButtonElement) btn.disabled = !isHost;
    }
}

function refreshSandboxUI() {
    const v2 = sandboxConfigAsV2(sandboxConfig);
    rebuildSandboxConfigForm(v2, {
        onChange: () => {
            sandboxConfig = sandboxRuntimeFlat(readSandboxConfigFromForm(sandboxConfigAsV2(sandboxConfig)));
            saveSandboxDraft();
            syncSandboxCustomizeButtons(sandboxConfigAsV2(sandboxConfig));
        },
    });
    syncSandboxCustomizeButtons(v2);
}

function syncSandboxConfigFromUI() {
    const v2 = sandboxConfigAsV2(sandboxConfig);
    sandboxConfig = sandboxRuntimeFlat(readSandboxConfigFromForm(v2));
    saveSandboxDraft();
}

function toggleSandboxSetting() {
    /* toggles handled inside dynamic form */
    syncSandboxConfigFromUI();
    refreshSandboxUI();
}

function destroySandboxSpeedrunEditorIfAny() {
    if (sandboxSpeedrunEditorApi) {
        sandboxSpeedrunEditorApi.destroy();
        sandboxSpeedrunEditorApi = null;
    }
}

function destroySandboxPenaltyEditorIfAny() {
    if (sandboxPenaltyEditorApi) {
        sandboxPenaltyEditorApi.destroy();
        sandboxPenaltyEditorApi = null;
    }
}

function openSandboxSpeedrunPreview() {
    syncSandboxConfigFromUI();
    hideEl(sandboxScreen);
    showEl(sandboxSpeedrunPreviewScreen);
    showEl(returnBtn);
    const mount = document.getElementById("sandboxSpeedrunEditorMount");
    destroySandboxSpeedrunEditorIfAny();
    if (mount) {
        sandboxSpeedrunEditorApi = mountAdminSpeedrunEditor(mount, {
            onLevelsChanged: () => {},
            variant: "sandbox",
        });
        const initialDef = normalizeSandboxSpeedrunLayout(JSON.parse(JSON.stringify(sandboxConfig.speedrunLayout)));
        sandboxSpeedrunEditorApi.loadLevel(initialDef);
        sandboxSpeedrunEditorApi.refitCanvas();
    }
    updateMusicState();
}

function closeSandboxSpeedrunPreview(saveLayout) {
    if (saveLayout && sandboxSpeedrunEditorApi) {
        const def = sandboxSpeedrunEditorApi.getDef();
        sandboxConfig = normalizeSandboxConfig({
            ...sandboxConfig,
            speedrunLayout: def,
            baseMode: "speedrun",
        });
        saveSandboxDraft();
        refreshSandboxUI();
    }
    destroySandboxSpeedrunEditorIfAny();
    hideEl(sandboxSpeedrunPreviewScreen);
    showEl(sandboxScreen);
    showEl(returnBtn);
    updateMusicState();
}

function openSandboxPenaltyPreview() {
    syncSandboxConfigFromUI();
    hideEl(sandboxScreen);
    showEl(sandboxPenaltyPreviewScreen);
    showEl(returnBtn);
    const mount = document.getElementById("sandboxPenaltyEditorMount");
    destroySandboxPenaltyEditorIfAny();
    if (mount) {
        sandboxPenaltyEditorApi = mountAdminPenaltyEditor(mount, {
            onLevelsChanged: () => {},
            variant: "sandbox",
        });
        const initialDef = normalizePenaltyLevelData(
            JSON.parse(JSON.stringify(sandboxConfig.penaltyLayout || {})),
        );
        sandboxPenaltyEditorApi.loadLevel(initialDef);
        sandboxPenaltyEditorApi.refitCanvas();
    }
    updateMusicState();
}

function closeSandboxPenaltyPreview(saveLayout) {
    if (saveLayout && sandboxPenaltyEditorApi) {
        const def = sandboxPenaltyEditorApi.getDef();
        sandboxConfig = normalizeSandboxConfig({
            ...sandboxConfig,
            penaltyLayout: def,
            baseMode: "penalty",
        });
        saveSandboxDraft();
        refreshSandboxUI();
    }
    destroySandboxPenaltyEditorIfAny();
    hideEl(sandboxPenaltyPreviewScreen);
    showEl(sandboxScreen);
    showEl(returnBtn);
    updateMusicState();
}

if (sandboxSpeedrunCustomizeBtn) {
    sandboxSpeedrunCustomizeBtn.onclick = () => openSandboxSpeedrunPreview();
}
if (sandboxSpeedrunPreviewDoneBtn) {
    sandboxSpeedrunPreviewDoneBtn.onclick = () => closeSandboxSpeedrunPreview(true);
}
if (sandboxSpeedrunPreviewCancelBtn) {
    sandboxSpeedrunPreviewCancelBtn.onclick = () => closeSandboxSpeedrunPreview(false);
}
if (sandboxPenaltyCustomizeBtn) {
    sandboxPenaltyCustomizeBtn.onclick = () => openSandboxPenaltyPreview();
}
if (sandboxPenaltyPreviewDoneBtn) {
    sandboxPenaltyPreviewDoneBtn.onclick = () => closeSandboxPenaltyPreview(true);
}
if (sandboxPenaltyPreviewCancelBtn) {
    sandboxPenaltyPreviewCancelBtn.onclick = () => closeSandboxPenaltyPreview(false);
}

function syncSandboxSavePublicUi() {
    if (sandboxSavePublicCheck) sandboxSavePublicCheck.checked = sandboxSaveIsPublicPref;
}

function openSandboxSaveCard() {
    hideEl(sandboxLoadCard);
    showEl(sandboxSaveCard);
    sandboxPresetName.value = "";
    sandboxSaveIsPublicPref = getBoolSetting(SANDBOX_SAVE_IS_PUBLIC_KEY, false);
    syncSandboxSavePublicUi();
    sandboxPresetName.focus();
}

function openSandboxLoadCard() {
    hideEl(sandboxSaveCard);
    if (sandboxPresetInfoCard) hideEl(sandboxPresetInfoCard);
    showEl(sandboxLoadCard);
    void refreshSandboxLoadList();
}

function closeSandboxCards() {
    hideEl(sandboxSaveCard);
    hideEl(sandboxLoadCard);
    if (sandboxPresetInfoCard) hideEl(sandboxPresetInfoCard);
}

sandboxSaveBtn.onclick = openSandboxSaveCard;
sandboxLoadBtn.onclick = openSandboxLoadCard;
document.getElementById("sandboxResetBtn")?.addEventListener("click", () => {
    syncSandboxConfigFromUI();
    const base = sandboxConfigAsV2(sandboxConfig).baseMode || "normal";
    sandboxConfig = sandboxRuntimeFlat(defaultSandboxConfigV2(base));
    sandboxActivePlayContext = { localName: null, cloudPresetId: null };
    saveSandboxDraft();
    refreshSandboxUI();
});
sandboxPlayBtn.onclick = (e) => {
    const origin = { x: e.clientX, y: e.clientY };
    if (isPlayTransitionEnabled()) runPlayTransition(() => startSandboxGame(), { origin });
    else startSandboxGame();
};
cancelSandboxSaveBtn.onclick = () => hideEl(sandboxSaveCard);
closeSandboxLoadBtn.onclick = () => hideEl(sandboxLoadCard);
if (closeSandboxPresetInfoBtn && sandboxPresetInfoCard) {
    closeSandboxPresetInfoBtn.onclick = () => hideEl(sandboxPresetInfoCard);
}

function sandboxPresetOptionsInnerHTML(cfg) {
    const flat = normalizeSandboxConfig(cfg);
    const v2 = sandboxConfigAsV2(flat);
    const c = flat;
    const base = v2.baseMode ? (SANDBOX_BASE_MODE_TITLES[v2.baseMode] || v2.baseMode) : "Normal";
    return (
        `Base mode: <strong>${base}</strong><br>` +
        `Balls Size: ${c.ballsSize} | Balls Speed: ${Number(c.ballsSpeed).toFixed(1)}<br>` +
        `Initial: ${c.initialBalls ?? "—"} | Balls/Spawn: ${c.ballsPerSpawn} | Points/Spawn: ${c.pointsPerSpawn}<br>` +
        `Cursor Speed: ${c.cursorSpeed} | Cursor Size: ${c.cursorSize} | Smooth: ${c.smoothCursor || "OFF"}<br>` +
        `Collisions: ${c.ballCollisionsEnabled ? "ON" : "OFF"} | Bounce: ${formatSandboxBoost(c.bounceSpeedBoost)}<br>` +
        `WASD: ${c.wasdEnabled ? "ON" : "OFF"} | Progression: ${c.progressionEnabled ? "ON" : "OFF"}<br>` +
        `Magnet: ${c.magnetEnabled ? "ON" : "OFF"} | Spawn Clearance: ${c.spawnClearance ?? 44}`
    );
}

function cloudAccountDisplayName() {
    if (!cloudUser) return null;
    const dn = cloudUser.displayName != null ? String(cloudUser.displayName).trim() : "";
    if (dn) return dn;
    const em = cloudUser.email != null ? String(cloudUser.email).trim() : "";
    if (em) return em;
    const id = cloudUser.id != null ? String(cloudUser.id).trim() : "";
    return id || null;
}

function fillSandboxPresetListMeta(meta, presetTitle, byCreator, topOneLine) {
    meta.replaceChildren();
    const title = document.createElement("strong");
    title.className = "sandboxPresetListTitle";
    title.textContent = presetTitle;
    meta.appendChild(title);
    const by = document.createElement("span");
    by.className = "sandboxPresetListBy";
    by.textContent = `By ${byCreator}`;
    meta.appendChild(by);
    const top = document.createElement("span");
    top.className = "sandboxPresetListTop";
    top.textContent = topOneLine;
    meta.appendChild(top);
}

function sandboxPresetTopOneSummaryLine(config, cloudPresetId, topOneMap) {
    const c = normalizeSandboxConfig(config);
    if (!c.speedrunMode) return "Top 1: —";
    if (!cloudPresetId) return "Top 1: —";
    const holder = topOneMap && topOneMap.get ? topOneMap.get(cloudPresetId) : null;
    if (holder) return `Top 1: ${holder}`;
    return "Top 1: —";
}

async function prefetchSandboxSpeedrunTopOneNames(presetIds) {
    const map = new Map();
    const ids = [...new Set((presetIds || []).filter(Boolean))];
    await Promise.all(
        ids.map(async id => {
            try {
                const r = await fetch(
                    apiPath(
                        `/api/leaderboard?mode=sandbox_speedrun&presetId=${encodeURIComponent(id)}&limit=1`,
                    ),
                    { credentials: "include" },
                );
                const d = await r.json();
                const it = (d.items || [])[0];
                map.set(id, it && it.displayName ? String(it.displayName) : null);
            } catch {
                map.set(id, null);
            }
        }),
    );
    return map;
}

async function openSandboxPresetInfo(opts) {
    const { name, badge, config, cloudPresetId, presetForBest } = opts;
    if (!sandboxPresetInfoCard || !sandboxPresetInfoBody || !sandboxPresetInfoRank) return;
    const c = normalizeSandboxConfig(config);
    hideEl(sandboxSaveCard);

    sandboxPresetInfoBody.replaceChildren();
    const head = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = name;
    head.appendChild(strong);
    const badgeSpan = document.createElement("span");
    badgeSpan.className = "accessHint";
    badgeSpan.textContent = ` (${badge})`;
    head.appendChild(badgeSpan);
    sandboxPresetInfoBody.appendChild(head);
    const detail = document.createElement("div");
    detail.className = "accessHint";
    detail.style.marginTop = "8px";
    detail.textContent = "Saved options:";
    sandboxPresetInfoBody.appendChild(detail);
    const optsBox = document.createElement("div");
    optsBox.innerHTML = sandboxPresetOptionsInnerHTML(c);
    sandboxPresetInfoBody.appendChild(optsBox);

    sandboxPresetInfoRank.replaceChildren();
    const recTitle = document.createElement("h3");
    recTitle.style.marginTop = "12px";
    recTitle.style.fontSize = "1rem";
    recTitle.textContent = "Records & ranking";
    sandboxPresetInfoRank.appendChild(recTitle);

    const pb = presetForBest || { name, config, cloudPresetId };
    const yourP = document.createElement("p");
    yourP.className = "accessHint";
    if (c.speedrunMode) {
        const bestMs = getSandboxSpeedrunBestMsForPreset(pb);
        yourP.textContent =
            (cloudUser ? "Your best time: " : "Your best time (local): ") +
            (bestMs > 0 ? formatSpeedrunTime(bestMs) : "—");
    } else {
        const best = getSandboxPresetRecord(pb);
        const label = c.progressionEnabled ? "level" : "score";
        yourP.textContent =
            (cloudUser ? `Your best ${label}: ` : `Your best ${label} (local): `) + String(best);
    }
    sandboxPresetInfoRank.appendChild(yourP);

    if (cloudPresetId) {
        const rankHint = document.createElement("p");
        rankHint.className = "accessHint";
        rankHint.textContent = c.speedrunMode
            ? "Leaderboard (lower time wins):"
            : "Leaderboard (higher score wins):";
        sandboxPresetInfoRank.appendChild(rankHint);
        try {
            const mode = c.speedrunMode ? "sandbox_speedrun" : "sandbox";
            const r = await fetch(
                apiPath(
                    `/api/leaderboard?mode=${encodeURIComponent(mode)}&presetId=${encodeURIComponent(cloudPresetId)}&limit=15`,
                ),
                { credentials: "include" },
            );
            const d = await r.json();
            const items = d.items || [];
            if (!items.length) {
                const empty = document.createElement("p");
                empty.className = "accessHint";
                empty.textContent = "No cloud records for this preset yet.";
                sandboxPresetInfoRank.appendChild(empty);
            } else {
                const ol = document.createElement("ol");
                ol.style.marginTop = "6px";
                for (const it of items) {
                    const li = document.createElement("li");
                    const val = c.speedrunMode
                        ? formatSpeedrunTime(Number(it.value) || 0)
                        : String(it.value);
                    li.textContent = `${it.rank}. ${it.displayName || "?"} — ${val}`;
                    ol.appendChild(li);
                }
                sandboxPresetInfoRank.appendChild(ol);
            }
        } catch {
            const err = document.createElement("p");
            err.className = "accessHint";
            err.textContent = "Could not load the leaderboard.";
            sandboxPresetInfoRank.appendChild(err);
        }
    } else {
        const onlyLocal = document.createElement("p");
        onlyLocal.className = "accessHint";
        onlyLocal.textContent =
            "To see the global leaderboard, publish or save the preset to the cloud (sign in) and link the preset id.";
        sandboxPresetInfoRank.appendChild(onlyLocal);
    }

    showEl(sandboxPresetInfoCard);
}

function appendSandboxInfoButton(btnRow, infoOpts) {
    const infoBtn = document.createElement("button");
    infoBtn.type = "button";
    infoBtn.className = "btn";
    infoBtn.textContent = "Info.";
    infoBtn.onclick = () => void openSandboxPresetInfo(infoOpts);
    btnRow.appendChild(infoBtn);
}

function loadSandboxPresetConfigIntoEditor(config, playCtx) {
    if (playCtx === undefined) {
        sandboxActivePlayContext = { localName: null, cloudPresetId: null };
    } else {
        sandboxActivePlayContext = {
            localName: playCtx && playCtx.localName != null ? playCtx.localName : null,
            cloudPresetId: playCtx && playCtx.cloudPresetId != null ? playCtx.cloudPresetId : null,
        };
    }
    sandboxConfig = normalizeSandboxConfig(config);
    saveSandboxDraft();
    refreshSandboxUI();
    hideEl(sandboxLoadCard);
    if (sandboxPresetInfoCard) hideEl(sandboxPresetInfoCard);
    showEl(sandboxScreen);
}

function appendSandboxLocalRow(preset, topOneMap, byCreator) {
    const { name, config, cloudPresetId } = preset;
    const row = document.createElement("div");
    row.className = "sandboxPresetItem";
    const meta = document.createElement("div");
    meta.className = "sandboxPresetMeta";
    const topLine = sandboxPresetTopOneSummaryLine(config, cloudPresetId || null, topOneMap);
    fillSandboxPresetListMeta(meta, name, byCreator || "Local", topLine);
    const btnRow = document.createElement("div");
    btnRow.className = "sandboxRowBtns";
    const loadBtn = document.createElement("button");
    loadBtn.type = "button";
    loadBtn.className = "btn green";
    loadBtn.textContent = "Load";
    loadBtn.onclick = () =>
        loadSandboxPresetConfigIntoEditor(config, {
            localName: name,
            cloudPresetId: cloudPresetId || null,
        });
    const del = document.createElement("button");
    del.type = "button";
    del.className = "btn";
    del.textContent = "Delete";
    del.onclick = () => {
        const presets = loadSandboxPresets().filter((p) => p.name.toLowerCase() !== name.toLowerCase());
        saveSandboxPresets(presets);
        void refreshSandboxLoadList();
    };
    btnRow.appendChild(loadBtn);
    appendSandboxInfoButton(btnRow, {
        name,
        badge: "device",
        config,
        cloudPresetId: cloudPresetId || null,
        presetForBest: preset,
    });
    btnRow.appendChild(del);
    if (cloudUser) {
        const publishBtn = document.createElement("button");
        publishBtn.type = "button";
        publishBtn.className = "btn";
        publishBtn.textContent = "Publish";
        publishBtn.onclick = async () => {
            try {
                const r = await fetch(apiPath("/api/sandbox-presets"), {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        name,
                        config: normalizeSandboxConfig(config),
                        isPublic: true,
                    }),
                });
                if (r.ok) {
                    const d = await r.json().catch(() => ({}));
                    const pid = d.preset && d.preset.id;
                    if (pid) {
                        const cur = loadSandboxPresets();
                        const ix = cur.findIndex((p) => p.name.toLowerCase() === name.toLowerCase());
                        if (ix >= 0) {
                            cur[ix].cloudPresetId = pid;
                            saveSandboxPresets(cur);
                        }
                    }
                }
            } catch {
                /* ignore */
            }
            void refreshSandboxLoadList();
        };
        btnRow.appendChild(publishBtn);
    }
    row.appendChild(meta);
    row.appendChild(btnRow);
    sandboxLoadList.appendChild(row);
}

function appendSandboxCloudOwnedRow(p, topOneMap, byCreator) {
    const row = document.createElement("div");
    row.className = "sandboxPresetItem";
    const meta = document.createElement("div");
    meta.className = "sandboxPresetMeta";
    const badge = p.isPublic ? "cloud · public" : "cloud · private";
    const topLine = sandboxPresetTopOneSummaryLine(p.config, p.id, topOneMap);
    fillSandboxPresetListMeta(meta, p.name, byCreator || "?", topLine);
    const btnRow = document.createElement("div");
    btnRow.className = "sandboxRowBtns";
    const loadBtn = document.createElement("button");
    loadBtn.type = "button";
    loadBtn.className = "btn green";
    loadBtn.textContent = "Load";
    loadBtn.onclick = () =>
        loadSandboxPresetConfigIntoEditor(p.config, { localName: null, cloudPresetId: p.id });
    btnRow.appendChild(loadBtn);
    appendSandboxInfoButton(btnRow, {
        name: p.name,
        badge,
        config: p.config,
        cloudPresetId: p.id,
        presetForBest: { ...p, cloudPresetId: p.id },
    });
    if (p.isPublic) {
        const priv = document.createElement("button");
        priv.type = "button";
        priv.className = "btn";
        priv.textContent = "Make private";
        priv.onclick = async () => {
            try {
                await fetch(`${apiPath("/api/sandbox-presets")}?${new URLSearchParams({ id: p.id })}`, {
                    method: "PATCH",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ isPublic: false }),
                });
            } catch {
                /* ignore */
            }
            void refreshSandboxLoadList();
        };
        btnRow.appendChild(priv);
    } else {
        const pub = document.createElement("button");
        pub.type = "button";
        pub.className = "btn";
        pub.textContent = "Publish";
        pub.onclick = async () => {
            try {
                await fetch(`${apiPath("/api/sandbox-presets")}?${new URLSearchParams({ id: p.id })}`, {
                    method: "PATCH",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ isPublic: true }),
                });
            } catch {
                /* ignore */
            }
            void refreshSandboxLoadList();
        };
        btnRow.appendChild(pub);
    }
    const delCloud = document.createElement("button");
    delCloud.type = "button";
    delCloud.className = "btn";
    delCloud.textContent = "Delete";
    delCloud.onclick = async () => {
        if (!confirm("Delete this preset from the cloud?")) return;
        try {
            await fetch(`${apiPath("/api/sandbox-presets")}?${new URLSearchParams({ id: p.id })}`, {
                method: "DELETE",
                credentials: "include",
            });
        } catch {
            /* ignore */
        }
        const cur = loadSandboxPresets();
        let changed = false;
        for (const pr of cur) {
            if (pr.cloudPresetId === p.id) {
                delete pr.cloudPresetId;
                changed = true;
            }
        }
        if (changed) saveSandboxPresets(cur);
        void refreshSandboxLoadList();
    };
    btnRow.appendChild(delCloud);
    row.appendChild(meta);
    row.appendChild(btnRow);
    sandboxLoadList.appendChild(row);
}

function appendSandboxRemotePresetRow(p, creatorLabel, parentEl, topOneMap) {
    const parent = parentEl || sandboxLoadList;
    if (!parent) return;
    const row = document.createElement("div");
    row.className = "sandboxPresetItem sandboxRemoteFetched";
    const meta = document.createElement("div");
    meta.className = "sandboxPresetMeta";
    const topLine = sandboxPresetTopOneSummaryLine(p.config, p.id || null, topOneMap);
    fillSandboxPresetListMeta(meta, p.name, creatorLabel || "?", topLine);
    const btnRow = document.createElement("div");
    btnRow.className = "sandboxRowBtns";
    const loadBtn = document.createElement("button");
    loadBtn.type = "button";
    loadBtn.className = "btn green";
    loadBtn.textContent = "Load";
    loadBtn.onclick = () =>
        loadSandboxPresetConfigIntoEditor(p.config, { localName: null, cloudPresetId: p.id || null });
    btnRow.appendChild(loadBtn);
    appendSandboxInfoButton(btnRow, {
        name: p.name,
        badge: `remote · ${creatorLabel || "?"}`,
        config: p.config,
        cloudPresetId: p.id || null,
        presetForBest: { ...p, cloudPresetId: p.id },
    });
    row.appendChild(meta);
    row.appendChild(btnRow);
    parent.appendChild(row);
}

function appendSandboxSectionTitle(text, extraClass = "") {
    const h = document.createElement("div");
    h.className = "sandboxPresetItem" + (extraClass ? ` ${extraClass}` : "");
    const m = document.createElement("div");
    m.className = "sandboxPresetMeta";
    const em = document.createElement("em");
    em.textContent = text;
    m.appendChild(em);
    h.appendChild(m);
    sandboxLoadList.appendChild(h);
}

async function refreshSandboxLoadList() {
    if (!sandboxLoadList) return;
    if (cloudUser) {
        await Promise.all([refreshSandboxSpeedrunCloudBests(), refreshSandboxScoreCloudBests()]);
    }

    const local = loadSandboxPresets();
    let cloudList = [];
    let cloudPresetsFetchFailed = false;
    if (cloudUser) {
        try {
            const r = await fetch(apiPath("/api/sandbox-presets"), { credentials: "include" });
            const data = await r.json();
            cloudList = data.presets || [];
        } catch {
            cloudPresetsFetchFailed = true;
            cloudList = [];
        }
    }

    const topIds = [];
    for (const preset of local) {
        const c = normalizeSandboxConfig(preset.config);
        if (c.speedrunMode && preset.cloudPresetId) topIds.push(preset.cloudPresetId);
    }
    for (const p of cloudList) {
        const c = normalizeSandboxConfig(p.config);
        if (c.speedrunMode && p.id) topIds.push(p.id);
    }
    const topOneMap = await prefetchSandboxSpeedrunTopOneNames(topIds);
    const bySelf = cloudAccountDisplayName() || "Local";

    sandboxLoadList.innerHTML = "";
    const searchMount = document.createElement("div");
    searchMount.id = "sandboxSearchResultsMount";
    sandboxLoadList.appendChild(searchMount);

    appendSandboxSectionTitle("My device");
    if (!local.length) {
        const empty = document.createElement("div");
        empty.className = "sandboxPresetItem";
        empty.innerHTML = `<div class="sandboxPresetMeta">No local presets — Save to add a copy on this device.</div>`;
        sandboxLoadList.appendChild(empty);
    } else {
        for (const preset of local) appendSandboxLocalRow(preset, topOneMap, bySelf);
    }

    if (cloudUser) {
        appendSandboxSectionTitle("My cloud");
        const cloudBy = cloudAccountDisplayName() || "?";
        if (cloudPresetsFetchFailed) {
            const err = document.createElement("div");
            err.className = "sandboxPresetItem";
            err.innerHTML = `<div class="sandboxPresetMeta">Cloud list unavailable.</div>`;
            sandboxLoadList.appendChild(err);
        } else if (!cloudList.length) {
            const empty = document.createElement("div");
            empty.className = "sandboxPresetItem";
            empty.innerHTML = `<div class="sandboxPresetMeta">No cloud presets yet — Save with your account or use Publish on a device preset.</div>`;
            sandboxLoadList.appendChild(empty);
        } else {
            for (const p of cloudList) appendSandboxCloudOwnedRow(p, topOneMap, cloudBy);
        }
    } else {
        const sign = document.createElement("div");
        sign.className = "sandboxPresetItem";
        sign.innerHTML = `<div class="sandboxPresetMeta">Sign in to sync presets to the cloud, see My cloud, and global SpeedRun rankings per preset.</div>`;
        sandboxLoadList.appendChild(sign);
    }
}

async function saveCurrentSandboxPreset() {
    const name = sandboxPresetName.value.trim();
    if (!name) return;

    if (sandboxSavePublicCheck) sandboxSaveIsPublicPref = sandboxSavePublicCheck.checked;

    const presets = loadSandboxPresets();
    const existing = presets.findIndex(p => p.name.toLowerCase() === name.toLowerCase());
    const prevRow = existing >= 0 ? presets[existing] : null;
    const item = { name, config: normalizeSandboxConfig(sandboxConfig) };
    if (prevRow && prevRow.cloudPresetId) item.cloudPresetId = prevRow.cloudPresetId;
    if (prevRow && prevRow.lastSpeedrunMs) item.lastSpeedrunMs = prevRow.lastSpeedrunMs;

    if (existing >= 0) {
        presets[existing] = item;
    } else {
        presets.push(item);
    }

    saveSandboxPresets(presets);
    if (cloudUser) {
        try {
            const r = await fetch(apiPath("/api/sandbox-presets"), {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name: item.name, config: item.config, isPublic: sandboxSaveIsPublicPref }),
            });
            if (r.ok) {
                const d = await r.json().catch(() => ({}));
                const pid = d.preset && d.preset.id;
                if (pid) {
                    const cur = loadSandboxPresets();
                    const ix = cur.findIndex((p) => p.name.toLowerCase() === name.toLowerCase());
                    if (ix >= 0) {
                        cur[ix].cloudPresetId = pid;
                        saveSandboxPresets(cur);
                    }
                }
            }
        } catch {
            /* ignore */
        }
    }
    setBoolSetting(SANDBOX_SAVE_IS_PUBLIC_KEY, sandboxSaveIsPublicPref);
    hideEl(sandboxSaveCard);
    await refreshSandboxLoadList();
}

confirmSandboxSaveBtn.onclick = saveCurrentSandboxPreset;
if (sandboxSavePublicCheck) {
    sandboxSavePublicCheck.addEventListener("change", () => {
        sandboxSaveIsPublicPref = sandboxSavePublicCheck.checked;
        setBoolSetting(SANDBOX_SAVE_IS_PUBLIC_KEY, sandboxSaveIsPublicPref);
    });
}
sandboxPresetName.addEventListener("keydown", e => {
    if (e.key === "Enter") void saveCurrentSandboxPreset();
});

if (sandboxRemoteFetchBtn && sandboxRemoteUserId) {
    sandboxRemoteFetchBtn.onclick = async () => {
        const q = sandboxRemoteUserId.value.trim();
        const mount = document.getElementById("sandboxSearchResultsMount");
        if (!q || !mount) return;
        mount.innerHTML = "";
        const head = document.createElement("div");
        head.className = "sandboxPresetItem sandboxRemoteFetched";
        head.innerHTML = `<div class="sandboxPresetMeta"><em>Search results</em> · ${q}</div>`;
        mount.appendChild(head);
        try {
            const r = await fetch(apiPath(`/api/sandbox-presets?search=${encodeURIComponent(q)}`));
            const data = await r.json();
            const results = data.results || [];
            if (!results.length) {
                const empty = document.createElement("div");
                empty.className = "sandboxPresetItem sandboxRemoteFetched";
                empty.innerHTML = `<div class="sandboxPresetMeta">No players matched (try full user id or part of a username).</div>`;
                mount.appendChild(empty);
                return;
            }
            const remoteTopIds = [];
            for (const block of results) {
                for (const pr of block.presets || []) {
                    const c = normalizeSandboxConfig(pr.config);
                    if (c.speedrunMode && pr.id) remoteTopIds.push(pr.id);
                }
            }
            const remoteTopMap = await prefetchSandboxSpeedrunTopOneNames(remoteTopIds);
            for (const block of results) {
                const u = block.user;
                const presets = block.presets || [];
                const sub = document.createElement("div");
                sub.className = "sandboxPresetItem sandboxRemoteFetched";
                sub.innerHTML =
                    `<div class="sandboxPresetMeta"><strong>${u.displayName || "—"}</strong> <span class="accessHint">(${u.id})</span> · ${presets.length} shown</div>`;
                mount.appendChild(sub);
                if (!presets.length) {
                    const p = document.createElement("div");
                    p.className = "sandboxPresetItem sandboxRemoteFetched";
                    p.innerHTML = `<div class="sandboxPresetMeta">No public presets (or only private).</div>`;
                    mount.appendChild(p);
                } else {
                    const creator = u.displayName || u.id || "?";
                    for (const p of presets) {
                        appendSandboxRemotePresetRow(p, creator, mount, remoteTopMap);
                    }
                }
            }
        } catch {
            const err = document.createElement("div");
            err.className = "sandboxPresetItem sandboxRemoteFetched";
            err.innerHTML = `<div class="sandboxPresetMeta">Search failed.</div>`;
            mount.appendChild(err);
        }
    };
}

/** Pixels per frame toward cursor in Roulette (Magnet event only). */
const ROULETTE_MAGNET_STEP = 3.2;
/** Uniform spawn speed; bounce applies ROULETTE_BOUNCE_MULT per wall hit. */
const ROULETTE_BALL_BASE_SPEED = 0.22;
const ROULETTE_BOUNCE_MULT = 1.5;
const ROULETTE_SPAWN_EVERY_MS = 5000;
/** While `plus100` effect is active, periodic waves use this interval instead. */
const ROULETTE_SPAWN_EVERY_PLUS100_MS = 10000;
const ROULETTE_SPAWN_BATCH = 10;

/** Sandbox magnet when config is missing (should be rare); real sandbox uses `ballsSpeed` below. */
const SANDBOX_MAGNET_FALLBACK_STEP = 0.4;

function sandboxMagnetStepPx() {
    const ls = gameLayoutScale();
    let base = 0.8;
    if (isSandboxRunActive()) {
        base = sbNum("ballSpeed", sbCommonNum("ballsSpeed", 0.8));
    } else if (sandboxRuntimeConfig) {
        base = Number(sandboxRuntimeConfig.ballsSpeed) || 0.8;
    } else {
        return SANDBOX_MAGNET_FALLBACK_STEP * ls;
    }
    if (!Number.isFinite(base) || base <= 0) base = 0.8;
    // Roulette magnet uses ~3.2; scale with Balls Speed so the pull is clearly felt.
    const step = Math.max(ROULETTE_MAGNET_STEP * 0.85, base * 4) * ls;
    const w = canvas && canvas.width > 0 ? canvas.width : 800;
    const maxStep = Math.max(48, Math.min(320, w * 0.14)) * ls;
    return clamp(step, 0.2, maxStep);
}

function applyMagnetObstacleStep(o, speedPx) {
    const tx = mouse.x;
    const ty = mouse.y;
    let dx = tx - o.x;
    let dy = ty - o.y;
    const d = Math.hypot(dx, dy);
    if (d < 1e-6) return;
    dx /= d;
    dy /= d;
    const nx = o.x + dx * speedPx;
    const ny = o.y + dy * speedPx;
    if (isProgressionLaneActive()) {
        const b = progressionObstacleBounds();
        o.x = clamp(nx, b.minX + o.r, b.maxX - o.r);
        o.y = clamp(ny, b.minY + o.r, b.maxY - o.r);
    } else {
        o.x = clamp(nx, o.r, canvas.width - o.r);
        o.y = clamp(ny, o.r, canvas.height - o.r);
    }
}

class Obstacle {
    constructor(speed, radius = 14) {
        const w = canvas.width > 0 ? canvas.width : 800;
        const h = canvas.height > 0 ? canvas.height : 600;
        const spawnBounds = isProgressionLaneActive()
            ? progressionObstacleBounds()
            : { minX: 0, minY: 0, maxX: w, maxY: h };
        const minDist = getMinSpawnDistanceFromCursor(radius);
        const clearanceCenters = isLocalActive()
            ? localSpawnClearanceCenters()
            : gameMode === "delay"
              ? [getDelayRealCursorPos()]
              : [{ x: mouse.x, y: mouse.y }];
        const pad = Math.max(0, radius);
        const pos = pickSpawnOutsideClearance({
            minX: spawnBounds.minX + pad,
            maxX: spawnBounds.maxX - pad,
            minY: spawnBounds.minY + pad,
            maxY: spawnBounds.maxY - pad,
            centers: clearanceCenters,
            minDist,
            reject:
                gameMode === "mirror"
                    ? (nx, ny) => {
                          const mp = mirrorCursorPos(mouse.x, mouse.y, w, h);
                          return Math.hypot(nx - mp.x, ny - mp.y) < minDist;
                      }
                    : null,
        });
        this.x = pos.x;
        this.y = pos.y;
        this.vx = (gameRandom() * 2 - 1) * speed;
        this.vy = (gameRandom() * 2 - 1) * speed;
        this.r = radius;
        this.lastBounceFx = 0;
        this.colorRushIdx = null;
        this.counterNum = null;
        this.isAimGolden = false;
        this.isHookRed = false;
        this.isHunter = false;
        this.hunterBias = 0;
        this.hunterPatrolX = undefined;
        this.hunterPatrolY = undefined;
        this.hunterActive = false;
        this.popSize = POP_SIZE_LARGE;
        this.popSplitReadyAt = 0;
    }

    update(mult = 1) {
        this.x += this.vx * mult;
        this.y += this.vy * mult;

        let bounced = false;
        let minX = this.r;
        let maxX = canvas.width - this.r;
        let minY = this.r;
        let maxY = canvas.height - this.r;
        if (isProgressionLaneActive()) {
            const b = progressionObstacleBounds();
            minX = b.minX + this.r;
            maxX = b.maxX - this.r;
            minY = b.minY + this.r;
            maxY = b.maxY - this.r;
        }

        if (this.x < minX) {
            this.x = minX;
            this.vx *= -1;
            bounced = true;
        } else if (this.x > maxX) {
            this.x = maxX;
            this.vx *= -1;
            bounced = true;
        }

        if (this.y < minY) {
            this.y = minY;
            this.vy *= -1;
            bounced = true;
        } else if (this.y > maxY) {
            this.y = maxY;
            this.vy *= -1;
            bounced = true;
        }

        if (bounced) {
            if (dpadPositionCustomizeMode) {
                const sp = 1.2;
                const len = Math.hypot(this.vx, this.vy) || 1;
                this.vx = (this.vx / len) * sp;
                this.vy = (this.vy / len) * sp;
            } else {
            if (gameMode === "normal" || gameMode === "tilt" || gameMode === "mirror" || gameMode === "delay" || gameMode === "combo" || (gameMode === "hunter" && !this.isHunter) || gameMode === "counter" || gameMode === "aim" || gameMode === "hook") {
                const boost = sbBounceBoost(1.08);
                this.vx *= boost;
                this.vy *= boost;
            }

            if (gameMode === "pop") {
                enforcePopBallSpeed(this, gameLayoutScale());
            }

            if (gameMode === "roulette") {
                const bounce = sbNum("bounceMult", ROULETTE_BOUNCE_MULT);
                this.vx *= bounce;
                this.vy *= bounce;
            }

            if (gameMode === "sandbox" && sandboxRuntimeConfig) {
                const boost = Number(sandboxRuntimeConfig.bounceSpeedBoost) || 0;
                if (boost > 0) {
                    this.vx *= boost;
                    this.vy *= boost;
                }
            }

            if (performance.now() - this.lastBounceFx > 120) {
                this.lastBounceFx = performance.now();
                emitBurst(this.x, this.y, 3, [settingBallsColor, "#ffffff"], 0.9, 0, 0.9, 2.0, 10, 18);
                addShake(0.2);
            }

            playBounceSound(Math.abs(this.vx) + Math.abs(this.vy));
            }
        }
    }

    draw() {
        // Hunter red / Hook red keep dedicated threat art (no Theme tint).
        if (gameMode === "hunter" && this.isHunter) {
            ctx.save();
            if (isChallengeDeathSequence() || isMarathonDeathSequence()) ctx.globalAlpha = challengeDeathBallAlpha;
            drawHunterBall(ctx, this.x, this.y, this.r);
            ctx.restore();
            return;
        }
        if (gameMode === "hook" && this.isHookRed) {
            ctx.save();
            if (isChallengeDeathSequence() || isMarathonDeathSequence()) ctx.globalAlpha = challengeDeathBallAlpha;
            drawHunterBall(ctx, this.x, this.y, this.r);
            ctx.restore();
            return;
        }
        const rouletteScale = gameMode === "roulette" ? roulette.ballScale : 1;
        const ballDrawScale = rouletteScale;
        const rouletteAlpha =
            (gameMode === "roulette" ? roulette.ballAlpha : 1) *
            (isChallengeDeathSequence() || isMarathonDeathSequence() ? challengeDeathBallAlpha : 1);
        const white = gameMode === "roulette" && getGameSimNowMs() < roulette.whiteOverrideUntil;
        const colorRushHex =
            gameMode === "colorrush" && this.colorRushIdx != null
                ? getColorRushBallHex(this.colorRushIdx)
                : null;
        const counterTarget =
            gameMode === "counter" && this.counterNum != null && this.counterNum === getCounterNextExpected();
        const aimGolden = gameMode === "aim" && this.isAimGolden;
        const aimWaveFade = gameMode === "aim" ? getAimWaveFadeAlpha(getGameSimNowMs()) : 1;
        const comboDodged = gameMode === "combo" && isComboBallDodged(this);
        const comboDodgeAlpha = comboDodged ? 0.48 : 1;

        ctx.save();
        ctx.globalAlpha = rouletteAlpha * aimWaveFade * comboDodgeAlpha;
        // AIM: theme only on low-opacity distractors; golden stays gold.
        const ballPaint = gameplayBallsPaint({ isAimGolden: !!aimGolden });
        const useThemePaint = !!ballPaint.color && !colorRushHex && !white && !comboDodged;
        let baseCol = white
            ? "#ffffff"
            : colorRushHex || (useThemePaint ? ballPaint.color : null) || settingBallsColor;
        if (comboDodged) {
            // Same radius; muted cool tone marks an already-credited close dodge.
            baseCol = "#7a8494";
        } else if (gameMode === "counter" && this.counterNum != null) {
            baseCol = getCounterBallHex(this.counterNum);
            ctx.globalAlpha = rouletteAlpha * getCounterBallDrawAlpha(this.counterNum);
        } else if (aimGolden) {
            baseCol = AIM_GOLDEN_BALL_HEX;
            ctx.globalAlpha = rouletteAlpha * getAimBallDrawAlpha(true);
        } else if (gameMode === "aim") {
            ctx.globalAlpha = rouletteAlpha * getAimBallDrawAlpha(false);
        }
        const neonStrength =
            gameMode === "counter" && this.counterNum != null
                ? getCounterBallNeonStrength(this.counterNum)
                : gameMode === "aim"
                  ? getAimBallNeonStrength(!!aimGolden)
                  : comboDodged
                    ? 0.35
                    : 1;
        const drawR = this.r * ballDrawScale * (counterTarget || aimGolden ? 1.06 : 1);
        const fillBall = (radiusMul = 1) => {
            const rr = drawR * radiusMul;
            if (useThemePaint && ballPaint.gradientTo && !aimGolden && !(gameMode === "counter" && this.counterNum != null)) {
                const g = ctx.createLinearGradient(this.x - rr, this.y - rr, this.x + rr, this.y + rr);
                g.addColorStop(0, ballPaint.color);
                g.addColorStop(1, ballPaint.gradientTo);
                ctx.fillStyle = g;
            } else {
                ctx.fillStyle = white ? "#ffffff" : baseCol;
            }
            ctx.beginPath();
            ctx.arc(this.x, this.y, rr, 0, Math.PI * 2);
            ctx.fill();
        };
        const modeBallAlpha =
            gameMode === "counter" && this.counterNum != null
                ? getCounterBallDrawAlpha(this.counterNum)
                : gameMode === "aim"
                  ? getAimBallDrawAlpha(!!aimGolden)
                  : comboDodgeAlpha;
        if (!white && settingNeonBalls) {
            ctx.shadowColor = aimGolden ? AIM_GOLDEN_GLOW_HEX : baseCol;
            ctx.shadowBlur = Math.max(6, this.r * 0.9) * (counterTarget || aimGolden ? 1.65 : neonStrength);
            ctx.globalAlpha = rouletteAlpha * modeBallAlpha * 0.32 * neonStrength;
            ctx.fillStyle = aimGolden ? AIM_GOLDEN_GLOW_HEX : baseCol;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.r * ballDrawScale * (counterTarget || aimGolden ? 1.14 : 1.08), 0, Math.PI * 2);
            ctx.fill();
            ctx.shadowBlur = 0;
            ctx.globalAlpha = rouletteAlpha * modeBallAlpha;
        }
        fillBall(1);
        if (comboDodged) {
            // Hollow rim at the same radius — no size change, clear “spent” look.
            ctx.shadowBlur = 0;
            ctx.globalAlpha = rouletteAlpha * 0.7;
            ctx.strokeStyle = "rgba(200,214,230,0.55)";
            ctx.lineWidth = Math.max(1.2, this.r * 0.14);
            ctx.beginPath();
            ctx.arc(this.x, this.y, drawR, 0, Math.PI * 2);
            ctx.stroke();
            ctx.strokeStyle = "rgba(40,48,58,0.45)";
            ctx.lineWidth = Math.max(1, this.r * 0.08);
            ctx.beginPath();
            ctx.arc(this.x, this.y, drawR * 0.55, 0, Math.PI * 2);
            ctx.stroke();
        }
        if (gameMode === "counter" && this.counterNum != null) {
            drawCounterBallLabel(ctx, this.x, this.y, this.r * ballDrawScale, this.counterNum, getGameSimNowMs());
        }
        if (aimGolden) {
            const pulse = 1 + Math.sin(performance.now() * 0.014) * 0.06;
            ctx.strokeStyle = "rgba(255,255,255,0.75)";
            ctx.lineWidth = Math.max(1.5, this.r * 0.12 * pulse);
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.r * ballDrawScale * 1.18 * pulse, 0, Math.PI * 2);
            ctx.stroke();
        }
        ctx.restore();
    }

    hitAt(cx, cy) {
        const cursorHit = getCursorRadiusForMode();
        const ballR = this.collisionRadius();
        return Math.hypot(cx - this.x, cy - this.y) < ballR + cursorHit;
    }

    collisionRadius() {
        const rouletteScale = gameMode === "roulette" ? roulette.ballScale : 1;
        return this.r * rouletteScale;
    }

    hitAtSweep(x0, y0, x1, y1) {
        const cursorHit = getCursorRadiusForMode();
        return sweptCircleHitsCircle(x0, y0, x1, y1, cursorHit, this.x, this.y, this.collisionRadius());
    }

    hit() {
        return this.hitAtSweep(collisionPrevMouse.x, collisionPrevMouse.y, mouse.x, mouse.y);
    }
}

function syncBallCollisionPrevMouse() {
    collisionPrevMouse.x = mouse.x;
    collisionPrevMouse.y = mouse.y;
    if (gameMode === "delay") {
        const real = getDelayRealCursorPos();
        syncDelayRealPrev(real.x, real.y);
    }
}

function usesLocalBallCollisionSweep() {
    if (!playing || gamePaused || deathPending || resumeCountdownActive) return false;
    if (gameMode === "multiplayer" || isMultiplayerActive()) return false;
    if (gameMode === "highway" || gameMode === "speedrun") return false;
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) return false;
    return (
        gameMode === "normal" ||
        gameMode === "tilt" ||
        gameMode === "wasd" ||
        gameMode === "progression" ||
        gameMode === "roulette" ||
        gameMode === "sandbox" ||
        gameMode === "darkness" ||
        gameMode === "mirror" ||
        gameMode === "delay" ||
        gameMode === "snake" ||
        gameMode === "combo" ||
        gameMode === "superdot" ||
        gameMode === "colorrush" ||
        gameMode === "heat" ||
        gameMode === "hunter" ||
        gameMode === "pop" ||
        gameMode === "counter" ||
        gameMode === "hook" ||
        gameMode === "orbit"
    );
}

function getObstacleRadius() {
    const ls = gameLayoutScale();
    if (isSandboxRunActive() || (gameMode === "sandbox" && sandboxRuntimeConfig)) {
        const size = sandboxRuntimeConfig?.ballsSize ?? sbCommonNum("ballsSize", 14);
        return size * ls;
    }
    if (gameMode === "aim") return AIM_BALL_RADIUS_REF * ls;
    if (gameMode === "hook") return HOOK_BALL_RADIUS_REF * ls;
    return 14 * ls;
}

function getCursorRadiusForMode() {
    const ls = gameLayoutScale();
    let r = 5 * ls;
    if (gameMode === "roulette") r = 5 * ls * roulette.cursorScale;
    else if (isSandboxRunActive() || (gameMode === "sandbox" && sandboxRuntimeConfig)) {
        r = (sandboxRuntimeConfig?.cursorSize ?? sbCommonNum("cursorSize", 5)) * ls;
    } else if (gameMode === "multiplayer" && isMultiplayerActive() && getMpGameMode() === "sandbox" && sandboxRuntimeConfig) {
        r = sandboxRuntimeConfig.cursorSize * ls;
    }
    return Math.max(Math.ceil(CURSOR_HITBOX_MIN * ls), r);
}

function getMinSpawnDistanceFromCursor(ballRadiusPx) {
    const ls = gameLayoutScale();
    let extraRef = SPAWN_CLEARANCE_FROM_CURSOR_REF_PX;
    if (isSandboxRunActive()) {
        extraRef = sbCommonNum("spawnClearance", SPAWN_CLEARANCE_FROM_CURSOR_REF_PX);
    } else if (gameMode === "sandbox" && sandboxRuntimeConfig) {
        const n = Number(sandboxRuntimeConfig.spawnClearance);
        if (Number.isFinite(n)) extraRef = n;
    }
    const extra = Math.max(0, extraRef) * ls;
    return getCursorRadiusForMode() + ballRadiusPx + extra;
}

/**
 * Spawn outside clearance circles. Never falls back to a random point inside the
 * forbidden radius when any legal cell exists; if the arena is fully covered,
 * picks the point farthest from the nearest clearance center.
 */
function pickSpawnOutsideClearance({
    minX,
    maxX,
    minY,
    maxY,
    centers,
    minDist,
    randomTries = 220,
    reject = null,
}) {
    const loX = Math.min(minX, maxX);
    const hiX = Math.max(minX, maxX);
    const loY = Math.min(minY, maxY);
    const hiY = Math.max(minY, maxY);
    const spanX = Math.max(0, hiX - loX);
    const spanY = Math.max(0, hiY - loY);
    const list = centers && centers.length > 0 ? centers : [{ x: (loX + hiX) / 2, y: (loY + hiY) / 2 }];
    const need = Math.max(0, Number(minDist) || 0);

    const minClearDist = (x, y) => {
        let m = Infinity;
        for (const c of list) m = Math.min(m, Math.hypot(x - c.x, y - c.y));
        return m;
    };
    const passes = (x, y) => {
        if (x < loX || x > hiX || y < loY || y > hiY) return false;
        if (minClearDist(x, y) < need) return false;
        if (typeof reject === "function" && reject(x, y)) return false;
        return true;
    };

    if (spanX <= 0 || spanY <= 0) {
        return { x: (loX + hiX) / 2, y: (loY + hiY) / 2 };
    }

    // Always consume a fixed number of RNG samples so spawn clearance (which depends on
    // cursor position) cannot desynchronize the seeded stream between record and replay.
    let found = null;
    for (let i = 0; i < randomTries; i++) {
        const x = loX + gameRandom() * spanX;
        const y = loY + gameRandom() * spanY;
        if (!found && passes(x, y)) found = { x, y };
    }
    if (found) return found;

    /** @type {Array<[number, number]>} */
    const candidates = [
        [loX, loY],
        [hiX, loY],
        [loX, hiY],
        [hiX, hiY],
    ];
    const edgeN = 32;
    for (let i = 0; i <= edgeN; i++) {
        const t = i / edgeN;
        candidates.push([loX + t * spanX, loY], [loX + t * spanX, hiY], [loX, loY + t * spanY], [hiX, loY + t * spanY]);
    }
    for (const c of list) {
        for (let a = 0; a < 48; a++) {
            const ang = (a / 48) * Math.PI * 2;
            for (const mul of [1, 1.08, 1.2, 1.4, 1.75, 2.2]) {
                candidates.push([c.x + Math.cos(ang) * need * mul, c.y + Math.sin(ang) * need * mul]);
            }
        }
    }

    let bestOk = null;
    let bestOkScore = -1;
    let bestAny = { x: loX, y: loY };
    let bestAnyScore = -1;
    for (const [rx, ry] of candidates) {
        const x = clamp(rx, loX, hiX);
        const y = clamp(ry, loY, hiY);
        if (typeof reject === "function" && reject(x, y)) continue;
        const score = minClearDist(x, y);
        if (score > bestAnyScore) {
            bestAnyScore = score;
            bestAny = { x, y };
        }
        if (passes(x, y) && score > bestOkScore) {
            bestOkScore = score;
            bestOk = { x, y };
        }
    }
    return bestOk || bestAny;
}

function spawnObstacle(speed, radius = getObstacleRadius()) {
    obstacles.push(new Obstacle(speed * gameLayoutScale(), radius));
}

function spawnHunterRedBall() {
    const radius = getObstacleRadius();
    const ls = gameLayoutScale();
    const o = new Obstacle(HUNTER_NORMAL_SPEED * ls, radius);
    o.isHunter = true;
    o.hunterBias = gameRandom() * Math.PI * 2;
    const slot = obstacles.filter((ob) => ob.isHunter).length;
    const clearance =
        isSandboxRunActive() || gameMode === "sandbox"
            ? getMinSpawnDistanceFromCursor(radius)
            : hunterSpawnClearancePx(ls, radius, getCursorRadiusForMode());
    if (
        !placeBallAwayFromCursor(o, mouse.x, mouse.y, clearance, canvas.width, canvas.height)
    ) {
        o.x = mouse.x < canvas.width / 2 ? canvas.width - radius - 4 : radius + 4;
        o.y = mouse.y < canvas.height / 2 ? canvas.height - radius - 4 : radius + 4;
    }
    assignHunterPatrolAnchor(o, slot, slot + 1, canvas.width, canvas.height, ls);
    obstacles.push(o);
}

function resolveBallCollisionsAmongObstacles() {
    for (let i = 0; i < obstacles.length; i++) {
        for (let j = i + 1; j < obstacles.length; j++) {
            const a = obstacles[i];
            const b = obstacles[j];
            const dx = b.x - a.x;
            const dy = b.y - a.y;
            const dist = Math.hypot(dx, dy);
            const minDist = a.r + b.r;

            if (dist <= 0 || dist >= minDist) continue;

            const nx = dx / dist;
            const ny = dy / dist;

            const overlap = (minDist - dist) / 2;
            a.x -= nx * overlap;
            a.y -= ny * overlap;
            b.x += nx * overlap;
            b.y += ny * overlap;

            const rvx = b.vx - a.vx;
            const rvy = b.vy - a.vy;
            const velAlongNormal = rvx * nx + rvy * ny;
            if (velAlongNormal > 0) continue;

            const impulse = -velAlongNormal;
            const ix = impulse * nx;
            const iy = impulse * ny;

            a.vx -= ix;
            a.vy -= iy;
            b.vx += ix;
            b.vy += iy;
        }
    }
}

function resolveSandboxBallCollisions() {
    if (!sandboxBallCollisionsEnabled()) return;
    resolveBallCollisionsAmongObstacles();
}

/** Sandbox rule toggle; when not in a sandbox run, mode hardcodes decide separately. */
function sandboxBallCollisionsEnabled() {
    if (isSandboxRunActive()) return sbRuleEnabled("ballCollisionsEnabled");
    if (gameMode === "sandbox" && sandboxRuntimeConfig) return !!sandboxRuntimeConfig.ballCollisionsEnabled;
    return false;
}

function sandboxMagnetEnabled() {
    if (isSandboxRunActive()) return sbRuleEnabled("magnetEnabled");
    if (gameMode === "sandbox" && sandboxRuntimeConfig) return !!sandboxRuntimeConfig.magnetEnabled;
    return false;
}

function sandboxProgressionOverlayEnabled() {
    if (isSandboxRunActive()) return sbRuleEnabled("progressionEnabled");
    if (gameMode === "sandbox" && sandboxRuntimeConfig) return !!sandboxRuntimeConfig.progressionEnabled;
    return false;
}

/** Green safe-lane active for Progression mode or Sandbox Progression Lane overlay. */
function isProgressionLaneActive() {
    if (isSandboxRunActive()) return sbRuleEnabled("progressionEnabled");
    return gameMode === "progression" || sandboxProgressionOverlayEnabled();
}

/**
 * Middle playfield for balls when Progression lanes are active.
 * Invisible walls sit at the inner edge of both green side bands (cursor-only passages).
 */
function progressionObstacleBounds() {
    const band = progressionTouchBandPx();
    const w = canvas.width > 0 ? canvas.width : 800;
    const h = canvas.height > 0 ? canvas.height : 600;
    let minX = band;
    let maxX = w - band;
    if (maxX <= minX) {
        const mid = w * 0.5;
        minX = mid - 1;
        maxX = mid + 1;
    }
    return { minX, minY: 0, maxX, maxY: h };
}

function updateObstacleMaybeMagnet(o, fs) {
    o.update(fs);
}

function applySandboxMagnetPass(fs) {
    if (!sandboxMagnetEnabled()) return;
    const step = sandboxMagnetStepPx() * fs;
    for (const o of obstacles) applyMagnetObstacleStep(o, step);
}

function resolveColorRushBallCollisions() {
    if (gameMode !== "colorrush") return;
    // Normal Color Rush always collides; Sandbox uses the Ball Collisions toggle.
    if (isSandboxRunActive() && !sbRuleEnabled("ballCollisionsEnabled")) return;
    resolveBallCollisionsAmongObstacles();
}

function resolveCounterBallCollisions() {
    if (gameMode !== "counter") return;
    if (isSandboxRunActive() && !sbRuleEnabled("ballCollisionsEnabled")) return;
    resolveBallCollisionsAmongObstacles();
}

function resolveHookBallCollisions() {
    if (gameMode !== "hook") return;
    if (isSandboxRunActive() && !sbRuleEnabled("ballCollisionsEnabled")) return;
    resolveBallCollisionsAmongObstacles();
}

function resolvePopBallCollisions() {
    if (gameMode !== "pop") return;
    if (isSandboxRunActive() && !sbRuleEnabled("ballCollisionsEnabled")) return;

    const ls = gameLayoutScale();
    const now = getGameSimNowMs();
    const n = obstacles.length;
    if (n < 2) return;

    const toSplit = new Set();
    const toRemove = new Set();
    /** @type {Map<number, number>} */
    const growBy = new Map();
    /** @type {Array<{ i: number, j: number, nx: number, ny: number }>} */
    const bounceContacts = [];
    /** Preferred split axis per ball (collision tangent). */
    const splitAxis = new Map();

    /** @type {Array<{ i: number, j: number, nx: number, ny: number }>} */
    const contacts = [];
    for (let i = 0; i < n; i++) {
        for (let j = i + 1; j < n; j++) {
            const a = obstacles[i];
            const b = obstacles[j];
            const dx = b.x - a.x;
            const dy = b.y - a.y;
            const dist = Math.hypot(dx, dy);
            const minDist = a.r + b.r;
            if (dist <= 0 || dist >= minDist) continue;
            contacts.push({ i, j, nx: dx / dist, ny: dy / dist });
        }
    }
    if (contacts.length === 0) return;

    // Same size, or any large+/large+ pair, with both ready → both split.
    for (const c of contacts) {
        const a = obstacles[c.i];
        const b = obstacles[c.j];
        const sizeA = clampPopSize(a.popSize ?? POP_SIZE_LARGE);
        const sizeB = clampPopSize(b.popSize ?? POP_SIZE_LARGE);
        if (!popSizesShouldSplit(sizeA, sizeB)) continue;
        if (!popBallReadyToSplit(a, now) || !popBallReadyToSplit(b, now)) continue;
        toSplit.add(c.i);
        toSplit.add(c.j);
        const tx = -c.ny;
        const ty = c.nx;
        if (!splitAxis.has(c.i)) splitAxis.set(c.i, { x: tx, y: ty });
        if (!splitAxis.has(c.j)) splitAxis.set(c.j, { x: tx, y: ty });
    }

    // Different size: mini fuses into the larger ball; otherwise bounce.
    /** @type {Array<{ remove: number, host: number }>} */
    const merges = [];
    const miniMerging = new Set();
    for (const c of contacts) {
        const a = obstacles[c.i];
        const b = obstacles[c.j];
        const sizeA = clampPopSize(a.popSize ?? POP_SIZE_LARGE);
        const sizeB = clampPopSize(b.popSize ?? POP_SIZE_LARGE);
        const aSplit = toSplit.has(c.i);
        const bSplit = toSplit.has(c.j);

        if (aSplit && bSplit) continue;
        if (aSplit || bSplit) {
            bounceContacts.push(c);
            continue;
        }

        if (sizeA === sizeB) {
            bounceContacts.push(c);
            continue;
        }

        const aMini = isPopMini(sizeA);
        const bMini = isPopMini(sizeB);
        if (aMini && !bMini) {
            if (miniMerging.has(c.i)) {
                bounceContacts.push(c);
            } else {
                miniMerging.add(c.i);
                merges.push({ remove: c.i, host: c.j });
            }
        } else if (bMini && !aMini) {
            if (miniMerging.has(c.j)) {
                bounceContacts.push(c);
            } else {
                miniMerging.add(c.j);
                merges.push({ remove: c.j, host: c.i });
            }
        } else {
            bounceContacts.push(c);
        }
    }

    for (const m of merges) {
        if (toSplit.has(m.remove) || toSplit.has(m.host) || toRemove.has(m.host)) {
            // Host unavailable — bounce instead of free-deleting the mini.
            const a = obstacles[m.remove];
            const b = obstacles[m.host];
            if (a && b) bouncePopBalls(a, b, ls);
            continue;
        }
        toRemove.add(m.remove);
        growBy.set(m.host, (growBy.get(m.host) || 0) + 1);
    }

    for (const c of bounceContacts) {
        if (toRemove.has(c.i) || toRemove.has(c.j)) continue;
        if (toSplit.has(c.i) && toSplit.has(c.j)) continue;
        const a = obstacles[c.i];
        const b = obstacles[c.j];
        if (toSplit.has(c.i) && !toSplit.has(c.j)) {
            bouncePopBallOffPoint(b, a.x, a.y, a.r, ls);
            continue;
        }
        if (toSplit.has(c.j) && !toSplit.has(c.i)) {
            bouncePopBallOffPoint(a, b.x, b.y, b.r, ls);
            continue;
        }
        bouncePopBalls(a, b, ls);
        if (now - a.lastBounceFx > 120) {
            a.lastBounceFx = now;
            emitBurst(a.x, a.y, 2, [settingBallsColor, "#ffffff"], 0.7, 0, 0.8, 1.6, 8, 14);
            playBounceSound(Math.abs(a.vx) + Math.abs(a.vy));
        }
    }

    const childReadyAt = now + POP_SPLIT_COOLDOWN_MS;
    let anyMerge = false;
    for (const [host, count] of growBy.entries()) {
        if (toRemove.has(host) || toSplit.has(host)) continue;
        const o = obstacles[host];
        if (!o) continue;
        let grew = false;
        for (let k = 0; k < count; k++) {
            if (growPopBall(o, ls)) grew = true;
        }
        o.x = clamp(o.x, o.r, canvas.width - o.r);
        o.y = clamp(o.y, o.r, canvas.height - o.r);
        o.popSplitReadyAt = childReadyAt;
        anyMerge = true;
        emitBurst(o.x, o.y, grew ? 5 : 3, [settingBallsColor, "#ffffff"], 0.95, 0, 0.85, 2.0, 8, 16);
        playBounceSound(Math.abs(o.vx) + Math.abs(o.vy) + 0.5);
    }
    if (anyMerge) addShake(0.2);

    if (toSplit.size === 0 && toRemove.size === 0) return;

    const kept = [];
    const children = [];
    for (let i = 0; i < obstacles.length; i++) {
        const o = obstacles[i];
        if (toRemove.has(i)) {
            emitBurst(o.x, o.y, 4, [settingBallsColor, "#ffffff"], 0.85, 0, 0.8, 1.8, 8, 14);
            continue;
        }
        if (!toSplit.has(i)) {
            kept.push(o);
            continue;
        }
        const axis = splitAxis.get(i) || { x: 1, y: 0 };
        const parts = makePopSplitChildren(o, axis.x, axis.y, ls, canvas.width, canvas.height);
        if (!parts) {
            kept.push(o);
            continue;
        }
        emitBurst(o.x, o.y, 6, [settingBallsColor, "#ffffff"], 1.0, 0, 0.9, 2.2, 10, 20);
        addShake(0.25);
        playBounceSound(Math.abs(o.vx) + Math.abs(o.vy) + 1);
        for (const p of parts) {
            children.push(spawnPopBall(p.size, p.x, p.y, p.vx, p.vy, { splitReadyAt: childReadyAt }));
        }
    }
    obstacles = kept.concat(children);
}

function resolveAimBallCollisions() {
    if (gameMode !== "aim") return;
    if (isSandboxRunActive() && !sbRuleEnabled("ballCollisionsEnabled")) return;
    for (let i = 0; i < obstacles.length; i++) {
        for (let j = i + 1; j < obstacles.length; j++) {
            const a = obstacles[i];
            const b = obstacles[j];
            if (!a.isAimGolden && !b.isAimGolden) continue;

            const dx = b.x - a.x;
            const dy = b.y - a.y;
            const dist = Math.hypot(dx, dy);
            const minDist = a.r + b.r;

            if (dist <= 0 || dist >= minDist) continue;

            const nx = dx / dist;
            const ny = dy / dist;

            const overlap = (minDist - dist) / 2;
            a.x -= nx * overlap;
            a.y -= ny * overlap;
            b.x += nx * overlap;
            b.y += ny * overlap;

            const rvx = b.vx - a.vx;
            const rvy = b.vy - a.vy;
            const velAlongNormal = rvx * nx + rvy * ny;
            if (velAlongNormal > 0) continue;

            const impulse = -velAlongNormal;
            const ix = impulse * nx;
            const iy = impulse * ny;

            a.vx -= ix;
            a.vy -= iy;
            b.vx += ix;
            b.vy += iy;
        }
    }
}

function resetProgressionCursor() {
    mouse.y = canvas.height / 2;
    flipProgressionCursorSide();
}

function flipProgressionCursorSide() {
    const inset = cursorEdgeInsetPx();
    mouse.x = progressionSide === "left" ? canvas.width - inset : inset;
    mouse.y = clamp(mouse.y, inset, canvas.height - inset);
    syncCursorSweepPrevFromMouse();
    resetRelativePointerAnchor();
}

function progressionTargetCount() {
    return Math.min(PROGRESSION_MAX_BALLS, Math.pow(2, progressionLevel));
}

function progressionSpawnSpeed() {
    if (isSandboxRunActive()) return sbCommonNum("ballsSpeed", 0.8);
    if (gameMode === "sandbox" && sandboxRuntimeConfig) {
        return Number(sandboxRuntimeConfig.ballsSpeed) || 0.8;
    }
    return 0.8;
}

function spawnProgressionBalls() {
    const target = progressionTargetCount();
    const speed = progressionSpawnSpeed();
    while (obstacles.length < target) {
        spawnObstacle(speed, getObstacleRadius());
    }
}

function advanceProgression() {
    if (progressionLevel >= 200) return;

    progressionLevel++;
    progressionSide = progressionSide === "left" ? "right" : "left";

    playProgressionLevelUpSound(progressionLevel);
    triggerFlash("#39ff14", 0.5, 95);
    addShake(3);
    emitBurst(mouse.x, mouse.y, 18, ["#39ff14", "#b8ffb8", "#fff"], 3.0, 0, 1.3, 3.2, 16, 28);

    flipProgressionCursorSide();
    spawnProgressionBalls();
}

function rouletteLabelFor(effect) {
    const map = {
        balls_big_10: "BIG BALLS x10",
        balls_big_5: "BIG BALLS x5",
        cursor_big_10: "BIG CURSOR x10",
        cursor_big_5: "BIG CURSOR x5",
        balls_fade: "INVISIBLE BALLS",
        plus100: "+100 BALLS",
        sens_slow: "SLOW CURSOR",
        controls_wasd: "WASD CONTROLS",
        magnet: "MAGNET"
    };
    return map[effect] || "";
}

function showRouletteLabel(text, now = getGameSimNowMs()) {
    roulette.labelText = text;
    roulette.labelStart = now;
    rouletteEffectText.textContent = text;
    rouletteEffectText.style.opacity = "0";
}

function updateRouletteLabel(now) {
    if (!roulette.labelText) {
        rouletteEffectText.style.opacity = "0";
        rouletteEffectText.textContent = "";
        return;
    }

    const age = now - roulette.labelStart;
    let opacity = 0;

    if (age < 1000) {
        opacity = age / 1000;
    } else if (age < 4000) {
        opacity = 1;
    } else if (age < 6000) {
        opacity = 1 - ((age - 4000) / 2000);
    } else {
        opacity = 0;
    }

    opacity = clamp(opacity, 0, 1);
    rouletteEffectText.textContent = roulette.labelText;
    rouletteEffectText.style.opacity = String(opacity);
}

function chooseRouletteEffect(first = false) {
    gameMusicGainMultiplier = 1;
    clearFlashbangMusicSchedule();

    const effects = [
        "balls_big_10",
        "balls_big_5",
        "cursor_big_10",
        "cursor_big_5",
        "balls_fade",
        "plus100",
        "sens_slow",
        "controls_wasd",
        "magnet"
    ];

    let effect = effects[Math.floor(gameRandom() * effects.length)]!;
    if (effects.length > 1) {
        // Always consume a second sample so avoiding lastEffect cannot desync the RNG stream.
        const second = effects[Math.floor(gameRandom() * effects.length)]!;
        if (effect === roulette.lastEffect) effect = second;
        if (effect === roulette.lastEffect) {
            effect = effects[(effects.indexOf(effect) + 1) % effects.length]!;
        }
    }

    roulette.lastEffect = effect;
    roulette.effect = effect;
    roulette.startedAt = getGameSimNowMs();
    roulette.endsAt = roulette.startedAt + 10000;
    roulette.nextDisplay = 10;
    roulette.pulseUntil = roulette.startedAt + 250;
    roulette.transitionPending = false;

    roulette.cursorScale = 1;
    roulette.targetCursorScale = 1;
    roulette.ballScale = 1;
    roulette.targetBallScale = 1;
    roulette.ballAlpha = 1;
    roulette.mouseLerp = ROULETTE_MOUSE_LERP_DEFAULT;
    roulette.targetMouseLerp = ROULETTE_MOUSE_LERP_DEFAULT;
    roulette.flashVisibleUntil = 0;
    roulette.flashFadeEnd = 0;
    roulette.whiteOverrideUntil = 0;
    roulette.controlMode = effect === "controls_wasd" ? "wasd" : "mouse";

    if (effect === "balls_big_10") roulette.targetBallScale = 10;
    if (effect === "balls_big_5") roulette.targetBallScale = 5;
    if (effect === "cursor_big_10") roulette.targetCursorScale = 10;
    if (effect === "cursor_big_5") roulette.targetCursorScale = 5;

    if (effect === "plus100") {
        for (let i = 0; i < 100; i++) spawnObstacle(ROULETTE_BALL_BASE_SPEED);
        roulette.nextPeriodicSpawnAt = Math.max(
            roulette.nextPeriodicSpawnAt,
            getGameSimNowMs() + ROULETTE_SPAWN_EVERY_PLUS100_MS
        );
    }

    if (effect === "sens_slow") roulette.targetMouseLerp = 0.02;

    roulette.pointerTarget = { x: mouse.x, y: mouse.y };

    showRouletteLabel(rouletteLabelFor(effect), roulette.startedAt);

    if (!first) {
        triggerFlash("#ffffff", 0.16, 80);
        addShake(1.2);
    }

    updateRoulette(roulette.startedAt);
    updateMobilePlayChrome();
}

function updateRoulette(now = getGameSimNowMs(), dt = 1 / REFERENCE_HZ) {
    if (gameMode !== "roulette") return;

    const scaleLerp = lerpFrameRate(0.12, dt);
    roulette.cursorScale += (roulette.targetCursorScale - roulette.cursorScale) * scaleLerp;
    roulette.ballScale += (roulette.targetBallScale - roulette.ballScale) * scaleLerp;
    roulette.mouseLerp += (roulette.targetMouseLerp - roulette.mouseLerp) * scaleLerp;

    if (Math.abs(roulette.cursorScale - roulette.targetCursorScale) < 0.01) roulette.cursorScale = roulette.targetCursorScale;
    if (Math.abs(roulette.ballScale - roulette.targetBallScale) < 0.01) roulette.ballScale = roulette.targetBallScale;
    if (Math.abs(roulette.mouseLerp - roulette.targetMouseLerp) < 0.005) roulette.mouseLerp = roulette.targetMouseLerp;

    if (roulette.effect === "balls_fade") {
        const t = clamp((now - roulette.startedAt) / 3000, 0, 1);
        roulette.ballAlpha = 1 - t;
    } else {
        roulette.ballAlpha += (1 - roulette.ballAlpha) * lerpFrameRate(0.08, dt);
    }

    if (!settingEffectFlashes) {
        fxFlash.style.opacity = "0";
    }

    const remaining = Math.max(0, (roulette.endsAt - now) / 1000);
    const display = Math.ceil(remaining);

    if (display !== roulette.nextDisplay) {
        roulette.nextDisplay = display;
        roulette.pulseUntil = now + 180;
    }

    if (remaining <= 0 && !roulette.transitionPending) {
        roulette.transitionPending = true;
        roulette.transitionDoneAt = now + 220;
        roulette.nextDisplay = 0;
        roulette.pulseUntil = now + 220;
    }

    if (roulette.transitionPending && now >= roulette.transitionDoneAt) {
        chooseRouletteEffect();
    }
}

function shouldAutoRestartAfterDeath() {
    if (!gameMode || isMultiplayerActive()) return false;
    // Campaign always shows the normal Game Over screen (Play Again / Return).
    if (isCampaignAttemptPlaying() || isCampaignGameOver()) return false;
    return settingAutoRetry;
}

function deathCursorColor() {
    const white = gameMode === "roulette" && getGameSimNowMs() < roulette.whiteOverrideUntil;
    if (white) return "#ffffff";
    if (gameMode === "colorrush") return getColorRushCursorHex();
    if (gameMode === "heat") return getHeatCursorColor(getHeatLevel());
    return settingCursorColor;
}

/** Modes (or momentary overrides) that replace the player's cursor color. */
function isCursorColorForcedByMode() {
    if (gameMode === "colorrush" || gameMode === "heat") return true;
    if (gameMode === "roulette" && getGameSimNowMs() < roulette.whiteOverrideUntil) return true;
    return false;
}

/** Cursor always rematches live fill; Settings toggle also tints Hat / Face / Body. Outlines stay via mask-aware draw. */
function cosmeticsDrawOptsForForcedCursor(liveColor) {
    if (!isCursorColorForcedByMode()) return { liveCursorColor: liveColor };
    return {
        liveCursorColor: liveColor,
        forceLiveCursorTint: true,
        tintAllCosmetics: !!settingCosmeticsMatchCursor,
    };
}

function freezeReplayAtStreamEnd() {
    if (!isReplayPlaybackActive() || replayDeathFrozen) return;
    replayDeathFrozen = true;
    freezeReplayPlayback();
    deathPending = true;
    deathStart = performance.now();
    gamePaused = false;
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    if (gameMode === "highway") {
        const scr = highwayCursorScreen();
        frozenMouse = { x: scr.x, y: scr.y };
    } else if (gameMode === "delay") {
        const real = getDelayRealCursorPos();
        frozenMouse = { x: real.x, y: real.y };
    } else {
        frozenMouse = { x: mouse.x, y: mouse.y };
    }
    syncReplayControlsUi();
    updateMobilePlayChrome();
}

function beginDeath(message = "") {
    if (isReplayPlaybackActive()) {
        // Mid-stream collisions can desync on older payloads; recorded duration is authoritative.
        // Freeze only when the replay stream ends (freezeReplayAtStreamEnd).
        return;
    }
    if (isChallengeAttemptPlaying()) {
        saveDeathRunOnce();
        void onChallengeDeathFail();
        return;
    }
    if (isMarathonAttemptPlaying()) {
        saveDeathRunOnce();
        void onMarathonDeathFail();
        return;
    }
    if (isTournamentPlaying()) {
        saveDeathRunOnce();
        void onTournamentPlayerDeath();
        return;
    }
    // Campaign goal already met: claim CLEARED (Challenges-style) instead of Game Over.
    if (isCampaignAttemptPlaying() && isCampaignGoalCompleted()) {
        saveDeathRunOnce();
        void onCampaignDeathWithGoal();
        return;
    }
    if (isChallengeDeathSequence() || isChallengeRewardFlow() || isCampaignClaiming() || isMarathonDeathSequence() || isMarathonAdvancing()) return;
    if (isMultiplayerActive() && onLocalMpDeathBegin()) return;
    if (isLocalActive() && isLocalCoopMode()) {
        /* coop local deaths handled in handleLocalCollisions */
    } else if (isLocalActive()) {
        return;
    }
    if (deathPending) return;
    if (dpadPositionCustomizeMode) return;
    clearFlashbangMusicSchedule();
    endTouchCursorAnalogAny();
    pointerLockPauseSuppressedUntil = performance.now() + 900;
    deathPending = true;
    gameOverMessage = message;
    deathStart = performance.now();
    gamePaused = false;
    hideEl(pauseScreen);
    leavePauseMenuCursorMode();
    exitGamePointerLock();
    deathCount = Math.floor(Number(deathCount) || 0) + 1;
    writeStored(KEY_DEATHS, deathCount);
    void syncPlayerStatsToCloud(true);
    if (gameMode === "highway") {
        const scr = highwayCursorScreen();
        frozenMouse = { x: scr.x, y: scr.y };
    } else if (gameMode === "delay") {
        const real = getDelayRealCursorPos();
        frozenMouse = { x: real.x, y: real.y };
    } else {
        frozenMouse = { x: mouse.x, y: mouse.y };
    }
    setSuperHudVisible(false);
    if (!settingEffectParticles && (gameMode === "speedrun" || (gameMode === "sandbox" && sandboxRuntimeConfig?.speedrunMode))) {
        speedrunDeathFrozenTSec = getGameSimNowSec();
    } else {
        speedrunDeathFrozenTSec = -1;
    }
    defeatGameMusicDuck = 0.07;
    stopDarknessTensionAudio();
    darknessMusicDuck = 1;
    playCursorCrackSound();
    playDefeatSound();

    trail = [];
    particles = [];
    triggerFlash(deathCursorColor(), 0.28, 65);
    addShake(5);
    const fxX = gameMode === "highway" || gameMode === "delay" ? frozenMouse.x : mouse.x;
    const fxY = gameMode === "highway" || gameMode === "delay" ? frozenMouse.y : mouse.y;
    if (settingEffectParticles) startDeathCursorBreak(fxX, fxY);
    else deathCursorBreak = null;
    updateMobilePlayChrome();
    saveDeathRunOnce();

    if (gameMode === "speedrun" && speedrunLastCheckpointIndex == null) {
        resetSpeedrunProgressAndTimer();
    }

    if (!isMultiplayerActive() && deathLoseDelayMs() === 0) {
        if (shouldAutoRestartAfterDeath()) performAutoRetry();
        else showGameOver();
        return;
    }
}

/** Sandbox runs record per preset (and the global Sandbox best) — never the base mode’s best. */
function persistSandboxRunBest(finalScore) {
    if (sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) return false;
    const value = sandboxRunUsesLevelMetric() ? progressionLevel : finalScore;
    const ref = sandboxRunPresetRef();
    let isNewRecord;
    if (ref) {
        const key = sandboxPresetStorageKey(ref.cloudPresetId, ref.name);
        isNewRecord = maybeWriteSandboxScoreLocalBest(key, value);
        if (ref.cloudPresetId) void submitSandboxPresetScoreCloud(value);
    } else {
        isNewRecord = value > bestSandbox;
    }
    if (!sandboxRunUsesLevelMetric() && value > bestSandbox) {
        bestSandbox = value;
        writeStored(KEY_BEST_SANDBOX, bestSandbox);
    }
    return isNewRecord;
}

function persistDeathRunBests() {
    let gameOverIsNewRecord = false;

    const finalScore = gameplayScoreFloor();

    if (sandboxRunActiveNow()) return persistSandboxRunBest(finalScore);

    if (gameMode === "normal") {
        gameOverIsNewRecord = finalScore > bestNormal;
        if (gameOverIsNewRecord) {
            bestNormal = finalScore;
            writeStored(KEY_BEST_NORMAL, bestNormal);
        }
    } else if (gameMode === "wasd") {
        gameOverIsNewRecord = finalScore > bestWASD;
        if (gameOverIsNewRecord) {
            bestWASD = finalScore;
            writeStored(KEY_BEST_WASD, bestWASD);
        }
    } else if (gameMode === "superdot") {
        gameOverIsNewRecord = finalScore > bestSuper;
        if (gameOverIsNewRecord) {
            bestSuper = finalScore;
            writeStored(KEY_BEST_SUPER, bestSuper);
        }
    } else if (gameMode === "progression") {
        gameOverIsNewRecord = progressionLevel > bestProg;
        if (gameOverIsNewRecord) {
            bestProg = progressionLevel;
            writeStored(KEY_BEST_PROG, bestProg);
        }
    } else if (gameMode === "roulette") {
        gameOverIsNewRecord = finalScore > bestRoulette;
        if (gameOverIsNewRecord) {
            bestRoulette = finalScore;
            writeStored(KEY_BEST_ROULETTE, bestRoulette);
        }
    } else if (gameMode === "highway") {
        gameOverIsNewRecord = finalScore > bestHighway;
        if (gameOverIsNewRecord) {
            bestHighway = finalScore;
            writeStored(KEY_BEST_HIGHWAY, bestHighway);
        }
    } else if (gameMode === "darkness") {
        gameOverIsNewRecord = finalScore > bestDarkness;
        if (gameOverIsNewRecord) {
            bestDarkness = finalScore;
            writeStored(KEY_BEST_DARKNESS, bestDarkness);
        }
    } else if (gameMode === "mirror") {
        gameOverIsNewRecord = finalScore > bestMirror;
        if (gameOverIsNewRecord) {
            bestMirror = finalScore;
            writeStored(KEY_BEST_MIRROR, bestMirror);
        }
    } else if (gameMode === "delay") {
        gameOverIsNewRecord = finalScore > bestDelay;
        if (gameOverIsNewRecord) {
            bestDelay = finalScore;
            writeStored(KEY_BEST_DELAY, bestDelay);
        }
    } else if (gameMode === "snake") {
        gameOverIsNewRecord = finalScore > bestSnake;
        if (gameOverIsNewRecord) {
            bestSnake = finalScore;
            writeStored(KEY_BEST_SNAKE, bestSnake);
        }
    } else if (gameMode === "combo") {
        gameOverIsNewRecord = finalScore > bestCombo;
        if (gameOverIsNewRecord) {
            bestCombo = finalScore;
            writeStored(KEY_BEST_COMBO, bestCombo);
        }
    } else if (gameMode === "overload") {
        gameOverIsNewRecord = finalScore > bestOverload;
        if (gameOverIsNewRecord) {
            bestOverload = finalScore;
            writeStored(KEY_BEST_OVERLOAD, bestOverload);
        }
    } else if (gameMode === "colorrush") {
        gameOverIsNewRecord = finalScore > bestColorRush;
        if (gameOverIsNewRecord) {
            bestColorRush = finalScore;
            writeStored(KEY_BEST_COLOR_RUSH, bestColorRush);
        }
    } else if (gameMode === "heat") {
        gameOverIsNewRecord = finalScore > bestHeat;
        if (gameOverIsNewRecord) {
            bestHeat = finalScore;
            writeStored(KEY_BEST_HEAT, bestHeat);
        }
    } else if (gameMode === "hunter") {
        gameOverIsNewRecord = finalScore > bestHunter;
        if (gameOverIsNewRecord) {
            bestHunter = finalScore;
            writeStored(KEY_BEST_HUNTER, bestHunter);
        }
    } else if (gameMode === "pop") {
        gameOverIsNewRecord = finalScore > bestPop;
        if (gameOverIsNewRecord) {
            bestPop = finalScore;
            writeStored(KEY_BEST_POP, bestPop);
        }
    } else if (gameMode === "counter") {
        gameOverIsNewRecord = finalScore > bestCounter;
        if (gameOverIsNewRecord) {
            bestCounter = finalScore;
            writeStored(KEY_BEST_COUNTER, bestCounter);
        }
    } else if (gameMode === "aim") {
        gameOverIsNewRecord = finalScore > bestAim;
        if (gameOverIsNewRecord) {
            bestAim = finalScore;
            writeStored(KEY_BEST_AIM, bestAim);
        }
    } else if (gameMode === "hook") {
        gameOverIsNewRecord = finalScore > bestHook;
        if (gameOverIsNewRecord) {
            bestHook = finalScore;
            writeStored(KEY_BEST_HOOK, bestHook);
        }
    } else if (gameMode === "tilt") {
        gameOverIsNewRecord = finalScore > bestTilt;
        if (gameOverIsNewRecord) {
            bestTilt = finalScore;
            writeStored(KEY_BEST_TILT, bestTilt);
        }
    } else if (gameMode === "orbit") {
        gameOverIsNewRecord = finalScore > bestOrbit;
        if (gameOverIsNewRecord) {
            bestOrbit = finalScore;
            writeStored(KEY_BEST_ORBIT, bestOrbit);
        }
    }

    return gameOverIsNewRecord;
}

/** Persist personal bests (and cloud score) once per death, immediately on lose. */
function saveDeathRunOnce() {
    if (deathRunPersisted) return deathRunWasNewRecord;
    if (isReplayPlaybackActive()) {
        deathRunPersisted = true;
        deathRunWasNewRecord = false;
        activeReplayRecorder = null;
        return false;
    }
    if (isThemeCosmeticPreviewPlay()) {
        deathRunPersisted = true;
        deathRunWasNewRecord = false;
        clearLastRunDotsReward();
        return false;
    }
    // Campaign skips normal death saves unless the node goal was cleared (then count as a mode run).
    if (
        (isCampaignAttemptPlaying() || isCampaignGameOver() || isCampaignActive()) &&
        !isCampaignGoalCompleted()
    ) {
        // Do not show a prior run's Dots on Campaign fail Game Over.
        clearLastRunDotsReward();
        return false;
    }
    if (!gameMode || gameMode === "speedrun" || gameMode === "penalty" || gameMode === "multiplayer" || isMultiplayerActive()) {
        return false;
    }
    deathRunPersisted = true;
    const modeId = gameMode;
    const prevRecord = getModeBestValue(modeId);
    const scoreFinal = modeId === "progression" ? progressionLevel : gameplayScoreFloor();
    deathRunWasNewRecord = persistDeathRunBests();
    clearLastRunDotsReward();
    const sandboxRun = isSandboxRunActive();
    let replayOwnsScoreSubmit = false;
    if (!isReplayPlaybackActive()) {
        replayOwnsScoreSubmit = !!finalizeAndMaybeSubmitReplay({
            isNewRecord: deathRunWasNewRecord,
            value: scoreFinal,
        });
    } else {
        activeReplayRecorder = null;
    }
    if (!sandboxRun && cloudUser && modeId) {
        // Optimistic Game Over panel while the server confirms (does not credit locally).
        const optimistic = computeRunDotsReward(modeId, scoreFinal, prevRecord, deathRunWasNewRecord);
        if (optimistic.totalDots > 0) {
            setLastRunDotsReward(optimistic);
        }
        void (async () => {
            try {
                const res = await postDotsRunReward({
                    modeId,
                    score: scoreFinal,
                    previousRecord: prevRecord,
                    isNewRecord: deathRunWasNewRecord,
                });
                if (res?.dots) applyDotsFromApi(res.dots);
                if (res?.battlePass) notifyBattlePassXp(res.battlePass);
                if (res?.reward) {
                    setLastRunDotsReward(res.reward);
                    if (!gameOverScreen.classList.contains("hidden")) {
                        updateGameOverDotsPanel(modeId, false);
                    }
                }
            } catch {
                clearLastRunDotsReward();
                if (!gameOverScreen.classList.contains("hidden")) {
                    updateGameOverDotsPanel(modeId, false);
                }
                /* keep balance without inventing local Dots */
            }
        })();
    }
    if (!sandboxRun && !replayOwnsScoreSubmit) void submitCloudScore();
    schedulePushAccountData(true);
    return deathRunWasNewRecord;
}

function resetQuickRestartTapState() {
    quickRestartTapCount = 0;
    quickRestartLastTapMs = 0;
}

function canUseQuickRestart() {
    if (isTouchGameUi() || !settingQuickRestart) return false;
    if (!playing || !gameMode || deathPending || gamePaused || resumeCountdownActive) return false;
    if (isMultiplayerActive() || dpadPositionCustomizeMode || keybindListenAction) return false;
    if (!hasKeybindAssigned("quickRestart")) return false;
    return true;
}

function performQuickRestart() {
    if (!canUseQuickRestart()) return;
    resetQuickRestartTapState();
    gamePaused = false;
    hideEl(pauseScreen);
    clearResumeCountdown();
    leavePauseMenuCursorMode();
    gameOverMessage = "";
    if ((adminSpeedrunPlaytestActive || practicePlayActive) && gameMode === "speedrun") {
        respawnAdminSpeedrunPlaytest();
        updateMobilePlayChrome();
        return;
    }
    if (adminPenaltyPlaytestActive && gameMode === "penalty" && adminPenaltyPlaytestSnapshot) {
        restartAdminPenaltyPlaytestFromSnapshot();
        updateMobilePlayChrome();
        return;
    }
    restartCurrentGameMode();
    tryRequestGamePointerLock();
    updateMobilePlayChrome();
}

function handleQuickRestartKeydown(e) {
    if (!canUseQuickRestart() || isTypingInEditable() || e.repeat) return false;
    if (!keyEventMatchesAction(e, "quickRestart")) return false;

    const now = performance.now();
    if (now - quickRestartLastTapMs > QUICK_RESTART_TAP_WINDOW_MS) {
        quickRestartTapCount = 0;
    }
    quickRestartLastTapMs = now;
    quickRestartTapCount += 1;
    e.preventDefault();

    if (quickRestartTapCount >= QUICK_RESTART_TAP_COUNT) {
        performQuickRestart();
    }
    return true;
}

function restartCurrentGameMode() {
    if (isSandboxRunActive()) {
        startSandboxGame();
        return;
    }
    const mode = gameMode;
    const level = speedrunActiveLevel;
    if (mode === "normal") startNormal();
    else if (mode === "wasd") startWASD();
    else if (mode === "superdot") startSuperDot();
    else if (mode === "progression") startProgression();
    else if (mode === "roulette") beginRouletteGame();
    else if (mode === "sandbox") startSandboxGame();
    else if (mode === "highway") startHighway();
    else if (mode === "darkness") startDarkness();
    else if (mode === "mirror") startMirror();
    else if (mode === "delay") startDelay();
    else if (mode === "snake") startSnake();
    else if (mode === "combo") startCombo();
    else if (mode === "colorrush") startColorRush();
    else if (mode === "heat") startHeat();
    else if (mode === "hunter") startHunter();
    else if (mode === "pop") startPop();
    else if (mode === "counter") startCounter();
    else if (mode === "aim") startAim();
    else if (mode === "hook") startHook();
    else if (mode === "tilt") void startTilt();
    else if (mode === "orbit") startOrbit();
    else if (mode === "speedrun") startSpeedrunGame(level);
    else if (mode === "penalty") startPenaltyGame(level);
}

function tickDeathFrame(now, dt = 1 / REFERENCE_HZ) {
    // Replay: hold the final gameplay frame forever — never open Game Over.
    if (isReplayPlaybackActive() || replayDeathFrozen) {
        updateTopHud(now);
        renderScene(true, 0);
        if (replayReentryDepth === 0) syncReplayControlsUi();
        return;
    }
    const worldFrozen = isDeathWorldFrozen();
    if (!worldFrozen) {
        if (particles.length) updateParticles(dt);
        decayScreenShake(dt);
    }
    renderScene(true, worldFrozen ? 0 : dt);

    const deadMs = now - deathStart;
    if (speedrunCheckpointDeathPending) {
        if (deadMs >= deathLoseDelayMs()) {
            finishSpeedrunCheckpointDeath();
        }
        return;
    }
    if ((adminSpeedrunPlaytestActive || practicePlayActive) && gameMode === "speedrun") {
        if (deadMs >= 1000) {
            respawnAdminSpeedrunPlaytest();
        }
    } else if (deadMs >= deathLoseDelayMs()) {
        if (shouldAutoRestartAfterDeath()) performAutoRetry();
        else showGameOver();
    }
}

function performAutoRetry() {
    if (!deathPending || !gameMode) {
        if (deathPending) showGameOver();
        return;
    }
    saveDeathRunOnce();
    writeStored(KEY_PLAYTIME, Math.floor(playTime));

    gamePaused = false;
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    hideEl(gameOverNewRecord);
    if (gameOverNewRecord) gameOverNewRecord.setAttribute("aria-hidden", "true");
    clearDeathState();
    gameOverMessage = "";
    leavePauseMenuCursorMode();
    restartCurrentGameMode();
    updateMobilePlayChrome();
    void pollAchievementUnlocksNow();
}

function showGameOver() {
    if (isReplayPlaybackActive() || replayDeathFrozen) return;
    if (!deathPending) return;
    const campaignDeath = isCampaignAttemptPlaying();
    gamePaused = false;
    hideEl(pauseScreen);
    playing = false;
    deathPending = false;
    deathCursorBreak = null;
    defeatGameMusicDuck = 1;
    darknessMusicDuck = 1;
    stopDarknessTensionAudio();
    stopTiltOrientationListening();

    leavePauseMenuCursorMode();
    document.body.classList.remove("hideCursor");
    showEl(gameOverScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideComboHud();
    hideEl(gameOverNewRecord);
    if (gameOverNewRecord) gameOverNewRecord.setAttribute("aria-hidden", "true");
    triggerFlash("#ffffff", 0.1, 55);
    addShake(1);

    const gameOverIsNewRecord = saveDeathRunOnce();

    if (isSandboxRunActive() || gameMode === "sandbox") {
        updateGameOverStatsPanel(gameMode === "sandbox" ? "sandbox" : gameMode);
        playAgainBtn.onclick = startSandboxGame;
    } else if (gameMode === "normal") {
        updateGameOverStatsPanel("normal");
        playAgainBtn.onclick = startNormal;
    } else if (gameMode === "wasd") {
        updateGameOverStatsPanel("wasd");
        playAgainBtn.onclick = startWASD;
    } else if (gameMode === "superdot") {
        updateGameOverStatsPanel("superdot");
        playAgainBtn.onclick = startSuperDot;
    } else if (gameMode === "progression") {
        updateGameOverStatsPanel("progression");
        playAgainBtn.onclick = startProgression;
    } else if (gameMode === "roulette") {
        updateGameOverStatsPanel("roulette");
        playAgainBtn.onclick = startRoulette;
    } else if (gameMode === "highway") {
        updateGameOverStatsPanel("highway");
        playAgainBtn.onclick = startHighway;
    } else if (gameMode === "darkness") {
        updateGameOverStatsPanel("darkness");
        playAgainBtn.onclick = startDarkness;
    } else if (gameMode === "mirror") {
        updateGameOverStatsPanel("mirror");
        playAgainBtn.onclick = startMirror;
    } else if (gameMode === "delay") {
        updateGameOverStatsPanel("delay");
        playAgainBtn.onclick = startDelay;
    } else if (gameMode === "snake") {
        updateGameOverStatsPanel("snake");
        playAgainBtn.onclick = startSnake;
    } else if (gameMode === "combo") {
        updateGameOverStatsPanel("combo");
        playAgainBtn.onclick = startCombo;
    } else if (gameMode === "colorrush") {
        updateGameOverStatsPanel("colorrush");
        playAgainBtn.onclick = startColorRush;
    } else if (gameMode === "heat") {
        updateGameOverStatsPanel("heat");
        playAgainBtn.onclick = startHeat;
    } else if (gameMode === "hunter") {
        updateGameOverStatsPanel("hunter");
        playAgainBtn.onclick = startHunter;
    } else if (gameMode === "pop") {
        updateGameOverStatsPanel("pop");
        playAgainBtn.onclick = startPop;
    } else if (gameMode === "counter") {
        updateGameOverStatsPanel("counter");
        playAgainBtn.onclick = startCounter;
    } else if (gameMode === "aim") {
        updateGameOverStatsPanel("aim");
        playAgainBtn.onclick = startAim;
    } else if (gameMode === "hook") {
        updateGameOverStatsPanel("hook");
        playAgainBtn.onclick = startHook;
    } else if (gameMode === "tilt") {
        updateGameOverStatsPanel("tilt");
        playAgainBtn.onclick = () => { void startTilt(); };
    } else if (gameMode === "orbit") {
        updateGameOverStatsPanel("orbit");
        playAgainBtn.onclick = startOrbit;
    } else if (gameMode === "speedrun") {
        updateGameOverStatsPanel("speedrun");
        playAgainBtn.onclick = () => {
            hideEl(gameOverScreen);
            startSpeedrunGame(speedrunActiveLevel);
        };
    }

    if (campaignDeath) {
        noteCampaignGameOverShown();
        // Incomplete Campaign runs never earn score Dots — hide any stale panel.
        if (!isCampaignGoalCompleted()) {
            clearLastRunDotsReward();
            if (gameOverDotsPanel) hideEl(gameOverDotsPanel);
        }
        playAgainBtn.onclick = () => {
            void retryCampaignFromGameOver();
        };
    }

    if (gameOverIsNewRecord && gameOverNewRecord) {
        showEl(gameOverNewRecord);
        gameOverNewRecord.setAttribute("aria-hidden", "false");
    }

    writeStored(KEY_PLAYTIME, Math.floor(playTime));
    updateMobilePlayChrome();
    syncReturnBtnVisibility();
    void pollAchievementUnlocksNow();
}

window.addEventListener("focus", () => {
    if (playing && document.pointerLockElement !== canvas) resetRelativePointerAnchor();
});

window.addEventListener("blur", () => {
    if (playing && document.pointerLockElement !== canvas) resetRelativePointerAnchor();
});
document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden" && playing) resetRelativePointerAnchor();
});

canvas.addEventListener("click", (e) => {
    if (trySoccerSkipReplay()) {
        e.preventDefault();
        return;
    }
    if (isLootDropActive() && isLdHost() && playing) {
        // Drop already spawned on pointerdown; never request pointer lock as host.
        e.preventDefault();
        return;
    }
    if (!playing || gamePaused || deathPending || resumeCountdownActive || isTouchGameUi()) return;
    tryRequestGamePointerLock();
});

window.addEventListener(
    "pointerdown",
    (e) => {
        if (!isLootDropActive() || !isLdHost() || !playing) return;
        if (e.button !== 0) return;
        const t = e.target;
        if (t instanceof Element && t.closest("#ldHostPanel")) return;
        if (
            t instanceof Element &&
            (t.closest(".sideNav") ||
                t.closest("#returnBtn") ||
                t.closest("#ldHostPanel") ||
                t.closest("button") ||
                t.closest("input") ||
                t.closest("a") ||
                t.closest(".screen"))
        ) {
            return;
        }
        const touchPaint = e.pointerType === "touch" || e.pointerType === "pen" || isTouchTabletUi();
        if (touchPaint) {
            beginLootDropHostPaint(e.clientX, e.clientY, canvas);
            try {
                canvas.setPointerCapture?.(e.pointerId);
            } catch {
                /* ignore */
            }
            e.preventDefault();
            return;
        }
        handleLootDropCanvasClick(e.clientX, e.clientY, canvas);
    },
    true,
);

window.addEventListener(
    "pointermove",
    (e) => {
        if (!isLootDropActive() || !isLdHost() || !playing) return;
        const t = e.target;
        if (t instanceof Element && (t.closest("#ldHostPanel") || t.closest("button") || t.closest("input"))) {
            if (!isLootDropHostPaintActive()) return;
        }
        if (isLootDropHostPaintActive()) {
            continueLootDropHostPaint(e.clientX, e.clientY, canvas);
            e.preventDefault();
            return;
        }
        updateLootDropPointerFromClient(e.clientX, e.clientY, canvas);
    },
    { passive: false, capture: true },
);

window.addEventListener(
    "pointerup",
    (e) => {
        if (!isLootDropHostPaintActive()) return;
        endLootDropHostPaint();
        try {
            canvas.releasePointerCapture?.(e.pointerId);
        } catch {
            /* ignore */
        }
    },
    true,
);

window.addEventListener(
    "pointercancel",
    () => {
        endLootDropHostPaint();
    },
    true,
);

function keyboardEventKeyLower(e) {
    if (!e || e.key == null) return "";
    return String(e.key).toLowerCase();
}

addEventListener("keydown", e => {
    if (handleKeybindCaptureKeydown(e)) return;

    if (handleQuickRestartKeydown(e)) return;

    if (handleSidebarArrowNavKeydown(e)) return;

    const key = keyboardEventKeyLower(e);
    if (!isTypingInEditable()) {
        if (keyEventMatchesAction(e, "playAgain")) {
            if (tryPlayAgainOrStartKeybind()) {
                e.preventDefault();
                return;
            }
        }
        if (keyEventMatchesAction(e, "nextLevel")) {
            if (tryNextLevelKeybind()) {
                e.preventDefault();
                return;
            }
        }
    }
    if (keyEventMatchesAction(e, "return") && !isTypingInEditable()) {
        e.preventDefault();
        if (e.repeat) return;
        if (beginReturnHold(false)) return;
        handleGlobalReturnAction();
        return;
    }
    if (keyEventMatchesAction(e, "pause") && !isTypingInEditable()) {
        if (
            playing &&
            !deathPending &&
            gameMode !== null &&
            !resumeCountdownActive &&
            !isMultiplayerActive() &&
            !isLootDropActive() &&
            !isReplayPlaybackActive()
        ) {
            e.preventDefault();
            togglePause();
        }
        return;
    }
    if (keyEventMatchesAction(e, "menu") && !isTypingInEditable() && canShowSidebar()) {
        e.preventDefault();
        toggleSidebarMenu();
        return;
    }
    if (keyEventMatchesAction(e, "uiCursor") && !isTypingInEditable()) {
        if (playing && !isTouchGameUi()) {
            e.preventDefault();
            toggleUiCursorMode();
        }
        return;
    }
    if (deathPending) return;

    if (key) keys[key] = true;
    if (activeReplayRecorder && activeReplayRecorder.isActive && key) {
        activeReplayRecorder.recordKey(getGameSimNowMs(), key, true);
    }

    if (gameMode === "superdot" && !e.repeat && !isReplayPlaybackActive()) {
        if (key === "e") tryActivateSuperdotShield();
        if (key === "q") tryActivateSuperdotSlow();
        if (key === "w") tryActivateSuperdotBarrier();
        if (key === "r") tryActivateSuperdotPush();
    }
});

addEventListener("keyup", e => {
    if (keyEventMatchesAction(e, "return") && returnHoldActive && !returnHoldFromPointer) {
        e.preventDefault();
        endReturnHold();
    }
    const key = keyboardEventKeyLower(e);
    if (key) keys[key] = false;
    if (activeReplayRecorder && activeReplayRecorder.isActive && key) {
        activeReplayRecorder.recordKey(getGameSimNowMs(), key, false);
    }
});

window.addEventListener("blur", () => {
    cancelReturnHold();
});
document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") cancelReturnHold();
});

function clipCanvasHalfPlane(c, qx, qy, nx, ny, keepPositive) {
    const L = Math.max(canvas.width, canvas.height) * 4;
    c.beginPath();
    c.moveTo(qx, qy);
    if (keepPositive) {
        c.lineTo(qx + nx * L - ny * L, qy + ny * L + nx * L);
        c.lineTo(qx + nx * L + ny * L, qy + ny * L - nx * L);
    } else {
        c.lineTo(qx - nx * L - ny * L, qy - ny * L + nx * L);
        c.lineTo(qx - nx * L + ny * L, qy - ny * L - nx * L);
    }
    c.closePath();
    c.clip();
}

function drawCursorPortalSplitOnto(c, split, r, color) {
    const { entryX, entryY, exitX, exitY, qx, qy, nx, ny, exitQx, exitQy, exitNx, exitNy } = split;
    c.save();
    c.globalCompositeOperation = "source-over";
    c.save();
    clipCanvasHalfPlane(c, qx, qy, nx, ny, true);
    c.fillStyle = color;
    c.beginPath();
    c.arc(entryX, entryY, r, 0, Math.PI * 2);
    c.fill();
    c.restore();
    c.save();
    clipCanvasHalfPlane(c, exitQx, exitQy, exitNx, exitNy, false);
    c.fillStyle = color;
    c.beginPath();
    c.arc(exitX, exitY, r, 0, Math.PI * 2);
    c.fill();
    c.restore();
    c.restore();
}

function drawCursorOnto(c, x, y) {
    if (!c) return;
    const size = getCursorRadiusForMode();
    const white = gameMode === "roulette" && getGameSimNowMs() < roulette.whiteOverrideUntil;
    const now = getGameSimNowMs();
    const colorRushActive = gameMode === "colorrush";
    const heatActive = gameMode === "heat";
    const fill = colorRushActive ? getColorRushCursorHex() : white ? "#ffffff" : settingCursorColor;
    const drawSize = colorRushActive ? size * getColorRushCursorPulseScale(now) : size;
    const hideBase = equippedHidesBaseCursor();
    /** ORBIT: bottom of the cursor faces the core (inward radial). */
    const orbitFacing = gameMode === "orbit";
    const dx = orbitFacing ? 0 : x;
    const dy = orbitFacing ? 0 : y;
    c.save();
    c.globalCompositeOperation = "source-over";
    if (orbitFacing) {
        c.translate(x, y);
        c.rotate(getOrbitAngle() + Math.PI / 2);
    }
    if (colorRushActive && isColorRushCursorPulsing(now) && !hideBase) {
        c.strokeStyle = "#ffffff";
        c.lineWidth = Math.max(2, drawSize * 0.55);
        c.beginPath();
        c.arc(dx, dy, drawSize + c.lineWidth * 0.85, 0, Math.PI * 2);
        c.stroke();
    }
    if (heatActive) {
        if (!hideBase) {
            const heatColor = getHeatCursorColor(getHeatLevel());
            c.fillStyle = heatColor;
            c.beginPath();
            c.arc(dx, dy, drawSize, 0, Math.PI * 2);
            c.fill();
            c.strokeStyle = "rgba(255,255,255,0.72)";
            c.lineWidth = Math.max(1, drawSize * 0.1);
            c.beginPath();
            c.arc(dx, dy, drawSize, 0, Math.PI * 2);
            c.stroke();
            drawEquippedCosmeticOverlays(c, dx, dy, drawSize, cosmeticsDrawOptsForForcedCursor(heatColor));
        } else {
            drawEquippedCosmeticOverlays(
                c,
                dx,
                dy,
                drawSize,
                cosmeticsDrawOptsForForcedCursor(getHeatCursorColor(getHeatLevel())),
            );
        }
        c.restore();
        return;
    }
    if (!hideBase) {
        c.fillStyle = fill;
        c.beginPath();
        c.arc(dx, dy, drawSize, 0, Math.PI * 2);
        c.fill();
    }
    drawEquippedCosmeticOverlays(c, dx, dy, drawSize, cosmeticsDrawOptsForForcedCursor(fill));
    c.restore();
}

/** Edge darkening only (no gameplay impact). Skipped when Special Effects is OFF or game bg plain. */
function drawCosmeticCanvasVignette() {
    if (!settingEffectFlashes || isBackgroundBrightMax(settingGameBackgroundBright)) return;
    const w = canvas.width;
    const h = canvas.height;
    if (w < 8 || h < 8) return;
    ctx.save();
    const cx = w * 0.5;
    const cy = h * 0.5;
    const r0 = Math.min(w, h) * 0.14;
    const r1 = Math.hypot(w, h) * 0.52;
    const g = ctx.createRadialGradient(cx, cy, r0, cx, cy, r1);
    g.addColorStop(0, "rgba(0,0,0,0)");
    g.addColorStop(0.62, "rgba(0,0,0,0)");
    g.addColorStop(1, "rgba(0,0,0,0.19)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    ctx.restore();
}

function renderActiveGameFrame(frozen = false, dt = 1 / REFERENCE_HZ) {
    if (isSoccerActive()) {
        renderSoccer(ctx, canvas.width, canvas.height);
        clearGameCursorTopLayer();
        return;
    }
    renderScene(frozen, dt);
}

function renderScene(frozen = false, dt = 1 / REFERENCE_HZ) {
    const fs = frameScale(dt);
    ctx.save();
    const shakeX = (Math.random() * 2 - 1) * screenShake;
    const shakeY = (Math.random() * 2 - 1) * screenShake;
    ctx.translate(shakeX, shakeY);

    const darknessActive = gameMode === "darkness";
    const delayRealLive = gameMode === "delay" && !(frozen && deathPending) ? getDelayRealCursorPos() : null;
    const pxBase = frozen && deathPending
        ? frozenMouse.x
        : delayRealLive
          ? delayRealLive.x
          : mouse.x;
    const pyBase = frozen && deathPending
        ? frozenMouse.y
        : delayRealLive
          ? delayRealLive.y
          : mouse.y;
    let darknessZoomApplied = 1;
    if (darknessActive) {
        darknessZoomApplied = getDarknessZoom();
        if (darknessZoomApplied !== 1) {
            ctx.translate(pxBase, pyBase);
            ctx.scale(darknessZoomApplied, darknessZoomApplied);
            ctx.translate(-pxBase, -pyBase);
        }
        fillDarknessBackground(ctx, canvas.width, canvas.height);
        ctx.save();
        applyDarknessVisionClip(ctx, pxBase, pyBase, gameLayoutScale());
        fillDarknessVisionInterior(ctx, canvas.width, canvas.height, effectiveGameBackgroundColor());
    }

    const progressionActive = isProgressionLaneActive();
    if (progressionActive) {
        const band = progressionTouchBandPx();
        const barX = progressionSide === "left" ? 0 : canvas.width - band;
        ctx.save();
        ctx.shadowColor = "#b8ffc8";
        ctx.shadowBlur = 34;
        ctx.fillStyle = "#5dff2e";
        ctx.fillRect(barX, 0, band, canvas.height);
        ctx.shadowBlur = 18;
        ctx.fillStyle = "#39ff14";
        ctx.fillRect(barX, 0, band, canvas.height);
        ctx.shadowBlur = 12;
        ctx.fillStyle = "rgba(230,255,235,0.62)";
        ctx.fillRect(barX + Math.max(0, band * 0.1), 0, Math.max(1, band * 0.28), canvas.height);
        ctx.shadowBlur = 0;
        ctx.strokeStyle = "rgba(255,255,255,0.78)";
        ctx.lineWidth = 2.5;
        ctx.strokeRect(barX + 1, 1, Math.max(0, band - 2), canvas.height - 2);
        ctx.restore();
    }

    if (gameMode === "highway") {
        const ls = gameLayoutScale();
        drawHighwayRoad(ctx, canvas.width, canvas.height, ls, gameplayBallsColor());
    } else if (isMpHighwayPlaying()) {
        renderMpHighwayLayer(
            ctx,
            canvas.width,
            canvas.height,
            gameplayBallsColor(),
            performance.now(),
        );
    }

    if (gameMode === "multiplayer" && (isMultiplayerActive() || isMpHighwayPlaying())) {
        renderMultiplayerTrails(ctx, canvas.width, canvas.height);
    }
    if (gameMode === "snake") {
        drawSnakePlayBorder(
            ctx,
            canvas.width,
            canvas.height,
            cursorEdgeInsetPx(),
            settingTrailColor,
            gameLayoutScale(),
        );
        drawSnakeTrail(ctx, gameLayoutScale(), settingTrailColor);
    } else if (gameMode === "orbit") {
        drawOrbitCore(ctx, canvas.width, canvas.height, gameplayBallsColor(), settingCursorColor, gameLayoutScale());
        drawOrbitReversalMarks(
            ctx,
            canvas.width,
            canvas.height,
            getCursorRadiusForMode(),
            gameLayoutScale(),
            settingCursorColor,
            performance.now(),
        );
    } else if (gameMode === "multiplayer" && isMpSnakeMode()) {
        renderMpSnakePlayBorder(ctx, canvas.width, canvas.height, gameLayoutScale(), settingTrailColor);
        renderMpSnakeTrails(ctx, canvas.width, canvas.height, gameLayoutScale(), settingTrailColor);
    }
    if (!deathPending) {
        const skipLocalTrail =
            isMultiplayerActive() &&
            (!isMpLocalAlive() || isMpSpectator() || isMpSpeedrunLocalFinished());
        if (gameMode !== "snake" && !skipLocalTrail) drawTrail();
    }
    let savedSpeedrunPts = null;
    if (isMultiplayerActive() && isMpSpeedrunMode() && isMpSpeedrunSpectating()) {
        const sp = getMpSpectatePointsSet();
        if (sp) {
            savedSpeedrunPts = speedrunPointsCollected;
            speedrunPointsCollected = sp;
            refreshSpeedrunGroupWallState();
            refreshSpeedrunFrameGeometry();
        }
    }
    if (!isMultiplayerActive() || isMpSpeedrunMode()) drawSpeedrunLayer();
    if (practicePlayActive && playing && practiceActiveDef) {
        drawPracticeGuideOverlay(
            ctx,
            canvas.width,
            canvas.height,
            practiceActiveDef.guideSteps,
            practiceGuideState,
        );
    }
    if (gameMode === "penalty" && playing) {
        drawPenaltyBallLayer(ctx, penaltyRuntime.ball);
    }
    if (savedSpeedrunPts) {
        speedrunPointsCollected = savedSpeedrunPts;
        refreshSpeedrunGroupWallState();
        refreshSpeedrunFrameGeometry();
    }

    if (gameMode === "highway") {
        ctx.save();
        if (isChallengeDeathSequence() || isMarathonDeathSequence()) ctx.globalAlpha = challengeDeathBallAlpha;
        drawHighwayObstacles(ctx, canvas.width, canvas.height, gameLayoutScale(), performance.now());
        ctx.restore();
    } else if (isMpHighwayPlaying()) {
        /* road + obstacles drawn above via renderMpHighwayLayer */
    } else if (
        frozen ||
        gamePaused ||
        isPracticeGuideFrozen() ||
        isChallengeDeathWorldActive()
    ) {
        for (const o of obstacles) o.draw();
    } else if (gameMode === "sandbox") {
        if (sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
            /* no ball dots in SpeedRun sandbox */
        } else {
            for (const o of obstacles) o.update(fs);
            resolveSandboxBallCollisions();
            applySandboxMagnetPass(fs);
            for (const o of obstacles) o.draw();
        }
    } else if (gameMode === "multiplayer") {
        if (isMultiplayerActive()) {
            renderMultiplayerObstacles(ctx, canvas.width, canvas.height, gameplayBallsColor());
        }
    } else if (gameMode === "snake") {
        const inset = cursorEdgeInsetPx();
        const ls = gameLayoutScale();
        if (!isLocalActive()) {
            for (const o of obstacles) {
                const wallBounced = updateSnakeApple(o, fs, canvas.width, canvas.height, inset);
                const trailBounced = resolveSnakeAppleTrailCollision(o, ls);
                if (wallBounced || trailBounced) {
                    if (performance.now() - o.lastBounceFx > 120) {
                        o.lastBounceFx = performance.now();
                        emitBurst(o.x, o.y, 3, ["#e53e3e", "#ffffff"], 0.9, 0, 0.9, 2.0, 10, 18);
                        addShake(0.15);
                    }
                    playBounceSound(Math.abs(o.vx) + Math.abs(o.vy));
                }
            }
            applySandboxMagnetPass(fs);
            for (const o of obstacles) o.draw();
        }
    } else if (gameMode === "colorrush") {
        for (const o of obstacles) o.update(fs);
        resolveColorRushBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    } else if (gameMode === "counter") {
        for (const o of obstacles) o.update(fs);
        resolveCounterBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    } else if (gameMode === "aim") {
        for (const o of obstacles) o.update(fs);
        resolveAimBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    } else if (gameMode === "hook") {
        for (const o of obstacles) o.update(fs);
        resolveHookBallCollisions();
        applySandboxMagnetPass(fs);
        const caught = getHookCaughtBall();
        if (caught) {
            caught.vx = 0;
            caught.vy = 0;
        }
        for (const o of obstacles) o.draw();
    } else if (gameMode === "hunter") {
        const ls = gameLayoutScale();
        const hunters = obstacles.filter((o) => o.isHunter);
        const bounces = updateHunterBalls(
            hunters,
            mouse.x,
            mouse.y,
            mouse.x - collisionPrevMouse.x,
            mouse.y - collisionPrevMouse.y,
            fs,
            canvas.width,
            canvas.height,
            ls,
        );
        for (let i = 0; i < hunters.length; i++) {
            const o = hunters[i]!;
            if (bounces[i] && performance.now() - o.lastBounceFx > 120) {
                o.lastBounceFx = performance.now();
                emitBurst(o.x, o.y, 3, ["#ff3333", "#ffffff"], 0.9, 0, 0.9, 2.0, 10, 18);
                addShake(0.15);
                playBounceSound(Math.abs(o.vx) + Math.abs(o.vy));
            }
        }
        for (const o of obstacles) {
            if (!o.isHunter) o.update(fs);
        }
        if (isSandboxRunActive()) resolveSandboxBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    } else if (gameMode === "pop") {
        for (const o of obstacles) o.update(fs);
        resolvePopBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    } else if (gameMode === "orbit") {
        for (const o of obstacles) {
            o.x += o.vx * fs;
            o.y += o.vy * fs;
        }
        for (const o of obstacles) o.draw();
    } else {
        for (const o of obstacles) {
            if (gameMode === "superdot" && slowActive) o.update(0.3 * fs);
            else if (gameMode === "roulette" && roulette.effect === "magnet" && !sandboxMagnetEnabled()) {
                applyMagnetObstacleStep(o, ROULETTE_MAGNET_STEP * gameLayoutScale() * fs);
            } else o.update(fs);
        }
        if (isSandboxRunActive()) resolveSandboxBallCollisions();
        applySandboxMagnetPass(fs);
        for (const o of obstacles) o.draw();
    }

    if (darknessActive) {
        drawDarknessPoints(ctx, performance.now(), gameLayoutScale());
    }

    drawParticles();

    const px = gameMode === "highway"
        ? frozen && deathPending
            ? frozenMouse.x
            : highwayCursorScreen().x
        : isMpHighwayPlaying()
          ? frozen && deathPending
              ? frozenMouse.x
              : mpHighwayMouseScreen().x
          : pxBase;
    const py = gameMode === "highway"
        ? frozen && deathPending
            ? frozenMouse.y
            : highwayCursorScreen().y
        : isMpHighwayPlaying()
          ? frozen && deathPending
              ? frozenMouse.y
              : mpHighwayMouseScreen().y
          : pyBase;

    if (gameMode === "superdot" && shieldActive) {
        const ls = gameLayoutScale();
        ctx.strokeStyle = "#00f";
        ctx.lineWidth = 2 * ls;
        ctx.beginPath();
        ctx.arc(px, py, 10 * ls, 0, Math.PI * 2);
        ctx.stroke();
    }
    if (gameMode === "superdot" && barrierActive) {
        const ls = gameLayoutScale();
        const r = sbNum("barrierRadius", SUPERDOT_BARRIER_RADIUS) * ls;
        ctx.save();
        ctx.strokeStyle = "#2d7dff";
        ctx.shadowColor = "rgba(60,140,255,0.9)";
        ctx.shadowBlur = 18 * ls;
        ctx.globalAlpha = 0.95;
        ctx.lineWidth = 2 * ls;
        ctx.beginPath();
        ctx.arc(px, py, r, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }
    if (gameMode === "superdot" && pushActive) {
        const ls = gameLayoutScale();
        const t = performance.now() * 0.004;
        const r = sbNum("pushRadius", SUPERDOT_PUSH_RADIUS) * ls;
        ctx.save();
        ctx.strokeStyle = "#ff9a3c";
        ctx.shadowColor = "rgba(255,140,40,0.85)";
        ctx.shadowBlur = 14 * ls;
        ctx.globalAlpha = 0.75 + Math.sin(t * 1.7) * 0.12;
        ctx.lineWidth = 2.5 * ls;
        ctx.beginPath();
        ctx.arc(px, py, r, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }

    if (darknessActive) {
        drawDarknessEdgeShade(ctx, pxBase, pyBase, gameLayoutScale());
        ctx.restore();
    }

    if (ctxCursorTop && canvasCursorTop) {
        ctxCursorTop.clearRect(0, 0, canvasCursorTop.width, canvasCursorTop.height);
        ctxCursorTop.save();
        ctxCursorTop.translate(shakeX, shakeY);
        if (darknessActive && darknessZoomApplied !== 1) {
            ctxCursorTop.translate(px, py);
            ctxCursorTop.scale(darknessZoomApplied, darknessZoomApplied);
            ctxCursorTop.translate(-px, -py);
        }
        if (darknessActive) {
            ctxCursorTop.save();
            applyDarknessVisionClip(ctxCursorTop, px, py, gameLayoutScale());
        }
        if (gameMode === "mirror") {
            const mp = mirrorCursorScreen();
            drawMirrorCursorOnto(ctxCursorTop, mp.x, mp.y, getCursorRadiusForMode());
        }
        if (gameMode === "delay" && !deathPending) {
            drawDelayGhostCursorOnto(
                ctxCursorTop,
                mouse.x,
                mouse.y,
                getCursorRadiusForMode(),
                settingCursorColor,
            );
        }
        if (deathPending && settingEffectParticles) {
            if (!deathCursorBreak) {
                startDeathCursorBreak(px, py);
            }
            const breakNow = performance.now();
            updateDeathCursorBreak(breakNow);
            drawBrokenCursorOnto(ctxCursorTop, deathCursorBreak, breakNow);
        } else if (gameMode !== "multiplayer" && !isLocalActive() && !isLootDropActive() && !isSoccerActive()) {
            const srMode =
                gameMode === "speedrun" ||
                (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode);
            if (srMode && speedrunPortalCursorSplit && !deathPending) {
                const color = settingCursorColor;
                drawCursorPortalSplitOnto(
                    ctxCursorTop,
                    speedrunPortalCursorSplit,
                    getCursorRadiusForMode(),
                    color,
                );
            } else {
                drawCursorOnto(ctxCursorTop, px, py);
            }
        }
        if (isLocalActive()) {
            renderLocalOverlay(ctxCursorTop, canvas.width, canvas.height, performance.now());
        }
        if (isLootDropActive()) {
            renderLootDropOverlay(ctxCursorTop, canvas.width, canvas.height, performance.now());
        }
        if (gameMode === "multiplayer" && (isMultiplayerActive() || isMpHighwayPlaying())) {
            renderMultiplayerCursors(
                ctxCursorTop,
                canvas.width,
                canvas.height,
                getCursorRadiusForMode(),
                px,
                py,
            );
        }
        if (darknessActive) {
            ctxCursorTop.restore();
        }
        ctxCursorTop.restore();
    }

    if (!darknessActive) {
        drawCosmeticCanvasVignette();
    }

    if (gameMode === "heat" && !isLocalActive()) {
        drawHeatBar(ctx, canvas.width, canvas.height, gameLayoutScale(), getHeatLevel());
    }

    if (gameMode === "counter") {
        drawCounterTimeHud(ctx, canvas.width, canvas.height, gameLayoutScale(), getGameSimNowMs(), gamePaused || resumeCountdownActive);
    }

    if (gameMode === "aim") {
        drawAimTimeHud(
            ctx,
            canvas.width,
            canvas.height,
            gameLayoutScale(),
            getGameSimNowMs(),
            gamePaused || resumeCountdownActive || isAimTimerFrozen(getGameSimNowMs(), false),
        );
    }

    if (gameMode === "hook" && !deathPending) {
        drawHookOverlay(
            ctx,
            mouse.x,
            mouse.y,
            canvas.width,
            canvas.height,
            obstacles,
            gameLayoutScale(),
            cursorEdgeInsetPx(),
            settingCursorColor,
        );
    }

    if (gameMode === "combo" && !deathPending) {
        drawComboMultiplierPopups(ctx, getGameSimNowMs(), gameLayoutScale());
    }

    ctx.restore();
}

function syncGameLogic(dt) {
    if (isLocalActive() && resumeCountdownActive) return;
    tickSuperdotAbilityExpiry();
    const fs = frameScale(dt);
    // Replay already applied the recorded cursor for this frame. Do not re-drive mouse
    // via WASD / roulette lerp / tilt / orbit — that desyncs cursor from balls at ≠1x.
    const replayCursorX = mouse.x;
    const replayCursorY = mouse.y;
    const replayLockCursor = isReplayPlaybackActive();
    /* Official speedrun: mouse comes only from applyPointerDelta. Sandbox speedrun must run
     * the normal sandbox block below so mouse lerps to sandboxPointerTarget (or WASD). */
    if (gameMode === "speedrun") {
        return;
    }
    if (gameMode === "penalty") {
        return;
    }

    if (gameMode === "normal") {
        const pts = sbNum("pointsPerSpawn", sbCommonNum("pointsPerSpawn", 500));
        const batch = sbNum("ballsPerSpawn", sbCommonNum("ballsPerSpawn", 50));
        const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "tilt") {
        const pts = sbNum("pointsPerSpawn", TILT_SCORE_PER_SPAWN);
        const batch = sbNum("ballsPerSpawn", TILT_BALLS_PER_SPAWN);
        const spd = sbNum("ballsSpeed", TILT_BALL_SPEED);
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "heat") {
        const pts = sbNum("pointsPerSpawn", HEAT_SCORE_PER_SPAWN);
        const batch = sbNum("ballsPerSpawn", HEAT_BALLS_PER_SPAWN);
        const spd = sbNum("ballsSpeed", HEAT_BALL_SPEED);
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "hunter") {
        const pts = sbNum("pointsPerSpawn", HUNTER_SCORE_PER_SPAWN);
        const normals = sbNum("normalPerSpawn", HUNTER_NORMAL_PER_SPAWN);
        const reds = sbNum("redPerSpawn", HUNTER_RED_PER_SPAWN);
        const spd = sbNum("normalSpeed", HUNTER_NORMAL_SPEED);
        while (score - lastHunterRedSpawn >= pts) {
            lastHunterRedSpawn += pts;
            for (let i = 0; i < normals; i++) spawnObstacle(spd);
            for (let i = 0; i < reds; i++) spawnHunterRedBall();
        }
    }

    if (gameMode === "hook") {
        const nowHook = getGameSimNowMs();
        if (shouldHookSpawn(nowHook)) {
            spawnHookBalls(
                Math.max(0, Math.floor(sbNum("normalPerSpawn", HOOK_NORMAL_PER_SPAWN))),
                Math.max(0, Math.floor(sbNum("redPerSpawn", HOOK_RED_PER_SPAWN))),
            );
            markHookSpawned(nowHook);
            syncBallCollisionPrevMouse();
        }
    }

    if (gameMode === "snake") {
        /* apples spawned on pickup only */
    } else if (gameMode === "combo") {
        const nowSp = getGameSimNowMs();
        const spawnEvery = sbNum("spawnEveryMs", COMBO_SPAWN_EVERY_MS);
        const batch = sbNum("ballsPerSpawn", COMBO_BALLS_PER_SPAWN);
        const spd = sbNum("ballsSpeed", COMBO_BALL_BASE_SPEED);
        if (!comboNextSpawnAt) comboNextSpawnAt = nowSp + spawnEvery;
        let guard = 0;
        while (nowSp >= comboNextSpawnAt && guard < 8) {
            guard++;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
            comboNextSpawnAt += spawnEvery;
        }
    }

    if (gameMode === "multiplayer") {
        if (isMpGameplayInputBlocked()) return;
        if (!uiCursorMode && isMultiplayerActive() && isMpWasdMode()) {
            const move = settingWASDSensitivity * gameLayoutScale() * fs;
            if (keys.w) mouse.y -= move;
            if (keys.s) mouse.y += move;
            if (keys.a) mouse.x -= move;
            if (keys.d) mouse.x += move;
            const cw = clampCursorXYToEdgeInset(mouse.x, mouse.y);
            mouse.x = cw.x;
            mouse.y = cw.y;
        } else if (isMultiplayerActive() && isMpSpeedrunMode()) {
            /* speedrun movement handled above in shared blocks if needed */
        } else if (!uiCursorMode && isMultiplayerActive() && getMpGameMode() === "sandbox" && sandboxRuntimeConfig) {
            const cfg = sandboxRuntimeConfig;
            const sandboxClampFn = clampCursorXYToEdgeInset;
            if (cfg.wasdEnabled) {
                const move = cfg.cursorSpeed * gameLayoutScale() * fs;
                if (keys.w) mouse.y -= move;
                if (keys.s) mouse.y += move;
                if (keys.a) mouse.x -= move;
                if (keys.d) mouse.x += move;
                const cs = sandboxClampFn(mouse.x, mouse.y);
                mouse.x = cs.x;
                mouse.y = cs.y;
            } else {
                mouse.x = sandboxPointerTarget.x;
                mouse.y = sandboxPointerTarget.y;
                const cs = sandboxClampFn(mouse.x, mouse.y);
                mouse.x = cs.x;
                mouse.y = cs.y;
            }
        }
        return;
    }

    if (gameMode === "mirror") {
        const pts = sbNum("pointsPerSpawn", sbCommonNum("pointsPerSpawn", 500));
        const batch = sbNum("ballsPerSpawn", sbCommonNum("ballsPerSpawn", 50));
        const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "delay") {
        if (!resumeCountdownActive) {
            tickDelayGhost(dt, mouse.x, mouse.y);
        }
        const pts = sbNum("pointsPerSpawn", sbCommonNum("pointsPerSpawn", 500));
        const batch = sbNum("ballsPerSpawn", sbCommonNum("ballsPerSpawn", 50));
        const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "superdot") {
        const pts = sbNum("pointsPerSpawn", sbCommonNum("pointsPerSpawn", 500));
        const batch = sbNum("ballsPerSpawn", sbCommonNum("ballsPerSpawn", 50));
        const spd = sbNum("ballsSpeed", sbCommonNum("ballsSpeed", 0.8));
        while (score - lastNormalSpawn >= pts) {
            lastNormalSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    if (gameMode === "roulette") {
        const nowSp = getGameSimNowMs();
        const interval =
            roulette.effect === "plus100"
                ? sbNum("spawnEveryPlus100Ms", ROULETTE_SPAWN_EVERY_PLUS100_MS)
                : sbNum("spawnEveryMs", ROULETTE_SPAWN_EVERY_MS);
        const batch = Math.max(0, Math.floor(sbNum("ballsPerSpawn", ROULETTE_SPAWN_BATCH)));
        const spd = sbNum("ballsSpeed", ROULETTE_BALL_BASE_SPEED);
        if (!roulette.nextPeriodicSpawnAt) roulette.nextPeriodicSpawnAt = nowSp + interval;
        let guard = 0;
        while (nowSp >= roulette.nextPeriodicSpawnAt && guard < 80) {
            guard++;
            for (let i = 0; i < batch; i++) {
                spawnObstacle(spd);
            }
            roulette.nextPeriodicSpawnAt += interval;
        }

        if (roulette.controlMode === "mouse" && !sandboxWasdMovementActive()) {
            if (roulettePointerFollowInstant()) {
                mouse.x = roulette.pointerTarget.x;
                mouse.y = roulette.pointerTarget.y;
            } else {
                const lerp = lerpFrameRate(roulette.targetMouseLerp, dt);
                mouse.x += (roulette.pointerTarget.x - mouse.x) * lerp;
                mouse.y += (roulette.pointerTarget.y - mouse.y) * lerp;
            }
            const cr = clampCursorXYToEdgeInset(mouse.x, mouse.y);
            mouse.x = cr.x;
            mouse.y = cr.y;
        } else if (roulette.controlMode === "wasd" && !uiCursorMode && !sandboxWasdMovementActive()) {
            const move = 5 * gameLayoutScale() * fs;

            if (keys.w) mouse.y -= move;
            if (keys.s) mouse.y += move;
            if (keys.a) mouse.x -= move;
            if (keys.d) mouse.x += move;

            const cr = clampCursorXYToEdgeInset(mouse.x, mouse.y);
            mouse.x = cr.x;
            mouse.y = cr.y;
            roulette.pointerTarget.x = mouse.x;
            roulette.pointerTarget.y = mouse.y;
        }
    }

    if (gameMode === "sandbox") {
        const cfg = sandboxRuntimeConfig || sandboxConfig;
        const sandboxClampFn = cfg.speedrunMode ? clampCursorXYToCanvas : clampCursorXYToEdgeInset;

        if (!cfg.speedrunMode) {
            while (score - lastSandboxSpawn >= cfg.pointsPerSpawn) {
                lastSandboxSpawn += cfg.pointsPerSpawn;
                for (let i = 0; i < cfg.ballsPerSpawn; i++) {
                    spawnObstacle(cfg.ballsSpeed, cfg.ballsSize);
                }
            }
        }

        if ((cfg.wasdEnabled || sandboxWasdMovementActive()) && !uiCursorMode) {
            const move = cfg.cursorSpeed * gameLayoutScale() * fs;
            if (keys.w) mouse.y -= move;
            if (keys.s) mouse.y += move;
            if (keys.a) mouse.x -= move;
            if (keys.d) mouse.x += move;
            const cs = sandboxClampFn(mouse.x, mouse.y);
            mouse.x = cs.x;
            mouse.y = cs.y;
        } else if (!cfg.speedrunMode) {
            mouse.x = sandboxPointerTarget.x;
            mouse.y = sandboxPointerTarget.y;
            const cs = sandboxClampFn(mouse.x, mouse.y);
            mouse.x = cs.x;
            mouse.y = cs.y;
        }
    }

    if (gameMode === "wasd" && !uiCursorMode) {
        const useWasdKeys = !isSandboxRunActive() || sandboxWasdMovementActive();
        if (useWasdKeys) {
            const move =
                (isSandboxRunActive()
                    ? sbNum("cursorSpeed", sbCommonNum("cursorSpeed", settingWASDSensitivity))
                    : settingWASDSensitivity) *
                gameLayoutScale() *
                fs;

            if (keys.w) mouse.y -= move;
            if (keys.s) mouse.y += move;
            if (keys.a) mouse.x -= move;
            if (keys.d) mouse.x += move;

            const cw = clampCursorXYToEdgeInset(mouse.x, mouse.y);
            mouse.x = cw.x;
            mouse.y = cw.y;
        }

        if (!dpadPositionCustomizeMode) {
            if (isSandboxRunActive()) {
                const pts = sbNum("pointsPerSpawn", 500);
                const batch = sbNum("ballsPerSpawn", 5);
                const spd = sbNum("ballsSpeed", 1.2);
                while (score - lastWASDSpawn >= pts) {
                    lastWASDSpawn += pts;
                    for (let i = 0; i < batch; i++) spawnObstacle(spd);
                }
            } else if (score - lastWASDSpawn >= 100) {
                lastWASDSpawn = score;
                for (let i = 0; i < 5; i++) spawnObstacle(1.2);
            }
        }
    }

    if (
        sandboxWasdMovementActive() &&
        gameMode !== "wasd" &&
        gameMode !== "sandbox" &&
        gameMode !== "tilt" &&
        gameMode !== "orbit" &&
        !uiCursorMode
    ) {
        const move = sbCommonNum("cursorSpeed", 4) * gameLayoutScale() * fs;
        if (keys.w) mouse.y -= move;
        if (keys.s) mouse.y += move;
        if (keys.a) mouse.x -= move;
        if (keys.d) mouse.x += move;
        const cw = clampCursorXYToEdgeInset(mouse.x, mouse.y);
        mouse.x = cw.x;
        mouse.y = cw.y;
    }

    if (gameMode === "tilt" && !uiCursorMode && !isGameplayInputFrozen()) {
        const next = tickTiltPhysics(dt, (x, y) => clampCursorXYToEdgeInset(x, y));
        mouse.x = next.x;
        mouse.y = next.y;
    }

    if (gameMode === "orbit" && !uiCursorMode && !isGameplayInputFrozen()) {
        let inputDir = 0;
        if (keys.a || keys.arrowleft || orbitHold.left) inputDir -= 1;
        if (keys.d || keys.arrowright || orbitHold.right) inputDir += 1;
        const next = tickOrbitMovement(
            dt,
            inputDir,
            canvas.width,
            canvas.height,
            getCursorRadiusForMode(),
            gameLayoutScale(),
        );
        mouse.x = next.x;
        mouse.y = next.y;

        syncOrbitLivesFromScore(score);
        tickOrbitLives(dt);

        if (!dpadPositionCustomizeMode) {
            const { count, ballSpeed } = takeOrbitSpawns(dt, score);
            for (let i = 0; i < count; i++) spawnOrbitBall(ballSpeed);
        }
    }

    if (gameMode === "darkness") {
        const pts = sbNum("pointsPerSpawn", 500);
        const batch = sbNum("ballsPerSpawn", 5);
        const spd = sbNum("ballsSpeed", 0.85);
        while (score - lastDarknessSpawn >= pts) {
            lastDarknessSpawn += pts;
            for (let i = 0; i < batch; i++) spawnObstacle(spd);
        }
    }

    const progressionActive = isProgressionLaneActive();
    if (progressionActive) {
        const band = progressionTouchBandPx();
        const hitBar =
            (progressionSide === "left" && mouse.x <= band) ||
            (progressionSide === "right" && mouse.x >= canvas.width - band);

        if (hitBar) advanceProgression();
    }

    if (replayLockCursor) {
        mouse.x = replayCursorX;
        mouse.y = replayCursorY;
        if (gameMode === "roulette") {
            roulette.pointerTarget.x = replayCursorX;
            roulette.pointerTarget.y = replayCursorY;
        }
        if (gameMode === "sandbox") {
            sandboxPointerTarget.x = replayCursorX;
            sandboxPointerTarget.y = replayCursorY;
        }
    }
}

function handleCollisions() {
    if (isLocalActive()) {
        handleLocalCollisions();
        return;
    }
    if (isMultiplayerActive() && isMpSpeedrunMode()) {
        if (!resumeCountdownActive && !isMpSpeedrunLocalFinished() && !isMpSpeedrunSpectating()) {
            handleSpeedrunCollisions();
        }
        return;
    }
    if (isMpHighwayPlaying()) {
        if (!resumeCountdownActive && isMpLocalAlive() && !isMpSpectator()) {
            notifyMpHighwayCollision();
        }
        return;
    }
    if (gameMode === "multiplayer" || isMultiplayerActive()) return;
    if (gameMode === "aim") return;
    if (gameMode === "hook") {
        for (const o of obstacles) {
            if (hookShouldSkipCursorBallCollision(o)) continue;
            if (o.hit()) {
                beginDeath(o.isHookRed ? "Red ball!" : undefined);
                break;
            }
        }
        return;
    }
    if (gameMode === "highway") {
        const cr = getCursorRadiusForMode();
        const scr = highwayCursorScreen();
        if (highwayCursorOffScreen(scr.x, scr.y, cr, canvas.width, canvas.height)) {
            beginDeath("You fell behind the camera.");
            return;
        }
        if (highwayCursorOffTrack(scr.x, cr, canvas.width)) {
            beginDeath("You left the track.");
            return;
        }
        if (highwayCollides(scr.x, scr.y, cr, canvas.height)) {
            beginDeath();
        }
        return;
    }
    if (gameMode === "speedrun") {
        handleSpeedrunCollisions();
        return;
    }
    if (gameMode === "penalty") {
        handlePenaltyCollisions();
        return;
    }
    if (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
        handleSpeedrunCollisions();
        return;
    }

    if (gameMode === "mirror") {
        const mp = mirrorCursorScreen();
        const mpPrev = mirrorCursorPos(collisionPrevMouse.x, collisionPrevMouse.y, canvas.width, canvas.height);
        for (const o of obstacles) {
            if (
                o.hitAtSweep(collisionPrevMouse.x, collisionPrevMouse.y, mouse.x, mouse.y) ||
                o.hitAtSweep(mpPrev.x, mpPrev.y, mp.x, mp.y)
            ) {
                beginDeath();
                break;
            }
        }
        return;
    }

    if (gameMode === "delay") {
        const real = getDelayRealCursorPos();
        const prev = getDelayRealPrev();
        for (const o of obstacles) {
            if (o.hitAtSweep(prev.x, prev.y, real.x, real.y)) {
                beginDeath();
                break;
            }
        }
        return;
    }

    if (gameMode === "snake") {
        const cr = getCursorRadiusForMode();
        const inset = cursorEdgeInsetPx();
        if (snakeBorderCollision(mouse.x, mouse.y, cr, canvas.width, canvas.height, inset)) {
            beginDeath("Hit the wall.");
            return;
        }
        if (snakeSelfCollision(mouse.x, mouse.y, cr, gameLayoutScale(), collisionPrevMouse.x, collisionPrevMouse.y)) {
            beginDeath("Hit your trail.");
            return;
        }
        for (let i = obstacles.length - 1; i >= 0; i--) {
            const o = obstacles[i];
            if (!o.hit()) continue;
            const hx = o.x;
            const hy = o.y;
            obstacles.splice(i, 1);
            score += 1;
            playSpeedrunCoinPickupSound();
            emitBurst(hx, hy, 8, ["#e53e3e", "#38a169", "#ffffff"], 1.05, 0, 0.9, 2.4, 10, 22);
            addShake(0.25);
            spawnSnakeApple();
        }
        return;
    }

    if (gameMode === "combo") {
        if (shouldSkipLocalCollision()) return;
        handleComboCollisions(getGameSimNowMs());
        return;
    }

    if (gameMode === "colorrush") {
        if (shouldSkipLocalCollision()) return;
        const cursorIdx = getColorRushCursorColorIdx();
        for (let i = obstacles.length - 1; i >= 0; i--) {
            const o = obstacles[i];
            if (!o.hit()) continue;
            if (o.colorRushIdx === cursorIdx) {
                const hx = o.x;
                const hy = o.y;
                const ballHex = getColorRushBallHex(o.colorRushIdx);
                obstacles.splice(i, 1);
                score += 1;
                playSpeedrunCoinPickupSound();
                emitBurst(hx, hy, 6, [ballHex, "#ffffff"], 1.05, 0, 0.9, 2.4, 8, 18);
                addShake(0.2);
                if (obstacles.length === 0) scheduleColorRushRespawn(getGameSimNowMs());
            } else {
                beginDeath("Wrong color!");
            }
            return;
        }
        return;
    }

    if (gameMode === "counter") {
        if (shouldSkipLocalCollision()) return;
        // With a gamepad (and no recent mouse), require RT/A confirm instead of auto-touch.
        if (isGamepadConnected() && !isGamepadDeferringToMouse()) return;
        const expected = getCounterNextExpected();
        const nowHit = getGameSimNowMs();
        for (let i = obstacles.length - 1; i >= 0; i--) {
            const o = obstacles[i];
            if (!o.hit()) continue;
            if (o.counterNum === expected) {
                const hx = o.x;
                const hy = o.y;
                obstacles.splice(i, 1);
                score += 1;
                advanceCounterExpected();
                resetCounterTimer(nowHit);
                playSpeedrunCoinPickupSound();
                emitBurst(hx, hy, 6, [settingBallsColor, "#ffffff"], 1.05, 0, 0.9, 2.4, 8, 18);
                addShake(0.2);
                if (getCounterNextExpected() > COUNTER_BALLS_TOTAL) {
                    scheduleCounterRespawn(nowHit);
                }
            } else {
                beginDeath("Wrong ball!");
            }
            return;
        }
        return;
    }

    if (gameMode === "heat") {
        if (shouldSkipLocalCollision()) return;
        for (const o of obstacles) {
            if (o.hit()) {
                beginDeath();
                break;
            }
        }
        return;
    }

    if (gameMode === "hunter") {
        if (shouldSkipLocalCollision()) return;
        for (const o of obstacles) {
            if (o.hit()) {
                beginDeath();
                break;
            }
        }
        return;
    }

    if (gameMode === "pop") {
        if (shouldSkipLocalCollision()) return;
        for (const o of obstacles) {
            if (o.hit()) {
                beginDeath();
                break;
            }
        }
        return;
    }

    if (gameMode === "orbit") {
        if (shouldSkipLocalCollision()) return;
        for (let i = obstacles.length - 1; i >= 0; i--) {
            const o = obstacles[i];
            if (orbitBallHitsCore(o.x, o.y, o.collisionRadius(), canvas.width, canvas.height)) {
                const hit = orbitCoreTakeHit(o.x, o.y, canvas.width, canvas.height);
                obstacles.splice(i, 1);
                playOrbitCoreHitSound();
                const rim = orbitImpactPoint(canvas.width, canvas.height, hit.angle);
                if (settingEffectParticles) {
                    emitBurst(rim.x, rim.y, 18, ["#ff4422", "#ff8844", "#ffcc66", settingBallsColor], 3.2, 0.1, 1.2, 3.6, 12, 28);
                }
                addShake(2.8);
                triggerFlash("#ff3344", 0.18, 48);
                if (hit.gameOver) beginDeath("Core breached!");
                continue;
            }
            if (o.hit()) {
                const hx = o.x;
                const hy = o.y;
                obstacles.splice(i, 1);
                playOrbitExplosionSound();
                if (settingEffectParticles) {
                    emitBurst(hx, hy, 28, [settingBallsColor, "#ffaa44", "#ffffff", "#ff6622"], 4.2, 0.12, 1.6, 4.8, 18, 42);
                }
                addShake(1.4);
                triggerFlash("#ff8844", 0.12, 40);
            }
        }
        return;
    }

    if (gameMode === "normal" || gameMode === "tilt" || gameMode === "wasd" || gameMode === "progression" || gameMode === "roulette" || gameMode === "sandbox" || gameMode === "darkness") {
        if (shouldSkipLocalCollision()) return;
        for (const o of obstacles) {
            if (o.hit()) {
                beginDeath();
                break;
            }
        }
    }

    if (gameMode === "superdot") {
        const ls = gameLayoutScale();
        const barrierR = sbNum("barrierRadius", SUPERDOT_BARRIER_RADIUS) * ls;
        const pushR = sbNum("pushRadius", SUPERDOT_PUSH_RADIUS) * ls;
        if (pushActive) {
            const pushOutSpeed = 1.6 * ls;
            for (const o of obstacles) {
                const dx = o.x - mouse.x;
                const dy = o.y - mouse.y;
                const dist = Math.hypot(dx, dy);
                const reach = pushR + o.r;
                if (dist >= reach) continue;
                if (dist > 1e-6) {
                    const nx = dx / dist;
                    const ny = dy / dist;
                    const radial = o.vx * nx + o.vy * ny;
                    if (radial < pushOutSpeed) {
                        const add = pushOutSpeed - radial;
                        o.vx += nx * add;
                        o.vy += ny * add;
                    }
                } else {
                    o.vx = Math.max(o.vx, pushOutSpeed);
                }
            }
        }
        const cursorVx = mouse.x - collisionPrevMouse.x;
        const cursorVy = mouse.y - collisionPrevMouse.y;
        const applyBarrierLaunch = (o) => {
            let dx = o.x - mouse.x;
            let dy = o.y - mouse.y;
            let dist = Math.hypot(dx, dy);
            let nx;
            let ny;
            if (dist > 1e-6) {
                nx = dx / dist;
                ny = dy / dist;
            } else {
                nx = 1;
                ny = 0;
                dist = 0;
            }
            const minDist = barrierR + o.r;
            const overlap = Math.max(0, minDist - dist);
            const inbound = Math.max(0, -(o.vx * nx + o.vy * ny));
            const cursorPush = Math.max(0, cursorVx * nx + cursorVy * ny);
            const base = Math.hypot(o.vx, o.vy) || 0.6 * ls;
            const pushSpeed = Math.min(
                4.5 * ls,
                base + overlap * 0.12 + inbound * 0.55 + cursorPush * 0.85,
            );
            // Only snap onto the ring when already inside / overlapping it.
            // Sweep hits outside the ring just get launched (no teleport onto cursor).
            if (dist < minDist) {
                o.x = mouse.x + nx * (minDist + 0.5 * ls);
                o.y = mouse.y + ny * (minDist + 0.5 * ls);
            } else {
                const cursorHit = getCursorRadiusForMode();
                const need = o.r + cursorHit + 0.5 * ls;
                if (dist < need) {
                    o.x = mouse.x + nx * need;
                    o.y = mouse.y + ny * need;
                }
            }
            o.vx = nx * pushSpeed;
            o.vy = ny * pushSpeed;
            if (performance.now() - o.lastBounceFx > 90) {
                o.lastBounceFx = performance.now();
                emitBurst(o.x, o.y, 4, ["#2d7dff", "#ffffff"], 1.1, 0, 0.9, 2.2, 10, 20);
                addShake(0.25);
            }
            playBounceSound(Math.abs(o.vx) + Math.abs(o.vy));
        };
        for (const o of obstacles) {
            if (barrierActive) {
                const dist = Math.hypot(o.x - mouse.x, o.y - mouse.y);
                const minDist = barrierR + o.r;
                if (dist < minDist) {
                    applyBarrierLaunch(o);
                    continue;
                }
            }
            if (o.hit()) {
                if (shieldActive) continue;
                // Fast cursor sweeps can tunnel through balls while Barrier is up;
                // treat those contacts as launches instead of death.
                if (barrierActive) {
                    applyBarrierLaunch(o);
                    continue;
                }
                beginDeath();
                break;
            }
        }
    }
}

function deathLoseDelayMs() {
    if (settingEffectParticles) return DEATH_LOSE_ANIM_MS;
    if (gameMode === "speedrun") {
        if (!settingFreezeOnLose) return 1000;
        return Math.max(1000, settingFreezeOnLoseSeconds * 1000);
    }
    if (!settingFreezeOnLose) return 0;
    return settingFreezeOnLoseSeconds * 1000;
}

function applyFreezeGameSecondsFromInput() {
    if (!freezeGameSecondsInput) return;
    const raw = Number(freezeGameSecondsInput.value);
    const next = Number.isFinite(raw)
        ? Math.max(FREEZE_ON_LOSE_SEC_MIN, Math.min(FREEZE_ON_LOSE_SEC_MAX, Math.round(raw * 10) / 10))
        : FREEZE_ON_LOSE_SEC_DEFAULT;
    settingFreezeOnLoseSeconds = next;
    freezeGameSecondsInput.value = String(next);
    localStorage.setItem("settingFreezeOnLoseSeconds", String(next));
}

function showComboHud() {
    if (comboHeartsRow) {
        comboHeartsRow.classList.remove("hidden");
        comboHeartsRow.setAttribute("aria-hidden", "false");
        comboHeartsRow.replaceChildren();
        for (let i = 0; i < COMBO_LIVES_MAX; i++) {
            const heart = document.createElement("span");
            heart.className = "comboHeart";
            heart.setAttribute("aria-hidden", "true");
            heart.textContent = "♥";
            comboHeartsRow.appendChild(heart);
        }
    }
    if (comboMultiplierHud) {
        comboMultiplierHud.classList.remove("hidden");
        comboMultiplierHud.setAttribute("aria-hidden", "false");
    }
    refreshComboHud(getGameSimNowMs());
}

function hideComboHud() {
    if (comboHeartsRow) {
        comboHeartsRow.classList.add("hidden");
        comboHeartsRow.setAttribute("aria-hidden", "true");
        comboHeartsRow.replaceChildren();
    }
    if (comboMultiplierHud) {
        comboMultiplierHud.classList.add("hidden");
        comboMultiplierHud.setAttribute("aria-hidden", "true");
        comboMultiplierHud.textContent = "";
    }
    if (comboToast) {
        comboToast.classList.remove("comboToast--visible");
        comboToast.classList.add("hidden");
        comboToast.setAttribute("aria-hidden", "true");
    }
}

function refreshComboHud(now = getGameSimNowMs()) {
    if (gameMode !== "combo" || !playing) return;

    if (comboHeartsRow) {
        const hearts = comboHeartsRow.querySelectorAll(".comboHeart");
        hearts.forEach((el, i) => {
            const dim = getHeartDimProgress(i);
            el.classList.toggle("comboHeart--dim", dim > 0.45);
            el.style.opacity = String(1 - dim * 0.55);
        });
    }

    const mult = getComboMultiplier();
    const deadline = getComboDeadline();
    const timerPct =
        mult > 1 && deadline > now
            ? Math.max(0, Math.min(1, (deadline - now) / COMBO_TIMEOUT_MS))
            : 0;

    if (comboMultiplierHud) {
        const pulse = now < getComboBoostFlashUntil();
        comboMultiplierHud.classList.toggle("comboMultiplierHud--pulse", pulse);
        comboMultiplierHud.classList.toggle("comboMultiplierHud--idle", mult <= 1);
        comboMultiplierHud.innerHTML =
            `${formatComboMultiplier()}` +
            (mult > 1
                ? `<span class="comboMultiplierTimer"><span class="comboMultiplierTimerFill" style="width:${Math.round(timerPct * 100)}%"></span></span>`
                : "");
    }

    if (comboToast) {
        const showLost = now < getComboLostFlashUntil();
        comboToast.textContent = "COMBO LOST";
        comboToast.classList.toggle("hidden", !showLost);
        comboToast.classList.toggle("comboToast--visible", showLost);
        comboToast.setAttribute("aria-hidden", showLost ? "false" : "true");
    }
}

function handleComboCollisions(now) {
    for (const o of obstacles) {
        if (!o.hit()) continue;
        const dead = comboTakeDamage(now);
        playComboLifeLostSound();
        triggerFlash("#ff3344", 0.22, 55);
        addShake(3.5);
        const dx = o.x - mouse.x;
        const dy = o.y - mouse.y;
        const dist = Math.hypot(dx, dy) || 1;
        const push = getCursorRadiusForMode() + o.r + 8 * gameLayoutScale();
        o.x = mouse.x + (dx / dist) * push;
        o.y = mouse.y + (dy / dist) * push;
        o.vx = (dx / dist) * Math.max(Math.abs(o.vx), 1.2);
        o.vy = (dy / dist) * Math.max(Math.abs(o.vy), 1.2);
        refreshComboHud(now);
        if (dead) beginDeath();
        return;
    }
}

/** Modes where score rises mainly by discrete player actions (animate every +N). */
const DISCRETE_SCORE_HUD_MODES = new Set(["aim", "colorrush", "counter", "hook", "snake"]);

let hudScorePulsePrev = -1;
let hudScorePulseMode = "";

function shouldPulseHudScore(prev, next, mode) {
    if (!(next > prev)) return false;
    if (DISCRETE_SCORE_HUD_MODES.has(mode)) return true;
    // Continuous (~60/sec): only when crossing a multiple of 1000.
    return Math.floor(next / 1000) > Math.floor(prev / 1000) && next >= 1000;
}

function pulseHudScoreEl(el, prev, next, mode) {
    if (!el) return;
    if (!shouldPulseHudScore(prev, next, mode)) return;
    el.classList.remove("hudScoreValue--squash");
    // Force restart of CSS animation
    void el.offsetWidth;
    el.classList.add("hudScoreValue--squash");
}

/**
 * Keep Score HUD structure stable across frames so squash/stretch can play.
 * @param {HTMLElement} host
 * @param {number} score
 * @param {string} afterHtml HTML after the score span (e.g. `<br>Best…`)
 * @param {string} [prefix="Score: "]
 * @param {string} [mode=gameMode]
 */
function setScoreHudHost(host, score, afterHtml, prefix = "Score: ", mode = gameMode) {
    if (!host) return;
    const sig = `${prefix}|${afterHtml}|${mode}`;
    let span = host.querySelector(".hudScoreValue");
    if (host.dataset.hudScoreSig !== sig || !span) {
        host.dataset.hudScoreSig = sig;
        host.innerHTML = `${prefix}<span class="hudScoreValue">${score}</span>${afterHtml}`;
        span = host.querySelector(".hudScoreValue");
        if (hudScorePulseMode !== mode) {
            hudScorePulsePrev = score;
            hudScorePulseMode = mode;
        } else if (span) {
            const prev = hudScorePulsePrev;
            pulseHudScoreEl(span, prev, score, mode);
            hudScorePulsePrev = score;
        }
        return;
    }
    const prev = hudScorePulsePrev;
    const shown = Number(span.textContent);
    if (shown !== score) {
        span.textContent = String(score);
        pulseHudScoreEl(span, prev < 0 ? shown : prev, score, mode);
        hudScorePulsePrev = score;
    }
}

function updateTopHud(now = getGameSimNowMs()) {
    if (isChallengeLobby() || gameMode === "challenges") {
        if (topCenter) {
            topCenter.textContent = "";
            topCenter.classList.remove("rouletteHud", "roulettePulse");
        }
        resetRouletteHudOverlay();
        hideComboHud();
        return;
    }
    if (!playing) {
        topCenter.textContent = "";
        topCenter.classList.remove("roulettePulse");
        resetRouletteHudOverlay();
        hideComboHud();
        return;
    }

    if (dpadPositionCustomizeMode) {
        topCenter.textContent = "";
        topCenter.classList.remove("rouletteHud", "roulettePulse");
        resetRouletteHudOverlay();
        hideComboHud();
        return;
    }

    if (gamePaused) {
        topCenter.classList.remove("rouletteHud", "roulettePulse");
        rouletteEffectText.style.opacity = "0";
        rouletteEffectText.textContent = "";
        if (gameMode === "roulette" && rouletteScoreLine) {
            setScoreHudHost(rouletteScoreLine, gameplayScoreFloor(), "", "Score: ", "roulette");
            rouletteScoreLine.style.opacity = "1";
            rouletteScoreLine.setAttribute("aria-hidden", "false");
        } else {
            resetRouletteHudOverlay();
        }
        if (resumeCountdownActive) {
            topCenter.textContent = "";
            if (gameMode === "roulette" && rouletteScoreLine) {
                setScoreHudHost(rouletteScoreLine, gameplayScoreFloor(), "", "Score: ", "roulette");
                rouletteScoreLine.style.opacity = "1";
                rouletteScoreLine.setAttribute("aria-hidden", "false");
            }
            return;
        }
        const pauseSub = isTouchGameUi()
            ? `<span style="font-size:8px;opacity:.85">${L.pauseHintTouch}</span>`
            : `<span style="font-size:8px;opacity:.85">${settingShowKeybindIndicator ? `Press ${formatKeybindDisplay(getKeybindKey("pause"))} or click Resume to continue.` : L.pauseHintNoKbd}</span>`;
        topCenter.innerHTML = `${L.pauseTitle}<br>${pauseSub}`;
        return;
    }

    if (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode()) {
        topCenter.classList.remove("rouletteHud", "roulettePulse");
        if (isMpSpeedrunLocalFinished()) {
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(getMpSpeedrunLocalFinishTime())}<br><span style="font-size:8px;opacity:.85">Level ${speedrunActiveLevel}</span>`;
        } else {
            const elapsed = getGameSimNowMs() - speedrunStartPerf;
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(elapsed)}<br><span style="font-size:8px;opacity:.85">Level ${speedrunActiveLevel}</span>`;
        }
        return;
    }

    if (gameMode === "speedrun") {
        topCenter.classList.remove("rouletteHud", "roulettePulse");
        if (practicePlayActive) {
            topCenter.innerHTML =
                `<span style="font-size:14px;font-weight:700;letter-spacing:.04em">PRACTICE</span>` +
                (practicePlayFromAdmin
                    ? `<br><span style="font-size:10px;opacity:.95;font-weight:bold">EXIT ${
                          !isTouchGameUi() && settingShowKeybindIndicator
                              ? replaceKeybindPlaceholders("[H]")
                              : ""
                      }</span>`
                    : "");
            return;
        }
        if (isChallengeTimedLevelAttempt() && !isChallengeGoalCompleted()) {
            const remMs = Math.max(0, getChallengeCountdownRemainingSec() * 1000);
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(remMs)}<br><span style="font-size:8px;opacity:.85">Level ${speedrunActiveLevel}</span>`;
            return;
        }
        const campaignRaceRem = getCampaignRaceRemainingSec();
        if (campaignRaceRem != null && isCampaignAttemptPlaying() && !isCampaignGoalCompleted()) {
            const remMs = Math.max(0, campaignRaceRem * 1000);
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(remMs)}<br><span style="font-size:8px;opacity:.85">Level ${speedrunActiveLevel}</span>`;
            return;
        }
        const elapsed = getGameSimNowMs() - speedrunStartPerf;
        if (adminSpeedrunPlaytestActive) {
            const exitLine =
                !isTouchGameUi() && settingShowKeybindIndicator
                    ? `<span style="font-size:10px;opacity:.95;font-weight:bold">EXIT ${replaceKeybindPlaceholders("[H]")}</span>`
                    : `<span style="font-size:10px;opacity:.95;font-weight:bold">EXIT</span>`;
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(elapsed)}<br>${exitLine}`;
            return;
        }
        const best = displayedSpeedrunBestMs(speedrunActiveLevel);
        const bestLabel = cloudUser ? "Best" : "Best (local)";
        topCenter.innerHTML = `Time: ${formatSpeedrunTime(elapsed)}<br>${
            best > 0 ? `${bestLabel}: ${formatSpeedrunTime(best)}` : `${bestLabel}: —`
        }<br><span style="font-size:8px;opacity:.85">Level ${speedrunActiveLevel}</span>`;
        return;
    }

    if (gameMode === "penalty") {
        topCenter.classList.remove("rouletteHud", "roulettePulse");
        const hits = penaltyRuntime.hitCount;
        if (adminPenaltyPlaytestActive) {
            const exitLine =
                !isTouchGameUi() && settingShowKeybindIndicator
                    ? `<span style="font-size:10px;opacity:.95;font-weight:bold">EXIT ${replaceKeybindPlaceholders("[H]")}</span>`
                    : `<span style="font-size:10px;opacity:.95;font-weight:bold">EXIT</span>`;
            topCenter.innerHTML = `Hits: ${formatPenaltyHits(hits)}<br>${exitLine}`;
            return;
        }
        if (isChallengeTimedLevelAttempt() && !isChallengeGoalCompleted()) {
            const remMs = Math.max(0, getChallengeCountdownRemainingSec() * 1000);
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(remMs)}<br>Hits: ${formatPenaltyHits(hits)}<br><span style="font-size:8px;opacity:.85">Level ${penaltyRuntime.activeLevel}</span>`;
            return;
        }
        const campaignRaceRem = getCampaignRaceRemainingSec();
        if (campaignRaceRem != null && isCampaignAttemptPlaying() && !isCampaignGoalCompleted()) {
            const remMs = Math.max(0, campaignRaceRem * 1000);
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(remMs)}<br>Hits: ${formatPenaltyHits(hits)}<br><span style="font-size:8px;opacity:.85">Level ${penaltyRuntime.activeLevel}</span>`;
            return;
        }
        const best = displayedPenaltyBestHits(penaltyRuntime.activeLevel);
        const bestLabel = cloudUser ? "Best" : "Best (local)";
        topCenter.innerHTML = `Hits: ${formatPenaltyHits(hits)}<br>${
            best > 0 ? `${bestLabel}: ${formatPenaltyHits(best)}` : `${bestLabel}: —`
        }<br><span style="font-size:8px;opacity:.85">Level ${penaltyRuntime.activeLevel}</span>`;
        return;
    }

    if (gameMode === "roulette") {
        topCenter.classList.add("rouletteHud");
        topCenter.textContent = String(roulette.nextDisplay);
        topCenter.classList.toggle("roulettePulse", now < roulette.pulseUntil);
        if (rouletteScoreLine) {
            setScoreHudHost(rouletteScoreLine, gameplayScoreFloor(), "", "Score: ", "roulette");
            rouletteScoreLine.style.opacity = "1";
            rouletteScoreLine.setAttribute("aria-hidden", "false");
        }
        updateRouletteLabel(now);
        return;
    }

    topCenter.classList.remove("rouletteHud");
    topCenter.classList.remove("roulettePulse");

    const hudScore = gameplayScoreFloor();

    if (gameMode === "normal") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("normal")}`);
    } else if (gameMode === "tilt") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("tilt")}`);
    } else if (gameMode === "orbit") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("orbit")}`);
    } else if (gameMode === "multiplayer") {
        const mpScore = Math.floor(getMpScore());
        const spec = isMpSpectator() ? "<br><span style=\"font-size:8px;opacity:.85\">Spectating</span>" : "";
        setScoreHudHost(topCenter, mpScore, spec, "Score: ", "multiplayer");
    } else if (gameMode === "mirror") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("mirror")}`);
    } else if (gameMode === "delay") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("delay")}`);
    } else if (gameMode === "snake") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("snake")}`);
    } else if (gameMode === "combo") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("combo")}`);
        refreshComboHud(now);
    } else if (gameMode === "wasd") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("wasd")}`);
    } else if (gameMode === "progression") {
        topCenter.dataset.hudScoreSig = "";
        topCenter.innerHTML = `Level: ${progressionLevel}<br>${formatHudBestLine("progression")}`;
    } else if (gameMode === "superdot") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("superdot")}`);
    } else if (gameMode === "highway") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("highway")}`);
    } else if (gameMode === "darkness") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("darkness")}`);
    } else if (gameMode === "colorrush") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("colorrush")}`);
    } else if (gameMode === "heat") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("heat")}`);
    } else if (gameMode === "hunter") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("hunter")}`);
    } else if (gameMode === "pop") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("pop")}`);
    } else if (gameMode === "counter") {
        setScoreHudHost(
            topCenter,
            hudScore,
            `<br>${formatHudBestLine("counter")}<br><span style="font-size:8px;opacity:.85">Next: ${getCounterNextExpected()}</span>`,
        );
    } else if (gameMode === "aim") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("aim")}`);
    } else if (gameMode === "hook") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("hook")}`);
    } else if (gameMode === "roulette") {
        setScoreHudHost(topCenter, hudScore, `<br>${formatHudBestLine("roulette")}`);
    } else if (gameMode === "sandbox") {
        if (sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) {
            topCenter.dataset.hudScoreSig = "";
            const elapsed = getGameSimNowMs() - speedrunStartPerf;
            const best = displayedSandboxSpeedrunBestMs();
            const bestLabel = cloudUser ? "Best" : "Best (local)";
            topCenter.innerHTML = `Time: ${formatSpeedrunTime(elapsed)}<br>${
                best > 0 ? `${bestLabel}: ${formatSpeedrunTime(best)}` : `${bestLabel}: —`
            }<br><span style="font-size:8px;opacity:.85">SANDBOX SpeedRun · avoid red walls</span>`;
        } else if (sandboxProgressionOverlayEnabled()) {
            topCenter.dataset.hudScoreSig = "";
            topCenter.innerHTML = `SANDBOX<br>Level: ${progressionLevel}<br>${sandboxRunBestLine() || ""}`;
        } else {
            setScoreHudHost(topCenter, hudScore, `<br>${sandboxRunBestLine() || ""}`, "SANDBOX<br>Score: ", "sandbox");
        }
    }
}

function updateSuperHUD() {
    if (gameMode !== "superdot") {
        setSuperHudVisible(false);
        return;
    }

    setSuperHudVisible(true);

    const now = Date.now();

    const shieldLeft = Math.max(0, 15 - Math.floor((now - lastShieldUse) / 1000));
    const slowLeft = Math.max(0, 15 - Math.floor((now - lastSlowUse) / 1000));
    const barrierLeft = Math.max(0, 30 - Math.floor((now - lastBarrierUse) / 1000));
    const pushLeft = Math.max(0, 30 - Math.floor((now - lastPushUse) / 1000));

    const shieldReady = shieldLeft === 0;
    const slowReady = slowLeft === 0;
    const barrierReady = barrierLeft === 0;
    const pushReady = pushLeft === 0;

    shieldText.className = "superdot-skill-label " + (shieldReady ? "hudReady" : "hudCooldown");
    shieldTime.className = "superdot-skill-timer hudTime " + (shieldReady ? "hudReady" : "hudCooldown");
    shieldTime.textContent = shieldReady ? "READY" : `${shieldLeft}s`;

    slowText.className = "superdot-skill-label " + (slowReady ? "hudReady" : "hudCooldown");
    slowTime.className = "superdot-skill-timer hudTime " + (slowReady ? "hudReady" : "hudCooldown");
    slowTime.textContent = slowReady ? "READY" : `${slowLeft}s`;

    if (barrierText && barrierTime) {
        barrierText.className = "superdot-skill-label " + (barrierReady ? "hudReady" : "hudCooldown");
        barrierTime.className = "superdot-skill-timer hudTime " + (barrierReady ? "hudReady" : "hudCooldown");
        barrierTime.textContent = barrierReady ? "READY" : `${barrierLeft}s`;
    }

    if (pushText && pushTime) {
        pushText.className = "superdot-skill-label " + (pushReady ? "hudReady" : "hudCooldown");
        pushTime.className = "superdot-skill-timer hudTime " + (pushReady ? "hudReady" : "hudCooldown");
        pushTime.textContent = pushReady ? "READY" : `${pushLeft}s`;
    }
}

/** Pause / Return HUD: invisible when pointer/cursor (or in-game cursor on canvas) is over the control; opacity ramps up as it moves away. Same on mobile and desktop. */
/** Pixels from button edge to full opacity (`opacity = min(1, d/this)`); larger = fade starts farther away. */
const HUD_BTN_FADE_RANGE_PX = 140;
const HUD_BTN_POINTER_EVENTS_THRESHOLD = 0.07;

let lastHudPointerClient = { x: 0, y: 0 };
let lastHudPointerClientValid = false;

window.addEventListener(
    "pointermove",
    (e) => {
        if (!playing) return;
        lastHudPointerClient.x = e.clientX;
        lastHudPointerClient.y = e.clientY;
        lastHudPointerClientValid = true;
    },
    { passive: true },
);

function distPointToRect(px, py, rect) {
    const cx = clamp(px, rect.left, rect.right);
    const cy = clamp(py, rect.top, rect.bottom);
    return Math.hypot(px - cx, py - cy);
}

function canvasGameCursorToClient(mx, my) {
    if (!canvas) return { x: 0, y: 0 };
    const rect = canvas.getBoundingClientRect();
    const cw = canvas.width || 1;
    const ch = canvas.height || 1;
    return {
        x: rect.left + (mx / cw) * rect.width,
        y: rect.top + (my / ch) * rect.height,
    };
}

function getHudProximityClientPoint() {
    if (!canvas || !playing) return { x: 0, y: 0 };
    if (gamePaused && lastHudPointerClientValid) {
        return { x: lastHudPointerClient.x, y: lastHudPointerClient.y };
    }
    if (isMultiplayerActive() && isMpSpeedrunSpectating()) {
        const sp = getMpSpectateCursorCanvas(canvas.width, canvas.height);
        if (sp) return canvasGameCursorToClient(sp.x, sp.y);
    }
    return canvasGameCursorToClient(mouse.x, mouse.y);
}

function opacityForHudProximity(px, py, rect) {
    const d = distPointToRect(px, py, rect);
    return Math.min(1, d / (HUD_BTN_FADE_RANGE_PX * gameLayoutScale()));
}

function applyHudButtonProximityStyle(el, px, py) {
    const r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) {
        el.style.opacity = "";
        el.style.pointerEvents = "";
        return;
    }
    const o = opacityForHudProximity(px, py, r);
    el.style.opacity = String(o);
    el.style.pointerEvents = o < HUD_BTN_POINTER_EVENTS_THRESHOLD ? "none" : "";
}

function resetPlayingHudButtonsOpacity() {
    if (returnBtn) {
        returnBtn.style.opacity = "";
        returnBtn.style.pointerEvents = "";
    }
    if (pauseTopBtn) {
        pauseTopBtn.style.opacity = "";
        pauseTopBtn.style.pointerEvents = "";
    }
    const finList = document.getElementById("mpSpeedrunFinisherList");
    if (finList) {
        finList.style.opacity = "";
        finList.style.pointerEvents = "";
    }
    lastHudPointerClientValid = false;
}

function updateMpSpeedrunSpectateChrome() {
    const bar = document.getElementById("mpSpectateBar");
    const label = document.getElementById("mpSpectateLabel");
    const list = document.getElementById("mpSpeedrunFinisherList");
    const resultsOpen = document.getElementById("mpSpeedrunResultsScreen") &&
        !document.getElementById("mpSpeedrunResultsScreen")!.classList.contains("hidden");
    const showSpectate = playing && isMultiplayerActive() && isMpSpeedrunMode() && isMpSpeedrunLocalFinished() && isMpSpeedrunSpectating() && !resultsOpen;
    if (bar) bar.classList.toggle("hidden", !showSpectate);
    if (label && showSpectate) label.textContent = `Spectating: ${getMpSpectateTargetName()}`;
    if (list) {
        const showList = playing && isMultiplayerActive() && isMpSpeedrunMode() && getMpSpeedrunFinishers().length > 0 && !resultsOpen;
        list.classList.toggle("hidden", !showList);
        if (showList) {
            list.replaceChildren();
            for (const f of getMpSpeedrunFinishers()) {
                const li = document.createElement("li");
                li.textContent = `${f.name} — ${formatSpeedrunTime(f.timeMs)}`;
                list.appendChild(li);
            }
        }
    }
    if (showSpectate && !isTouchGameUi()) {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
    }
}

function updateMpSpeedrunFinisherListProximity() {
    const list = document.getElementById("mpSpeedrunFinisherList");
    if (!list || list.classList.contains("hidden") || !playing) return;
    const { x: px, y: py } = getHudProximityClientPoint();
    applyHudButtonProximityStyle(list, px, py);
}

function updatePlayingHudButtonsProximityOpacity() {
    if (document.body.classList.contains("mp-results-active")) {
        resetPlayingHudButtonsOpacity();
        return;
    }
    if (!playing) {
        resetPlayingHudButtonsOpacity();
        return;
    }
    const { x: px, y: py } = getHudProximityClientPoint();
    if (returnBtn && !returnBtn.classList.contains("hidden")) {
        applyHudButtonProximityStyle(returnBtn, px, py);
    } else if (returnBtn) {
        returnBtn.style.opacity = "";
        returnBtn.style.pointerEvents = "";
    }
    if (pauseTopBtn && !pauseTopBtn.classList.contains("hidden")) {
        applyHudButtonProximityStyle(pauseTopBtn, px, py);
    } else if (pauseTopBtn) {
        pauseTopBtn.style.opacity = "";
        pauseTopBtn.style.pointerEvents = "";
    }
    updateMpSpeedrunFinisherListProximity();
    const oppHud = document.getElementById("tournamentOpponentHud");
    if (oppHud) {
        if (isTournamentPlaying()) {
            oppHud.classList.remove("hidden");
            oppHud.setAttribute("aria-hidden", "false");
            const score = getTournamentOpponentScore();
            const fin = isTournamentOpponentFinished();
            oppHud.textContent = fin
                ? `Opponent Score: ${score ?? "—"}`
                : `Opponent Score: ${score ?? "…"}`;
            oppHud.classList.toggle("tournamentOpponentHud--lost", fin);
            applyHudButtonProximityStyle(oppHud, px, py);
        } else {
            oppHud.classList.add("hidden");
            oppHud.setAttribute("aria-hidden", "true");
            oppHud.style.opacity = "";
            oppHud.style.pointerEvents = "";
        }
    }
}

function loop(rafNow) {
    const now = typeof rafNow === "number" ? rafNow : performance.now();
    const menuIdle = isMenuIdleLoopThrottled();

    if (menuIdle) {
        if (typeof document !== "undefined" && document.hidden) {
            wasMenuIdleLoopThrottled = true;
            requestAnimationFrame(loop);
            return;
        }
        if (lastMenuIdlePaintAt > 0 && now - lastMenuIdlePaintAt < MENU_IDLE_LOOP_MIN_MS) {
            wasMenuIdleLoopThrottled = true;
            requestAnimationFrame(loop);
            return;
        }
        lastMenuIdlePaintAt = now;
    } else if (wasMenuIdleLoopThrottled || lastMenuIdlePaintAt !== 0) {
        resetFrameClockLeavingMenuIdle(now);
    }

    if (!menuIdle && replayReentryDepth === 0) {
        const minFrameMs = getGameplayFpsMinFrameMs();
        if (minFrameMs > 0 && lastFpsLimitedFrameAt > 0 && now - lastFpsLimitedFrameAt < minFrameMs) {
            requestAnimationFrame(loop);
            return;
        }
        lastFpsLimitedFrameAt = now;
    }

    noteFpsFrame(now);
    let dt = clampFrameDtSec((now - lastFrameTime) / 1000);
    if (replayReentryDepth === 0) lastFrameTime = now;

    // Lock-step recording: simulate with the same quantized dt that will be stored,
    // so playback (seed + inputs + dts) reconstructs this exact run.
    if (
        !isReplayPlaybackActive() &&
        activeReplayRecorder &&
        activeReplayRecorder.isActive &&
        playing &&
        !deathPending &&
        !gamePaused &&
        !resumeCountdownActive
    ) {
        dt = quantizeDtMs(dt) / 1000;
    }

    // Replay: drive dt + cursor from the recorded stream (deterministic playback).
    if (isReplayPlaybackActive() && playing && !deathPending && !replayDeathFrozen) {
        if (replayReentryDepth === 0 && consumeReplayNeedsGameRestart()) {
            applyReplaySeekRestart();
        }
        if (replayReentryDepth === 0) {
            if (isReplaySeeking() && !replaySeekReached()) {
                replayStepsLeftThisTick = 120;
            } else {
                replayStepsLeftThisTick = takeReplayFrameStepsThisTick();
            }
        }
        if (replayStepsLeftThisTick <= 0) {
            dt = 0;
        } else {
            const stepDt = stepReplayPlaybackFrame(mouse, keys, canvas.width, canvas.height);
            if (stepDt == null) {
                dt = 0;
                replayStepsLeftThisTick = 0;
                freezeReplayAtStreamEnd();
            } else {
                dt = stepDt;
                replayStepsLeftThisTick--;
                // Keep secondary cursor targets aligned so lerp/WASD paths cannot tug the cursor.
                if (gameMode === "roulette") {
                    roulette.pointerTarget.x = mouse.x;
                    roulette.pointerTarget.y = mouse.y;
                }
                if (gameMode === "sandbox") {
                    sandboxPointerTarget.x = mouse.x;
                    sandboxPointerTarget.y = mouse.y;
                }
            }
        }
        if (replayReentryDepth === 0) syncReplayControlsUi();
    } else if (isReplayPlaybackActive() && replayReentryDepth === 0) {
        syncReplayControlsUi();
    }

    pollGamepadInFrame(dt);

    tickChallengeRedMusicDuck(dt);

    if (playing && !gamePaused && !deathPending) {
        playTime += dt;
    }
    if (playing && now - lastPlayTimeUpdate >= 1000) {
        lastPlayTimeUpdate = now;
        writeStored(KEY_PLAYTIME, Math.floor(playTime));
        void syncPlayerStatsToCloud();
    }

    if (statsScreen && !statsScreen.classList.contains("hidden")) {
        if (now - lastStatsUiUpdate >= 200) {
            lastStatsUiUpdate = now;
            refreshStatsPlaytimeOnly();
        }
    }

    // Menu idle: skip — music is suspended; resume only on user gesture.
    // Playing / pause still need music state each frame.
    if (playing || !menuAudioIdleSuspended) {
        updateMusicState();
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!playing) {
        clearGameCursorTopLayer();
    }

    if (deathPending) {
        tickDeathFrame(now, dt);
        requestAnimationFrame(loop);
        return;
    }

    // Challenges loss cinematic: freeze balls, soft-collide cursor, then fade to red square.
    if (isChallengeDeathSequence()) {
        applyMobileJoystickInput(dt);
        if (!isLocalActive()) {
            applyTouchCursorAnalogInLoop(dt);
            pollTouchSteerInGameLoop();
        }
        if (isChallengeDeathWorldActive()) {
            resolveChallengeDeathCursorCollisions();
            updateTopHud(now);
            renderScene(true, 0);
            drawChallengeDeathAshes();
        } else if (isChallengeDeathShowingLobby() || gameMode === "challenges") {
            constrainChallengeLobbyCursor();
            updateTopHud(now);
            renderScene(true, 0);
            drawChallengeLobbySquare(ctx, canvas.width, canvas.height);
        } else {
            // black_in / lost_hold: empty field under rising veil + YOU LOST panel
            updateTopHud(now);
            renderScene(true, 0);
        }
        tickChallengeDeathSequence(now, dt);
        decayScreenShake(dt);
        requestAnimationFrame(loop);
        return;
    }

    // Marathon loss cinematic (same ash/black sequence; progress bar instead of YOU LOST).
    if (isMarathonDeathSequence()) {
        applyMobileJoystickInput(dt);
        if (!isLocalActive()) {
            applyTouchCursorAnalogInLoop(dt);
            pollTouchSteerInGameLoop();
        }
        if (isMarathonDeathWorldActive()) {
            resolveChallengeDeathCursorCollisions();
            updateTopHud(now);
            renderScene(true, 0);
            drawChallengeDeathAshes();
        } else {
            updateTopHud(now);
            renderScene(true, 0);
        }
        tickMarathonDeathSequence(now, dt);
        decayScreenShake(dt);
        requestAnimationFrame(loop);
        return;
    }

    if (playing) {
        updatePlayingHudButtonsProximityOpacity();
        syncMessageNotifyToastVisibility();
        pollMessageInboxWhilePlaying(now);
        if (now - lastAchievementPollMs >= ACHIEVEMENT_POLL_INTERVAL_MS) {
            lastAchievementPollMs = now;
            void pollAchievementUnlocksNow();
        }
        if (gameMode === "roulette" && !gamePaused) updateRoulette(getGameSimNowMs(), dt);

        if (gamePaused) {
            updateTopHud(now);
            renderActiveGameFrame(false, dt);
            decayScreenShake(dt);
            requestAnimationFrame(loop);
            return;
        }

        // Play transition: game is set up under the veil but nothing moves until it clears.
        if (isPlayTransitionRunning()) {
            updateTopHud(now);
            renderScene(true, 0);
            decayScreenShake(dt);
            requestAnimationFrame(loop);
            return;
        }

        // Challenges lobby: cursor + neon square only (no balls / HUD / pause).
        if (gameMode === "challenges" || isChallengeLobby()) {
            applyMobileJoystickInput(dt);
            if (!isLocalActive()) {
                applyTouchCursorAnalogInLoop(dt);
                pollTouchSteerInGameLoop();
            }
            tickChallengeLobby(now, dt);
            constrainChallengeLobbyCursor();
            updateTopHud(now);
            renderScene(true, 0);
            drawChallengeLobbySquare(ctx, canvas.width, canvas.height);
            decayScreenShake(dt);
            requestAnimationFrame(loop);
            return;
        }

        // Challenges attempt: accumulate play time; goal check runs after score/collisions.
        if (isChallengeAttemptPlaying()) {
            noteChallengePlayFrame(now, !!gamePaused);
            tickChallengeReturnSure(now);
        }
        if (isCampaignAttemptPlaying()) {
            noteCampaignPlayFrame(now, !!gamePaused);
        }

        // Practice Guide tip: freeze world (balls/lasers) but keep cursor + zone detection.
        if (isPracticeGuideFrozen()) {
            applyMobileJoystickInput(dt);
            if (!isLocalActive()) {
                applyTouchCursorAnalogInLoop(dt);
                pollTouchSteerInGameLoop();
            }
            if (gameMode === "speedrun") handleSpeedrunCollisions();
            updateTopHud(now);
            renderScene(true, 0);
            decayScreenShake(dt);
            requestAnimationFrame(loop);
            return;
        }

        if (!isReplayPlaybackActive()) {
            applyMobileJoystickInput(dt);
            if (!isLocalActive()) {
                applyTouchCursorAnalogInLoop(dt);
                pollTouchSteerInGameLoop();
            }
        }
        if (isLocalActive()) {
            tickLocalMultiplayer(dt);
        }
        if (isLootDropActive()) {
            tickLootDrop(dt);
        }
        if (isSoccerActive()) {
            tickSoccer(dt);
        }
        if (isLocalActive() && isLocalMatchUpdatesFrozen()) {
            updateTopHud(now);
            renderLocalEndBackdrop();
            decayScreenShake(dt);
            requestAnimationFrame(loop);
            return;
        }
        // Simulation clock: advances only while the match is stepping (paused/frozen = hold).
        if (!resumeCountdownActive) {
            advanceGameSimClock(dt);
        }
        if (isReplayPlaybackActive() && isReplaySeeking() && replaySeekReached()) {
            clearReplaySeekTarget();
        }
        const simNow = getGameSimNowMs();
        if (isLocalActive() && !resumeCountdownActive && !isLocalMatchUpdatesFrozen()) {
            const lm = getLocalConfig()?.mode;
            const sandboxSr = lm === "sandbox" && sandboxRuntimeConfig?.speedrunMode;
            if (
                lm === "normal" ||
                lm === "wasd" ||
                lm === "heat" ||
                lm === "hunter" ||
                lm === "snake" ||
                (lm === "sandbox" && !sandboxSr)
            ) {
                score += SCORE_PER_SEC * dt;
            }
        }
        if (
            !dpadPositionCustomizeMode &&
            !isLocalActive() &&
            !isLootDropActive() &&
            !isSoccerActive() &&
            gameMode !== "challenges" &&
            gameMode !== "speedrun" &&
            !(gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) &&
            gameMode !== "multiplayer" &&
            gameMode !== "colorrush" &&
            gameMode !== "counter" &&
            gameMode !== "aim" &&
            gameMode !== "hook" &&
            gameMode !== "snake"
        ) {
            if (gameMode === "combo") {
                tickComboHearts(dt);
                const boosted = updateComboNearDodges(
                    obstacles,
                    mouse.x,
                    mouse.y,
                    getCursorRadiusForMode(),
                    gameLayoutScale(),
                    simNow,
                );
                if (boosted) {
                    playSpeedrunCoinPickupSound();
                    emitBurst(mouse.x, mouse.y, 8, ["#ffcc44", "#ffffff"], 1.1, 0, 0.9, 2.6, 10, 22);
                    addShake(0.35);
                }
                refreshComboHud(simNow);
                score += SCORE_PER_SEC * dt * getComboMultiplier();
            } else {
                score += SCORE_PER_SEC * dt;
            }
        }
        if (gameMode === "highway") {
            updateHighway(dt, score, canvas.width, canvas.height, gameLayoutScale());
        }
        syncGameLogic(dt);
        if (gameMode === "multiplayer" && playing) {
            ensureMultiplayerGameRunning();
            tickMultiplayer(dt);
        }
        if (gameMode === "darkness") {
            const cr = getCursorRadiusForMode();
            const dark = updateDarkness(
                dt,
                score,
                mouse.x,
                mouse.y,
                cr,
                canvas.width,
                canvas.height,
                gameLayoutScale(),
                cursorEdgeInsetPx(),
            );
            if (dark.pointCollected) {
                playSpeedrunCoinPickupSound();
                emitBurst(mouse.x, mouse.y, 6, ["#fff6a8", "#ffffff"], 1.05, 0, 0.85, 2.4, 8, 18);
            }
            updateDarknessTensionAudio(getDarknessDanger(), dt);
            if (dark.visionDead) {
                beginDeath("Your vision faded to nothing.");
                tickDeathFrame(now, dt);
                requestAnimationFrame(loop);
                return;
            }
        }
        if (gameMode === "colorrush") {
            const colorChanged = tickColorRushColorCycle(dt * 1000, simNow);
            if (colorChanged) {
                triggerFlash(getColorRushCursorHex(), 0.22, 70);
                playSpeedrunCoinPickupSound();
            }
            if (tickColorRushRespawn(simNow)) {
                if (isLocalActive()) spawnLocalColorRushBalls(getLocalConfig());
                else spawnColorRushBalls();
                syncBallCollisionPrevMouse();
                triggerFlash(getColorRushCursorHex(), 0.18, 60);
                playSpeedrunCoinPickupSound();
            }
        }
        if (gameMode === "counter" && !deathPending && !gamePaused && !resumeCountdownActive) {
            const timerFrozen = isCounterAwaitingRespawn(simNow);
            if (tickCounterTimer(simNow, gamePaused || resumeCountdownActive || timerFrozen)) {
                beginDeath("Time's up!");
                tickDeathFrame(now, dt);
                requestAnimationFrame(loop);
                return;
            }
            if (tickCounterRespawn(simNow)) {
                resetCounterWave(simNow);
                spawnCounterBalls();
                syncBallCollisionPrevMouse();
                triggerFlash("#aaff66", 0.18, 60);
                playSpeedrunCoinPickupSound();
            }
        }
        if (gameMode === "aim" && !deathPending && !gamePaused && !resumeCountdownActive) {
            const aimNow = simNow;
            const waveEv = tickAimWave(aimNow);
            if (waveEv === "startFadeIn") {
                spawnAimBalls();
                syncBallCollisionPrevMouse();
                triggerFlash("#ffd84d", 0.14, 50);
            } else if (waveEv === "fadeComplete") {
                resetAimTimer(aimNow);
                triggerFlash("#ffd84d", 0.18, 60);
                playSpeedrunCoinPickupSound();
            }
            const aimTimerFrozen = isAimTimerFrozen(aimNow, gamePaused || resumeCountdownActive);
            if (tickAimTimer(aimNow, aimTimerFrozen)) {
                beginDeath("Time's up!");
                tickDeathFrame(now, dt);
                requestAnimationFrame(loop);
                return;
            }
        }
        if (gameMode === "hook" && !deathPending && !gamePaused && !resumeCountdownActive) {
            const hookEv = tickHook(
                simNow,
                dt,
                mouse.x,
                mouse.y,
                canvas.width,
                canvas.height,
                obstacles,
                gameLayoutScale(),
                cursorEdgeInsetPx(),
                getCursorRadiusForMode(),
            );
            playPendingHookCatchSfx();
            if (hookEv?.type === "red_at_cursor") {
                beginDeath("Red ball!");
                tickDeathFrame(now, dt);
                requestAnimationFrame(loop);
                return;
            }
            if (hookEv?.type === "retract_complete") {
                if (hookEv.hadRed) {
                    beginDeath("Red ball!");
                    tickDeathFrame(now, dt);
                    requestAnimationFrame(loop);
                    return;
                }
                completeHookCatchBatch(hookEv.balls);
            }
        }
        if (gameMode === "heat" && !deathPending && !gamePaused && !resumeCountdownActive && !isLocalActive()) {
            const heatDeath = tickHeat(
                collisionPrevMouse.x,
                collisionPrevMouse.y,
                mouse.x,
                mouse.y,
                dt,
                gameLayoutScale(),
            );
            if (heatDeath) {
                beginDeath(getHeatDeathMessage(heatDeath));
                tickDeathFrame(now, dt);
                requestAnimationFrame(loop);
                return;
            }
        }
        if (!isSoccerActive()) handleCollisions();
        if (usesLocalBallCollisionSweep()) {
            syncBallCollisionPrevMouse();
        }
        // Record AFTER cursor-driving logic + collisions so playback restores the same mouse
        // that produced hits/spawns this frame (WASD / roulette lerp / tilt / orbit).
        if (activeReplayRecorder && activeReplayRecorder.isActive && !isReplayPlaybackActive()) {
            activeReplayRecorder.recordFrame(dt, mouse.x, mouse.y, canvas.width, canvas.height);
        }
        if (gameMode === "snake" && !deathPending && !gamePaused && !resumeCountdownActive && !isLocalActive()) {
            appendSnakeTrailPoint(mouse.x, mouse.y, gameLayoutScale());
        }
        if (deathPending && !isMultiplayerActive()) {
            tickDeathFrame(now, dt);
            requestAnimationFrame(loop);
            return;
        }

        if (isChallengeAttemptPlaying() && !isChallengeGoalCompleted() && checkChallengeGoalMet()) {
            onChallengeGoalReached();
        }
        if (isChallengeAttemptPlaying() && checkChallengeTimeExpired()) {
            beginDeath("Time's up");
            requestAnimationFrame(loop);
            return;
        }
        if (isCampaignAttemptPlaying() && !isCampaignGoalCompleted() && checkCampaignGoalMet()) {
            onCampaignGoalReached();
        }
        if (isCampaignAttemptPlaying() && isCampaignRaceTimedOut()) {
            beginDeath("Time's up");
            requestAnimationFrame(loop);
            return;
        }
        if (isMarathonAttemptPlaying()) {
            tickMarathonPlayElapsed(now, { paused: gamePaused });
            tickMarathonReturnSure(now);
        }
        if (isMarathonAttemptPlaying() && !isMarathonAdvancing() && checkMarathonGoalMet()) {
            void onMarathonGoalReached();
        }
        if (isMarathonAttemptPlaying() && isMarathonRaceTimedOut()) {
            beginDeath("Time's up");
            requestAnimationFrame(loop);
            return;
        }

        if (
            (gameMode === "speedrun" || (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode)) &&
            canvas.width > 0 &&
            canvas.height > 0
        ) {
            speedrunLastNorm.nx = clamp(mouse.x / canvas.width, 0, 1);
            speedrunLastNorm.ny = clamp(mouse.y / canvas.height, 0, 1);
        }

        updateTopHud(simNow);

        if (gameMode === "superdot") {
            updateSuperHUD();
        } else {
            setSuperHudVisible(false);
        }

        if (settingTrailEnabled && gameMode !== "snake" && !(isMultiplayerActive() && isMpSnakeMode())) {
            if (isMultiplayerActive() && (isMpSpectator() || !isMpLocalAlive() || isMpSpeedrunLocalFinished())) {
                trail = [];
                clearTrailParticles();
            }
            const skipLocalTrail =
                isMultiplayerActive() &&
                (!isMpLocalAlive() || isMpSpectator() || isMpSpeedrunLocalFinished());
            if (!skipLocalTrail) {
                const trailPt =
                    gameMode === "highway"
                        ? highwayCursorScreen()
                        : isMpHighwayPlaying()
                          ? mpHighwayMouseScreen()
                          : gameMode === "delay"
                            ? getDelayRealCursorPos()
                            : { x: mouse.x, y: mouse.y };
                const equippedTrail = getEquippedTrailLayer();
                if (equippedTrail?.trailMode === "particle") {
                    // Particle cosmetics: one fixed stamp at a time (~1s), shorter life when moving fast.
                    trail = [];
                    let speed = 0;
                    if (trailParticlePrev) {
                        const d = Math.hypot(
                            trailPt.x - trailParticlePrev.x,
                            trailPt.y - trailParticlePrev.y,
                        );
                        speed = d / Math.max(1e-3, dt);
                    }
                    const moving = speed > Math.max(12, 14 * gameLayoutScale());
                    trailParticleStamps = updateTrailParticleStamps(
                        trailParticleStamps,
                        dt,
                        speed,
                    );
                    if (moving) {
                        const cr = getCursorRadiusForMode();
                        const particleSize = Math.max(
                            28 * gameLayoutScale(),
                            cr * (COSMETIC_ART_SIZE / COSMETIC_REF_CURSOR_R) * 0.58,
                        );
                        trailParticleStamps = trySpawnTrailParticleStamp(
                            trailParticleStamps,
                            trailPt.x,
                            trailPt.y,
                            speed,
                            {
                                minSpacing: Math.max(22, particleSize * 0.85),
                                maxStamps: 16,
                            },
                        );
                    }
                    trailParticlePrev = { x: trailPt.x, y: trailPt.y };
                } else {
                    clearTrailParticles();
                    const srTrail =
                        gameMode === "speedrun" ||
                        (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode);
                    if (speedrunPortalTrailBridge && srTrail) {
                        const b = speedrunPortalTrailBridge;
                        const jumpTh = Math.max(48 * gameLayoutScale(), canvas.width * 0.08);
                        if (trail.length > 0) {
                            const prev = trail[0];
                            const toEntry = Math.hypot(prev.x - b.entryX, prev.y - b.entryY);
                            if (toEntry > jumpTh) {
                                prev.breakAfter = true;
                                trail.unshift({
                                    x: b.entryX,
                                    y: b.entryY,
                                    life: 12,
                                    breakBefore: true,
                                    breakAfter: true,
                                });
                            } else {
                                trail[0].x = b.entryX;
                                trail[0].y = b.entryY;
                                trail[0].breakAfter = true;
                            }
                        } else {
                            trail.unshift({ x: b.entryX, y: b.entryY, life: 12, breakAfter: true });
                        }
                        trail.unshift({ x: b.exitX, y: b.exitY, life: 12, breakBefore: true });
                        trail.unshift({ x: trailPt.x, y: trailPt.y, life: 12 });
                        speedrunPortalTrailBridge = null;
                    } else if (srTrail && trail.length > 0) {
                        const prev = trail[0];
                        const dist = Math.hypot(trailPt.x - prev.x, trailPt.y - prev.y);
                        const jumpTh = Math.max(48 * gameLayoutScale(), canvas.width * 0.08);
                        const minTrailDist = Math.max(2.5, 2.5 * gameLayoutScale());
                        if (dist > jumpTh && !prev.breakAfter) {
                            prev.breakAfter = true;
                            trail.unshift({
                                x: trailPt.x,
                                y: trailPt.y,
                                life: 12,
                                breakBefore: true,
                                animOffset: performance.now() % 10000,
                            });
                        } else if (dist >= minTrailDist) {
                            trail.unshift({
                                x: trailPt.x,
                                y: trailPt.y,
                                life: 12,
                                animOffset: performance.now() % 10000,
                            });
                        }
                    } else {
                        const minTrailDist = Math.max(2.5, 2.5 * gameLayoutScale());
                        if (
                            trail.length === 0 ||
                            Math.hypot(trailPt.x - trail[0].x, trailPt.y - trail[0].y) >= minTrailDist
                        ) {
                            trail.unshift({
                                x: trailPt.x,
                                y: trailPt.y,
                                life: 12,
                                animOffset: performance.now() % 10000,
                            });
                        }
                    }
                    if (trail.length > 14) trail.pop();
                    updateTrail(dt);
                }
            } else {
                trail = [];
                clearTrailParticles();
            }
        } else {
            trail = [];
            clearTrailParticles();
        }
        const srPortalFx =
            gameMode === "speedrun" ||
            (gameMode === "sandbox" && sandboxRuntimeConfig && sandboxRuntimeConfig.speedrunMode) ||
            (gameMode === "multiplayer" && isMultiplayerActive() && isMpSpeedrunMode());
        if (srPortalFx && speedrunPortalsNorm.length) {
            const fs = frameScale(dt);
            updateSpeedrunPortalFx(
                speedrunPortalsNorm,
                canvas.width,
                canvas.height,
                fs,
                gameLayoutScale(),
            );
        }
        updateParticles(dt);

        const seekingBurst =
            isReplayPlaybackActive() &&
            isReplaySeeking() &&
            !replaySeekReached() &&
            replayReentryDepth < 119;
        const speedBurst =
            isReplayPlaybackActive() &&
            !isReplaySeeking() &&
            replayStepsLeftThisTick > 0 &&
            replayReentryDepth < 7;
        if (!seekingBurst && !speedBurst) {
            renderActiveGameFrame(isLocalPreRoundFrozen(), dt);
            updateMpSpeedrunSpectateChrome();
            decayScreenShake(dt);
        }
    } else {
        resetPlayingHudButtonsOpacity();
        hideMessageNotifyToast();
    }

    // Replay seek / speed: process more recorded frames in this turn (nested loop calls).
    if (
        isReplayPlaybackActive() &&
        playing &&
        !deathPending &&
        !gamePaused
    ) {
        const seeking = isReplaySeeking() && !replaySeekReached();
        const moreSteps = seeking || replayStepsLeftThisTick > 0;
        if (moreSteps && replayReentryDepth < (seeking ? 120 : 8)) {
            replayReentryDepth++;
            try {
                loop(now);
            } finally {
                replayReentryDepth--;
            }
            return;
        }
    }

    requestAnimationFrame(loop);
}

setupMobileControls();
setupGamepadControls();
refreshMenuKbdLabels();
configureReplayUi({
    onReturn: () => exitReplayViewer(),
    onSeekRestart: () => {
        if (replayDeathFrozen) {
            replayDeathFrozen = false;
            deathPending = false;
            clearDeathState();
            hideEl(gameOverScreen);
        }
        if (consumeReplayNeedsGameRestart()) {
            applyReplaySeekRestart();
        }
    },
});
wireReplayControls();
loop();

document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
        stopMenuMusic();
    } else {
        updateMusicState();
    }
});

window.addEventListener("resize", () => {
    if (settingsScreen && !settingsScreen.classList.contains("hidden")) {
        scheduleSettingsCardWidthSync();
        refreshDpadSettingsVisibility();
    }
});

function setActiveSettingsNavButton(sectionId) {
    const nav = document.getElementById("settingsSectionNav");
    if (!nav) return;
    nav.querySelectorAll(".settingsSectionNavBtn").forEach((btn) => {
        btn.classList.toggle(
            "settingsSectionNavBtn--active",
            btn.getAttribute("data-settings-section") === sectionId,
        );
    });
}

function ensureSettingsAccordionOpen(detailsEl) {
    if (!detailsEl || detailsEl.classList.contains("settingsAccordion--expanded")) {
        return Promise.resolve();
    }
    const reduceMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const openUnlockMs = reduceMotion ? 40 : 280;
    return new Promise((resolve) => {
        detailsEl.dataset.accAnimBusy = "1";
        detailsEl.setAttribute("open", "");
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                detailsEl.classList.add("settingsAccordion--expanded");
                window.setTimeout(() => {
                    detailsEl.dataset.accAnimBusy = "";
                    scheduleSettingsCardWidthSync();
                    resolve();
                }, openUnlockMs);
            });
        });
    });
}

function scrollToSettingsSection(sectionId) {
    const container = document.getElementById("settingsContainer");
    const section = document.getElementById(sectionId);
    if (!container || !section) return;
    void ensureSettingsAccordionOpen(section).then(() => {
        requestAnimationFrame(() => {
            const summary = section.querySelector(":scope > summary.settingsAccordionSummary");
            const target = summary || section;
            const cRect = container.getBoundingClientRect();
            const tRect = target.getBoundingClientRect();
            const top = tRect.top - cRect.top + container.scrollTop - 6;
            const reduceMotion =
                typeof window.matchMedia === "function" &&
                window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            container.scrollTo({
                top: Math.max(0, top),
                behavior: reduceMotion ? "auto" : "smooth",
            });
            setActiveSettingsNavButton(sectionId);
        });
    });
}

function updateSettingsNavFromScroll() {
    const container = document.getElementById("settingsContainer");
    if (!container) return;
    const sections = Array.from(container.querySelectorAll(".settingsAccordion[id]")).filter(
        (section) => !section.classList.contains("hidden"),
    );
    if (!sections.length) return;
    const scrollMid = container.scrollTop + container.clientHeight * 0.22;
    let activeId = sections[0].id;
    for (const section of sections) {
        const summary = section.querySelector(":scope > summary.settingsAccordionSummary");
        const top = (summary || section).offsetTop;
        if (top <= scrollMid + 4) activeId = section.id;
    }
    setActiveSettingsNavButton(activeId);
}

function initSettingsSectionNav() {
    const nav = document.getElementById("settingsSectionNav");
    const container = document.getElementById("settingsContainer");
    if (!nav || !container || nav.dataset.settingsNavInit === "1") return;
    nav.dataset.settingsNavInit = "1";
    nav.querySelectorAll("[data-settings-section]").forEach((btn) => {
        btn.addEventListener("click", () => {
            const id = btn.getAttribute("data-settings-section");
            if (id) scrollToSettingsSection(id);
        });
    });
    let scrollRaf = 0;
    container.addEventListener(
        "scroll",
        () => {
            if (scrollRaf) return;
            scrollRaf = requestAnimationFrame(() => {
                scrollRaf = 0;
                updateSettingsNavFromScroll();
            });
        },
        { passive: true },
    );
}

function initSettingsAccordionAnimations() {
    const root = document.getElementById("settingsContainer");
    if (!root || root.dataset.settingsAccordionAnim === "1") return;
    root.dataset.settingsAccordionAnim = "1";
    const reduceMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const closeMs = reduceMotion ? 40 : 360;
    const openUnlockMs = reduceMotion ? 40 : 420;
    root.querySelectorAll(".settingsAccordion").forEach((d) => {
        const sum = d.querySelector(":scope > summary.settingsAccordionSummary");
        const panel = d.querySelector(":scope > .settingsAccordionPanel");
        if (!sum || !panel) return;
        if (d.hasAttribute("open")) d.classList.add("settingsAccordion--expanded");

        sum.addEventListener("click", (e) => {
            e.preventDefault();
            if (d.dataset.accAnimBusy === "1") return;
            const expanded = d.classList.contains("settingsAccordion--expanded");
            if (expanded) {
                d.dataset.accAnimBusy = "1";
                d.classList.remove("settingsAccordion--expanded");
                window.setTimeout(() => {
                    d.removeAttribute("open");
                    d.dataset.accAnimBusy = "";
                    scheduleSettingsCardWidthSync();
                }, closeMs);
            } else {
                d.dataset.accAnimBusy = "1";
                d.setAttribute("open", "");
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        d.classList.add("settingsAccordion--expanded");
                        window.setTimeout(() => {
                            d.dataset.accAnimBusy = "";
                            scheduleSettingsCardWidthSync();
                        }, openUnlockMs);
                    });
                });
            }
        });
    });
}

function initSpeedrunAuxUi() {
    const fill = (sel, storageKey, onChange) => {
        if (!sel) return;
        const n = Math.max(1, getSpeedrunLevelCount());
        const needRebuild = sel.options.length !== n || sel.dataset.speedrunOptCount !== String(n);
        if (needRebuild) {
            sel.dataset.speedrunOptCount = String(n);
            sel.replaceChildren();
            for (let i = 1; i <= n; i++) {
                const o = document.createElement("option");
                o.value = String(i);
                o.textContent = "Level " + i;
                sel.appendChild(o);
            }
        }
        if (!sel.dataset.speedrunChangeHook) {
            sel.dataset.speedrunChangeHook = "1";
            sel.addEventListener("change", () => {
                localStorage.setItem(storageKey, sel.value);
                onChange();
            });
        }
        const sv = localStorage.getItem(storageKey);
        const lv = clamp(Math.round(Number(sv) || 1), 1, n);
        sel.value = String(lv);
    };
    fill(statsSpeedrunLevelSelect, KEY_STATS_SPEEDRUN_LEVEL, refreshStatsSpeedrunLine);
    fill(rankingSpeedrunLevelSelect, KEY_RANKING_SPEEDRUN_LEVEL, loadLeaderboardTable);
    syncRankingSpeedrunLevelUi();
}

/* SANDBOX INIT */
RANKING_MODES.forEach(([val, label]) => {
    const opt = document.createElement("option");
    opt.value = val;
    opt.textContent = label;
    rankingModeSelect.appendChild(opt);
});
initSpeedrunAuxUi();
initPenaltyAuxUi();
void initHomeSplash();
initShowAdminThemeFromStorage();
setThemeMusicPlaybackHook(() => {
    stopMenuMusic();
    stopGameMusic();
    updateMusicState();
    refreshSettingsUI();
});
setThemePlayerColorRestorer(({ background, balls, buttons, text }) => {
    const root = document.documentElement;
    if (buttons) {
        root.style.setProperty("--btn-main-bg", settingButtonsColor);
        root.style.setProperty("--btn-main-glow", settingButtonsColor);
        root.style.setProperty("--btn-green-bg", settingButtonsColor);
        root.style.setProperty("--btn-green-glow", settingButtonsColor);
        root.style.setProperty("--home-start-glow", settingButtonsColor);
        applyButtonGradientCssVars(settingButtonsColor, true);
    }
    if (text) {
        const effectiveTextColor = settingButtonsAutoText ? settingButtonsColor : settingTextColor;
        root.style.setProperty("--text-color", effectiveTextColor);
        root.style.setProperty("--home-title-glow", effectiveTextColor);
    }
    if (balls) {
        root.style.setProperty("--ball-color", settingBallsColor);
        root.style.removeProperty("--ball-color-to");
        document.body.classList.remove("admin-theme-balls-gradient");
        document.body.classList.remove("player-theme-balls-gradient");
    }
    if (background) {
        applyBackgroundTheme();
        root.style.removeProperty("--menu-bg-to");
        root.style.removeProperty("--game-bg-to");
        document.body.classList.remove("admin-theme-bg-gradient");
        document.body.classList.remove("player-theme-bg-gradient");
    }
    applyEquippedThemeCosmetics({
        onlyChannels: { background, balls, buttons, text },
    });
});
bootstrapThemeDevicePreviewFrame();
void loadPublishedGameTheme();
void refreshSpeedrunLevelsFromApi();
void refreshPenaltyLevelsFromApi();
void refreshPracticeLevelsFromApi();
ensureStatsSpeedrunFitOnResize();
initSettingsAccordionAnimations();
initSettingsSectionNav();
initKeybindSettingsUi();
migrateLegacyEffectSettings();
reloadSettingsGlobalsFromStorage();
refreshSettingsUI();
refreshSandboxUI();
applySettings();
updateMusicState();
setProfilePanel("friends");
initPendingLeaderboardSync(() => {
    void refreshSpeedrunCloudPersonalBests();
    void refreshPenaltyCloudPersonalBests();
    void refreshSandboxSpeedrunCloudBests();
    void refreshSandboxScoreCloudBests();
});
void pollAchievementUnlocksNow();
applyDpadLayoutFromStorage();
refreshDpadSettingsVisibility();
if (dpadCustomizeBtn) dpadCustomizeBtn.onclick = startDpadPositionCustomize;
if (dpadCustomizeDoneBtn) dpadCustomizeDoneBtn.onclick = finishDpadPositionCustomize;
if (dpadCustomizeLayoutBtn) {
    dpadCustomizeLayoutBtn.onclick = () => {
        pushDpadCustomizeUndoBeforeChange();
        cycleDpadLayout();
    };
}
if (dpadCustomizeResetBtn) {
    dpadCustomizeResetBtn.onclick = () => {
        pushDpadCustomizeUndoBeforeChange();
        resetDpadToDefaults();
    };
}
if (dpadCustomizeUndoBtn) {
    dpadCustomizeUndoBtn.onclick = () => undoDpadCustomize();
}
if (dpadCustomizeRedoBtn) {
    dpadCustomizeRedoBtn.onclick = () => redoDpadCustomize();
}
if (dpadCustomizeGridBtn) {
    dpadCustomizeGridBtn.onclick = () => toggleDpadGridSnap();
}
if (toggleDpadEightDirBtn) {
    toggleDpadEightDirBtn.onclick = () => {
        pushSettingsUndoCurrent();
        setDpadEightDirections(!settingDpadEightDirections);
    };
}
if (dpadCustomizeReturnBtn) {
    dpadCustomizeReturnBtn.onclick = () => openDpadCustomizeExitConfirm();
}
if (dpadCustomizeExitYesBtn) {
    dpadCustomizeExitYesBtn.onclick = () => cancelDpadPositionCustomizeWithoutSave();
}
if (dpadCustomizeExitNoBtn) {
    dpadCustomizeExitNoBtn.onclick = () => closeDpadCustomizeExitConfirm();
}
if (dpadCustomizeScaleSlider) {
    let scaleSliderEditing = false;
    dpadCustomizeScaleSlider.addEventListener("pointerdown", () => {
        if (!scaleSliderEditing) {
            pushDpadCustomizeUndoBeforeChange();
            scaleSliderEditing = true;
        }
    });
    const endScaleSliderEdit = () => {
        scaleSliderEditing = false;
    };
    dpadCustomizeScaleSlider.addEventListener("pointerup", endScaleSliderEdit);
    dpadCustomizeScaleSlider.addEventListener("pointercancel", endScaleSliderEdit);
    dpadCustomizeScaleSlider.addEventListener("change", endScaleSliderEdit);
    dpadCustomizeScaleSlider.addEventListener("input", () => {
        setDpadScaleFromSliderValue(Number(dpadCustomizeScaleSlider.value));
    });
}
if (dpadCustomizeOpacitySlider) {
    let opacitySliderEditing = false;
    dpadCustomizeOpacitySlider.addEventListener("pointerdown", () => {
        if (!opacitySliderEditing) {
            pushDpadCustomizeUndoBeforeChange();
            opacitySliderEditing = true;
        }
    });
    const endOpacitySliderEdit = () => {
        opacitySliderEditing = false;
    };
    dpadCustomizeOpacitySlider.addEventListener("pointerup", endOpacitySliderEdit);
    dpadCustomizeOpacitySlider.addEventListener("pointercancel", endOpacitySliderEdit);
    dpadCustomizeOpacitySlider.addEventListener("change", endOpacitySliderEdit);
    dpadCustomizeOpacitySlider.addEventListener("input", () => {
        setDpadOpacityFromSliderValue(Number(dpadCustomizeOpacitySlider.value));
    });
}

function stopLootDropPlaying() {
    cancelPendingModeView();
    stopLootDropSession();
    playing = false;
    gameMode = null;
    obstacles = [];
    particles = [];
    trail = [];
    deathPending = false;
    clearDeathState();
    exitGamePointerLock();
    relativePointerLastClient = null;
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    hideEl(gameOverScreen);
    hideEl(pauseScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    if (topCenter) topCenter.textContent = "";
    updateMusicState();
    updateMobilePlayChrome();
    syncReturnBtnVisibility();
}

function stopMultiplayerPlaying() {
    cancelPendingModeView();
    playing = false;
    gameMode = null;
    obstacles = [];
    particles = [];
    trail = [];
    deathPending = false;
    clearDeathState();
    exitGamePointerLock();
    relativePointerLastClient = null;
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    hideEl(gameOverScreen);
    hideEl(pauseScreen);
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    updateMusicState();
    updateMobilePlayChrome();
    syncReturnBtnVisibility();
}

initMultiplayerUi({
    showEl,
    hideEl,
    openModes: openGameHub,
    playScreenEnterMotion,
    playSelectSound: () => playModeCardBeep(),
    playModeCardBeep,
    getPlayerName: () => (cloudUser?.displayName || cloudUser?.email || "").trim(),
    getAccountUserId: () => cloudUser?.id ?? null,
    fetchFriends: async () => {
        if (!cloudUser) return [];
        try {
            const r = await fetch(apiPath("/api/friends"), { credentials: "include" });
            if (!r.ok) return [];
            const d = await r.json();
            return Array.isArray(d.friends) ? d.friends : [];
        } catch {
            return [];
        }
    },
    stopPlaying: stopMultiplayerPlaying,
    isPlaying: () => playing,
    refreshMpSpeedrunChrome: () => updateMpSpeedrunSpectateChrome(),
    releaseGamePointer: () => {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
    },
    updateMusicState,
});

initMultiplayerGameRuntime({
    initGame,
    showEl,
    hideEl,
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    getMouse: () => ({ x: mouse.x, y: mouse.y }),
    setMouse: (x, y) => { mouse.x = x; mouse.y = y; },
    isPlaying: () => playing,
    getGameMode: () => gameMode,
    setTopHudText: (text) => { if (topCenter) topCenter.textContent = text; },
    endMultiplayerGame: endMultiplayerToLobby,
    releaseGamePointer: () => {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
    },
    getTrailEnabled: () => settingTrailEnabled,
    getTrailColor: () => settingTrailColor,
    prepareMpModeGame(mode, opts) {
        if (mode === "speedrun" && opts.speedrunLevel) {
            speedrunActiveLevel = opts.speedrunLevel;
            rebuildSpeedrunGeometry();
            const d = getSpeedrunLevelDef(speedrunActiveLevel);
            mouse.x = d.spawn.nx * canvas.width;
            mouse.y = d.spawn.ny * canvas.height;
            speedrunPrevMouse.x = mouse.x;
            speedrunPrevMouse.y = mouse.y;
            speedrunPointsCollected = new Set();
            updateMpSpeedrunSpectateChrome();
        } else if (mode === "sandbox" && opts.sandboxConfig) {
            sandboxRuntimeConfig = mpSandboxRuntimeFromWire(opts.sandboxConfig);
            mouse.x = canvas.width / 2;
            mouse.y = canvas.height / 2;
            sandboxPointerTarget = { x: mouse.x, y: mouse.y };
        } else if (mode === "highway") {
            resetHighwayState(MP_REF_W, MP_REF_H);
            mouse.x = MP_REF_W / 2;
            mouse.y = 0.12 * MP_REF_H;
        } else if (mode === "snake") {
            mouse.x = canvas.width / 2;
            mouse.y = canvas.height / 2;
        }
    },
    encodeMpPos(mode, mousePt, cw, ch) {
        if (mode === "highway") {
            return { x: mouse.x / MP_REF_W, y: mouse.y / MP_REF_H };
        }
        return mpCanvasToNorm(mousePt.x, mousePt.y, cw, ch);
    },
    getMpLocalCursor(cw, ch) {
        if (isMpHighwayMode()) return mpHighwayMouseScreen(cw, ch);
        return { x: mouse.x, y: mouse.y };
    },
    getCursorRadiusPx: () => getCursorRadiusForMode(),
    startMpGameCountdown: () => startResumeCountdown(),
    isMpGameplayInputBlocked,
    playModeCardBeep,
    clearLocalTrail: () => { trail = []; clearTrailParticles(); },
});

registerMpSpeedrunCoopHooks({
    applyTeamPoints: applyMpTeamSpeedrunPoints,
    respawnFromLaser: mpSpeedrunRespawnFromLaser,
});

mountSoccerUi({
    showEl,
    hideEl,
    openGameHub,
    playModeCardBeep,
    playScreenEnterMotion,
    onCompeteFormat: (format, variant) => beginSoccerCompeteQueue(format, variant),
});
initSoccerRuntime({
    initGame,
    showEl,
    hideEl,
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    getMouse: () => ({ x: mouse.x, y: mouse.y }),
    setMouse: (x, y) => { mouse.x = x; mouse.y = y; },
    isPlaying: () => playing,
    stopPlaying: () => {
        playing = false;
        document.body.classList.remove("game-active");
        document.body.classList.remove("hideCursor");
        hideEl(pauseScreen);
        setTopHudMode(null);
        if (topCenter) topCenter.textContent = "";
        updateMusicState();
        updateMobilePlayChrome();
        syncReturnBtnVisibility();
    },
    drawCursorAt: (ctx, x, y, color) => {
        const prev = settingCursorColor;
        settingCursorColor = color;
        drawCursorOnto(ctx, x, y);
        settingCursorColor = prev;
    },
    drawPlayerName(ctx, x, y, name, color) {
        const ls = gameLayoutScale();
        ctx.save();
        ctx.font = `${Math.max(8, Math.round(9 * ls))}px "Press Start 2P", monospace`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = color;
        ctx.strokeStyle = "rgba(0,0,0,0.75)";
        ctx.lineWidth = 3;
        ctx.strokeText(name, x, y - 22);
        ctx.fillText(name, x, y - 22);
        ctx.restore();
    },
    getPlayerName: () => (cloudUser?.displayName || cloudUser?.email || "Player").trim(),
    getAccountUserId: () => cloudUser?.id ?? null,
    getDots: () => getDotsBalance(),
    getTournamentsWon: () => 0,
    getCursorColor: () => settingCursorColor,
    getEquippedCosmeticIds: () => getDotsState().equippedCosmeticIds ?? [],
    openGameHub,
    openMpEntry,
    openLocalSetup,
    playModeCardBeep,
    hideReturn: () => hideEl(returnBtn),
    convertClientDelta: (dx, dy) => clampGamePointerDelta(dx, dy),
});

initLootDropUi({
    showEl,
    hideEl,
    openGameHub,
    playScreenEnterMotion,
    playSelectSound: () => playModeCardBeep(),
    playModeCardBeep,
    getPlayerName: () => (cloudUser?.displayName || cloudUser?.email || "").trim(),
    getAccountUserId: () => cloudUser?.id ?? null,
    getCursorColor: () => settingCursorColor,
    fetchFriends: async () => {
        if (!cloudUser) return [];
        try {
            const r = await fetch(apiPath("/api/friends"), { credentials: "include" });
            if (!r.ok) return [];
            const d = await r.json();
            return Array.isArray(d.friends) ? d.friends : [];
        } catch {
            return [];
        }
    },
    stopPlaying: stopLootDropPlaying,
    isPlaying: () => playing,
    releaseGamePointer: () => {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
    },
    updateMusicState,
    refreshDotsUi: () => {
        const bal = getDotsBalance();
        const label = `${bal.toLocaleString()} Dots`;
        if (shopDotsBalanceValue) shopDotsBalanceValue.textContent = label;
        const inv = document.getElementById("inventoryDotsBalanceValue");
        if (inv) inv.textContent = label;
    },
});

initLootDropGameRuntime({
    initGame,
    showEl,
    hideEl,
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    getMouse: () => ({ x: mouse.x, y: mouse.y }),
    setMouse: (x, y) => { mouse.x = x; mouse.y = y; },
    isPlaying: () => playing,
    setTopHudText: (text) => { if (topCenter) topCenter.textContent = text; },
    releaseGamePointer: () => {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
    },
    showSystemCursor: () => {
        exitGamePointerLock();
        relativePointerLastClient = null;
        document.body.classList.remove("hideCursor");
        document.body.classList.remove("game-playing-touch");
    },
    getCursorRadiusPx: () => getCursorRadiusForMode(),
    getCursorColor: () => settingCursorColor,
    clampCursorToEdgeInset: (x, y) => clampCursorXYToEdgeInset(x, y),
    drawPlayerName(ctx, x, y, name, color) {
        const ls = gameLayoutScale();
        ctx.save();
        ctx.font = `${Math.max(8, Math.round(9 * ls))}px "Press Start 2P", monospace`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = color;
        ctx.strokeStyle = "rgba(0,0,0,0.75)";
        ctx.lineWidth = 3;
        ctx.strokeText(name, x, y - getCursorRadiusForMode() - 10);
        ctx.fillText(name, x, y - getCursorRadiusForMode() - 10);
        ctx.restore();
    },
    playModeCardBeep,
    playLootPickupSound: playLootDropPickupSound,
});

registerMpModeBridge({
    buildSpeedrunLevelGridForMp(onSelect, selectedLevel) {
        if (!speedrunLevelGrid) return;
        buildLevelPickerGrid(speedrunLevelGrid, {
            kind: "speedrun",
            levels: speedrunLevelCardRows(),
            selectedLevel,
            emptyMessage: "No official SpeedRun levels yet. (Admin)",
            onSelect: (lvl) => {
                playModeCardBeep();
                onSelect(lvl);
            },
        });
        speedrunLevelGrid.dataset.built = `mp:${selectedLevel ?? ""}`;
    },
    openMpSpeedrunLevelScreen() {
        hideEl(document.getElementById("mpLobbyScreen"));
        hideEl(document.getElementById("mpGameModeScreen"));
        hideEl(document.getElementById("sandboxScreen"));
        buildSpeedrunLevelGridOnce();
        showEl(speedrunLevelScreen);
        showEl(returnBtn);
    },
    openMpSandboxScreen() {
        hideEl(document.getElementById("mpLobbyScreen"));
        hideEl(document.getElementById("mpGameModeScreen"));
        hideEl(speedrunLevelScreen);
        syncSandboxConfigFromUI();
        refreshSandboxUI();
        showEl(sandboxScreen);
        showEl(returnBtn);
    },
    collectSandboxConfigWire() {
        syncSandboxConfigFromUI();
        return toMpSandboxWire(sandboxConfigAsV2(sandboxConfig));
    },
    applySandboxConfigWire(wire) {
        sandboxConfig = mpSandboxRuntimeFromWire(wire);
        refreshSandboxUI();
    },
    prepareMpSpeedrunGame(level) {
        speedrunActiveLevel = level;
        rebuildSpeedrunGeometry();
    },
    prepareMpSandboxGame(wire) {
        sandboxRuntimeConfig = mpSandboxRuntimeFromWire(wire);
        beginSandboxRun(sandboxConfigAsV2(sandboxRuntimeConfig));
    },
    prepareMpHighwayGame() {
        resetHighwayState(canvas.width, canvas.height);
    },
    applyHighwayWireSnapshot(snap) {
        applyHighwaySnapshot({
            cameraY: snap.cameraY,
            obstacles: snap.obstacles,
            nextSpawnWorldY: snap.nextSpawnWorldY,
        });
    },
    isMpHighwayMode: () => isMpHighwayMode(),
    isMpSpeedrunMode: () => isMpSpeedrunMode(),
    getMpHighwayCursorScreen: () => highwayCursorScreen(),
    setSandboxMpHostOnly,
});

function stopLocalPlaying() {
    cancelPendingModeView();
    stopLocalSession();
    playing = false;
    gameMode = null;
    obstacles = [];
    particles = [];
    trail = [];
    localSnakeTrails = [];
    deathPending = false;
    localSpeedrunFrozenTSec = -1;
    clearDeathState();
    exitGamePointerLock();
    relativePointerLastClient = null;
    document.body.classList.remove("hideCursor");
    document.body.classList.remove("game-active");
    hideEl(gameOverScreen);
    hideEl(pauseScreen);
    hideEl(localResultScreen);
    if (localTouchZones) {
        localTouchZones.classList.add("hidden");
        localTouchZones.replaceChildren();
    }
    setSuperHudVisible(false);
    setTopHudMode(null);
    topCenter.textContent = "";
    updateMusicState();
    updateMobilePlayChrome();
    syncReturnBtnVisibility();
}

function prepareLocalModeStart(config) {
    if (config.mode === "speedrun") {
        speedrunActiveLevel = config.speedrunLevel || 1;
        rebuildSpeedrunGeometry();
        resetSpeedrunProgressAndTimer();
        const d = getSpeedrunLevelDef(speedrunActiveLevel);
        mouse.x = d.spawn.nx * canvas.width;
        mouse.y = d.spawn.ny * canvas.height;
        speedrunPrevMouse.x = mouse.x;
        speedrunPrevMouse.y = mouse.y;
    } else if (config.mode === "highway") {
        resetHighwayState(canvas.width, canvas.height);
    } else if (config.mode === "colorrush") {
        resetColorRushState();
    } else if (config.mode === "counter") {
        resetCounterState(getGameSimNowMs());
        spawnCounterBalls();
    } else if (config.mode === "heat") {
        resetHeatState();
    } else if (config.mode === "snake") {
        obstacles = [];
        resetSnakeTrail();
    } else if (config.mode === "sandbox") {
        sandboxRuntimeConfig = sandboxRuntimeConfig || sandboxConfig;
    }
}

function seedLocalModeInitialContent(config) {
    const mode = config.mode;
    syncPrimaryMouseFromLocalPlayers();
    if (mode === "normal") {
        spawnObstacle(0.8);
    } else if (mode === "wasd") {
        for (let i = 0; i < 5; i++) spawnObstacle(1.2);
    } else if (mode === "heat") {
        for (let i = 0; i < HEAT_BALLS_START; i++) spawnObstacle(HEAT_BALL_SPEED);
    } else if (mode === "hunter") {
        for (let i = 0; i < HUNTER_NORMAL_START; i++) spawnObstacle(HUNTER_NORMAL_SPEED);
    } else if (mode === "colorrush") {
        spawnLocalColorRushBalls(config);
    } else if (mode === "counter") {
        if (obstacles.length === 0) spawnCounterBalls();
    } else if (mode === "sandbox") {
        const cfg = sandboxRuntimeConfig;
        if (cfg && !cfg.speedrunMode) {
            const initialCount = Math.max(1, Math.min(5, cfg.ballsPerSpawn));
            for (let i = 0; i < initialCount; i++) spawnObstacle(cfg.ballsSpeed, cfg.ballsSize);
        }
    }
    syncBallCollisionPrevMouse();
}

function syncPrimaryMouseFromLocalPlayers() {
    const centers = localSpawnClearanceCenters();
    if (centers.length > 0) {
        mouse.x = centers[0].x;
        mouse.y = centers[0].y;
    }
}

function startLocalGameFromSetup(config) {
    localPendingConfig = config;
    initGame(config.mode, { skipModeView: true });
    recordModePlay("local");
    if (config.mode) {
        void commitPlayStreakDay(config.mode, { server: !!cloudUser });
    }
    prepareLocalModeStart(config);
    localSnakeTrails = Array.from({ length: config.playerCount }, () => []);
    const speedrunSharedSpawn =
        config.mode === "speedrun"
            ? (() => {
                const d = getSpeedrunLevelDef(config.speedrunLevel || speedrunActiveLevel || 1);
                return { x: d.spawn.nx * canvas.width, y: d.spawn.ny * canvas.height };
            })()
            : null;
    startLocalSession(config, canvas.width, canvas.height, speedrunSharedSpawn);
    seedLocalModeInitialContent(config);
    if (localTouchZones) {
        refreshLocalTouchZoneLayout(localTouchZones);
        localTouchZones.classList.remove("hidden");
    }
    startResumeCountdown();
    updateMobilePlayChrome();
}

function localWithPlayerMouse(px, py, ppx, ppy, fn) {
    const sm = { x: mouse.x, y: mouse.y };
    const sp = { x: collisionPrevMouse.x, y: collisionPrevMouse.y };
    mouse.x = px;
    mouse.y = py;
    collisionPrevMouse.x = ppx;
    collisionPrevMouse.y = ppy;
    const out = fn();
    mouse.x = sm.x;
    mouse.y = sm.y;
    collisionPrevMouse.x = sp.x;
    collisionPrevMouse.y = sp.y;
    return out;
}

function localDrawHeatBarInZone(ctx, playerIndex, playerCount, level, cw, ch, layoutScale, cursorY) {
    void playerIndex;
    void playerCount;
    if (cw < 24 || ch < 24) return;
    const barW = Math.max(14, 16 * layoutScale);
    const margin = Math.max(12, 14 * layoutScale);
    const barH = Math.min(ch * 0.58, ch - margin * 2);
    const barX = cw - margin - barW;
    let barY = cursorY - barH * 0.5;
    barY = Math.max(margin, Math.min(ch - margin - barH, barY));
    const r = Math.min(barW * 0.35, 6 * layoutScale);

    ctx.save();
    ctx.beginPath();
    ctx.roundRect(barX, barY, barW, barH, r);
    ctx.clip();

    const grad = ctx.createLinearGradient(0, barY, 0, barY + barH);
    grad.addColorStop(0, "#ff3333");
    grad.addColorStop(0.38, "#ff4444");
    grad.addColorStop(0.5, "#c8b8d8");
    grad.addColorStop(0.62, "#5599ee");
    grad.addColorStop(1, "#3388ff");
    ctx.fillStyle = grad;
    ctx.fillRect(barX, barY, barW, barH);

    const safeH = Math.max(4, barH * 0.08);
    const safeY = barY + barH * 0.5 - safeH * 0.5;
    ctx.fillStyle = "rgba(255,255,255,0.16)";
    ctx.fillRect(barX, safeY, barW, safeH);
    ctx.restore();

    ctx.save();
    ctx.strokeStyle = "rgba(255,255,255,0.72)";
    ctx.lineWidth = Math.max(1.5, 2 * layoutScale);
    ctx.beginPath();
    ctx.roundRect(barX, barY, barW, barH, r);
    ctx.stroke();

    const clamped = Math.max(0, Math.min(1, level));
    const indicatorY = barY + barH * (1 - clamped);
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = Math.max(2, 2.5 * layoutScale);
    ctx.beginPath();
    ctx.moveTo(barX, indicatorY);
    ctx.lineTo(barX + barW, indicatorY);
    ctx.stroke();
    ctx.restore();
}

function renderLocalEndBackdrop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
}

initLocalUi({
    showEl,
    hideEl,
    openModes: openGameHub,
    playScreenEnterMotion,
    playModeCardBeep,
    startLocalGame: startLocalGameFromSetup,
    startLocalSoccer(config) {
        hideLocalScreens();
        prepareLocalSoccer(config.players.slice(0, config.playerCount).map((p) => p.name));
    },
    openLocalSandboxConfig(onDone) {
        hideLocalScreens();
        sandboxMpReturnToLocal = onDone;
        hideEl(sandboxScreen);
        showEl(sandboxBaseScreen);
        showEl(returnBtn);
        updateMusicState();
        playScreenEnterMotion();
    },
    isTouchDevice: () => isLocalModeDevice(),
    updateMusicState,
});

const sandboxHubHooks = {
    onSelectBaseMode: (mode) => openSandboxConfigForBaseMode(mode),
    onLoadPublicPreset: (preset) => {
        sandboxConfig = sandboxRuntimeFlat(preset.config);
        sandboxActivePlayContext = { localName: preset.name, cloudPresetId: preset.id };
        saveSandboxDraft();
        openSandboxScreen();
    },
    getPresetBestLine: (preset) => formatSandboxPresetBestLine(preset),
    onOpenPresetLeaderboard: (preset) => {
        void openSandboxCommunityLeaderboard(preset);
    },
    playModeCardBeep,
};
mountSandboxBaseModePicker(sandboxHubHooks);
mountSandboxCommunityScreen(sandboxHubHooks);
document.getElementById("sandboxOpenCommunityBtn")?.addEventListener("click", () => {
    playModeCardBeep();
    openSandboxCommunityFromHub();
});
document.getElementById("sandboxCommunityLbCloseBtn")?.addEventListener("click", () => {
    hideSandboxCommunityLeaderboard();
});

async function openSandboxCommunityLeaderboard(preset) {
    const card = document.getElementById("sandboxCommunityLbCard");
    const title = document.getElementById("sandboxCommunityLbTitle");
    const subtitle = document.getElementById("sandboxCommunityLbSubtitle");
    const status = document.getElementById("sandboxCommunityLbStatus");
    const wrap = document.getElementById("sandboxCommunityLbTableWrap");
    if (!card || !wrap) return;
    const cfg = normalizeSandboxConfig(preset.config);
    const isSr = !!cfg.speedrunMode;
    if (title) title.textContent = "Leaderboard";
    if (subtitle) {
        subtitle.textContent = isSr
            ? `${preset.name} — best times (lower is better)`
            : `${preset.name} — best scores`;
    }
    wrap.replaceChildren();
    if (status) status.textContent = "Loading…";
    showEl(card);
    const yourBest = formatSandboxPresetBestLine(preset);
    try {
        const mode = isSr ? "sandbox_speedrun" : "sandbox";
        const r = await fetch(
            apiPath(
                `/api/leaderboard?mode=${encodeURIComponent(mode)}&presetId=${encodeURIComponent(preset.id)}&limit=25`,
            ),
            { credentials: "include" },
        );
        const data = await r.json();
        const items = data.items || [];
        if (status) {
            if (data.message) status.textContent = data.message;
            else if (items.length)
                status.textContent = `Your ${isSr ? "best time" : "best score"}: ${yourBest.replace(/^Best (Score|Time): /, "")} · Top ${items.length} players.`;
            else status.textContent = `Your ${isSr ? "best time" : "best score"}: ${yourBest.replace(/^Best (Score|Time): /, "")} · No entries yet for this preset.`;
        }
        if (!items.length) return;
        const tbl = document.createElement("table");
        tbl.className = "lbTable";
        const thead = document.createElement("thead");
        const hr = document.createElement("tr");
        ["#", "Name", isSr ? "Best time" : "Best score", "Device", "When"].forEach((h) => {
            const th = document.createElement("th");
            th.textContent = h;
            hr.appendChild(th);
        });
        thead.appendChild(hr);
        tbl.appendChild(thead);
        const tb = document.createElement("tbody");
        items.forEach((it, i) => {
            const tr = document.createElement("tr");
            const rank = i + 1;
            applyLeaderboardRankRowClass(tr, rank);
            const deviceLabel = it.device === "mobile" ? "Mobile" : it.device === "pc" ? "PC" : "—";
            const valCell = isSr
                ? formatSpeedrunTime(Number(it.value) || 0)
                : String(it.value);
            [String(rank), String(it.displayName || "?"), valCell, deviceLabel, new Date(it.at).toLocaleString()].forEach(
                (txt) => {
                    const td = document.createElement("td");
                    td.textContent = txt;
                    tr.appendChild(td);
                },
            );
            tb.appendChild(tr);
        });
        tbl.appendChild(tb);
        wrap.appendChild(tbl);
    } catch {
        if (status) status.textContent = "Could not load the leaderboard.";
    }
}

function hideSandboxCommunityLeaderboard() {
    const card = document.getElementById("sandboxCommunityLbCard");
    if (card) hideEl(card);
}

mountGameHub({
    showEl,
    hideEl,
    openModes,
    openPractice,
    openSandbox: openSandboxHub,
    openMpEntry,
    openLootDropEntry,
    openLocalSetup,
    openChallenges: () => {
        void openChallengesFlow();
    },
    openTournaments: () => {
        void openTournamentsFlow();
    },
    openMarathon: () => {
        void openMarathonFlow();
    },
    openCampaign: () => {
        void openCampaignFlow();
    },
    openWorldMap: () => {
        void openWorldMapFlow();
    },
    openSoccer: () => {
        openSoccerCompete();
    },
    playScreenEnterMotion,
    playModeCardBeep,
    isTouchDevice: isLocalModeDevice,
});

markDefaultHubIconSvgs();
void loadPublishedHubIcons();

mountHomeDashboard({
    isSignedIn: () => !!cloudUser,
    getAccountId: () => (cloudUser && cloudUser.id ? String(cloudUser.id) : null),
    openChallenges: () => {
        void openChallengesFlow();
    },
    playMode: (modeId) => {
        startModeById(modeId);
    },
    openLootDropLobby: () => {
        void openLootDropEntry();
    },
    pushSettingsUndo: () => {
        pushSettingsUndoCurrent();
    },
    applySettings: () => {
        // Keep legacy news/splash vars in sync when home prefs change via dashboard toggles.
        settingNewsInHome = getBoolSetting("settingNewsInHome", false);
        settingNotificationsInHome = getBoolSetting("settingNotificationsInHome", true);
        settingHomeSplash = getBoolSetting("settingHomeSplash", true);
        applySettings();
    },
    isTouchUi: () => isTouchGameUi(),
    hideSettingsAndShowHome: () => {
        setActiveSidebarBtn(sideHomeBtn);
        goToMenu("home");
    },
    getCursorColor: () => settingCursorColor,
});

function endChallengeRunQuiet() {
    clearDeathState();
    deathPending = false;
    gamePaused = false;
    hideEl(pauseScreen);
    hideEl(gameOverScreen);
    playing = false;
    obstacles = [];
    particles = [];
    trail = [];
    challengeDeathWorldFrozen = false;
    challengeDeathBallAlpha = 1;
    challengeDeathAshes = [];
    challengeDeathAshSpawnAcc = 0;
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideComboHud();
    stopTiltOrientationListening();
}

function leaveChallengesToHubUi() {
    withExitPlayTransition(() => {
        exitGamePointerLock();
        leavePauseMenuCursorMode();
        playing = false;
        gameMode = null;
        document.body.classList.remove(
            "challenge-lobby",
            "challenge-active",
            "challenge-goal-complete",
            "game-active",
            "hideCursor",
            "game-playing-touch",
        );
        applyBackgroundTheme();
        if (topCenter) {
            topCenter.textContent = "";
            topCenter.style.opacity = "";
        }
        if (returnBtn) returnBtn.textContent = "Return";
        setChallengeRedMusicDuck(false);
        hideChallengeLostScreen();
        const fade = document.getElementById("challengeFadeOverlay");
        if (fade) {
            fade.style.opacity = "0";
            fade.classList.remove("challengeFadeOverlay--on");
            fade.setAttribute("aria-hidden", "true");
        }
        clearGameCursorTopLayer();
        openGameHub();
        updateMobilePlayChrome();
        scheduleSidebarSync();
        syncReturnBtnVisibility();
        updateMusicState();
    });
}

const CHALLENGE_ASH_COLORS = ["#3a3530", "#5c5348", "#7a6e60", "#9a8570", "#c47a3a", "#e0a050", "#2a2824", "#8a8880"];

function beginChallengeDeathAsh() {
    challengeDeathAshes = [];
    challengeDeathAshSpawnAcc = 0;
    // Initial crumbling burst from every ball.
    for (const o of obstacles) {
        emitChallengeDeathAshAt(o.x, o.y, o.r || 14, 18);
    }
}

function emitChallengeDeathAshAt(x, y, radius, count) {
    const ls = gameLayoutScale();
    const r = Math.max(4, Number(radius) || 14);
    for (let i = 0; i < count; i++) {
        const ang = Math.random() * Math.PI * 2;
        const dist = Math.random() * r * 0.85;
        const px = x + Math.cos(ang) * dist;
        const py = y + Math.sin(ang) * dist;
        const vx = (Math.random() - 0.5) * 1.35 * ls;
        const vy = -(0.55 + Math.random() * 1.8) * ls;
        const life = 28 + Math.random() * 55;
        const size = (0.7 + Math.random() * 2.4) * ls;
        const color = CHALLENGE_ASH_COLORS[Math.floor(Math.random() * CHALLENGE_ASH_COLORS.length)];
        challengeDeathAshes.push({
            x: px,
            y: py,
            vx,
            vy,
            life,
            maxLife: life,
            size,
            color,
            rot: Math.random() * Math.PI * 2,
            spin: (Math.random() - 0.5) * 0.18,
        });
    }
}

function tickChallengeDeathAsh(dt, t) {
    const fs = frameScale(dt);
    // Continuous ash shedding while balls dissolve (more flakes mid-fade).
    const rate = 14 + t * 38;
    challengeDeathAshSpawnAcc += rate * dt;
    while (challengeDeathAshSpawnAcc >= 1) {
        challengeDeathAshSpawnAcc -= 1;
        if (!obstacles.length) break;
        const o = obstacles[Math.floor(Math.random() * obstacles.length)];
        if (!o) break;
        emitChallengeDeathAshAt(o.x, o.y, o.r || 14, 1 + (Math.random() < 0.35 ? 1 : 0));
    }
    for (let i = challengeDeathAshes.length - 1; i >= 0; i--) {
        const p = challengeDeathAshes[i];
        p.x += p.vx * fs;
        p.y += p.vy * fs;
        p.vx *= decayFrameRate(0.992, dt);
        p.vy = p.vy * decayFrameRate(0.988, dt) + 0.012 * gameLayoutScale() * fs;
        p.rot += p.spin * fs;
        p.life -= fs;
        if (p.life <= 0) challengeDeathAshes.splice(i, 1);
    }
}

function drawChallengeDeathAshes() {
    if (!challengeDeathAshes.length) return;
    ctx.save();
    for (const p of challengeDeathAshes) {
        const u = Math.max(0, p.life / p.maxLife);
        const alpha = u * u * 0.92;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = alpha;
        ctx.fillStyle = p.color;
        const w = p.size;
        const h = p.size * (0.45 + u * 0.55);
        ctx.fillRect(-w * 0.5, -h * 0.5, w, h);
        ctx.restore();
    }
    ctx.restore();
}

/** Soft push so the cursor still collides with frozen challenge-death balls. */
function resolveChallengeDeathCursorCollisions() {
    if ((!isChallengeDeathWorldActive() && !isMarathonDeathWorldActive()) || !obstacles.length) return;
    const cr = getCursorRadiusForMode();
    for (let pass = 0; pass < 3; pass++) {
        for (const o of obstacles) {
            const br = typeof o.collisionRadius === "function" ? o.collisionRadius() : o.r;
            const dx = mouse.x - o.x;
            const dy = mouse.y - o.y;
            const dist = Math.hypot(dx, dy);
            const min = cr + br;
            if (dist >= min) continue;
            if (dist < 0.0001) {
                mouse.x = o.x + min;
                mouse.y = o.y;
            } else {
                const push = (min - dist) / dist;
                mouse.x += dx * push;
                mouse.y += dy * push;
            }
        }
    }
    const inset = cursorEdgeInsetPx();
    mouse.x = clamp(mouse.x, inset, canvas.width - inset);
    mouse.y = clamp(mouse.y, inset, canvas.height - inset);
    syncBallCollisionPrevMouse();
}

function clearChallengeDeathWorldVisuals() {
    obstacles = [];
    particles = [];
    trail = [];
    challengeDeathAshes = [];
    challengeDeathAshSpawnAcc = 0;
    setSuperHudVisible(false);
    setTopHudMode(null);
    hideComboHud();
    if (topCenter) {
        topCenter.textContent = "";
        topCenter.style.opacity = "0";
    }
    clearGameCursorTopLayer();
}

function showChallengeLostScreen(countdownLabel) {
    const panel = document.getElementById("challengeLostPanel");
    const cd = document.getElementById("challengeLostCountdown");
    const label = countdownLabel || "00:00:00:00";
    if (cd) {
        ensureDomFlipClock(cd, label);
        applyDomFlipClock(cd, getChallengeCountdownFlipCells());
    }
    if (panel) {
        panel.classList.remove("hidden");
        panel.setAttribute("aria-hidden", "false");
    }
}

function updateChallengeLostCountdown(countdownLabel) {
    const cd = document.getElementById("challengeLostCountdown");
    if (!cd) return;
    const label = countdownLabel || "00:00:00:00";
    ensureDomFlipClock(cd, label);
    applyDomFlipClock(cd, getChallengeCountdownFlipCells());
}

function hideChallengeLostScreen() {
    const panel = document.getElementById("challengeLostPanel");
    if (panel) {
        panel.classList.add("hidden");
        panel.setAttribute("aria-hidden", "true");
    }
}

let marathonLostFailIndex = 0;
let marathonLostFailRatio = 0;
let marathonLostSegCount = 1;
let marathonCursorFromIndex = 0;
let marathonCursorFromRatio = 0;
let marathonCursorToIndex = 0;
let marathonCursorToRatio = 0;

function marathonBarPositionPx(bar, cells, index, ratio) {
    const n = cells.length || marathonLostSegCount;
    const idx = Math.min(Math.max(0, n - 1), Math.max(0, Math.floor(index)));
    const r = Math.max(0, Math.min(1, Number(ratio) || 0));
    const barW = Math.max(1, bar.getBoundingClientRect().width);
    if (!cells.length) {
        return ((idx + r) / Math.max(1, n)) * barW;
    }
    let px = 0;
    for (let i = 0; i < idx; i++) {
        px += cells[i].getBoundingClientRect().width;
    }
    px += cells[idx].getBoundingClientRect().width * r;
    return px;
}

function setMarathonBarCursorPx(pct) {
    const cursor = document.getElementById("marathonLostCursor");
    if (!cursor) return;
    cursor.style.left = `${Math.max(0, Math.min(100, pct))}%`;
}

function showMarathonProgressHud(opts) {
    const hud = document.getElementById("marathonProgressHud");
    if (!hud) return;
    const segs = opts?.segments || [];
    const cur = Math.max(0, Math.floor(Number(opts?.currentIndex) || 0));
    hud.innerHTML = "";
    const track = document.createElement("div");
    track.className = "marathonProgressTrack";
    segs.forEach((seg, i) => {
        const cell = document.createElement("div");
        cell.className = "marathonProgressCell";
        if (i < cur) cell.classList.add("marathonProgressCell--done");
        if (i === cur) cell.classList.add("marathonProgressCell--current");
        if (i === segs.length - 1) cell.classList.add("marathonProgressCell--finish");
        cell.textContent = seg.modeLabel || seg.modeId || `Leg ${i + 1}`;
        track.appendChild(cell);
    });
    hud.appendChild(track);
    hud.classList.remove("hidden");
    hud.setAttribute("aria-hidden", "false");
}

function hideMarathonProgressHud() {
    const hud = document.getElementById("marathonProgressHud");
    if (!hud) return;
    hud.classList.add("hidden");
    hud.setAttribute("aria-hidden", "true");
    hud.innerHTML = "";
}

function showMarathonLostScreen(opts) {
    const panel = document.getElementById("marathonLostPanel");
    const bar = document.getElementById("marathonLostBar");
    const cursor = document.getElementById("marathonLostCursor");
    if (!panel || !bar) return;
    const segs = opts?.segments || [];
    marathonLostFailIndex = Math.max(0, Math.floor(Number(opts?.failSegmentIndex) || 0));
    marathonLostFailRatio = Math.max(0, Math.min(1, Number(opts?.failProgressRatio) || 0));
    marathonLostSegCount = Math.max(1, segs.length);
    marathonCursorFromIndex = 0;
    marathonCursorFromRatio = 0;
    marathonCursorToIndex = marathonLostFailIndex;
    marathonCursorToRatio = marathonLostFailRatio;
    bar.innerHTML = "";
    panel.classList.remove("marathonLostPanel--advance");
    segs.forEach((seg, i) => {
        const cell = document.createElement("div");
        cell.className = "marathonLostSeg";
        if (i === segs.length - 1) cell.classList.add("marathonLostSeg--finish");
        if (i < marathonLostFailIndex) cell.classList.add("marathonLostSeg--cleared");
        if (i === marathonLostFailIndex) cell.classList.add("marathonLostSeg--fail");
        const label = document.createElement("span");
        label.className = "marathonLostSegLabel";
        label.textContent = seg.modeLabel || seg.modeId || `Leg ${i + 1}`;
        cell.appendChild(label);
        bar.appendChild(cell);
    });
    if (cursor) {
        cursor.style.left = "0%";
        cursor.classList.remove("hidden");
    }
    panel.classList.remove("hidden");
    panel.setAttribute("aria-hidden", "false");
    updateMarathonLostCursor(0);
}

function updateMarathonLostCursor(t) {
    const cursor = document.getElementById("marathonLostCursor");
    const bar = document.getElementById("marathonLostBar");
    if (!cursor || !bar) return;
    const cells = Array.from(bar.querySelectorAll(".marathonLostSeg"));
    const u = Math.max(0, Math.min(1, Number(t) || 0));
    const eased = 1 - Math.pow(1 - u, 3);
    const barW = Math.max(1, bar.getBoundingClientRect().width);
    const fromPx = marathonBarPositionPx(bar, cells, marathonCursorFromIndex, marathonCursorFromRatio);
    const toPx = marathonBarPositionPx(bar, cells, marathonCursorToIndex, marathonCursorToRatio);
    const px = fromPx + (toPx - fromPx) * eased;
    setMarathonBarCursorPx((px / barW) * 100);
}

function hideMarathonLostScreen() {
    const panel = document.getElementById("marathonLostPanel");
    if (panel) {
        panel.classList.add("hidden");
        panel.classList.remove("marathonLostPanel--advance");
        panel.setAttribute("aria-hidden", "true");
    }
}

function showMarathonAdvanceScreen(opts) {
    const panel = document.getElementById("marathonLostPanel");
    const bar = document.getElementById("marathonLostBar");
    const cursor = document.getElementById("marathonLostCursor");
    if (!panel || !bar) return;
    const segs = opts?.segments || [];
    const fromIndex = Math.max(0, Math.floor(Number(opts?.fromIndex) || 0));
    const toIndex = Math.max(0, Math.floor(Number(opts?.toIndex) || 0));
    marathonLostSegCount = Math.max(1, segs.length);
    // Sweep across the cleared leg into the start of the next.
    marathonCursorFromIndex = fromIndex;
    marathonCursorFromRatio = 0;
    marathonCursorToIndex = toIndex;
    marathonCursorToRatio = toIndex > fromIndex ? 0 : 1;
    bar.innerHTML = "";
    panel.classList.add("marathonLostPanel--advance");
    segs.forEach((seg, i) => {
        const cell = document.createElement("div");
        cell.className = "marathonLostSeg";
        if (i === segs.length - 1) cell.classList.add("marathonLostSeg--finish");
        if (i < toIndex) cell.classList.add("marathonLostSeg--cleared");
        if (i === toIndex) cell.classList.add("marathonLostSeg--next");
        if (i === fromIndex) cell.classList.add("marathonLostSeg--justCleared");
        const label = document.createElement("span");
        label.className = "marathonLostSegLabel";
        label.textContent = seg.modeLabel || seg.modeId || `Leg ${i + 1}`;
        cell.appendChild(label);
        bar.appendChild(cell);
    });
    if (cursor) {
        cursor.classList.remove("hidden");
    }
    panel.classList.remove("hidden");
    panel.setAttribute("aria-hidden", "false");
    updateMarathonAdvanceCursor(0);
}

function updateMarathonAdvanceCursor(t) {
    updateMarathonLostCursor(t);
}

function hideMarathonAdvanceScreen() {
    hideMarathonLostScreen();
}

function setChallengeRedMusicDuck(active) {
    challengeRedMusicDuckTarget = active ? CHALLENGE_RED_MUSIC_LEVEL : 1;
}

function tickChallengeRedMusicDuck(dt) {
    const d = challengeRedMusicDuckTarget - challengeRedMusicDuck;
    if (Math.abs(d) < 0.0008) {
        challengeRedMusicDuck = challengeRedMusicDuckTarget;
        return;
    }
    const maxStep = CHALLENGE_RED_MUSIC_FADE_PER_SEC * Math.max(0, dt);
    challengeRedMusicDuck += Math.sign(d) * Math.min(Math.abs(d), maxStep);
}

function startChallengeAssignedMode(modeId, opts) {
    document.body.classList.remove("challenge-lobby", "challenge-goal-complete");
    if (topCenter) topCenter.style.opacity = "";
    const levelIndex = Math.floor(Number(opts?.levelIndex) || 0);
    const map = {
        normal: () => startNormal(),
        wasd: () => startWASD(),
        superdot: () => startSuperDot(),
        roulette: () => beginRouletteGame(),
        highway: () => startHighway(),
        darkness: () => startDarkness(),
        mirror: () => startMirror(),
        delay: () => startDelay(),
        snake: () => startSnake(),
        combo: () => startCombo(),
        colorrush: () => startColorRush(),
        heat: () => startHeat(),
        hunter: () => startHunter(),
        pop: () => startPop(),
        counter: () => startCounter(),
        aim: () => startAim(),
        hook: () => startHook(),
        tilt: () => {
            void startTilt({ withTransition: false });
        },
        orbit: () => startOrbit(),
        progression: () => startProgression(),
        speedrun: () => startSpeedrunGame(levelIndex >= 1 ? levelIndex : undefined),
        penalty: () => startPenaltyGame(levelIndex >= 1 ? levelIndex : undefined),
    };
    if (modeId === "speedrun") {
        return refreshSpeedrunLevelsFromApi().then(() => {
            startSpeedrunGame(levelIndex >= 1 ? levelIndex : undefined);
            requestAnimationFrame(() => {
                if (gameMode !== "speedrun" || !playing) return;
                rebuildSpeedrunGeometry();
                repositionCursorToSpeedrunNorm(getSpeedrunLevelDef(speedrunActiveLevel).spawn);
            });
        });
    }
    if (modeId === "penalty") {
        return refreshPenaltyLevelsFromApi().then(() => {
            startPenaltyGame(levelIndex >= 1 ? levelIndex : undefined);
            requestAnimationFrame(() => {
                if (gameMode !== "penalty" || !playing) return;
                rebuildPenaltyGeometry();
                repositionCursorToSpeedrunNorm(getPenaltyLevelDef(penaltyRuntime.activeLevel).spawn);
                resetPenaltyBallFromLevel(penaltyRuntime, canvas.width, canvas.height, gameLayoutScale());
                refreshSpeedrunGroupWallState();
                refreshSpeedrunFrameGeometry();
            });
        });
    }
    const fn = map[modeId];
    if (fn) fn();
    else startNormal();
}

async function startCampaignSandboxFromPreset(layoutRef) {
    document.body.classList.remove("challenge-lobby", "challenge-goal-complete");
    if (topCenter) topCenter.style.opacity = "";
    const presetId = typeof layoutRef === "string" ? layoutRef.trim() : "";
    if (!presetId) {
        console.warn("[campaign] sandbox node missing layoutRef");
        startNormal();
        return;
    }
    try {
        const r = await fetch(
            apiPath(`/api/sandbox-presets?${new URLSearchParams({ presetId })}`),
            { credentials: "include", headers: { Accept: "application/json" } },
        );
        if (!r.ok) throw new Error(`preset ${r.status}`);
        const data = await r.json();
        const preset = data?.preset;
        if (!preset?.config) throw new Error("preset_missing_config");
        sandboxConfig = sandboxRuntimeFlat(preset.config);
        sandboxActivePlayContext = {
            localName: preset.name || null,
            cloudPresetId: preset.id || presetId,
        };
        saveSandboxDraft();
        startSandboxGame();
    } catch (e) {
        console.warn("[campaign] sandbox preset load failed", e);
        startNormal();
    }
}

mountChallengesRuntime({
    isSignedIn: () => !!cloudUser,
    openSignIn: () => openAuthScreen("login"),
    initLobbyGame: () => {
        initGame("challenges", { skipModeView: true });
        document.body.classList.add("challenge-lobby");
        if (topCenter) {
            topCenter.textContent = "";
            topCenter.style.opacity = "0";
        }
        showEl(returnBtn);
        syncReturnBtnVisibility();
    },
    startModeRun: (modeId, opts) => startChallengeAssignedMode(modeId, opts),
    endRunQuiet: () => endChallengeRunQuiet(),
    returnToHub: () => leaveChallengesToHubUi(),
    persistRunBestIfAny: () => {
        saveDeathRunOnce();
    },
    getMouse: () => ({ x: mouse.x, y: mouse.y }),
    setMouse: (x, y) => {
        mouse.x = x;
        mouse.y = y;
    },
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    getCursorRadius: () => getCursorRadiusForMode(),
    getScore: () => gameplayScoreFloor(),
    getChallengeProgress: (modeId, metric) => {
        if (metric === "time") return 0;
        // Progression challenges use level, not the time-based score (60 pts/sec).
        if (modeId === "progression" || gameMode === "progression") {
            return Math.max(0, Math.floor(Number(progressionLevel) || 0));
        }
        // SpeedRun / Golf challenges treat finishing the assigned level as score 1.
        if (modeId === "speedrun" || modeId === "penalty") {
            return 0;
        }
        return gameplayScoreFloor();
    },
    getPlayElapsedSec: () => 0,
    setDotsBalance: (balance) => {
        setDotsBalance(balance);
        schedulePushAccountData();
    },
    setReturnBtnLabel: (label) => {
        if (returnBtn) returnBtn.textContent = label;
    },
    hideHudForLobby: (hide) => {
        document.body.classList.toggle("challenge-lobby", !!hide);
        document.body.classList.toggle("challenge-active", isChallengesActive());
        if (topCenter) topCenter.style.opacity = hide ? "0" : "";
    },
    setFadeOverlay: (alpha) => {
        const el = document.getElementById("challengeFadeOverlay");
        if (!el) return;
        const a = Math.max(0, Math.min(1, Number(alpha) || 0));
        el.style.opacity = String(a);
        el.classList.toggle("challengeFadeOverlay--on", a > 0.001);
        el.setAttribute("aria-hidden", a > 0.001 ? "false" : "true");
    },
    setChallengeRunPaused: (paused) => {
        gamePaused = !!paused;
        if (paused) hideEl(pauseScreen);
    },
    setChallengeGoalCompleteFx: (active) => {
        document.body.classList.toggle("challenge-goal-complete", !!active);
    },
    setChallengeDeathWorld: ({ frozen, ballAlpha }) => {
        challengeDeathWorldFrozen = !!frozen;
        challengeDeathBallAlpha = Math.max(0, Math.min(1, Number(ballAlpha) ?? 1));
        if (challengeDeathWorldFrozen) {
            trail = [];
            particles = [];
            setSuperHudVisible(false);
            hideComboHud();
            if (topCenter) {
                topCenter.textContent = "";
                topCenter.style.opacity = "0";
            }
            document.body.classList.add("challenge-lobby");
        }
    },
    clearChallengeDeathWorld: () => clearChallengeDeathWorldVisuals(),
    beginChallengeDeathAsh: () => beginChallengeDeathAsh(),
    tickChallengeDeathAsh: (dt, t) => tickChallengeDeathAsh(dt, t),
    drawChallengeDeathAsh: () => drawChallengeDeathAshes(),
    showChallengeLostScreen: (label) => showChallengeLostScreen(label),
    updateChallengeLostCountdown: (label) => updateChallengeLostCountdown(label),
    hideChallengeLostScreen: () => hideChallengeLostScreen(),
    setChallengeRedMusicDuck: (active) => setChallengeRedMusicDuck(active),
    playSfx: (kind) => playChallengeSfx(kind),
});

function leaveCampaignToHubUi() {
    withExitPlayTransition(() => {
        exitGamePointerLock();
        leavePauseMenuCursorMode();
        playing = false;
        gameMode = null;
        document.body.classList.remove("game-active", "hideCursor", "game-playing-touch");
        applyBackgroundTheme();
        if (topCenter) {
            topCenter.textContent = "";
            topCenter.style.opacity = "";
        }
        if (returnBtn) returnBtn.textContent = "Return";
        const fade = document.getElementById("challengeFadeOverlay");
        if (fade) {
            fade.style.opacity = "0";
            fade.classList.remove("challengeFadeOverlay--on");
            fade.setAttribute("aria-hidden", "true");
        }
        clearGameCursorTopLayer();
        hideEl(campaignScreen);
        openGameHub();
        updateMobilePlayChrome();
        scheduleSidebarSync();
    });
}

mountCampaignRuntime({
    isSignedIn: () => !!cloudUser,
    openSignIn: () => openAuthScreen("login"),
    showCampaignScreen: () => {
        hideEl(gameHubScreen);
        hideEl(modeScreen);
        showEl(campaignScreen);
        if (campaignScreen) campaignScreen.setAttribute("aria-hidden", "false");
        showEl(returnBtn);
        syncReturnBtnVisibility();
        syncSidebarState();
        scheduleSidebarSync();
        playScreenEnterMotion();
    },
    hideCampaignScreen: () => {
        hideEl(campaignScreen);
        if (campaignScreen) campaignScreen.setAttribute("aria-hidden", "true");
        scheduleSidebarSync();
    },
    getCampaignMount: () => document.getElementById("campaignTreeMount"),
    startModeRun: (modeId, opts) => {
        if (modeId === "sandbox") {
            return startCampaignSandboxFromPreset(opts?.layoutRef);
        }
        return startChallengeAssignedMode(modeId, opts);
    },
    endRunQuiet: () => endChallengeRunQuiet(),
    restoreMenuCursor: () => {
        exitGamePointerLock();
        leavePauseMenuCursorMode();
        setUiCursorMode(false);
        playing = false;
        gameMode = null;
        document.body.classList.remove(
            "game-active",
            "hideCursor",
            "game-playing-touch",
            "challenge-lobby",
            "challenge-active",
            "ui-cursor-mode",
        );
        clearGameCursorTopLayer();
        applyBackgroundTheme();
        updateMobilePlayChrome();
        updateMusicState();
        scheduleSidebarSync();
        syncReturnBtnVisibility();
    },
    prepCampaignRetry: () => {
        hideEl(gameOverScreen);
        hideEl(gameOverNewRecord);
        if (gameOverNewRecord) gameOverNewRecord.setAttribute("aria-hidden", "true");
        clearDeathState();
        deathPending = false;
        gameOverMessage = "";
        gamePaused = false;
        hideEl(pauseScreen);
        leavePauseMenuCursorMode();
        syncReturnBtnVisibility();
    },
    hideCampaignGameOver: () => {
        hideEl(gameOverScreen);
        hideEl(gameOverNewRecord);
        if (gameOverNewRecord) gameOverNewRecord.setAttribute("aria-hidden", "true");
        clearDeathState();
        deathPending = false;
        gameOverMessage = "";
        gamePaused = false;
        hideEl(pauseScreen);
    },
    returnToHub: () => leaveCampaignToHubUi(),
    getScore: () => gameplayScoreFloor(),
    getCampaignProgress: (modeId, metric) => {
        if (metric === "time") return 0;
        if (modeId === "progression" || gameMode === "progression") {
            return Math.max(0, Math.floor(Number(progressionLevel) || 0));
        }
        // SpeedRun / Golf race nodes: finishing the level is tracked via begin*Win, not score.
        if (modeId === "speedrun" || modeId === "penalty") {
            return 0;
        }
        return gameplayScoreFloor();
    },
    setDotsBalance: (balance) => {
        setDotsBalance(balance);
        schedulePushAccountData();
    },
    addOwnedCosmetic: (id) => {
        addOwnedCosmetic(id);
        schedulePushAccountData();
    },
    setReturnBtnLabel: (label) => {
        if (returnBtn) returnBtn.textContent = label;
    },
    setFadeOverlay: (alpha) => {
        const el = document.getElementById("challengeFadeOverlay");
        if (!el) return;
        const a = Math.max(0, Math.min(1, Number(alpha) || 0));
        el.style.opacity = String(a);
        el.classList.toggle("challengeFadeOverlay--on", a > 0.001);
        el.setAttribute("aria-hidden", a > 0.001 ? "false" : "true");
    },
    setCampaignRunPaused: (paused) => {
        gamePaused = !!paused;
        if (paused) hideEl(pauseScreen);
    },
    setCampaignGoalCompleteFx: (active) => {
        document.body.classList.toggle("challenge-goal-complete", !!active);
    },
    playSfx: (kind) => playChallengeSfx(kind),
    persistRunBestIfAny: () => {
        saveDeathRunOnce();
    },
    playModeCardBeep: () => playModeCardBeep(),
});

function clearMarathonFadeOverlay() {
    const fade = document.getElementById("challengeFadeOverlay");
    if (!fade) return;
    fade.style.opacity = "0";
    fade.style.pointerEvents = "none";
    fade.classList.remove("challengeFadeOverlay--on");
    fade.setAttribute("aria-hidden", "true");
}

function prepareMarathonLobbyChrome() {
    exitGamePointerLock();
    leavePauseMenuCursorMode();
    playing = false;
    gamePaused = false;
    deathPending = false;
    gameMode = null;
    document.body.classList.remove(
        "game-active",
        "hideCursor",
        "game-playing-touch",
        "challenge-lobby",
        "challenge-goal-complete",
        "challenge-active",
    );
    applyBackgroundTheme();
    clearMarathonFadeOverlay();
    hideMarathonProgressHud();
    hideMarathonLostScreen();
    clearChallengeDeathWorldVisuals();
    if (topCenter) {
        topCenter.textContent = "";
        topCenter.style.opacity = "";
    }
    if (returnBtn) returnBtn.textContent = "Return";
    clearGameCursorTopLayer();
    updateMobilePlayChrome();
}

function leaveMarathonToHubUi() {
    withExitPlayTransition(() => {
        prepareMarathonLobbyChrome();
        hideEl(marathonScreen);
        if (marathonScreen) marathonScreen.setAttribute("aria-hidden", "true");
        openGameHub();
        scheduleSidebarSync();
    });
}

mountMarathonRuntime({
    isSignedIn: () => !!cloudUser,
    openSignIn: () => openAuthScreen("login"),
    showMarathonScreen: () => {
        prepareMarathonLobbyChrome();
        claimExclusiveUi("marathonScreen");
        hideEl(gameHubScreen);
        hideEl(modeScreen);
        showEl(marathonScreen);
        if (marathonScreen) marathonScreen.setAttribute("aria-hidden", "false");
        showEl(returnBtn);
        syncReturnBtnVisibility();
        syncSidebarState();
        scheduleSidebarSync();
        playScreenEnterMotion();
    },
    hideMarathonScreen: () => {
        hideEl(marathonScreen);
        if (marathonScreen) marathonScreen.setAttribute("aria-hidden", "true");
        scheduleSidebarSync();
    },
    getMarathonMount: () => document.getElementById("marathonScreenMount"),
    startModeRun: (modeId, opts) => startChallengeAssignedMode(modeId, opts),
    endRunQuiet: () => endChallengeRunQuiet(),
    restoreMenuCursor: () => {
        prepareMarathonLobbyChrome();
        showEl(returnBtn);
        syncReturnBtnVisibility();
        syncSidebarState();
    },
    returnToHub: () => leaveMarathonToHubUi(),
    getScore: () => gameplayScoreFloor(),
    getMarathonProgress: (modeId, metric) => {
        if (metric === "time") return 0;
        if (modeId === "progression" || gameMode === "progression") {
            return Math.max(0, Math.floor(Number(progressionLevel) || 0));
        }
        if (modeId === "speedrun" || modeId === "penalty") return 0;
        return gameplayScoreFloor();
    },
    setDotsBalance: (balance) => {
        setDotsBalance(balance);
        schedulePushAccountData();
    },
    addOwnedCosmetic: (id) => {
        if (id) addOwnedCosmetic(id);
    },
    setReturnBtnLabel: (label) => {
        if (returnBtn) returnBtn.textContent = label;
    },
    setFadeOverlay: (alpha) => {
        const el = document.getElementById("challengeFadeOverlay");
        if (!el) return;
        const a = Math.max(0, Math.min(1, Number(alpha) || 0));
        el.style.opacity = String(a);
        const on = a > 0.001;
        el.classList.toggle("challengeFadeOverlay--on", on);
        el.style.pointerEvents = on ? "auto" : "none";
        el.setAttribute("aria-hidden", on ? "false" : "true");
    },
    setMarathonRunPaused: (paused) => {
        gamePaused = !!paused;
        if (paused) hideEl(pauseScreen);
    },
    playModeCardBeep: () => playModeCardBeep(),
    setMarathonGoalCompleteFx: (active) => {
        document.body.classList.toggle("challenge-goal-complete", !!active);
    },
    playSfx: (kind) => playChallengeSfx(kind),
    persistRunBestIfAny: () => {
        saveDeathRunOnce();
    },
    hideHudForDeath: (hide) => {
        document.body.classList.toggle("challenge-lobby", !!hide);
        if (topCenter) topCenter.style.opacity = hide ? "0" : "";
    },
    setChallengeDeathWorld: ({ frozen, ballAlpha }) => {
        challengeDeathWorldFrozen = !!frozen;
        challengeDeathBallAlpha = Math.max(0, Math.min(1, Number(ballAlpha) ?? 1));
        if (challengeDeathWorldFrozen) {
            trail = [];
            particles = [];
            setSuperHudVisible(false);
            hideComboHud();
            if (topCenter) {
                topCenter.textContent = "";
                topCenter.style.opacity = "0";
            }
            document.body.classList.add("challenge-lobby");
        } else {
            document.body.classList.remove("challenge-lobby");
        }
    },
    clearChallengeDeathWorld: () => clearChallengeDeathWorldVisuals(),
    beginChallengeDeathAsh: () => beginChallengeDeathAsh(),
    tickChallengeDeathAsh: (dt, t) => tickChallengeDeathAsh(dt, t),
    showMarathonLostScreen: (opts) => showMarathonLostScreen(opts),
    hideMarathonLostScreen: () => hideMarathonLostScreen(),
    updateMarathonLostCursor: (t) => updateMarathonLostCursor(t),
    showMarathonAdvanceScreen: (opts) => showMarathonAdvanceScreen(opts),
    hideMarathonAdvanceScreen: () => hideMarathonAdvanceScreen(),
    updateMarathonAdvanceCursor: (t) => updateMarathonAdvanceCursor(t),
    showMarathonProgressHud: (opts) => showMarathonProgressHud(opts),
    hideMarathonProgressHud: () => hideMarathonProgressHud(),
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    setMouse: (x, y) => {
        mouse.x = x;
        mouse.y = y;
    },
});

function showTournamentScreenUi() {
    hideEl(gameHubScreen);
    hideEl(modeScreen);
    showEl(tournamentsScreen);
    if (tournamentsScreen) tournamentsScreen.setAttribute("aria-hidden", "false");
    showEl(returnBtn);
    syncReturnBtnVisibility();
    syncSidebarState();
    scheduleSidebarSync();
    playScreenEnterMotion();
}

function hideTournamentScreenUi() {
    hideEl(tournamentsScreen);
    if (tournamentsScreen) tournamentsScreen.setAttribute("aria-hidden", "true");
    scheduleSidebarSync();
}

function showTournamentResultOverlay(html: string) {
    const el = document.getElementById("tournamentResultOverlay");
    if (!el) return;
    el.innerHTML = html;
    el.classList.remove("hidden");
    el.setAttribute("aria-hidden", "false");
    el.style.opacity = "1";
}

function hideTournamentResultOverlay() {
    const el = document.getElementById("tournamentResultOverlay");
    if (!el) return;
    el.classList.add("hidden");
    el.setAttribute("aria-hidden", "true");
    el.replaceChildren();
}

mountTournamentsScreen(document.getElementById("tournamentsScreenMount") as HTMLElement, {
    isSignedIn: () => !!cloudUser,
    getViewerUserId: () => cloudUser?.id ?? null,
    onNeedSignIn: () => openAuthScreen("login"),
    showScreen: () => showTournamentScreenUi(),
    hideScreen: () => hideTournamentScreenUi(),
    onPlayMatch: (detail, matchId) => {
        hideTournamentScreenUi();
        void beginTournamentMatch(detail, matchId);
    },
});

mountTournamentRuntime({
    isSignedIn: () => !!cloudUser,
    startModeRun: (modeId, opts) => startChallengeAssignedMode(modeId, opts),
    endRunQuiet: () => endChallengeRunQuiet(),
    getScore: () => gameplayScoreFloor(),
    getProgressionLevel: () => progressionLevel,
    getPlayElapsedSec: () => 0,
    setDotsBalance: (balance) => {
        setDotsBalance(balance);
        schedulePushAccountData();
    },
    setReturnBtnLabel: (label) => {
        if (returnBtn) returnBtn.textContent = label;
    },
    showTournamentResultOverlay,
    hideTournamentResultOverlay,
    returnToTournamentDetail: () => returnToTournamentScreen(),
    persistRunBestIfAny: () => {
        saveDeathRunOnce();
    },
});

function leaveWorldMapToHubUi() {
    hideEl(document.getElementById("worldMapScreen"));
    const panel = document.getElementById("worldMapPanel");
    if (panel) {
        panel.replaceChildren();
        panel.classList.add("hidden");
        panel.setAttribute("aria-hidden", "true");
    }
    if (returnBtn) returnBtn.textContent = "Return";
    openGameHub();
    scheduleSidebarSync();
}

mountWorldMapRuntime({
    isSignedIn: () => !!cloudUser,
    openSignIn: () => openAuthScreen("login"),
    showWorldMapScreen: () => {
        hideEl(gameHubScreen);
        hideEl(modeScreen);
        const worldMapScreen = document.getElementById("worldMapScreen");
        showEl(worldMapScreen);
        if (worldMapScreen) worldMapScreen.setAttribute("aria-hidden", "false");
        showEl(returnBtn);
        syncReturnBtnVisibility();
        syncSidebarState();
        scheduleSidebarSync();
        playScreenEnterMotion();
    },
    hideWorldMapScreen: () => {
        const worldMapScreen = document.getElementById("worldMapScreen");
        hideEl(worldMapScreen);
        if (worldMapScreen) worldMapScreen.setAttribute("aria-hidden", "true");
        scheduleSidebarSync();
    },
    getWorldMapMount: () => document.getElementById("worldMapMount"),
    getWorldMapPanel: () => document.getElementById("worldMapPanel"),
    returnToHub: () => leaveWorldMapToHubUi(),
    openPublicPlayerProfile: (userId) => {
        void openPublicPlayerProfile(userId);
    },
    playModeCardBeep: () => playModeCardBeep(),
    setReturnBtnLabel: (label) => {
        if (returnBtn) returnBtn.textContent = label;
    },
    resolveCosmeticDisplay: resolvePublicCosmeticDisplay,
});

let sandboxMpReturnToLocal = null;

initLocalGameRuntime({
    getCanvasSize: () => ({ w: canvas.width, h: canvas.height }),
    getCursorRadius: () => getCursorRadiusForMode(),
    getCursorEdgeInset: () => cursorEdgeInsetPx(),
    getLayoutScale: () => gameLayoutScale(),
    getWasdSensitivity: () => settingWASDSensitivity,
    isPlaying: () => playing,
    isLocalResultVisible: () =>
        !!localResultScreen && !localResultScreen.classList.contains("hidden"),
    isDeathPending: () => deathPending,
    isResumeCountdownActive: () => resumeCountdownActive,
    isGamePaused: () => gamePaused,
    setMouse: (x, y) => { mouse.x = x; mouse.y = y; },
    getMouse: () => ({ x: mouse.x, y: mouse.y }),
    setCollisionPrevMouse: (x, y) => { collisionPrevMouse.x = x; collisionPrevMouse.y = y; },
    getCollisionPrevMouse: () => ({ x: collisionPrevMouse.x, y: collisionPrevMouse.y }),
    convertClientDelta: (dx, dy) => clampGamePointerDelta(dx, dy),
    clampLocalCursor(x, y) {
        const cfg = getLocalConfig();
        const mode = cfg?.mode ?? gameMode;
        if (mode === "speedrun" || (mode === "sandbox" && sandboxRuntimeConfig?.speedrunMode)) {
            return clampCursorXYToCanvas(x, y);
        }
        if (mode === "highway") {
            return { x, y };
        }
        return clampCursorXYToEdgeInset(x, y);
    },
    beginDeath,
    showLocalResult(message) {
        if (localResultMessage) localResultMessage.textContent = message;
        hideEl(gameOverScreen);
        showEl(localResultScreen);
        syncReturnBtnVisibility();
    },
    showLocalWinScreen(title, message = "") {
        if (localResultTitle) localResultTitle.textContent = title;
        if (localResultMessage) {
            localResultMessage.textContent = message;
            localResultMessage.classList.toggle("hidden", !message);
        }
        hideEl(gameOverScreen);
        showEl(localResultScreen);
        syncReturnBtnVisibility();
    },
    hideLocalResult() {
        hideEl(localResultScreen);
        if (localResultMessage) localResultMessage.classList.remove("hidden");
    },
    getTouchJoystickSensitivity: () => settingTouchJoystickSensitivity,
    clearLocalMatchVisuals() {
        obstacles = [];
        particles = [];
        trail = [];
        localSnakeTrails = [];
        clearGameCursorTopLayer();
    },
    openLocalSetup() {
        hideLocalScreens();
        hideEl(localResultScreen);
        hideEl(gameOverScreen);
        hideEl(modeScreen);
        hideHubScreens();
        document.getElementById("localSetupScreen")?.classList.remove("hidden");
        showEl(returnBtn);
        playScreenEnterMotion();
        updateMusicState();
    },
    openModes: openGameHub,
    stopPlaying: stopLocalPlaying,
    drawCursorAt(ctx, x, y, color) {
        const size = getCursorRadiusForMode();
        ctx.save();
        if (!equippedHidesBaseCursor()) {
            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, size, 0, Math.PI * 2);
            ctx.fill();
            ctx.strokeStyle = "rgba(255,255,255,0.65)";
            ctx.lineWidth = Math.max(1, size * 0.12);
            ctx.stroke();
        }
        drawEquippedCosmeticOverlays(
            ctx,
            x,
            y,
            size,
            cosmeticsDrawOptsForForcedCursor(color),
        );
        ctx.restore();
    },
    drawPlayerName(ctx, x, y, name, color) {
        const ls = gameLayoutScale();
        ctx.save();
        ctx.font = `${Math.max(8, Math.round(9 * ls))}px "Press Start 2P", monospace`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = color;
        ctx.strokeStyle = "rgba(0,0,0,0.75)";
        ctx.lineWidth = 3;
        ctx.strokeText(name, x, y);
        ctx.fillText(name, x, y);
        ctx.restore();
    },
    drawHeatBarInZone: localDrawHeatBarInZone,
    checkObstacleHit(px, py, ppx, ppy) {
        return localWithPlayerMouse(px, py, ppx, ppy, () => {
            for (const o of obstacles) {
                if (o.hitAtSweep(ppx, ppy, px, py) || o.hit()) return true;
            }
            return false;
        });
    },
    checkSnakeBorder(x, y, cr) {
        return snakeBorderCollision(x, y, cr, canvas.width, canvas.height, cursorEdgeInsetPx());
    },
    checkSnakeSelfTrail(x, y, cr, ppx, ppy, playerIndex) {
        const pts = localSnakeTrails[playerIndex];
        if (!pts || pts.length < 4) return false;
        const ls = gameLayoutScale();
        const immuneTail = Math.max(3, Math.ceil(4 * ls));
        return snakeSelfCollisionFromPoints(x, y, cr, ls, ppx, ppy, pts, immuneTail);
    },
    checkSnakeOtherTrails(x, y, cr, ppx, ppy, playerIndex) {
        const ls = gameLayoutScale();
        for (let i = 0; i < localSnakeTrails.length; i++) {
            if (i === playerIndex) continue;
            const pts = localSnakeTrails[i];
            if (!pts || pts.length < 4) continue;
            if (snakeSelfCollisionFromPoints(x, y, cr, ls, ppx, ppy, pts, 0)) return true;
        }
        return false;
    },
    appendSnakeTrail(playerIndex, x, y) {
        if (!localSnakeTrails[playerIndex]) localSnakeTrails[playerIndex] = [];
        appendSnakeTrailPointToArray(localSnakeTrails[playerIndex], x, y, gameLayoutScale());
    },
    drawSnakeTrails(ctx) {
        const ls = gameLayoutScale();
        for (let i = 0; i < localSnakeTrails.length; i++) {
            const color = getLocalConfig()?.players[i]?.color ?? settingTrailColor;
            drawSnakeTrailFromPoints(ctx, localSnakeTrails[i], ls, color);
        }
    },
    drawSnakeBorder(ctx) {
        drawSnakePlayBorder(ctx, canvas.width, canvas.height, cursorEdgeInsetPx(), settingTrailColor, gameLayoutScale());
    },
    checkHighwayDeath(x, y, cr) {
        const scr = highwayCursorScreenPos(x, y, canvas.height);
        if (highwayCursorOffScreen(scr.x, scr.y, cr, canvas.width, canvas.height)) return "You fell behind the camera.";
        if (highwayCursorOffTrack(scr.x, cr, canvas.width)) return "You left the track.";
        if (highwayCollides(scr.x, scr.y, cr, canvas.height)) return "";
        return null;
    },
    checkSpeedrunDeath(px, py, ppx, ppy, playerIndex) {
        void playerIndex;
        let deathMsg = null;
        let outX = px;
        let outY = py;
        localWithPlayerMouse(px, py, ppx, ppy, () => {
            pendingLocalSpeedrunLaserHit = false;
            speedrunPointerIntentDx = px - ppx;
            speedrunPointerIntentDy = py - ppy;
            speedrunPrevMouse.x = ppx;
            speedrunPrevMouse.y = ppy;
            handleSpeedrunCollisions();
            outX = mouse.x;
            outY = mouse.y;
            if (pendingLocalSpeedrunLaserHit) deathMsg = "Laser hit!";
        });
        return { deathMsg, x: outX, y: outY };
    },
    onSpeedrunCheckpoint(playerIndex) {
        void playerIndex;
        if (isLocalCoopMode()) applyMpTeamSpeedrunPoints(speedrunPointsCollected);
    },
    beginLocalSpeedrunLaserDeathFx() {
        playLocalSpeedrunLaserDeathFx();
    },
    finishLocalSpeedrunLaserRespawn() {
        return applyLocalSpeedrunLaserRespawn();
    },
    checkColorRushHit(px, py, ppx, ppy) {
        return localWithPlayerMouse(px, py, ppx, ppy, () => {
            const cursorIdx = getColorRushCursorColorIdx();
            for (let i = obstacles.length - 1; i >= 0; i--) {
                const o = obstacles[i];
                if (!o.hit()) continue;
                if (o.colorRushIdx === cursorIdx) {
                    const hx = o.x;
                    const hy = o.y;
                    obstacles.splice(i, 1);
                    score += 1;
                    playSpeedrunCoinPickupSound();
                    emitBurst(hx, hy, 6, [getColorRushBallHex(o.colorRushIdx), "#ffffff"], 1.05, 0, 0.9, 2.4, 8, 18);
                    if (obstacles.length === 0) scheduleColorRushRespawn(getGameSimNowMs());
                    return "ok";
                }
                return "wrong";
            }
            return null;
        });
    },
    checkCounterHit(px, py, ppx, ppy) {
        return localWithPlayerMouse(px, py, ppx, ppy, () => {
            const expected = getCounterNextExpected();
            const nowHit = getGameSimNowMs();
            for (let i = obstacles.length - 1; i >= 0; i--) {
                const o = obstacles[i];
                if (!o.hit()) continue;
                if (o.counterNum === expected) {
                    obstacles.splice(i, 1);
                    score += 1;
                    advanceCounterExpected();
                    resetCounterTimer(nowHit);
                    playSpeedrunCoinPickupSound();
                    if (getCounterNextExpected() > COUNTER_BALLS_TOTAL) scheduleCounterRespawn(nowHit);
                    return "ok";
                }
                return "wrong";
            }
            return null;
        });
    },
    getColorRushCursorColor: () => getColorRushCursorHex(),
    getAllCursorPositions: () => localSpawnClearanceCenters(),
});

function snakeSelfCollisionFromPoints(x, y, cr, ls, ppx, ppy, pts, skipTailPoints = 0) {
    if (!pts || pts.length < 4) return false;
    const immuneCount = Math.max(0, Math.floor(skipTailPoints));
    const checkLen = Math.max(0, pts.length - immuneCount);
    if (checkLen < 4) return false;
    const step = Math.max(1, Math.floor(checkLen / 80));
    for (let i = 0; i < checkLen - step; i += step) {
        const a = pts[i];
        const b = pts[i + step];
        if (!a || !b) continue;
        if (sweptCircleHitsCircle(ppx, ppy, x, y, cr, a.x, a.y, cr * 0.35)) return true;
        if (sweptCircleHitsCircle(a.x, a.y, b.x, b.y, cr * 0.35, x, y, cr)) return true;
    }
    return false;
}

function appendSnakeTrailPointToArray(pts, x, y, ls) {
    if (!pts) return;
    const minDist = Math.max(2, 3 * ls);
    const last = pts[pts.length - 1];
    if (last && Math.hypot(x - last.x, y - last.y) < minDist) return;
    pts.push({ x, y });
    const maxPts = 900;
    if (pts.length > maxPts) pts.splice(0, pts.length - maxPts);
}

function drawSnakeTrailFromPoints(ctx, pts, ls, color) {
    if (!pts || pts.length < 2) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(2, 4 * ls);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.globalAlpha = 0.85;
    ctx.beginPath();
    ctx.moveTo(pts[0].x, pts[0].y);
    for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
    ctx.stroke();
    ctx.restore();
}

document.getElementById("localResultPlayAgainBtn")?.addEventListener("click", () => {
    playModeCardBeep();
    const cfg = localPendingConfig || getLocalConfig();
    hideEl(localResultScreen);
    if (cfg) startLocalGameFromSetup(cfg);
});

